/** Page-level i18n (journals, recon, statements, reports, tax) — merged into messages.ts */
export const pageMessages = {
  id: {
    'common.company': 'Perusahaan',
    'common.pt': 'PT',
    'common.year': 'Tahun',
    'common.date': 'Tanggal',
    'common.from': 'Dari',
    'common.to': 'Sampai',
    'common.source': 'Sumber',
    'common.memo': 'Memo',
    'common.debit': 'Debit',
    'common.credit': 'Kredit',
    'common.account': 'Akun',
    'common.amount': 'Nominal',
    'common.refresh': 'Muat ulang',
    'common.export': 'Ekspor Excel',
    'common.void': 'Void',
    'common.note': 'Catatan',
    'common.failed': 'Gagal',
    'common.created': 'Dibuat',
    'common.results': 'Hasil ({n})',
    'common.accountNo': 'No Akun',
    'common.accountName': 'Nama',
    'common.total': 'Total',
    'common.addRow': '+ Baris',
    'common.balance': 'Balance',
    'common.diff': 'Selisih {n}',

    'jr.generalTitle': 'Jurnal',
    'jr.hubTitle': 'Jurnal',
    'jr.generalSub': 'Semua entri double-entry — filter sumber, void, & audit',
    'jr.hub.sub':
      'Buku jurnal lengkap — Umum, Pembelian, Penjualan, Kas Masuk/Keluar, Penyesuaian, Pembetulan, dan Penutup. Pilih jenis, baca panduan, lalu posting.',
    'jr.hub.kicker': 'JasaPembayaran · Buku besar',
    'jr.kind.all': 'Semua',
    'jr.kind.general': 'Jurnal Umum',
    'jr.kind.purchase': 'Jurnal Pembelian',
    'jr.kind.sales': 'Jurnal Penjualan',
    'jr.kind.cash_in': 'Penerimaan Kas',
    'jr.kind.cash_out': 'Pengeluaran Kas',
    'jr.kind.adjustment': 'Jurnal Penyesuaian',
    'jr.kind.correction': 'Jurnal Pembetulan',
    'jr.kind.close': 'Jurnal Penutup',
    'jr.kind.hint.all': 'Semua sumber & jenis dalam periode filter.',
    'jr.kind.hint.general': 'Transaksi campuran / non-spesial (manual & cepat).',
    'jr.kind.hint.purchase': 'Beli barang/jasa — tunai atau kredit (utang).',
    'jr.kind.hint.sales': 'Jual barang/jasa — tunai atau piutang.',
    'jr.kind.hint.cash_in': 'Uang masuk ke kas/bank (bukan penjualan baru).',
    'jr.kind.hint.cash_out': 'Uang keluar dari kas/bank (bayar utang/beban).',
    'jr.kind.hint.adjustment': 'Akrual, deferral, penyusutan — akhir periode.',
    'jr.kind.hint.correction': 'Koreksi posting salah (Ref [CORR:…]).',
    'jr.kind.hint.close': 'Tutup nominal ke laba ditahan — akhir tahun.',
    'jr.guide.desk': 'Meja konsultan',
    'jr.guide.howTo': 'Cara pakai: {kind}',
    'jr.guide.coachTitle': 'Panduan posting pintar',
    'jr.guide.open': 'Buka panduan',
    'jr.guide.collapse': 'Tutup',
    'jr.ptChip': 'PT {pt}',
    'jr.ptHide': 'Sembunyikan pilih PT',
    'jr.fillDiff': 'Isi selisih',
    'jr.fillDiffDone': 'Selisih {n} diisi ke baris kosong',
    'jr.kbdHint': 'Ctrl+Enter posting · Ctrl+Shift+Enter +baris · Tab Debit↔Kredit',
    'jr.kbdPostHint': 'Ctrl+Enter',
    'jr.kbdNeedBalance': 'Seimbangkan Debit = Kredit dulu',
    'jr.recentTag': 'Baru',
    'jr.guide.labelFungsi': 'Fungsi',
    'jr.guide.labelKapan': 'Kapan dipakai',
    'jr.guide.labelFormula': 'Pola Debit / Kredit',
    'jr.guide.labelSteps': 'Langkah pakai (urut)',
    'jr.guide.labelContoh': 'Contoh nyata',
    'jr.guide.labelTips': 'Tips konsultan',
    'jr.guide.labelMistakes': 'Kesalahan yang sering',
    'jr.guide.startCreate': 'Mulai buat {kind}',

    'jr.dp.btn': 'Wizard DP / Uang Muka',
    'jr.dp.title': 'Wizard DP → Pendapatan',
    'jr.dp.sub': 'Bayar di muka masuk kas dulu — omset baru naik saat jasa diakui',
    'jr.dp.explain':
      'Benar secara akrual: DP = Dr Kas/Bank · Cr Uang Muka (bukan pendapatan). Setelah selesai/lunas kinerja: Dr Uang Muka · Cr Pendapatan — omset & PPh Final naik, kewajiban turun. Pelunasan sisa = piutang lalu Penerimaan Kas + rekonsiliasi.',
    'jr.dp.umBalance': 'Saldo uang muka (sudah cleared)',
    'jr.dp.customer': 'Nama pelanggan',
    'jr.dp.dpAmount': 'Nominal DP',
    'jr.dp.contract': 'Total kontrak (opsional)',
    'jr.dp.remaining': 'Sisa jadi piutang: {n}',
    'jr.dp.bank': 'Kas / Bank penerima',
    'jr.dp.dpDate': 'Tanggal DP masuk',
    'jr.dp.recognizeDate': 'Tanggal akui pendapatan',
    'jr.dp.recognizeNow': 'Langsung akui pendapatan sekarang (jasa sudah selesai)',
    'jr.dp.needAmount': 'Isi nominal DP > 0',
    'jr.dp.submitDp': 'Catat DP saja (pending rekonsiliasi)',
    'jr.dp.submitFull': 'Catat DP + akui pendapatan',
    'jr.dp.done': 'Berhasil diposting',
    'jr.dp.openHint': 'Pakai wizard DP / uang muka pelanggan',

    'dash.umKicker': 'Akrual · Kas',
    'dash.umTitle': 'Uang muka pelanggan & DP',
    'dash.umSub': 'Pantau DP yang belum diakui jadi omset, plus yang masih menunggu cocok di rekonsiliasi.',
    'dash.umSubShort': 'Pantau DP belum jadi omset & yang menunggu rekonsiliasi.',
    'dash.umOpen': 'Buka rincian uang muka',
    'dash.umBalHint': 'Saldo kewajiban akun 2600 (sudah cleared)',
    'dash.umPendingHint': '{n} transaksi menunggu cocok',
    'dash.umOmsetHint': 'Pendapatan cleared tahun ini',
    'dash.umRatioHint': 'Ideal di bawah 15%',
    'dash.cfoKicker': 'Ringkasan CFO',
    'dash.cfoTitle': 'Posisi keuangan periode ini',
    'dash.cfoSub': 'Klik kartu untuk buka laporan detail · mengikuti filter PT & periode di atas',
    'dash.cfoOpenHub': 'Pusat laporan',
    'dash.cfoTodayBtn': 'Yang harus dikerjakan hari ini',
    'dash.cfoRunwayDays': 'Runway ~{n} hari',
    'dash.cfoRunwayInfinite': 'Runway aman',
    'dash.cfoRunwayZero': 'Runway habis',
    'dash.cfoTaxDue': 'Pajak jatuh tempo',
    'dash.cfoTaxOverdue': '{n} overdue',
    'dash.cfoTaxH3': '{n} dalam 3 hari',
    'dash.cfoTaxClear': 'Tidak ada urgensi',
    'dash.cfoAttGap': 'Gap absensi',
    'dash.cfoAttMeta': '{absent} bolos · {n} perlu perhatian',
    'dash.cfoLk': 'Laporan keuangan',
    'dash.cfoLkHint': 'Buka Report Studio',
    'dash.taxKicker': 'Modul pajak',
    'dash.taxTitle': 'Snapshot kepatuhan pajak',
    'dash.taxSub': 'PPh final, PPN, SSP, bukti potong · klik kartu untuk detail',
    'dash.taxOpenHub': 'Pusat pajak',

    'rpt.unearnedTitle': 'Uang Muka Pelanggan',
    'rpt.unearnedKicker': 'Rincian · DP',
    'rpt.unearnedSub': 'Saldo kewajiban 2600, DP menunggu rekonsiliasi, dan rasio vs omset tahun ini',
    'rpt.unearnedJgiJgtNote':
      'JGI dan JGT: konsumen biasanya bayar kecil-kecil dan langsung lunas — tidak memakai uang muka. Saldo di sini hanya muncul jika ada kredit akun 2600 yang belum diakui.',
    'rpt.unearnedBal': 'Saldo uang muka',
    'rpt.unearnedPending': 'DP menunggu rekonsiliasi',
    'rpt.unearnedOmset': 'Omset tahun ini',
    'rpt.unearnedRatio': 'Uang muka ÷ omset',
    'rpt.unearnedDays': 'hari',
    'rpt.unearnedPendingList': 'DP menunggu cocok statement',
    'rpt.unearnedAging': 'Daftar uang muka terbuka (FIFO)',
    'rpt.unearnedEmpty': 'Tidak ada uang muka terbuka',
    'rpt.ue.healthNoDp': 'Normal · tanpa uang muka',
    'rpt.omsetUnearnedHint':
      'Omset hanya dari pendapatan cleared. DP di uang muka belum dihitung sampai diakui.',
    'rpt.consultantNotes': 'Catatan konsultan',
    'rpt.lkCostAttrTitle': 'Identifikasi biaya per rekening',
    'rpt.lkCostAttrShare': 'Porsi PT ini dari biaya bersama: {pct}% ({method})',
    'rpt.lkCostAttrHpp': 'HPP dari CC/DBS bersama: {n}',
    'rpt.lkCostAttrOpex': 'Opex dari DBS bersama: {n}',
    'rpt.ue.pageAll': 'All',
    'rpt.ue.perPage': 'Per halaman',
    'rpt.ue.pageMeta': 'Halaman {page} / {pages} · {total} baris',
    'rpt.ue.showing': 'Menampilkan {from}–{to} dari {total}',
    'rpt.ue.pagePrev': 'Sebelumnya',
    'rpt.ue.pageNext': 'Berikutnya',
    'rpt.ue.jumpPage': 'Ke halaman',
    'rpt.ue.go': 'Go',
    'rpt.ue.searchPh': 'Cari ref / memo…',
    'rpt.ue.entries': 'entri',
    'rpt.ue.clickFilter': 'Klik untuk filter',
    'rpt.ue.clearBucket': 'Hapus filter umur',
    'rpt.ue.totalNominal': 'Total',
    'rpt.ue.pendingKicker': 'Pending',
    'rpt.ue.emptyHint': 'Belum ada saldo 2600 terbuka, atau coba ganti PT / tahun.',
    'rpt.ue.account': 'Akun',
    'rpt.ue.loadedAt': 'Dimuat',
    'rpt.ue.factOpen': 'Terbuka',
    'rpt.ue.factOpenVal': '{n} baris',
    'rpt.ue.factPending': 'Pending',
    'rpt.ue.factPendingVal': '{n} trx',
    'rpt.ue.factRatio': 'Rasio UM',
    'rpt.ue.btnDpShort': 'Wizard DP',
    'rpt.ue.btnCashShort': 'Penerimaan kas',
    'rpt.ue.healthOk': 'Sehat',
    'rpt.ue.healthWatch': 'Perlu pantau',
    'rpt.ue.healthCritical': 'Perlu review',
    'rpt.ue.sort': 'Urutkan',
    'rpt.ue.sortDaysDesc': 'Umur terlama',
    'rpt.ue.sortDaysAsc': 'Umur terbaru',
    'rpt.ue.sortAmtDesc': 'Nilai terbesar',
    'rpt.ue.sortAmtAsc': 'Nilai terkecil',
    'rpt.ue.sortDateDesc': 'Tanggal terbaru',
    'rpt.ue.sortDateAsc': 'Tanggal terlama',
    'rpt.ue.resetFilters': 'Reset filter',
    'rpt.ue.exportEmpty': 'Tidak ada baris untuk diekspor',
    'rpt.ue.pendingEmpty': 'Tidak ada DP pending',
    'rpt.ue.pendingEmptyHint': 'Semua penerimaan DP sudah cocok di rekonsiliasi.',
    'rpt.ue.guideTitle': 'Cara baca meja uang muka',
    'rpt.ue.guideFlow': 'Alur kerja',
    'rpt.ue.guideWatch': 'Yang dipantau',
    'rpt.ue.guideStep1': 'Terima DP via Penerimaan Kas / Wizard → kredit 2600 (pending).',
    'rpt.ue.guideStep2': 'Cocokkan di Rekonsiliasi agar status cleared.',
    'rpt.ue.guideStep3': 'Saat jasa selesai, akui: Debit 2600 · Kredit pendapatan.',
    'rpt.ue.guideStep4': 'Pantau rasio uang muka ÷ omset (ideal < 15%).',
    'rpt.ue.guideTip1': 'Bucket 90+ hari biasanya DP belum diakui / proyek tertunda.',
    'rpt.ue.guideTip2': 'Pending tinggi = statement belum di-match, bukan omset.',
    'rpt.ue.guideTip3': 'Ekspor CSV sebelum koreksi massal / tutup bulan.',
    'rpt.ue.vizAgingMix': 'Komposisi umur DP',
    'rpt.ue.vizComposition': 'Saldo · pending · terbuka',
    'rpt.ue.vizSnapshot': 'Snapshot meja',
    'rpt.ue.vizOpenAging': 'Aging terbuka',
    'rpt.ue.snapHealth': 'Status kesehatan',
    'rpt.ue.snapOpen': 'Entri terbuka',
    'rpt.ue.snapPending': 'DP pending',
    'rpt.ue.tipsTitle': 'Saran tindakan',
    'rpt.ue.tipPending': '{n} DP pending · {amount} — cocokkan di rekonsiliasi',
    'rpt.ue.tipD90': 'Bucket 90+: {n} entri · {amount} — review pengakuan',
    'rpt.ue.tipRatio': 'Rasio {pct}% di atas ambang 15% — pantau uang muka',
    'rpt.ue.tipRatioWatch': 'Rasio {pct}% mendekati ambang — pantau',
    'rpt.ue.tipWizard': 'Catat DP baru lewat Wizard DP / Uang Muka',
    'rpt.ue.tipRecon': 'Buka rekonsiliasi untuk match statement bank',
    'rpt.ue.tipOk': 'Meja uang muka sehat — tidak ada temuan mendesak',
    'rpt.ue.kpiTapOmset': 'Klik buka laporan omset',
    'rpt.ue.focusBucket': 'Filter umur: {b} hari',
    'rpt.ue.focusBal': 'Fokus: saldo uang muka',
    'rpt.ue.focusPending': 'Fokus: DP pending',
    'rpt.ue.focusOmset': 'Fokus: omset',
    'rpt.ue.focusRatio': 'Fokus: rasio',
    'rpt.ue.focusSearch': 'Cari: “{q}”',

    'tax.umTitle': 'Uang muka pelanggan',
    'tax.umPending': '{n} DP masih menunggu rekonsiliasi',

    'recon.chipDp': 'DP pending {n}',
    'recon.chipDpHint': 'Filter sisi buku ke memo [DP:…] / uang muka',

    'prac.docDpHint':
      'Lampirkan kontrak/invoice DP di sini, lalu tautkan memo jurnal dengan nama pelanggan yang sama.',

    'jr.guide.all.fungsi':
      'Tampilan gabungan seluruh buku jurnal. Pakai untuk audit cepat, cari Ref, bulk unmatch/void, dan ekspor CSV tanpa membatasi jenis.',
    'jr.guide.all.kapan':
      'Saat review harian/mingguan, rekonsiliasi, atau mencari transaksi lintas jenis (umum + pembelian + kas + penyesuaian).',
    'jr.guide.all.formula':
      'Tidak ada pola Dr/Cr tunggal — setiap baris mengikuti jenis asalnya.\nFilter Sumber (saat Semua) untuk mempersempit.',
    'jr.guide.all.contoh':
      'Cari Ref J7P-001234 di kotak pencarian → buka detail → lihat timeline CORR/VOID → batalkan rekonsiliasi jika perlu diperbaiki.',
    'jr.guide.all.steps':
      'Pilih periode (tahun / bulan / 30 hari) dan PT.\nBiarkan jenis “Semua”, atau klik kartu jenis untuk fokus.\nGunakan pencarian Ref / memo; filter Cleared untuk unmatch.\nCentang beberapa baris untuk bulk unmatch atau void.\nKlik kartu jenis lalu “Buat Jurnal” jika ingin posting baru.',
    'jr.guide.all.tips':
      'Mulai dari Cleared + PT yang aktif sebelum tutup buku.\nEkspor CSV sebelum koreksi massal sebagai jejak kerja.\nGunakan menu Tutup Bulan jika periode hampir ditutup.',
    'jr.guide.all.mistakes':
      'Void tanpa unmatch dulu saat masih terkunci rekonsiliasi.\nMencampur filter Sumber dengan kartu jenis (Sumber hanya aktif di Semua).\nMengedit angka jurnal lama — gunakan Pembetulan, jangan ubah historis.',

    'jr.guide.general.fungsi':
      'Jurnal Umum mencatat transaksi yang tidak punya buku spesial (atau yang Anda pilih masukkan ke umum). Tetap double-entry: total Debit = total Kredit.',
    'jr.guide.general.kapan':
      'Gaji, opex, admin bank, transfer antar akun, akrual sederhana, atau transaksi campuran yang tidak murni pembelian/penjualan/kas.',
    'jr.guide.general.formula':
      'Dr Beban / Aset    ·    Cr Kas-Bank / Utang / Pendapatan\n(minimal 2 baris; satu baris hanya Dr atau Cr)',
    'jr.guide.general.contoh':
      'Bayar biaya server Rp 500.000: Dr Biaya Server 500.000 · Cr Bank BCA 500.000. Memo: “Langganan server Maret”.',
    'jr.guide.general.steps':
      'Pilih PT JGI atau JGT (wajib).\nIsi tanggal transaksi (bukan tanggal input).\nTambah ≥2 baris akun; pastikan Debit = Kredit (selisih 0).\nTulis memo jelas (siapa, apa, bukti).\nCentang “Langsung masuk Laporan” jika sudah final; atau biarkan pending jika masih menunggu rekonsiliasi bank.\nPosting → catat Ref ID → cek di lookup bila perlu.',
    'jr.guide.general.tips':
      'Pakai Jurnal Khusus (Gaji, Opex, Admin bank) agar akun konsisten untuk transaksi berulang.\nSatu transaksi = satu Ref; jangan campur beberapa bukti beda tanggal.\nJika murni beli kredit / jual / gerak kas, pilih buku spesial agar laporan lebih rapi.',
    'jr.guide.general.mistakes':
      'Debit dan kredit di baris yang sama.\nLupa pilih PT → laporan salah perusahaan.\nNominal tidak balance lalu memaksa posting (sistem menolak — perbaiki selisih).',

    'jr.guide.purchase.fungsi':
      'Jurnal Pembelian mencatat perolehan barang/jasa/persediaan. Membedakan pembelian kredit (utang usaha) dan tunai (kas/bank keluar).',
    'jr.guide.purchase.kapan':
      'Saat ada faktur supplier, PO diterima, atau pembelian perlengkapan/persediaan — baik dibayar sekarang maupun nanti.',
    'jr.guide.purchase.formula':
      'Kredit:  Dr Persediaan / Beban / Aset    ·    Cr Utang Usaha\nTunai:    Dr Persediaan / Beban / Aset    ·    Cr Kas / Bank',
    'jr.guide.purchase.contoh':
      'Beli persediaan Rp 2.000.000 tempo 14 hari: Dr Persediaan 2.000.000 · Cr Utang Usaha 2.000.000. Saat bayar nanti → pakai Pengeluaran Kas (Dr Utang · Cr Bank).',
    'jr.guide.purchase.steps':
      'Pilih jenis Jurnal Pembelian (atau buka dari kartu hub).\nPilih PT & tanggal sesuai faktur supplier.\nDebit akun yang diterima (Persediaan / Beban / Aktiva).\nKredit Utang Usaha (kredit) atau Kas/Bank (tunai).\nIsi memo: nomor faktur, supplier, jatuh tempo.\nGunakan template “Pembelian kredit/tunai”, isi nominal, posting.\nSimpan bukti faktur di Surat & Berkas bila perlu audit.',
    'jr.guide.purchase.tips':
      'Pisahkan pembelian aset tetap dari opex — akun Dr berbeda.\nJangan catat pembayaran utang di sini; itu Pengeluaran Kas.\nJika ada PPN (nanti), pisahkan baris pajak sesuai kebijakan fiskal.',
    'jr.guide.purchase.mistakes':
      'Mencatat pembelian kredit sebagai pendapatan.\nLangsung Cr Bank padahal masih utang (saldo utang hilang).\nMembayar utang dengan jurnal pembelian lagi (double count).',

    'jr.guide.sales.fungsi':
      'Jurnal Penjualan mengakui pendapatan saat jasa terjual ATAU saat uang muka dialihkan jadi pendapatan (Dr 2600 · Cr 4000) — bukan saat DP baru masuk kas.',
    'jr.guide.sales.kapan':
      'Invoice pelanggan, penyerahan jasa, atau pengakuan DP yang sudah earned. Untuk DP mentah pakai Penerimaan Kas / Wizard DP dulu.',
    'jr.guide.sales.formula':
      'Kredit:           Dr Piutang · Cr Pendapatan\nTunai langsung:    Dr Kas/Bank · Cr Pendapatan\nDari uang muka:    Dr Uang Muka (2600) · Cr Pendapatan\nSisa setelah DP:   Dr Piutang · Cr Pendapatan (porsi sisa)',
    'jr.guide.sales.contoh':
      'Kontrak 10jt, DP 3jt di uang muka: Dr Uang Muka 3jt · Cr Pendapatan 3jt + Dr Piutang 7jt · Cr Pendapatan 7jt. Pelunasan 7jt via Penerimaan Kas + rekonsiliasi.',
    'jr.guide.sales.steps':
      'Pastikan DP (jika ada) sudah di akun 2600.\nPilih Penjualan atau Wizard DP (centang akui).\nDr Uang Muka dan/atau Piutang · Cr Pendapatan.\nPosting cleared → omset & dasar PPh Final naik.\nPantau AR / Omset / LK.',
    'jr.guide.sales.tips':
      'Pisahkan “terima uang” vs “akui omset”.\nTemplate “Akui pendapatan dari uang muka” & “Invoice sisa setelah DP” siap pakai.\nPelunasan piutang = Penerimaan Kas, bukan penjualan.',
    'jr.guide.sales.mistakes':
      'Mengakui seluruh kontrak saat DP masuk (lewati uang muka).\nCr Pendapatan + Dr Bank untuk DP mentah.\nLupa invoice sisa sehingga pendapatan understated.',

    'jr.guide.cash_in.fungsi':
      'Penerimaan Kas = uang masuk rekening: pelunasan piutang, DP/uang muka, setoran, bunga. DP harus ke akun 2600 — bukan langsung ke pendapatan.',
    'jr.guide.cash_in.kapan':
      'Transfer masuk (pelunasan atau DP), setoran, bunga bank, atau kas masuk lain yang terlihat di statement.',
    'jr.guide.cash_in.formula':
      'Pelunasan:     Dr Kas/Bank · Cr Piutang\nDP / uang muka: Dr Kas/Bank · Cr Uang Muka Pelanggan (2600) ← belum omset\nLainnya:        Dr Kas/Bank · Cr bunga / modal / sumber lain',
    'jr.guide.cash_in.contoh':
      'DP Rp 3.000.000: Dr Bank · Cr Uang Muka (pending → match). Setelah jasa selesai: Dr Uang Muka · Cr Pendapatan. Tombol Wizard DP memandu ini.',
    'jr.guide.cash_in.steps':
      'Tentukan: pelunasan, DP, atau penerimaan lain.\nDP → Wizard DP / template “DP uang muka pelanggan”.\nDebit Kas/Bank · Kredit Piutang atau 2600 (jangan Cr Pendapatan untuk DP).\nPosting pending → Rekonsiliasi.\nSaat selesai kinerja: akui pendapatan agar omset naik.',
    'jr.guide.cash_in.tips':
      'DP ke Pendapatan = omset & PPh terlalu awal (salah).\nSetelah match, cek Neraca: Uang Muka Pelanggan.\nMemo [DP:nama] memudahkan lacak rantai Ref.',
    'jr.guide.cash_in.mistakes':
      'Cr Pendapatan saat terima DP.\nDr Piutang · Cr Bank (terbalik).\nAkui pendapatan sebelum DP masuk laporan tanpa kebijakan jelas.',

    'jr.guide.cash_out.fungsi':
      'Jurnal Pengeluaran Kas mencatat uang keluar dari kas/bank: bayar utang, opex tunai, gaji transfer, pajak, dan pengeluaran operasional.',
    'jr.guide.cash_out.kapan':
      'Transfer keluar, pembayaran supplier atas utang, biaya yang langsung dibayar, tarik tunai, atau pembayaran pajak/SSP.',
    'jr.guide.cash_out.formula':
      'Dr Utang Usaha / Beban / Pajak\nCr Kas / Bank',
    'jr.guide.cash_out.contoh':
      'Bayar utang supplier Rp 2.000.000: Dr Utang Usaha 2.000.000 · Cr Bank 2.000.000. Atau bayar opex: Dr Biaya Opex · Cr Bank.',
    'jr.guide.cash_out.steps':
      'Pilih Pengeluaran Kas.\nPastikan utang (jika pelunasan) sudah tercatat di Pembelian sebelumnya.\nDebit Utang atau Beban yang dibayar.\nKredit Kas/Bank sumber dana.\nMemo: bukti transfer / no invoice yang dilunasi.\nPosting → rekonsiliasi ke statement keluar.\nUntuk gaji rutin, boleh template Gaji (Jurnal Umum) atau jalur ini — konsistenkan kebijakan.',
    'jr.guide.cash_out.tips':
      'Pisahkan pembayaran utang vs biaya baru agar aging utang akurat.\nCek saldo bank sebelum posting besar.\nAdmin bank otomatis potong rekening → biasanya Jurnal Umum/template Admin bank.',
    'jr.guide.cash_out.mistakes':
      'Dr Bank · Cr Beban (terbalik — kas naik).\nMembayar utang dengan Dr Beban lagi (beban dobel, utang tetap).\nMenggabungkan banyak supplier tanpa memo jelas.',

    'jr.guide.adjustment.fungsi':
      'Jurnal Penyesuaian (adjusting entries) menyelaraskan buku dengan prinsip akrual di akhir periode: beban/pendapatan yang belum tercatat, deferral, dan penyusutan.',
    'jr.guide.adjustment.kapan':
      'Akhir bulan/tahun sebelum tutup buku — akrual beban, sewa dibayar di muka yang dipakai, bunga berjalan, penyusutan aset, koreksi cut-off.',
    'jr.guide.adjustment.formula':
      'Akrual beban:     Dr Beban · Cr Utang / Beban masih harus dibayar\nDeferral:          Dr Beban · Cr Dibayar di muka (atau sebaliknya)\nPenyusutan:        Dr Beban Penyusutan · Cr Akumulasi Penyusutan',
    'jr.guide.adjustment.contoh':
      'Penyusutan bulanan: Dr Beban Penyusutan · Cr Akumulasi Penyusutan. Akrual listrik belum dibayar: Dr Beban Opex · Cr Utang Usaha.',
    'jr.guide.adjustment.steps':
      'Jalankan checklist tutup periode / Tutup Bulan.\nIdentifikasi akrual & deferral yang belum ada jurnalnya.\nPilih Jurnal Penyesuaian (source adjustment).\nPosting dengan memo “Penyesuaian Masa MM/YYYY”.\nReview Laba Rugi & Neraca setelah posting.\nBaru lanjut jurnal penutup jika akhir tahun.',
    'jr.guide.adjustment.tips':
      'Jangan campur pembetulan kesalahan input — itu Pembetulan.\nTemplate Penyusutan & Akrual beban siap dipakai.\nDokumentasikan dasar hitung (jadwal aset, kontrak sewa).',
    'jr.guide.adjustment.mistakes':
      'Menyesuaikan dengan mengedit jurnal lama (langgar jejak audit).\nPosting penyesuaian di tengah bulan tanpa cut-off jelas.\nLupa reverse akrual di periode berikutnya jika kebijakan reverse.',

    'jr.guide.correction.fungsi':
      'Jurnal Pembetulan memperbaiki kesalahan posting tanpa menghapus sejarah: reverse/koreksi bertanda [CORR:…] atau void terkendali.',
    'jr.guide.correction.kapan':
      'Salah akun, salah nominal, salah PT, atau jurnal yang sudah cleared tetapi ternyata keliru setelah rekonsiliasi.',
    'jr.guide.correction.formula':
      'Alur: Unmatch (jika locked) → Pembetulan (balik / sesuaikan / void) → Posting Ref baru [CORR:…] / VOID-…\nJangan hapus baris historis.',
    'jr.guide.correction.contoh':
      'Jurnal salah akun Bank: batalkan rekonsiliasi → buka Pembetulan → cari Ref → mode balik penuh → posting koreksi → buat jurnal benar.',
    'jr.guide.correction.steps':
      'Cari Ref di hub / lookup.\nJika status Cleared & terkunci match: Batalkan rekonsiliasi dulu.\nBuka /journals/pembetulan.\nPilih mode: balik penuh, sesuaikan manual, atau void.\nPosting → cek timeline Ref (asal → CORR → VOID).\nBuat jurnal pengganti yang benar di jenis yang sesuai.\nMinta Tasya jelaskan rantai Ref bila perlu review.',
    'jr.guide.correction.tips':
      'Selalu sisakan jejak: memo wajib sebut Ref asal.\nBulk void hanya untuk yang memang boleh divoid.\nSetelah koreksi, cocokkan lagi ke statement.',
    'jr.guide.correction.mistakes':
      'Mengedit database / menghapus baris jurnal.\nVoid tanpa unmatch saat masih matched.\nMembuat jurnal “pengganti” tanpa membalik yang salah (saldo dobel).',

    'jr.guide.close.fungsi':
      'Jurnal Penutup menutup akun nominal (pendapatan & beban) ke ikhtisar laba rugi / laba ditahan sehingga buku siap tahun baru.',
    'jr.guide.close.kapan':
      'Setelah semua penyesuaian final di akhir tahun buku (atau periode penutupan resmi perusahaan).',
    'jr.guide.close.formula':
      'Dr Pendapatan (tutup) · Cr Ikhtisar Laba Rugi\nDr Ikhtisar Laba Rugi · Cr Beban (tutup)\nDr/Cr Ikhtisar → Laba Ditahan / Modal sesuai laba/rugi',
    'jr.guide.close.contoh':
      'Pakai Tutup Bulan/Tahun: pastikan checklist hijau → generate jurnal penutup → review Ref source close.',
    'jr.guide.close.steps':
      'Selesaikan rekonsiliasi & penyesuaian.\nBuka Tutup Bulan / checklist.\nPastikan omset, pajak, dan IC sudah direview.\nPosting jurnal penutup (atau dari entry kind=close).\nKunci bulan jika kebijakan perusahaan memakai kunci.\nBackup database setelah tutup.',
    'jr.guide.close.tips':
      'Jangan posting penutup jika masih ada pending material.\nSimpan paket LK + SPT sebelum/ sesudah close.\nPenutup bukan untuk koreksi — koreksi dulu.',
    'jr.guide.close.mistakes':
      'Menutup di tengah tahun tanpa kebijakan.\nPosting penutup ganda untuk periode sama.\nMengunci periode sebelum koreksi fiskal selesai.',

    'jr.hub.flowTitle': 'Alur kerja',
    'jr.hub.actionUnmatch': 'Batalkan rekonsiliasi',
    'jr.hub.actionUnmatchSub': 'Lepas match · jurnal kembali ke antrian',
    'jr.hub.actionFix': 'Perbaiki data input',
    'jr.hub.actionFixSub': 'Jalur pembetulan · balik / sesuaikan / void',
    'jr.hub.actionCreate': 'Buat Jurnal',
    'jr.hub.actionCreateSub': 'Posting sesuai jenis yang aktif',
    'jr.hub.unmatchHint':
      'Filter Cleared aktif. Buka baris → Batalkan rekonsiliasi.',
    'jr.hub.periodYear': 'Tahun ini',
    'jr.hub.periodMonth': 'Bulan ini',
    'jr.hub.period30': '30 hari',
    'jr.hub.periodCustom': 'Kustom',
    'jr.hub.filterToggle': 'Filter daftar',
    'jr.hub.howtoShort': 'Cara pakai',
    'jr.hub.widenYear': 'Perluas ke tahun ini',
    'jr.hub.copyRef': 'Salin Ref',
    'jr.hub.copied': 'Ref {ref} disalin',
    'jr.hub.exportCsv': 'Ekspor CSV',
    'jr.hub.exportOk': 'CSV diunduh ({n} baris)',
    'jr.hub.gotoRecon': 'Rekonsiliasi',
    'jr.hub.listTitle': 'Daftar entri',
    'jr.hub.activeKind': 'Jenis aktif',
    'jr.hub.perPage': 'Per halaman',
    'jr.hub.pageAll': 'All',
    'jr.hub.pageMeta': 'Halaman {page} / {pages} · {total} entri',
    'jr.hub.showing': 'Menampilkan {from}–{to} dari {total}',
    'jr.hub.pagePrev': 'Sebelumnya',
    'jr.hub.pageNext': 'Berikutnya',
    'jr.hub.pageFirst': 'Halaman pertama',
    'jr.hub.pageLast': 'Halaman terakhir',
    'jr.hub.pagination': 'Navigasi halaman',
    'jr.hub.jumpPage': 'Ke halaman',
    'jr.hub.go': 'Go',
    'jr.hub.sort': 'Urutkan',
    'jr.hub.sortDateDesc': 'Tanggal terbaru',
    'jr.hub.sortDateAsc': 'Tanggal terlama',
    'jr.hub.sortAmtDesc': 'Nilai terbesar',
    'jr.hub.sortAmtAsc': 'Nilai terkecil',
    'jr.hub.sortCreated': 'Baru diinput',
    'jr.hub.sortPending': 'Pending dulu',
    'jr.hub.sortRef': 'Ref A→Z',
    'jr.hub.quickPending': 'Pending saja',
    'jr.hub.quickUnbalanced': 'Tidak balance',
    'jr.hub.resetFilters': 'Reset filter',
    'jr.hub.clickFilter': 'Klik untuk filter',
    'jr.hub.ofBase': 'dari {n} total',
    'jr.hub.compact': 'Tampilan rapat',
    'jr.hub.periodToday': 'Hari ini',
    'jr.hub.amtMin': 'Nilai min',
    'jr.hub.amtMax': 'Nilai max',
    'jr.hub.hideVoid': 'Sembunyikan void',
    'jr.hub.shortcuts': 'Shortcut',
    'jr.hub.keySearch': 'cari',
    'jr.hub.keyPage': 'ganti halaman',
    'jr.hub.keyEsc': 'tutup / batal pilih',
    'jr.hub.keyNav': 'pindah baris',
    'jr.hub.keyExpand': 'expand',
    'jr.hub.keyDetail': 'buka detail',
    'jr.hub.keyPreview': 'preview baris',
    'jr.hub.viewTable': 'Tampilan tabel',
    'jr.hub.groupByDate': 'Kelompokkan per tanggal',
    'jr.hub.saveView': 'Simpan tampilan',
    'jr.hub.viewName': 'Nama tampilan',
    'jr.hub.viewSaved': 'Tampilan disimpan',
    'jr.hub.savedViews': 'Tersimpan',
    'jr.hub.healthOk': 'Kesehatan OK',
    'jr.hub.healthWarn': 'Perlu perhatian',
    'jr.hub.healthUnbal': 'Tidak balance {n}',
    'jr.hub.healthPending': 'Pending {n}',
    'jr.hub.healthVoid': 'Void {n}',
    'jr.hub.healthVolume': 'D {d} · K {c}',
    'jr.hub.dayMeta': '{n} entri · {amt}',
    'jr.hub.colRef': 'Ref',
    'jr.hub.colMemo': 'Memo',
    'jr.hub.openSelected': 'Buka detail',
    'jr.hub.openFirstOf': 'Membuka 1 dari {n} terpilih',
    'jr.hub.auditHint': 'Riwayat lengkap di Detail → Timeline',
    'jr.hub.auditSection': 'Audit',
    'jr.hub.toTop': 'Ke atas daftar',
    'jr.hub.exportEmpty': 'Tidak ada data untuk diekspor',
    'jr.bulk.selectPage': 'Pilih halaman',
    'jr.bulk.clearPage': 'Lepas halaman',
    'jr.bulk.copyRefs': 'Salin Ref',
    'jr.bulk.copiedRefs': '{n} Ref disalin',
    'jr.bulk.noneCopy': 'Tidak ada Ref untuk disalin',
    'jr.bulk.exportSelected': 'Ekspor dipilih',
    'jr.confirmUnmatch':
      'Batalkan rekonsiliasi untuk {ref}?\n\nJurnal kembali ke antrian match.',
    'jr.snackUnmatched': 'Rekonsiliasi {ref} dibatalkan',
    'jr.snackUnmatchFail': 'Gagal batalkan rekonsiliasi',
    'jr.statEntries': 'Entri',
    'jr.statVolume': 'Volume debit',
    'jr.statPending': 'Pending rekonsiliasi',
    'jr.statCleared': 'Cleared',
    'jr.statSources': 'Sumber',
    'jr.expandAll': 'Buka semua',
    'jr.collapseAll': 'Tutup semua',
    'jr.expandView': 'Perbesar',
    'jr.collapseView': 'Kecilkan',
    'jr.lines': 'baris',
    'jr.emptyHint': 'Ubah filter tanggal/jenis, atau buat jurnal baru.',
    'jr.emptyKind': 'Belum ada entri untuk {kind} di periode ini.',
    'jr.emptySearchHint': 'Coba Ref lain, kosongkan pencarian, atau perluas rentang tanggal.',
    'jr.emptyCorrectionHint':
      'Belum ada jurnal pembetulan di periode ini. Buka jalur Perbaiki data, atau perluas filter tanggal.',
    'jr.emptyCloseHint': 'Belum ada jurnal penutup. Jalankan Wizard Tutup Bulan setelah penyesuaian final.',
    'jr.emptyPeriodHint': 'Perluas periode, ganti jenis, atau buat jurnal baru.',
    'jr.corrPanel.kicker': 'Jalur khusus',
    'jr.corrPanel.title': 'Koreksi posting salah',
    'jr.corrPanel.sub':
      'Batalkan rekonsiliasi bila perlu → perbaiki di Pembetulan → posting Ref [CORR:…] yang balance.',
    'jr.corrPanel.s1': 'Batalkan rekonsiliasi',
    'jr.corrPanel.s1h': 'Lepas match agar jurnal bisa dikoreksi',
    'jr.corrPanel.s2': 'Perbaiki data input',
    'jr.corrPanel.s2h': 'Balik / sesuaikan / void lewat Pembetulan',
    'jr.corrPanel.s3': 'Buat jurnal koreksi',
    'jr.corrPanel.s3h': 'Posting CORR balance Debit = Kredit',
    'jr.recon.all': 'Semua status',
    'jr.entryTitle': 'Buat Jurnal',
    'jr.entrySub': 'Entri jurnal profesional — Ref ID otomatis J7P-###### · wajib balance Debit = Kredit',
    'jr.entrySub.manual':
      'Jurnal Umum — transaksi operasional / campuran. Ref otomatis · Debit harus = Kredit.',
    'jr.entrySub.purchase':
      'Jurnal Pembelian — catat perolehan barang/jasa (tunai atau utang). Debit aset/beban · Kredit utang atau kas.',
    'jr.entrySub.sales':
      'Jurnal Penjualan — akui pendapatan (tunai atau piutang). Debit kas/piutang · Kredit pendapatan.',
    'jr.entrySub.cash_receipt':
      'Penerimaan Kas — uang masuk ke kas/bank (pelunasan piutang / setoran). Bukan penjualan baru.',
    'jr.entrySub.cash_disbursement':
      'Pengeluaran Kas — uang keluar dari kas/bank (bayar utang / biaya). Debit utang/beban · Kredit kas.',
    'jr.entrySub.adjustment':
      'Jurnal Penyesuaian — akrual, deferral, penyusutan akhir periode sebelum tutup buku.',
    'jr.entrySub.close':
      'Jurnal Penutup — tutup akun nominal ke laba ditahan. Pakai setelah penyesuaian final.',
    'jr.entryKicker': 'Posting manual · Double-entry',
    'jr.entryKicker.manual': 'Jurnal Umum · Double-entry',
    'jr.entryKicker.purchase': 'Jurnal Pembelian · Supplier / PO',
    'jr.entryKicker.sales': 'Jurnal Penjualan · Invoice / omset',
    'jr.entryKicker.cash_receipt': 'Penerimaan Kas · Mutasi masuk',
    'jr.entryKicker.cash_disbursement': 'Pengeluaran Kas · Mutasi keluar',
    'jr.entryKicker.adjustment': 'Jurnal penyesuaian · Accrual / deferral',
    'jr.entryKicker.close': 'Jurnal penutup · Tutup buku',
    'jr.entryKickerAdj': 'Jurnal penyesuaian · Accrual / deferral',
    'jr.entryKickerClose': 'Jurnal penutup · Tutup buku',
    'jr.tpl.title': 'Template jurnal',
    'jr.tpl.sub': 'Pilih pola siap pakai — isi nominal, lalu posting.',
    'jr.tpl.open': 'Dari template',
    'jr.tpl.save': 'Simpan sebagai template',
    'jr.tpl.apply': 'Terapkan',
    'jr.tpl.amount': 'Nominal (opsional)',
    'jr.tpl.amountHint': 'Jika diisi, nominal sama di sisi Debit & Kredit.',
    'jr.tpl.empty': 'Belum ada template untuk jenis ini.',
    'jr.tpl.system': 'Sistem',
    'jr.tpl.custom': 'Kustom',
    'jr.tpl.used': '{n}× dipakai',
    'jr.tpl.name': 'Nama template',
    'jr.tpl.saved': 'Template “{name}” disimpan',
    'jr.tpl.applied': 'Template “{name}” diterapkan',
    'jr.tpl.deleted': 'Template dihapus',
    'jr.tpl.deleteConfirm': 'Hapus template “{name}”?',
    'jr.tpl.needLines': 'Isi minimal 2 baris akun dulu sebelum menyimpan template.',
    'jr.tpl.needName': 'Isi nama template.',
    'jr.tpl.strip': 'Cepat isi dari template',
    'jr.khusus.kicker': 'Di dalam Jurnal Umum',
    'jr.khusus.title': 'Jurnal Khusus',
    'jr.khusus.sub':
      'Pola jurnal berulang yang sering dipakai (gaji, opex, admin bank, dll.). Klik untuk isi cepat, lalu posting.',
    'jr.khusus.add': 'Buat pola baru',
    'jr.khusus.empty': 'Belum ada pola Jurnal Khusus. Simpan jurnal sebagai template berulang.',
    'jr.khusus.loading': 'Memuat pola…',
    'jr.khusus.saveCheck': 'Simpan ke Jurnal Khusus (berulang / sering dipakai)',
    'jr.draft.title': 'Draft tersimpan',
    'jr.draft.sub': 'Ada draft lokal · {at}',
    'jr.draft.restore': 'Lanjutkan draft',
    'jr.draft.discard': 'Buang',
    'jr.draft.restored': 'Draft dipulihkan',
    'jr.draft.discarded': 'Draft dibuang',
    'jr.timeline.title': 'Rantai Ref',
    'jr.timeline.origin': 'Asal',
    'jr.timeline.correction': 'Pembetulan',
    'jr.timeline.void': 'Void',
    'jr.timeline.related': 'Terkait',
    'jr.timeline.single': 'Belum ada koreksi/void terkait.',
    'jr.timeline.askTasya': 'Tasya jelaskan',
    'jr.bulk.selectAll': 'Pilih semua',
    'jr.bulk.selected': '{n} dipilih',
    'jr.bulk.clear': 'Batal pilih',
    'jr.bulk.confirmUnmatch': 'Batalkan rekonsiliasi {n} jurnal?',
    'jr.bulk.confirmVoid': 'Void {n} jurnal?\nJurnal yang terkunci match akan gagal.',
    'jr.bulk.doneUnmatch': 'Unmatch: {ok} berhasil · {fail} gagal',
    'jr.bulk.doneVoid': 'Void: {ok} berhasil · {fail} gagal',
    'jr.bulk.noneUnmatch': 'Tidak ada jurnal cleared yang bisa di-unmatch.',
    'jr.bulk.noneVoid': 'Tidak ada jurnal yang bisa di-void.',
    'jr.wizard.nav': 'Tutup bulan',
    'jr.wizard.kicker': 'Akuntansi · Pajak · Konsultan',
    'jr.wizard.title': 'Tutup Bulan',
    'jr.wizard.sub':
      'Urutan kerja: rekonsiliasi bank → jurnal penyesuaian → uang muka → pajak → cek laporan → checklist → paket konsultan → tutup tahun.',
    'jr.wizard.stepLabel': 'Langkah {n}',
    'jr.wizard.open': 'Buka',
    'jr.wizard.next': 'Lanjut',
    'jr.wizard.prev': 'Kembali',
    'jr.wizard.progress': 'Progres {pct}% · {done}/{total}',
    'jr.wizard.viewAdj': 'Lihat penyesuaian',
    'jr.wizard.taxHub': 'Menu pajak',
    'jr.wizard.lk': 'Laporan keuangan',
    'jr.wizard.downloads': 'Unduhan laporan',
    'jr.wizard.pickPt': 'Pilih PT dulu',
    'jr.wizard.readyBadge': 'Siap tutup {pct}%',
    'jr.wizard.readyShort': 'Siap',
    'jr.wizard.step.recon': 'Rekonsiliasi bank',
    'jr.wizard.step.reconHint': 'Impor statement, selesaikan yang belum cocok, pastikan buku sama dengan bank.',
    'jr.wizard.step.adjust': 'Jurnal penyesuaian',
    'jr.wizard.step.adjustHint': 'Posting akrual, deferral, penyusutan, dan koreksi sebelum tutup.',
    'jr.wizard.step.unearned': 'Uang Muka / DP',
    'jr.wizard.step.unearnedHint': 'Cek uang muka pelanggan & DP yang masih menunggu sebelum hitung pajak.',
    'jr.wizard.step.tax': 'Pajak bulan ini',
    'jr.wizard.step.taxHint': 'PPh Final UMKM, PPh 21/23, SSP, kalender & SPT Masa.',
    'jr.wizard.step.checklist': 'Checklist tutup',
    'jr.wizard.step.checklistHint': 'Centang semua kontrol tutup bulan sebelum review konsultan.',
    'jr.wizard.step.checklistHintInline': 'Centang di wizard ini — tidak perlu buka halaman terpisah.',
    'jr.wizard.checklistInlineNote': 'Checklist tutup bulan sudah digabung di langkah ini. Centang item di atas, lalu lanjut paket konsultan.',
    'jr.wizard.checklistFullPage': 'Halaman checklist penuh (opsional)',
    'jr.wizard.checklistHere': 'Kerjakan di sini',
    'jr.wizard.step.reports': 'Cek laporan',
    'jr.wizard.step.reportsHint': 'Pastikan neraca saldo seimbang, lalu review Neraca / Laba Rugi / omset.',
    'jr.wizard.step.pack': 'Paket konsultan',
    'jr.wizard.step.packHint': 'Unduh Excel untuk KAP/konsultan, backup, dan lembar kerja tutup.',
    'jr.wizard.step.year': 'Tutup tahun',
    'jr.wizard.step.yearHint': 'Tutup akun pendapatan & beban ke laba ditahan (biasanya Desember).',
    'jr.wizard.metric.clear': 'Bersih',
    'jr.wizard.metric.pending': '{n} pending',
    'jr.wizard.metric.journals': '{n} jurnal',
    'jr.wizard.metric.dpPending': '{n} DP',
    'jr.wizard.metric.pphPosted': 'Sudah posting',
    'jr.wizard.metric.pphOpen': 'Belum posting',
    'jr.wizard.metric.noOmset': 'Tanpa omset',
    'jr.wizard.metric.tbOk': 'Seimbang',
    'jr.wizard.metric.tbDiff': 'Selisih {amt}',
    'jr.wizard.metric.quality': 'Skor {n}',
    'jr.wizard.metric.yearClosed': 'Sudah ditutup',
    'jr.wizard.metric.yearReady': 'Siap ditinjau',
    'jr.wizard.metric.yearLater': 'Akhir tahun',
    'jr.wizard.metric.payrollOk': 'Ada run',
    'jr.wizard.kpi.ready': 'Kesiapan',
    'jr.wizard.kpi.recon': 'Rekon pending',
    'jr.wizard.kpi.tax': 'PPh Final',
    'jr.wizard.kpi.tb': 'Neraca saldo',
    'jr.wizard.kpi.checklist': 'Checklist',
    'jr.wizard.kpi.quality': 'Kelengkapan',
    'jr.wizard.stat.pending': 'Pending',
    'jr.wizard.stat.highRisk': 'Risiko tinggi',
    'jr.wizard.stat.aging': 'Aging',
    'jr.wizard.stat.lowRisk': 'Risiko rendah',
    'jr.wizard.stat.adjCount': 'Jurnal penyesuaian masa',
    'jr.wizard.stat.umBalance': 'Saldo uang muka',
    'jr.wizard.stat.dpPending': 'DP pending',
    'jr.wizard.stat.dpTotal': 'Nilai DP pending',
    'jr.wizard.stat.aging90': 'Aging >90 hari',
    'jr.wizard.stat.omset': 'Omset masa',
    'jr.wizard.stat.pphFinal': 'PPh Final',
    'jr.wizard.stat.pphStatus': 'Status posting',
    'jr.wizard.stat.paid': 'lunas',
    'jr.wizard.stat.tb': 'Neraca saldo',
    'jr.wizard.stat.debit': 'Total debit',
    'jr.wizard.stat.credit': 'Total kredit',
    'jr.wizard.stat.accounts': 'Akun aktif',
    'jr.wizard.stat.critical': 'Temuan kritis',
    'jr.wizard.stat.noCompany': 'Tanpa PT',
    'jr.wizard.stat.badRef': 'Ref mismatch',
    'jr.wizard.guide.adjustTitle': 'Urutan kerja penyesuaian',
    'jr.wizard.guide.adjust1': 'Selesaikan rekonsiliasi bank terlebih dahulu.',
    'jr.wizard.guide.adjust2': 'Posting akrual beban/pendapatan & deferral yang belum dicatat.',
    'jr.wizard.guide.adjust3': 'Jalankan / review penyusutan aset tetap.',
    'jr.wizard.guide.adjust4': 'Cek ulang Laba Rugi setelah penyesuaian.',
    'jr.wizard.guide.rptTitle': 'Review profesional sebelum tutup',
    'jr.wizard.guide.rpt1': 'Pastikan neraca saldo debit = kredit.',
    'jr.wizard.guide.rpt2': 'Bandingkan Neraca & Laba Rugi vs bulan/tahun lalu.',
    'jr.wizard.guide.rpt3': 'Simpan jejak audit & unduh paket untuk klien/KAP.',
    'jr.wizard.guide.yearTitle': 'Tutup buku tahunan',
    'jr.wizard.guide.year1': 'Semua penyesuaian & pajak masa Desember final.',
    'jr.wizard.guide.year2': 'Checklist tutup 100% dan skor kelengkapan memadai.',
    'jr.wizard.guide.year3': 'Generate jurnal penutup ke laba ditahan.',
    'jr.wizard.guide.year4': 'Backup DB + export paket konsultan sebelum/sesudah tutup.',
    'jr.wizard.action.postPph': 'Posting PPh Final masa ini',
    'jr.wizard.action.exportPack': 'Export paket konsultan (Excel)',
    'jr.wizard.action.yearClose': 'Tutup buku tahun ini',
    'jr.wizard.action.yearClosed': 'Tahun sudah ditutup',
    'jr.wizard.confirmYear': 'Tutup buku tahun {year}? Jurnal penutup akan dibuat dan tidak bisa dihapus langsung.',
    'jr.wizard.yearClosedBanner': 'Tahun {year} ditutup {date} · Laba bersih {amt}',
    'jr.wizard.yearMonthHint': 'Tutup tahun biasanya dijalankan di Desember atau akhir tahun fiskal. Anda tetap bisa meninjau kesiapan kapan saja.',
    'jr.wizard.snack.pphOk': 'PPh Final diposting · {ref} · {amt}',
    'jr.wizard.snack.pphExists': 'PPh Final sudah ada · {ref}',
    'jr.wizard.snack.yearOk': 'Tutup buku berhasil',
    'jr.wizard.snack.packOk': 'Paket konsultan diunduh',
    'jr.wizard.link.importStmt': 'Impor statement',
    'jr.wizard.link.recon': 'Rekonsiliasi',
    'jr.wizard.link.bankRpt': 'Laporan bank',
    'jr.wizard.link.cashBank': 'Kas & bank',
    'jr.wizard.link.accrual': 'Akrual',
    'jr.wizard.link.depreciation': 'Penyusutan',
    'jr.wizard.link.revenue': 'Pendapatan',
    'jr.wizard.link.tb': 'Neraca saldo',
    'jr.wizard.link.audit': 'Audit trail',
    'jr.wizard.link.quality': 'Kontrol kualitas',
    'jr.wizard.link.backup': 'Backup database',
    'jr.wizard.link.engagements': 'Engagement',
    'jr.wizard.link.clients': 'Klien pajak',
    'jr.wizard.asideTitle': 'Standar kerja konsultan',
    'jr.wizard.aside1': 'PT dipisah ketat (JGI ≠ JGT) — filter perusahaan selalu aktif.',
    'jr.wizard.aside2': 'Jangan hitung PPh Final sebelum uang muka & omset dicek.',
    'jr.wizard.aside3': 'Simpan jejak: statement, bukti potong, SSP, dan paket Excel sebelum tutup.',
    'jr.wizard.aside4': 'Tutup tahun hanya setelah penyesuaian penting selesai dan neraca saldo seimbang.',
    'jr.wizard.jumpRec': 'Ke prioritas',
    'jr.wizard.print': 'Cetak paraf',
    'jr.wizard.priorityNow': 'Yang perlu dikerjakan dulu',
    'jr.wizard.focusStep': 'Buka langkah ini',
    'jr.wizard.allClear': 'Tidak ada masalah kritis',
    'jr.wizard.allClearHint': 'Bulan ini relatif bersih — lanjut checklist / paket konsultan.',
    'jr.wizard.stepsDone': '{done}/{total} langkah selesai',
    'jr.wizard.workTitle': 'Daftar kerja',
    'jr.wizard.gateTitle': 'Syarat tutup',
    'jr.wizard.signoffTitle': 'Paraf tutup bulan',
    'jr.wizard.signoffReady': 'Siap untuk paraf konsultan / reviewer.',
    'jr.wizard.signoffBlocked': '{n} masalah penting — selesaikan dulu sebelum paraf.',
    'jr.wizard.markAll': 'Centang semua',
    'jr.wizard.clearAll': 'Kosongkan',
    'jr.wizard.confirmMarkAll': 'Centang semua item checklist bulan ini?',
    'jr.wizard.snack.markAll': 'Checklist dilengkapi',
    'jr.wizard.snack.clearAll': 'Checklist dikosongkan',
    'jr.wizard.recentJournals': 'Jurnal bulan ini (terbaru)',
    'jr.wizard.kbdHint': 'Keyboard: ← → pindah langkah',
    'jr.wizard.col.step': 'Langkah',
    'jr.wizard.col.status': 'Status',
    'jr.wizard.col.metric': 'Ringkas',
    'jr.wizard.printSign': 'Paraf reviewer / konsultan',
    'jr.wizard.sev.critical': 'Kritis',
    'jr.wizard.sev.high': 'Tinggi',
    'jr.wizard.sev.medium': 'Sedang',
    'jr.wizard.sev.low': 'Rendah',
    'jr.wizard.kpi.omset': 'Omset bulan',
    'jr.wizard.kpi.activity': 'Jurnal bulan',
    'jr.wizard.kpi.readyHint': 'Syarat {done}/{total}',
    'jr.wizard.kpi.reconHint': 'Risiko tinggi {high}',
    'jr.wizard.kpi.omsetHint': 'Δ vs bulan lalu {pct}%',
    'jr.wizard.kpi.taxHint': 'PPh Final bulan ini',
    'jr.wizard.kpi.tbHint': '{n} akun aktif',
    'jr.wizard.kpi.activityHint': 'Semua jenis jurnal',
    'jr.wizard.gate.recon': 'Rekonsiliasi bersih',
    'jr.wizard.gate.pph': 'PPh Final siap',
    'jr.wizard.gate.tb': 'Neraca saldo seimbang',
    'jr.wizard.gate.checklist': 'Checklist 100%',
    'jr.wizard.gate.quality': 'Kelengkapan data ≥70',
    'jr.wizard.gate.ssp': 'SSP tanpa tunggakan',
    'jr.wizard.stat.umRatio': 'UM / omset YTD',
    'jr.wizard.stat.omsetPrev': 'Omset bulan lalu',
    'jr.wizard.stat.omsetYtd': 'Omset YTD',
    'jr.wizard.autoCheck': 'Isi checklist otomatis',
    'jr.wizard.autoSnack': 'AI menulis {n} note di lonceng — silakan cross-check.',
    'jr.wizard.batch': 'Semua PT',
    'jr.wizard.filterToggle': 'Periode & PT',
    'jr.wizard.batchTitle': 'Status tutup semua PT',
    'jr.wizard.batchSum':
      '{total} PT · siap penuh: {ready} · terkunci: {locked} · sudah paraf: {signed} · rata {avg}%',
    'jr.wizard.workpaper': 'Lembar kerja PDF',
    'jr.wizard.tasya': 'Bantuan Tasya',
    'jr.wizard.tasyaMemo': 'Buatkan memo (Tasya)',
    'jr.wizard.assistTitle': 'Bantuan Tasya · Tutup bulan',
    'jr.wizard.lock': 'Kunci bulan',
    'jr.wizard.unlock': 'Buka kunci',
    'jr.wizard.sign': 'Paraf tutup',
    'jr.wizard.revokeSign': 'Cabut paraf',
    'jr.wizard.signHistory': 'Riwayat paraf',
    'jr.wizard.lockedBanner': 'Bulan ini terkunci',
    'jr.wizard.deadlineNext': 'Batas setor:',
    'jr.wizard.deadlineTitle': 'Batas pajak',
    'jr.wizard.deadlineIn': '{n} hari lagi',
    'jr.wizard.deadlineOverdue': 'terlewat {n} hari',
    'jr.wizard.varianceTitle': 'Bandingkan vs bulan lalu',
    'jr.wizard.stat.revCur': 'Pendapatan bulan ini',
    'jr.wizard.stat.expCur': 'Beban bulan ini',
    'jr.wizard.stat.netCur': 'Net bulan ini',
    'jr.wizard.confirmLock':
      'Kunci bulan ini? Jurnal baru bertanggal bulan ini akan ditolak sampai dibuka lagi (admin).',
    'jr.wizard.confirmUnlock': 'Buka kunci bulan ini? Hanya admin.',
    'jr.wizard.confirmSign': 'Simpan paraf tutup bulan ini ke sistem?',
    'jr.wizard.confirmRevoke': 'Cabut paraf yang aktif?',
    'jr.wizard.snack.autoCheck': 'Checklist otomatis: {n} item diisi',
    'jr.wizard.snack.locked': 'Bulan dikunci',
    'jr.wizard.snack.unlocked': 'Kunci dibuka',
    'jr.wizard.snack.signed': 'Paraf tersimpan',
    'jr.wizard.snack.revoked': 'Paraf dicabut',
    'jr.wizard.snack.workpaper': 'Lembar kerja PDF diunduh',
    'jr.wizard.signedBy': 'Diparaf {who} · {when}',
    'jr.wizard.gate.signed': 'Sudah diparaf',
    'jr.wizard.gate.locked': 'Bulan terkunci',
    'jr.wizard.loadingStatus': 'Memuat status tutup bulan…',
    'jr.wizard.emptyHint': 'Pilih PT, lalu muat ulang jika angka masih 0%.',
    'jr.wizard.roleAll': 'Semua role',
    'jr.wizard.roleAkuntan': 'Akuntan',
    'jr.wizard.roleKonsultan': 'Konsultan',
    'jr.wizard.rolePartner': 'Partner',
    'jr.wizard.compareTitle': 'Bandingkan antar PT',
    'jr.wizard.compareMetric': 'Metrik',
    'jr.wizard.lockHistoryTitle': 'Riwayat kunci bulan',
    'jr.wizard.lockAction.lock': 'Kunci',
    'jr.wizard.lockAction.unlock': 'Buka',
    'jr.wizard.memoClient': 'Memo ke klien (PDF)',
    'jr.wizard.snack.memo': 'Memo klien diunduh',
    'jr.wizard.noLockHistory': 'Belum ada riwayat kunci/buka untuk bulan ini.',


    'corr.kicker': 'Jurnal · Jalur pembetulan',
    'corr.title': 'Jurnal Pembetulan',
    'corr.sub':
      'Koreksi jurnal/rekonsiliasi yang salah. Wajib pilih PT dulu, cari Ref ID asal, lalu pilih mode pembetulan.',
    'corr.stepPt': 'Pilih PT dulu',
    'corr.stepPtHint': 'JGI dan JGT terpisah — jangan sampai tertukar sebelum memulai.',
    'corr.lockUntilPt': 'Form terkunci sampai PT dipilih.',
    'corr.stepFind': 'Cari jurnal yang salah',
    'corr.stepFindHint': 'Masukkan Ref ID (J7P-…) atau pilih saran di bawah.',
    'corr.refLabel': 'Ref ID jurnal asal',
    'corr.btnFind': 'Cari',
    'corr.needRef': 'Isi Ref ID jurnal yang akan dibetulkan.',
    'corr.notFound': 'Ref ID tidak ditemukan.',
    'corr.ptMismatch': 'Jurnal {pt} ≠ PT aktif {pick}. Ganti PT agar cocok.',
    'corr.ptMatch': 'PT cocok',
    'corr.ptBad': 'PT tidak cocok',
    'corr.fixPtFirst': 'Samakan PT dengan jurnal asal dulu.',
    'corr.suggestions': 'Saran jurnal terbaru (PT ini)',
    'corr.suggestionsHint': 'Klik untuk memuat — prioritaskan yang pending / baru saja.',
    'corr.noSuggestions': 'Belum ada jurnal untuk PT ini.',
    'corr.stepFix': 'Pilih cara pembetulan',
    'corr.stepFixHint': 'Balik penuh, sesuaikan manual, atau void jurnal asal.',
    'corr.modeReverse': 'Balik penuh (pembetulan)',
    'corr.modeReverseHint': 'Buat jurnal lawan (Dr↔Cr) bertanda [CORR:…]. Asal tetap ada.',
    'corr.modeCustom': 'Sesuaikan manual',
    'corr.modeCustomHint': 'Edit baris akun & nominal sesuai koreksi yang dibutuhkan.',
    'corr.modeVoid': 'Void jurnal asal',
    'corr.modeVoidHint': 'Batalkan penuh dengan VOID-… (harus unmatch rekonsiliasi dulu jika terkunci).',
    'corr.reason': 'Alasan pembetulan',
    'corr.defaultReason': 'Pembetulan rekonsiliasi / posting salah · {ref}',
    'corr.postCleared': 'Langsung masuk laporan (cleared)',
    'corr.linesTitle': 'Baris jurnal pembetulan',
    'corr.reseed': 'Isi ulang dari balik',
    'corr.needBalance': 'Debit harus = Kredit dan > 0.',
    'corr.confirmVoid': 'Saya yakin void jurnal asal (tidak bisa dibatalkan dengan mudah).',
    'corr.confirmVoidHint': 'Centang konfirmasi void dulu.',
    'corr.btnPost': 'Posting Pembetulan',
    'corr.btnPostAuto': 'Posting otomatis…',
    'corr.btnVoid': 'Void Jurnal Asal',
    'corr.snackOk': 'Berhasil · {ref}',
    'corr.autoHint': 'Mode balik penuh: pembetulan diposting otomatis setelah jurnal asal siap — tidak perlu klik tombol.',
    'corr.autoPosting': 'Memposting pembetulan otomatis…',
    'corr.autoPosted': 'Pembetulan otomatis tersimpan · {ref}',
    'corr.alreadyPosted': 'Pembetulan untuk Ref ini sudah diposting di sesi ini.',
    'corr.done': 'Pembetulan tersimpan',
    'corr.progressLabel': 'Progres pembetulan',
    'corr.progressWait': 'Menunggu…',
    'corr.checkPt': 'PT aktif',
    'corr.checkJournal': 'Jurnal asal cocok',
    'corr.checkBalance': 'Debit = Kredit',
    'corr.checkVoid': 'Konfirmasi void',
    'corr.needJournalFirst': 'Cari & pilih jurnal asal dulu.',
    'corr.statusPending': 'Pending',
    'corr.statusCleared': 'Cleared',
    'corr.statusReleased': 'Released',
    'corr.filterAll': 'Semua',
    'corr.sugSearchPh': 'Cari ref / memo…',
    'corr.expandSug': 'Perbesar daftar saran',
    'corr.expandOrig': 'Detail jurnal asal',
    'corr.linesCount': 'baris',
    'corr.showAllLines': 'Lihat semua {n} baris',
    'corr.showMore': 'Tampilkan lebih banyak',
    'corr.showLess': 'Tampilkan lebih sedikit',
    'corr.switchToJournalPt': 'Samakan ke PT jurnal ini',
    'corr.voidLockedHint': 'Jurnal sudah cleared — unmatch rekonsiliasi dulu jika void gagal.',
    'corr.previewTitle': 'Pratinjau posting',
    'corr.previewFoot': '{n} baris akan diposting sebagai [CORR:{tag}]',
    'corr.nextOne': 'Pembetulan berikutnya',
    'corr.sessionHistory': 'Riwayat sesi ini',
    'corr.hotkeyHint': 'Shortcut: Enter cari · Ctrl+Enter posting',
    'corr.copyRef': 'Salin Ref',
    'corr.copied': 'Disalin · {ref}',
    'corr.copyFail': 'Gagal menyalin',
    'corr.timelineTitle': 'Rantai Ref (asal → CORR → VOID)',
    'corr.roleOrigin': 'Asal',
    'corr.roleCorr': 'Pembetulan',
    'corr.roleVoid': 'Void',
    'corr.roleRelated': 'Terkait',
    'corr.warnAlreadyVoid': 'Jurnal ini sudah void — tidak bisa dibetulkan lagi.',
    'corr.warnAlreadyCorr': 'Ini jurnal pembetulan (CORR). Pastikan Anda memang ingin mengkoreksi koreksi.',
    'corr.warnHasCorr': 'Sudah ada {n} pembetulan terkait Ref ini — cek timeline sebelum posting ulang.',
    'corr.cashImpact': 'Dampak kas/bank',
    'corr.cashOrig': 'Asal',
    'corr.cashCorr': 'Koreksi',
    'corr.cashNet': 'Gabungan',
    'corr.compareTitle': 'Bandingkan akun (asal vs koreksi)',
    'corr.compareOrig': 'Net asal',
    'corr.compareCorr': 'Net koreksi',
    'corr.compareAfter': 'Setelah',
    'corr.confirmPostTitle': 'Konfirmasi posting pembetulan?',
    'corr.confirmVoidTitle': 'Konfirmasi void jurnal asal?',
    'corr.recentCorrections': 'Pembetulan terbaru (PT ini)',
    'jr.entryHeader': 'Header jurnal',
    'jr.entryLinesTitle': 'Baris akun',
    'jr.entryLinesSub': 'Minimal 2 baris. Satu baris hanya debit atau kredit. Saldo harus seimbang sebelum posting.',
    'jr.entryFilledLines': 'Baris terisi',
    'jr.entryDiff': 'Selisih',
    'jr.entryPreview': 'Preview jurnal',
    'jr.entryReset': 'Kosongkan',
    'jr.entrySwap': 'Tukar Dr/Cr',
    'jr.entryDuplicate': 'Duplikat baris',
    'jr.entrySharedPt': 'Bersama / tanpa PT',
    'jr.entryPostCleared': 'Langsung masuk Laporan Keuangan',
    'jr.entryRequireApproval': 'Perlu approval reviewer',
    'jr.entryProject': 'Proyek',
    'jr.entryWarehouse': 'Gudang',
    'jr.entryPostedCleared': 'Sudah cleared — masuk neraca & laba rugi.',
    'jr.entryPostedPending': 'Pending rekonsiliasi — belum masuk laporan hingga di-clear.',
    'jr.lookupKicker': 'Lacak transaksi',
    'jr.lookupTitle': 'Cari Ref ID',
    'jr.lookupSub':
      'Setiap debit/kredit punya Ref ID unik J7P-###### (3 campuran + nomor urut). Cari untuk melacak memo & baris akun.',
    'jr.lookupClickHint': 'Klik baris untuk popup rincian lengkap (tanggal, jam input, akun).',
    'jr.lookup.truncated': 'Hasil dibatasi {n} baris — sempitkan filter bila perlu',
    'jr.lookup.pageTotal': 'Total halaman ini',
    'jr.btnMulti': 'Multi-Baris',
    'jr.btnQuick': '+ Cepat',
    'jr.btnPost': 'Posting Jurnal',
    'jr.btnTrack': 'Lacak',
    'jr.btnVoid': 'Void',
    'jr.btnAddRow': 'Baris',
    'jr.btnSaveNote': 'Simpan catatan',
    'jr.labelSource': 'Sumber',
    'jr.labelMemo': 'Memo / keterangan jurnal',
    'jr.labelLineDesc': 'Keterangan baris',
    'jr.labelSearch': 'Ref ID / ID / kata di memo',
    'jr.searchPh': 'contoh: J7P-000001 atau transfer',
    'jr.writeMemo': 'Tulis memo jurnal',
    'jr.noteTitle': 'Memo / Catatan',
    'jr.lineAccounts': 'Baris akun',
    'jr.sourceCompany': 'Sumber · Perusahaan',
    'jr.savedRef': 'Tersimpan · Ref ID',
    'jr.snackSaved': 'Tersimpan Ref ID {ref}',
    'jr.snackVoided': 'Jurnal {ref} di-void',
    'jr.snackVoidFail': 'Gagal void',
    'jr.snackSearchFail': 'Gagal mencari',
    'jr.confirmVoid': 'Void jurnal {ref}?\n\nAkan dibuat jurnal pembalik VOID-{ref}.',
    'jr.emptyPeriod': 'Belum ada jurnal pada periode ini.',
    'jr.emptySearch': 'Tidak ada jurnal. Coba Ref ID lain atau perluas tanggal.',
    'jr.detail': 'Detail',
    'jr.detailKicker': 'Rincian Ref ID',
    'jr.ref': 'Ref {ref}',
    'jr.journalDate': 'Tanggal jurnal',
    'jr.reconStatus': 'Status rekonsiliasi',
    'jr.balanced': 'Seimbang',
    'jr.unbalanced': 'Tidak seimbang',
    'jr.dbId': 'ID database',
    'jr.lineCount': 'Jumlah baris',
    'jr.recon.pending': 'Pending',
    'jr.recon.cleared': 'Cleared',
    'jr.recon.released': 'Released',
    'jr.source.all': 'Semua sumber',
    'jr.source.quick': 'Cepat',
    'jr.source.manual': 'Manual / Umum',
    'jr.source.purchase': 'Pembelian',
    'jr.source.sales': 'Penjualan',
    'jr.source.cash_receipt': 'Penerimaan kas',
    'jr.source.cash_disbursement': 'Pengeluaran kas',
    'jr.source.import': 'Impor',
    'jr.source.importStmt': 'Impor / Statement',
    'jr.source.opening': 'Saldo awal',
    'jr.source.tax': 'Pajak',
    'jr.source.close': 'Tutup buku',
    'jr.source.void': 'Void',
    'jr.source.correction': 'Pembetulan',
    'jr.source.adjustment': 'Penyesuaian',

    'recon.kicker': 'Pencocokan cerdas · Anti dobel',
    'recon.title': 'Rekonsiliasi',
    'recon.tasks': '{n} tugas',
    'recon.pickPt': 'Pilih PT',
    'recon.pickPtPlaceholder': 'PT JGI / JGT…',
    'recon.needCompanyTitle': 'Pilih PT dulu',
    'recon.needCompanyBody': 'Pilih PT JGI atau JGT agar data rekonsiliasi, saran, dan saldo muncul di bawah.',
    'recon.gateKicker': 'Workspace rekonsiliasi',
    'recon.gateStep1': 'Pilih PT (JGI / JGT)',
    'recon.gateStep2': 'Set periode (bulan / 30 hari / tahun)',
    'recon.gateStep3': 'Cocokkan buku kiri ↔ statement kanan',
    'recon.gateRecent': 'Terakhir dipakai',
    'recon.quickPeriods': 'Periode cepat',
    'recon.periodToday': 'Hari ini',
    'recon.periodMonth': 'Bulan ini',
    'recon.pickMonth': 'Bulan',
    'recon.pickMonthPlaceholder': 'Januari – Desember',
    'recon.pickMonthHint':
      'Pilih bulan: tanggal dari 1 sampai hari ini (nomor tanggal tetap hari ini, bulannya diganti).',
    'recon.period30': '30 hari',
    'recon.periodYear': 'Tahun {year}',
    'recon.periodCustom': 'Kustom',
    'recon.coachKicker': 'Tips meja kerja',
    'recon.coachTitle': 'Cara kerja rekonsiliasi cepat',
    'recon.coachBody':
      'Pilih baris buku di kiri, statement di kanan, lalu Match/Tolak. Gunakan antrian fokus untuk risiko tinggi.',
    'recon.coachTip1': 'j / k — antrian fokus',
    'recon.coachTip2': 'Enter — match · x — tolak',
    'recon.coachTip3': 'u — urungkan aksi terakhir',
    'recon.coachTip1Mobile': 'Ketuk baris buku di panel bawah',
    'recon.coachTip2Mobile': 'Ketuk baris statement, lalu Match',
    'recon.coachTip3Mobile': 'Gunakan Urungkan jika salah cocok',
    'recon.expandBoards': 'Perbesar board',
    'recon.collapseBoards': 'Kecilkan',
    'recon.boardsFsTitle': 'Board rekonsiliasi — layar penuh',
    'recon.taskFeedTitle': '{n} notifikasi tugas · {pt}',
    'recon.sub': 'Kiri = buku tercatat · Kanan = statement baru · cocokkan tanpa dobel posting',
    'recon.refresh': 'Muat ulang',
    'recon.matchLow': 'Cocokkan semua risiko rendah ({n})',
    'recon.export': 'Ekspor Excel',
    'recon.undo': 'Urungkan',
    'recon.ruleBuilder': 'Pembuat aturan',
    'recon.advanced': 'Pengaturan',
    'recon.toolsMenu': 'Ekspor & alat',
    'recon.matchGroup': 'Cocokkan grup',
    'recon.reject': 'Tolak',
    'recon.partial': 'Cocok sebagian',
    'recon.unmatch': 'Lepas cocok',
    'recon.newRule': '+ Aturan baru',
    'recon.quickJournal': '+ Jurnal cepat',
    'recon.eStatement': '+ E-Statement',
    'recon.leftTitle': 'Kiri · Sudah tercatat',
    'recon.rightTitle': 'Kanan · Baru masuk',
    'recon.kpiMatched': 'Terekonciliasi',
    'recon.kpiBookOpen': 'Buku belum cocok',
    'recon.kpiStmtOpen': 'Statement belum cocok',
    'recon.kpiDiff': 'Selisih',
    'recon.kpiRisk': 'Risiko',
    'recon.kpiAging': 'Statement menua',
    'recon.presetAging': 'Menua',
    'recon.presetHigh': 'Risiko tinggi',
    'recon.presetPartial': 'Sisa sebagian',
    'recon.presetMonth': 'Bulan ini',
    'recon.saveFilter': 'Simpan filter ini',
    'recon.emptyBook': 'Belum ada data tercatat terbuka',
    'recon.emptyStmt': 'Belum ada statement baru terbuka',
    'recon.emptyPairs': 'Belum ada antrian atau pasangan.',
    'recon.emptyHistory': 'Belum ada riwayat aksi.',
    'recon.emptyRules': 'Belum ada aturan.',
    'recon.sameBank': 'Wajib rekening bank sama',
    'recon.bankMode': 'Mode saldo bank',
    'recon.dateWindow': 'Jendela tanggal',
    'recon.amountTol': 'Toleransi nominal',
    'recon.compareTitle': 'Perbandingan duplikat',
    'recon.compareStudio': 'Anti dobel · Studio banding',
    'recon.confirmDiffDir': 'Arah transaksi berbeda',
    'recon.confirmDirLead': 'Nominal sama, tapi masuk/keluar tidak sama antara buku dan statement.',
    'recon.confirmDirPoint1': 'Cek dulu: apakah ini transaksi yang sama, hanya salah arah posting?',
    'recon.confirmDirPoint2': 'Jika salah pasangan (bukan transaksi yang sama) — batalkan, jangan cocokkan.',
    'recon.confirmDirPoint3': 'Jika yakin pasangan yang sama — klik “Ya, tetap cocokkan”.',
    'recon.sideUnknown': 'Arah tidak jelas',
    'recon.confirmMatchLow': 'Cocokkan semua risiko rendah?',
    'recon.confirmSaveFilter': 'Simpan filter saat ini',
    'recon.snackMatched': 'Berhasil dicocokkan — bukan dobel posting',
    'recon.snackRejected': 'Ditolak → masuk riwayat',
    'recon.snackPartial': 'Cocok sebagian tersimpan',
    'recon.snackBatch': 'Batch selesai: {m} cocok, {f} gagal',
    'recon.snackExcel': 'Excel diunduh',
    'recon.pickPair': 'Pilih 1 baris kiri + 1 baris kanan',
    'recon.keyboard': 'Keyboard:',
    'recon.history': 'Riwayat',
    'recon.rules': 'Aturan',
    'recon.suggestions': 'Saran',
    'recon.suggestionsHint': '{n} pasangan siap ditinjau',
    'recon.suggestionsBadge': 'siap',
    'recon.bulkSelectPage': 'Pilih halaman ini',
    'recon.bulkPicked': '{n} dipilih',
    'recon.bulkMatch': 'Cocokkan terpilih',
    'recon.bulkReject': 'Tolak terpilih',
    'recon.bulkPickFirst': 'Centang saran dulu',
    'recon.perPage': '{n}/halaman',
    'recon.pageOf': 'Halaman {page}/{pages}',
    'recon.actions': 'Aksi',
    'recon.emptySuggestionsFilter': 'Tidak ada saran pada filter ini',
    'recon.snackBulkMatch': 'Massal match: {m} berhasil, {f} gagal',
    'recon.snackBulkReject': 'Massal tolak: {m} berhasil, {f} gagal',
    'recon.bulkDirTitle': 'Ada arah berbeda di pilihan',
    'recon.bulkDirLead': '{n} pasangan terpilih — sebagian arah debit/kredit tidak sama.',
    'recon.bulkDirPoint1': 'Pastikan bukan salah pasangan sebelum cocokkan massal.',
    'recon.bulkDirPoint2': 'Jika yakin, lanjutkan. Jika ragu, batalkan dan tinjau satu per satu.',
    'recon.bulkDirConfirm': 'Ya, cocokkan semua terpilih',
    'recon.amountGroups': 'Nominal',
    'recon.amountGroupsHint': 'Klik chip → lihat semua transaksi open dengan nominal itu',
    'recon.amountGroupTip': '{amount}: {left} buku · {right} statement open',
    'recon.amountFilterOn': 'Filter {amount}: {sug} saran · {left} buku · {right} statement',
    'recon.amountFilterOff': 'Filter nominal dimatikan',
    'recon.amountFilterBanner': 'Filter aktif: {amount}',
    'recon.amountFilterCounts': '{sug} saran · {left} di buku · {right} di statement',
    'recon.amountFilterNoSugHint':
      'Belum ada saran otomatis. Bandingkan daftar di bawah, atau catat dulu yang belum ada di buku.',
    'recon.amountFilterNoneLeft': 'Belum ada di buku — catat dulu lewat link pencatatan',
    'recon.amountFilterNoneRight': 'Belum ada di statement — upload / cek e-statement',
    'recon.amountFilterGoBoards': 'Lihat antrian kiri/kanan',
    'recon.amountOpenTitle': 'Open {amount}',
    'recon.amountOpenHint': 'Klik baris untuk masuk Area match',
    'recon.amountExplainNeedBook':
      'Statement: {right} · Buku: {left}. Selisih {gap} kemungkinan belum dicatat di buku.',
    'recon.amountExplainNeedStmt':
      'Buku: {left} · Statement: {right}. Selisih {gap} kemungkinan belum ada di statement.',
    'recon.amountExplainEqual':
      'Jumlah sama ({left}↔{right}). Cek tanggal & deskripsi sebelum Match.',
    'recon.amountExplainEmpty': 'Tidak ada transaksi open untuk {amount}.',
    'recon.amountOpenTip': 'Klik baris → masuk Area match. Belum tercatat? pakai link Jurnal cepat / E-Statement.',
    'recon.linkQuickJournal': 'Jurnal cepat',
    'recon.linkQuickJournalHint': 'Catat transaksi yang belum masuk buku',
    'recon.linkJournalEntry': 'Jurnal manual',
    'recon.linkJournalEntryHint': 'Input jurnal lengkap di tab baru',
    'recon.linkStatements': 'E-Statement',
    'recon.linkStatementsHint': 'Upload / cek statement bank',
    'recon.match': 'Cocokkan',
    'recon.filter': 'Filter',
    'recon.inbox': 'Kotak masuk pintar',
    'recon.riskLow': 'aman',
    'recon.riskMed': 'perlu dicek',
    'recon.riskHigh': 'berisiko',
    'recon.chipAging': '{n} belum cocok lama',
    'recon.chipDup': '{n} kemungkinan dobel',
    'recon.srcStatement': 'Statement',
    'recon.srcQuick': 'Cepat',
    'recon.srcManual': 'Manual',
    'recon.balBalanced': 'Balance — buku = statement',
    'recon.balBookHigher': 'Buku lebih besar dari statement',
    'recon.balStmtHigher': 'Statement lebih besar dari buku',
    'recon.balTitle': 'Saldo bank — buku vs statement',
    'recon.balBook': 'Buku',
    'recon.balStmt': 'Statement',
    'recon.balMatched': 'Sudah match',
    'recon.balDiffLabel': 'Selisih (buku - stmt)',
    'recon.dateWindowDays': 'Jendela tanggal: ±{n} hari',
    'recon.amountTolRp': 'Toleransi nominal: Rp {n}',
    'recon.leftSub': 'Quick Journal / Manual — debit & kredit jelas',
    'recon.rightSub': 'E-Statement / Import — tampil asal file & bank',
    'recon.kbNav': 'navigasi',
    'recon.kbSwitch': 'ganti sisi',
    'recon.kbMatch': 'match',
    'recon.kbReject': 'tolak',
    'recon.kbPartial': 'partial',
    'recon.kbGroup': 'grup',
    'recon.kbPick': 'pilih saran/kandidat',
    'recon.kbUndo': 'undo',
    'recon.kbClear': 'bersihkan',
    'recon.savedFilters': 'Filter tersimpan:',
    'recon.resetFilter': 'Reset filter',
    'recon.uploadStmt': 'Upload statement',
    'recon.queueRight': '{n} antri kanan',
    'recon.inboxHubMeta': 'cocokkan · anti-double',
    'recon.quickDC': 'Quick Debit/Credit',
    'recon.queueLeft': '{n} antri kiri',
    'recon.cleanReport': 'Laporan bersih',
    'recon.pctMatched': '{n}% matched',
    'recon.matchPct': '{n}% match',
    'recon.inboxTipDefault': 'Semua mutasi baru diverifikasi di sini sebelum dianggap final.',
    'recon.dupGroups': '{g} grup berpotensi double · {n} baris tertandai',
    'recon.dupHint': 'Bandingkan di studio compare di bawah sebelum match — hindari laporan duplikasi.',
    'recon.openCompare': 'Buka Compare',
    'recon.book': 'Buku',
    'recon.statement': 'Statement',
    'recon.colRef': 'Ref',
    'recon.colDesc': 'Keterangan',
    'recon.colOrigin': 'Asal / sumber',
    'recon.colAction': 'Aksi',
    'recon.pick': 'Pilih',
    'recon.voidDouble': 'Void double',
    'recon.compareHint':
      'Tip: pilih 1 baris yang valid untuk di-match ke sisi lawan, lalu Tolak baris double agar tidak masuk laporan dua kali.',
    'recon.agingAlert': '{n} statement belum di-match > 30 hari',
    'recon.agingHint': 'Prioritaskan baris aging agar rekonsiliasi tidak menumpuk.',
    'recon.agingOldest': 'Tertua: {days} hari · {desc}',
    'recon.gateClick': 'Klik untuk muat workspace',
    'recon.checkTitle': 'Checklist kerja',
    'recon.checkLow': 'Cocokkan risiko rendah ({n})',
    'recon.checkAging': 'Update aging 30+ ({n})',
    'recon.checkHigh': 'Review risiko tinggi ({n})',
    'recon.checkDup': 'Bandingkan duplikat ({n})',
    'recon.chipAge07': '{n} aging 0–7h',
    'recon.chipAge830': '{n} aging 8–30h',
    'recon.seeAllTasks': 'Lihat semua {n} di Saran',
    'recon.pairDays': 'Selisih {n} hari',
    'recon.ageDays': 'Aging {n} hari',
    'recon.partialRemain': 'Sisa {remain} · terpakai {used}',
    'recon.emptyActivityHint': 'Setelah Match / Tolak, jejak aksi muncul di sini.',
    'recon.emptyPairsHint':
      'Upload & simpan e-statement agar muncul di kolom Baru (asal). Match/tolak akan tercatat di tabel yang sama.',
    'recon.startFromSaran': 'Mulai dari saran',
    'recon.tlMatch': 'Cocokkan',
    'recon.tlStmtInbox': 'E-statement masuk antrian',
    'recon.statusQueuedStmt': 'Antrian statement',
    'recon.statusQueuedBook': 'Antrian buku',
    'recon.waitingBook': 'Menunggu data tercatat (Jurnal Cepat)',
    'recon.waitingStmt': 'Menunggu e-statement',
    'recon.gotoMatch': 'Cocokkan',
    'recon.tlReject': 'Tolak',
    'recon.tlUndo': 'Urungkan',
    'recon.tlReopen': 'Buka ulang',
    'recon.tlRelease': 'Loloskan',
    'recon.tlUnmatch': 'Lepas cocok',
    'recon.tlPartial': 'Sebagian',
    'recon.tlGroup': 'Grup',
    'recon.tlBatch': 'Batch match',
    'recon.deskMode': 'Mode desk',
    'recon.modeWork': 'Kerja',
    'recon.modeReview': 'Review',
    'recon.focusTitle': 'Antrian fokus hari ini',
    'recon.focusReviewTitle': 'Antrian review (risiko / aging)',
    'recon.focusMeta': '{high} high · {aging} aging · {n} total',
    'recon.focusPrev': 'Prev',
    'recon.focusNext': 'Next',
    'recon.focusOpen': 'Buka',
    'recon.kbQueue': 'antrian',
    'recon.batchPreviewHint': 'Pratinjau {n} pasangan aman (skor tertinggi dulu):',
    'recon.batchPreviewEmpty': 'Tidak ada pasangan low-risk untuk dipratinjau.',
    'recon.batchRun': 'Jalankan {n} match',
    'recon.historyHub': 'Riwayat',
    'recon.density': 'Kepadatan',
    'recon.exportAging': 'CSV aging',
    'recon.copyDigest': 'Salin digest',
    'recon.exportAgingEmpty': 'Tidak ada statement aging > 7 hari',
    'recon.exportAgingOk': 'CSV aging {n} baris diunduh',
    'recon.digestCopied': 'Ringkasan digest disalin',
    'recon.noteRequired': 'Isi catatan dulu untuk risiko sedang/tinggi',
    'recon.noteRequiredMark': 'wajib',
    'recon.notePlaceholderRequired': 'Wajib: alasan match / tolak…',
    'recon.noteTplSameAmt': 'Nominal sama',
    'recon.noteTplDirDiff': 'Arah beda — dicek',
    'recon.noteTplFee': 'Biaya admin / selisih kecil',
    'recon.noteTplPartial': 'Partial / sisa',
    'recon.noteTplChecked': 'Sudah diverifikasi',
    'recon.lockTaken': 'Sedang direview oleh {user}',
    'recon.lockMine': 'Anda memegang review · {user}',
    'recon.lockBlocked': 'Terkunci oleh {user} — tunggu atau pilih pasangan lain',
    'recon.pinPreset': 'Pin filter PT',
    'recon.pinPresetNeed': 'Pilih filter tersimpan dulu',
    'recon.pinPresetOk': 'Filter dipin untuk {pt}',
    'recon.confTitle': 'Confidence',
    'recon.confAmount': 'Nominal',
    'recon.confDate': 'Tanggal',
    'recon.confDir': 'Arah',
    'recon.confBank': 'Bank',
    'recon.confWarn': 'Peringatan',
    'recon.emptyBookHint':
      'Panel kiri = Jurnal Cepat / Manual yang belum cocok. Upload e-statement mengisi panel kanan — catat buku di Jurnal Cepat agar bisa dicocokkan.',
    'recon.emptyStmtHint':
      'Panel kanan = hasil e-statement yang disimpan ke antrian recon. Upload & simpan e-statement, lalu kembali ke sini — baris muncul otomatis.',
    'recon.bankFilterCleared': 'Filter bank dilepas agar semua statement di periode ini tampil.',
    'recon.ruleSub': 'Boost/prefer scoring pasangan berdasarkan pola teks, sisi, dan bank',
    'recon.pattern': 'Pattern',
    'recon.matchType': 'Match type',
    'recon.preferSide': 'Prefer side',
    'recon.boost': 'Boost',
    'recon.bankCode': 'Bank code',
    'recon.active': 'Aktif',
    'recon.saveChanges': 'Simpan perubahan',
    'recon.addRule': 'Tambah rule',
    'recon.emptyRulesHint': 'Belum ada rule. Tambahkan untuk mengarahkan scoring otomatis.',
    'recon.matchContains': 'Mengandung',
    'recon.matchStarts': 'Diawali',
    'recon.matchRegex': 'Regex',
    'recon.sideAny': 'Bebas',
    'recon.sideIn': 'Masuk (in)',
    'recon.sideOut': 'Keluar (out)',
    'recon.groupCandidates': 'Kandidat grup 1↔N / N↔1',
    'recon.group1n': '1 buku → N stmt',
    'recon.groupN1': 'N buku → 1 stmt',
    'recon.bookCount': 'Buku ({n})',
    'recon.stmtCount': 'Statement ({n})',
    'recon.totalLabel': 'Total: {n}',
    'recon.filterActive': 'Filter aktif',
    'recon.bookedLabel': 'Sudah tercatat',
    'recon.directionDiff': 'Arah beda',
    'recon.splitLike': 'Split-like',
    'recon.newOrigin': 'Baru · {origin}',
    'recon.pickedLeft': 'Dipilih kiri (buku)',
    'recon.pickedRight': 'Dipilih kanan (statement)',
    'recon.clickLeft': '— klik baris kiri —',
    'recon.clickRight': '— klik baris kanan —',
    'recon.dockTitle': 'Area match',
    'recon.dockSubEmpty': 'Slot kosong di bawah siap diisi — klik baris kiri/kanan agar masuk ke sini.',
    'recon.dockSubEmptyMobile': 'Ketuk baris buku atau statement di bawah agar masuk ke sini.',
    'recon.dockSubActive': 'Bandingkan pasangan, lalu pilih Match / Loloskan / Tolak.',
    'recon.dockClose': 'Tutup & kosongkan pilihan',
    'recon.dockDropLeft': 'Baris buku yang diklik akan muncul di sini',
    'recon.dockDropRight': 'Baris statement yang diklik akan muncul di sini',
    'recon.dockBridgeHint': 'Akan terhubung',
    'recon.dockGuide1': 'Klik 1 baris di panel kiri (sudah tercatat).',
    'recon.dockGuide2': 'Klik 1 baris di panel kanan (statement bank).',
    'recon.dockGuide1Mobile': 'Ketuk 1 baris di panel Buku (sudah tercatat).',
    'recon.dockGuide2Mobile': 'Ketuk 1 baris di panel Statement.',
    'recon.dockGuide3': 'Cek perbandingan, lalu Match / Tolak.',
    'recon.dockCompareTitle': 'Perbandingan detail',
    'recon.diffOk': 'Sama',
    'recon.diffWarn': 'Mendekati',
    'recon.diffBad': 'Beda',
    'recon.nSelected': '{n} terpilih',
    'recon.pairReady': 'Siap match',
    'recon.pairDirDiff': 'Nominal OK · arah beda',
    'recon.pairAmtDiff': 'Nominal beda',
    'recon.originLabel': 'Asal: {origin}',
    'recon.matchToReport': 'Match → Laporan',
    'recon.releaseToReport': 'Loloskan ke laporan',
    'recon.matchGroup1n': 'Match grup 1↔N',
    'recon.decideTitle': 'Pilih keputusan',
    'recon.actionMatchName': 'Match',
    'recon.actionMatchShort': 'Pasangkan buku ↔ statement',
    'recon.actionMatchDesc':
      'Match = pasangan yang sama. Kedua sisi diikat jadi 1 rekonsiliasi, keluar dari antrian, dan masuk laporan sebagai cocok (bukan dobel).',
    'recon.actionReleaseName': 'Loloskan',
    'recon.actionReleaseShort': 'Masuk laporan tanpa pasangan',
    'recon.actionReleaseDesc':
      'Loloskan = tidak ada pasangan, tapi tetap masuk laporan. Dipakai jika transaksi valid tapi tidak perlu / tidak ketemu pasangan statement atau buku.',
    'recon.actionRejectName': 'Tolak',
    'recon.actionRejectShort': 'Bukan pasangan yang sama',
    'recon.actionRejectDesc':
      'Tolak = ini bukan pasangan. Disimpan di riwayat ditolak agar tidak disarankan lagi. Data tetap di antrian sampai dicocokkan/loloskan dengan benar.',
    'recon.actionGroupShort': 'Satu ke banyak / banyak ke satu',
    'recon.dockCompareHint': 'Hijau = sama · Kuning = mendekati · Merah = beda — cek dulu sebelum Match',
    'recon.diffStatus': 'Status',
    'recon.clear': 'Clear',
    'recon.notePlaceholder': 'Tulis catatan match / tolak di sini…',
    'recon.noteHint': 'Tarik pojok kanan bawah untuk besar/kecilin. Tersimpan saat Match atau Tolak.',
    'recon.partialHint': 'Nominal beda — partial match:',
    'recon.field': 'Field',
    'recon.diffLeft': 'Kiri (buku)',
    'recon.diffRight': 'Kanan (statement)',
    'recon.direction': 'Arah',
    'recon.topRight': 'Top kandidat kanan',
    'recon.topLeft': 'Top kandidat kiri',
    'recon.onlyDupWarnings': 'Hanya peringatan duplikat',
    'recon.multiSelected': 'Kiri: {l} · Kanan: {r} terpilih',
    'recon.leftEyebrow': 'Buku · Inbox Quick/Manual',
    'recon.leftPanelTitle': 'Data tercatat',
    'recon.leftPanelHint': 'Klik baris → masuk Area match sebagai sisi buku',
    'recon.rightEyebrow': 'Statement · Inbox upload',
    'recon.rightPanelTitle': 'Dana baru + asal',
    'recon.rightPanelHint': 'Klik baris → masuk Area match sebagai sisi statement',
    'recon.rangeOf': '{from}–{to} dari {total}',
    'recon.searchLeft': 'Cari tgl / keterangan / nominal…',
    'recon.searchRight': 'Cari asal / bank / nominal…',
    'recon.colSource': 'Asal sumber',
    'recon.prev': '‹ Prev',
    'recon.next': 'Next ›',
    'recon.timeline': 'Timeline aksi',
    'recon.undoLast': 'Undo aksi terakhir',
    'recon.emptyActivity': 'Belum ada aktivitas.',
    'recon.fullHistory': 'History lengkap',
    'recon.eventPage': '{n} event · 100 / halaman',
    'recon.historySub': 'Semua aksi terekam: tanggal · bulan · tahun · jam · perubahan dari → ke',
    'recon.colWhen': 'Waktu',
    'recon.colActionLabel': 'Aksi',
    'recon.colFromTo': 'Dari → Ke',
    'recon.colDetail': 'Detail',
    'recon.colBy': 'Oleh',
    'recon.pairsTitle': 'Antrian & Pasangan',
    'recon.pairsSub':
      'Antrian e-statement / buku yang menunggu pasangan, plus hasil match & tolak. Setelah kirim e-statement, baris muncul di sini.',
    'recon.colStatus': 'Status',
    'recon.colBooked': 'Sudah tercatat',
    'recon.colNew': 'Baru (asal)',
    'recon.statusMatched': 'Match',
    'recon.statusRejected': 'Ditolak',
    'recon.kindPartial': 'Partial',
    'recon.kindGroup': 'Grup',
    'recon.editAgain': 'Edit lagi',
    'recon.confirmMatchBtn': 'Ya, tetap cocokkan',
    'recon.batchMatchBody':
      'Akan mencocokkan {n} pasangan low-risk (tanpa arah beda) sekaligus. High/medium tetap manual.',
    'recon.bankFilterChip': 'Bank {code}',
    'recon.clearBankFilter': 'Hapus filter bank',
    'recon.run': 'Jalankan',
    'recon.filterName': 'Nama filter',
    'recon.snackFilterSaved': 'Filter tersimpan',
    'recon.snackPatternRequired': 'Pattern rule wajib diisi',
    'recon.snackRuleUpdated': 'Rule diperbarui',
    'recon.snackRuleAdded': 'Rule ditambahkan',
    'recon.snackRuleSaveFail': 'Gagal simpan rule',
    'recon.snackRuleDeleted': 'Rule dihapus',
    'recon.snackRuleDeleteFail': 'Gagal hapus rule',
    'recon.confirmDirMsg':
      'Arah debit/kredit berbeda antara buku dan statement. Yakin ini pasangan yang sama (bukan salah posting)?',
    'recon.snackMatchFail': 'Gagal match',
    'recon.pickPairFirst': 'Pilih pasangan dulu',
    'recon.rejectNote': 'Ditolak — bukan pasangan',
    'recon.confirmVoid': 'Void jurnal #{id}? Baris ini akan keluar dari antrian & tidak masuk laporan.',
    'recon.voidReason': 'Duplikat di rekonsiliasi — anti double laporan',
    'recon.snackVoided': 'Jurnal #{id} di-void',
    'recon.snackVoidFail': 'Gagal void',
    'recon.pickToRelease': 'Pilih baris dulu untuk diloloskan ke laporan',
    'recon.confirmRelease': 'Loloskan {n} jurnal ke laporan tanpa pasangan?',
    'recon.releaseNote': 'Lolos manual ke laporan',
    'recon.snackReleased': '{n} jurnal masuk laporan',
    'recon.snackPartialAmount': 'Isi nominal partial yang valid',
    'recon.snackPartialFail': 'Gagal partial match',
    'recon.pickGroupPattern': 'Pilih 1 sisi tunggal + sisi lain ≥2 (pola 1↔N atau N↔1)',
    'recon.snackGroupMatch': 'Grup match: {n} pasangan · total {total}',
    'recon.snackGroupFail': 'Gagal match grup',
    'recon.snackUnmatched': 'Unmatch — siap dicocokkan lagi',
    'recon.snackReopened': 'Dibuka lagi dari history',
    'recon.snackBatchFail': 'Batch gagal',
    'recon.snackExportFail': 'Export gagal',
    'recon.snackUndo': 'Undo: {action} ({n} baris)',
    'recon.snackUndoEmpty': 'Tidak ada aksi untuk di-undo',
    'recon.debitCredit': 'Debit {d} · Kredit {c}',

    'ptGate.kicker': 'Langkah wajib',
    'ptGate.stepLabel': 'Langkah 1 · Pilih PT',
    'ptGate.kickerReady': 'Target aktif',
    'ptGate.title': 'Pilih PT target',
    'ptGate.titleReady': 'PT {pt} dipilih',
    'ptGate.body':
      'Upload, parse, dan tambah baris baru aktif setelah PT dipilih. Data tiap PT tidak tercampur.',
    'ptGate.readyBody': 'Semua unggahan & baris baru masuk ke {pt}. Ganti PT kapan saja jika perlu.',
    'ptGate.readySub': 'Target aktif: {code}',
    'ptGate.pickSub': 'Klik salah satu PT di bawah, atau tambah PT baru.',
    'ptGate.chooseHint': 'Klik salah satu',
    'ptGate.chipAction': 'Pilih',
    'ptGate.chipSelected': 'Dipilih',
    'ptGate.change': 'Ganti',
    'ptGate.hide': 'Sembunyikan',
    'ptGate.placeholder': 'Kode PT…',
    'ptGate.empty': 'Belum ada PT di master. Tambah dulu.',
    'ptGate.addPt': 'Tambah PT baru',
    'ptGate.needPt': 'Pilih PT dulu sebelum upload, drag-drop, atau tambah baris.',
    'ptGate.needPtSave': 'Pilih PT dulu sebelum menyimpan.',
    'ptGate.needPtRows': '{n} baris belum punya PT — pilih target atau isi kolom PT.',
    'ptGate.dropLocked': 'Pilih PT di atas dulu — lalu seret / pilih file.',

    'bankDesk.label': 'Alur Meja Bank',
    'bankDesk.kicker': 'Meja Bank',
    'bankDesk.title': 'Alur linear bank',
    'bankDesk.sub': 'Impor → klasifikasi → rekon → posisi kas',
    'bankDesk.stepImport': 'Impor statement',
    'bankDesk.stepImportHint': 'Unduh & unggah e-statement',
    'bankDesk.stepClassify': 'Klasifikasi',
    'bankDesk.stepClassifyHint': 'Tinjau & posting jurnal',
    'bankDesk.stepRecon': 'Rekonsiliasi',
    'bankDesk.stepReconHint': 'Cocokkan buku vs bank',
    'bankDesk.stepCash': 'Posisi kas',
    'bankDesk.stepCashHint': 'Saldo & selisih rekening',
    'stmt.kicker': 'Pusat unduh e-statement',
    'stmt.title': 'E-Statement Pintar',
    'stmt.sub':
      'Unduh mutasi per bank · filter 1 minggu / 2 minggu / 1 bulan · tahun & bulan · Excel & CSV',
    'stmt.dlKicker': 'Pusat unduh',
    'stmt.dlTitle': 'Unduh e-statement',
    'stmt.dlSub': 'Periode aktif: {period}',
    'stmt.dlPickBank': 'Pilih bank yang Anda punya',
    'stmt.dlBankMine': 'Punya saya',
    'stmt.dlBankMineEmpty': 'Belum ada nomor — isi di Rekening Bank',
    'stmt.dlPickPeriod': 'Pilih periode',
    'stmt.dlWeek1': '1 minggu',
    'stmt.dlWeek2': '2 minggu',
    'stmt.dlMonth1': '1 bulan',
    'stmt.dlYearMonth': 'Tahun & bulan',
    'stmt.dlCustom': 'Rentang tanggal',
    'stmt.dlAllBanks': 'Semua bank',
    'stmt.dlExcel': 'Unduh Excel',
    'stmt.dlCsv': 'Unduh CSV',
    'stmt.dlPdf': 'Unduh PDF',
    'stmt.dlZip': 'ZIP multi-bank',
    'stmt.dlThisMonth': 'Bulan ini',
    'stmt.dlLastMonth': 'Bulan lalu',
    'stmt.dlYtd': 'YTD',
    'stmt.dlQ1': 'Q1',
    'stmt.dlQ2': 'Q2',
    'stmt.dlQ3': 'Q3',
    'stmt.dlQ4': 'Q4',
    'stmt.dlStatRows': 'Mutasi',
    'stmt.dlStatDebit': 'Debit',
    'stmt.dlStatCredit': 'Kredit',
    'stmt.dlStatNet': 'Netto',
    'stmt.dlPreviewTitle': 'Cuplikan mutasi',
    'stmt.dlBankBreak': 'Pecahan per bank',
    'stmt.dlEmptyTitle': 'Tidak ada mutasi',
    'stmt.dlEmptyHint':
      'Tidak ada mutasi untuk filter ini — coba perluas periode, ganti bank, atau pilih Semua bank.',
    'stmt.dlPreviewFail': 'Gagal memuat preview unduh',
    'stmt.dlTruncWarn':
      'Data terpotong di {n} baris. Sempitkan periode atau unduh per bank / ZIP multi-bank.',
    'stmt.dlDoneTrunc':
      '{format} terunduh · file mungkin terpotong di ~{n} baris — sempitkan periode untuk lengkap',
    'stmt.dlHistoryTitle': 'Riwayat unduh',
    'stmt.dlHistoryEmpty': 'Belum ada unduhan di perangkat ini.',
    'stmt.dlHistoryClear': 'Hapus riwayat',
    'stmt.dlAgain': 'Unduh lagi',
    'stmt.dlHint':
      'Excel berisi Cover + Mutasi + Ringkasan (saldo berjalan, arah, recon, PT). ZIP = 1 file per bank. Unggah e-statement baru lewat panel di atas.',
    'stmt.dlDone': 'E-statement {format} siap · {period}',
    'stmt.dlHeroCta': 'Unduh sekarang',
    'stmt.uploadMoreTitle': 'Unggah e-statement (bank / kartu kredit)',
    'stmt.uploadMoreSub':
      'Drop PDF, Excel, ZIP, atau foto — channel Rekening untuk bank, Kartu kredit untuk CC. Mutasi history di bawah hanya untuk lihat.',
    'stmt.uploadHeroCta': 'Buka upload',
    'stmt.histUploadCta': 'Upload e-statement baru',
    'stmt.needCcSlot': 'Pilih channel Kartu kredit dulu (slot Utang CC).',
    'stmt.periodLast14': '14 hari terakhir',
    'stmt.legacyExcel': 'Excel lama',
    'stmt.opening': 'Saldo awal',
    'stmt.lk': 'Laporan keuangan',
    'stmt.dropTitle': 'Unggah banyak file ke sini',
    'stmt.toolbarUpload': 'Antrean file',
    'stmt.toolbarReview': 'Setelah review',
    'stmt.dropActive': 'Lepas untuk menambahkan ke antrean…',
    'stmt.pickFiles': 'Pilih file',
    'stmt.pickFilesMulti': 'Pilih file (bisa banyak)',
    'stmt.process': 'Proses unggah ({n})',
    'stmt.processFabHint': 'Langkah berikutnya ↓',
    'stmt.uploadProgressTitle': 'Memproses e-statement',
    'stmt.uploadPhaseUpload': 'Mengunggah file',
    'stmt.uploadPhaseParse': 'Membaca PDF & ekstrak mutasi',
    'stmt.uploadPhaseAi': 'Memetakan akun',
    'stmt.uploadPhaseDone': 'Selesai',
    'stmt.uploadSecondsLeft': '±{n} detik lagi',
    'stmt.uploadFileCount': '{n} file',
    'stmt.uploadAlmost': 'Hampir selesai…',
    'stmt.uploadElapsed': '{done} / {total}',
    'stmt.uploadStepUpload': 'Unggah',
    'stmt.uploadStepParse': 'Baca',
    'stmt.uploadStepAi': 'AI',
    'stmt.uploadStepDone': 'Selesai',
    'stmt.uploadBytes': '{loaded} / {total}',
    'stmt.uploadFilesDone': '{done}/{total} file',
    'stmt.uploadRowsFound': '{n} mutasi',
    'stmt.aiSkipOn': 'Cepat · AI belakangan',
    'stmt.aiSkipOff': 'AI saat upload',
    'stmt.aiSkipHint': 'Lewati AI saat unggah — review muncul dulu, AI jalan di belakang',
    'stmt.aiBgStart': 'AI jalan di belakang…',
    'stmt.aiBgDone': 'AI selesai · {n} baris diperkaya',
    'stmt.aiBgRunning': 'AI jalan…',
    'stmt.aiBgQueued': 'AI menunggu',
    'stmt.clearQueue': 'Kosongkan',
    'stmt.tabMutasi': 'Mutasi & pemetaan',
    'stmt.tabBalance': 'Cocok saldo',
    'stmt.tabRules': 'Editor aturan',
    'stmt.tabMemory': 'Memori',
    'stmt.tabLk': 'LK → Saldo awal',
    'stmt.rows': 'Baris',
    'stmt.selected': 'Dipilih',
    'stmt.allBanks': 'Semua bank',
    'stmt.mapSource': 'Sumber peta',
    'stmt.pickFilter': 'Pilih filter',
    'stmt.filterBar': 'Filter & seleksi',
    'stmt.bulkChecked': 'Tercentang massal',
    'stmt.cashBank': 'Kas/Bank',
    'stmt.pickBankTitle': 'Pilih rekening bank',
    'channel.rekening': 'Rekening',
    'channel.cc': 'Kartu Kredit',
    'channel.smartUploadRekening': 'Upload Pintar Rekening',
    'channel.smartUploadCc': 'Upload Pintar Kartu Kredit',
    'channel.smartUploadRekeningSub': 'E-statement & mutasi bank — BCA, Mandiri, BNI, DBS bersama.',
    'channel.smartUploadCcSub': 'Tagihan & mutasi kartu kredit — alokasi HPP otomatis.',
    'channel.rekeningHint': 'Upload e-statement bank — pilih PT lalu rekening BCA, Mandiri, BNI, atau DBS bersama.',
    'channel.ccHint': 'Upload tagihan kartu kredit — akun lawan difilter ke HPP & beban terkait, alokasi otomatis.',
    'channel.dbsShared': '50:50',
    'channel.ccLock': 'Utang CC · {code}',
    'cls.label': 'Dianggap sebagai',
    'cls.defaultLabel': 'Default saat upload',
    'cls.defaultPick': 'Pilih klasifikasi default',
    'cls.defaultHint': 'Bisa diubah per baris setelah upload — pilih Custom untuk akun manual.',
    'cls.inflow': 'Uang masuk',
    'cls.outflow': 'Uang keluar',
    'cls.autoFlow': 'Otomatis (sesuai mutasi)',
    'cls.groupIn': 'Uang masuk',
    'cls.groupOut': 'Uang keluar',
    'cls.groupCc': 'Kartu kredit',
    'cls.groupManual': 'Manual',
    'cls.dp': 'DP / uang muka pelanggan',
    'cls.ar': 'Pelunasan piutang',
    'cls.revenue': 'Pendapatan jasa',
    'cls.bunga': 'Bunga bank',
    'cls.ownerIn': 'Utang owner (setor masuk)',
    'cls.ownerOut': 'Piutang owner / pihak berelasi',
    'cls.internal': 'Transfer internal antar rekening',
    'cls.prepaid': 'Prepaid / dibayar di muka',
    'cls.ap': 'Bayar hutang usaha / supplier',
    'cls.admin': 'Biaya admin bank',
    'cls.gaji': 'Gaji & tunjangan',
    'cls.bpjs': 'Iuran BPJS',
    'cls.server': 'Biaya server / IT',
    'cls.perlengkapan': 'Perlengkapan kantor',
    'cls.perjamuan': 'Perjamuan bisnis',
    'cls.opex': 'Biaya operasional lain',
    'cls.hpp': 'HPP (harga pokok penjualan)',
    'cls.custom': 'Custom — pilih akun manual',
    'stmt.bankQuickPick': 'Pilih bank cepat',
    'stmt.sharedMode': 'Bersama (DBS / Kartu Kredit)',
    'stmt.sharedHint': 'Tanpa PT — saldo dibagi 50:50 JGI & JGT di neraca konsolidasi.',
    'stmt.sharedBankOnly': 'Mode bersama hanya untuk DBS (1004) atau Kartu Kredit (2700).',
    'stmt.queueNeedBank': '{n} file di antrean — pilih rekening bank dulu, lalu klik Proses.',
    'stmt.queueReadyHint': '{n} file di antrean — pilih rekening lalu Proses Upload',
    'stmt.filterCount': 'Menampilkan {shown} dari {total} mutasi · {period}',
    'stmt.savedLinks': 'Tersimpan ke jurnal — lanjutkan:',
    'stmt.savedLinksPending': 'Tersimpan · siap di meja rekonsiliasi:',
    'stmt.openJournal': 'Jurnal Umum',
    'stmt.toReconBatch': 'Buka rekonsiliasi',
    'stmt.stepPt': 'PT / Shared',
    'stmt.stepBank': 'Rekening',
    'stmt.stepQueue': 'Antrian file',
    'stmt.stepReview': 'Review mutasi',
    'stmt.stepSave': 'Simpan',
    'stmt.uploadPhaseRead': 'Membaca file lokal…',
    'stmt.uploadFileProgress': 'File {current}/{total} · {name}',
    'stmt.snackBalanceMismatch': 'Saldo tidak cocok: {ok} OK · {bad} selisih — perbaiki di tab Saldo',
    'stmt.balanceGateBanner': 'Saldo rekening: {ok} cocok · {bad} selisih — simpan diblokir sampai dicek',
    'stmt.viewBalance': 'Lihat saldo',
    'stmt.ccPoolTitle': 'Pool tagihan kartu kredit',
    'stmt.ccPoolSub': 'Alokasi HPP proporsional JGI/JGT — bukan jurnal per baris CC',
    'wizard.checkBank': 'Bank siap',
    'wizard.checkFiles': 'File siap',
    'wizard.checkReviewOk': 'Review bersih',
    'wizard.checkReviewWarn': '{n} baris perlu dicek',
    'wizard.checkBalanceOk': 'Saldo {n} cocok',
    'wizard.checkBalanceWarn': '{n} saldo selisih',
    'wizard.checkBalanceNa': 'Saldo belum dicek',
    'wizard.shortcutsHint': 'Ctrl+Enter simpan · Ctrl+Shift+Enter proses · 1–7 lane · A perlu dicek',
    'stmt.draftBannerTitle': 'Review tersimpan — lanjutkan dari sesi sebelumnya',
    'stmt.draftDiscard': 'Buang draft',
    'stmt.draftDiscarded': 'Draft review dihapus',
    'stmt.draftPendingTitle': 'Ada review tersimpan — muat untuk lanjut',
    'stmt.draftLoaded': '{n} baris review dimuat',
    'stmt.draftRestored': '{n} baris dipulihkan · {time}',
    'stmt.draftDurableHint':
      'Draft per PT · disimpan ≤7 hari — ganti rekening/CC tidak menghapus baris; filter chip untuk fokus bank.',
    'stmt.draftBankAny': 'semua bank',
    'stmt.draftOtherLabel': 'Draft PT lain:',
    'stmt.draftFilterBank': 'Filter → {bank} (draft tetap utuh)',
    'stmt.queueBankFocus': 'Sorot {n} file · {bank}',
    'stmt.autoPickBank': 'Bank otomatis: {bank} (dari nama file)',
    'stmt.bankBreakdown': 'Ringkasan per bank',
    'stmt.histSourcesKicker': 'Sumber e-statement',
    'stmt.histSourcesTitle': 'Semua sumber yang pernah diunggah',
    'stmt.histSourcesSub':
      'Tombol hijau = sudah ada data di tahun {year}. Klik untuk memuat mutasi history ke tabel review (tanpa upload ulang).',
    'stmt.histEmpty': 'kosong',
    'stmt.histLoaded': '{n} mutasi dari history e-statement {year} dimuat ke tabel',
    'stmt.histLoadedCapped':
      '{n} dari {total} mutasi history {year} dimuat (dibatasi agar halaman tetap responsif)',
    'stmt.histLoadFail': 'Gagal memuat history e-statement',
    'stmt.histDashTitle': 'History e-statement',
    'stmt.histInsight':
      '{n} mutasi yang sudah diunggah & disimpan tahun {year} — langsung tampil tanpa upload ulang.',
    'stmt.histMixedInsight':
      '{live} baris sesi baru · {posted} dari history · {files} file upload.',
    'stmt.histBrowseHint':
      '{n} mutasi history tahun {year} sudah tersimpan (Posted). Ini bukan antrean upload — klik “Upload e-statement baru” untuk bank atau kartu kredit.',
    'stmt.histMixedHint':
      '{live} baris baru siap direview · {posted} baris history (Posted) hanya untuk lihat, tidak ikut disimpan ulang.',
    'stmt.mapPosted': 'Posted',
    'stmt.mapConfTitle': 'Keyakinan mapping {pct}%',
    'stmt.autoScanKicker': 'Pindai otomatis',
    'stmt.autoScanTitle': 'Hasil deteksi bank / kartu kredit',
    'stmt.autoScanSub': 'Sistem memindai file segera setelah upload — tanpa menunggu perintah.',
    'stmt.mixedBankHint': 'Beberapa bank terdeteksi — klik chip untuk filter per bank.',
    'stmt.bankModeDetect': 'Ikuti deteksi file',
    'stmt.bankModeSlot': 'Paksa ke rekening ini',
    'stmt.bankModeDetectHint':
      'Tiap file memakai bank dari PDF/nama. Slot terpilih hanya untuk file yang belum jelas.',
    'stmt.queueBankSplit': 'Antrean: {parts}',
    'stmt.queueBanksLabel': 'Antrean bank',
    'stmt.queueBankSplitLine': '{n} → {bank}',
    'stmt.queueBankUnknown': '{n} belum jelas',
    'stmt.mixedBankSplitDone': 'Batch multi-bank: {summary}',
    'stmt.mixedBankAutoDetect': 'Beberapa bank di antrean — mode ikuti deteksi file aktif.',
    'stmt.queueNeedBankOrDetect':
      '{n} file di antrean — pilih rekening fallback, atau aktifkan ikuti deteksi file.',
    'stmt.pickBankSub': 'Wajib pilih salah satu nomor rekening per PT sebelum upload/submit.',
    'stmt.pickBankLabel': 'Rekening tujuan',
    'stmt.needBankAccount': 'Pilih rekening bank dulu (kode + nomor rekening)',
    'stmt.needAccountNo': 'Pilih nomor rekening spesifik. Jika kosong, isi dulu di Update Rekening.',
    'stmt.needBankRows': '{n} baris belum punya akun kas/bank',
    'stmt.bankEmpty': 'Daftar akun kas/bank kosong — cek Chart of Accounts (1000–1005).',
    'bsp.title': 'Pilih kas/bank & no rekening',
    'bsp.subNeedPt': 'Pilih PT dulu, lalu pilih kas/bank dan nomor rekening.',
    'bsp.subPt': '{pt} · {n} slot · {filled} punya no rekening',
    'bsp.selectLabel': 'Kas/Bank + No rekening',
    'bsp.placeholder': 'Pilih rekening…',
    'bsp.searchPh': 'Cari bank, kode, no rekening…',
    'bsp.manage': 'Update / buat rekening',
    'bsp.manageShort': 'Update',
    'bsp.emptyNo': 'No. rek kosong',
    'bsp.fillNow': 'Isi sekarang',
    'bsp.needPick': 'Wajib pilih rekening dari daftar sebelum lanjut.',
    'bsp.emptyHint': '{n} slot belum punya no rekening — isi lewat Update (bukan di sini).',
    'bsp.noRekLabel': 'No rekening',
    'bsp.noRekPlaceholder': 'Contoh: 2532999996',
    'bsp.noRekSave': 'Simpan no rekening',
    'bsp.noRekHint': 'Isi / pilih no rekening agar arah rekonsiliasi jelas.',
    'bsp.noRekSaved': 'No rekening tersimpan.',
    'bsp.noRekNeedSlot': 'Pilih slot kas/bank dulu, lalu isi no rekening.',
    'bsp.kasCash': 'Kas tunai · tanpa no rekening',
    'bsp.noRekEmpty': 'No rekening belum diisi',
    'bsp.stepBadge': 'Langkah 1 · wajib',
    'bsp.prominentHint': 'Sudah ada rekening default — cek dulu, ganti jika perlu, baru upload.',
    'bsp.defaultSelected': 'Default terpilih',
    'bsp.confirmed': 'Rekening siap — boleh upload',
    'bsp.needConfirm': 'Pilih rekening dari daftar (default sudah terisi) sebelum upload.',
    'bam.kicker': 'Master · Rekening bank',
    'bam.title': 'Update Rekening',
    'bam.sub': 'Kelola nomor rekening per PT: nama, alias, target bank (COA), dan buat slot baru (#1 / #2).',
    'bam.toCash': 'Posisi Kas',
    'bam.toStmt': 'E-Statement',
    'bam.save': 'Simpan semua',
    'bam.saved': 'Rekening bank disimpan',
    'bam.statTotal': 'Total slot',
    'bam.statFilled': 'Berisi nomor',
    'bam.statEmpty': 'Kosong',
    'bam.allPt': 'Semua',
    'bam.searchPh': 'Cari bank, alias, nomor…',
    'bam.add': 'Tambah rekening',
    'bam.addSecond': 'Tambah slot #2',
    'bam.colPt': 'PT',
    'bam.colBank': 'Target bank',
    'bam.colName': 'Nama rekening',
    'bam.colAlias': 'Alias',
    'bam.colNo': 'No. rekening',
    'bam.colOrder': 'Urut',
    'bam.colActive': 'Aktif',
    'bam.shared': 'Bersama',
    'bam.aliasPh': 'BCA JGI #1',
    'bam.noPh': 'Nomor rekening',
    'bam.empty': 'Belum ada baris — tekan Tambah rekening.',
    'bam.note': 'Satu bank (COA) bisa punya beberapa nomor per PT. Dipakai E-Statement, Import Excel, dan Debit/Kredit Cepat.',
    'bam.lockHint': 'Rekening yang sudah punya jurnal / e-statement dikunci sistem — tidak bisa dihapus.',
    'bam.statLocked': 'Terkunci',
    'bam.colStatus': 'Status',
    'bam.colActions': 'Aksi',
    'bam.locked': 'Sistem',
    'bam.lockedTip': 'Sudah ada data — hanya sistem yang boleh hapus',
    'bam.lockedDelete': 'Tidak bisa hapus: sudah ada {n} data ({reason}). Hanya sistem.',
    'bam.lockedEditHint': 'PT, bank, dan nomor terkunci. Nama/alias/aktif masih bisa dirapikan.',
    'bam.editable': 'Bisa dihapus',
    'bam.inactive': 'Nonaktif',
    'bam.edit': 'Edit',
    'bam.delete': 'Hapus',
    'bam.deleteTitle': 'Hapus rekening?',
    'bam.deleteConfirm': 'Hapus {name} ({no}) dari daftar? Simpan untuk menerapkan.',
    'bam.deletedLocal': 'Dihapus dari daftar — tekan Simpan untuk menerapkan',
    'bam.editTitle': 'Edit rekening',
    'bam.createTitle': 'Rekening baru',
    'bam.editLockedTitle': 'Edit (terkunci)',
    'bam.apply': 'Terapkan',
    'bam.errBank': 'Pilih target bank dulu',
    'bam.showing': '{n} baris tampil',
    'bam.unsaved': 'Ada perubahan belum disimpan',
    'bam.discarded': 'Perubahan dibatalkan',
    'bam.discard': 'Batalkan perubahan',
    'bam.leaveDirty': 'Ada perubahan belum disimpan. Tinggalkan halaman?',
    'bam.exportCsv': 'Ekspor CSV',
    'bam.exported': 'CSV {n} baris diunduh',
    'bam.sort': 'Urutkan',
    'bam.sortOrder': 'Urutan #',
    'bam.sortPt': 'PT',
    'bam.sortBank': 'Bank / COA',
    'bam.sortName': 'Nama A → Z',
    'bam.sortNo': 'No. rekening',
    'bam.sortStatus': 'Status',
    'bam.resetFilters': 'Reset filter',
    'bam.filterAll': 'Semua',
    'bam.filterHint': 'Hasil filter · {n} rekening',
    'bam.statDup': 'Duplikat',
    'bam.dupWarn': '{n} nomor duplikat',
    'bam.dupHint': 'Nomor sama di slot lain',
    'bam.fillNo': 'Isi nomor rekening',
    'bam.copyNo': 'Salin nomor rekening',
    'bam.copiedNo': 'Nomor {n} disalin',
    'bam.tipsTitle': 'Saran cepat · master rekening rapi',
    'bam.tipsShow': 'Tampilkan',
    'bam.tipsHide': 'Sembunyikan',
    'bam.tip1': 'Isi nomor kosong dulu (chip Kosong) agar E-Statement & import akurat.',
    'bam.tip2': 'Slot terkunci tetap bisa dirapikan nama/alias — nomor & PT tidak berubah.',
    'bam.tip3': 'Pakai #2 untuk rekening kedua pada bank/PT yang sama.',
    'bam.tip4': 'Ctrl+S menyimpan semua. Peringatan muncul jika meninggalkan halaman dengan draft.',
    'bam.tableKicker': 'Master data',
    'bam.tableTitle': 'Daftar nomor rekening',
    'bam.emptyTitle': 'Tidak ada rekening cocok',
    'bam.pageAll': 'Semua',
    'bam.perPage': 'Per halaman',
    'bam.pageRange': 'Baris {from}–{to} dari {total}',
    'bam.pageMeta': 'Halaman {page} / {pages}',
    'bam.saveHint': 'Draft lokal — tekan Simpan semua (Ctrl+S) untuk menerapkan ke database.',
    'bam.savedHint': 'Semua perubahan sudah tersimpan.',
    'bam.fillPct': 'Terisi {pct}%',
    'bam.fillPctHint': '{filled} dari {total} slot punya nomor rekening',
    'bam.filterBank': 'Bank / COA',
    'bam.bankAll': 'Semua bank',
    'bam.groupByBank': 'Kelompokkan per bank',
    'bam.compact': 'Tampilan padat',
    'bam.seedSlots': 'Lengkapi slot standar',
    'bam.seeded': '{n} slot standar ditambahkan (draft)',
    'bam.seedNone': 'Slot standar sudah lengkap',
    'bam.selected': '{n} dipilih',
    'bam.selectPage': 'Pilih semua di halaman ini',
    'bam.clearSelection': 'Batal pilih',
    'bam.bulkActivate': 'Aktifkan',
    'bam.bulkDeactivate': 'Nonaktifkan',
    'bam.bulkDelete': 'Hapus ({n})',
    'bam.bulkDeleteTitle': 'Hapus rekening terpilih?',
    'bam.bulkDeleteConfirm': 'Hapus {n} rekening yang bisa dihapus dari daftar? Simpan untuk menerapkan.',
    'bam.bulkActivated': '{n} rekening diaktifkan (draft)',
    'bam.bulkDeactivated': '{n} rekening dinonaktifkan (draft)',
    'bam.bulkDeleted': '{n} rekening dihapus dari daftar (draft)',
    'bam.exportSelected': 'Ekspor pilihan',
    'bam.exportEmpty': 'Tidak ada baris untuk diekspor',
    'bam.inlineEdit': 'Klik untuk edit cepat',
    'bam.inlineHint': 'Klik alias / nomor untuk edit cepat · Enter simpan · Esc batal',
    'bam.suggestAlias': 'Isi alias otomatis',
    'bam.groupMeta': '{n} slot · {empty} kosong',
    'bam.stickyTitle': 'Perubahan belum disimpan',
    'bam.stickySub': 'Ada {n} draft di halaman ini — simpan agar E-Statement & impor tetap akurat.',
    'bam.tip5': 'Centang beberapa baris untuk aktif/nonaktif/hapus massal, atau kelompokkan per bank.',
    'bam.vizReady': 'Kesiapan nomor',
    'bam.vizPt': 'Isi per PT',
    'bam.vizBank': 'Komposisi bank',
    'bam.vizShared': '{n} slot bersama (SHARED)',
    'bam.vizBankEmpty': 'Belum ada slot bank',
    'bam.readyHint': '{ok} terisi · {need} perlu perhatian',
    'bam.filterBar': 'Filter rekening & pencarian',
    'bam.healthTitle': 'Status kesehatan master',
    'bam.healthSub': 'Klik lane untuk fokus baris yang perlu dirapikan.',
    'bam.clearLane': 'Tampilkan semua',
    'bam.lane.all': 'Semua',
    'bam.lane.empty': 'Kosong',
    'bam.lane.filled': 'Berisi nomor',
    'bam.lane.locked': 'Terkunci',
    'bam.lane.inactive': 'Nonaktif',
    'bam.lane.dup': 'Duplikat',
    'bam.tipActEmpty': 'Isi {n} nomor kosong',
    'bam.tipActDup': 'Cek {n} duplikat',
    'bam.tipActInactive': 'Tinjau {n} nonaktif',
    'bam.tipActSeed': 'Lengkapi slot standar',
    'stmt.contra': 'Akun lawan',
    'stmt.preview': 'Pratinjau',
    'stmt.saveLearn': 'Simpan + belajar',
    'stmt.toRecon': 'Ke rekonsiliasi',
    'stmt.toJournal': 'Lihat jurnal',
    'stmt.split': 'Pecah',
    'stmt.saveRule': 'Simpan aturan',
    'stmt.delete': 'Hapus',
    'stmt.matchBalance': 'Cocok saldo statement vs buku besar',
    'stmt.addRule': 'Tambah aturan pemetaan',
    'stmt.rulesSub': 'Aturan otomatis memetakan keterangan mutasi ke akun lawan — prioritas lebih kecil dievaluasi lebih dulu.',
    'stmt.rulesTotal': 'Total aturan',
    'stmt.rulesActive': 'Aktif',
    'stmt.rulesInactive': 'Nonaktif',
    'stmt.rulesFiltered': 'Hasil filter',
    'stmt.rulesSearch': 'Cari pattern / akun / catatan',
    'stmt.rulesPageSize': 'Tampilkan',
    'stmt.rulesSeeAll': 'Lihat semua',
    'stmt.rulesEmpty': 'Belum ada aturan — tambah pattern di form di atas.',
    'stmt.rulesEmptySearch': 'Tidak ada aturan cocok dengan pencarian.',
    'stmt.rulesFoot': 'Tampil {from}–{to} dari {total} aturan',
    'stmt.memory': 'Memori pemetaan',
    'stmt.memorySub': 'Pola keterangan yang pernah Anda simpan — dipakai otomatis saat upload berikutnya.',
    'stmt.memTotal': 'Entri memori',
    'stmt.memTotalHits': 'Total hit',
    'stmt.memAccounts': 'Akun unik',
    'stmt.memSearch': 'Cari keterangan / akun',
    'stmt.memEmptySearch': 'Tidak ada memori cocok dengan pencarian.',
    'stmt.lkImport': 'Impor LK PDF → saldo awal',
    'stmt.lkSub': 'Baca neraca dari draft LK PDF dan siapkan jurnal saldo awal.',
    'stmt.lkFiles': 'File LK',
    'stmt.lkLines': 'Baris neraca',
    'stmt.lkBalanced': 'Seimbang',
    'stmt.lkUnbalanced': 'Selisih',
    'stmt.lkEmptySub': 'Unggah file LK PDF bersama e-statement atau lempar ke dropzone di atas.',
    'stmt.noLk': 'Belum ada file LK terdeteksi.',
    'stmt.snackEmpty': 'Antrean kosong — lempar file dulu',
    'stmt.snackParsed': 'Terurai {n} baris · {f} file',
    'stmt.snackNoMutasi': 'File terbaca tapi mutasi debit/kredit belum terdeteksi — cek tab Mutasi atau unggah ulang PDF.',
    'stmt.snackNeedRows': 'Centang minimal 1 baris',
    'stmt.snackSaved': 'Tersimpan & dipelajari',
    'stmt.snackExcel': 'Excel tinjauan diunduh',
    'stmt.snackRule': 'Aturan ditambahkan',
    'stmt.ocr': 'OCR gambar',
    'stmt.excel': 'Excel',
    'stmt.pdf': 'PDF',
    'stmt.dropHint':
      'PDF e-statement, ZIP, Excel/CSV, HTML/bukti, atau foto OCR. Klik Pilih file lalu Shift/Ctrl untuk banyak file sekaligus — antre dulu, proses bareng.',
    'stmt.zip': 'ZIP',
    'stmt.csv': 'CSV',
    'stmt.ofx': 'OFX/QFX',
    'stmt.json': 'JSON',
    'stmt.queueTitle': 'Antrean · {n} file · {size}',
    'stmt.queueLoading': '{n} memuat',
    'stmt.queueIngesting': 'Memuat file…',
    'stmt.queueStillLoading': 'Tunggu semua file selesai dimuat ke antrean.',
    'stmt.queueNotReady': 'Ada file yang belum siap — tunggu hingga 100%.',
    'stmt.queueReadFail': 'Gagal membaca file',
    'stmt.queueReadFailCount': '{n} file gagal dimuat',
    'stmt.uploadTimeout': 'Upload melebihi batas waktu — coba lagi.',
    'stmt.queueSwipeHint': 'Geser kartu atau pakai ‹ › untuk melihat file lain',
    'upload.rule.kicker': 'Aturan penting',
    'upload.rule.badge': 'Wajib baca',
    'upload.rule.badgeDetect': 'Pintar',
    'upload.rule.title': 'Boleh banyak PDF — asal 1 rekening bank yang sama',
    'upload.rule.titleDetect': 'Boleh banyak PDF — campur bank OK (ikuti deteksi file)',
    'upload.rule.titleImport': 'Excel / PDF e-statement — satu rekening per sesi upload',
    'upload.rule.summaryShort': 'Banyak file OK · satu rekening · jangan campur bank',
    'upload.rule.summaryShortDetect': 'Multi-bank OK · tiap file ke rekeningnya · slot = fallback',
    'upload.rule.summaryShortImport': 'Excel · PDF · CSV · OFX · AI Gemini ↔ Groq',
    'upload.rule.line1':
      'Beberapa file PDF untuk rekening yang sama boleh (mis. Januari + Februari, atau halaman terpisah).',
    'upload.rule.line2':
      'Yang dilarang: mencampur bank atau nomor rekening berbeda dalam satu unggahan (mis. BCA + BNI, atau dua no rekening beda).',
    'upload.rule.line3':
      'Cek rekening default di bawah sebelum upload. Semua file akan masuk ke rekening yang dipilih itu.',
    'upload.rule.detectLine1':
      'Campur BCA + Mandiri + BNI dalam satu batch boleh — tiap file ikut deteksi PDF/nama.',
    'upload.rule.detectLine2':
      'Slot rekening hanya dipakai untuk file yang belum jelas banknya.',
    'upload.rule.detectLine3':
      'Setelah parse, filter chip per bank untuk review fokus.',
    'upload.rule.target': 'Rekening aktif: {bank}',
    'upload.rule.importNote':
      'Halaman ini untuk Excel multi-sheet. PDF e-statement → menu E-Statement; tetap satu rekening per sesi upload.',
    'upload.rule.intense':
      'Pilih rekening bank di langkah 1 dulu — jangan upload sebelum nomor rekening cocok.',
    'upload.rule.intenseDetect':
      'Mode deteksi aktif — Proses boleh jalan meski slot belum dipilih (asalkan nama file terbaca).',
    'setup.kicker': 'Persiapan',
    'setup.title': 'Target & rekening bank',
    'setup.sub': 'Pilih PT, pastikan rekening default benar, lalu unggah file ke rekening yang sama.',
    'setup.ready': 'Siap upload',
    'setup.needBank': 'Konfirmasi rekening',
    'setup.needPt': 'Pilih PT',
    'setup.step2': 'Unggah file',
    'stmt.needsOcr': 'Perlu OCR',
    'stmt.periodUnknown': 'periode ?',
    'stmt.txnCount': '{n} mutasi',
    'stmt.noRowsYet':
      'Belum ada baris mutasi yang bisa ditampilkan. Cek tipe file: jika itu file LK/saldo, hasilnya ada di tab lain. Untuk rekonsiliasi, upload e-statement/mutasi bank.',
    'stmt.parseInsight':
      'Hasil upload: {files} file · {rows} baris mutasi · {lk} preview LK · {balances} cek saldo · {errors} error file.',
    'stmt.dashTitle': 'Ringkasan upload',
    'stmt.dashFiles': 'File diunggah',
    'stmt.dashHintTitle': 'Petunjuk',
    'stmt.fileLibKicker': 'E-statement tersimpan',
    'stmt.fileLibTitle': 'File yang sudah masuk sistem',
    'stmt.fileLibSub':
      'Klik file untuk memuat mutasi ke tabel review · tahun {year}. Upload baru tetap lewat dropzone di atas.',
    'stmt.fileLibEmpty':
      'Belum ada e-statement tersimpan. Unggah file di dropzone di atas, lalu simpan ke jurnal.',
    'stmt.bank': 'Bank',
    'stmt.allMapping': 'Semua mapping',
    'stmt.mapRule': 'Rule',
    'stmt.mapMemory': 'Memory',
    'stmt.mapAuto': 'Auto',
    'stmt.mapManual': 'Manual',
    'stmt.notSelected': 'Tidak',
    'stmt.desc': 'Keterangan',
    'stmt.mapCol': 'Map',
    'stmt.contraShort': 'No akun lawan',
    'stmt.actions': 'Aksi',
    'stmt.acctNo': 'No rekening',
    'stmt.refNo': 'NoRef',
    'stmt.bankName': 'Nama kas/bank',
    'stmt.contraName': 'Nama lawan',
    'stmt.mapDir': 'Arah',
    'stmt.swapDir': 'Tukar debit/kredit',
    'stmt.applyRec': 'Pakai',
    'stmt.applyAllRec': 'Terapkan semua rekomendasi',
    'stmt.clearSelection': 'Batal centang',
    'stmt.deleteSelected': 'Hapus terpilih',
    'stmt.clearTable': 'Kosongkan tabel',
    'stmt.resetTable': 'Reset tabel ke awal',
    'stmt.selectInvalid': 'Pilih yang invalid',
    'stmt.deleteSelectedCount': 'Hapus terpilih ({n})',
    'stmt.snackInvalidSelected': '{n} baris invalid dicentang',
    'stmt.snackNoInvalid': 'Tidak ada baris invalid',
    'stmt.swapSide': 'Tukar debit ↔ kredit',
    'stmt.snackRowDeleted': '1 baris dihapus dari tabel',
    'stmt.snackRowsDeleted': '{n} baris dihapus dari tabel',
    'stmt.snackTableCleared': 'Tabel dikosongkan',
    'stmt.snackRowAdded': 'Baris manual ditambahkan — isi deskripsi, debit/kredit, lalu simpan.',
    'stmt.periodFilter': 'Filter tanggal',
    'stmt.periodAll': 'Semua tanggal',
    'stmt.periodLast7': '7 hari terakhir',
    'stmt.periodLast30': '30 hari terakhir',
    'stmt.periodLast90': '90 hari terakhir',
    'stmt.periodLastYear': 'Tahun lalu',
    'stmt.periodMatch':
      'Tampil {n} / {total} baris · Debit filter {debit} · Kredit filter {credit}',
    'stmt.toolbarBulkSelected': '{n} tercentang',
    'stmt.toolbarFiltersActive': '{n} filter aktif',
    'stmt.pageInfo': 'Halaman {page}/{pages} · {n} baris · 100/halaman',
    'stmt.tableFoot': '{n} baris terfilter · pagination di dalam tabel (default 50)',
    'stmt.howtoTitle': 'Tata cara E-Statement',
    'stmt.howtoHint': 'Klik untuk buka',
    'stmt.howtoS1t': '1. Pilih PT',
    'stmt.howtoS1': 'Klik kartu JGI atau JGT — semua mutasi ikut PT itu.',
    'stmt.howtoS2t': '2. Pilih rekening',
    'stmt.howtoS2': 'Pilih kas/bank + no rekening. Ganti PT = rekening ikut remap otomatis.',
    'stmt.howtoS3t': '3. Unggah & proses / Tambah Baris',
    'stmt.howtoS3':
      'Drop PDF/ZIP/Excel/CSV/gambar — AI parse mengisi debit/kredit & akun. Atau tekan Tambah Baris (teal) untuk input manual seperti Debit/Kredit Cepat.',
    'stmt.howtoS4t': '4. Cek tabel',
    'stmt.howtoS4':
      'Kolom # · checklist 1×/2× · deskripsi wajib · NoRef AUTO · frame kas/bank · tag DP/AR · pagination 50+',
    'stmt.howtoS5t': '5. Simpan / kirim rekon',
    'stmt.howtoS5': 'Simpan + belajar atau kirim ke rekonsiliasi — konfirmasi “sudah cek?” dulu.',
    'stmt.howtoTip':
      'Tip: pilih rekening dulu agar tombol Tambah Baris muncul. Kosongkan deskripsi = kotak merah.',
    'stmt.confirmAccKicker': 'Simpan e-statement',
    'stmt.confirmReconKicker': 'Kirim ke rekonsiliasi',
    'stmt.confirmAccTitle': 'Anda yakin dan sudah cek?',
    'stmt.confirmAccLead':
      '{n} baris terpilih akan disimpan. Pastikan deskripsi, debit/kredit, dan akun sudah dicek.',
    'stmt.confirmAccB1': 'Deskripsi wajib · NoRef otomatis · kas/bank & lawan terisi.',
    'stmt.confirmAccB2': 'Uncentang baris yang masih ragu/salah sebelum lanjut.',
    'stmt.confirmAccB3': 'Setelah Ya, baris masuk jurnal import (pending atau cleared sesuai switch).',
    'stmt.confirmProcessKicker': 'Proses unggah',
    'stmt.confirmProcessTitle': 'Tinjau file sebelum diproses',
    'stmt.confirmProcessLead': 'Anda akan memproses {n} file. Pastikan semua milik rekening yang sama.',
    'stmt.confirmProcessLeadDetect':
      'Anda akan memproses {n} file. Mode deteksi: tiap file masuk ke banknya sendiri.',
    'stmt.confirmStep': 'Langkah {n}/2',
    'stmt.confirmStep2Title': 'Konfirmasi akhir',
    'stmt.confirmStep2Lead': 'Centang pernyataan di bawah jika sudah yakin — tidak bisa dibatalkan setelah diproses.',
    'stmt.confirmFiles': 'Total file',
    'stmt.confirmSize': 'Ukuran',
    'stmt.confirmTotalDebit': 'Total debit',
    'stmt.confirmTotalCredit': 'Total kredit',
    'stmt.confirmTargetBank': 'Masuk ke rekening',
    'stmt.confirmChangeBank': 'Salah rekening? Ganti di sini sebelum lanjut.',
    'stmt.confirmPanelSize': 'Ukuran panel',
    'stmt.confirmSizeS': 'Kecil (S)',
    'stmt.confirmSizeM': 'Sedang (M)',
    'stmt.confirmSizeL': 'Besar (L)',
    'stmt.confirmDragHint': 'Geser header untuk pindah panel',
    'stmt.confirmResizeHint': 'Tarik untuk ubah ukuran',
    'stmt.confirmSelected': 'Terpilih',
    'stmt.confirmMoreFiles': '+{n} file lainnya',
    'stmt.confirmWarnSameBank': 'Semua file harus untuk rekening yang sama. Jangan campur bank/rekening berbeda.',
    'stmt.confirmWarnDetect':
      'Mode ikuti deteksi aktif — file campur bank OK. Slot hanya fallback untuk yang belum jelas.',
    'stmt.confirmRecapProcess': '{n} file akan diproses → rekening: {bank}',
    'stmt.confirmRecapProcessDetect': '{n} file akan diproses · {summary}',
    'stmt.confirmRecapSave': '{n} baris ({deb} debit · {cred} kredit) → rekening: {bank}',
    'stmt.confirmSureCheck': 'Saya yakin rekening {bank} sudah benar dan data siap diproses.',
    'stmt.confirmSureCheckDetect':
      'Saya yakin deteksi bank per file sudah benar dan data siap diproses.',
    'stmt.confirmNext': 'Lanjut cek ulang',
    'stmt.confirmNextHint': 'Ke langkah konfirmasi akhir',
    'stmt.confirmBack': 'Kembali',
    'stmt.confirmBackHint': 'Tinjau rincian lagi',
    'stmt.confirmFinalHint': 'Proses sekarang',
    'stmt.confirmSaveLead': 'Anda akan menyimpan {n} baris terpilih ke buku besar.',
    'stmt.confirmNoHint': 'Kembali cek tabel',
    'stmt.confirmYesAccHint': 'Ya, sudah cek — simpan',
    'stmt.confirmYesReconHint': 'Ya — simpan & buka Rekon',
    'stmt.balanceEmpty':
      'Upload e-statement dulu — sistem ekstrak ending balance PDF dan bandingkan dengan saldo akun.',
    'stmt.balanceSub': 'Bandingkan saldo akhir e-statement dengan posisi buku besar per rekening.',
    'stmt.balanceNotesTitle': 'Catatan perbandingan',
    'stmt.balanceTipTitle': 'Tips & penjelasan',
    'stmt.balanceNoStmt': 'Tidak terdeteksi dari PDF',
    'stmt.balUnknown': 'Belum dibandingkan',
    'stmt.balMatchRate': 'Tingkat match',
    'stmt.balanceUnknownHint':
      '{n} rekening belum bisa dibandingkan — saldo statement tidak terdeteksi dari PDF atau saldo buku kosong.',
    'stmt.stmtBal': 'Saldo Statement',
    'stmt.bookBal': 'Saldo Buku',
    'stmt.diffCol': 'Selisih',
    'stmt.status': 'Status',
    'stmt.matchOk': 'Match',
    'stmt.matchDiff': 'Selisih',
    'stmt.na': 'N/A',
    'stmt.balanceTip':
      'Selisih biasanya karena saldo awal belum diisi, atau mutasi belum semua di-posting. Posting mutasi lalu refresh dengan upload ulang.',
    'stmt.pattern': 'Pattern (teks / regex)',
    'stmt.matchType': 'Tipe',
    'stmt.side': 'Sisi',
    'stmt.priority': 'Priority',
    'stmt.prio': 'Prio',
    'stmt.active': 'Aktif',
    'stmt.memoryHint':
      'Setiap kali Anda simpan mutasi, sistem mengingat pola keterangan → akun lawan. Upload berikutnya otomatis memakai memory (chip memory).',
    'stmt.sampleDesc': 'Contoh keterangan',
    'stmt.hits': 'Hit',
    'stmt.noMemory': 'Belum ada memory — posting beberapa mutasi dulu.',
    'stmt.lkHint':
      'Upload draft LK (mis. 2024 LK Jasa Gudang Tangerang) bersama e-statement, atau lempar file LK ke dropzone. Sistem baca NERACA dan siapkan jurnal opening.',
    'stmt.postOpening': 'Posting Saldo Awal',
    'stmt.asOf': 'as of {date}',
    'stmt.importDone': 'Import selesai',
    'stmt.saveSummary': '{imported} baru · {skipped} skip',
    'stmt.skippedDupHint': 'Skip = sudah ada di buku (fingerprint [FP]) — tidak dibuat ulang.',
    'stmt.memoryPlus': ' · memory +{n}',
    'stmt.newRefs': 'Ref ID baru:',
    'stmt.noteTitle': 'Memo / Note baris',
    'stmt.noteLabel': 'Tulis memo untuk credit/debit ini',
    'stmt.noteHint': 'Tersimpan ke jurnal saat posting · Ref ID otomatis J7P-######',
    'stmt.saveNote': 'Simpan note',
    'stmt.splitTitle': 'Split Transaksi',
    'stmt.splitSubtitle': '{desc} · total {amount}',
    'stmt.addSplit': '+ Baris split',
    'stmt.splitSum': 'Total split {n}',
    'stmt.splitOk': '= OK',
    'stmt.splitNeq': '≠ {n}',
    'stmt.applySplit': 'Terapkan Split',
    'stmt.part1': 'Pembagian 1',
    'stmt.part2': 'Pembagian 2',
    'stmt.snackQueued': '{n} file masuk antrean · klik Proses Upload',
    'stmt.snackDupFile': '{n} file sudah ada di antrean (nama sama) — dilewati',
    'stmt.snackDebitXor':
      '{n} baris invalid: isi Debit ATAU Kredit saja (bukan keduanya / kosong)',
    'stmt.snackNeedAcctNo': '{n} baris bank tanpa nomor rekening — isi rekening dulu',
    'stmt.snackChannelMix':
      '{n} baris tidak cocok channel {channel} — pisahkan upload CC vs rekening',
    'stmt.snackUnsupported': '{n} file tidak didukung dan tidak dimasukkan antrean',
    'stmt.snackUploadFail': 'Gagal upload',
    'stmt.snackSplit': 'Split tersimpan di baris — siap posting',
    'stmt.snackMemo': 'Memo baris tersimpan (ikut saat posting)',
    'stmt.snackPreviewOk': 'Preview OK · {n} jurnal',
    'stmt.snackImported': 'Tersimpan {imported} · skip {skipped} → masuk antrian Rekonsiliasi',
    'stmt.snackImportedDup':
      'Tersimpan {imported} baru · {skipped} sudah ada (fingerprint) — tidak double',
    'stmt.snackAllDup': 'Semua {skipped} baris sudah ada di buku (fingerprint) — tidak ada yang baru',
    'stmt.saveToRecon': 'Simpan terpilih → Rekonsiliasi',
    'stmt.snackSaveFail': 'Gagal simpan',
    'stmt.snackExportFail': 'Gagal export',
    'stmt.snackLkPreview': 'Preview saldo awal {n} baris',
    'stmt.snackLkSaved': 'Saldo awal tersimpan {ref}',
    'stmt.label': 'Label',
    'stmt.code': 'Kode',
    'stmt.splitChip': 'split {n}',
    'stmt.ocrShort': 'OCR',
    'stmt.ocrRescueTitle': 'File perlu OCR / scan ulang',
    'stmt.ocrRescueBody':
      '{n} file sulit dibaca sebagai teks. Upload ulang scan lebih tajam (PNG/JPG) atau PDF yang bukan hasil foto buram.',
    'stmt.readyScore': 'Siap posting',
    'stmt.readyHint': '{ok} benar · {need} masih perlu dicek',
    'stmt.healthTitle': 'Lane review cepat',
    'stmt.healthSub': 'Klik chip untuk filter baris — sinkron dengan tabel di bawah.',
    'stmt.clearLane': 'Reset filter',
    'stmt.tableFootRich':
      '{n} baris tampil · perlu cek {unsure} · DP {dp} · prepaid {prepaid} · benar {ok}',
    'stmt.openRecon': 'Buka Rekonsiliasi',
    'stmt.balTotal': 'Rekening dicek',
    'stmt.balAbsDiff': '|Selisih| total',
    'stmt.balanceMismatchHint':
      '{n} rekening belum cocok. Posting mutasi yang sudah dicek, atau isi saldo awal — lalu buka Rekonsiliasi.',

    'rpt.hubTitle': 'Pusat Laporan',
    'rpt.hubSub': 'Semua laporan keuangan & klasifikasi akun — siap review konsultan / KAP',
    'rpt.cfoKicker': 'Ringkasan CFO',
    'rpt.cfoTitle': 'Snapshot Keuangan',
    'rpt.cfoSub': 'Mengikuti konteks PT & periode kerja — klik kartu untuk drill-down laporan',
    'rpt.cfoCash': 'Kas & bank',
    'rpt.cfoCashHint': 'Posisi akhir {closing}',
    'rpt.cfoNetProfit': 'Laba bersih',
    'rpt.cfoRevenue': 'Omset {amount}',
    'rpt.cfoAr': 'Piutang terbuka',
    'rpt.cfoAp': 'Utang terbuka',
    'rpt.cfoOpenDocs': '{n} dokumen · {overdue} overdue',
    'rpt.cfoCfOps': 'Arus kas operasi',
    'rpt.cfoCfMix': 'Inv {inv} · Fin {fin}',
    'rpt.cfoEquity': 'Ekuitas akhir',
    'rpt.cfoEquityHint': 'Laba periode {income}',
    'rpt.cfoBs': 'Neraca',
    'rpt.cfoBsHint': 'Posisi per {to}',
    'rpt.cfoStmtCoverage': 'Coverage e-statement',
    'rpt.cfoStmtCoverageEmpty': 'Belum ada mutasi import di periode ini',
    'rpt.hubKicker': 'Studio laporan',
    'rpt.hubSearch': 'Cari laporan…',
    'rpt.hub.count': '{n} laporan aktif',
    'rpt.hub.groupExport': 'Ekspor',
    'rpt.hub.groupCore': 'Laporan inti',
    'rpt.hub.groupOps': 'Operasional',
    'rpt.hub.groupClassify': 'Klasifikasi & analisis',
    'rpt.hub.downloads': 'Download Laporan',
    'rpt.hub.downloadsDesc': 'Template Excel/PDF/CSV/Word profesional — pratinjau & unduh',
    'rpt.hub.lk': 'Laporan Keuangan (LK)',
    'rpt.hub.lkDesc': 'Neraca, L/R komersial–fiskal, SPT',
    'rpt.hub.yoy': 'Perbandingan YoY',
    'rpt.hub.yoyDesc': 'Bandingkan L/R & neraca antar tahun',
    'rpt.hub.bank': 'Per bank / rekening',
    'rpt.hub.bankDesc': 'Mutasi & saldo per akun kas/bank',
    'rpt.hub.forecast': 'Prakiraan kas',
    'rpt.hub.forecastDesc': 'Proyeksi kas 30/60 hari',
    'rpt.hub.ic': 'Antar perusahaan JGI↔JGT',
    'rpt.hub.icDesc': 'Kandidat & eliminasi',
    'rpt.hub.budget': 'Anggaran vs aktual',
    'rpt.hub.budgetDesc': 'Anggaran vs realisasi',
    'rpt.hub.ledger': 'Buku besar',
    'rpt.hub.ledgerDesc': 'Ledger per akun',
    'rpt.ld.kicker': 'Mutasi akun',
    'rpt.ld.loadedAt': 'Dimuat {t}',
    'rpt.ld.healthOk': 'Saldo wajar',
    'rpt.ld.healthNeg': 'Saldo negatif',
    'rpt.ld.openJournals': 'Jurnal',
    'rpt.ld.openJournalsShort': 'Jurnal',
    'rpt.ld.exportCsv': 'Ekspor CSV',
    'rpt.ld.exportCsvShort': 'Ekspor CSV',
    'rpt.ld.exportEmpty': 'Tidak ada baris untuk diekspor',
    'rpt.ld.bannerNegCash': 'Saldo kas/bank negatif · {amount} — review pengeluaran',
    'rpt.ld.bannerOk': '{n} mutasi · perubahan bersih {net}',
    'rpt.ld.focusCreditShort': 'Fokus kredit',
    'rpt.ld.kpiOpeningMeta': 'Saldo sebelum periode',
    'rpt.ld.kpiClosingMeta': 'Perubahan {net}',
    'rpt.ld.kpiDebit': 'Total debit',
    'rpt.ld.kpiDebitMeta': 'Mutasi masuk / debit periode',
    'rpt.ld.kpiCredit': 'Total kredit',
    'rpt.ld.kpiCreditMeta': '{n} baris di periode',
    'rpt.ld.vizDc': 'Debit vs kredit',
    'rpt.ld.vizMonth': 'Aktivitas bulanan',
    'rpt.ld.vizSnapshot': 'Snapshot ledger',
    'rpt.ld.vizNet': 'Perubahan bersih {amount}',
    'rpt.ld.vizEmpty': 'Belum ada mutasi di periode',
    'rpt.ld.snapLines': 'Jumlah baris',
    'rpt.ld.snapOpening': 'Saldo awal',
    'rpt.ld.snapClosing': 'Saldo akhir',
    'rpt.ld.snapNormal': 'Normal balance',
    'rpt.ld.healthTitle': 'Jalur sumber & sisi',
    'rpt.ld.healthSub': 'Klik untuk filter daftar mutasi',
    'rpt.ld.tipsTitle': 'Saran tindakan',
    'rpt.ld.tipNegCash': 'Kas/bank negatif {amount} — cek kredit / kasbon',
    'rpt.ld.tipEmpty': 'Belum ada mutasi — cek akun HPP 5000 / bank, atau impor ulang e-statement',
    'rpt.ld.tipOutOnly': 'Hanya kredit di periode — tidak ada debit masuk',
    'rpt.ld.tipTb': 'Bandingkan saldo akhir dengan neraca saldo',
    'rpt.ld.tipJournals': 'Buka jurnal untuk edit / telusuri ref',
    'rpt.ld.tipStatements': 'Sinkron e-statement bank & kartu kredit (HPP)',
    'rpt.ld.tipOk': 'Ledger sehat — mutasi & saldo konsisten',
    'rpt.ld.focusSource': 'Filter sumber: {s}',
    'rpt.ld.focusOpening': 'Fokus: saldo awal',
    'rpt.ld.focusClosing': 'Fokus: saldo akhir',
    'rpt.ld.focusDebit': 'Fokus: baris debit',
    'rpt.ld.focusCredit': 'Fokus: baris kredit',
    'rpt.ld.focusLines': 'Fokus: semua baris',
    'rpt.ld.focusSearch': 'Cari: “{q}”',
    'rpt.ld.clearFocus': 'Hapus fokus',
    'rpt.ld.empty': 'Ledger belum dimuat',
    'rpt.ld.emptyHint': 'Pilih akun / periode lalu muat ulang',
    'rpt.ld.tableKicker': 'Rincian',
    'rpt.ld.tableTitle': 'Mutasi buku besar',
    'rpt.ld.tableSub': 'Menampilkan {shown} dari {total} baris',
    'rpt.ld.searchPh': 'Cari ref / keterangan / sumber…',
    'rpt.ld.noRows': 'Tidak ada baris cocok',
    'rpt.ld.noRowsHint': 'Ubah filter atau hapus fokus',
    'rpt.ld.footerNote': 'Saldo berjalan memakai normal balance akun. Hanya jurnal cleared/released.',
    'rpt.hub.omset': 'Omset tahunan',
    'rpt.hub.omsetDesc': 'Omset bulanan per PT',
    'rpt.hub.tb': 'Neraca saldo',
    'rpt.hub.tbDesc': 'Saldo akun & uji keseimbangan',
    'rpt.tb.kicker': 'Uji keseimbangan',
    'rpt.tb.ok': 'Seimbang',
    'rpt.tb.bad': 'Belum seimbang',
    'rpt.tb.balancedHint': 'Total debit = total kredit',
    'rpt.tb.unbalancedHint': 'Selisih debit vs kredit — cek jurnal',
    'rpt.tb.accountsChip': '{n} akun aktif',
    'rpt.tb.loadedAt': 'Dimuat {t}',
    'rpt.tb.openLk': 'Laporan keuangan',
    'rpt.tb.openLkShort': 'Laporan LK',
    'rpt.tb.exportCsv': 'Ekspor CSV',
    'rpt.tb.exportCsvShort': 'Ekspor CSV',
    'rpt.tb.exportEmpty': 'Tidak ada baris untuk diekspor',
    'rpt.tb.bannerGap': 'Neraca saldo belum balance · selisih {amount}',
    'rpt.tb.bannerOk': 'Neraca saldo seimbang — debit sama dengan kredit',
    'rpt.tb.focusGapShort': 'Fokus selisih',
    'rpt.tb.kpiDebit': 'Total debit',
    'rpt.tb.kpiDebitMeta': 'Jumlah sisi debit periode',
    'rpt.tb.kpiCredit': 'Total kredit',
    'rpt.tb.kpiCreditMeta': 'Jumlah sisi kredit periode',
    'rpt.tb.kpiGap': 'Selisih (D−K)',
    'rpt.tb.kpiAccounts': 'Akun aktif',
    'rpt.tb.kpiAccountsMeta': 'Tampil {n} baris setelah filter',
    'rpt.tb.vizDc': 'Debit vs kredit',
    'rpt.tb.vizTypeMix': 'Aktivitas per tipe',
    'rpt.tb.vizTop': 'Saldo terbesar',
    'rpt.tb.vizEmpty': 'Belum ada aktivitas akun',
    'rpt.tb.meterLabel': 'Selisih balance',
    'rpt.tb.meterHint': 'Deviasi relatif ~{pct}%',
    'rpt.tb.healthTitle': 'Jalur tipe akun',
    'rpt.tb.healthSub': 'Klik untuk filter daftar neraca saldo',
    'rpt.tb.tipsTitle': 'Saran tindakan',
    'rpt.tb.tipGap': 'Selisih {amount} — telusuri akun dengan saldo terbesar',
    'rpt.tb.tipJournals': 'Buka jurnal untuk cari entri yang tidak balance',
    'rpt.tb.tipOpening': 'Periksa saldo awal jika periode dimulai di tengah tahun',
    'rpt.tb.tipLk': 'Lanjut ke Neraca / Laba Rugi setelah TB seimbang',
    'rpt.tb.tipEmptyTypes': '{n} tipe akun tanpa aktivitas di periode ini',
    'rpt.tb.tipOk': 'Neraca saldo sehat — siap review laporan keuangan',
    'rpt.tb.tipEmpty': 'Tidak ada baris — tampilkan akun nol atau ganti periode',
    'rpt.tb.focusType': 'Filter tipe: {type}',
    'rpt.tb.focusDebit': 'Fokus: akun dengan debit',
    'rpt.tb.focusCredit': 'Fokus: akun dengan kredit',
    'rpt.tb.focusGap': 'Fokus: saldo absolut terbesar',
    'rpt.tb.focusAccounts': 'Fokus: daftar akun (kode)',
    'rpt.tb.focusSearch': 'Cari: “{q}”',
    'rpt.tb.clearFocus': 'Hapus fokus',
    'rpt.tb.empty': 'Data neraca saldo belum dimuat',
    'rpt.tb.emptyHint': 'Pilih PT / periode lalu muat ulang',
    'rpt.tb.tableKicker': 'Rincian',
    'rpt.tb.tableTitle': 'Daftar saldo akun',
    'rpt.tb.tableSub': 'Menampilkan {shown} dari {total} akun',
    'rpt.tb.searchPh': 'Cari kode / nama / tipe…',
    'rpt.tb.showZeros': 'Tampilkan akun nol',
    'rpt.tb.noRows': 'Tidak ada baris cocok',
    'rpt.tb.noRowsHint': 'Ubah filter, hapus fokus, atau tampilkan akun nol',
    'rpt.tb.footerNote': 'Uji keseimbangan: total debit harus sama total kredit (cleared/released).',
    'rpt.hub.bs': 'Neraca',
    'rpt.hub.bsDesc': 'Posisi keuangan aset = L+E',
    'rpt.bss.kicker': 'Posisi keuangan',
    'rpt.bss.loadedAt': 'Dimuat {t}',
    'rpt.bss.openLk': 'Laporan keuangan',
    'rpt.bss.openLkShort': 'Laporan LK',
    'rpt.bss.exportCsv': 'Ekspor CSV',
    'rpt.bss.exportCsvShort': 'Ekspor CSV',
    'rpt.bss.exportEmpty': 'Tidak ada data untuk diekspor',
    'rpt.bss.focusGapShort': 'Fokus selisih',
    'rpt.bss.kpiAssets': 'Total aset',
    'rpt.bss.kpiAssetsMeta': 'Sisi kiri neraca',
    'rpt.bss.kpiLiab': 'Total kewajiban',
    'rpt.bss.kpiLiabMeta': 'Utang & kewajiban lain',
    'rpt.bss.kpiEquity': 'Total ekuitas',
    'rpt.bss.kpiEquityMeta': 'Porsi {pct}% dari L+E',
    'rpt.bss.kpiGap': 'Selisih (A − L−E)',
    'rpt.bss.vizBalance': 'Aset vs L+E',
    'rpt.bss.vizMix': 'Komposisi neraca',
    'rpt.bss.vizTop': 'Saldo terbesar',
    'rpt.bss.vizEmpty': 'Belum ada baris neraca',
    'rpt.bss.meterLabel': 'Selisih balance',
    'rpt.bss.meterHint': 'Deviasi relatif ~{pct}%',
    'rpt.bss.healthTitle': 'Jalur neraca',
    'rpt.bss.healthSub': 'Klik untuk fokus bagian neraca',
    'rpt.bss.laneGap': 'Selisih',
    'rpt.bss.tipsTitle': 'Saran tindakan',
    'rpt.bss.tipGap': 'Selisih {amount} — Aset ≠ Kewajiban+Ekuitas',
    'rpt.bss.tipTb': 'Buka neraca saldo untuk lacak akun yang timpang',
    'rpt.bss.tipJournals': 'Cek jurnal / rekonsiliasi yang belum cleared',
    'rpt.bss.tipOpening': 'Periksa saldo awal jika periode dimulai di tengah tahun',
    'rpt.bss.tipNegAssets': '{n} akun aset bersaldo negatif — review kas/bank',
    'rpt.bss.tipLk': 'Buka laporan keuangan formal (tab Neraca)',
    'rpt.bss.tipOk': 'Neraca seimbang — siap review formal / tutup periode',
    'rpt.bss.focusAssets': 'Fokus: aset',
    'rpt.bss.focusLiab': 'Fokus: kewajiban',
    'rpt.bss.focusEquity': 'Fokus: ekuitas',
    'rpt.bss.focusGap': 'Fokus: selisih A vs L+E',
    'rpt.bss.focusSearch': 'Cari: “{q}”',
    'rpt.bss.clearFocus': 'Hapus fokus',
    'rpt.bss.empty': 'Neraca belum dimuat',
    'rpt.bss.emptyHint': 'Pilih PT / periode lalu muat ulang',
    'rpt.bss.sheetKicker': 'Rincian',
    'rpt.bss.sheetTitle': 'Posisi keuangan',
    'rpt.bss.sheetSub': 'Aset {assets} · L+E {le}',
    'rpt.bss.searchPh': 'Cari kode / nama akun…',
    'rpt.bss.noLines': 'Tidak ada baris cocok',
    'rpt.bss.footerNote': 'Ekuitas termasuk laba/(rugi) periode berjalan (3999). Hanya jurnal cleared/released.',
    'rpt.bss.mandiriNegTitle': 'Saldo Bank Mandiri JGI minus',
    'rpt.bss.mandiriNegDetail':
      'Mandiri (1003) JGI {amount}. Perhitungan debit−kredit benar; minus karena mutasi keluar tanpa saldo awal. Reset meng-void jurnal Mandiri JGI agar saldo 0 — lalu upload ulang e-statement Mandiri 2.',
    'rpt.bss.mandiriPreview': 'Cek jurnal Mandiri',
    'rpt.bss.mandiriReset': 'Hapus & input ulang',
    'rpt.bss.mandiriPreviewOk': 'Preview: {n} jurnal Mandiri JGI akan di-void',
    'rpt.bss.mandiriResetOk': '{n} jurnal Mandiri JGI di-void. Saldo kembali 0 — silakan upload ulang.',
    'rpt.bss.mandiriResetNone': 'Tidak ada jurnal Mandiri JGI yang perlu di-void',
    'rpt.bss.mandiriConfirm':
      'Void {n} jurnal Bank Mandiri JGI (akun 1003)? Mandiri JGT tidak diubah. Tidak mudah di-undo — Anda perlu upload ulang e-statement.',
    'rpt.bss.tipMandiriNeg': 'Bank Mandiri JGI {amount} — cek sumber atau reset untuk input ulang',
    'rpt.hub.is': 'Laba rugi',
    'rpt.hub.isDesc': 'Pendapatan, HPP, beban, laba bersih',
    'rpt.is.kicker': 'Laporan kinerja',
    'rpt.is.profitChip': 'Laba',
    'rpt.is.lossChip': 'Rugi',
    'rpt.is.marginChip': 'Margin {pct}%',
    'rpt.is.loadedAt': 'Dimuat {t}',
    'rpt.is.openLk': 'Laporan keuangan',
    'rpt.is.openLkShort': 'Laporan LK',
    'rpt.is.exportCsv': 'Ekspor CSV',
    'rpt.is.exportCsvShort': 'Ekspor CSV',
    'rpt.is.exportEmpty': 'Tidak ada data untuk diekspor',
    'rpt.is.bannerLoss': 'Periode ini rugi · {amount}',
    'rpt.is.bannerOpex': 'Rasio opex {pct}% tinggi — review beban',
    'rpt.is.bannerOk': 'Laba bersih positif · margin {pct}%',
    'rpt.is.focusOpexShort': 'Fokus opex',
    'rpt.is.kpiRev': 'Omset',
    'rpt.is.kpiRevMeta': 'Total pendapatan periode',
    'rpt.is.kpiGross': 'Laba kotor',
    'rpt.is.kpiGrossMeta': 'Margin kotor {pct}%',
    'rpt.is.kpiOpex': 'Biaya operasional',
    'rpt.is.kpiOpexMeta': 'Rasio opex {pct}% dari omset',
    'rpt.is.kpiNet': 'Laba bersih',
    'rpt.is.kpiNetMeta': 'Margin bersih {pct}%',
    'rpt.is.vizMix': 'Komposisi P&L',
    'rpt.is.vizShare': 'Porsi per PT',
    'rpt.is.vizSnapshot': 'Snapshot margin',
    'rpt.is.vizEmpty': 'Belum ada data PT',
    'rpt.is.snapGrossMargin': 'Margin kotor',
    'rpt.is.snapNetMargin': 'Margin bersih',
    'rpt.is.snapOpexRatio': 'Rasio opex',
    'rpt.is.snapPt': 'Jumlah PT',
    'rpt.is.healthTitle': 'Jalur laporan',
    'rpt.is.healthSub': 'Klik untuk fokus bagian ringkasan',
    'rpt.is.tipsTitle': 'Saran tindakan',
    'rpt.is.tipLoss': 'Rugi {amount} — telusuri beban operasional',
    'rpt.is.tipOpexHigh': 'Opex {pct}% dari omset — di atas ambang 25%',
    'rpt.is.tipOpexWatch': 'Opex {pct}% mendekati ambang — pantau',
    'rpt.is.tipHppZero': 'HPP masih nol — cek klasifikasi e-statement / kartu kredit bersama',
    'rpt.is.tipGajiZero': 'Biaya gaji (5001) masih nol — post payroll HR agar selaras daftar gaji',
    'rpt.is.tipStmtAligned': 'E-statement: omset {omset} · HPP {hpp} (setelah alokasi bersama)',
    'rpt.is.stmtStripTitle': 'Selaras e-statement (jurnal import cleared)',
    'rpt.is.stmtOmset': 'Omset import',
    'rpt.is.stmtHpp': 'HPP import',
    'rpt.is.stmtNamedOpex': 'Opex bernama',
    'rpt.is.stmtAdmin': 'Admin bank',
    'rpt.is.stmtOpexOther': 'Opex lain',
    'rpt.is.stmtStripHint':
      'Angka di atas dari source=import. Biaya gaji 5001 dari payroll; transfer bank gaji/nama karyawan = pelunasan 2201. Draw Lim/Lix = piutang pemilik, bukan opex.',
    'rpt.is.tipLk': 'Buka laporan keuangan formal (tab Laba Rugi)',
    'rpt.is.tipTb': 'Cek neraca saldo jika angka terasa janggal',
    'rpt.is.tipOk': 'Kinerja sehat — margin bersih positif & opex terkendali',
    'rpt.is.focusRev': 'Fokus: pendapatan',
    'rpt.is.focusHpp': 'Fokus: HPP / laba kotor',
    'rpt.is.focusOpex': 'Fokus: biaya operasional',
    'rpt.is.focusNet': 'Fokus: laba bersih',
    'rpt.is.focusPt': 'Fokus PT: {code}',
    'rpt.is.focusSearch': 'Cari: “{q}”',
    'rpt.is.clearFocus': 'Hapus fokus',
    'rpt.is.empty': 'Laba rugi belum dimuat',
    'rpt.is.emptyHint': 'Pilih PT / periode lalu muat ulang',
    'rpt.is.ptKicker': 'Per PT',
    'rpt.is.ptTitle': 'Ringkasan per perusahaan',
    'rpt.is.ptSub': 'Klik kartu untuk filter konsolidasi · buka LK untuk detail formal',
    'rpt.is.ptTap': 'Klik untuk filter',
    'rpt.is.ptEmpty': 'Tidak ada data PT',
    'rpt.is.sheetKicker': 'Konsolidasi',
    'rpt.is.sheetSub': 'Laba rugi sederhana selaras neraca — uraian dan jumlah',
    'rpt.is.searchPh': 'Cari kode / nama akun…',
    'rpt.is.noLines': 'Tidak ada baris cocok',
    'rpt.is.hppEmpty': 'Tidak ada HPP 51xx di periode ini',
    'rpt.is.footerNote':
      'Format: Pendapatan → HPP → Laba Kotor → Biaya Operasional (gaji dari payroll) → Laba Usaha → Diluar Usaha → PPh Final. Hanya jurnal cleared/released.',
    'rpt.hub.cf': 'Arus kas',
    'rpt.hub.cfDesc': 'Laporan arus kas 3 aktivitas',
    'rpt.hub.assets': 'Laporan Aset',
    'rpt.hub.assetsDesc': 'Kas, piutang, persediaan, aktiva tetap',
    'rpt.hub.liabilities': 'Laporan Liabilitas',
    'rpt.hub.liabilitiesDesc': 'Utang & kewajiban keuangan',
    'rpt.hub.equity': 'Laporan Ekuitas',
    'rpt.hub.equityDesc': 'Modal & kekayaan bersih pemilik',
    'rpt.eqSub': 'Perubahan modal, saldo laba ditahan, dan laba periode berjalan',
    'rpt.eqOpening': 'Saldo awal',
    'rpt.eqIncrease': 'Penambahan',
    'rpt.eqDecrease': 'Pengurangan',
    'rpt.eqClosing': 'Saldo akhir',
    'rpt.eqNetIncome': 'Laba (rugi) bersih',
    'rpt.eqComponent': 'Komponen ekuitas',
    'rpt.eqTableTitle': 'Rincian perubahan ekuitas',
    'rpt.eqExport': 'Export laporan',
    'rpt.hub.revenue': 'Laporan Pendapatan',
    'rpt.hub.revenueDesc': 'Penghasilan penjualan barang/jasa',
    'rpt.hub.expense': 'Laporan Beban',
    'rpt.hub.expenseDesc': 'Ringkas per akun + rincian jurnal (satu ID Ref per baris)',
    'rpt.hub.ar': 'Piutang Usaha',
    'rpt.hub.arDesc': 'Tagihan pelanggan belum tertagih',
    'rpt.hub.ap': 'Utang Usaha',
    'rpt.hub.apDesc': 'Kewajiban ke pemasok',
    'rpt.hub.depreciation': 'Penyusutan',
    'rpt.hub.depreciationDesc': 'Beban & akumulasi penyusutan aset',
    'rpt.hub.inventory': 'Persediaan',
    'rpt.hub.inventoryDesc': 'Stok barang & bahan di neraca',
    'rpt.hub.cogs': 'Laporan HPP',
    'rpt.hub.cogsDesc': 'Harga pokok penjualan (51xx)',
    'rpt.hub.accrual': 'Akrual vs Kas',
    'rpt.hub.accrualDesc': 'Laba akrual dibanding arus kas netto',
    'rpt.hub.ctxAllPt': 'Semua PT',
    'rpt.hub.ctxHint': 'Mengikuti Konteks Kerja di atas',
    'rpt.hub.pinCount': '{n} dipin',
    'rpt.hub.statAll': 'Semua laporan',
    'rpt.hub.statAllMeta': 'Katalog penuh',
    'rpt.hub.statCore': 'Laporan inti',
    'rpt.hub.statCoreMeta': '{n} prioritas KAP',
    'rpt.hub.statOps': 'Operasional',
    'rpt.hub.statOpsMeta': 'Bank · IC · omset',
    'rpt.hub.statClassify': 'Klasifikasi',
    'rpt.hub.statClassifyMeta': 'Aset · L · E · P/L',
    'rpt.hub.statPinned': 'Favorit',
    'rpt.hub.statPinnedMeta': 'Pin lokal',
    'rpt.hub.vizReady': 'Kesiapan studio',
    'rpt.hub.vizReadySub': 'siap review',
    'rpt.hub.vizReadyHint': 'Naikkan skor dengan pin laporan & set filter PT',
    'rpt.hub.vizMix': 'Komposisi katalog',
    'rpt.hub.vizPriority': 'Prioritas konsultan',
    'rpt.hub.healthTitle': 'Navigasi cepat',
    'rpt.hub.healthSub': 'Filter grup katalog dengan satu klik',
    'rpt.hub.laneAll': 'Semua',
    'rpt.hub.laneCore': 'Inti',
    'rpt.hub.laneOps': 'Ops',
    'rpt.hub.laneClassify': 'Klasifikasi',
    'rpt.hub.lanePinned': 'Pin',
    'rpt.hub.tipsTitle': 'Saran alur review',
    'rpt.hub.tipCtx': 'Setel PT di Konteks Kerja agar laporan fokus ke entitas yang benar',
    'rpt.hub.tipCtxOk': 'Konteks aktif: {pt} · {period} — lanjut ke LK',
    'rpt.hub.tipPin': 'Pin laporan yang sering dipakai agar muncul di atas',
    'rpt.hub.tipLk': 'Mulai review dari Laporan Keuangan (LK) lengkap',
    'rpt.hub.tipTb': 'Cek Neraca Saldo untuk uji keseimbangan akun',
    'rpt.hub.tipCons': 'Tanpa filter PT — buka Konsolidasi Grup untuk semua PT',
    'rpt.hub.tipIc': 'Cek transaksi antar perusahaan sebelum konsolidasi',
    'rpt.hub.tipDownload': 'Siapkan paket unduh Excel/PDF untuk KAP',
    'rpt.hub.recent': 'Baru dibuka',
    'rpt.hub.focusAll': 'Semua',
    'rpt.hub.focusGroup': 'Grup: {group} · {n} laporan',
    'rpt.hub.focusPinned': 'Favorit · {n} laporan',
    'rpt.hub.focusSearch': 'Cari “{q}” · {n} hasil',
    'rpt.hub.clearFocus': 'Hapus filter',
    'rpt.hub.empty': 'Tidak ada laporan cocok',
    'rpt.hub.emptyHint': 'Ubah kata kunci atau hapus filter grup/pin.',
    'rpt.hub.badgePriority': 'Prioritas',
    'rpt.hub.togglePin': 'Pin / unpin laporan',
    'studio.kicker': 'Studio laporan',
    'studio.healthTitle': 'Status laporan',
    'studio.healthSub': 'Ringkas kesehatan data sebelum export / review.',
    'studio.healthRows': 'Baris',
    'studio.healthKpi': 'KPI',
    'studio.healthNotes': 'Catatan',
    'studio.healthExport': 'Export',
    'studio.healthOk': 'Baik',
    'studio.healthNeedReview': 'Perlu cek',
    'studio.healthReady': 'Siap',
    'studio.ptAll': 'Semua PT (All)',
    'studio.ptAllShort': 'Semua PT',
    'studio.filterPt': 'Filter PT',
    'studio.search': 'Cari',
    'studio.searchPh': 'Cari akun, kode, memo…',
    'studio.notes': 'Catatan & lingkup',
    'studio.dataTitle': 'Data rinci',
    'studio.rowCount': '{n} baris',
    'studio.openDownload': 'Buka Download',
    'studio.exportPack': 'Paket unduh',
    'studio.refresh': 'Muat ulang',
    'studio.loading': 'Memuat laporan…',
    'studio.empty': 'Belum ada data untuk filter ini',
    'studio.emptySection': 'Tidak ada data lampiran',
    'studio.loadFail': 'Gagal memuat laporan',
    'rpt.lkTitle': 'Laporan Keuangan',
    'rpt.lkSub': 'Format dokumen formal — neraca, laba rugi, SPT (siap cetak PDF)',
    'rpt.lkModes': 'Mode',
    'rpt.lkModeRead': 'Baca / cetak',
    'rpt.lkModeWork': 'Kerja neraca',
    'rpt.lkModeDownload': 'Paket unduh',
    'rpt.lkDocKicker': 'Dokumen formal',
    'rpt.lkDocTitle': 'Laporan Keuangan',
    'rpt.lkConfidential': 'Rahasia klien',
    'rpt.lkColAccount': 'Uraian',
    'rpt.lkSptHint': 'Ikhtisar per masa pajak · untuk kelengkapan konsultan',
    'rpt.lkSignerRole': 'Direktur / Penanggung Jawab',
    'rpt.lkFooterLeft': 'Dokumen kerja konsultan · bukan e-Filing resmi DJP',
    'rpt.printPdf': 'Cetak / PDF',
    'rpt.printChoose': 'Pilih mode cetak',
    'rpt.printCurrent': 'Tab aktif saja',
    'rpt.printCurrentHint': 'Cetak bagian yang sedang dibuka',
    'rpt.printAll': 'Paket lengkap',
    'rpt.printAllHint': 'Neraca + Laba Rugi + SPT (1 PDF)',
    'rpt.printOneByOne': 'Custom 1–1',
    'rpt.printScopeLabel': 'Isi cetak',
    'rpt.closeYear': 'Tutup buku tahun',
    'rpt.closedYear': 'Sudah tutup buku',
    'rpt.tabBs': 'Neraca',
    'rpt.tabIs': 'Laba rugi',
    'rpt.tabSpt': 'SPT / PPh final',
    'rpt.sectionBs': 'NERACA',
    'rpt.assets': 'AKTIVA',
    'rpt.liabEquity': 'KEWAJIBAN & EKUITAS',
    'rpt.sectionIs': 'Laporan laba rugi',
    'rpt.colCommercial': 'Komersial',
    'rpt.colFiscalAdj': 'Koreksi fiskal',
    'rpt.colFiscal': 'Fiskal',
    'rpt.bsOk': 'Neraca seimbang',
    'rpt.bsBad': 'Neraca belum seimbang',
    'rpt.lkKpiAssets': 'Total aktiva',
    'rpt.lkKpiAssetsMeta': 'Sisi aset neraca',
    'rpt.lkKpiLE': 'Kewajiban + ekuitas',
    'rpt.lkKpiLEMeta': 'Sisi pasiva neraca',
    'rpt.lkKpiGap': 'Selisih neraca',
    'rpt.lkKpiGapMeta': 'Deviasi ~{pct}% sisi terbesar',
    'rpt.lkKpiAssetsYoYMeta': 'Δ YoY {amount}',
    'rpt.lkKpiNetYoYMeta': 'Komersial {year} · Δ {amount}',
    'rpt.lkYoYPct': '{pct}%',
    'rpt.lkFactPeriod': 'Periode',
    'rpt.lkFactPeriodVal': 'TB {year} vs {prior}',
    'rpt.lkFactBalance': 'Neraca',
    'rpt.lkFactClose': 'Tutup buku',
    'rpt.lkFactClosed': 'Sudah ditutup',
    'rpt.lkFactOpen': 'Belum ditutup',
    'rpt.lkFactPrint': 'Cetak PDF',
    'rpt.lkFactPrintReady': 'Siap cetak',
    'rpt.lkFactPrintHold': 'Tahan — belum balance',
    'rpt.lkSnapPriorAssets': 'Aktiva tahun lalu',
    'rpt.lkSnapPph': 'PPh Final YTD',
    'rpt.lkSheetNote':
      'Neraca tersusun vertikal: Aset, lalu Liabilitas, lalu Ekuitas. Satu akun satu baris — nama dan nominal sejajar. Kolom {year} vs {prior}.',
    'rpt.lkKpiNet': 'Laba setelah pajak',
    'rpt.lkKpiNetMeta': 'Komersial {year}',
    'rpt.lkKpiPph': 'PPh Final tahun',
    'rpt.lkKpiPphMeta': 'Akumulasi SPT masa',
    'rpt.lkVizBalance': 'Keseimbangan neraca',
    'rpt.lkVizYoY': 'Komparatif YoY',
    'rpt.lkVizSnapshot': 'Snapshot dokumen',
    'rpt.lkVizAssetsYoY': 'Aktiva',
    'rpt.lkVizNetYoY': 'Laba setelah pajak',
    'rpt.lkVizEmpty': 'Data komparatif belum tersedia',
    'rpt.lkMeterLabel': 'Delta Aset vs Kewajiban+Ekuitas',
    'rpt.lkMeterHint': 'Selisih relatif ~{pct}% dari sisi terbesar',
    'rpt.lkSnapTab': 'Tab aktif',
    'rpt.lkSnapClosed': 'Tahun ditutup',
    'rpt.lkSnapGap': 'Abs selisih',
    'rpt.lkOpenTrial': 'Neraca saldo',
    'rpt.lkOpenCf': 'Arus kas',
    'rpt.lkStudioKicker': 'Report Studio',
    'rpt.lkStudioTitle': 'Banding YoY · drill ke buku besar',
    'rpt.lkStudioHint': 'Klik nominal berkode akun untuk buka ledger tahun ini. Mode presentasi menyembunyikan chrome.',
    'rpt.lkStudioPrior': 'Banding vs {year}',
    'rpt.lkPresent': 'Presentasi',
    'rpt.lkPresentExit': 'Keluar presentasi',
    'rpt.lkShare': 'Salin tautan',
    'rpt.lkShareOk': 'Tautan disalin',
    'rpt.lkShareFail': 'Gagal menyalin tautan',
    'rpt.lkDrillLedger': 'Buka buku besar akun ini',
    'rpt.lkHealthTitle': 'Navigasi laporan',
    'rpt.lkHealthSub': 'Klik chip untuk ganti tab dokumen.',
    'rpt.lkTipsTitle': 'Saran tindakan',
    'rpt.lkTipGap': 'Neraca timpang {amount} — cek modal, mutasi owner, atau saldo awal',
    'rpt.lkAutoSnack': 'AI menulis {n} note di lonceng — silakan cross-check neraca/TB.',
    'rpt.lkTipTrial': 'Buka neraca saldo untuk lacak akun yang tidak balance',
    'rpt.lkTipOpening': 'Periksa saldo awal / opening balance PT ini',
    'rpt.lkTipUnearned': 'Review uang muka pelanggan (akun 2600) vs pendapatan',
    'rpt.lkTipCloseReady': 'Neraca seimbang — {year} siap tutup buku jika penyesuaian selesai',
    'rpt.lkTipCloseBlocked': 'Jangan tutup tahun sebelum neraca balance',
    'rpt.lkTipClosed': 'Tahun {year} sudah ditutup',
    'rpt.lkTipOk': 'Dokumen LK sehat — neraca balance',
    'rpt.lkEmpty': 'Laporan belum termuat',
    'rpt.lkEmptyHint': 'Pilih PT & tahun, lalu muat ulang.',
    'rpt.closeOk': 'Tutup buku OK · Laba/Rugi diposting',
    'rpt.closeFail': 'Gagal tutup buku',
    'rpt.omsetTitle': 'Omset 1 tahun',
    'rpt.omsetKicker': 'Laporan · Pendapatan',
    'rpt.omsetSub':
      'Breakdown bulan 1–12 dari akun pendapatan (terhubung ke jurnal cleared). Filter PT, periode, dan rentang tanggal seperti dashboard.',
    'rpt.omsetTotal': 'Total omset {year}',
    'rpt.omsetChart': 'Grafik omset bulanan',
    'rpt.omsetChartHint': 'Total vs per PT — klik perbesar untuk fullscreen',
    'rpt.omsetTable': 'Tabel bulan 1–12',
    'rpt.omsetFilters': 'Filter laporan omset',
    'rpt.omsetFiltersHint': 'PT · Tahun · Periode · Dari / Sampai — buka/tutup untuk hemat ruang',
    'rpt.omsetFullYear': 'Tahun penuh',
    'rpt.omsetPartial': 'Rentang parsial',
    'rpt.omsetAvg': 'Rata-rata / bulan aktif',
    'rpt.omsetAvgHint': 'Total ÷ bulan yang ada omset',
    'rpt.omsetPeak': 'Bulan puncak',
    'rpt.omsetNoPeak': 'Belum ada omset',
    'rpt.omsetActiveMonths': '{n} bulan aktif',
    'rpt.omsetOfTotal': 'dari total',
    'rpt.omsetMom': 'MoM',
    'rpt.omsetShare': 'Porsi',
    'rpt.omsetHideZero': 'Sembunyikan bulan Rp 0',
    'rpt.omsetExpand': 'Perbesar grafik',
    'rpt.omsetViz': 'Visualisasi',
    'rpt.omsetDetail': 'Rincian',
    'rpt.omsetNoData': 'Tidak ada data untuk filter ini',
    'rpt.omsetEmptyExport': 'Tidak ada baris untuk diekspor',
    'rpt.omsetExported': 'CSV omset diunduh',
    'rpt.omsetGuideTitle': 'Cara baca laporan omset',
    'rpt.omsetGuide1': 'Omset diambil dari jurnal pendapatan berstatus cleared/released — bukan draft atau void.',
    'rpt.omsetGuide2': 'Filter periode membatasi tanggal jurnal; tahun menentukan kolom bulan 1–12 yang ditampilkan.',
    'rpt.omsetGuide3': 'Uang muka / DP belum masuk omset sampai diakui sebagai pendapatan — cek laporan Uang Muka.',
    'rpt.omsetModeBar': 'Bar',
    'rpt.omsetModeLine': 'Line',
    'rpt.omsetModeArea': 'Area',
    'rpt.omsetModeStacked': 'Stacked',
    'rpt.omsetChartMode': 'Mode grafik',
    'rpt.omsetShowPt': 'Tampilkan per PT',
    'rpt.omsetCumulative': 'Kumulatif YTD',
    'rpt.omsetShowYoy': 'Bandingkan tahun lalu',
    'rpt.omsetYoy': 'YoY vs {year}',
    'rpt.omsetYoyPrev': 'Tahun lalu',
    'rpt.omsetYoySeries': 'Omset {year}',
    'rpt.omsetPkp': 'Progress PKP UMKM',
    'rpt.omsetPkpRemain': 'Sisa ke batas',
    'rpt.omsetPkpLimit': 'Batas',
    'rpt.omsetDonutTitle': 'Porsi per PT',
    'rpt.omsetDonutHint': 'Kontribusi masing-masing perusahaan',
    'rpt.omsetPrint': 'Cetak',
    'rpt.colMonth': 'Bulan',
    'rpt.colPeriod': 'Periode',
    'rpt.colOmset': 'Total omset',
    'rpt.filterPt': 'Filter PT',
    'rpt.load': 'Muat',
    'rpt.assetsLabel': 'Aset',
    'rpt.liabilities': 'Kewajiban',
    'rpt.equity': 'Ekuitas',
    'rpt.totalAssets': 'Total Aset',
    'rpt.totalLiabilities': 'Total Kewajiban',
    'rpt.totalEquity': 'Total Ekuitas',
    'rpt.liabPlusEquity': 'Kewajiban + Ekuitas',
    'rpt.bsBalancedHint': 'Neraca balance',
    'rpt.bsUnbalancedHint': 'Neraca belum balance — cek jurnal',
    'rpt.asOf': 'Per {date}',
    'rpt.opex': 'Biaya Operasional',
    'rpt.consolidatedSummary': 'Ringkasan Konsolidasi',
    'rpt.totalRevenue': 'Total Pendapatan (Omset)',
    'rpt.grossProfitLoss': 'Laba / (Rugi) Kotor',
    'rpt.netProfitLoss': 'Laba / (Rugi) Bersih',
    'rpt.colLine': 'Pos',
    'rpt.colDelta': 'Δ',
    'rpt.cfInflows': 'Kas Masuk',
    'rpt.cfOutflows': 'Kas Keluar',
    'rpt.cfNet': 'Netto',
    'rpt.cfRecentTitle': 'Mutasi Kas/Bank Terbaru',
    'rpt.cfOperating': 'Operasi',
    'rpt.cfInvesting': 'Investasi',
    'rpt.cfFinancing': 'Pendanaan',
    'rpt.cfOpening': 'Kas awal periode',
    'rpt.cfClosing': 'Kas akhir periode',
    'rpt.cfStatementTitle': 'Ringkasan 3 Aktivitas',
    'rpt.cfStatementSub': 'Operasi · Investasi · Pendanaan — klasifikasi dari lawan akun jurnal kas',
    'rpt.cfActivity': 'Aktivitas',
    'rpt.cfAmount': 'Arus kas',
    'rpt.cfNetChange': 'Perubahan bersih kas',
    'rpt.cfNetIncome': 'Laba/rugi bersih (referensi)',
    'rpt.cfNetIncomeHint': 'Dari P&L akrual, bukan baris SCF',
    'rpt.cfStmtTab': 'Detail per jurnal',
    'rpt.colIn': 'Masuk',
    'rpt.colOut': 'Keluar',
    'rpt.colAccountCode': 'Rekening',
    'rpt.forecastDays': 'Hari',
    'rpt.currentCash': 'Saldo kas kini',
    'rpt.avgInflowDay': 'Avg inflow / hari',
    'rpt.avgOutflowDay': 'Avg outflow / hari',
    'rpt.horizon': 'Horizon',
    'rpt.inflow': 'Inflow',
    'rpt.outflow': 'Outflow',
    'rpt.projectedCash': 'Proyeksi kas',
    'rpt.daysUnit': '{n} hari',
    'rpt.openingBalance': 'Saldo Awal',
    'rpt.closingBalance': 'Saldo Akhir',
    'rpt.budgetNew': 'Budget baru',
    'rpt.budgetSelect': 'Pilih budget',
    'rpt.budgetSaved': 'Budget disimpan',
    'rpt.budgetLineAdded': 'Baris ditambah',
    'rpt.budgetAddLine': '+ Baris (form bawah)',
    'rpt.budgetLineForm': 'Form baris budget',
    'rpt.budgetYearNew': 'Tahun (budget baru)',
    'rpt.budgetMonth': 'Bulan 1-12',
    'rpt.budgetAmount': 'Jumlah budget',
    'rpt.budgetActual': 'Actual',
    'rpt.budgetVariance': 'Variance',
    'rpt.budgetFormHint': 'Isi akun/bulan/jumlah di form baris, lalu simpan.',
    'rpt.icElimDetected': 'Eliminasi terdeteksi: {pairs} pasangan · Total {total}',
    'rpt.icAutoRunning': 'AI sedang mengeksekusi saran antar perusahaan…',
    'rpt.icAutoDone': 'AI sudah eksekusi · {n} note baru di lonceng.',
    'rpt.icAutoSynced': 'AI sudah scan — note lonceng siap di-cross-check.',
    'rpt.icKicker': 'Grup · Eliminasi IC · Cross-check',
    'rpt.icHealthOk': 'IC rapi',
    'rpt.icHealthWarn': 'Perlu review pasangan',
    'rpt.icHealthHot': 'Ada kandidat tanpa pasangan',
    'rpt.icHealthOkShort': 'Sehat',
    'rpt.icHealthWarnShort': 'Review',
    'rpt.icHealthHotShort': 'Perhatian',
    'rpt.icHealthTitle': 'Status IC',
    'rpt.icHealthHint': 'Pasangan vs kandidat memo antar PT',
    'rpt.icPairsChip': '{n} pasangan',
    'rpt.icUnmatchedMeta': '~{n} tanpa pasangan',
    'rpt.icOpenCons': 'Konsolidasi',
    'rpt.icPairsTitle': 'Pasangan eliminasi',
    'rpt.icPairsSub': 'Kandidat yang sudah cocok nominal & tanggal antar PT.',
    'rpt.icCandTitle': 'Semua kandidat IC',
    'rpt.icCandSub': 'Jurnal dengan memo antar perusahaan / interco / pinjaman.',
    'rpt.icNoCandidates': 'Belum ada kandidat di periode ini',
    'rpt.icElimPairs': 'Pasangan eliminasi',
    'rpt.icNoPairs': 'Belum ada pasangan otomatis',
    'rpt.icAllCandidates': 'Semua kandidat (keyword interco)',
    'rpt.icColPtA': 'PT A',
    'rpt.icColPtB': 'PT B',
    'rpt.closeConfirm':
      'Tutup buku tahun {year}?\n\nSaldo L/R akan dipindah ke Laba Ditahan. Jurnal close bertanggal 31 Des {year}.',
    'rpt.yearClosedBanner': 'Tahun {year} sudah ditutup pada {date} · net {amount}',
    'rpt.docMeta': '{code} · Tahun Buku {year} · Komparatif {prior}',
    'rpt.asOfDec31': 'Per 31 Desember {year}',
    'rpt.inRupiah': '(Dalam Rupiah)',
    'rpt.bsBannerDetail': 'Aset {assets} vs Kewajiban+Ekuitas {total}',
    'rpt.compareAssets': 'Komparatif Aktiva {year}',
    'rpt.compareNetAfterTax': 'Komparatif Laba Setelah Pajak {year}',
    'rpt.thisYearAmount': 'Tahun ini {amount}',
    'rpt.deltaAmount': 'Δ {amount}',
    'rpt.compareIncomeBanner':
      'Komparatif {year}: Pendapatan {revenue} · Laba kotor {gross} · Setelah pajak {afterTax}',
    'rpt.revenue': 'Pendapatan',
    'rpt.grossProfit': 'Laba kotor',
    'rpt.afterTax': 'Setelah pajak',
    'rpt.pph25Title': 'Perhitungan PPh 25 tahun {year}',
    'rpt.pph25Base': 'Penghasilan dasar perhitungan (fiskal, dibulatkan)',
    'rpt.pph25Self': 'PPh yang harus disetor sendiri (estimasi)',
    'rpt.pph25Installment': 'Angsuran PPh 25 (1/12)',
    'rpt.sptDisclaimer':
      'Halaman ini memudahkan penyusunan angka SPT. Validasi akhir tetap dengan konsultan pajak / e-Filing DJP.',
    'rpt.periodOf': 'Periode {label}',
    'rpt.signPlace': 'Jakarta, {date}',

    'common.edit': 'Edit',
    'common.delete': 'Hapus',
    'common.yes': 'Ya',
    'common.no': 'Tidak',
    'common.confirmDelete': 'Hapus?',
    'common.action': 'Aksi',
    'common.code': 'Kode',
    'common.type': 'Tipe',
    'common.status': 'Status',
    'common.description': 'Keterangan',
    'common.select': 'Pilih',
    'common.apply': 'Terapkan',
    'common.file': 'File',
    'common.rows': 'Baris',
    'common.invalid': 'Invalid',
    'common.selectAll': 'Pilih semua',
    'common.unselectAll': 'Batal pilih',
    'common.descShort': 'Deskripsi',
    'common.autoFix': 'Auto Fix',

    'qj.uploadTitle': 'Upload Pintar Bukti Transaksi',
    'qj.uploadSub':
      'Semua file · auto-parse · Gemini→Groq · debit/kredit pintar · baris bertambah otomatis ke bawah.',
    'qj.uploadLabel': 'Upload file transaksi / statement',
    'qj.aiOn': 'AI ON (Gemini→Groq)',
    'qj.aiOff': 'AI OFF · rule lokal',
    'qj.aiGemini': 'Gemini ON',
    'qj.aiGroq': 'Groq cadangan',
    'qj.recFillManual': 'Isi debit/kredit + akun bank & lawan',
    'qj.uploadHint': 'Multi-file · semua format dicoba · jpg/png/pdf/xlsx/csv/zip/dll',
    'qj.uploadHintReady': 'Draft siap: {n} baris. Cek, revisi, lalu ACC simpan.',
    'qj.uploadHintAppend': '+{n} baris baru · total {total}. Upload lagi = bertambah ke bawah.',
    'qj.uploadHintDone': 'Import selesai: {imported} jurnal, skip {skipped}, error {errors}.',
    'qj.parseAuto': 'Parse Otomatis',
    'qj.accSaveSelected': 'ACC Simpan Terpilih ({n})',
    'qj.howtoTitle': 'Tata cara upload & ACC',
    'qj.howtoHint': 'Klik untuk buka',
    'qj.howtoS1t': '1. Pilih PT',
    'qj.howtoS1': 'Klik kartu JGI atau JGT — semua baris ikut PT itu (tidak bisa campur).',
    'qj.howtoS2t': '2. Pilih rekening',
    'qj.howtoS2': 'Pilih slot rekening tujuan. Nomor rekening terkunci dari master — isi dulu lewat Update jika kosong.',
    'qj.howtoS3t': '3. Unggah & Parse',
    'qj.howtoS3': 'Drop file (semua format) lalu Parse Otomatis. File baru ditambahkan ke bawah, tidak menimpa.',
    'qj.howtoS4t': '4. Cek tabel (# & checklist)',
    'qj.howtoS4':
      'Kolom # = nomor baris. Checklist header: 1× = centang semua, 2× (double-click) = hilangkan semua. Review ✓/?/✕ sebelum ACC.',
    'qj.howtoS5t': '5. ACC lalu Kirim Rekon',
    'qj.howtoS5':
      'ACC Simpan Terpilih = simpan draft ke jurnal import. Kirim Laporan = ACC + buka antrian rekonsiliasi pintar.',
    'qj.howtoTip':
      'Tip: pastikan debit/kredit, no rekening, kas/bank, dan akun lawan sudah benar sebelum Ya di dialog konfirmasi.',
    'qj.autoFillAccount': 'Auto Fill Akun',
    'qj.setContraSelected': 'Set akun lawan (terpilih)',
    'qj.setContraManual': 'Set akun lawan (manual terpilih)',
    'qj.fileErrors': 'Error file',
    'qj.avgConfidence': 'Avg confidence',
    'qj.needsOcrScan': 'Perlu OCR ulang (scan)',
    'qj.fillForm': 'Isi Form',
    'qj.toManual': '+ Manual',
    'qj.manualTitle': 'Input Multi-Baris Manual (Bukan Single)',
    'qj.manualTitleShort': 'Input Multi-Baris Manual',
    'qj.manualSub':
      'Tabel debit/kredit angka · Tambah baris · simpan terpilih. Alat bantu opsional (Auto Fix / akun lawan).',
    'qj.manualTipsTitle': 'Cara isi cepat',
    'qj.manualTip1': 'Geser tabel ke kanan untuk Debit, Kredit, No rekening, Ref, Kas/Bank, Lawan, Map, Review.',
    'qj.manualTip2': 'Isi deskripsi + salah satu Debit/Kredit + akun lawan sebelum simpan.',
    'qj.manualTip3': 'PT terkunci ke target di kiri — ganti PT di panel upload jika perlu.',
    'qj.manualScrollHint': '↔ Scroll horizontal untuk semua kolom',
    'qj.manualCheckSelected': 'Terpilih: {n} baris',
    'qj.manualCheckInvalid': 'Perlu perbaikan: {n} baris',
    'qj.manualCheckValid': 'Semua baris terpilih valid',
    'qj.manualCheckBankOk': 'Rekening kas/bank siap',
    'qj.manualCheckBankNeed': 'Pilih rekening di panel kiri dulu',
    'qj.showAssist': 'Alat bantu',
    'qj.hideAssist': 'Tutup alat',
    'qj.aiParsing': 'AI parsing…',
    'qj.aiParsingHint': 'Gemini membaca file… jika gagal otomatis Groq. Debit/kredit dinormalisasi.',
    'qj.autoTable': 'Tabel otomatis hasil AI',
    'qj.autoTableHint': '{n} baris siap dicek · field sudah diisi otomatis',
    'qj.dropLockTitle': 'Upload terkunci',
    'qj.dropLockNeedBoth': 'Lengkapi dulu: pilih PT dan rekening — baru bisa drop / pilih file.',
    'qj.dropLockNeedBank': 'Lengkapi dulu: pilih rekening tujuan — baru bisa drop / pilih file.',
    'qj.dropReadyTitle': 'Seret & lepas file di sini',
    'qj.dropReadyBody': 'Semua format · multi-file · auto-parse · debit/kredit dikenali AI',
    'qj.dropPickFiles': 'Pilih file',
    'qj.dropAddMore': 'Tambah file',
    'qj.dropClearFiles': 'Hapus semua',
    'qj.dropPrev': 'File sebelumnya',
    'qj.dropNext': 'File berikutnya',
    'qj.dropFilesUnit': 'file',
    'qj.dropRemoveFile': 'Hapus file ini',
    'qj.demoBadge': 'Contoh',
    'qj.demoTitle': 'Pratinjau hasil setelah parse',
    'qj.demoSub': 'Dummy interaktif — lihat contoh tabel setelah AI membaca multi-file.',
    'qj.demoShow': 'Lihat contoh',
    'qj.demoHide': 'Tutup',
    'qj.demoFoot':
      'Contoh: No rekening = rekening bank · Kas/Bank = akun 1001 · No akun lawan = 4101/5201… · Arah = sisi bank di rekonsiliasi. Tidak tersimpan.',
    'qj.demoRow1Desc': 'TRF MASUK · PT Maju Jaya · invoice gudang',
    'qj.demoRow2Desc': 'BIAYA ADMIN BCA · biaya transfer',
    'qj.demoRow3Desc': 'PEMBAYARAN DP · pelanggan Sinar Abadi',
    'qj.demoContra1': 'Pendapatan jasa',
    'qj.demoContra2': 'Beban operasional',
    'qj.demoContra3': 'Piutang usaha',
    'qj.demoDirIn': 'Bank Debit',
    'qj.demoDirOut': 'Bank Kredit',
    'qj.demoRekHint': 'No rekening bisa dipilih per baris',
    'qj.emptyUploadTitle': 'Belum ada tabel',
    'qj.emptyUploadSub': 'Pilih PT + rekening, lalu unggah file — AI parse otomatis mengisi tabel.',
    'qj.skelPreview': 'Pratinjau kolom',
    'qj.skelSeeHere': 'Lihat di sini',
    'qj.skelDetailTitle': 'Slot detail baris',
    'qj.skelDetailSub': 'Setelah parse, ringkasan file + detail tiap baris muncul di sini.',
    'qj.skelHint1': 'Tgl · PT · Deskripsi · No rekening · No ref',
    'qj.skelHint2': 'Debit/Kredit · Kas/Bank · No akun lawan · Tipe',
    'qj.skelHint3': 'Arah map · AI Gemini/Groq · Kirim → Rekon',
    'qj.sendReport': 'Kirim Laporan ({n})',
    'qj.cancelUpload': 'Batal',
    'qj.sendHint': 'Kirim = ACC + antre rekonsiliasi pintar · Batal = clear & unggah ulang',
    'qj.uploadHintCleared': 'Dibatalkan. Semua file & tabel di-clear — silakan unggah ulang.',
    'qj.confirmSendKicker': 'Kirim ke rekonsiliasi',
    'qj.confirmSendTitle': 'Kirim laporan terpilih sekarang?',
    'qj.confirmSendLead':
      '{n} baris akan disimpan sebagai jurnal import (antrian pending) lalu dibuka di Rekonsiliasi.',
    'qj.confirmSendB1': 'Field lengkap: tgl, PT, deskripsi, no akun, no ref, debit/kredit, kas/bank, lawan, tipe, arah map.',
    'qj.confirmSendB2': 'AI Gemini (utama) + Groq (cadangan) sudah mengisi field otomatis — Anda bisa edit sebelum kirim.',
    'qj.confirmSendB3': 'Setelah Ya, baris masuk antrian rekonsiliasi pintar untuk dicocokkan ke statement.',
    'qj.confirmCancelKicker': 'Batalkan upload',
    'qj.confirmCancelTitle': 'Batalkan dan clear semua?',
    'qj.confirmCancelLead':
      'Semua file, tabel draft, dan hasil parse AI akan dihapus. Workspace siap unggah ulang dari awal.',
    'qj.confirmCancelB1': 'File upload + baris draft di-clear total.',
    'qj.confirmCancelB2': 'Tidak ada jurnal yang dibuat ke database.',
    'qj.confirmCancelB3': 'Anda bisa pilih PT/rekening lalu unggah statement lagi.',
    'qj.confirmAccKicker': 'ACC simpan terpilih',
    'qj.confirmAccTitle': 'Anda yakin dan sudah cek?',
    'qj.confirmAccLead':
      '{n} baris tercentang akan disimpan sebagai jurnal import. Pastikan data sudah dicek sebelum Ya.',
    'qj.confirmAccB1': 'Cek kolom #: tanggal, deskripsi, debit/kredit, no rekening, kas/bank, akun lawan.',
    'qj.confirmAccB2': 'Checklist hanya baris yang benar — uncentang yang masih ragu/salah.',
    'qj.confirmAccB3': 'Setelah Ya, baris tersimpan (pending). Bisa lanjut Kirim Laporan ke rekonsiliasi.',
    'qj.confirmYes': 'Ya',
    'qj.confirmNo': 'Tidak',
    'qj.confirmYesSendHint': 'Simpan & buka Rekonsiliasi',
    'qj.confirmNoSendHint': 'Tetap di halaman ini',
    'qj.confirmYesCancelHint': 'Clear semua & mulai ulang',
    'qj.confirmNoCancelHint': 'Kembali edit tabel',
    'qj.confirmYesAccHint': 'Ya, sudah cek — simpan ACC',
    'qj.confirmNoAccHint': 'Belum — kembali cek tabel',
    'stmt.contraType': 'Tipe lawan',
    'qj.manualTable': 'Tabel manual',
    'qj.manualTableHint': 'Edit sel langsung · pakai Auto Fix / Auto Fill untuk cepat',
    'qj.singleTitle': 'Entri tunggal cepat',
    'qj.singleSub': 'Pilih PT, bank, akun lawan, isi debit/kredit angka → Tambah ke tabel → Submit',
    'qj.addToTable': 'Tambah ke tabel',
    'qj.resetForm': 'Reset form',
    'qj.resetFormHint': 'Kosongkan nominal & deskripsi — PT/bank/rekening tetap',
    'qj.singleQueueTitle': 'Antrian entri tunggal',
    'qj.singleQueueSub': '{n} baris siap disimpan',
    'qj.singleQueueEmpty': 'Belum ada baris — isi form lalu klik Tambah ke tabel.',
    'qj.singleQueueDummySub': 'Contoh tabel (dummy) — isi form & Tambah untuk mengganti dengan data nyata',
    'qj.singleDummyBadge': 'CONTOH',
    'qj.singleDummy1': 'TRF MASUK · contoh invoice gudang',
    'qj.singleDummy2': 'BIAYA ADMIN · contoh biaya transfer',
    'qj.singleDummy3': 'PEMBAYARAN DP · contoh pelanggan',
    'qj.singleActive': 'Aktif',
    'qj.singleActiveOn': 'Masuk tabel (tercentang)',
    'qj.singleActiveOff': 'Nonaktif di tabel',
    'qj.singleSubmit': 'Submit ({n})',
    'qj.confirmContinueTitle': 'Yakin dan lanjutkan?',
    'qj.confirmSingleSubmitKicker': 'Submit antrian',
    'qj.confirmSingleSubmitLead': 'Submit {n} baris terpilih ke antrian rekonsiliasi?',
    'qj.confirmSingleSubmitB1': 'Cek PT, deskripsi, debit/kredit, rekening, kas/bank, akun lawan, map, review.',
    'qj.confirmSingleSubmitB2': 'Hanya baris tercentang (aktif) yang dikirim.',
    'qj.confirmSingleSubmitB3': 'Setelah Ya, baris tersimpan pending untuk dicocokkan ke statement.',
    'qj.confirmSingleCancelKicker': 'Batalkan entri',
    'qj.confirmSingleCancelLead': 'Kosongkan antrian dan reset form entri tunggal?',
    'qj.confirmSingleCancelB1': 'Antrian tabel di-clear (dummy muncul lagi).',
    'qj.confirmSingleCancelB2': 'Tidak ada data yang disimpan ke database.',
    'qj.confirmYesSingleSubmitHint': 'Ya — submit sekarang',
    'qj.confirmNoSingleSubmitHint': 'Belum — kembali cek',
    'qj.confirmYesSingleCancelHint': 'Ya — kosongkan',
    'qj.confirmNoSingleCancelHint': 'Tidak — tetap edit',
    'qj.errDebitOrCredit': 'Isi salah satu saja: Debit atau Kredit (bukan keduanya).',
    'qj.confManualSingle': 'Diisi manual (entri tunggal)',
    'qj.clearQueue': 'Kosongkan',
    'qj.saveQueue': 'Simpan antrian ({n})',
    'qj.errNoSingleQueue': 'Belum ada baris nyata terpilih di antrian (dummy tidak ikut submit).',
    'qj.addRow': 'Tambah Baris',
    'qj.addRowNeedPt': 'Pilih PT JGI / JGT dulu — baru bisa tambah baris.',
    'qj.addRowNeedBank': 'Pilih rekening dulu — baru tombol Tambah Baris muncul.',
    'qj.saveMulti': 'Simpan Multi Baris ({n})',
    'qj.manualSelected': 'Manual terpilih',
    'qj.resetRow': 'Reset baris',
    'qj.removeRow': 'Hapus baris',
    'qj.resetAllRows': 'Reset semua ke awal',
    'qj.removeSelected': 'Hapus terpilih ({n})',
    'qj.selectInvalid': 'Pilih yang invalid',
    'qj.expandTitle': 'Perbesar Debit / Kredit Cepat',
    'qj.confUnevaluated': 'Belum dievaluasi',
    'qj.confEmptyContra': 'Akun lawan kosong.',
    'qj.confStrongKeyword': 'Keyword kuat terdeteksi.',
    'qj.confNeedVerify': 'Ada konteks, tetap perlu verifikasi.',
    'qj.confDescThin': 'Deskripsi terlalu minim.',
    'qj.confParserFilled': 'Parser mengisi akun lawan, cek ulang.',
    'qj.confContraMissing': 'Akun lawan belum terdeteksi.',
    'qj.errNoTxn': 'File ter-upload, tapi belum ada transaksi yang bisa dibaca.',
    'qj.errParseUpload': 'Gagal memproses upload',
    'qj.errNoUploadSelected': 'Belum ada baris upload yang dipilih.',
    'qj.errUploadInvalid': 'Ada {n} baris upload belum valid (debit/kredit/akun/tanggal).',
    'qj.errSaveUpload': 'Gagal simpan hasil upload',
    'qj.errManualNeedRow':
      'Isi minimal 1 baris manual valid (debit/credit + akun bank + akun lawan).',
    'qj.errManualInvalid': 'Ada {n} baris manual belum valid (debit/kredit/akun/tanggal).',
    'qj.errSaveManual': 'Gagal simpan baris manual',
    'qj.errManualDate': 'Ada {n} baris tanpa tanggal lengkap (tahun-bulan-hari). Isi dulu sebelum simpan.',
    'qj.errNeedDate': 'Tanggal wajib diisi lengkap (tahun-bulan-hari).',
    'qj.errNeedDesc': '{n} baris belum ada deskripsi — isi dulu (kotak merah) sebelum lanjut.',

    'stx.scrollHint': 'Geser kanan · review ✓/?/✕ · tag DP/Prepaid · pilih akun sebelum recon',
    'stx.massCheckHint': '1× centang semua · 2× hilangkan checklist',
    'stx.descRequired': 'Deskripsi wajib diisi',
    'stx.toolbar': 'Alat tabel',
    'stx.showTools': 'Alat',
    'stx.hideTools': 'Tutup alat',
    'stx.lanes': 'Filter baris',
    'stx.segSelect': 'Pilih baris',
    'stx.selected': 'Terpilih',
    'stx.fillDates': 'Isi tanggal kosong',
    'stx.fillDatesShort': 'Tanggal',
    'stx.deleteAll': 'Hapus semua',
    'stx.enlarge': 'Perbesar tabel',
    'stx.confirmDeleteAll': 'Hapus semua baris di tabel ini?',
    'stx.review': 'Review',
    'stx.tag': 'Tag cepat',
    'stx.wrong': 'Salah',
    'stx.unsure': 'Ragu',
    'stx.markOk': 'Benar',
    'stx.markWrong': 'Salah',
    'stx.markUnsure': 'Ragu',
    'stx.selectUnsure': 'Pilih yang ragu',
    'stx.applyGate': 'Auto ✓/? confidence',
    'stx.applyGateShort': 'Auto ✓/?',
    'stx.openDpWizard': 'Wizard DP',
    'stx.laneEmpty': 'Tidak ada baris di lane ini',
    'stx.lane.all': 'Semua',
    'stx.lane.unsure': 'Perlu cek',
    'stx.lane.dp': 'DP',
    'stx.lane.prepaid': 'Prepaid',
    'stx.lane.no_acct': 'Tanpa akun',
    'stx.lane.wrong': 'Salah',
    'stx.lane.ok': 'Benar',
    'stx.ptLocked': 'PT terkunci sesuai pilihan di awal — tidak bisa campur PT lain',
    'stx.refLocked': 'NoRef otomatis dari nomor J7P available — tidak bisa dipilih manual',
    'stx.refAutoBadge': 'Auto',
    'stx.refAutoPending': 'Menunggu…',
    'stx.perPage': 'Per halaman',
    'stx.pageAll': 'Semua',
    'stx.pageAllCapped': 'Semua dibatasi (>{max}) → 50/halaman',
    'stx.pageAllCappedHint': 'Dataset besar tidak ditampilkan sekaligus agar halaman tidak hang.',
    'stx.pagination': 'Navigasi halaman',
    'stx.pagePrev': 'Halaman sebelumnya',
    'stx.pageNext': 'Halaman berikutnya',
    'stx.pageShowing': 'Menampilkan {from}–{to} dari {total}',
    'qj.errNeedHuman': '{n} baris confidence rendah — tandai ✓ atau perbaiki akun dulu.',
    'stmt.snackNeedHuman': '{n} baris masih perlu dicek (confidence rendah / tanpa akun).',
    'recon.rowDpHint': 'DP / uang muka — match ke kas masuk pending, jangan ke pendapatan',
    'recon.matchDpHint': 'Pasangan ini terkait DP. Cocokkan penerimaan kas ↔ uang muka pelanggan (2600).',
    'stmt.postPending': 'Antrian rekonsiliasi (pending)',
    'stmt.postCleared': 'Langsung masuk laporan (cleared)',
    'stx.needReview': 'Tandai dulu baris yang masih salah/ragu, atau uncentang sebelum masuk rekonsiliasi.',
    'stmt.reviewHint': 'Cek akun lawan · tandai ✓ benar / ✕ salah · tag DP/Prepaid sebelum simpan.',
    'stmt.tagDp': 'DP',
    'stmt.tagPrepaid': 'Prepaid',
    'stmt.tagAr': 'AR',
    'stmt.tagAp': 'AP',
    'stmt.markOk': 'Benar',
    'stmt.markWrong': 'Salah',
    'stmt.markUnsure': 'Ragu',
    'stmt.bulkOk': 'Tandai ✓ terpilih',
    'stmt.bulkWrong': 'Tandai ✕ terpilih',
    'stmt.snackNeedReview': '{n} baris ditandai salah — perbaiki akun, uncentang, atau tandai ✓ dulu.',
    'qj.errNeedReview': '{n} baris ditandai salah — perbaiki akun atau uncentang sebelum simpan.',

    'dash.expandByCompany': 'Perbesar Per Perusahaan',
    'dash.expandActivity': 'Perbesar Aktivitas',
    'dash.expandOmset': 'Perbesar Omset',
    'dash.expandBank': 'Perbesar Saldo Bank',
    'dash.expandInsight': 'Perbesar Analytics',

    'tax.hubTitle': 'Pusat Pajak',
    'tax.hubSub': 'PPh Final UMKM (PP 55/2022) per masa — hitung & posting jurnal otomatis',
    'tax.vatTitle': 'Rekap PPN',
    'tax.vatSub': 'Pantau PPN keluaran invoice vs PPN masukan vendor bill per masa.',
    'tax.vatOutput': 'PPN keluaran',
    'tax.vatInput': 'PPN masukan',
    'tax.vatNet': 'Net PPN',
    'tax.vatMonthly': 'Pergerakan bulanan',
    'tax.vatHint': 'Net positif = potensi kurang bayar, net negatif = kredit pajak / lebih bayar operasional.',
    'tax.vatGapFilter': '{n} masa belum lunas SSP',
    'tax.vatSspAmount': 'Setor SSP',
    'tax.vatSspStatus': 'Status SSP',
    'tax.vatNtpn': 'NTPN',
    'tax.vatAction': 'Aksi',
    'tax.vatDraftAll': 'Buat draft SSP PPN',
    'tax.vatDraftOne': 'Draft',
    'tax.vatOpenSsp': 'Buka SSP',
    'tax.vatNeedCompany': 'Pilih PT dulu untuk membuat draft SSP PPN',
    'tax.vatDrafted': '{n} draft SSP PPN dibuat',
    'tax.vatDraftSkipped': 'Tidak ada draft SSP baru yang perlu dibuat',
    'tax.vatExport': 'Export Excel',
    'tax.vatExportPdf': 'Export PDF',
    'tax.vatSalesDocs': 'Invoice',
    'tax.vatPurchaseDocs': 'Vendor bill',
    'tax.pph21Title': 'PPh 21 — kalkulator & upload',
    'tax.pph21ExportPdf': 'Export PDF',
    'tax.pph21Sub': 'Hitung estimasi PPh 21, lalu upload bukti potong / SPT Masa langsung ke sistem.',
    'tax.pph21Employee': 'Karyawan (opsional)',
    'tax.pph21EmployeeHint': 'Pilih dari master HR — status resign & masa kerja ikut tampil.',
    'tax.pph21Status': 'Status PTKP',
    'tax.pph21Base': 'Gaji pokok',
    'tax.pph21Allowance': 'Tunjangan',
    'tax.pph21Gross': 'Gross bulanan',
    'tax.pph21Annual': 'Gross tahunan',
    'tax.pph21Ptkp': 'PTKP',
    'tax.pph21TakeHome': 'Net setelah PPh 21',
    'tax.pph21MethodTitle': 'Ringkasan metode',
    'tax.pph21MethodNote': 'Kalkulator ini memakai formula tahunan sederhana yang saat ini dipakai di preview payroll sistem.',
    'tax.pph21MethodGross': 'Gross tahunan disetahunkan dari gross bulanan: {amount}',
    'tax.pph21MethodPtkp': 'PTKP untuk status {status}: {amount}',
    'tax.pph21MethodPkp': 'PKP estimasi setelah PTKP: {amount}',
    'tax.pph21UploadKicker': 'Masuk ke sistem',
    'tax.pph21UploadTitle': 'Upload bukti PPh 21',
    'tax.pph21UploadSub': 'PDF/CSV bukti potong, SPT Masa, atau e-billing — tersimpan di arsip dokumen pajak.',
    'tax.pph21UploadKind': 'Jenis berkas',
    'tax.pph21UploadFile': 'File PDF / CSV',
    'tax.pph21UploadTitleField': 'Judul (opsional)',
    'tax.pph21UploadBtn': 'Upload ke sistem',
    'tax.pph21UploadOk': 'Berkas PPh 21 tersimpan',
    'tax.pph21UploadArchive': 'Lihat arsip',
    'tax.pph21NeedFile': 'Pilih file dulu',
    'tax.pph21NeedCompany': 'Pilih PT sebelum upload',
    'tax.postAll': 'Posting semua masa',
    'tax.postAllShort': 'Posting semua',
    'tax.rate': 'Tarif PPh final',
    'tax.gross': 'Peredaran bruto',
    'tax.post': 'Posting',
    'tax.posted': 'Sudah',
    'tax.snackPosted': 'Jurnal pajak {ref} · {amount}',
    'tax.snackExists': 'Sudah ada {ref}',
    'tax.snackFail': 'Gagal posting',
    'tax.month': 'Masa',
    'tax.sptTitle': 'Paket SPT masa',
    'tax.sptOpen': 'Buka & cetak PDF',
    'tax.sptOpenShort': 'Cetak PDF',
    'tax.sptPx.kicker': 'Kelengkapan masa',
    'tax.sptPx.sub':
      'HTML siap cetak / PDF — checklist lampiran, PPh 23, payroll, SSP. NPWP PT wajib terisi.',
    'tax.sptPx.loadedAt': 'Dimuat {t}',
    'tax.sptPx.chipReady': 'Siap dibuka',
    'tax.sptPx.chipBlocked': 'NPWP / data wajib kurang',
    'tax.sptPx.bannerBlocked': 'Paket belum bisa dibuka — lengkapi NPWP & data wajib PT',
    'tax.sptPx.bannerGaps': '{n} item belum lengkap · kesiapan {pct}%',
    'tax.sptPx.bannerOk': 'Checklist lengkap — paket siap dicetak',
    'tax.sptPx.focusGapsShort': 'Lihat gap',
    'tax.sptPx.kpiReady': 'Kesiapan',
    'tax.sptPx.kpiReadyMeta': '{ok}/{total} item OK',
    'tax.sptPx.kpiGaps': 'Belum lengkap',
    'tax.sptPx.kpiGapsMeta': '{n} item wajib kurang',
    'tax.sptPx.kpiAttach': 'Lampiran',
    'tax.sptPx.kpiAttachMeta': 'PPh 23 + payroll + SSP',
    'tax.sptPx.kpiPph': 'PPh final masa',
    'tax.sptPx.notPosted': 'Belum posting',
    'tax.sptPx.vizReady': 'Kesiapan checklist',
    'tax.sptPx.vizAttach': 'Lampiran masa',
    'tax.sptPx.vizSnapshot': 'Snapshot paket',
    'tax.sptPx.vizAttachHint': 'PPh 23 {wht} · SSP {ssp}',
    'tax.sptPx.meterLabel': 'Progress kesiapan',
    'tax.sptPx.readyOk': 'Sudah OK',
    'tax.sptPx.readyGap': 'Belum',
    'tax.sptPx.attWht': 'Bukti potong',
    'tax.sptPx.attPayroll': 'Payroll',
    'tax.sptPx.attSsp': 'SSP',
    'tax.sptPx.attNtpn': 'NTPN',
    'tax.sptPx.npwpMissing': 'Belum diisi',
    'tax.sptPx.snapPph': 'Jurnal PPh final',
    'tax.sptPx.snapKpp': 'KPP',
    'tax.sptPx.healthTitle': 'Jalur kesiapan',
    'tax.sptPx.healthSub': 'Klik untuk filter checklist',
    'tax.sptPx.tipsTitle': 'Saran tindakan',
    'tax.sptPx.tipNpwp': 'Isi NPWP perusahaan sebelum membuka paket',
    'tax.sptPx.tipAddress': 'Lengkapi alamat PT di master perusahaan',
    'tax.sptPx.tipPph': 'Posting jurnal PPh final untuk masa ini',
    'tax.sptPx.tipSsp': 'Tambah kode billing / SSP untuk masa ini',
    'tax.sptPx.tipCal': 'Cek deadline di Kalender Pajak',
    'tax.sptPx.tipOk': 'Paket siap — buka & cetak PDF',
    'tax.sptPx.focusReady': 'Fokus: item sudah OK',
    'tax.sptPx.focusGaps': 'Fokus: item belum lengkap',
    'tax.sptPx.focusAttach': 'Fokus: lampiran masa',
    'tax.sptPx.clearFocus': 'Hapus fokus',
    'tax.sptPx.empty': 'Paket SPT belum dimuat',
    'tax.sptPx.emptyHint': 'Pilih PT / masa lalu muat ulang',
    'tax.sptPx.checkKicker': 'Checklist',
    'tax.sptPx.checkTitle': 'Kelengkapan lampiran',
    'tax.sptPx.checkSub': 'Wajib harus hijau sebelum paket dibuka',
    'tax.sptPx.statusOk': 'OK',
    'tax.sptPx.statusRequired': 'Wajib — belum',
    'tax.sptPx.statusOptional': 'Opsional — belum',
    'tax.sptPx.noChecks': 'Tidak ada item pada fokus ini',
    'tax.sptPx.actionKicker': 'Aksi',
    'tax.sptPx.actionTitle': 'Buka paket & perbaikan',
    'tax.sptPx.actionSub': 'Cetak HTML ke PDF (Ctrl+P). Bukan e-Filing resmi.',
    'tax.sptPx.openTaxHub': 'Pusat Pajak (PPh final)',
    'tax.sptPx.openTaxHubShort': 'Pusat Pajak',
    'tax.sptPx.refreshShort': 'Ulang',
    'tax.sptPx.calShort': 'Kalender',
    'tax.sptPx.whtShort': 'PPh 23',
    'tax.sptPx.sspShort': 'SSP',
    'tax.sptPx.statusRequiredShort': 'Wajib',
    'tax.sptPx.statusOptionalShort': 'Opsional',
    'tax.sptPx.blockedNpwp': 'NPWP belum lengkap — lengkapi di Perusahaan',
    'tax.sptPx.footerNote':
      'Paket untuk kelengkapan konsultan. Lengkapi SSP/NTPN setelah bayar pajak.',
    'tax.sptPx.check.npwp': 'Identitas PT & NPWP',
    'tax.sptPx.check.address': 'Alamat PT',
    'tax.sptPx.check.kpp': 'KPP terdaftar',
    'tax.sptPx.check.pph': 'Jurnal PPh Final masa',
    'tax.sptPx.check.wht': 'Bukti potong PPh 23 (jika ada)',
    'tax.sptPx.check.payroll': 'PPh 21 / payroll',
    'tax.sptPx.check.ssp': 'Kode billing / SSP',
    'tax.sptPx.check.ntpn': 'NTPN terisi (setelah bayar)',
    'tax.fillNpwp': 'Lengkapi NPWP di perusahaan',
    'tax.fillNpwpShort': 'Isi NPWP',
    'tax.fiscalTitle': 'Koreksi fiskal',
    'tax.fiscalAdd': 'Tambah aturan',
    'tax.fiscalAddShort': 'Tambah',
    'tax.fiscalSaved': 'Aturan disimpan — dipakai di LK',
    'tax.fiscPx.kicker': 'Aturan L/R fiskal',
    'tax.fiscPx.loadedAt': 'Dimuat {t}',
    'tax.fiscPx.ctxGlobal': 'Global (semua PT)',
    'tax.fiscPx.chipYear': 'LK {year}',
    'tax.fiscPx.chipInactive': '{n} nonaktif',
    'tax.fiscPx.chipOk': '{n} aktif',
    'tax.fiscPx.bannerInactive': '{n} aturan nonaktif — tidak dipakai di LK',
    'tax.fiscPx.bannerOk': '{n} aktif · {zero} zero-out di L/R fiskal',
    'tax.fiscPx.focusInactiveShort': 'Lihat nonaktif',
    'tax.fiscPx.kpiCount': 'Jumlah aturan',
    'tax.fiscPx.kpiCountMeta': 'Semua perlakuan',
    'tax.fiscPx.kpiActive': 'Aktif',
    'tax.fiscPx.kpiActiveMeta': '{n} nonaktif',
    'tax.fiscPx.kpiZeroOut': 'Zero-out',
    'tax.fiscPx.kpiZeroOutMeta': 'Fiskal = 0 di LK',
    'tax.fiscPx.kpiGaps': 'Perlu review',
    'tax.fiscPx.kpiGapsMeta': '{reason} tanpa dasar · {partial} parsial',
    'tax.fiscPx.vizTreatment': 'Perlakuan',
    'tax.fiscPx.vizActive': 'Status aktif',
    'tax.fiscPx.vizSnapshot': 'Snapshot dampak',
    'tax.fiscPx.snapZeroOut': 'Akun zero-out',
    'tax.fiscPx.snapMissingReason': 'Tanpa dasar/alasan',
    'tax.fiscPx.snapPartial': 'Koreksi parsial (%)',
    'tax.fiscPx.snapNone': 'Tanpa koreksi (none)',
    'tax.fiscPx.healthTitle': 'Jalur aturan',
    'tax.fiscPx.healthSub': 'Klik untuk filter daftar aturan',
    'tax.fiscPx.laneActive': 'Aktif',
    'tax.fiscPx.laneInactive': 'Nonaktif',
    'tax.fiscPx.tipsTitle': 'Saran tindakan',
    'tax.fiscPx.tipInactive': '{n} aturan nonaktif — aktifkan atau hapus',
    'tax.fiscPx.tipReason': '{n} tanpa dasar hukum / alasan',
    'tax.fiscPx.tipPartial': '{n} koreksi percent < 100%',
    'tax.fiscPx.tipLk': 'Cek dampak di Laporan Keuangan (kolom fiskal)',
    'tax.fiscPx.tipHub': 'Kembali ke Pusat Pajak',
    'tax.fiscPx.tipAdd': 'Tambah aturan untuk akun baru',
    'tax.fiscPx.tipOk': 'Aturan sehat — siap dipakai di LK',
    'tax.fiscPx.focusTreatment': 'Filter perlakuan: {s}',
    'tax.fiscPx.focusActive': 'Filter: aktif',
    'tax.fiscPx.focusInactive': 'Filter: nonaktif',
    'tax.fiscPx.focusSearch': 'Cari: “{q}”',
    'tax.fiscPx.clearFocus': 'Hapus fokus',
    'tax.fiscPx.empty': 'Belum ada aturan fiskal',
    'tax.fiscPx.emptyHint': 'Tambah aturan zero / percent / none untuk akun yang dikoreksi',
    'tax.fiscPx.tableKicker': 'Register',
    'tax.fiscPx.tableTitle': 'Aturan koreksi',
    'tax.fiscPx.tableSub': 'Menampilkan {shown} dari {total}',
    'tax.fiscPx.searchPh': 'Cari kode / akun / perlakuan / dasar…',
    'tax.fiscPx.noRows': 'Tidak ada baris cocok',
    'tax.fiscPx.action': 'Aksi',
    'tax.fiscPx.treatZero': 'Zero (penuh)',
    'tax.fiscPx.treatNone': 'None (tanpa koreksi)',
    'tax.fiscPx.treatPercent': 'Percent',
    'tax.fiscPx.noReason': 'Tanpa dasar',
    'tax.fiscPx.impactZero': 'Di LK: nilai fiskal akun ini = 0',
    'tax.fiscPx.impactNone': 'Di LK: ikut komersial (tanpa koreksi)',
    'tax.fiscPx.impactPercent': 'Di LK: koreksi {p}% dari saldo',
    'tax.fiscPx.impactInactive': 'Tidak dipakai sampai diaktifkan',
    'tax.fiscPx.previewLabel': 'Dampak di LK',
    'tax.fiscPx.needCode': 'Kode akun wajib diisi',
    'tax.fiscPx.deleted': 'Aturan dihapus',
    'tax.fiscPx.exportCsv': 'Ekspor CSV',
    'tax.fiscPx.exportCsvShort': 'CSV',
    'tax.fiscPx.refreshShort': 'Ulang',
    'tax.fiscPx.searchLabel': 'Cari',
    'tax.fiscPx.exportEmpty': 'Tidak ada baris untuk diekspor',
    'tax.fiscPx.footerNote':
      'Aturan global untuk semua PT. Treatment zero / percent ≥100% membuat akun zero-out di L/R fiskal.',
    'tax.whtTitle': 'PPh 23 / Bukti potong',
    'tax.whtSub': 'Register potongan pajak pihak ketiga',
    'tax.whtAdd': 'Tambah',
    'tax.whtVendor': 'Nama vendor',
    'tax.whtDpp': 'DPP',
    'tax.whtNo': 'No bukti potong',
    'tax.whtSaved': 'Bukti potong disimpan',
    'tax.whtPx.kicker': 'Register bukti potong',
    'tax.whtPx.loadedAt': 'Dimuat {t}',
    'tax.whtPx.chipDraft': '{n} draft',
    'tax.whtPx.chipOk': 'Tidak ada draft',
    'tax.whtPx.bannerDraft': '{n} bukti masih draft · {amount}',
    'tax.whtPx.bannerOk': '{n} bukti · total PPh 23 {amount}',
    'tax.whtPx.focusDraftShort': 'Lihat draft',
    'tax.whtPx.kpiCount': 'Jumlah bukti',
    'tax.whtPx.kpiCountMeta': 'Tahun {year}',
    'tax.whtPx.kpiDpp': 'Total DPP',
    'tax.whtPx.kpiDppMeta': 'Dasar pengenaan pajak',
    'tax.whtPx.kpiPphMeta': 'Jumlah potongan PPh 23',
    'tax.whtPx.kpiDraft': 'Draft',
    'tax.whtPx.kpiDraftMeta': '{amount} belum diterbitkan',
    'tax.whtPx.vizStatus': 'Status bukti',
    'tax.whtPx.vizMonth': 'PPh per bulan',
    'tax.whtPx.vizSnapshot': 'Snapshot register',
    'tax.whtPx.vizEmpty': 'Belum ada data bulanan',
    'tax.whtPx.monthCount': '{n} bukti',
    'tax.whtPx.snapMissingBukti': 'Tanpa no bukti',
    'tax.whtPx.snapMissingNpwp': 'Tanpa NPWP vendor',
    'tax.whtPx.snapAvgRate': 'Tarif efektif',
    'tax.whtPx.snapReported': 'Sudah dilaporkan',
    'tax.whtPx.healthTitle': 'Jalur status',
    'tax.whtPx.healthSub': 'Klik untuk filter daftar bukti',
    'tax.whtPx.tipsTitle': 'Saran tindakan',
    'tax.whtPx.tipDraft': '{n} bukti masih draft — lengkapi & terbitkan',
    'tax.whtPx.tipBukti': '{n} baris tanpa nomor bukti potong',
    'tax.whtPx.tipNpwp': '{n} vendor tanpa NPWP',
    'tax.whtPx.tipSpt': 'Masukkan ke Paket SPT masa saat siap e-Filing',
    'tax.whtPx.tipAdd': 'Catat bukti potong baru',
    'tax.whtPx.tipOk': 'Register sehat — tidak ada draft mendesak',
    'tax.whtPx.focusStatus': 'Filter status: {s}',
    'tax.whtPx.focusSearch': 'Cari: “{q}”',
    'tax.whtPx.clearFocus': 'Hapus fokus',
    'tax.whtPx.empty': 'Belum ada bukti potong',
    'tax.whtPx.emptyHint': 'Tambah PPh 23 untuk vendor di tahun ini',
    'tax.whtPx.tableKicker': 'Register',
    'tax.whtPx.tableTitle': 'Bukti potong {year}',
    'tax.whtPx.tableSub': 'Menampilkan {shown} dari {total}',
    'tax.whtPx.searchPh': 'Cari vendor / no bukti / NPWP…',
    'tax.whtPx.searchLabel': 'Cari',
    'tax.whtPx.noRows': 'Tidak ada baris cocok',
    'tax.whtPx.action': 'Aksi',
    'tax.whtPx.rateLabel': 'Tarif PPh 23',
    'tax.whtPx.statusDraft': 'Draft',
    'tax.whtPx.statusIssued': 'Diterbitkan',
    'tax.whtPx.statusReported': 'Dilaporkan',
    'tax.whtPx.noNpwp': 'NPWP kosong',
    'tax.whtPx.addTitle': 'Tambah bukti potong',
    'tax.whtPx.editTitle': 'Edit bukti potong',
    'tax.whtPx.needCompany': 'Pilih PT sebelum menyimpan',
    'tax.whtPx.deleted': 'Bukti potong dihapus',
    'tax.whtPx.exportCsv': 'Ekspor CSV',
    'tax.whtPx.exportCsvShort': 'CSV',
    'tax.whtPx.refreshShort': 'Ulang',
    'tax.whtPx.exportEmpty': 'Tidak ada baris untuk diekspor',
    'tax.whtPx.footerNote': 'Tarif default 2%. Status: draft → diterbitkan → dilaporkan di SPT masa.',
    'tax.sspTitle': 'e-Bupot / Pelacak billing SSP',
    'tax.sspSub': 'Dossier rinci satu-satu · billing PPN & PPh 23 · arsip e-bupot / SPT',
    'tax.sspAdd': 'Tambah',
    'tax.sspSaved': 'SSP disimpan',
    'tax.sspPx.kicker': 'e-Bupot · dossier',
    'tax.sspPx.loadedAt': 'Dimuat {t}',
    'tax.sspPx.chipOverdue': '{n} terlambat',
    'tax.sspPx.chipUnpaid': '{n} belum bayar',
    'tax.sspPx.chipOk': 'Semua lunas',
    'tax.sspPx.bannerOverdue': '{n} SSP terlambat · {amount}',
    'tax.sspPx.bannerUnpaid': '{n} belum lunas · {amount}',
    'tax.sspPx.bannerOk': '{n} billing · sudah dibayar {amount}',
    'tax.sspPx.focusOverdueShort': 'Lihat terlambat',
    'tax.sspPx.focusUnpaidShort': 'Lihat belum bayar',
    'tax.sspPx.kpiCount': 'Jumlah SSP',
    'tax.sspPx.kpiCountMeta': 'Tahun {year}',
    'tax.sspPx.kpiAmount': 'Total nominal',
    'tax.sspPx.kpiAmountMeta': 'Semua status',
    'tax.sspPx.kpiUnpaid': 'Belum bayar',
    'tax.sspPx.kpiUnpaidMeta': '{amount} outstanding',
    'tax.sspPx.kpiOverdue': 'Terlambat',
    'tax.sspPx.kpiOverdueMeta': '{amount} lewat jatuh tempo',
    'tax.sspPx.vizStatus': 'Status bayar',
    'tax.sspPx.vizType': 'Jenis pajak',
    'tax.sspPx.vizSnapshot': 'Snapshot kepatuhan',
    'tax.sspPx.vizMonth': 'Nominal per masa',
    'tax.sspPx.vizEmpty': 'Belum ada data jenis',
    'tax.sspPx.typeCount': '{n} billing',
    'tax.sspPx.snapMissingBilling': 'Tanpa kode billing',
    'tax.sspPx.snapMissingNtpn': 'Billing tanpa NTPN',
    'tax.sspPx.snapPaidPct': 'Persentase lunas',
    'tax.sspPx.snapDueSoon': 'Jatuh tempo ≤14 hari',
    'tax.sspPx.healthTitle': 'Jalur status',
    'tax.sspPx.healthSub': 'Klik untuk filter daftar SSP',
    'tax.sspPx.tipsTitle': 'Saran tindakan',
    'tax.sspPx.tipOverdue': '{n} terlambat · {amount} — bayar segera',
    'tax.sspPx.tipDueSoon': '{n} jatuh tempo dalam 14 hari',
    'tax.sspPx.tipBilling': '{n} belum punya kode billing',
    'tax.sspPx.tipNtpn': '{n} billing belum diisi NTPN',
    'tax.sspPx.tipCal': 'Cek deadline di Kalender Pajak',
    'tax.sspPx.tipSpt': 'Lampirkan NTPN ke Paket SPT masa',
    'tax.sspPx.tipAdd': 'Catat kode billing / SSP baru',
    'tax.sspPx.tipOk': 'Billing sehat — tidak ada yang terlambat',
    'tax.sspPx.focusStatus': 'Filter status: {s}',
    'tax.sspPx.focusType': 'Filter jenis: {t}',
    'tax.sspPx.focusSearch': 'Cari: “{q}”',
    'tax.sspPx.clearFocus': 'Hapus fokus',
    'tax.sspPx.empty': 'Belum ada billing SSP',
    'tax.sspPx.emptyHint': 'Tambah kode billing, jatuh tempo, dan NTPN untuk tahun ini',
    'tax.sspPx.tableKicker': 'Register',
    'tax.sspPx.tableTitle': 'Billing SSP {year}',
    'tax.sspPx.tableSub': 'Menampilkan {shown} dari {total}',
    'tax.sspPx.searchPh': 'Cari masa / billing / NTPN / jenis…',
    'tax.sspPx.noRows': 'Tidak ada baris cocok',
    'tax.sspPx.action': 'Aksi',
    'tax.sspPx.statusOpen': 'Belum billing',
    'tax.sspPx.statusBilled': 'Sudah billing',
    'tax.sspPx.statusPaid': 'Lunas',
    'tax.sspPx.statusOverdue': 'Terlambat',
    'tax.sspPx.noBilling': 'Belum ada',
    'tax.sspPx.noNtpn': 'Belum ada',
    'tax.sspPx.paidAt': 'Bayar {d}',
    'tax.sspPx.paidDate': 'Tanggal bayar',
    'tax.sspPx.addTitle': 'Tambah billing SSP',
    'tax.sspPx.editTitle': 'Edit billing SSP',
    'tax.sspPx.needCompany': 'Pilih PT sebelum menyimpan',
    'tax.sspPx.needFile': 'Pilih file PDF/CSV dulu',
    'tax.sspPx.gapsKicker': '7 sumber prioritas',
    'tax.sspPx.gapsTitle': 'Sumber statement yang masih bolong',
    'tax.sspPx.gapsSub': 'Cek coverage Jan–Jul {year}. Upload ulang via E-Statement jika kosong.',
    'tax.sspPx.gapsMissing': 'Kurang: {months}',
    'tax.sspPx.gapsOk': 'Sudah ada di GL',
    'tax.sspPx.gapsHint': '{n} sumber masih bolong — prioritaskan upload e-statement.',
    'tax.sspPx.uploadKicker': 'Arsip pajak',
    'tax.sspPx.uploadTitle': 'Upload e-billing / e-bupot / SPT',
    'tax.sspPx.uploadSub': 'Khusus PPN & PPh 23 — file masuk ke arsip dokumen pajak.',
    'tax.sspPx.vaultKicker': 'Brankas e-Bupot',
    'tax.sspPx.vaultTitle': 'Upload bukti potong / e-billing / SPT',
    'tax.sspPx.vaultSub': '{n} berkas tahun ini di arsip — unggah PDF/CSV lalu hubungkan ke masa.',
    'tax.sspPx.uploadKind': 'Jenis berkas',
    'tax.sspPx.uploadFile': 'File PDF / CSV',
    'tax.sspPx.uploadBtn': 'Upload',
    'tax.sspPx.uploadOk': 'Berkas pajak tersimpan',
    'tax.sspPx.uploadArchive': 'Lihat arsip',
    'tax.sspPx.uploadDialogHint': 'Opsional: lampirkan saat simpan billing PPN / PPh 23',
    'tax.sspPx.viewDossier': 'Rinci',
    'tax.sspPx.viewTable': 'Tabel',
    'tax.sspPx.timelineKicker': 'Coverage masa',
    'tax.sspPx.timelineTitle': 'Timeline e-Bupot & SSP',
    'tax.sspPx.timelineSub': 'Klik bulan untuk filter · kelengkapan rata-rata {pct}% · {year}',
    'tax.sspPx.timelineTip': 'Masa {m}: {n} billing · {docs} berkas · {amount}',
    'tax.sspPx.completenessShort': 'Lengkap',
    'tax.sspPx.completenessAvg': 'Rata-rata kelengkapan {pct}%',
    'tax.sspPx.completenessOf': '{done}/{total} langkah',
    'tax.sspPx.stepAmount': 'Nominal',
    'tax.sspPx.stepBilling': 'Billing',
    'tax.sspPx.stepDue': 'Jatuh tempo',
    'tax.sspPx.stepNtpn': 'NTPN/Lunas',
    'tax.sspPx.stepDoc': 'Berkas',
    'tax.sspPx.markPaid': 'Tandai lunas',
    'tax.sspPx.markedPaid': 'Ditandai lunas',
    'tax.sspPx.attachDoc': 'Lampirkan berkas',
    'tax.sspPx.attachedDocs': '{n} berkas terlampir',
    'tax.sspPx.noAttachedDoc': 'Belum ada e-bupot / e-billing terlampir untuk masa ini.',
    'tax.sspPx.copiedBilling': 'Kode billing disalin',
    'tax.sspPx.copiedNtpn': 'NTPN disalin',
    'tax.sspPx.draftWht': 'Dari bukti potong',
    'tax.sspPx.draftWhtShort': 'Dari potong',
    'tax.sspPx.draftWhtOk': '{n} draft SSP dibuat dari {wht} bukti potong ({skip} dilewati)',
    'tax.sspPx.draftWhtSkip': 'Semua masa sudah punya SSP ({skip} dilewati · {wht} bukti potong)',
    'tax.sspPx.draftWhtEmpty': 'Belum ada bukti potong tahun ini untuk digenerate',
    'tax.sspPx.chipDueOverdue': '{n} terlambat',
    'tax.sspPx.chipDueH1': '{n} H−1',
    'tax.sspPx.chipDueH3': '{n} H−3',
    'tax.sspPx.focusDueH1': 'Filter: jatuh tempo H−1',
    'tax.sspPx.focusDueH3': 'Filter: jatuh tempo ≤3 hari',
    'tax.sspPx.tipDueH1': '{n} jatuh tempo besok / hari ini · {amount}',
    'tax.sspPx.tipDueH3': '{n} jatuh tempo ≤3 hari · {amount}',
    'tax.sspPx.urgOverdue': 'Terlambat',
    'tax.sspPx.urgH1': 'H−1',
    'tax.sspPx.urgH3': 'H−3',
    'tax.sspPx.urgSoon': '≤14h',
    'tax.sspPx.coreTitle': 'Checklist Coretax',
    'tax.sspPx.corePct': '{done}/{total} · {pct}%',
    'tax.sspPx.core.bupot': 'e-Bupot / bukti potong',
    'tax.sspPx.core.billing': 'Kode billing e-Billing',
    'tax.sspPx.core.pay': 'Setor / bayar',
    'tax.sspPx.core.ntpn': 'Isi NTPN',
    'tax.sspPx.core.spt': 'Lampirkan ke SPT masa',
    'tax.sspPx.coreTodo': 'Belum',
    'tax.sspPx.coreDone': 'Selesai',
    'tax.sspPx.coreBupotMeta': '{n} bukti potong terhubung',
    'tax.sspPx.openWht': 'Buka bukti potong',
    'tax.sspPx.openCalendar': 'Kalender pajak',
    'tax.sspPx.openSpt': 'Paket SPT masa',
    'tax.sspPx.whtLinked': '{n} bukti potong masa ini',
    'tax.sspPx.deleted': 'SSP dihapus',
    'tax.sspPx.exportCsv': 'Ekspor CSV',
    'tax.sspPx.exportCsvShort': 'CSV',
    'tax.sspPx.refreshShort': 'Ulang',
    'tax.sspPx.searchLabel': 'Cari',
    'tax.sspPx.exportEmpty': 'Tidak ada baris untuk diekspor',
    'tax.sspPx.previewLabel': 'Nominal SSP',
    'tax.sspPx.monthLabel': 'Bulan {m}',
    'tax.sspPx.footerNote':
      'Status efektif: lewat jatuh tempo tanpa bayar = terlambat. Isi NTPN setelah bayar di DJP Online.',
    'tax.type.final': 'PPh final UMKM',
    'tax.type.pph21': 'PPh 21',
    'tax.type.pph23': 'PPh 23',
    'tax.type.pph25': 'PPh 25',
    'tax.type.ppn': 'PPN',
    'tax.type.other': 'Lainnya',
    'tax.postingHint':
      'Posting membuat jurnal: Dr Pajak PPh Final (5009) / Cr Hutang Pajak PPh Final (2303). Duplikat masa yang sama akan di-skip (ref unik). Detail SPT ada juga di halaman Laporan Keuangan.',
    'tax.journalRef': 'Ref Jurnal',
    'tax.action': 'Aksi',
    'tax.openLkSpt': 'Buka Laporan Keuangan (tab SPT)',
    'tax.px.kicker': 'Kepatuhan pajak',
    'tax.px.loadedAt': 'Dimuat {t}',
    'tax.px.chipPending': '{n} masa menunggu posting',
    'tax.px.chipDone': 'Semua masa terposting',
    'tax.px.chipNeedPost': 'Perlu posting',
    'tax.px.bannerPending': '{n} masa belum diposting · {amount}',
    'tax.px.bannerOk': 'Semua masa beromset sudah punya jurnal PPh final',
    'tax.px.focusPendingShort': 'Lihat pending',
    'tax.px.kpiBruto': 'Peredaran bruto {year}',
    'tax.px.kpiBrutoMeta': '{n} masa beromset',
    'tax.px.kpiPph': 'PPh final UMKM {year}',
    'tax.px.kpiPphMeta': 'Tarif × peredaran bruto',
    'tax.px.kpiRateMeta': 'PP 55/2022 (UMKM)',
    'tax.px.kpiProgress': 'Progress posting',
    'tax.px.kpiProgressMeta': '{pct}% masa berpajak sudah diposting',
    'tax.px.vizMonthly': 'PPh per masa',
    'tax.px.vizStatus': 'Status posting',
    'tax.px.vizSnapshot': 'Snapshot tahun',
    'tax.px.meterLabel': 'Progress posting',
    'tax.px.snapPending': 'Masa pending',
    'tax.px.statusPosted': 'Sudah posting',
    'tax.px.statusPending': 'Menunggu posting',
    'tax.px.statusZero': 'Tanpa omset',
    'tax.px.healthTitle': 'Jalur masa pajak',
    'tax.px.healthSub': 'Klik untuk filter tabel bulanan',
    'tax.px.tipsTitle': 'Saran tindakan',
    'tax.px.tipPending': '{n} masa pending · {amount} — posting jurnal PPh final',
    'tax.px.tipUnearned': 'Uang muka {amount} — pantau agar tidak menggelembungkan omset',
    'tax.px.tipSpt': 'Siapkan paket SPT masa untuk e-Filing',
    'tax.px.tipLk': 'Buka tab SPT di laporan keuangan formal',
    'tax.px.tipSsp': 'Catat kode billing / NTPN di pelacak SSP',
    'tax.px.tipOk': 'PPh final tahun ini terkendali — semua masa terposting',
    'tax.px.focusPending': 'Filter: masa menunggu posting',
    'tax.px.focusPosted': 'Filter: masa sudah diposting',
    'tax.px.focusZero': 'Filter: masa tanpa omset',
    'tax.px.focusRate': 'Fokus: tarif PPh final',
    'tax.px.focusBruto': 'Fokus: peredaran bruto',
    'tax.px.focusPph': 'Fokus: PPh final',
    'tax.px.focusProgress': 'Fokus: progress posting',
    'tax.px.clearFocus': 'Hapus fokus',
    'tax.px.empty': 'Data pajak belum dimuat',
    'tax.px.emptyHint': 'Pilih PT / tahun lalu muat ulang',
    'tax.px.tableKicker': 'Bulanan',
    'tax.px.tableTitle': 'PPh final UMKM {year}',
    'tax.px.tableSub': 'Menampilkan {shown} dari {total} masa',
    'tax.px.noRows': 'Tidak ada masa cocok',
    'tax.px.footPosted': '{n}/{total} masa berpajak terposting',
    'tax.px.footerNote': 'Posting membuat Dr 5009 / Cr 2303. Duplikat masa di-skip (ref unik).',
    'tax.snap.kicker': 'Modul pajak',
    'tax.snap.title': 'Snapshot Kepatuhan',
    'tax.snap.sub': 'Ringkasan silang PPh final, PPN, SSP, dan bukti potong · klik kartu untuk detail',
    'tax.snap.pphFinal': 'PPh final UMKM',
    'tax.snap.pphPending': '{n} masa pending · {amount}',
    'tax.snap.pphDone': '{pct}% masa terposting',
    'tax.snap.vatNet': 'Net PPN',
    'tax.snap.vatSspGap': '{n} masa net positif belum lunas SSP',
    'tax.snap.vatOk': 'SSP PPN terpantau',
    'tax.snap.sspOpen': 'SSP belum lunas',
    'tax.snap.sspOverdue': '{n} overdue · {amount}',
    'tax.snap.sspOk': 'Semua SSP lunas',
    'tax.snap.withholdings': 'Bukti potong',
    'tax.snap.withholdingsHint': '{n} bukti · DPP {dpp}',
    'tax.fiscalSub': 'Aturan editable — langsung mempengaruhi L/R fiskal di Laporan Keuangan',
    'tax.fiscalTreatmentHint':
      'Treatment zero = koreksi penuh (fiskal = 0 untuk akun tersebut). Konsultasikan sebelum e-Filing.',
    'tax.colTreatment': 'Perlakuan',
    'tax.colPercent': '%',
    'tax.colBasis': 'Dasar',
    'tax.colActive': 'Aktif',
    'tax.confirmDeleteRule': 'Hapus aturan?',
    'tax.addRule': 'Tambah aturan',
    'tax.editRule': 'Edit aturan',
    'tax.accountCode': 'Kode akun',
    'tax.accountName': 'Nama akun',
    'tax.treatment': 'Treatment',
    'tax.percentIf': 'Percent (jika percent)',
    'tax.reason': 'Alasan',
    'tax.openLk': 'Buka LK',
    'tax.colType': 'Jenis',
    'tax.billing': 'Billing',
    'tax.dueDate': 'Jatuh tempo',
    'tax.taxType': 'Jenis pajak',
    'tax.billingCode': 'Kode billing',
    'tax.vendorNpwp': 'NPWP vendor',

    'dl.title': 'Download Laporan',
    'dl.sub': 'Unduh laporan profesional (Excel & PDF) — pilih laporan, atur periode, pratinjau, lalu unduh',
    'dl.kicker': 'Ekspor profesional',
    'dl.guide.heroSub':
      'Alur singkat: pilih PT & periode (default bulan kemarin) → katalog terbuka → unduh.',
    'dl.guide.bannerTitle': 'Siapkan filter unduhan',
    'dl.guide.bannerSub': 'Default periode = bulan kemarin. Pilih PT, lalu unduh laporan.',
    'dl.guide.bannerSeal': 'Siap unduh',
    'dl.guide.bannerCta': 'Ke filter',
    'dl.guide.catalogOpen': 'Katalog terbuka',
    'dl.guide.stepShort1': 'PT & periode',
    'dl.guide.stepShort2': 'Buka kunci',
    'dl.guide.stepShort3': 'Laporan',
    'dl.guide.intentTag': 'Paket',
    'dl.guide.intentSelected': 'Aktif',
    'dl.guide.intentPick': 'Buka paket',
    'dl.guide.ctxHint': 'Default periode = bulan kemarin. Ganti PT/tanggal kapan saja — katalog tetap terbuka.',
    'dl.guide.check1': 'Pilih PT & periode (default bulan kemarin)',
    'dl.guide.check2': 'Buka kunci katalog',
    'dl.guide.check3': 'Pilih laporan lalu unduh',
    'dl.guide.aria': 'Panduan unduh laporan',
    'dl.guide.kicker': 'Katalog unduhan',
    'dl.guide.step1': '1 · PT & periode',
    'dl.guide.step2': '2 · Buka kunci',
    'dl.guide.step3': '3 · Pilih laporan',
    'dl.guide.titleLocked': 'Semua laporan terkunci',
    'dl.guide.titleOpen': 'Pilih paket, lalu unduh',
    'dl.guide.subLocked':
      'Pilih PT dan periode di filter atas. Default sudah bulan kemarin — katalog terbuka otomatis setelah filter valid.',
    'dl.guide.subOpen':
      'Satu paket = filter katalog. Pilih yang paling dekat dengan kebutuhanmu.',
    'dl.guide.pickIntent': 'Saring katalog (opsional)',
    'dl.guide.searchIntent': 'Cari paket (nama, tag, deskripsi)…',
    'dl.guide.intentCount': '{shown} / {total} paket',
    'dl.guide.intentReports': 'laporan',
    'dl.guide.searchEmptyTitle': 'Paket tidak ditemukan',
    'dl.guide.searchEmptySub': 'Coba kata kunci lain atau bersihkan pencarian.',
    'dl.guide.searchClear': 'Bersihkan pencarian',
    'dl.guide.pagerAria': 'Halaman paket tujuan',
    'dl.guide.pagerPrev': 'Halaman sebelumnya',
    'dl.guide.pagerNext': 'Halaman berikutnya',
    'dl.guide.intent.lk': 'Paket LK & buku',
    'dl.guide.intent.lkDesc': 'LK, laba rugi, neraca, NS, buku besar',
    'dl.guide.intent.lkHint': 'Cocok untuk closing bulanan & review manajemen',
    'dl.guide.intent.bank': 'Bank & e-statement',
    'dl.guide.intent.bankDesc': 'Bank/kas, rekening koran, arus kas',
    'dl.guide.intent.bankHint': 'Rekonsiliasi bank dan posisi kas harian',
    'dl.guide.intent.tax': 'Pajak & operasional',
    'dl.guide.intent.taxDesc': 'SPT/PPh Final, kasbon, antar PT',
    'dl.guide.intent.taxHint': 'Operasional pajak & transaksi antar perusahaan',
    'dl.guide.intent.classify': 'Klasifikasi akun',
    'dl.guide.intent.classifyDesc': 'Aset, utang, piutang, HPP, stok',
    'dl.guide.intent.classifyHint': 'Breakdown akun untuk analisis struktur neraca',
    'dl.guide.intent.audit': 'Audit & analisis',
    'dl.guide.intent.auditDesc': 'Akrual vs kas, kualitas data',
    'dl.guide.intent.auditHint': 'Cek konsistensi dan kualitas pencatatan',
    'dl.guide.intent.all': 'Jelajah semua',
    'dl.guide.intent.allDesc': 'Buka kunci 27 laporan sekaligus',
    'dl.guide.intent.allHint': 'Akses penuh katalog tanpa filter paket',
    'dl.guide.ctxTitle': 'Konfirmasi filter aktif',
    'dl.guide.unlockBtn': 'Buka kunci katalog',
    'dl.guide.editCtx': 'Ubah filter dulu',
    'dl.guide.reset': 'Ulangi tujuan',
    'dl.guide.lockChip': 'Terkunci',
    'dl.guide.cardLockedDesc': 'Menunggu buka kunci katalog',
    'dl.guide.relock': 'Kunci lagi',
    'dl.guide.needIntent': 'Pilih PT & periode di filter atas dulu',
    'dl.guide.needDates': 'Isi tanggal Dari & Sampai di filter atas dulu',
    'dl.guide.badDates': 'Tanggal Dari tidak boleh setelah Sampai',
    'dl.guide.lockedHint': 'Laporan terkunci — pilih PT & periode, lalu buka kunci katalog',
    'dl.guide.contextOk': 'Katalog dibuka — pilih laporan di kiri',
    'dl.guide.catalogLocked': 'Terkunci',
    'dl.guide.gateBadge': 'Akses terbatas',
    'dl.guide.gateTitle1': '27 laporan terkunci',
    'dl.guide.gateTitle2': 'PT & periode siap — buka kunci',
    'dl.guide.gateSub1':
      'Atur PT dan periode di filter atas (default bulan kemarin). Setelah valid, katalog terbuka otomatis atau klik Buka kunci.',
    'dl.guide.gateSub2':
      'Filter PT & periode sudah siap. Katalog akan terbuka otomatis — atau klik Buka kunci di bawah.',
    'dl.guide.gateHint': 'Default periode = bulan kemarin · pilih PT di filter atas',
    'dl.pickReport': 'Pilih laporan',
    'dl.group.core': '01 · Laporan inti',
    'dl.group.classify': '02 · Klasifikasi akun',
    'dl.group.ops': '03 · Operasional & pajak',
    'dl.group.extra': '04 · Analisis & audit',
    'dl.searchReportPlaceholder': 'Cari laporan (nama, deskripsi, kategori)',
    'dl.searchReportCount': '{shown} dari {total} laporan',
    'dl.searchNoReport': 'Tidak ada laporan yang cocok dengan kata kunci',
    'dl.searchTablePlaceholder': 'Cari di tabel pratinjau (akun, memo, kode, ID Ref)',
    'dl.searchNoRows': 'Data tidak ditemukan untuk kata kunci ini',
    'dl.filterAll': 'Semua',
    'dl.filterReady': 'Siap Unduh',
    'dl.filterAction': 'Perlu Aksi',
    'dl.filterFavorite': 'Favorit ({n})',
    'dl.pinFavorite': 'Pin favorit',
    'dl.unpinFavorite': 'Lepas favorit',
    'dl.favEmptyEdit': 'Tekan ikon pin di laporan di bawah untuk menambah',
    'dl.resetSort': 'Reset urutan',
    'dl.preview': 'Pratinjau',
    'dl.downloadExcel': 'Unduh Excel',
    'dl.downloadPdf': 'Unduh PDF',
    'dl.exportBtn': 'Export',
    'dl.exportTitle': 'Unduh laporan',
    'dl.exportFormat': 'Format file',
    'dl.exportHint': 'Konfirmasi PT, pilih format, lalu Muat filter & Download.',
    'dl.downloadNow': 'Download Now',
    'dl.loadAndDownload': 'Muat filter & Download',
    'dl.ptAll': 'Semua PT (All)',
    'dl.ptAllShort': 'Semua PT',
    'dl.ptActiveHint': 'Filter aktif: {pt}',
    'dl.ptConfirm': 'Konfirmasi PT unduhan',
    'dl.ptConfirmHint': 'Pastikan PT benar. Sistem akan memuat ulang filter dulu, baru mengunduh — agar data tidak tertukar.',
    'dl.exportTarget': 'Akan unduh · {pt}',
    'dl.snackDownloadReady': 'Laporan siap · {format}',
    'dl.downloading': 'Menyiapkan Excel…',
    'dl.downloadingPdf': 'Menyiapkan PDF…',
    'dl.snackOk': 'Excel berhasil diunduh',
    'dl.snackOkPdf': 'PDF berhasil diunduh',
    'dl.snackFail': 'Gagal mengunduh Excel',
    'dl.snackFailPdf': 'Gagal mengunduh PDF',
    'dl.expand': 'Perbesar pratinjau',
    'dl.expandShort': 'Perbesar',
    'dl.collapse': 'Kecilkan',
    'dl.expandHint': 'Geser horizontal/vertikal untuk melihat semua kolom & baris',
    'dl.ready': 'Siap unduh',
    'dl.emptyShort': 'X Kosong',
    'dl.needPt': 'Pilih PT',
    'dl.statusCheck': 'Cek…',
    'dl.statusUnknown': '—',
    'dl.needCompanyTitle': 'Pilih perusahaan',
    'dl.needCompany': 'Laporan LK membutuhkan PT spesifik (JGI atau JGT) agar neraca & laba rugi tidak tercampur.',
    'dl.soon': 'Berikutnya',
    'dl.step': '27 laporan siap',
    'dl.allReady': 'Semua siap',
    'dl.reportsReady': 'Laporan siap',
    'dl.statReady': 'Siap unduh',
    'dl.statTotal': 'Total laporan',
    'dl.statNeedPt': 'Perlu PT',
    'dl.statLiveFilter': 'Ikuti filter aktif',
    'dl.empty': 'Belum ada data untuk periode ini',
    'dl.emptyHint': 'Sesuaikan PT/periode, atau ikuti Konteks Kerja di atas.',
    'dl.emptySearchHint': 'Hapus kata kunci pencarian tabel, atau ganti filter.',
    'dl.clearTableSearch': 'Hapus pencarian tabel',
    'dl.followedCtx': 'Filter unduhan mengikuti Konteks Kerja',
    'dl.vizReady': 'Kesiapan unduhan',
    'dl.vizReadySub': 'siap',
    'dl.vizReadyHint': '{ready}/{known} laporan siap unduh pada filter ini',
    'dl.vizGroups': 'Siap per grup',
    'dl.vizActions': 'Aksi cepat',
    'dl.vizFollowCtx': 'Samakan dengan Konteks Kerja',
    'dl.vizShowAction': 'Tampilkan perlu aksi ({n})',
    'dl.vizOpenLk': 'Buka paket LK',
    'dl.vizManageFav': 'Kelola favorit',
    'dl.healthTitle': 'Filter katalog',
    'dl.healthSub': 'Klik chip untuk menyaring daftar laporan',
    'dl.tipsTitle': 'Saran unduhan',
    'dl.tipAllReady': 'Semua laporan terisi untuk filter ini — siap ekspor',
    'dl.tipNeedPt': '{n} laporan butuh PT spesifik — pilih JGI/JGT',
    'dl.tipEmpty': '{n} laporan kosong di periode ini — cek filter atau data jurnal',
    'dl.tipFollow': 'Konteks Kerja beda dari filter unduhan — klik untuk menyamakan',
    'dl.tipFav': 'Pin laporan favorit agar cepat diakses',
    'dl.tipLk': 'Paket LK cocok untuk review konsultan / KAP',
    'dl.tipLedger': 'Buku besar setelah rekonsiliasi = practice pack utama',
    'dl.loaded': '{n} akun · unduh tanggal {date}',
    'dl.loadedRows': '{n} baris · unduh {date}',
    'dl.snackSoon': 'Laporan ini menyusul',
    'dl.showIdRef': 'Tampilkan ID Ref',
    'dl.hideIdRef': 'Sembunyikan ID Ref',
    'dl.pickCompany': 'Pilih PT',
    'dl.detailKicker': 'Rincian baris',
    'dl.detailDay': 'Tanggal',
    'dl.detailMonth': 'Bulan',
    'dl.detailYear': 'Tahun',
    'dl.detailInputTime': 'Jam input',
    'dl.detailPeriod': 'Periode filter',
    'dl.detailFullStamp': 'Stempel waktu',
    'dl.detailJournal': 'Jurnal terkait',
    'dl.detailSource': 'Sumber',
    'dl.detailMemo': 'Memo',
    'dl.detailFields': 'Data baris',
    'dl.colOpening': 'Saldo awal',
    'dl.colClosing': 'Saldo akhir',
    'dl.colType': 'Tipe',
    'dl.colNormal': 'Normal',
    'dl.ledger.title': 'Buku Besar Setelah Rekonsiliasi',
    'dl.ledger.desc':
      'General ledger setelah rekonsiliasi: rollforward · mutasi ID Ref · jurnal AJ · klasifikasi — practice pack konsultan/KAP',
    'dl.ledger.tip':
      'Excel: Cover · Metodologi · Ringkasan · Rollforward (Ops+AJ) · Mutasi · Jurnal Rekonsiliasi · Klasifikasi · Pengesahan. Unduh setelah NS setelah rekonsiliasi.',
    'dl.ledgerUna.title': 'Buku Besar Sebelum Rekonsiliasi',
    'dl.ledgerUna.desc':
      'General ledger tanpa jurnal rekonsiliasi/penyesuaian — rollforward & mutasi ID Ref sebelum AJ',
    'dl.ledgerUna.tip':
      'Gunakan bersama NS sebelum rekonsiliasi. Setelah AJ, unduh Buku Besar Setelah Rekonsiliasi.',
    'dl.sheetTabs': 'Lembar laporan',
    'dl.sheetMain': 'Rollforward',
    'dl.notesTitle': 'Catatan lingkup & kebijakan',
    'dl.lk.title': 'LK / Laporan Keuangan',
    'dl.lk.desc':
      'Laporan keuangan sederhana: Laba Rugi, Neraca (komparatif), Perubahan Ekuitas, Arus Kas, Catatan, dan SPT Masa',
    'dl.lk.tip':
      'Susunan seperti LK UMKM/manajemen umum — multi-sheet untuk review konsultan pajak & KAP. Bukan opini audit.',
    'dl.tb.title': 'Neraca Saldo Setelah Rekonsiliasi',
    'dl.tb.desc':
      'Saldo akun termasuk jurnal rekonsiliasi/penyesuaian — uji debit = kredit sebelum LK final',
    'dl.tb.tip':
      'Urutan siklus: NS sebelum rekonsiliasi → jurnal AJ → NS ini → LK. Selisih? perbaiki di Jurnal dulu.',
    'dl.tbUna.title': 'Neraca Saldo Sebelum Rekonsiliasi',
    'dl.tbUna.desc':
      'Saldo akun tanpa jurnal rekonsiliasi (akrual, penyusutan, prepaid) — langkah awal tutup buku',
    'dl.tbUna.tip':
      'Gunakan sebelum membuat jurnal rekonsiliasi. Setelah AJ, unduh Neraca Saldo Setelah Rekonsiliasi.',
    'dl.is.title': 'Laporan Laba Rugi',
    'dl.is.desc':
      'Format laporan keuangan: Pendapatan − HPP → Laba Kotor − Beban Operasional → Laba Operasional − Pajak/PPN → Laba Bersih',
    'dl.is.tip':
      'Susunan berjenjang siap review KAP. Beban pajak/PPN dipotong setelah laba operasional. Margin detail ada di Laba Bersih.',
    'dl.bs.title': 'Neraca',
    'dl.bs.desc':
      'Laporan posisi keuangan sederhana: Aktiva Lancar/Tidak Lancar, Liabilitas, dan Ekuitas (termasuk laba berjalan)',
    'dl.bs.tip':
      'Susunan seperti neraca di PDF laporan keuangan. Pastikan Aset = Kewajiban + Ekuitas sebelum ke KAP.',
    'dl.cf.title': 'Laporan Arus Kas',
    'dl.cf.desc': 'Arus kas masuk/keluar akun kas-bank + posisi kas akhir — rekonsiliasi operasional',
    'dl.cf.tip': 'Metode langsung berbasis 11xx. Bandingkan dengan Akrual vs Kas untuk analisis gap.',
    'dl.np.title': 'Laba Bersih & Margin',
    'dl.np.desc':
      'Laba bersih = Penghasilan − HPP − Beban operasional · margin per PT (tanpa lapisan pajak di sini)',
    'dl.np.tip':
      'Fokus efisiensi operasional & banding margin antar PT. Hasil setelah pajak ada di Laporan Laba Rugi.',
    'dl.accrual.title': 'Akrual vs Kas',
    'dl.accrual.desc':
      'Gap laba akrual vs arus kas netto — analisis konsultan (bukan daftar akun akrual saja)',
    'dl.accrual.tip':
      'Selisih material sering dari piutang, utang, DP/uang muka. Investigasi sebelum review keuangan.',
    'dl.double.title': 'Pembukuan Berpasangan',
    'dl.double.desc': 'Digabung ke Jurnal + Kontrol Berpasangan',
    'dl.journal.title': 'Jurnal + Kontrol Berpasangan',
    'dl.journal.desc':
      'Baris jurnal double-entry + kontrol debit=kredit per ID Ref (menggabungkan Pembukuan Berpasangan)',
    'dl.journal.tip':
      'Fokuskan lampiran Kontrol Berpasangan yang “Tidak seimbang” sebelum audit. Klik ID Ref untuk jejak.',
    'dl.assets.title': 'Laporan Aset',
    'dl.assets.desc':
      'Semua inventory & aset kantor yang sudah masuk nomor akun (kas, bank, piutang, persediaan, aktiva tetap)',
    'dl.assets.tip':
      'Filter semua akun tipe aset di CoA. Termasuk kas/bank 11xx, piutang 12xx, persediaan 13xx, aktiva tetap 15xx.',
    'dl.liabilities.title': 'Laporan Liabilitas',
    'dl.liabilities.desc': 'Utang atau kewajiban keuangan perusahaan kepada pihak lain',
    'dl.liabilities.tip':
      'Semua akun tipe liabilitas — utang usaha, reimburse, dan utang pajak.',
    'dl.equity.title': 'Laporan Ekuitas',
    'dl.equity.desc': 'Hak pemilik atas aset perusahaan setelah dikurangi kewajiban',
    'dl.equity.tip':
      'Modal pemilik, mutasi owner, dan laba ditahan — kekayaan bersih perusahaan.',
    'dl.revenue.title': 'Laporan Pendapatan',
    'dl.revenue.desc': 'Total penghasilan dari penjualan barang atau jasa',
    'dl.revenue.tip':
      'Akun revenue (41xx/42xx). Ini dasar hitung omset & PPh Final.',
    'dl.expense.title': 'Laporan Beban',
    'dl.expense.desc': 'Biaya yang dikeluarkan untuk menjalankan operasional bisnis (tanpa HPP)',
    'dl.expense.tip':
      'Beban operasional 52xx/53xx — HPP 51xx dipisah di Laporan HPP.',
    'dl.ar.title': 'Laporan Piutang Usaha',
    'dl.ar.desc': 'Uang yang terutang kepada bisnis oleh pelanggan untuk penjualan kredit',
    'dl.ar.tip':
      'Akun 12xx / nama “piutang”. Kosong = belum ada mutasi piutang di periode ini.',
    'dl.ap.title': 'Laporan Utang Usaha',
    'dl.ap.desc': 'Uang yang terutang oleh bisnis kepada pemasok untuk pembelian kredit',
    'dl.ap.tip':
      'Akun 21xx (utang usaha & reimburse). Pantau kewajiban ke supplier.',
    'dl.depreciation.title': 'Penyusutan',
    'dl.depreciation.desc': 'Alokasi biaya aset berwujud secara sistematis dari waktu ke waktu',
    'dl.depreciation.tip':
      'Cari akun berlabel penyusutan/depresiasi (1520 / 5280). Posting jurnal penyusutan agar muncul di sini.',
    'dl.inventory.title': 'Laporan Persediaan',
    'dl.inventory.desc': 'Barang atau bahan yang dimiliki bisnis untuk dijual',
    'dl.inventory.tip':
      'Akun 13xx Persediaan. Kosong sampai ada saldo/mutasi persediaan barang.',
    'dl.cogs.title': 'Laporan HPP',
    'dl.cogs.desc': 'Biaya langsung untuk memproduksi atau membeli barang yang dijual',
    'dl.cogs.tip':
      'Akun 51xx Harga Pokok Penjualan — pengurang pendapatan menjadi laba kotor.',
    'dl.whyLabel': 'Untuk apa laporan ini',
    'dl.omset.title': 'Omset Bulanan',
    'dl.omset.desc': 'Digabung ke SPT / PPh Final + Omset',
    'dl.ledgerDetail.title': 'Buku Besar · Detail Mutasi',
    'dl.ledgerDetail.desc': 'Digabung ke Buku Besar (Saldo + Mutasi)',
    'dl.bank.title': 'Laporan Bank / Kas',
    'dl.bank.desc': 'Mutasi & posisi saldo rekening kas/bank 11xx',
    'dl.bank.tip':
      'Cocokkan mutasi di menu Rekonsiliasi (/reconciliation) sebelum review konsultan. Untuk rekening koran per bank, buka menu E-Statement Rekening Koran.',
    'dl.estatement.title': 'E-Statement Rekening Koran',
    'dl.estatement.desc': 'Unduh statement bank per rekening — Excel · PDF · Word · CSV · ZIP',
    'dl.estatement.tip':
      'Unduh hanya untuk bank yang sudah valid rekonsiliasi (cleared/released). Bank belum match otomatis terkunci — selesaikan di Rekonsiliasi dulu.',
    'dl.estatement.heroSub':
      'Gerbang kualitas: hanya bank siap unduh. Centang rekening cleared, unduh Excel/PDF/ZIP audit-ready.',
    'dl.bankEstmtKicker': 'Setelah rekonsiliasi',
    'dl.bankEstmtTitle': 'E-Statement Rekening Koran',
    'dl.bankEstmtSub':
      'Pilih bank/kas, lalu unduh tampilan seperti statement bank — rapi, profesional, siap audit.',
    'dl.bankEstmtPick': 'Pilih bank siap unduh (valid rekonsiliasi)',
    'dl.bankEstmtAll': 'Semua bank siap (ZIP)',
    'dl.bankEstmtEmpty':
      'Belum ada rekening kas/bank di master atau mutasi cleared pada periode ini',
    'dl.bankEstmtEmptyReady':
      'Belum ada bank dengan mutasi cleared/released di periode ini — unduh dikunci sampai rekonsiliasi selesai.',
    'dl.bankEstmtEmptyReadyTitle': 'Unduh masih terkunci',
    'dl.bankEstmtGoMaps': 'Kelola nomor rekening →',
    'dl.bankEstmtGoRecon': 'Buka Rekonsiliasi',
    'dl.bankEstmtLoading': 'Memuat rekening…',
    'dl.bankEstmtPickNeed': 'Centang minimal satu bank yang sudah valid rekonsiliasi',
    'dl.bankEstmtPickReady': 'Pilih semua yang siap',
    'dl.bankEstmtSelectedMeta': '{n} bank siap · {lines} mutasi cleared',
    'dl.bankEstmtSelectAll': 'Semua siap',
    'dl.bankEstmtSelectData': 'Semua siap unduh',
    'dl.bankEstmtSelectVisible': 'Yang tampil (siap)',
    'dl.bankEstmtClear': 'Kosongkan',
    'dl.bankEstmtOnlyData': 'Hanya yang siap unduh',
    'dl.bankEstmtShowLocked': 'Tampilkan terkunci',
    'dl.bankEstmtFilterAll': 'Semua jenis',
    'dl.bankEstmtFilterReady': 'Siap unduh',
    'dl.bankEstmtFilterLocked': 'Belum recon',
    'dl.bankEstmtNoMutasi': 'belum ada mutasi',
    'dl.bankEstmtMine': 'Punya saya',
    'dl.bankEstmtMineTip': 'Nomor rekening sudah terisi di master bank',
    'dl.bankEstmtPicked': 'Dipilih',
    'dl.bankEstmtBadgeReady': 'Siap',
    'dl.bankEstmtBadgeLocked': 'Terkunci',
    'dl.bankEstmtLockedSub': 'Belum cleared — unduh ditolak',
    'dl.bankEstmtLockedTip':
      'Bank ini belum punya mutasi valid rekonsiliasi (cleared/released) pada periode dipilih',
    'dl.bankEstmtLockedToast':
      'Bank belum valid rekonsiliasi — selesaikan match di Rekonsiliasi dulu, baru bisa diunduh',
    'dl.bankEstmtGateKicker': 'Gerbang kualitas data',
    'dl.bankEstmtGateReadyTitle': 'Semua bank terpilih sudah audit-ready',
    'dl.bankEstmtGateReadyText':
      '{n} rekening punya mutasi cleared/released. File e-statement hanya berisi data yang sudah lolos rekonsiliasi — aman untuk KAP & konsultan.',
    'dl.bankEstmtGatePartialTitle': 'Sebagian bank masih menunggu rekonsiliasi',
    'dl.bankEstmtGatePartialText':
      '{ready} siap unduh · {locked} masih terkunci. Bank terkunci tidak bisa dicentang sampai mutasinya cleared/released.',
    'dl.bankEstmtGateBlockedTitle': 'Belum ada data valid untuk diunduh',
    'dl.bankEstmtGateBlockedText':
      'E-statement hanya mengeluarkan mutasi setelah rekonsiliasi. Cocokkan buku ↔ bank di menu Rekonsiliasi, lalu kembali ke sini.',
    'dl.bankEstmtReadyLabel': 'kesiapan',
    'dl.bankEstmtReadyPct': 'Kesiapan unduh {pct}%',
    'dl.bankEstmtOpening': 'Saldo awal',
    'dl.bankEstmtDebit': 'Debit',
    'dl.bankEstmtCredit': 'Kredit',
    'dl.bankEstmtClosing': 'Saldo akhir',
    'dl.bankEstmtExcel': 'Unduh Excel',
    'dl.bankEstmtPdf': 'Unduh PDF',
    'dl.bankEstmtWord': 'Unduh Word',
    'dl.bankEstmtCsv': 'Unduh CSV',
    'dl.bankEstmtZip': 'ZIP bank terpilih',
    'dl.bankEstmtZipXlsx': 'ZIP Excel semua bank',
    'dl.bankEstmtZipPdf': 'ZIP PDF semua bank',
    'dl.bankEstmtPickFormat': 'Pilih format unduh',
    'dl.bankEstmtFmtXlsxDesc': 'Cover + rekening koran + ringkasan',
    'dl.bankEstmtFmtPdfDesc': 'Tampilan statement bank formal',
    'dl.bankEstmtFmtDocDesc': 'Dokumen Word siap cetak / edit',
    'dl.bankEstmtFmtCsvDesc': 'Data mentah untuk Excel / BI',
    'dl.bankEstmtFmtZipDesc': 'Bank terpilih dalam satu arsip ZIP',
    'dl.bankEstmtDownloadNow': 'Unduh sekarang',
    'dl.bankEstmtDownloadZip': 'Unduh ZIP sekarang',
    'dl.bankEstmtDone': 'E-statement {format} siap diunduh',
    'dl.bankEstmtHint':
      'Pilih bank Siap → format → Unduh. Beberapa bank = ZIP. Filter PT/periode di toolbar atas.',
    'dl.bankEstmtFilterBar': 'Filter e-statement',
    'dl.bankEstmtWeek1': '1 minggu',
    'dl.bankEstmtWeek2': '2 minggu',
    'dl.bankEstmtMonth1': '1 bulan',
    'dl.bankEstmtDirty': 'Belum diterapkan',
    'dl.bankEstmtApplyFirst': 'Klik Terapkan dulu agar filter tanggal & PT aktif sebelum unduh.',
    'dl.bankEstmtMeta': '{banks} rekening · {n} mutasi cleared',
    'dl.bankEstmtBanks': 'Rekening',
    'dl.bankEstmtLines': 'Mutasi',
    'dl.bankEstmtSample': 'Cuplikan mutasi cleared',
    'dl.exportBankMode': 'Jenis unduhan',
    'dl.exportBankModeEstmt': 'E-Statement rekening koran',
    'dl.exportBankModeEstmtSub': 'Detail debit/kredit per rekening · cleared',
    'dl.exportBankModeSummary': 'Ringkasan rollforward',
    'dl.exportBankModeSummarySub': 'Saldo awal → mutasi → saldo akhir (tabel)',
    'dl.exportBankPick': 'Pilih rekening bank',
    'dl.exportBankAllSub': '{n} rekening dalam ZIP',
    'dl.exportBankRowSub': '{n} mutasi · saldo {bal}',
    'dl.exportBankGo': 'Unduh e-statement',
    'dl.exportFail': 'Gagal mengunduh laporan',
    'dl.recon.title': 'Rekonsiliasi Laporan Keuangan',
    'dl.recon.desc':
      'Jembatan NS & BB sebelum ↔ setelah rekonsiliasi — uji selisih AJ per akun sebelum LK',
    'dl.recon.tip':
      'Hubungkan NS sebelum/sesudah + BB sebelum/sesudah. Match bank tetap di menu Rekonsiliasi.',
    'dl.ic.title': 'Antar Perusahaan',
    'dl.ic.desc': 'Kandidat & eliminasi transaksi JGI↔JGT',
    'dl.ic.tip': 'Wajib untuk Konsolidasi Grup — lampirkan ke review KAP grup.',
    'dl.tax.title': 'SPT / PPh Final + Omset',
    'dl.tax.desc':
      'Omset bruto, tarif, PPh Final per masa + lampiran omset bulanan (menggabungkan Omset Bulanan)',
    'dl.tax.tip':
      'Verifikasi tarif & posting PPHFIN sebelum SPT. Format siap konsultan pajak (PP 55/2022).',
    'dl.kasbon.title': 'Laporan Kasbon Karyawan',
    'dl.kasbon.desc':
      'Piutang · Setujui/Tolak · mutasi · slip gaji (awal − kasbon = pulang) · sinkron neraca & laba-rugi',
    'dl.kasbon.tip':
      'Pilih PT. Setujui = Dr Piutang 1201 · Cr Kas (neraca langsung). Tolak = slip saja. Payroll potong → piutang turun · L/R via beban gaji.',
    'dl.audit.title': 'Audit Kualitas Data',
    'dl.audit.desc':
      'Skor kualitas, temuan, rekomendasi, dan gap statement — review pra-KAP (bukan opini audit)',
    'dl.audit.tip':
      'Selesaikan temuan high/critical sebelum menyerahkan paket LK ke akuntan publik.',

    'bk.kicker': 'Vault · Transfer aman',
    'bk.title': 'Backup & Restore',
    'bk.sub':
      'Ambil database lokal, simpan di PC, perbaiki, lalu kirim ke Git/VPS — data tetap sama. Git tidak membawa file .db live; pakai unduhan, snapshot server, atau bootstrap Git.',
    'bk.subShort':
      'Backup ke PC dulu, restore balik ke mesin ini atau VPS. ZIP penuh = DB + uploads; JSON = per tabel.',
    'bk.twowayHint':
      'Windows → simpan ZIP → restore di VPS Linux (atau sebaliknya). Git pull TIDAK membawa live DB, uploads, maupun .env.',
    'bk.twowayHintShort':
      'Windows → ZIP → restore VPS (atau sebaliknya). Git pull tidak bawa DB/uploads/.env.',
    'bk.backupAll': 'Backup semua (ZIP)',
    'bk.backupAllNow': 'Backup Semua Now',
    'bk.backupAllNowShort': 'Backup Now',
    'bk.downloadZipOnly': 'ZIP saja',
    'bk.downloadZipOnlyShort': 'ZIP saja',
    'bk.downloadDbShort': 'Unduh .db',
    'bk.downloadJsonShort': 'JSON semua',
    'bk.restoreBtnShort': 'Restore',
    'bk.refreshShort': 'Ulang',
    'bk.liveZipAllShort': 'ZIP semua',
    'bk.selectAllShort': 'Semua',
    'bk.deselectAllShort': 'Batal',
    'bk.backupSelectedShort': 'Terpilih ({n})',
    'bk.snackBackupAllNowOk': 'Backup ZIP lengkap terunduh — cek histori di bawah',
    'bk.refreshStatus': 'Segarkan status',
    'bk.backupAllTitle': 'Backup database',
    'bk.backupAllSub':
      'Backup Semua Now = 1 file ZIP (DB + uploads). Backup 1–1 JSON hanya jika diklik per tabel.',
    'bk.zipContentsTitle': 'Isi Backup semua (ZIP)',
    'bk.zipItemDb': 'Database SQLite lengkap',
    'bk.zipItemUploads': 'Lampiran disk (jika ada)',
    'bk.zipItemManifest': 'Manifest & hitungan tabel',
    'bk.zipItemEnv': 'Daftar kunci .env (tanpa rahasia)',
    'bk.fileNameHint':
      'Nama file: laporanJP-full-*.zip · laporanJP-accounting-*.db · laporanJP-json-all-*.json · laporanJP-table-{nama}-*.json',
    'bk.uploadsPill': 'Uploads: {n} file',
    'bk.lastBackupAt': 'Backup terakhir',
    'bk.lastBackupHint': 'Waktu backup terakhir (tgl/bulan/tahun + jam:menit:detik)',
    'bk.lastRestoreAt': 'Restore terakhir',
    'bk.lastRestoreHint': 'Waktu restore terakhir (tgl/bulan/tahun + jam:menit:detik)',
    'bk.dbFileAt': 'File DB',
    'bk.gitGapLead':
      'Dari lokal Windows ke Git ke VPS Linux, yang tidak ikut pull lebih dari database saja — lihat daftar kanan. Pakai ZIP penuh untuk DB + uploads.',
    'bk.partsTitle': 'Backup 1–1 / terpilih',
    'bk.partsSub': 'Centang tabel → unduh JSON. Restore JSON hanya mengganti tabel yang dipilih (jika dicentang).',
    'bk.partsNote':
      'Tips: journal_entries + journal_lines sebaiknya di-backup/restore bersama agar jurnal tetap konsisten.',
    'bk.selectAll': 'Pilih semua',
    'bk.deselectAll': 'Batal pilih',
    'bk.backupSelected': 'Backup terpilih ({n})',
    'bk.backupOne': 'Backup',
    'bk.colTable': 'Tabel',
    'bk.colRows': 'Baris',
    'bk.colAction': 'Aksi',
    'bk.seeCoverage': 'Yang ikut / tidak lewat Git',
    'bk.gitTitleShort': 'Lewat Git (bootstrap)',
    'bk.dropSubJson': 'atau klik · .db / .zip / .json (maks 200MB)',
    'bk.partialRestoreHint':
      '{n} tabel tercentang — restore JSON hanya menimpa tabel itu (bukan seluruh DB).',
    'bk.snackNeedTables': 'Centang minimal satu tabel dulu',
    'bk.path': 'Lokasi',
    'bk.size': 'Ukuran',
    'bk.updated': 'Terakhir diubah',
    'bk.journals': 'Jurnal',
    'bk.lines': 'Baris',
    'bk.companies': 'Perusahaan',
    'bk.accounts': 'Akun',
    'bk.recon': 'Rekonsiliasi',
    'bk.refresh': 'Segarkan',
    'bk.quickZip': 'Unduh ZIP sekarang',
    'bk.workflowLabel': 'Alur kerja',
    'bk.flowTitle': 'Tiga cara fleksibel pindahkan database',
    'bk.flowManualTitle': 'Manual ke PC',
    'bk.flowManualDesc': 'Unduh ZIP/.db → simpan lokal → perbaiki → upload restore ke lokal atau VPS.',
    'bk.flowSnapTitle': 'Snapshot server',
    'bk.flowSnapDesc': 'Salin ke data/backups/ di mesin yang sama (aman rollback tanpa unduh).',
    'bk.flowGitTitle': 'Lewat Git',
    'bk.flowGitDesc': 'Pack ke data/bootstrap/ → commit+push → VPS pull (DB kosong auto-isi).',
    'bk.sectionBackup': 'Backup',
    'bk.sectionBackupSub': 'Simpan dulu di lokal sebelum ubah apa pun — rekomendasi ZIP (ada manifest)',
    'bk.zipTitle': 'Paket ZIP',
    'bk.zipDesc':
      'accounting.db + uploads/ + manifest + ENV_CHECKLIST — paling aman Windows ↔ VPS',
    'bk.dbTitle': 'SQLite mentah (.db)',
    'bk.dbDesc': 'Satu file — taruh di data/accounting.db atau rename lalu restore',
    'bk.jsonTitle': 'Ekspor JSON',
    'bk.jsonDesc': 'Dump tabel — bisa full atau per-tabel; restore JSON menimpa tabel isi file',
    'bk.downloadZip': 'Unduh ZIP penuh',
    'bk.downloadDb': 'Unduh .db',
    'bk.downloadJson': 'Unduh JSON semua',
    'bk.sectionSnap': 'Snapshot server',
    'bk.sectionSnapSub': 'Salin di VPS/server tanpa unduh (folder data/backups/)',
    'bk.snapNow': 'Buat snapshot sekarang',
    'bk.snapEmpty': 'Belum ada snapshot — buat satu sebelum eksperimen berisiko',
    'bk.snapRestore': 'Restore',
    'bk.snapDownload': 'Unduh',
    'bk.snapDelete': 'Hapus',
    'bk.sectionRestore': 'Restore',
    'bk.sectionRestoreSub':
      'ZIP = DB + uploads. .db = database saja. JSON = tabel. Snapshot pre-restore otomatis.',
    'bk.dropTitle': 'Lepas .db / .zip / .json di sini',
    'bk.dropSub': 'atau klik untuk pilih file (maks 200MB)',
    'bk.confirmLabel': 'Saya paham ini menimpa data saat ini',
    'bk.restoreBtn': 'Restore sekarang',
    'bk.restoring': 'Sedang restore…',
    'bk.confirmRestoreTitle': 'Restore database sekarang?',
    'bk.confirmRestoreLead':
      'File yang dipilih akan mengubah database aktif (ZIP juga mengembalikan uploads/). Salinan pre-restore di data/backups/.',
    'bk.confirmYes': 'Ya, restore',
    'bk.confirmNo': 'Tidak',
    'bk.confirmYesHint': 'Timpa DB aktif dengan file ini',
    'bk.confirmNoHint': 'Batalkan, tetap di halaman',
    'bk.sectionGuide': 'Panduan lengkap',
    'bk.seeGuide': 'Lihat di sini',
    'bk.hideGuide': 'Tutup',
    'bk.tipsTitle': 'Tips agar VPS sama dengan lokal',
    'bk.tip1': 'Sebelum push: Pack DB untuk Git (atau npm run db:pack) → commit folder data/bootstrap.',
    'bk.tip2': 'Di VPS: git pull. Jika data/accounting.db belum ada, app otomatis restore dari bootstrap.',
    'bk.tip3': 'Live DB (data/accounting.db) tetap di-.gitignore — yang di-push hanya snapshot bootstrap.',
    'bk.tip4': 'Timpa DB VPS dengan data lokal terbaru: DB_BOOTSTRAP_FORCE=1 npm run db:restore:force lalu restart.',
    'bk.tip5': 'Setelah restore, refresh browser (Ctrl+F5) agar laporan ter-reload.',
    'bk.gitTitle': 'Bawa database lewat Git (tanpa copy manual)',
    'bk.gitSub':
      'Pack snapshot ke data/bootstrap/ lalu commit+push. VPS otomatis pakai snapshot jika DB lokal kosong. Uploads & .env tetap tidak ikut Git.',
    'bk.gitPack': 'Pack DB untuk Git',
    'bk.gitStep1': 'Klik “Pack DB untuk Git” di mesin lokal yang datanya lengkap (atau npm run db:pack).',
    'bk.gitStep2': 'git add data/bootstrap && git commit -m "db: sync bootstrap" && git push',
    'bk.gitStep3': 'Di VPS: git pull && restart app — DB kosong otomatis terisi dari bootstrap.',
    'bk.gitStep4': 'Kalau VPS sudah punya DB lama dan mau diganti: npm run db:restore:force (sekali).',
    'bk.gitPacked': 'Snapshot siap',
    'bk.copyCmd': 'Salin',
    'bk.copied': 'Disalin',
    'bk.snackPackOk': 'Bootstrap DB siap di-commit ({size})',
    'bk.snackPackFail': 'Gagal pack bootstrap DB',
    'bk.countsTitle': 'Inventaris tabel',
    'bk.snackDlOk': 'Backup berhasil diunduh',
    'bk.snackDlFail': 'Gagal mengunduh',
    'bk.snackSnapOk': 'Snapshot tersimpan: {name}',
    'bk.snackSnapFail': 'Gagal membuat snapshot',
    'bk.snackRestoreOk': 'Database berhasil di-restore',
    'bk.snackRestoreFail': 'Restore gagal',
    'bk.snackNeedConfirm': 'Centang konfirmasi dulu',
    'bk.snackNeedFile': 'Pilih file .db, .zip, atau .json dulu',
    'bk.snackDelOk': 'Snapshot dihapus',
    'bk.confirmRestore':
      'Restore snapshot ini?\n\nData saat ini diganti (salinan pre-restore disimpan).',
    'bk.confirmDelete': 'Hapus snapshot {name}?',
    'bk.recommend': 'Direkomendasikan',
    'bk.danger': 'Berbahaya',
    'bk.live': 'Database aktif',
    'bk.snapshots': 'Snapshot',
    'bk.coverInTitle': 'Yang ikut ZIP / bootstrap',
    'bk.coverIn1': 'Semua jurnal, baris, COA, PT, rekonsiliasi, aturan statement, memori AI akun',
    'bk.coverIn2': 'Karyawan, payroll, kasbon, pajak, year-close, budget (jika dipakai)',
    'bk.coverIn3': 'ZIP penuh: accounting.db (WAL di-checkpoint) + data/uploads/',
    'bk.coverIn4': 'Lewat Git: hanya data/bootstrap/accounting.db (+ manifest) — Pack dulu sebelum push',
    'bk.coverIn5': 'ENV_CHECKLIST.txt di ZIP = daftar kunci yang harus diisi manual di VPS',
    'bk.coverOutTitle': 'Yang TIDAK ikut git pull (Windows → VPS)',
    'bk.coverOut1': 'data/accounting.db live (+ .db-wal / .db-shm) — sengaja di-.gitignore',
    'bk.coverOut2': 'data/uploads/ lampiran disk — ikut ZIP penuh, bukan Git',
    'bk.coverOut3': '.env / kunci API & login (Gemini, Groq, session) — set ulang di VPS',
    'bk.coverOut4': 'node_modules, .nuxt, .output — npm ci + build di Linux',
    'bk.coverOut5': 'data/backups/ snapshot server — lokal per mesin',

    'bk.histKicker': 'Aktivitas · Audit trail',
    'bk.histTitle': 'Histori Backup & Restore',
    'bk.histSub':
      'Setiap unduhan, restore, snapshot, dan pack Git tercatat lengkap: user, tanggal, jam, detik, dan isi yang diambil.',
    'bk.histEmpty': 'Belum ada aktivitas — coba Backup semua atau Restore, lalu histori muncul di sini.',
    'bk.histLoading': 'Memuat histori…',
    'bk.histClear': 'Hapus histori',
    'bk.histClearConfirm': 'Hapus semua histori backup/restore di mesin ini?',
    'bk.histCleared': 'Histori dikosongkan',
    'bk.histShowItems': 'Lihat {n} item yang diambil',
    'bk.histHideItems': 'Sembunyikan detail',
    'bk.histActBackupZip': 'Backup ZIP',
    'bk.histActBackupDb': 'Backup .db',
    'bk.histActBackupJson': 'Backup JSON',
    'bk.histActBackupTables': 'Backup 1–1',
    'bk.histActBackupAllNow': 'Backup Semua Now',
    'bk.histActBackupFile': 'Backup 1 file',
    'bk.histActBackupLiveZip': 'ZIP non-Git',
    'bk.histActRestoreZip': 'Restore ZIP',
    'bk.histActRestoreDb': 'Restore .db',
    'bk.histActRestoreJson': 'Restore JSON',
    'bk.histActSnapCreate': 'Snapshot',
    'bk.histActSnapRestore': 'Restore snapshot',
    'bk.histActSnapDelete': 'Hapus snapshot',
    'bk.histActPackGit': 'Pack Git',

    'bk.liveKicker': 'Non-Git · Inventaris live',
    'bk.liveTitle': 'File yang tidak ikut Git',
    'bk.liveSub':
      'Semua artefak di mesin ini yang sengaja di-.gitignore: DB live, uploads, snapshot server, checklist .env. Unduh ZIP sekaligus atau 1–1 sesuai nama file.',
    'bk.liveZipAll': 'Unduh semua (ZIP)',
    'bk.liveZipHint':
      'ZIP non-Git = accounting.db + uploads + snapshot + ENV_CHECKLIST (tanpa rahasia .env). ZIP penuh “Backup Semua Now” fokus untuk migrasi DB+uploads ke VPS.',
    'bk.liveColKind': 'Jenis',
    'bk.liveColName': 'Nama file',
    'bk.liveColPath': 'Path',
    'bk.liveColSize': 'Ukuran',
    'bk.liveColMtime': 'Diubah',
    'bk.liveColAction': 'Aksi',
    'bk.liveDownload': 'Unduh',
    'bk.liveBlocked': 'Rahasia',
    'bk.liveEmpty': 'Tidak ada file live di filter ini',
    'bk.livePillFiles': '{n} file non-Git',
    'bk.livePillSize': 'Σ {size}',
    'bk.liveKpiTotal': 'Inventaris',
    'bk.liveKpiReady': 'Bisa unduh',
    'bk.liveKpiBlocked': 'Diblokir',
    'bk.liveKpiSize': 'Total unduh',
    'bk.liveFilterAll': 'Semua',
    'bk.kindDb': 'Database',
    'bk.kindSidecar': 'WAL/SHM',
    'bk.kindUpload': 'Upload',
    'bk.kindSnapshot': 'Snapshot',
    'bk.kindEnv': '.env',
    'bk.kindChecklist': 'Checklist',
    'bk.snackLiveZipOk': 'ZIP semua file non-Git terunduh',
    'bk.noteMissing': 'File belum ada di disk',
    'bk.noteSidecar': 'Biasanya sudah ikut unduhan .db (serialize). Opsional untuk salinan mentah.',
    'bk.noteSnapshot': 'Snapshot lokal mesin ini (juga tidak ikut Git)',
    'bk.noteChecklist': 'Daftar kunci .env tanpa nilai rahasia',
    'bk.noteSecret': 'Berisi rahasia — tidak diunduh. Salin manual / pakai ENV_CHECKLIST.txt',

    'imp.title': 'Import Workbook',
    'imp.kicker': 'Import massal',
    'imp.sub':
      'Upload Excel mutasi bank & kartu kredit — otomatis jadi jurnal, HPP dialokasi proporsional ke JGI & JGT. Untuk e-statement multi-format, gunakan juga E-Statement Pintar.',
    'imp.eStatement': 'E-Statement Pintar',
    'imp.journals': 'Jurnal',
    'imp.fsUploadReview': 'Upload & review workbook',
    'imp.setupTitle': 'Persiapan import',
    'imp.setupStepPt': 'Pilih PT target',
    'imp.setupStepBank': 'Rekening bank',
    'imp.setupStepUpload': 'Upload workbook',
    'imp.setupHintPt': 'Semua baris & jurnal masuk ke PT yang dipilih.',
    'imp.setupHintBank': 'Pastikan kas/bank & nomor rekening sudah benar.',
    'imp.setupReady': 'Siap upload',
    'imp.step1': 'Langkah 1',
    'imp.step2Title': 'Langkah 2 — Impor ke sistem',
    'imp.step2Body': '{n} baris terpilih. Klik tombol biru “Impor ke sistem” (bukan cuma upload Excel). Centang “Posting ke laporan” agar langsung masuk neraca.',
    'imp.aiLocalFallback': 'Mapping rule lokal untuk {n} baris (AI offline). Cek kolom MAP lalu klik Impor ke sistem.',
    'imp.uploadTitle': 'Upload Excel / e-statement',
    'imp.uploadSub':
      'Excel multi-sheet bank & CC, atau PDF/CSV/OFX e-statement — AI Gemini ↔ Groq isi debit/kredit otomatis.',
    'imp.parsed': 'Parsed',
    'imp.readingWorkbook': 'Membaca workbook…',
    'imp.processingSheets': 'Memproses sheet bank & CC',
    'imp.aiSmartFill': 'Isi pintar AI',
    'imp.aiMapping': 'AI memetakan akun…',
    'imp.aiMappingHint': 'Gemini dulu, otomatis cadangan Groq — mengisi kind & lawan ke semua tabel',
    'imp.aiStatusGemini': 'AI Gemini aktif',
    'imp.aiStatusGroq': 'AI Groq aktif (cadangan)',
    'imp.aiStatusFailover': 'Gemini ↔ Groq otomatis jika limit',
    'imp.aiStatusOffline': 'AI offline — pakai rule lokal',
    'imp.aiOfflineChip': 'Rule lokal',
    'imp.mutations': 'mutasi',
    'imp.bankSheets': 'sheet bank',
    'imp.changeFile': 'Ganti file',
    'imp.step3Title': 'Upload file',
    'imp.toolbarUpload': 'Upload',
    'imp.toolbarReview': 'Review & aksi',
    'imp.processFiles': 'Proses {n} file',
    'imp.parsedStmtSummary': '{rows} baris mutasi · {files} file',
    'imp.multiFileLabel': '{n} file impor',
    'imp.parsedWorkbookSummary': '{bank} mutasi · {sheets} sheet bank · CC {cc}',
    'imp.snack.parseTimeout': 'Proses terlalu lama — coba lagi atau pakai file lebih kecil.',
    'imp.metricRows': 'baris',
    'imp.selectedShort': 'terpilih',
    'imp.debitShort': 'debit',
    'imp.creditShort': 'kredit',
    'imp.dropActive': 'Lepas file di sini',
    'imp.dropTitle': 'Seret & lepas Excel / PDF e-statement',
    'imp.dropHint': 'Upload → parse → AI isi debit/kredit otomatis · workbook multi-sheet atau PDF bank',
    'imp.chipMultiSheet': 'Multi sheet bank',
    'imp.chipCcHpp': 'CC → HPP',
    'imp.pickExcel': 'Pilih file Excel',
    'imp.pickFile': 'Pilih file',
    'imp.fsReviewMulti': 'Review mutasi · multi sheet',
    'imp.multiKicker': 'Frame multi sheet',
    'imp.reviewTitle': 'Review mutasi · pilih alur & akun',
    'imp.reviewTitleDemo': 'Tabel mutasi per sheet (contoh)',
    'imp.reviewSub':
      'Otomatis dari workbook · {n} baris siap diarahkan · ubah alur / akun debit-kredit sebelum import',
    'imp.reviewSubDemo':
      'Setelah upload Excel, semua sheet bank otomatis masuk — pilih alur & nomor akun debit/kredit.',
    'imp.realData': 'Data asli',
    'imp.illustration': 'Ilustrasi',
    'imp.file': 'File',
    'imp.visibleSelected': 'Tampil / pilih',
    'imp.debitFilter': 'Debit filter',
    'imp.creditFilter': 'Kredit filter',
    'imp.totalDebit': 'Total debit',
    'imp.totalCredit': 'Total kredit',
    'imp.readyScore': 'Siap import',
    'imp.readyHint': '{ok} benar · {need} masih perlu dicek',
    'imp.healthTitle': 'Lane review cepat',
    'imp.healthSub': 'Klik chip untuk filter baris — sinkron dengan tabel di bawah.',
    'imp.clearLane': 'Reset filter',
    'imp.statUnmatched': 'Sheet tak cocok',
    'imp.statInvalid': 'Baris bermasalah',
    'imp.statReady': 'Siap %',
    'imp.rulesLegendChip': 'Legenda',
    'imp.rulesLegendHint': 'Klik rule = filter tabel. Mapping default workbook (bukan CRUD rules).',
    'imp.hppPreviewTip':
      'Isi total pengeluaran CC (atau klik “Isi dari workbook”) — preview split JGI/JGT muncul otomatis.',
    'imp.sheetStatusTitle': 'Status semua sheet workbook',
    'imp.statusCc': 'CC',
    'imp.statusEmpty': 'kosong',
    'imp.statusSkip': 'skip',
    'imp.allSheets': 'Semua ({n})',
    'imp.selectVisible': 'Pilih tampilan',
    'imp.resetTable': 'Reset ke awal',
    'imp.selectInvalid': 'Pilih yang invalid',
    'imp.removeSelected': 'Hapus terpilih ({n})',
    'imp.removeRow': 'Hapus baris',
    'imp.snack.rowDeleted': '1 baris dihapus',
    'imp.snack.rowsDeleted': '{n} baris dihapus',
    'imp.snack.needSelected': 'Centang baris dulu',
    'imp.snack.invalidSelected': '{n} baris invalid dicentang',
    'imp.snack.noInvalid': 'Tidak ada baris invalid',
    'imp.snack.rowAdded': 'Baris manual ditambahkan — isi deskripsi, debit/kredit, lalu import.',
    'imp.filterBar': 'Filter & seleksi',
    'imp.manualMode': 'Input manual',
    'imp.errNeedAmount': '{n} baris debit/kredit belum valid — isi salah satu sisi saja (bukan keduanya / kosong).',
    'imp.errNeedAccounts': '{n} baris belum punya kas/bank & akun lawan.',
    'imp.confirmKicker': 'Import workbook',
    'imp.confirmLead': '{n} baris terpilih akan diimpor ke jurnal. Pastikan deskripsi, nominal, dan akun sudah dicek.',
    'imp.confirmB1': 'Deskripsi wajib · debit XOR kredit · kas/bank & lawan terisi · PT terpasang.',
    'imp.confirmB2': 'Uncentang baris yang masih ragu/salah sebelum Ya.',
    'imp.confirmB3': 'Setelah Ya, baris masuk jurnal (pending atau cleared sesuai opsi).',
    'imp.confirmYesHint': 'Ya, sudah cek — import sekarang',
    'imp.confirmImportTitle': 'Tinjau sebelum impor ke sistem',
    'imp.confirmSaveLead': 'Anda akan mengimpor {n} baris terpilih ke buku besar.',
    'imp.confirmRecapImport': '{n} baris ({deb} debit · {cred} kredit) → rekening: {bank}',
    'imp.processWorkbook': 'Baca workbook',
    'imp.processWorkbookHint': 'Parse Excel setelah konfirmasi',
    'imp.searchRows': 'Cari keterangan / akun / sheet…',
    'imp.allFlows': 'Semua alur',
    'imp.bulkApply': 'Terapkan ke terpilih ({n})',
    'imp.flow': 'Alur',
    'imp.setFlow': 'Set alur',
    'imp.bankAccount': 'Akun bank',
    'imp.contraAccount': 'Akun lawan',
    'imp.setAccountPt': 'Set akun/PT',
    'imp.bankSheetSummary': 'Ringkas sheet bank',
    'imp.ccSheetSummary': 'Ringkas sheet CC',
    'imp.colTxn': 'Txn',
    'imp.colCharges': 'Charges',
    'imp.totalHppPool': 'Total HPP pool',
    'imp.colDate': 'Tgl',
    'imp.colSheet': 'Sheet',
    'imp.colDesc': 'Keterangan',
    'imp.colFlow': 'Alur',
    'imp.colDebitAcct': 'Akun Debit',
    'imp.colCreditAcct': 'Akun Kredit',
    'imp.colKind': 'Jenis',
    'imp.noRowsFilter': 'Tidak ada baris di filter ini',
    'imp.demoUploadTitle': 'Upload Excel di atas',
    'imp.demoUploadSub': 'Semua sheet bank & CC otomatis masuk ke frame multi seperti ini',
    'imp.ccBanner':
      '{count} baris CC masuk review · terpilih {selected} · pool {pool}. Centang alokasi HPP proporsional = digabung ke JGI/JGT; matikan = jurnal per baris (wajib pilih PT).',
    'imp.sharedPtBanner':
      '{n} baris masih PT Bersama — tidak masuk laporan per PT (hindari double-count). Set JGI/JGT di kolom PT.',
    'imp.optHppAllocate': 'Alokasi HPP proporsional dari CC terpilih (bukan jurnal per baris CC)',
    'imp.optPostCleared': 'Langsung masuk Laporan Keuangan (cleared) — jangan pending rekonsiliasi',
    'imp.hppJournalDate': 'Tgl jurnal HPP',
    'imp.dryRun': 'Dry-run (preview)',
    'imp.importSelected': 'Import {n} terpilih',
    'imp.saveToRecon': 'Import terpilih → Rekonsiliasi',
    'imp.savedLinks': 'Tersimpan ke jurnal — lanjutkan:',
    'imp.savedLinksPending': 'Tersimpan · siap di meja rekonsiliasi:',
    'imp.openJournal': 'Jurnal Umum',
    'imp.toRecon': 'Ke rekonsiliasi',
    'imp.toReconBatch': 'Siap auto-match',
    'imp.postSaveTitle': 'Import berhasil',
    'imp.postSaveSub': '{imported} jurnal dibuat · skip {skipped} · error {errors}',
    'imp.postSaveRemaining': '{n} baris masih di review — bisa lanjut import atau upload file baru.',
    'imp.uploadAgain': 'Upload lagi',
    'imp.continueReview': 'Lanjut review',
    'imp.createdRefs': 'Ref jurnal',
    'imp.reconCleared': 'Langsung cleared (masuk LK)',
    'imp.reconPending': 'Pending rekonsiliasi',
    'imp.statImported': 'Imported',
    'imp.statSkipped': 'Skipped',
    'imp.statErrors': 'Error',
    'imp.statRemaining': 'Sisa review',
    'imp.queueOutcomeRows': '{n} mutasi',
    'imp.queueOutcomeEmpty': '0 mutasi',
    'imp.queueOutcomeFail': 'Gagal parse',
    'imp.queueProcessDone': '{ok} file OK · {rows} baris · {fail} gagal',
    'imp.draftReuploadHint': 'Review tersimpan — unggah ulang file yang sama jika perlu melihat sheet mentah.',
    'imp.applyDefaultPanel': 'Default panel',
    'imp.selectNeedCheck': 'Pilih perlu dicek',
    'imp.snack.defaultApplied': 'Default panel diterapkan ke {n} baris',
    'imp.snack.needCheckSelected': '{n} baris perlu dicek terpilih',
    'imp.snack.noNeedCheck': 'Tidak ada baris perlu dicek',
    'stmt.queueDoneOk': 'Selesai',
    'stmt.queueDoneFail': 'Gagal',
    'imp.viewJournals': 'Lihat Jurnal',
    'imp.financialReports': 'Laporan Keuangan',
    'imp.dryRunBanner': 'Dry-run: {n} jurnal siap dibuat',
    'imp.importedBanner': 'Imported {imported} · skipped {skipped} · error {errors}',
    'imp.classification': 'klasifikasi',
    'imp.searchPreview': 'Cari keterangan / sheet…',
    'imp.allKinds': 'Semua jenis',
    'imp.rowsCount': '{n} baris',
    'imp.hppAllocation': 'Alokasi HPP',
    'imp.colRevenue': 'Omset',
    'imp.controlPanel': 'Panel kontrol',
    'imp.sessionSummary': 'Ringkasan sesi',
    'imp.workbookActive': 'Workbook aktif',
    'imp.awaitingUpload': 'Menunggu upload',
    'imp.statBankRows': 'Bank rows',
    'imp.statCcRows': 'CC rows',
    'imp.statSelected': 'Terpilih',
    'imp.statSheets': 'Sheet',
    'imp.statCcPool': 'CC pool',
    'imp.statEmptyPt': 'PT kosong',
    'imp.sessionEmpty': 'Upload Excel di kiri untuk melihat jumlah sheet, mutasi, dan pool CC di sini.',
    'imp.sessionEmptyMobile': 'Upload Excel di atas untuk melihat jumlah sheet, mutasi, dan pool CC di sini.',
    'imp.coa': 'COA',
    'imp.mappingDefault': 'Mapping default',
    'imp.autoClassification': 'Klasifikasi otomatis',
    'imp.autoClassSub':
      'Dipakai saat parse. Di review bisa diganti per baris (alur, PT, akun Dr/Cr). Klik rule untuk filter tabel.',
    'imp.legendIn': 'Masuk',
    'imp.legendOut': 'Keluar',
    'imp.legendBoth': 'Kedua arah',
    'imp.legendCc': 'Kartu kredit',
    'imp.clearedNote':
      'Jurnal masuk laporan hanya jika status cleared (centang “Langsung masuk LK” saat import).',
    'imp.hppManualKicker': 'Tanpa workbook',
    'imp.hppManualTitle': 'Alokasi HPP manual',
    'imp.hppManualSub':
      'Split proporsional omset YTD JGI/JGT (atau rata jika omset 0). Jurnal: Dr 5000 · Cr 2700 per PT.',
    'imp.allTab': 'Semua',
    'imp.hppDebitAcct': '5000 HPP',
    'imp.hppCreditAcct': '2700 Utang reimburse CC',
    'imp.lkShort': 'LK',
    'imp.hppTotalLabel': 'Total pengeluaran CC (Rp)',
    'imp.fillFromWorkbook': 'Isi dari workbook',
    'imp.journalDate': 'Tanggal jurnal',
    'imp.memoLabel': 'Keterangan / memo',
    'imp.hppPostCleared': 'Langsung masuk Laporan Keuangan (cleared)',
    'imp.previewSplit': 'Preview split',
    'imp.allocateHpp': 'Alokasikan HPP → Jurnal',
    'imp.preview': 'Preview',
    'imp.result': 'Hasil',
    'imp.equalSplit': 'Bagi rata',
    'imp.revenueSplit': 'Proporsi omset',
    'imp.viewJournalLink': 'Lihat jurnal',
    'imp.openLk': 'Buka LK',
    'imp.shared': 'Bersama',
    'imp.kind.revenue': 'Pendapatan jasa',
    'imp.kind.bunga': 'Bunga bank',
    'imp.kind.owner': 'Mutasi owner',
    'imp.kind.internal': 'Transfer internal',
    'imp.kind.admin': 'Biaya admin bank',
    'imp.kind.opex': 'Biaya operasional',
    'imp.kind.hpp': 'HPP',
    'imp.kind.custom': 'Custom (pilih akun)',
    'imp.rule.revenue.title': 'Kredit masuk',
    'imp.rule.revenue.accountName': 'Pendapatan jasa',
    'imp.rule.revenue.journal': 'Dr Bank · Cr 4000',
    'imp.rule.revenue.hint': 'Transfer masuk / settlement / QRIS (default)',
    'imp.rule.bunga.title': 'Bunga bank',
    'imp.rule.bunga.accountName': 'Pendapatan bunga',
    'imp.rule.bunga.journal': 'Dr Bank · Cr 4001',
    'imp.rule.bunga.hint': 'Deskripsi mengandung “BUNGA”',
    'imp.rule.admin.title': 'Biaya admin / BIFAST',
    'imp.rule.admin.accountName': 'Biaya Admin Bank',
    'imp.rule.admin.journal': 'Dr 5003 · Cr Bank',
    'imp.rule.admin.hint': 'Admin, fee, card charge, saldo min',
    'imp.rule.owner.title': 'Mutasi owner',
    'imp.rule.owner.accountName': 'Piutang pihak berelasi / utang owner',
    'imp.rule.owner.journal': 'Keluar Dr 1202 · Masuk Cr 2400 ↔ Bank',
    'imp.rule.owner.hint': 'Lim Sulaiman / Sulaiman Jaya',
    'imp.rule.internal.title': 'Transfer internal',
    'imp.rule.internal.accountName': 'Piutang antar perusahaan',
    'imp.rule.internal.journal': 'Dr/Cr 1203 ↔ Bank',
    'imp.rule.internal.hint': 'Pemindahan antar rekening grup',
    'imp.rule.opex.title': 'Debit lain',
    'imp.rule.opex.accountName': 'Biaya Operasional',
    'imp.rule.opex.journal': 'Dr 5004 · Cr Bank',
    'imp.rule.opex.hint': 'Fallback keluar jika tidak match rule lain',
    'imp.rule.hpp.title': 'CC charges',
    'imp.rule.hpp.accountName': 'HPP',
    'imp.rule.hpp.journal': 'Dr 5000 · Cr 2700',
    'imp.rule.hpp.hint': 'Pool proporsional omset JGI/JGT, atau jurnal per baris + PT',
    'imp.rule.keywords.ccSheet': 'Sheet CC Panin/Danamon/…',
    'imp.hppDefaultMemo': 'Alokasi HPP dari pengeluaran kartu kredit owner',
    'imp.snack.noCcTotal': 'Belum ada total CC dari workbook',
    'imp.snack.hppFilled': 'HPP diisi {amount} dari CC terpilih/workbook',
    'imp.snack.unsupportedFile': 'Format tidak didukung — Excel, PDF, CSV, OFX, atau gambar e-statement',
    'imp.snack.unsupportedFileNamed': '“{name}” ditolak — gunakan Excel / PDF / CSV / OFX / gambar',
    'imp.snack.unsupportedMany': '{n} file ditolak — gunakan Excel / PDF / CSV / OFX / gambar',
    'imp.snack.parsedStmt': 'E-statement: {n} mutasi dari {files} file',
    'imp.snack.parseEmpty': 'Tidak ada mutasi terbaca — coba file lain atau format Excel workbook',
    'imp.snack.duplicateFile': '“{name}” sudah ada di antrean',
    'imp.snack.queuedMany': '{n} file masuk antrean — klik Baca workbook untuk lanjut',
    'imp.snack.queueReadFail': '{n} file gagal dibaca — coba unggah ulang',
    'imp.snack.queued': '{name} masuk antrean — klik Baca workbook untuk lanjut',
    'imp.snack.needFile': 'Pilih file Excel dulu',
    'imp.snack.parsed':
      'Parsed {bank} bank + {cc} CC · {sheets} sheet bank · CC {ccTotal}{unmatched}',
    'imp.snack.unmatchedSheets': ' · {n} sheet tak dikenali',
    'imp.snack.parseFail': 'Gagal parse Excel',
    'imp.snack.aiGemini': ' · Gemini mengisi {n} baris pintar',
    'imp.snack.aiGroq': ' · Groq (cadangan) mengisi {n} baris pintar',
    'imp.snack.aiOffline': ' · AI offline — pakai rule lokal',
    'imp.snack.aiFail': 'AI gagal — pakai klasifikasi rule lokal',
    'imp.snack.noSelection': 'Tidak ada baris terpilih',
    'imp.snack.sharedPtWarn':
      '{n} baris masih PT Bersama — pilih JGI/JGT agar tidak hilang dari laporan per PT',
    'imp.snack.ccNoPt':
      'CC per baris: {n} baris belum punya PT. Set JGI/JGT dulu, atau centang alokasi HPP proporsional.',
    'imp.snack.dryRun': 'Dry-run: {n} jurnal siap{pool}',
    'imp.snack.dryRunPool': ' + HPP pool {amount}',
    'imp.snack.imported': 'Import: {n} jurnal · skip {skipped}{report}',
    'imp.snack.inReport': ' · masuk laporan',
    'imp.snack.pendingRecon': ' · pending rekonsiliasi',
    'imp.snack.importFail': 'Gagal import',
    'imp.snack.hppPreview': 'Preview HPP: {method} · {amount}',
    'imp.snack.hppAllocated': 'HPP dialokasikan ke {n} PT{report}',
    'imp.snack.hppFail': 'Gagal alokasi',
    'imp.warn.unmatchedSheet':
      'Sheet "{sheet}" tidak dikenali — dilewati. Rename ke Bank BCA/BNI/Mandiri/DBS atau CC Panin/Danamon/Mega/CIMB/DBS.',
    'imp.warn.ccEmpty': 'Sheet CC "{sheet}" dikenali tapi charges = 0',
    'imp.warn.bankEmpty': 'Sheet "{sheet}" dikenali tapi 0 transaksi ter-parse',
    'imp.warn.oddYear': '{count} transaksi di luar 2025–2027 tetap diikutkan (cek tanggal di review).',
    'imp.accountTitle': 'Akun {code}',

    'usr.kicker': 'Kontrol akses',
    'usr.title': 'User & Level Akses',
    'usr.sub':
      'Buat akun, atur level, dan tentukan menu yang boleh dilihat. User tidak bisa dihapus — nonaktifkan saja. Hapus permanen hanya lewat system.',
    'usr.addUser': 'Tambah user',
    'usr.addUserShort': 'User',
    'usr.addLevel': 'Tambah level',
    'usr.addLevelShort': 'Level',
    'usr.editUser': 'Edit user',
    'usr.editLevel': 'Edit level',
    'usr.editShort': 'Edit',
    'usr.levelFormKicker': 'Akses & menu',
    'usr.sectionLevelIdentity': 'Identitas level',
    'usr.sectionLevelSettings': 'Pengaturan',
    'usr.levelCodeHint': 'Kode unik, huruf kecil',
    'usr.levelCodeAuto': 'Otomatis: nomor urut berikutnya yang tersedia',
    'usr.levelNamePreview': 'Level #{code}',
    'usr.levelCodeLocked': 'Kode tidak bisa diubah',
    'usr.rankHint': 'Semakin tinggi = semakin berwenang',
    'usr.rankAutoHint': 'Otomatis dari menu & wewenang yang dipilih',
    'usr.rankLocked': 'Rank level system terkunci',
    'usr.levelDescResize': 'Tarik sudut untuk perbesar',
    'usr.levelDescPlaceholder': 'Jelaskan tugas & batas wewenang level ini…',
    'usr.canManageHint': 'Boleh buka halaman kelola user',
    'usr.canManageOn': 'Aktif',
    'usr.canManageOff': 'Nonaktif',
    'usr.colorHint': 'Warna chip di daftar level',
    'usr.menuAccessSub': 'Pilih halaman yang boleh dibuka',
    'usr.allMenusNote': 'Level ini mendapat akses penuh ke semua menu.',
    'usr.saveLevel': 'Simpan level',
    'usr.createLevel': 'Buat level',
    'usr.tabUsers': 'Akun user',
    'usr.tabUsersShort': 'Akun',
    'usr.tabLevels': 'Level & menu',
    'usr.tabLevelsShort': 'Level',
    'usr.search': 'Cari user / level…',
    'usr.searchLabel': 'Cari',
    'usr.statUsers': 'Total user',
    'usr.statActive': 'Aktif',
    'usr.statInactive': 'Nonaktif',
    'usr.statLevels': 'Level',
    'usr.statToday': 'Perubahan hari ini',
    'usr.statPass': 'Ganti password',
    'usr.statTap': 'Semua akun',
    'usr.statFilter': 'Filter daftar',
    'usr.statReview': '{n} perlu review',
    'usr.statOpenLevels': 'Buka tab level',
    'usr.statJumpHist': 'Ke audit trail',
    'usr.statJumpPass': 'Filter password',
    'usr.vizLevelMix': 'Komposisi level',
    'usr.vizActivity': 'Aktivitas 7 hari',
    'usr.vizActivityHint': 'Jumlah perubahan akses per hari',
    'usr.vizSnapshot': 'Snapshot kontrol',
    'usr.vizEmpty': 'Belum ada data untuk divisualkan',
    'usr.snapActivePct': 'User aktif',
    'usr.snapNever': 'Belum login',
    'usr.snapReview': 'Level perlu review',
    'usr.openLevels': 'Kelola level',
    'usr.openLevelsShort': 'Level',
    'usr.openMenuSyncHist': 'Histori sync menu',
    'usr.openMenuSyncHistShort': 'Sync menu',
    'usr.healthTitle': 'Status akun',
    'usr.healthSub': 'Klik chip untuk filter daftar user.',
    'usr.laneNever': 'Belum login',
    'usr.laneMustPass': 'Wajib ganti sandi',
    'usr.tipsTitle': 'Saran tindakan',
    'usr.tipInactive': '{n} akun nonaktif — tinjau apakah masih dipakai',
    'usr.tipNever': '{n} user belum pernah login — cek undangan / sandi awal',
    'usr.tipMustPass': '{n} user aktif wajib ganti password',
    'usr.tipReviewLevels': '{n} level perlu review menu baru setelah sync',
    'usr.tipToday': '{n} perubahan hari ini — buka audit trail',
    'usr.tipOk': 'Kontrol akses sehat — tidak ada temuan mendesak',
    'usr.focusActive': 'Fokus: user aktif',
    'usr.focusInactive': 'Fokus: user nonaktif',
    'usr.focusNever': 'Fokus: belum pernah login',
    'usr.focusMustPass': 'Fokus: wajib ganti sandi',
    'usr.focusSearch': 'Cari: “{q}”',
    'usr.focusHist': 'Histori: {f}',
    'usr.clearFocus': 'Hapus filter',
    'usr.emptyUsersFiltered': 'Tidak ada user cocok filter',
    'usr.emptyUsersFilteredHint': 'Ubah pencarian atau hapus fokus status.',
    'usr.emptyUsersHint': 'Tambah user pertama untuk mulai mengelola akses.',
    'usr.hist.emptyHint': 'Aktivitas user & level akan muncul di sini setelah ada perubahan.',
    'usr.noDeleteNote':
      'Tidak ada tombol hapus user. Nonaktifkan akun yang tidak dipakai. User bertanda system terkunci. Klik ikon mata di password untuk melihat sandi; klik riwayat di bawahnya untuk timeline.',
    'usr.emptyUsers': 'Belum ada user',
    'usr.colUser': 'User',
    'usr.colName': 'Nama',
    'usr.colAccount': 'Akun',
    'usr.colContact': 'Kontak',
    'usr.colPassword': 'Password',
    'usr.colLevel': 'Level',
    'usr.colStatus': 'Status',
    'usr.colLogin': 'Login terakhir',
    'usr.colActions': 'Aksi',
    'usr.active': 'Aktif',
    'usr.inactive': 'Nonaktif',
    'usr.mustChange': 'Ganti sandi',
    'usr.passSet': 'Tersimpan',
    'usr.passNever': 'Belum pernah diganti',
    'usr.revealPass': 'Tampilkan password',
    'usr.hidePass': 'Sembunyikan password',
    'usr.passNoVault': 'Password lama belum bisa dilihat. Ganti password sekali agar tersimpan di vault.',
    'usr.passRevealFail': 'Gagal menampilkan password',
    'usr.lastLogin': 'Login terakhir',
    'usr.neverLogin': 'Belum pernah login',
    'usr.copyUser': 'Salin username',
    'usr.viewPassHistory': 'Riwayat password',
    'usr.noName': 'Nama belum diisi',
    'usr.edit': 'Edit',
    'usr.changePass': 'Ganti password',
    'usr.activate': 'Aktifkan',
    'usr.deactivate': 'Nonaktifkan',
    'usr.editMenus': 'Atur menu',
    'usr.canManage': 'Kelola user',
    'usr.allMenus': 'Semua menu',
    'usr.menuCount': '{n} menu',
    'usr.formKicker': 'Form akun',
    'usr.createUser': 'Buat user',
    'usr.sectionIdentity': 'Identitas',
    'usr.sectionContact': 'Kontak',
    'usr.sectionAccount': 'Akun & keamanan',
    'usr.sectionStatus': 'Status & kebijakan',
    'usr.sectionIdentityHint': 'Nama resmi yang tampil di daftar user dan audit trail.',
    'usr.sectionContactHint': 'Dipakai untuk notifikasi dan verifikasi akun.',
    'usr.sectionAccountHint': 'Kredensial login dan level wewenang di aplikasi.',
    'usr.sectionStatusHint': 'Atur kebijakan password dan status akses akun.',
    'usr.firstName': 'Nama depan',
    'usr.lastName': 'Nama belakang',
    'usr.username': 'Username',
    'usr.usernameHint': 'Otomatis dari nama, bisa diubah sebelum disimpan.',
    'usr.usernameLocked': 'Username tidak dapat diubah setelah akun dibuat.',
    'usr.levelHint': 'Menentukan menu dan wewenang yang tersedia.',
    'usr.displayName': 'Nama tampilan',
    'usr.email': 'Email',
    'usr.phone': 'No. telepon',
    'usr.phoneHint': 'Contoh: 08xxxxxxxxxx',
    'usr.phFirstName': 'Contoh: Budi',
    'usr.phLastName': 'Contoh: Santoso',
    'usr.phEmail': 'nama@perusahaan.com',
    'usr.phPhone': '08xxxxxxxxxx',
    'usr.phUsername': 'nama.user',
    'usr.phLevel': 'Pilih level akses',
    'usr.phPassword': 'Minimal 8 karakter',
    'usr.phPasswordConfirm': 'Ulangi password yang sama',
    'usr.level': 'Level akses',
    'usr.employeeLink': 'Tautan karyawan (portal)',
    'usr.employeeNone': '— Tidak ditautkan —',
    'usr.employeeNoneHint': 'User tidak bisa pakai portal slip/kasbon',
    'usr.employeeHint': 'Wajib untuk level Karyawan (Staff) agar bisa lihat gaji & ajukan kasbon.',
    'usr.employeeResign': 'Resign',
    'usr.phEmployee': 'Cari nama karyawan / PT…',
    'usr.taxClientLink': 'Tautan klien pajak (customer)',
    'usr.taxClientNone': '— Tidak ditautkan —',
    'usr.taxClientHint': 'Wajib untuk level Customer agar bisa ajukan request laporan pajak.',
    'usr.phTaxClient': 'Cari kode / nama klien…',
    'usr.password': 'Password',
    'usr.mustChangePass': 'Wajib ganti password saat login berikutnya',
    'usr.mustChangeShort': 'Ganti password',
    'usr.mustChangePassHint': 'User harus membuat password baru di login berikutnya.',
    'usr.mustChangeOn': 'Wajib',
    'usr.mustChangeOff': 'Tidak wajib',
    'usr.accountStatus': 'Status akun',
    'usr.activeHint': 'Akun nonaktif tidak bisa masuk ke aplikasi.',
    'usr.newPassword': 'Password baru',
    'usr.confirmPassword': 'Ulangi password',
    'usr.savePass': 'Simpan password',
    'usr.passFormKicker': 'Keamanan akun',
    'usr.passSection': 'Password baru',
    'usr.passSectionHint': 'Masukkan password baru dua kali. Gunakan ikon mata untuk memeriksa sebelum menyimpan.',
    'usr.passTipLength': 'Minimal 8 karakter (lebih panjang lebih aman).',
    'usr.passTipMix': 'Campur huruf, angka, dan simbol bila memungkinkan.',
    'usr.passTipUnique': 'Jangan pakai password yang sama dengan akun lain.',
    'usr.levelCode': 'Kode level',
    'usr.levelName': 'Nama level',
    'usr.levelDesc': 'Deskripsi',
    'usr.rank': 'Rank',
    'usr.color': 'Warna',
    'usr.menuAccess': 'Menu yang boleh dilihat',
    'usr.forbidden': 'Level Anda tidak boleh membuka halaman ini',
    'usr.loadFail': 'Gagal memuat data user',
    'usr.hist.kicker': 'Audit trail',
    'usr.hist.title': 'History perubahan',
    'usr.hist.sub': 'Semua aktivitas: tambah user, ganti password, update profil, level, sync menu, aktif/nonaktif.',
    'usr.hist.refresh': 'Muat ulang',
    'usr.hist.refreshShort': 'Ulang',
    'usr.hist.search': 'Cari di history…',
    'usr.hist.searchLabel': 'Cari',
    'usr.hist.empty': 'Belum ada history perubahan',
    'usr.hist.filterAll': 'Semua',
    'usr.hist.filterPass': 'Password',
    'usr.hist.filterPassShort': 'Password',
    'usr.hist.filterCreate': 'Tambah user',
    'usr.hist.filterCreateShort': 'Tambah',
    'usr.hist.filterUpdate': 'Update',
    'usr.hist.filterLevel': 'Level',
    'usr.hist.filterMenuSync': 'Update menu',
    'usr.hist.filterMenuSyncShort': 'Menu',
    'usr.hist.password': 'Password',
    'usr.hist.create': 'Tambah',
    'usr.hist.update': 'Update',
    'usr.hist.activate': 'Aktifkan',
    'usr.hist.deactivate': 'Nonaktif',
    'usr.hist.levelCreate': 'Level baru',
    'usr.hist.levelUpdate': 'Level diubah',
    'usr.hist.menuSync': 'Sync menu',
    'usr.sync.title': 'Katalog menu & akses',
    'usr.sync.kicker': 'Sinkronisasi otoritas',
    'usr.sync.desc':
      'Tarik semua halaman & menu terbaru. Admin / Super System otomatis centang semua. Level lain bisa di-review checklist-nya.',
    'usr.sync.update': 'Update',
    'usr.sync.updateNow': 'Update Now',
    'usr.sync.lastUpdate': 'Update terakhir',
    'usr.sync.never': 'Belum pernah di-update. Klik Update Now untuk tarik semua halaman.',
    'usr.sync.neverShort': 'Belum ada sync. Tekan Update Now.',
    'usr.sync.updating': 'Memperbarui…',
    'usr.sync.paths': '{n} path',
    'usr.sync.autoFull': 'Admin full · {n}',
    'usr.sync.autoFullHint': 'Admin & Super System sudah otomatis full akses.',
    'usr.sync.fullAccess': 'Full akses',
    'usr.sync.bootstrap': 'Katalog disinkronkan · {n} path · admin full otomatis ({a})',
    'usr.sync.foundNew': '{n} akses baru · admin full otomatis ({a}) — review level lain',
    'usr.sync.upToDate': 'Sudah terbaru · {n} path · admin full ({a})',
    'usr.sync.fail': 'Gagal update katalog menu',
    'usr.sync.newFound': '{n} menu/akses baru',
    'usr.sync.reviewHint': '{n} level perlu review checklist',
    'usr.sync.reviewChip': '{n} baru',
    'usr.sync.newChip': '{n} baru',
    'usr.sync.onlyNew': 'Hanya yang baru',
    'usr.sync.checkNew': 'Centang semua baru',
    'usr.sync.checkedNew': 'Menu baru dicentang — simpan level untuk menerapkan',
    'usr.sync.badgeNew': 'Baru',
    'usr.sync.noNewInFilter': 'Tidak ada menu baru di filter ini',
    'usr.hist.passKicker': 'Riwayat password',
    'usr.hist.passEmpty': 'Belum ada riwayat ganti password untuk user ini',
    'usr.hist.passEmptyHint': 'Saat password diganti, setiap perubahan akan tercatat di sini lengkap dengan tanggal dan aktor.',
    'usr.hist.passTimeline': 'Timeline perubahan',
    'usr.hist.passTimelineHint': 'Urutan terbaru di atas. Semuanya dari audit trail aplikasi.',
    'usr.hist.passCount': 'Total ganti',
    'usr.hist.passLast': 'Terakhir diganti',
    'usr.hist.passLatest': 'Terbaru',
    'usr.hist.day': 'Tanggal',
    'usr.hist.month': 'Bulan',
    'usr.hist.year': 'Tahun',
    'usr.hist.clock': 'Jam',
    'usr.snack.userCreated': 'User dibuat',
    'usr.snack.userUpdated': 'User diperbarui',
    'usr.snack.levelCreated': 'Level dibuat',
    'usr.snack.levelUpdated': 'Level diperbarui',
    'usr.snack.passChanged': 'Password diganti',
    'usr.snack.passMismatch': 'Password tidak sama',
    'usr.snack.saveFail': 'Gagal menyimpan',
    'usr.snack.systemLocked': 'User system tidak bisa dinonaktifkan',
    'usr.snack.activated': 'User diaktifkan',
    'usr.snack.deactivated': 'User dinonaktifkan',
    'usr.snack.copied': 'Username @{user} disalin',
    'usr.snack.copyFail': 'Gagal menyalin',

    'ob.title': 'Saldo Awal',
    'ob.kicker': 'Setup buku',
    'ob.sub':
      'Input neraca pembuka agar Laporan Keuangan balance. Jurnal diposting sehari sebelum tanggal “Per”. Contoh: Per 1 Jan 2026 → posting 31 Des 2025.',
    'ob.postingDateLabel': 'Tanggal posting jurnal',
    'ob.postingHint': 'Per {asOf} → jurnal sehari sebelumnya',
    'ob.formKicker': 'Form saldo awal',
    'ob.statusReady': 'Balance siap simpan',
    'ob.statusDiff': 'Selisih {n}',
    'ob.statusEmpty': 'Belum diisi',
    'ob.asOfLabel': 'Per tanggal (awal periode)',
    'ob.description': 'Keterangan',
    'ob.memoPlaceholder': 'Contoh: Opening balance 1 Jan 2026',
    'ob.memoAuto': 'Saldo awal {code} per {date}',
    'ob.tip':
      'Tip: isi Kas, Bank, Piutang Pemegang Saham, Hutang Usaha, Modal, Laba Ditahan.',
    'ob.tipBold': 'Total Debit harus sama dengan Total Kredit.',
    'ob.filledLines': 'Baris terisi',
    'ob.totalDebit': 'Total Debit',
    'ob.totalCredit': 'Total Kredit',
    'ob.diff': 'Selisih',
    'ob.pickAccount': 'Pilih akun',
    'ob.addLine': 'Tambah Baris',
    'ob.addFive': '+5 baris',
    'ob.clearLines': 'Kosongkan',
    'ob.save': 'Simpan Saldo Awal',
    'ob.snack.minLines': 'Minimal 2 baris',
    'ob.snack.saved': 'Saldo awal tersimpan {ref} (posting {date})',
    'ob.snack.template': 'Template diisi · {n} akun terdeteksi',
    'ob.snack.tplMissing': 'Akun template tidak ditemukan di COA',
    'ob.snack.alreadyBalanced': 'Sudah balance',
    'ob.snack.noRe': 'Akun Laba Ditahan / equity tidak ditemukan',
    'ob.snack.autoBal': 'Selisih {amt} dialihkan ke {acct}',
    'ob.snack.csv': 'Draft CSV diunduh',
    'ob.snack.dupWarn': 'Ada akun dobel — periksa sebelum simpan',
    'ob.snack.dupBlock': 'Ada akun dobel. Perbaiki dulu, atau centang override di peringatan.',
    'ob.snack.ptCleared': 'PT diganti — baris dikosongkan agar akun tidak tercampur',
    'ob.snack.loadedExisting': 'Memuat saldo awal {ref} ke form',
    'ob.existingTitle': 'Sudah ada saldo awal · Ref {ref}',
    'ob.existingSub': 'Posting jurnal {date}. Muat ulang ke form atau buka Ref.',
    'ob.existingLoad': 'Muat ke form',
    'ob.flowAria': 'Alur saldo awal',
    'ob.dupOverride': 'Saya paham — izinkan simpan dengan akun dobel',
    'ob.progress': 'Progress {n}/{total}',
    'ob.flow1': 'Pilih PT',
    'ob.flow2': 'Set tanggal Per',
    'ob.flow3': 'Isi baris akun',
    'ob.flow4': 'Balance & simpan',
    'ob.linkLk': 'Import dari LK PDF',
    'ob.linkHistory': 'Riwayat saldo awal',
    'ob.linkBs': 'Lihat neraca',
    'ob.coachKicker': 'Panduan meja',
    'ob.coachTitle': 'Checklist sebelum posting',
    'ob.check.pt': 'PT dipilih',
    'ob.check.date': 'Tanggal Per terisi',
    'ob.check.lines': 'Minimal 2 baris bernilai',
    'ob.check.dup': 'Tidak ada akun dobel',
    'ob.check.bal': 'Debit = Kredit',
    'ob.keySave': 'simpan',
    'ob.keyAdd': 'tambah baris',
    'ob.tpl.kicker': 'Kerangka cepat',
    'ob.tpl.title': 'Akun tipikal saldo awal',
    'ob.tpl.apply': 'Isi kerangka',
    'ob.tpl.dummy': 'Isi dummy balance',
    'ob.tpl.missing': 'Tidak ketemu di COA',
    'ob.tpl.cash': 'Kas',
    'ob.tpl.bank': 'Bank',
    'ob.tpl.ar': 'Piutang usaha',
    'ob.tpl.arStaff': 'Piutang karyawan',
    'ob.tpl.arRelated': 'Piutang pihak berelasi',
    'ob.tpl.inv': 'Persediaan',
    'ob.tpl.prepaid': 'Dibayar di muka',
    'ob.tpl.prepaidTax': 'Pajak dibayar di muka',
    'ob.tpl.fa': 'Aktiva tetap',
    'ob.tpl.accum': 'Akumulasi penyusutan',
    'ob.tpl.ap': 'Hutang usaha',
    'ob.tpl.tax': 'Hutang pajak',
    'ob.tpl.unearned': 'Uang muka pelanggan',
    'ob.tpl.cc': 'Utang kartu kredit',
    'ob.tpl.owner': 'Hutang owner',
    'ob.tpl.intangible': 'Aset tidak berwujud',
    'ob.tpl.equity': 'Modal',
    'ob.tpl.re': 'Laba ditahan',
    'ob.lk.kicker': 'Statement / LK',
    'ob.lk.title': 'Upload neraca PDF',
    'ob.lk.sub': 'Parse LK (dry-run) lalu masukkan baris ke tabel — tanpa posting otomatis.',
    'ob.lk.parse': 'Parse preview',
    'ob.lk.apply': 'Masukkan ke tabel',
    'ob.lk.clear': 'Hapus file',
    'ob.lk.pickFile': 'Pilih file PDF / TXT',
    'ob.lk.needFile': 'Pilih file PDF/TXT dulu',
    'ob.lk.parsed': 'Preview siap · {n} baris terdeteksi',
    'ob.lk.applied': '{n} baris dari LK dimasukkan ke tabel',
    'ob.lk.empty': 'Tidak ada baris neraca di preview',
    'ob.lk.previewMeta': '{pt} · {n} baris · Per {asOf}',
    'ob.linkLkFull': 'Buka Import Statement',
    'ob.col.lineRef': 'No Ref',
    'ob.col.code': 'Kode',
    'ob.col.type': 'Tipe',
    'ob.col.accountNo': 'No rekening',
    'ob.col.accountNoEmpty': 'Belum diisi',
    'ob.col.kasBank': 'Kas/Bank',
    'ob.col.cashName': 'Nama kas',
    'ob.col.contra': 'Akun lawan',
    'ob.col.contraPh': 'Pilih lawan',
    'ob.col.contraType': 'Tipe lawan',
    'ob.col.desc': 'Keterangan',
    'ob.col.descPh': 'Catatan baris',
    'ob.col.journalRef': 'Fingerprint jurnal',
    'ob.col.officialRef': 'Ref resmi (J7P)',
    'ob.col.fingerprint': 'Fingerprint OB',
    'ob.refPreviewHint': 'Angka berikutnya yang available — dikunci saat simpan (yang telat dapat nomor berikutnya)',
    'ob.refSavedHint': 'Ref resmi jurnal ini (unik, tidak double)',
    'ob.fingerprintHint': 'Kunci idempotent PT+tanggal — simpan ulang tidak buat jurnal baru',
    'ob.snack.dummy': 'Dummy balance diisi · {n} akun',
    'ob.snack.skippedDup': 'Sudah ada saldo awal · memakai Ref {ref} (tidak double)',
    'ob.typeAll': 'Semua tipe',
    'ob.typeAsset': 'Aset',
    'ob.typeLiability': 'Liabilitas',
    'ob.typeEquity': 'Ekuitas',
    'ob.typeRevenue': 'Pendapatan',
    'ob.typeExpense': 'Beban',
    'ob.dateThisFy': '1 Jan {year}',
    'ob.datePrevFy': '1 Jan {year}',
    'ob.dupAlert': 'Ada akun yang dipilih lebih dari sekali. Gabungkan atau ganti salah satunya.',
    'ob.savedTitle': 'Tersimpan · Ref {ref}',
    'ob.savedSub': 'Posting jurnal {date}',
    'ob.openRef': 'Buka Ref',
    'ob.hideEmpty': 'Sembunyikan kosong',
    'ob.showEmpty': 'Tampilkan kosong',
    'ob.autoBalance': 'Auto-balance selisih',
    'ob.exportCsv': 'Ekspor draft CSV',
    'ob.expand': 'Perbesar tabel',
    'ob.collapse': 'Kecilkan',
    'ob.expandTitle': 'Tabel saldo awal — layar penuh',
    'ob.confirmTitle': 'Konfirmasi simpan saldo awal',
    'ob.confirmBody': 'Posting untuk {pt} · Per {asOf} · jurnal {post}.',
    'ob.confirmDebit': 'Total Debit {n}',
    'ob.confirmCredit': 'Total Kredit {n}',
    'ob.confirmLines': '{n} baris terisi',

    'co.title': 'NPWP & Perusahaan',
    'co.kicker': 'Identitas & birokrasi pajak',
    'co.sub':
      'Input manual NPWP, KPP, NITKU, PKP, dan data terkait SPT. Sel kosong ditandai merah — lengkapi sebelum export.',
    'co.addCompany': 'Tambah PT',
    'co.statTotal': 'Total PT',
    'co.statNpwpOk': 'NPWP lengkap',
    'co.statNpwpMissing': 'NPWP kosong',
    'co.statIncomplete': 'Data birokrasi kurang',
    'co.listKicker': 'Master list',
    'co.listTitle': 'Daftar PT & data pajak',
    'co.searchPh': 'Cari kode / nama / NPWP / KPP…',
    'co.colNo': 'No',
    'co.colCode': 'Kode',
    'co.colName': 'Nama PT',
    'co.colNpwp': 'NPWP',
    'co.colAddress': 'Alamat',
    'co.colCity': 'Kota',
    'co.colKpp': 'KPP',
    'co.colNitku': 'NITKU',
    'co.colPkp': 'PKP',
    'co.colTaxPic': 'PIC Pajak',
    'co.colStatus': 'Status',
    'co.colAction': 'Aksi',
    'co.pphFinal': 'PPh Final {rate}%',
    'co.pkp': 'PKP',
    'co.nonPkp': 'Non-PKP',
    'co.statusIncomplete': 'Belum lengkap',
    'co.statusReady': 'Siap SPT',
    'co.editSave': 'Edit & Simpan',
    'co.empty':
      'Belum ada data PT — klik Tambah PT untuk input NPWP & birokrasi pajak',
    'co.alertIncomplete':
      'Ada {n} PT dengan data birokrasi kurang (NPWP / alamat / KPP). Edit manual lalu simpan sebelum export SPT.',
    'co.goSpt': 'Ke SPT Masa',
    'co.dialogEdit': 'Edit manual',
    'co.dialogNew': 'Tambah baru',
    'co.dialogEditTitle': 'Edit {code}',
    'co.dialogAddTitle': 'Tambah PT + NPWP',
    'co.tabIdentity': 'Identitas',
    'co.tabTax': 'Birokrasi pajak',
    'co.tabContact': 'Kontak & PIC',
    'co.codeLabel': 'Kode PT *',
    'co.codeHint': 'Contoh: JGI, JGT',
    'co.nameLabel': 'Nama lengkap PT *',
    'co.npwpLabel': 'NPWP *',
    'co.npwpHint': '15/16 digit — otomatis diformat',
    'co.required': 'Wajib diisi',
    'co.npwpIncomplete': 'NPWP belum lengkap (15/16 digit)',
    'co.addressLabel': 'Alamat lengkap *',
    'co.addressRequired': 'Wajib untuk SPT',
    'co.cityLabel': 'Kota / Kabupaten',
    'co.pphRateLabel': 'Tarif PPh Final (0.005 = 0.5%)',
    'co.kppLabel': 'Nama KPP *',
    'co.kppHint': 'Contoh: KPP Pratama Tangerang Barat',
    'co.kppRequired': 'Wajib untuk birokrasi pajak',
    'co.kppCodeLabel': 'Kode KPP',
    'co.nitkuLabel': 'NITKU',
    'co.nitkuHint': 'Nomor Identitas Tempat Kegiatan Usaha',
    'co.kluLabel': 'KLU / Bidang usaha',
    'co.pkpSwitch': 'Status PKP (Pengusaha Kena Pajak)',
    'co.pkpDateLabel': 'Tanggal pengukuhan PKP',
    'co.taxPicLabel': 'Nama PIC / penanggung jawab pajak',
    'co.taxPicNpwpLabel': 'NPWP PIC',
    'co.phoneLabel': 'Telepon',
    'co.emailLabel': 'Email',
    'co.saveCompany': 'Simpan data PT',
    'co.snack.nameRequired': 'Nama PT wajib',
    'co.snack.codeRequired': 'Kode PT wajib',
    'co.snack.saved': 'Data NPWP & birokrasi PT disimpan',
    'co.snack.added': 'PT baru ditambahkan',
    'co.snack.saveFail': 'Gagal simpan',
    'co.statReady': 'Siap SPT',
    'co.statNoPic': 'Tanpa PIC',
    'co.showing': '{n} PT tampil',
    'co.readyPct': 'Siap {pct}%',
    'co.incompleteN': '{n} belum lengkap',
    'co.readyHint': '{ok} siap SPT · {need} perlu dilengkapi',
    'co.needAttention': '{n} item perlu perhatian',
    'co.vizReady': 'Kesiapan SPT',
    'co.vizGaps': 'Field yang masih kosong',
    'co.vizPt': 'Kelengkapan per PT',
    'co.vizPkp': 'PKP {pkp} · Non-PKP {non}',
    'co.filterBar': 'Filter PT & pencarian',
    'co.healthTitle': 'Status kesehatan data pajak',
    'co.healthSub': 'Klik lane untuk fokus PT yang perlu dilengkapi.',
    'co.clearLane': 'Tampilkan semua',
    'co.lane.all': 'Semua',
    'co.lane.ready': 'Siap SPT',
    'co.lane.incomplete': 'Belum lengkap',
    'co.lane.npwp_missing': 'NPWP kosong',
    'co.lane.npwp_ok': 'NPWP lengkap',
    'co.lane.pkp': 'PKP',
    'co.lane.non_pkp': 'Non-PKP',
    'co.lane.no_pic': 'Tanpa PIC',
    'co.tipsTitle': 'Saran cepat · data pajak rapi',
    'co.tipsShow': 'Tampilkan',
    'co.tipsHide': 'Sembunyikan',
    'co.tip1': 'Prioritaskan NPWP, alamat, dan KPP — tanpa itu status tetap Belum lengkap.',
    'co.tip2': 'Isi NITKU & PIC pajak agar dokumen SPT dan surat menyurat siap.',
    'co.tip3': 'Klik chip merah pada baris untuk melihat field yang masih kosong.',
    'co.tip4': 'Ekspor CSV setelah data lengkap — filter aktif ikut terbawa.',
    'co.tipActEdit': 'Edit {n} PT belum lengkap',
    'co.tipActIncomplete': 'Filter belum lengkap ({n})',
    'co.tipActNpwp': 'Filter NPWP kosong ({n})',
    'co.tipActPic': 'Filter tanpa PIC ({n})',
    'co.toBank': 'Ke rekening bank',
    'co.exportCsv': 'Ekspor CSV',
    'co.exportEmpty': 'Tidak ada data untuk diekspor',
    'co.exportDone': 'CSV {n} PT diunduh',
    'co.listSub': 'Sel kosong ditandai merah · chip menunjukkan field yang kurang',
    'co.emptyTitle': 'Tidak ada PT cocok',
    'co.emptyFiltered': 'Filter terlalu ketat — reset atau ubah pencarian.',
    'co.resetFilters': 'Reset filter',
    'co.formReady': 'Kelengkapan form {pct}%',

    'acc.title': 'Daftar Akun',
    'acc.eyebrow': 'Master · Chart of Accounts',
    'acc.sub': 'Kelola nomor & nama akun, arah laporan, dan saldo normal — terhubung ke jurnal, rekonsiliasi, dan laporan',
    'acc.add': 'Tambah Akun',
    'acc.addMulti': 'Tambah Multi',
    'acc.expandView': 'Perbesar',
    'acc.collapseView': 'Kecilkan',
    'acc.edit': 'Edit',
    'acc.activate': 'Aktifkan',
    'acc.deactivate': 'Nonaktifkan',
    'acc.search': 'Cari nomor atau nama akun…',
    'acc.empty': 'Tidak ada akun yang cocok',
    'acc.colCode': 'No. Akun',
    'acc.colName': 'Nama Akun',
    'acc.colBand': 'Kelompok',
    'acc.colType': 'Tipe',
    'acc.colMap': 'Arah / Pemetaan',
    'acc.colNormal': 'Normal',
    'acc.colCompany': 'PT',
    'acc.colStatus': 'Status',
    'acc.colLastEdit': 'Terakhir edit',
    'acc.colActions': 'Aksi',
    'acc.log.title': 'Riwayat edit',
    'acc.log.sub': 'Siapa mengubah, tanggal & jam tersimpan otomatis',
    'acc.log.last': 'Edit terakhir',
    'acc.log.empty': 'Belum ada riwayat',
    'acc.log.showMore': 'Lihat semua ({n})',
    'acc.log.showLess': 'Ciutkan',
    'acc.log.action.create': 'Buat',
    'acc.log.action.update': 'Ubah',
    'acc.log.action.activate': 'Aktifkan',
    'acc.log.action.deactivate': 'Nonaktifkan',
    'acc.log.action.bulk': 'Massal',
    'acc.allCompanies': 'Semua',
    'acc.dialogTitle': 'Tambah Akun',
    'acc.dialogEdit': 'Edit Akun',
    'acc.dialogAddEyebrow': 'Akun baru',
    'acc.dialogEditEyebrow': 'Perbarui akun',
    'acc.dialogHint':
      'Pilih tipe → sistem atur arah laporan & saldo normal. Baca penjelasan merah (Debit/Kredit) lalu isi nama akun dengan jelas.',
    'acc.codeEditHint': 'Nomor akun terkunci setelah disimpan',
    'acc.codeLockedHint': 'Nomor terkunci — hanya sistem yang boleh mengubah. Nama & tipe masih bisa diedit.',
    'acc.codeCapacity': 'Jumlah: {used} · Sisa nomor: {remaining} · Cadangan: {reserve} (contoh {example})',
    'acc.codeLabel': 'Nomor akun',
    'acc.nameLabel': 'Nama akun',
    'acc.namePlaceholder': 'Contoh: Kas, Bank BCA, Piutang Usaha…',
    'acc.codeShort': 'No.',
    'acc.nameShort': 'Nama akun',
    'acc.typeLabel': 'Tipe / arah laporan',
    'acc.normalLabel': 'Saldo normal',
    'acc.normalHint': 'Arah default saat menjurnal (Debit atau Kredit)',
    'acc.normalGuide.incLabel': 'Bertambah',
    'acc.normalGuide.decLabel': 'Berkurang',
    'acc.normalGuide.asset.title': 'Saldo normal Aset = Debit',
    'acc.normalGuide.asset.side': 'Debit',
    'acc.normalGuide.asset.meaning':
      'Debit = sisi kiri jurnal (menaikkan aset/beban). Kredit = sisi kanan jurnal (menaikkan utang/modal/pendapatan).',
    'acc.normalGuide.asset.why':
      'Saldo normal = sisi yang membuat saldo akun naik. Aset (kas, bank, piutang, peralatan) naik di sisi Debit — jadi saldo normal aset = Debit.',
    'acc.normalGuide.asset.inc': 'Peralatan (asset) bertambah = Debit',
    'acc.normalGuide.asset.dec': 'Peralatan (asset) berkurang = Kredit',
    'acc.normalGuide.asset.tip':
      'Contoh: beli peralatan Rp10jt → Debit Peralatan, Kredit Bank/Kas. Jual/keluarkan aset → Kredit aset, Debit Bank/Kas/beban.',
    'acc.normalGuide.liability.title': 'Saldo normal Kewajiban = Kredit',
    'acc.normalGuide.liability.side': 'Kredit',
    'acc.normalGuide.liability.meaning':
      'Debit = sisi kiri. Kredit = sisi kanan. Utang naik di Kredit; bayar utang = Debit utang.',
    'acc.normalGuide.liability.why':
      'Kewajiban (utang usaha, utang pajak, dll.) naik di sisi Kredit. Saldo normal kewajiban = Kredit.',
    'acc.normalGuide.liability.inc': 'Utang usaha (kewajiban) bertambah = Kredit',
    'acc.normalGuide.liability.dec': 'Utang usaha (kewajiban) berkurang / dibayar = Debit',
    'acc.normalGuide.liability.tip':
      'Contoh: terima barang belum bayar → Debit Beban/Persediaan, Kredit Utang. Bayar utang → Debit Utang, Kredit Bank.',
    'acc.normalGuide.equity.title': 'Saldo normal Ekuitas = Kredit',
    'acc.normalGuide.equity.side': 'Kredit',
    'acc.normalGuide.equity.meaning':
      'Modal pemilik naik di Kredit (setor modal, laba). Ambil modal / prive = Debit ekuitas.',
    'acc.normalGuide.equity.why':
      'Modal / ekuitas pemilik naik di sisi Kredit. Saldo normal ekuitas = Kredit.',
    'acc.normalGuide.equity.inc': 'Modal (ekuitas) bertambah = Kredit',
    'acc.normalGuide.equity.dec': 'Modal (ekuitas) berkurang / diambil pemilik = Debit',
    'acc.normalGuide.equity.tip':
      'Contoh: setor modal → Debit Kas/Bank, Kredit Modal. Owner keluar uang → Debit Piutang pihak berelasi (1202), Kredit Bank. Owner masuk uang → Debit Bank, Kredit Hutang Owner (2400).',
    'acc.normalGuide.revenue.title': 'Saldo normal Pendapatan = Kredit',
    'acc.normalGuide.revenue.side': 'Kredit',
    'acc.normalGuide.revenue.meaning':
      'Pendapatan menambah laba → dicatat Kredit. Koreksi/batal pendapatan = Debit pendapatan.',
    'acc.normalGuide.revenue.why':
      'Pendapatan menambah ekuitas, naik di sisi Kredit. Saldo normal pendapatan = Kredit.',
    'acc.normalGuide.revenue.inc': 'Pendapatan jasa bertambah = Kredit',
    'acc.normalGuide.revenue.dec': 'Pendapatan dikoreksi / dibatalkan = Debit',
    'acc.normalGuide.revenue.tip':
      'Contoh: terima bayaran jasa → Debit Kas/Bank/Piutang, Kredit Pendapatan. Refund → Debit Pendapatan.',
    'acc.normalGuide.expense.title': 'Saldo normal Beban = Debit',
    'acc.normalGuide.expense.side': 'Debit',
    'acc.normalGuide.expense.meaning':
      'Beban mengurangi laba → dicatat Debit. Koreksi kelebihan beban = Kredit beban.',
    'acc.normalGuide.expense.why':
      'Beban mengurangi laba/ekuitas, naik di sisi Debit. Saldo normal beban = Debit.',
    'acc.normalGuide.expense.inc': 'Biaya gaji (beban) bertambah = Debit',
    'acc.normalGuide.expense.dec': 'Biaya gaji dikoreksi / dikembalikan = Kredit',
    'acc.normalGuide.expense.tip':
      'Contoh: bayar gaji → Debit Biaya Gaji, Kredit Bank. Koreksi kelebihan catat → Kredit Beban.',
    'acc.nameGuide.asset.title': 'Cara isi nama akun (Aset)',
    'acc.nameGuide.asset.hint':
      'Pakai nama jelas & spesifik. Jangan tulis “JGI/JGT” di nama — PT dipilih di jurnal. Satu bank = satu nama shared.',
    'acc.nameGuide.asset.examples':
      'Contoh bagus: Kas · Bank BCA · Bank BNI · Piutang Usaha · Peralatan Gudang · Persediaan Barang',
    'acc.nameGuide.liability.title': 'Cara isi nama akun (Kewajiban)',
    'acc.nameGuide.liability.hint':
      'Sebut jenis utangnya supaya jurnal mudah dibaca. Hindari singkatan yang membingungkan.',
    'acc.nameGuide.liability.examples':
      'Contoh bagus: Utang Usaha · Utang Reimburse Kartu Kredit · Hutang Pajak - PPh 21 · Hutang PPh Final',
    'acc.nameGuide.equity.title': 'Cara isi nama akun (Ekuitas)',
    'acc.nameGuide.equity.hint':
      'Pisahkan modal per pemilik bila perlu. Mutasi owner & transfer internal bukan ekuitas — itu piutang (1202 / 1203).',
    'acc.nameGuide.equity.examples':
      'Contoh bagus: Modal · Modal Lim Sulaiman Jaya · Modal Andi Chandra · Saldo Laba Ditahan',
    'acc.nameGuide.revenue.title': 'Cara isi nama akun (Pendapatan)',
    'acc.nameGuide.revenue.hint':
      'Satu jenis pendapatan = satu akun. Jangan campur bunga bank dengan pendapatan jasa.',
    'acc.nameGuide.revenue.examples':
      'Contoh bagus: Pendapatan Jasa Gudang · Pendapatan Lain - Bunga Bank · Pendapatan Sewa',
    'acc.nameGuide.expense.title': 'Cara isi nama akun (Beban)',
    'acc.nameGuide.expense.hint':
      'Kelompokkan biaya agar laporan jelas. Satu jenis beban utama = satu akun.',
    'acc.nameGuide.expense.examples':
      'Contoh bagus: Biaya Gaji dan Tunjangan · Biaya Admin Bank · Biaya Operasional Lain · HPP',
    'acc.companyOptional': 'Perusahaan',
    'acc.mapLabel': 'Pemetaan',
    'acc.map.asset': 'Neraca · Aktiva',
    'acc.map.liability': 'Neraca · Kewajiban',
    'acc.map.equity': 'Neraca · Ekuitas',
    'acc.map.revenue': 'Laba Rugi · Pendapatan',
    'acc.map.expense': 'Laba Rugi · Beban',
    'acc.status.active': 'Aktif',
    'acc.status.inactive': 'Nonaktif',
    'acc.stat.total': 'Total akun',
    'acc.stat.active': 'Aktif',
    'acc.stat.inactive': 'Nonaktif',
    'acc.stat.totalHint': 'Klik untuk reset semua filter',
    'acc.stat.activeHint': 'Klik untuk filter akun aktif',
    'acc.stat.inactiveHint': 'Klik untuk filter akun nonaktif',
    'acc.type.asset': 'Aset',
    'acc.type.liability': 'Kewajiban',
    'acc.type.equity': 'Ekuitas',
    'acc.type.revenue': 'Pendapatan',
    'acc.type.expense': 'Beban',
    'acc.bandsTitle': 'Kelas kode akun',
    'acc.bandsHint': 'Dikelompokkan sesuai pos laporan (PSAK 1). Nomor mengikuti kelas: kas 1000, piutang 1200, utang pajak 2300, …',
    'acc.view.ledger': 'Buku besar',
    'acc.view.table': 'Tabel',
    'acc.print': 'Cetak bagan',
    'acc.printTitle': 'Bagan Akun',
    'acc.printMeta': 'Dicetak {date} · {n} akun',
    'acc.exportCsv': 'Ekspor CSV',
    'acc.exportEmpty': 'Tidak ada akun untuk diekspor',
    'acc.exportDone': 'CSV {n} akun diunduh',
    'acc.ledgerCount': '{n} akun tampil',
    'acc.ledgerAccounts': '{n} akun',
    'acc.colFs': 'Pos laporan',
    'acc.vizStmt': 'Pos laporan',
    'acc.liq.current': 'Lancar',
    'acc.liq.noncurrent': 'Tidak lancar',
    'acc.liq.equity': 'Ekuitas',
    'acc.liq.pl': 'Laba rugi',
    'acc.stmt.bs_ca': 'Aktiva Lancar',
    'acc.stmt.bs_nca': 'Aktiva Tidak Lancar',
    'acc.stmt.bs_cl': 'Kewajiban Lancar',
    'acc.stmt.bs_ncl': 'Kewajiban Jangka Panjang',
    'acc.stmt.bs_eq': 'Ekuitas',
    'acc.stmt.pl_rev': 'Pendapatan',
    'acc.stmt.pl_exp': 'Beban',
    'acc.class.kas': 'Kas / setara kas',
    'acc.class.persediaan': 'Persediaan',
    'acc.class.piutang': 'Piutang',
    'acc.class.prepaid': 'Dibayar di muka',
    'acc.class.prepaid_tax': 'Pajak dibayar di muka',
    'acc.class.fixed_asset': 'Aset tetap',
    'acc.class.accum_depr': 'Akumulasi penyusutan',
    'acc.class.accum_amort': 'Akumulasi amortisasi',
    'acc.class.intangible': 'Aset tak berwujud',
    'acc.class.other_nca': 'Aset tidak lancar lain',
    'acc.class.hutang_usaha': 'Utang usaha',
    'acc.class.hutang_ops': 'Utang operasional',
    'acc.class.hutang_pajak': 'Utang pajak',
    'acc.class.hutang_owner': 'Utang owner',
    'acc.class.hutang_ic': 'Utang antar perusahaan',
    'acc.class.unearned': 'Diterima di muka',
    'acc.class.hutang_cc': 'Utang kartu kredit / bank',
    'acc.class.hutang_lt': 'Liabilitas jangka panjang',
    'acc.class.equity': 'Ekuitas',
    'acc.class.revenue': 'Pendapatan',
    'acc.class.expense': 'Beban',
    'acc.clearBand': 'Hapus filter kelas',
    'acc.codeAutoHint': 'Otomatis dari nama/kelas · rentang {range} · Regenerasi = nomor kosong berikutnya',
    'acc.codeManualHint': 'Nomor diubah manual — klik Regenerasi untuk isi otomatis lagi',
    'acc.codeRegen': 'Regenerasi',
    'acc.multiTitle': 'Tambah akun multi-baris',
    'acc.multiHint': 'Pilih tipe — nomor mengikuti kelas dari nama (persediaan 1100, piutang 1200, …). Isi nama saja.',
    'acc.multiApplyDefaults': 'Terapkan tipe ke semua baris',
    'acc.multiAddRow': 'Tambah baris',
    'acc.cap.used': 'Jumlah terpakai',
    'acc.cap.remaining': 'Sisa nomor',
    'acc.cap.reserve': 'Cadangan',
    'acc.cap.overflow': 'Contoh cadangan',
    'acc.multiRemoveRow': 'Hapus baris',
    'acc.multiNoRows': 'Belum ada baris. Klik Tambah baris untuk mulai.',
    'acc.multiReady': '{n} baris siap disimpan',
    'acc.multiSave': 'Simpan {n} akun',
    'acc.bulk.selected': '{n} akun dipilih',
    'acc.bulk.edit': 'Edit massal',
    'acc.bulk.title': 'Edit massal akun',
    'acc.bulk.hint': 'Ubah field di bawah untuk {n} akun terpilih. Field “Biarkan” tidak diubah.',
    'acc.bulk.keep': '— Biarkan —',
    'acc.bulk.keepNote': 'Hanya field yang Anda pilih yang akan diganti. Nomor & nama akun tidak diubah di sini.',
    'acc.bulk.apply': 'Terapkan perubahan',
    'acc.snack.required': 'Nomor dan nama akun wajib diisi',
    'acc.snack.saved': 'Akun diperbarui',
    'acc.snack.added': 'Akun baru ditambahkan',
    'acc.snack.saveFail': 'Gagal menyimpan akun',
    'acc.snack.activated': 'Akun diaktifkan',
    'acc.snack.deactivated': 'Akun dinonaktifkan',
    'acc.snack.multiEmpty': 'Isi minimal 1 baris (nomor + nama)',
    'acc.snack.multiOk': '{n} akun berhasil ditambahkan',
    'acc.snack.multiPartial': '{ok} berhasil, {err} gagal',
    'acc.snack.bulkEmpty': 'Pilih minimal 1 field yang ingin diubah',
    'acc.snack.bulkOk': '{n} akun diperbarui',
    'acc.dup.eyebrow': 'Perbaikan wajib',
    'acc.dup.title': '{n} nomor akun dobel / bentrok PT',
    'acc.dup.lead':
      'Ditemukan nomor atau nama akun yang dipakai lebih dari satu PT. Harus dirapikan agar jurnal & laporan tidak salah.',
    'acc.dup.admin':
      'Hubungi admin untuk merge ke 1 nomor shared (PT dipilih di jurnal, bukan di daftar akun). Klik baris untuk buka edit cepat.',
    'acc.dup.shared': 'Shared',
    'acc.dup.itemCode': 'No. {code} — dipakai {n}×',
    'acc.dup.itemCodeDetail': 'PT: {pts} · Nama: {names}',
    'acc.dup.itemName': '“{name}” — {n} baris (beda PT/kode)',
    'acc.dup.itemNameDetail': 'Kode: {codes} · PT: {pts}',
    'acc.dup.expand': 'Perluas',
    'acc.dup.collapse': 'Ciutkan',
    'acc.dup.dismiss': 'Tutup sementara',
    'acc.dup.purgeHint':
      '{n} isu berasal dari akun uji/sampah (mis. “zzz”). Hapus otomatis agar alert hilang — jurnal (jika ada) dipindah ke akun kanonik.',
    'acc.dup.purgeBtn': 'Hapus akun sampah',
    'acc.dup.purgeOk': '{n} akun sampah dihapus · {remapped} jurnal dipindah',
    'acc.dup.purgeEmpty': 'Tidak ada akun sampah tersisa',
    'acc.vizReady': 'Kesehatan COA',
    'acc.vizReadySub': 'siap',
    'acc.readyHint': '{active}/{total} akun aktif',
    'acc.vizTypes': 'Komposisi tipe',
    'acc.vizBands': 'Kapasitas rentang',
    'acc.healthTitle': 'Lane daftar akun',
    'acc.healthSub': 'Klik untuk filter cepat status, duplikat, dan anomali.',
    'acc.lane.all': 'Semua',
    'acc.lane.active': 'Aktif',
    'acc.lane.inactive': 'Nonaktif',
    'acc.lane.dups': 'Duplikat',
    'acc.lane.mismatch': 'Normal salah',
    'acc.lane.class': 'Kelas salah',
    'acc.lane.overflow': 'Overflow',
    'acc.lane.asset': 'Aset',
    'acc.lane.expense': 'Beban',
    'acc.tipsTitle': 'Checklist COA',
    'acc.tipEmpty': 'Tambah akun pertama ke chart of accounts',
    'acc.tipReadyOk': 'COA sehat {n}%',
    'acc.tipReadyFix': 'Kesehatan COA {n}% — cek duplikat & tipe',
    'acc.tipDups': '{n} isu nomor/nama dobel',
    'acc.tipDupsOk': 'Tidak ada duplikat nomor/nama',
    'acc.tipMismatch': '{n} akun saldo normal tidak sesuai tipe',
    'acc.tipMismatchOk': 'Saldo normal sesuai tipe',
    'acc.tipClass': '{n} akun nomornya di pita yang salah (nama ≠ kelas kode)',
    'acc.tipClassOk': 'Nomor akun sesuai kelas nama',
    'acc.tipMissingTypes': '{n} tipe belum ada: {list}',
    'acc.tipInactive': '{n} akun nonaktif',
    'acc.focusBanner': 'Fokus: {focus}',
    'acc.clearFocus': 'Hapus fokus',
    'acc.emptyFiltered': 'Tidak ada akun di filter ini',
    'acc.emptyFilteredSub': 'Ubah tipe/status/fokus atau reset filter.',
    'acc.resetFilters': 'Reset filter',

    'cb.title': 'Posisi Kas & Bank',
    'cb.sub': 'Saldo rekening kas/bank per PT — nomor rekening, saldo buku, dan status e-statement terakhir',
    'cb.totalLabel': 'Total Kas & Bank · {date}',
    'cb.colCode': 'Kode',
    'cb.colName': 'Nama Rekening',
    'cb.colBalance': 'Saldo',
    'cb.colAccountNo': 'No. Rekening',
    'cb.colBook': 'Saldo Buku',
    'cb.colStmtBal': 'Saldo Statement',
    'cb.colStmtDate': 'Tgl Statement',
    'cb.colStmtStatus': 'Status Update',
    'cb.ledger': 'Buku Besar',
    'cb.updateStmt': 'E-Statement',
    'cb.editMap': 'Update rekening',
    'cb.manageAccounts': 'Update rekening',
    'cb.accountNoEmpty': 'Isi nomor rekening',
    'cb.emptyNoAlert': '{n} rekening belum punya nomor',
    'cb.emptyNoHint': 'Isi nomor rekening agar import pintar & update saldo akurat.',
    'cb.emptyNoStat': 'Tanpa no. rek',
    'cb.emptyNoStatSub': 'Perlu diisi di master',
    'cb.sort': 'Urutkan',
    'cb.sortName': 'Nama A → Z',
    'cb.sortBalDesc': 'Saldo besar → kecil',
    'cb.sortBalAsc': 'Saldo kecil → besar',
    'cb.sortStatus': 'Status update',
    'cb.sortStmtDate': 'Tgl statement terakhir',
    'cb.filterAll': 'Semua',
    'cb.filterEmptyNo': 'No. rek kosong',
    'cb.showing': '{n} baris',
    'cb.tableKicker': 'Rekening',
    'cb.tableTitle': 'Detail posisi kas & bank',
    'cb.colDiff': 'Selisih',
    'cb.colActions': 'Aksi',
    'cb.continueFrom': 'Lanjut {date}',
    'cb.perPage': 'Per halaman',
    'cb.pageAll': 'All',
    'cb.pageMeta': 'Halaman {page} / {pages} · {total} rekening',
    'cb.mapKicker': 'Master rekening',
    'cb.mapTitle': 'Pemetaan nomor rekening bank',
    'cb.mapSub':
      'Satu bank bisa punya 2 nomor rekening per PT (contoh BCA JGI #1 & #2). Dipakai e-statement, Excel, dan debit/kredit cepat.',
    'cb.mapAdd': 'Tambah baris',
    'cb.mapAddSecond': 'Tambah slot #2 untuk bank ini',
    'cb.mapSave': 'Simpan pemetaan',
    'cb.mapSaved': 'Pemetaan rekening disimpan',
    'cb.colBank': 'Bank (COA)',
    'cb.colAlias': 'Alias / sheet',
    'cb.aliasPh': 'BCA 1 / BCA JGI #2',
    'cb.accountNoPh': 'Nomor rekening',
    'cb.shared': 'Bersama',
    'cb.asOf': 'Per tanggal',
    'cb.searchPh': 'Cari bank, kode, no rekening, alias, status…',
    'cb.filterHint': 'Filter aktif: {pt} · per {date}',
    'cb.ptAll': 'Semua PT (grup)',
    'cb.ptAllShort': 'Gabungan',
    'cb.accountCount': '{n} rekening',
    'cb.ptMini': '{n} akun · {stale} perlu update',
    'cb.stmtAttention': 'Perlu perhatian',
    'cb.stmtAttentionSub': '{stale} lama · {miss} belum ada',
    'cb.statusCurrent': 'Terbaru',
    'cb.statusStale': 'Terlambat',
    'cb.statusMissing': 'Belum ada',
    'cb.emptyTitle': 'Belum ada posisi kas/bank',
    'cb.emptySub': 'Pilih PT lain atau pastikan akun kas/bank sudah punya jurnal.',
    'cb.uploadStmt': 'E-Statement',
    'cb.quickImport': 'Import Excel',
    'cb.quickJournal': 'Debit/Kredit Cepat',
    'cb.footnote':
      'Saldo buku dari jurnal cleared/released. Saldo statement terisi setelah e-statement diunggah & disimpan. Pilih ALL / JGI / JGT dulu sebelum upload di menu terkait.',
    'cb.loading': 'Memuat',
    'cb.searchFull': 'Cari fullscreen',
    'cb.searchHint': '{n} rekening cocok · Enter tutup ·',
    'cb.today': 'Hari ini',
    'cb.thisMonth': 'Akhir bulan',
    'cb.coverage': 'Statement terbaru {pct}%',
    'cb.coverageHint': '{pct}% rekening punya e-statement terbaru (≤35 hari)',
    'cb.filterBar': 'Filter kas & bank',
    'cb.syncedDash': 'Disinkron dari Konteks Kerja (PT + periode + tanggal)',
    'cb.asOfShort': 'Posisi per {date}',
    'cb.readyScore': 'Siap treasury',
    'cb.readyHint': '{ok} lengkap · {need} perlu perhatian',
    'cb.healthTitle': 'Lane treasury cepat',
    'cb.healthSub': 'Klik chip untuk filter rekening — sinkron dengan tabel di bawah.',
    'cb.clearLane': 'Reset filter',
    'cb.openRecon': 'Buka Rekonsiliasi',
    'cb.filterDateOnly': 'Tgl ada, saldo belum',
    'cb.dateOnlyBal': 'Tgl saja',
    'cb.dateOnlyHint': 'Ada tanggal import, belum ada saldo statement — unggah e-statement',
    'cb.openMaster': 'Buka master rekening',
    'cb.masterShort': 'Master',
    'cb.lane.all': 'Semua',
    'cb.lane.stale': 'Terlambat',
    'cb.lane.missing': 'Belum ada',
    'cb.lane.current': 'Terbaru',
    'cb.lane.empty_no': 'No. rek kosong',
    'cb.lane.date_only': 'Tgl saja',
    'cb.lane.neg': 'Negatif',
    'cb.lane.diff': 'Ada selisih',
    'cb.tipActEmptyNo': 'Isi {n} no. rek',
    'cb.tipActDiff': 'Cek {n} selisih',
    'cb.tipActStale': 'Update {n} terlambat',
    'cb.tipActDateOnly': 'Lengkapi {n} saldo stmt',
    'cb.tipActImport': 'Import Excel',
    'cb.tipActStmt': 'E-Statement',
    'cb.daysAgo': '{n} hari lalu',
    'cb.sortDiff': 'Selisih besar → kecil',
    'cb.bankAll': 'Semua bank / COA',
    'cb.filterBank': 'Bank / COA',
    'cb.filterBalSign': 'Tanda saldo',
    'cb.balAll': 'Semua saldo',
    'cb.balPos': 'Saldo positif',
    'cb.balNeg': 'Saldo negatif',
    'cb.balZero': 'Saldo nol',
    'cb.balMin': 'Saldo min',
    'cb.balMax': 'Saldo max',
    'cb.balMinPh': 'mis. 0',
    'cb.balMaxPh': 'mis. 10000000',
    'cb.onlyDiff': 'Hanya ada selisih buku↔statement',
    'cb.onlyDiffShort': 'Ada selisih',
    'cb.hideZero': 'Sembunyikan saldo 0',
    'cb.advFilters': 'Filter lanjutan',
    'cb.resetFilters': 'Reset filter',
    'cb.activeFilters': '{n} filter aktif',
    'cb.filteredTotal': 'Hasil filter · {amt}',
    'cb.filteredDiff': 'Σ selisih {amt}',
    'cb.full': 'Perbesar (fullscreen)',
    'cb.exitFull': 'Kecilkan',
    'cb.minimize': 'Kecilkan',
    'cb.windowControls': 'Kontrol jendela',
    'cb.tipsTitle': 'Saran cepat · biar kerja treasury lebih rapi',
    'cb.tipsShow': 'Tampilkan',
    'cb.tipsHide': 'Sembunyikan',
    'cb.tip1': 'Isi nomor rekening dulu (chip “No. rek kosong”) agar import PDF/Excel akurat.',
    'cb.tip2': 'Pakai “Ada selisih” untuk cek rekonsiliasi buku vs statement sebelum closing.',
    'cb.tip3': 'Filter bank + rentang saldo untuk fokus rekening bermasalah (negatif / ekstrem).',
    'cb.tip4': 'Fullscreen di pojok kanan atas memudahkan review banyak baris; kecilkan / tutup untuk kembali.',
    'cb.editMapShort': 'Rekening',
    'cb.updateStmtShort': 'E-Stmt',
    'cb.ledgerShort': 'BB',
    'cb.copyNo': 'Salin nomor rekening',
    'cb.copiedNo': 'Nomor {n} disalin',
    'cb.noStmtYet': 'Belum ada e-statement',
    'cb.pageRange': 'Baris {from}–{to} dari {total}',
    'cb.firstPage': 'Halaman pertama',
    'cb.lastPage': 'Halaman terakhir',
    'cb.statClickPt': 'Filter PT {pt}',
    'cb.statClickAttention': 'Filter rekening yang perlu perhatian',
    'cb.statClickEmptyNo': 'Filter nomor rekening kosong',
    'aud.title': 'Audit Trail',
    'aud.sub': 'Jejak semua posting jurnal — sumber, waktu, & nominal',
    'aud.kicker': 'Kontrol · Jejak posting',
    'aud.searchPh': 'Cari ref/memo',
    'aud.colTime': 'Waktu',
    'aud.colRef': 'Ref',
    'aud.colDesc': 'Keterangan',
    'aud.colAmount': 'Nominal',
    'aud.allCompanies': 'ALL',
    'aud.ptAll': 'Semua PT',
    'aud.ptAllShort': 'Semua',
    'aud.followCtx': 'Ikuti konteks kerja',
    'aud.countLoaded': '{n} dimuat',
    'aud.countShown': '{n} ditampilkan',
    'aud.statTotal': 'Total jejak',
    'aud.statShare': '{n}% periode',
    'aud.vizMix': 'Komposisi sumber',
    'aud.vizDays': 'Aktivitas harian',
    'aud.vizDaysHint': '14 hari terakhir dalam filter',
    'aud.vizSnapshot': 'Ringkas periode',
    'aud.vizEmpty': 'Belum ada data untuk filter ini',
    'aud.snapImport': 'Porsi impor',
    'aud.snapFiltered': 'Nominal terfilter',
    'aud.snapVoid': 'Jurnal void',
    'aud.openQuality': 'Kelengkapan data',
    'aud.openJournals': 'Buka jurnal',
    'aud.healthTitle': 'Filter sumber cepat',
    'aud.healthSub': 'Klik chip untuk menyaring tabel',
    'aud.laneAll': 'Semua',
    'aud.tipsTitle': 'Saran audit',
    'aud.tipEmpty': 'Belum ada jejak — sesuaikan periode atau ikuti konteks kerja',
    'aud.tipImportHeavy': 'Impor mendominasi ({n}%) — wajar jika baru migrasi workbook',
    'aud.tipVoid': '{n} jurnal void — tinjau sebelum tutup buku',
    'aud.tipSystem': '{n} posting sistem (payroll/kasbon/dll.)',
    'aud.tipFollow': 'Konteks Kerja beda dari filter audit — klik untuk menyamakan',
    'aud.tipQuality': 'Cek Kelengkapan Data untuk temuan critical',
    'aud.tipJournals': 'Buka Jurnal untuk edit / detail ID Ref',
    'aud.tipOk': 'Jejak audit terlihat normal untuk filter ini',
    'aud.focusSource': 'Sumber: {source} · {n} baris',
    'aud.focusSearch': 'Cari “{q}” · {n} hasil',
    'aud.clearFocus': 'Hapus filter',
    'aud.empty': 'Belum ada jejak posting',
    'aud.emptyFilter': 'Tidak ada hasil untuk filter ini',
    'aud.emptyHint': 'Ubah PT/periode/sumber, atau ikuti Konteks Kerja.',
    'aud.sourceSystem': 'Sistem',
    'aud.refreshShort': 'Ulang',
    'aud.openQualityShort': 'Kelengkapan',
    'aud.openJournalsShort': 'Jurnal',
    'aud.followCtxShort': 'Ikuti konteks',
    'aud.searchLabel': 'Cari',
    'aud.fromLabel': 'Dari',
    'aud.toLabel': 'Sampai',
    'aud.sourceLabel': 'Sumber',

    'ql.title': 'Kelengkapan Data',
    'ql.kicker': 'Kontrol · Audit workbook',
    'ql.sub':
      'Cek kesiapan data sebelum review konsultan pajak / banding Accurate-style close. Gap statement diambil dari coverage GL Jan–Jul.',
    'ql.refreshShort': 'Ulang',
    'ql.previewVoid2025': 'Preview void 2025',
    'ql.previewVoidShort': 'Preview void',
    'ql.void2025': 'Void data 2025',
    'ql.voidShort': 'Void 2025',
    'ql.exportPack': 'Export Paket Konsultan',
    'ql.exportPackShort': 'Export',
    'ql.searchLabel': 'Cari',
    'ql.selectAllShort': 'Semua',
    'ql.unselectShort': 'Batal',
    'ql.selectOpenShort': 'Belum dicek',
    'ql.removeSelectedShort': 'Sembunyikan ({n})',
    'ql.cleanPreviewTitle': 'Preview void 2025',
    'ql.cleanPreview': 'Preview clean 2025: {n} jurnal. Sample ID: {ids}',
    'ql.scoreCaption': 'Skor kelengkapan {year}',
    'ql.statJournals': 'Jurnal',
    'ql.statNoPt': 'Tanpa PT',
    'ql.statRefMismatch': 'Ref mismatch',
    'ql.statCoa': 'Akun COA',
    'ql.findingsTitle': 'Temuan audit',
    'ql.gapTitle': 'Checklist tindakan (workbook)',
    'ql.gapKicker': 'Checklist',
    'ql.gapSub':
      'Tandai sudah dicek / salah klasifikasi. Tiap bank punya kode akun, no. rekening, grid bulan, dan langkah singkat.',
    'ql.gapEmpty': 'Semua gap disembunyikan atau tidak ada data.',
    'ql.gapSumMissing': 'Kurang bulan',
    'ql.gapSumOpen': 'Belum dicek',
    'ql.gapSumComplete': 'Lengkap',
    'ql.gapSumP1': 'Prioritas P1',
    'ql.gapMissingCount': '{n} bulan kurang',
    'ql.gapMonthGrid': 'Coverage bulan (jumlah jurnal)',
    'ql.gapFocusMiss': 'Jan–Jul kurang {n}',
    'ql.gapActionLabel': 'Tindakan',
    'ql.gapAccountInfo': 'Akun & rekening',
    'ql.glKicker': 'Prioritas P1',
    'ql.glTitle': 'Coverage di buku (GL) Jan–Jul',
    'ql.glSub':
      'Laporan per bank: kode akun COA, nomor rekening, PT, dan jumlah jurnal per bulan. Fokus Jan–Jul; Agt–Des + Akin CC tetap ditampilkan.',
    'ql.glEmpty': 'Belum ada data coverage.',
    'ql.glMissingBadge': '{n} sumber masih bolong',
    'ql.glGoImport': 'Impor Excel',
    'ql.glGoStmt': 'E-Statement',
    'ql.glColSource': 'Sumber',
    'ql.glColPresent': 'Ada di GL',
    'ql.glColMissing': 'Belum di GL',
    'ql.glColAccountCode': 'Kode akun',
    'ql.glColAccountNo': 'No. rekening',
    'ql.glColPt': 'PT',
    'ql.glColTag': 'Tag memo',
    'ql.glPtShared': 'Bersama',
    'ql.glStatBanks': 'Sumber bank',
    'ql.glStatFocusOk': 'Lengkap Jan–Jul',
    'ql.glStatFocusMiss': 'Slot bulan kosong',
    'ql.glStatJournals': 'Jurnal terdeteksi',
    'ql.glBankAccounts': '{n} rekening',
    'ql.glBankFocusMiss': '{n} slot Jan–Jul kosong',
    'ql.glBankFocusOk': '{n} lengkap fokus',
    'ql.glStatusGap': 'Perlu import',
    'ql.glStatusOk': 'Lengkap',
    'ql.glStatusFocusOk': 'Jan–Jul OK',
    'ql.glStatusFocusGap': 'Kurang {n} bln',
    'ql.glFocusProgress': 'Progress Jan–Jul',
    'ql.glFocusMonths': 'Fokus Jan–Jul (jumlah jurnal)',
    'ql.glRestMonths': 'Agt–Des + Akin CC',
    'ql.glAkinShort': 'Akin',
    'ql.glFocusMissingList': 'Jan–Jul kurang: {list}',
    'ql.glDoubleList': 'Suspect double: {list}',
    'ql.glActImport': 'Import',
    'ql.glActStmt': 'Statement',
    'ql.glHint':
      'Coverage Jan–Des + kolom Akin Des (tahun lalu) untuk kartu kredit. Centang “Posting ke laporan” saat import. Fingerprint [FP] mencegah double. DBS bersama otomatis 50:50 di neraca JGI/JGT. Kode akun: 1001 BCA · 1002 BNI · 1003 Mandiri · 1004 DBS · 2700 Utang CC.',
    'ql.priorYearAlert':
      'Bulan tahun sebelumnya (selain akin CC Desember) masih ada di buku — tinjau apakah perlu dipisah tutup buku.',
    'ql.colPrio': 'Prio',
    'ql.colBank': 'Bank / sumber',
    'ql.colMissingMonths': 'Bulan kurang',
    'ql.colNote': 'Catatan',
    'ql.colStatus': 'Status',
    'ql.complete': 'Lengkap',
    'ql.fixBtn': 'Perbaiki',
    'ql.fixKicker': 'Panel perbaikan',
    'ql.originalNote': 'Catatan asli',
    'ql.verdict': 'Penilaian',
    'ql.statusOk': 'Benar',
    'ql.statusWrong': 'Salah',
    'ql.statusOpen': 'Belum dicek',
    'ql.correctionLabel': 'Catatan perbaikan',
    'ql.correctionPh': 'Tulis apa yang sudah/akan diperbaiki…',
    'ql.saveFix': 'Simpan perbaikan',
    'ql.resetFix': 'Reset perbaikan baris ini',
    'ql.openStatements': 'Buka E-Statement',
    'ql.openImport': 'Buka Import Workbook',
    'ql.resetAllGaps': 'Tampilkan semua gap lagi',
    'ql.selectOpen': 'Pilih yang belum dicek',
    'ql.removeSelected': 'Sembunyikan terpilih ({n})',
    'ql.removeGap': 'Sembunyikan baris',
    'ql.snack.fixSaved': 'Perbaikan disimpan',
    'ql.snack.fixReset': 'Perbaikan baris direset',
    'ql.snack.gapHidden': 'Baris disembunyikan',
    'ql.snack.gapsHidden': '{n} baris disembunyikan',
    'ql.snack.gapsReset': 'Semua gap ditampilkan lagi',
    'ql.snack.needSelected': 'Centang baris dulu',
    'ql.companiesTitle': 'Perusahaan',
    'ql.npwpMissing': 'BELUM DIISI',
    'ql.pphFinal': 'PPh Final {rate}%',
    'ql.editCompanies': 'Edit perusahaan',
    'ql.omsetTitle': 'Omset {year}',
    'ql.recommendationsTitle': 'Rekomendasi',
    'ql.journalsByMonth': 'Jurnal per bulan ({year})',
    'ql.colMonth': 'Bulan',
    'ql.colJournalCount': 'Jumlah jurnal',
    'ql.colTotalDebit': 'Total debit',
    'ql.snack.loadFail': 'Gagal memuat',
    'ql.autoSnack': 'AI menulis {n} note di lonceng — silakan cross-check.',
    'ql.snack.packOk': 'Paket konsultan diunduh',
    'ql.snack.exportFail': 'Export gagal (cek NPWP PT)',
    'ql.snack.previewVoid': 'Preview: {n} jurnal tahun 2025 siap di-void',
    'ql.snack.previewFail': 'Gagal preview',
    'ql.confirmVoid2025':
      'Void SEMUA jurnal tahun 2025? Ini memisahkan data 2025 dari omset 2026. Tidak mudah di-undo.',
    'ql.snack.voided': '{n} jurnal 2025 di-void',
    'ql.snack.cleanFail': 'Gagal clean',
    'ql.rec.0':
      'Admin mengosongkan sumber e-statement prioritas lewat tombol Quality, lalu mengunggah ulang file satu per satu di menu E-Statement.',
    'ql.rec.1':
      'Admin memastikan sumber prioritas terisi: DBS Kartu Kredit, DBS Rekening, Danamon CC, Panin CC, Mandiri, Mega CC, BCA, dan BNI.',
    'ql.rec.2':
      'Admin mencentang “Posting ke laporan” saat mengimpor agar hutang kartu kredit dan saldo DBS langsung masuk neraca (status cleared).',
    'ql.rec.3':
      'Admin menandai checklist Coretax (PPN, PPh 23, PPh 21, SPT) setelah data pajak selesai di Coretax; bukti PDF boleh diarsipkan di menu SSP / Dokumen Pajak.',
    'ql.rec.4':
      'Admin menghitung PPh 21 lewat kalkulator dan/atau mengunggah bukti potong PDF di menu PPh 21.',
    'ql.rec.5':
      'Admin memeriksa tabel coverage GL Januari–Desember — terutama kolom Double? pada Mandiri 1 — agar tidak ada mutasi ganda.',
    'ql.rec.6':
      'Admin merekonsiliasi bank versus buku setiap bulan sampai aging statement mencapai nol.',
    'ql.rec.7':
      'Admin memasukkan tagihan kartu kredit Desember tahun sebelumnya sebagai akin siklus tahun berjalan; data itu tetap dihitung dalam review, bukan dihapus.',
    'ql.statJournalsMeta': 'Klik → tren bulanan',
    'ql.statNoPtMeta': 'Klik → temuan warning',
    'ql.statRefMeta': 'Klik → filter temuan',
    'ql.statCoaMeta': 'Klik → bagan akun',
    'ql.vizFindings': 'Temuan per level',
    'ql.vizGaps': 'Gap statement',
    'ql.vizMonths': 'Jurnal per bulan',
    'ql.vizMonthsHint': 'Batang tipis/oranye = volume rendah',
    'ql.healthTitle': 'Navigasi kesehatan data',
    'ql.healthSub': 'Filter temuan atau gap dengan satu klik',
    'ql.tipsTitle': 'Saran tindakan',
    'ql.tipScoreLow': 'Skor kelengkapan {n} — prioritaskan temuan critical',
    'ql.tipScoreOk': 'Skor {n} sudah kuat untuk review konsultan',
    'ql.tipCritical': '{n} temuan critical perlu ditutup dulu',
    'ql.tipP1': '{n} sumber statement prioritas 1 masih bolong',
    'ql.tipNoPt': '{n} jurnal tanpa PT — mapping bank → perusahaan',
    'ql.actVoidPreview': 'Preview void',
    'ql.actVoidCcDec': 'Preview void CC Des',
    'ql.actOpenCcJournals': 'Buka jurnal CC',
    'ql.actViewAkin': 'Lihat akin CC',
    'ql.findingItemsTitle': '{n} jurnal terkait',
    'ql.findingColDate': 'Tanggal',
    'ql.findingColRef': 'Ref',
    'ql.findingColMemo': 'Keterangan',
    'ql.findingColAmount': 'Nominal',
    'ql.snack.previewVoidCc': 'Preview: {n} jurnal CC Desember {year} siap di-void',
    'ql.confirmVoidCcDec':
      'Void {n} jurnal kartu kredit Desember {year}? Ini hanya CC Desember, bukan seluruh tahun. Tidak mudah di-undo.',
    'ql.snack.voidedCc': '{n} jurnal CC Desember di-void',
    'ql.ccDecBanner':
      '{n} tagihan CC Desember {prior} masuk sebagai akin siklus {year}. Data ini bagian dari laporan {year} — tidak perlu di-void hanya karena tanggal masih {prior}.',
    'ql.ccDecBannerTitle': 'Akin CC Desember {prior}',
    'ql.tipPriorYear':
      '{n} CC Desember tahun lalu masuk akin siklus ini — tinjau di temuan (bukan error void).',
    'ql.coretaxTitle': 'Checklist Coretax',
    'ql.coretaxSub': 'Centang setelah selesai di Coretax. Angka detail tetap dari Coretax.',
    'ql.coretax.ppn': 'PPN masa',
    'ql.coretax.pph23': 'PPh 23',
    'ql.coretax.pph21': 'PPh 21',
    'ql.coretax.spt': 'SPT / e-bupot',
    'ql.coretax.done': 'Selesai di Coretax',
    'ql.coretax.pending': 'Belum',
    'ql.tipPack': 'Export Paket Konsultan setelah gap P1 ditutup',
    'ql.levelCritical': 'Critical',
    'ql.levelWarning': 'Warning',
    'ql.levelInfo': 'Info',
    'ql.levelOk': 'OK',
    'ql.filterAll': 'Semua',
    'ql.focusP1': 'P1',
    'ql.focusMissing': 'Kurang bulan',
    'ql.focusOpen': 'Belum dicek',
    'ql.focusComplete': 'Lengkap',
    'ql.focusFindingBanner': 'Temuan: {level} · {n} item',
    'ql.focusGapBanner': 'Filter gap · {n} baris',
    'ql.clearFocus': 'Hapus filter',
    'ql.findingsSub': 'Ringkasan + rincian gap, metrik, dan langkah perbaikan — klik judul untuk buka/tutup',
    'ql.findingsEmpty': 'Tidak ada temuan untuk filter ini',
    'ql.findingExpandAll': 'Buka semua',
    'ql.findingCollapseAll': 'Tutup semua',
    'ql.findingImpact': 'Dampak',
    'ql.findingStepsTitle': 'Langkah perbaikan',
    'ql.findingGapsTitle': 'Rincian {n} sumber / periode',
    'ql.findingGapMissing': '{n} bulan kurang',
    'ql.findingGapOk': 'Lengkap',
    'ql.findingGapSuspect': '{n} bulan suspect',
    'ql.findingGapAkin': 'Akin Des: {n}',
    'ql.findingLegendOk': 'Ada',
    'ql.findingLegendMiss': 'Kosong',
    'ql.findingLegendSuspect': 'Suspect double',
    'ql.gapSearch': 'Cari bank / kode akun / rekening / catatan…',
    'ql.gapFilterEmpty': 'Tidak ada gap cocok filter',
    'ql.actCompanies': 'Perusahaan',
    'ql.actJournals': 'Jurnal',
    'ql.actGaps': 'Lihat gap',
    'ql.actHr': 'HR',
    'ql.actOpen': 'Buka',
    'ql.npwpMissingShort': 'NPWP?',
    'ql.npwpOk': 'OK',
    'ql.journalsByMonthSub': 'Volume posting per bulan — waspadai lonjakan/jatuh mendadak',

    'cl.title': 'Close Checklist Bulanan',
    'cl.kicker': 'Tutup bulan · Kontrol kualitas',
    'cl.sub': 'Checklist tutup bulan sebelum review konsultan / SPT Masa',
    'cl.companyOptional': 'PT (opsional)',
    'cl.allCompanies': 'Semua PT / konsolidasi',
    'cl.monthLabel': 'Bulan',
    'cl.yearLabel': 'Tahun',
    'cl.prevMonth': 'Bulan sebelumnya',
    'cl.cancel': 'Batal',
    'cl.save': 'Simpan',
    'cl.failed': 'Gagal memuat / menyimpan',
    'cl.nextMonth': 'Bulan berikutnya',
    'cl.thisMonth': 'Bulan ini',
    'cl.thisMonthShort': 'Bulan ini',
    'cl.jumpOpen': 'Lanjut {n} belum',
    'cl.jumpOpenShort': '{n} belum',
    'cl.search': 'Cari item checklist…',
    'cl.markDone': 'Selesai',
    'cl.markDoneShort': 'OK',
    'cl.markUndone': 'Batalkan',
    'cl.markUndoneShort': 'Undo',
    'cl.openRelated': 'Buka halaman terkait',
    'cl.progress': 'Progress {done}/{total}',
    'cl.progressHint': 'Item wajib harus selesai sebelum siap tutup periode.',
    'cl.statDone': 'Selesai',
    'cl.statOpen': 'Belum',
    'cl.statRequired': 'Wajib selesai',
    'cl.statPct': 'Progres',
    'cl.readyYes': 'Siap tutup',
    'cl.readyNo': 'Belum siap',
    'cl.copy': 'Salin ringkasan',
    'cl.copyShort': 'Salin',
    'cl.copied': 'Ringkasan disalin',
    'cl.markRequired': 'Centang wajib',
    'cl.markRequiredShort': 'Wajib',
    'cl.reset': 'Reset',
    'cl.confirmMarkAll': 'Centang semua item wajib untuk periode ini?',
    'cl.confirmReset': 'Reset semua checklist periode ini?',
    'cl.markedAll': 'Item wajib ditandai selesai',
    'cl.resetDone': 'Checklist di-reset',
    'cl.openWizard': 'Tutup Bulan',
    'cl.openWizardShort': 'Wizard',
    'cl.filterAll': 'Semua',
    'cl.filterOpen': 'Belum',
    'cl.filterDone': 'Selesai',
    'cl.role.all': 'Semua peran',
    'cl.role.allShort': 'Semua',
    'cl.role.akuntan': 'Akuntan',
    'cl.role.konsultan': 'Konsultan',
    'cl.role.konsultanShort': 'Konsultan',
    'cl.role.partner': 'Partner',
    'cl.optional': 'Opsional',
    'cl.hasNote': 'Ada catatan',
    'cl.addNote': 'Catatan',
    'cl.noteTitle': 'Catatan item',
    'cl.noteLabel': 'Catatan internal',
    'cl.noteHint': 'Temuan, blocker, atau follow-up untuk item ini',
    'cl.noteSaved': 'Catatan disimpan',
    'cl.emptyFilter': 'Tidak ada item pada filter ini.',
    'cl.item.stmt_import': 'Semua statement bank/CC bulan ini sudah diimpor',
    'cl.item.recon_done': 'Rekonsiliasi book ↔ statement selesai / aging ditinjau',
    'cl.item.unearned_review': 'Uang muka pelanggan (DP) direview — akui / biarkan sesuai kinerja',
    'cl.item.journals_ok': 'Jurnal anomali / tanpa company sudah diperbaiki',
    'cl.item.pph_final': 'PPh Final UMKM dihitung & diposting (jika ada omset)',
    'cl.item.payroll': 'Payroll & PPh 21 diposting (jika ada karyawan)',
    'cl.item.pph23': 'Bukti potong PPh 23 / SSP dicatat',
    'cl.item.lk_review': 'LK (Neraca / LR) direview untuk bulan berjalan',
    'cl.item.quality': 'Skor kelengkapan data dicek di Kontrol',
    'cl.item.backup': 'Backup DB / export paket konsultan (opsional)',

    'account.title': 'Akun Saya',
    'account.kicker': 'Profil & kompensasi karyawan',
    'account.unlinked':
      'Akun belum ditautkan ke karyawan. Menampilkan data contoh — minta admin HR menautkan user Anda.',
    'account.demoBadge': 'Contoh data',
    'account.position': 'Jabatan',
    'account.positionDemo': 'Staff (contoh)',
    'account.joinedAt': 'Masuk kerja',
    'account.leftAt': 'Tanggal resign',
    'account.lastAttendance': 'Absen terakhir',
    'account.salary': 'Gaji',
    'account.allowance': 'Tunjangan',
    'account.commission': 'Komisi',
    'account.bonus': 'Bonus',
    'account.gross': 'Bruto',
    'account.period': 'Periode',
    'account.takeHome': 'Gaji pulang',
    'account.pph21': 'PPh 21',
    'account.kasbonCut': 'Potong kasbon',
    'account.deductionsTotal': 'Total potongan',
    'account.kpiGrossHint': 'Gaji + komisi',
    'account.kpiGrossHintFull': 'Gaji + tunjangan + komisi + bonus',
    'account.kpiDeductHint': 'PPh + BPJS + kasbon',
    'account.tenure': 'Masa kerja',
    'account.payday': 'Estimasi gajian',
    'account.earningsTitle': 'Komponen pendapatan',
    'account.earningsTotal': 'Total bruto',
    'account.bonusYtd': 'Bonus YTD',
    'account.allowanceYtd': 'Tunjangan YTD (est.)',
    'account.earningsHint':
      'Gaji & tunjangan dari master karyawan. Bonus dari transaksi bulan ini. Komisi tampil jika sudah ada sumber data terpisah.',
    'account.compTitle': 'Kompensasi',
    'account.slipTitle': 'Slip estimasi',
    'account.compositionTitle': 'Komposisi gaji',
    'account.takeHomeShare': '{pct}% dari bruto menjadi gaji pulang',
    'account.trendTitle': 'Tren gaji',
    'account.trendTitleN': 'Tren gaji ({n} bulan)',
    'account.trendRange': 'Rentang',
    'account.trendMonthShort': ' bln',
    'account.trendAnchor': 'Titik akhir',
    'account.trendAnchorLast': 'Bulan kemarin',
    'account.trendAnchorThis': 'Bulan ini',
    'account.salaryDetail': 'Rincian gaji, potongan & take-home',
    'account.kasbonTitle': 'Kasbon saya',
    'account.kasbonOpen': 'Sisa kasbon',
    'account.kasbonMax': 'Plafon',
    'account.kasbonPending': 'Pending',
    'account.kasbonLimit': 'Plafon {pct}% dari bruto',
    'account.kasbonRoom': 'Sisa plafon {room}',
    'account.kasbonHistory': 'Riwayat / pengajuan',
    'account.kasbonEmpty': 'Belum ada riwayat kasbon',
    'account.askKasbon': 'Ajukan kasbon',
    'account.attTitle': 'Absensi bulan ini',
    'account.attPresent': 'Hadir',
    'account.attLate': 'Terlambat',
    'account.attAbsent': 'Absen',
    'account.attHadir': 'Hadir',
    'account.attBolos': 'Bolos',
    'account.attLeave': 'Cuti',
    'account.attSick': 'Sakit',
    'account.attPermit': 'Izin',
    'account.attHoliday': 'Libur',
    'account.attHalfday': 'Setengah hari',
    'account.attRate': 'Kehadiran',
    'account.attOfWorkdays': 'dari {n} hari kerja',
    'account.attHadirHint': 'Termasuk hadir & terlambat',
    'account.attDailyRate': 'Tarif harian',
    'account.attDailyRateHint': 'Bruto ÷ hari kerja',
    'account.attAbsentCut': 'Potong ≈ {amount}',
    'account.attLateCut': 'Potong telat ≈ {amount}',
    'account.attAbsentCutLabel': 'Potong bolos',
    'account.attLateCutLabel': 'Potong terlambat',
    'account.attCutsTitle': 'Potongan terkait absen',
    'account.attCutsHint':
      'Estimasi potongan bolos/telat untuk overview. Slip resmi mengikuti kebijakan HR.',
    'account.attBreakdown': 'Rincian status',
    'account.attRecent': 'Riwayat absen terbaru',
    'account.attRecentEmpty': 'Belum ada riwayat absen bulan ini',
    'account.attCheckIn': 'Absen masuk',
    'account.attCheckOut': 'Absen pulang',
    'account.attCheckInOk': 'Check-in berhasil',
    'account.attCheckOutOk': 'Check-out berhasil',
    'account.attNeedLink': 'Tautkan akun ke karyawan dulu untuk absen mandiri',
    'account.attDetail': 'Detail',
    'account.holTitle': 'Jadwal libur',
    'account.holThisMonth': 'Libur bulan ini',
    'account.holThisMonthEmpty': 'Tidak ada libur nasional bulan ini',
    'account.holUpcoming': 'Libur mendatang',
    'account.holUpcomingEmpty': 'Tidak ada libur mendatang tahun ini',
    'account.holLibur': 'Libur',
    'account.holCuti': 'Cuti bersama',
    'account.holYearSummary': '{year}: {libur} libur · {cuti} cuti bersama',
    'account.holOpenCalendar': 'Buka kalender',
    'account.bpjsTitle': 'BPJS (estimasi karyawan)',
    'account.bpjsNote':
      'Estimasi iuran karyawan dari bruto: kesehatan 1%, JHT 2%, JP 1%. Bukan angka resmi dari BPJS.',
    'account.bpjsHealth': 'Kesehatan',
    'account.bpjsJht': 'JHT',
    'account.bpjsJp': 'JP',
    'account.bpjsTotal': 'Total iuran',
    'account.bpjsCutHint': 'Dipotong di slip bulan ini: {amount}',
    'account.tabOverview': 'Ringkas',
    'account.tabSalary': 'Gaji',
    'account.tabKasbon': 'Kasbon',
    'account.tabInvoice': 'Invoice',
    'account.tabAttendance': 'Absen',
    'account.tabBpjs': 'BPJS',
    'account.tabPassword': 'Password',
    'account.invTitle': 'Invoice saya',
    'account.invPaidCair': 'Lunas sudah cair',
    'account.invPaidCairShort': 'Cair',
    'account.invPending': 'Pending',
    'account.invPartialPaid': 'Sudah terima (sebagian)',
    'account.invPipeline': 'Total pipeline',
    'account.invRecent': 'Invoice terbaru',
    'account.invEmpty': 'Belum ada invoice terkait',
    'account.invYear': 'Tahun {year}',
    'account.invPaidCount': '{n} dokumen lunas',
    'account.invPendingCount': '{n} menunggu cair',
    'account.invCairShare': '{pct}% sudah cair',
    'account.invHint':
      'Lunas sudah cair = invoice status lunas. Pending = sisa tagihan belum dibayar penuh.',
    'account.invStatusPaid': 'Lunas',
    'account.invStatusPartial': 'Sebagian',
    'account.invStatusSent': 'Terkirim',
    'account.openInvoices': 'Buka daftar invoice',
    'account.openPortal': 'Buka portal karyawan',
    'account.openAttendance': 'Buka absensi',
    'account.pwdTitle': 'Ganti password',
    'account.pwdSub': 'Masukkan password lama lalu password baru (min. 6 karakter).',
    'account.pwdOld': 'Password lama',
    'account.pwdNew': 'Password baru',
    'account.pwdConfirm': 'Ulangi password baru',
    'account.pwdSave': 'Simpan password',
    'account.pwdMin': 'Password baru minimal 6 karakter',
    'account.pwdMismatch': 'Konfirmasi password tidak cocok',
    'account.pwdOk': 'Password berhasil diganti',

    'portal.title': 'Portal Karyawan',
    'portal.kicker': 'Self-service',
    'portal.refresh': 'Muat ulang',
    'portal.refreshShort': 'Ulang',
    'portal.unlinked':
      'Akun belum ditautkan ke master karyawan. Minta admin di User & Akses memilih karyawan untuk user Anda.',
    'portal.askKasbon': 'Ajukan kasbon',
    'portal.askKasbonShort': 'Ajukan',
    'portal.resignBanner': 'Status kerja: Resign. Kasbon baru tidak bisa diajukan.',
    'portal.noKasbonResign': 'Akun ini sudah resign — pengajuan kasbon ditutup.',
    'portal.statGross': 'Gaji awal',
    'portal.statGrossHint': 'Bruto bulan ini',
    'portal.statKasbon': 'Sisa kasbon',
    'portal.statKasbonHint': 'Piutang terbuka',
    'portal.statDeduct': 'Potong kasbon',
    'portal.statDeductHint': 'Estimasi di slip',
    'portal.statTakeHome': 'Gaji pulang',
    'portal.statTakeHomeHint': 'Estimasi {period}',
    'portal.tabOverview': 'Ringkas',
    'portal.tabSlip': 'Slip gaji',
    'portal.tabKasbon': 'Kasbon',
    'portal.tabRequest': 'Ajukan',
    'portal.profileTitle': 'Profil gaji',
    'portal.baseSalary': 'Gaji pokok',
    'portal.allowance': 'Tunjangan',
    'portal.howItWorks': 'Alur kasbon & gaji',
    'portal.how1': 'Ajukan kasbon → status menunggu.',
    'portal.how2': 'Admin Setujui → piutang naik + jurnal realtime.',
    'portal.how3': 'Tolak → tidak masuk laporan; tetap tercatat di slip.',
    'portal.how4': 'Payroll → potong kasbon → gaji pulang turun; piutang lunas sebagian.',
    'portal.slipTitle': 'Slip estimasi',
    'portal.afterTax': 'Setelah PPh 21',
    'portal.openPiutang': 'Sisa piutang kasbon',
    'portal.openPiutangHint': 'Hanya kasbon yang sudah disetujui.',
    'portal.requestKicker': 'Pengajuan',
    'portal.requestTitle': 'Ajukan kasbon baru',
    'portal.requestSub': 'Setelah dikirim, admin akan Setujui atau Tolak.',
    'portal.requestHint':
      'Pending belum mengurangi gaji. Setelah disetujui, jumlah masuk piutang dan bisa dipotong di slip.',
    'portal.submitRequest': 'Kirim pengajuan',
    'portal.needAmount': 'Isi jumlah kasbon (> 0)',
    'portal.snackRequested': 'Pengajuan terkirim {no} — menunggu approve admin',
    'portal.installments': 'Cicilan',
    'portal.installmentsHint': 'Potongan per bulan = jumlah ÷ cicilan (1–12×)',
    'portal.limitLabel': 'Plafon kasbon',
    'portal.limitHint': '{pct}% gaji · sisa boleh ajukan {room}',
    'portal.downloadPdf': 'Unduh PDF slip',
    'portal.qrTitle': 'Approve kasbon via QR',
    'portal.qrKicker': 'Kasbon · QR',
    'portal.qrSub': 'Scan atau buka tautan untuk Setujui / Tolak pengajuan.',
    'portal.qrHint': 'Tunjukkan QR ke admin HR, atau salin tautan approve.',
    'portal.qrStaffHint': 'Menunggu keputusan admin. Anda tidak perlu menekan tombol.',
    'portal.openQr': 'Buka QR',
    'portal.proofUpload': 'Upload bukti',
    'portal.proofView': 'Lihat bukti',
    'portal.decidedBy': 'Diputuskan',
    'portal.waShare': 'Bagikan WA',
    'portal.snackPdf': 'PDF slip diunduh',
    'portal.snackProof': 'Bukti transfer tersimpan',
    'portal.unlinkedTitle': 'Akun belum tertaut karyawan',
    'portal.unlinkedStep1': 'Admin membuka menu User & Akses.',
    'portal.unlinkedStep2': 'Pilih user Anda, lalu tautkan ke master karyawan.',
    'portal.unlinkedStep3': 'Muat ulang portal — slip & kasbon langsung muncul.',
    'portal.openUsers': 'Buka User & Akses',
    'portal.openUsersShort': 'User & Akses',
    'portal.openHr': 'Buka Master HR',
    'portal.openHrShort': 'Master HR',
    'portal.vizReady': 'Kesiapan portal',
    'portal.vizReadySub': 'siap',
    'portal.readyHint': 'Profil {name}',
    'portal.vizComp': 'Komposisi slip',
    'portal.vizKasbon': 'Plafon & kasbon',
    'portal.compNet': 'Gaji pulang',
    'portal.compTax': 'PPh 21',
    'portal.compKasbon': 'Potong kasbon',
    'portal.barOpen': 'Sisa piutang',
    'portal.barRoom': 'Sisa plafon',
    'portal.barPending': 'Pending',
    'portal.barRejected': 'Ditolak',
    'portal.healthTitle': 'Lane self-service',
    'portal.healthSub': 'Klik untuk pindah tab slip, kasbon, atau ajukan.',
    'portal.lane.ringkas': 'Siap',
    'portal.lane.slip': 'Slip',
    'portal.lane.kasbon': 'Kasbon',
    'portal.lane.pending': 'Pending',
    'portal.lane.rejected': 'Ditolak',
    'portal.lane.ajukan': 'Bisa ajukan',
    'portal.tipsTitle': 'Checklist portal',
    'portal.tipUnlinked': 'Tautkan user ke karyawan agar slip tampil',
    'portal.tipAdminLink': 'Anda admin — tautkan di User & Akses',
    'portal.tipContactHr': 'Buka master karyawan untuk cek data HR',
    'portal.tipReadyOk': 'Portal siap {n}%',
    'portal.tipReadyFix': 'Kelengkapan portal {n}% — lengkapi profil',
    'portal.tipPending': '{n} pengajuan kasbon menunggu approve',
    'portal.tipPendingOk': 'Tidak ada kasbon pending',
    'portal.tipNoRoom': 'Plafon kasbon penuh — lunasi dulu',
    'portal.tipRoomOk': 'Sisa plafon {room} — siap ajukan',
    'portal.tipNik': 'NIK belum diisi di master karyawan',
    'portal.tipPdf': 'Unduh PDF slip estimasi bulan ini',

    'dash.hrCardTitle': 'Gaji & kasbon saya',
    'dash.hrCardSub': 'Estimasi take-home bulan ini',
    'dash.hrPendingTitle': 'Kasbon menunggu',
    'dash.hrPendingSub': '{n} pengajuan perlu Setujui / Tolak',
    'dash.hrOpenPortal': 'Portal saya',
    'dash.hrOpenEmployees': 'Buka HR',
    'dash.staffKasbonKicker': 'Kasbon saya',
    'dash.staffKasbonPending': 'Pending · {n}',
    'dash.staffKasbonNone': 'Tidak ada pending',
    'dash.staffKasbonLast': 'Terakhir',
    'dash.staffKasbonLastEmpty': 'Belum ada riwayat',
    'dash.staffKasbonShow': 'Riwayat',
    'dash.staffKasbonHide': 'Tutup',
    'dash.staffKasbonShowHint': 'Filter & halaman',
    'dash.staffKasbonPerPage': 'Per halaman',
    'dash.staffKasbonPageAll': 'Semua',
    'dash.staffKasbonShowing': 'Menampilkan {from}–{to} dari {total}',
    'dash.staffKasbonFilter': 'Filter',
    'dash.staffKasbonStatus': 'Status',
    'dash.staffKasbonStatusAll': 'Semua status',
    'dash.staffKasbonStatusPending': 'Pending',
    'dash.staffKasbonStatusApproved': 'Disetujui',
    'dash.staffKasbonStatusRejected': 'Ditolak',
    'dash.staffKasbonEmpty': 'Tidak ada kasbon pada filter ini',
    'dash.staffKasbonDemoBadge': 'Contoh',
    'dash.staffKasbonDemoName': 'Karyawan Demo',
    'dash.staffKasbonApprovedBy': 'Disetujui oleh',
    'dash.staffKasbonRejectedBy': 'Ditolak oleh',
    'dash.staffKasbonAwaiting': 'Menunggu persetujuan HR',
    'dash.staffKasbonNoDecision': 'Belum ada putusan',
    'dash.staffKasbonOpenShort': 'Sisa',
    'dash.staffKasbonExpandAria': 'Buka atau tutup riwayat kasbon',

    'hr.title': 'Master Karyawan & Payroll PPh 21',
    'hr.kicker': 'SDM & pajak',
    'hr.sub': 'Hitung PPh 21 progresif (sederhana) dan posting jurnal gaji',
    'hr.needPt': 'Pilih PT JGI atau JGT dulu sebelum menambah / mengedit karyawan.',
    'hr.needPtTitle': 'Pilih PT dulu',
    'hr.needPtBody':
      'Data karyawan JGI dan JGT dipisah. Pilih PT di atas agar tabel, payroll, dan kasbon tidak tercampur.',
    'hr.useContextPt': 'Pakai filter konteks ({pt})',
    'hr.contextPtHint': 'Konteks Kerja sudah {pt} — klik tombol di atas untuk membuka daftar.',
    'hr.tipPickPt': 'Pilih JGI atau JGT untuk membuka master karyawan',
    'hr.tipUseContext': 'Konteks Kerja = {pt} — pakai filter itu',
    'hr.tipReadyOk': 'Data karyawan {n}% lengkap',
    'hr.tipReadyFix': 'Kelengkapan data aktif {n}% — isi NIK/NPWP',
    'hr.tipNik': '{n} karyawan aktif tanpa NIK',
    'hr.tipNpwp': '{n} karyawan aktif tanpa NPWP',
    'hr.tipResignOk': '{n} karyawan resign — NIK/NPWP tidak diminta',
    'hr.tipResignOkDetail': 'Filter Resign untuk histori; kasbon & slip tetap bisa dibuka',
    'hr.tipPending': '{n} kasbon menunggu approve',
    'hr.tipPendingDetail': 'Setujui atau tolak di tab Kasbon',
    'hr.tipPendingOk': 'Tidak ada kasbon pending',
    'hr.tipNoPending': 'Tidak ada kasbon pending',
    'hr.tipKasbon': '{n} karyawan punya sisa kasbon',
    'hr.vizReady': 'Kesiapan data',
    'hr.vizReadySub': 'lengkap',
    'hr.readyHint': '{nik} aktif tanpa NIK · {npwp} aktif tanpa NPWP',
    'hr.vizPtkp': 'Sebaran PTKP',
    'hr.vizPtkpEmpty': 'Belum ada karyawan',
    'hr.vizGaps': 'Celahan data',
    'hr.healthTitle': 'Lane HR',
    'hr.healthSub': 'Klik untuk filter cepat status, kasbon, dan kelengkapan.',
    'hr.lane.all': 'Semua',
    'hr.lane.active': 'Aktif',
    'hr.lane.resign': 'Resign',
    'hr.lane.inactive': 'Resign',
    'hr.lane.kasbon': 'Ada kasbon',
    'hr.lane.pending': 'Pending',
    'hr.lane.nik': 'Tanpa NIK',
    'hr.lane.npwp': 'Tanpa NPWP',
    'hr.tipsTitle': 'Checklist HR',
    'hr.focusBanner': 'Fokus: {focus}',
    'hr.clearFocus': 'Hapus fokus',
    'hr.pickPtLabel': 'Pilih perusahaan',
    'hr.searchLabel': 'Cari karyawan',
    'hr.ptActiveHint': 'Menampilkan data {pt} saja — ganti chip untuk pindah PT.',
    'hr.ptPickHint': 'Wajib pilih JGI atau JGT dulu sebelum melihat daftar karyawan.',
    'hr.filterAllStatus': 'Semua status',
    'hr.filterActive': 'Aktif',
    'hr.filterResign': 'Resign',
    'hr.filterInactive': 'Resign',
    'hr.filterAllPtkp': 'Semua PTKP',
    'hr.filterKasbon': 'Ada kasbon',
    'hr.statPphEst': 'Estimasi PPh 21',
    'hr.statActiveMeta': '{total} total · {off} resign',
    'hr.kasbonOpen': 'belum dilunasi',
    'hr.kasbonCount': '{n} orang',
    'hr.kasbonAging': 'Aging kasbon',
    'hr.kasbonAgingHint': 'Berdasarkan tanggal kasbon tertua yang masih terbuka.',
    'hr.aging0_30': '0–30 hari',
    'hr.aging31_60': '31–60 hari',
    'hr.aging61_90': '61–90 hari',
    'hr.aging90p': '>90 hari',
    'hr.agingDays': '{n} hari',
    'hr.colAging': 'Aging',
    'hr.tabKasbon': 'Kasbon',
    'hr.exportCsv': 'Export CSV',
    'hr.exportBtn': 'Export',
    'hr.exportTitle': 'Unduh data HR',
    'hr.exportFormat': 'Format file',
    'hr.exportScope': 'Isi data',
    'hr.exportHint': 'Pilih format & isi, lalu pencet Download Now. Paket lengkap berisi karyawan, kasbon, payroll, dan COA.',
    'hr.downloadNow': 'Download Now',
    'hr.exportScopePack': 'Paket lengkap (semua)',
    'hr.exportScopeEmployees': 'Master karyawan',
    'hr.exportScopeKasbon': 'Kasbon & mutasi',
    'hr.exportScopePayroll': 'Payroll bulan ini',
    'hr.exportScopeCoa': 'Akun COA payroll',
    'hr.snack.downloadReady': 'Siap: {format} · {scope}',
    'hr.active': 'Aktif',
    'hr.resign': 'Resign',
    'hr.badgeGaji': 'Gaji LK',
    'hr.badgeOpex': 'Opex/office',
    'hr.badgeGajiHint': 'Masuk Biaya Gaji (5001) di laporan keuangan',
    'hr.badgeOpexHint': 'Bukan roster jasa gudang — beban ke pengeluaran lain-lain (5004)',
    'hr.inactive': 'Resign',
    'hr.activate': 'Aktifkan kembali',
    'hr.deactivate': 'Tandai resign',
    'hr.markResign': 'Tandai resign',
    'hr.employmentStatus': 'Status kerja',
    'hr.leftAtLabel': 'Tanggal resign',
    'hr.workPeriod': 'Masa kerja',
    'hr.periodRange': '{from} → {to}',
    'hr.periodOpenEnd': 'Sejak {from}',
    'hr.snack.resigned': 'Karyawan ditandai resign',
    'hr.kasbonChannel': 'Sumber kasbon',
    'hr.kasbonChannelSystem': 'Sistem HR (piutang karyawan vs kas)',
    'hr.kasbonChannelExternal': 'Sistem terpisah (hutang kasbon vs kas)',
    'hr.kasbonChannelSystemHint': 'Disetujui: Dr Piutang Karyawan · Cr Kas',
    'hr.kasbonChannelExternalHint': 'Disetujui: Dr Hutang Kasbon · Cr Kas — untuk kasbon yang sudah/akan lewat e-statement',
    'hr.kasbonResignBlocked': 'Karyawan resign tidak bisa mengajukan kasbon baru. Pelunasan masih boleh dicatat.',
    'hr.viewDetail': 'Lihat detail',
    'hr.addKasbon': 'Catat kasbon',
    'hr.addKasbonBtn': 'Tambah Kasbon',
    'hr.saveKasbon': 'Simpan Kasbon',
    'hr.kasbonNo': 'No. Kasbon',
    'hr.refId': 'Ref ID',
    'hr.refIdAuto': 'Ref ID jurnal',
    'hr.pickEmployee': 'Pilih karyawan',
    'hr.pickEmployeeHint': 'Pilih karyawan aktif di PT ini',
    'hr.copyNik': 'Salin NIK',
    'hr.kasbonBoardTitle': 'Kasbon terbuka',
    'hr.kasbonBoardSub': 'Karyawan dengan sisa kasbon — klik baris untuk riwayat lengkap.',
    'hr.noOpenKasbon': 'Tidak ada kasbon terbuka di PT ini.',
    'hr.kasbonLedger': 'Mutasi kasbon',
    'hr.kasbonLedgerHint': 'Mutasi dalam periode filter (default: bulan ini). Klik baris untuk history karyawan.',
    'hr.kasbonFilterActive': 'Filter mutasi aktif: {period}',
    'hr.kasbonSearchPh': 'Cari nama, no kasbon, ref…',
    'hr.filterKindAll': 'Semua jenis',
    'hr.filterEmployee': 'Karyawan',
    'hr.filterEmployeeAll': 'Semua karyawan',
    'hr.pengajuanTitle': 'Pengajuan kasbon',
    'hr.pengajuanSub':
      'Ajukan → Setujui (jurnal piutang realtime) atau Tolak (tetap di slip, tidak masuk laporan keuangan).',
    'hr.pengajuanBtn': 'Pengajuan kasbon',
    'hr.pengajuanEmptyTitle': 'Belum ada pengajuan',
    'hr.pengajuanEmptySub':
      'Kalau ada pengajuan masuk, daftarnya akan muncul di sini beserta tombol Setujui dan Tolak.',
    'hr.pengajuanDialogTitle': 'Ajukan kasbon',
    'hr.pengajuanDialogSub': 'Disimpan sebagai pending — belum jurnal sampai disetujui.',
    'hr.pengajuanStatusPending': 'Menunggu',
    'hr.pengajuanStatusApproved': 'Disetujui',
    'hr.pengajuanStatusRejected': 'Ditolak',
    'hr.pengajuanColStatus': 'Status',
    'hr.pengajuanColAction': 'Aksi',
    'hr.pengajuanApprove': 'Setujui',
    'hr.pengajuanReject': 'Tolak',
    'hr.pengajuanConfirmApprove':
      'Setujui kasbon {name} {n}? Jurnal Dr Piutang Karyawan · Cr Kas akan dibuat sekarang — neraca langsung terbarui.',
    'hr.pengajuanConfirmReject':
      'Tolak kasbon {name} {n}? Tidak masuk laporan keuangan, tetap tercatat di slip/riwayat.',
    'hr.snack.pengajuanSaved': 'Pengajuan kasbon tersimpan (menunggu approve)',
    'hr.snack.pengajuanApproved': 'Kasbon disetujui · jurnal {ref} · neraca terbarui',
    'hr.snack.pengajuanRejected': 'Kasbon ditolak — tidak masuk laporan keuangan',
    'hr.kasbonNeedsApproveHint':
      'Kasbon baru disimpan sebagai pengajuan. Setelah simpan, gunakan tombol Setujui / Tolak. Setujui membuat jurnal piutang secara langsung.',
    'hr.colGajiAwal': 'Gaji awal',
    'hr.colGajiPulang': 'Gaji pulang',
    'hr.colKasbonDeduct': 'Potong kasbon',
    'hr.kasbonDeductHint': 'Pelunasan piutang di slip',
    'hr.openBalances': 'Saldo terbuka',
    'hr.openPortal': 'Portal karyawan',
    'hr.pendingApproveBtn': '{n} menunggu',
    'hr.pendingBannerTitle': '{n} pengajuan kasbon menunggu persetujuan',
    'hr.pendingBannerSub': 'Setujui agar masuk piutang & neraca, atau tolak (tetap di slip tanpa jurnal).',
    'hr.ledgerTotal': 'akumulasi ledger',
    'hr.movements': '{n} mutasi',
    'hr.payrollPanelTitle': 'Payroll & jurnal gaji',
    'hr.payrollPanelSub': 'Periode {period} — preview, posting, dan riwayat per PT.',
    'hr.previewBreakdown': 'Rincian preview',
    'hr.clickRowHistory': 'Klik baris → history lengkap',
    'hr.journalPreview': 'Pratinjau jurnal',
    'hr.journalPreviewSub': 'Akan diposting ke akun COA berikut:',
    'hr.takeHome': 'take-home',
    'hr.postedRuns': 'run terposting',
    'hr.noCompanyPayroll': 'Belum ada payroll yang diposting untuk PT ini.',
    'hr.historyPopupTitle': 'History lengkap karyawan',
    'hr.tabOverview': 'Ringkas',
    'hr.tabPayHist': 'Gaji',
    'hr.tabJournals': 'Jurnal',
    'hr.tabCoa': 'COA',
    'hr.kasbonIn': 'Total kasbon',
    'hr.advanceDialogTitle': 'Catat kasbon / potongan',
    'hr.advanceDialogSub': 'Lengkap dengan akun COA, nomor kasbon, dan Ref ID jurnal otomatis.',
    'hr.advanceKind': 'Jenis',
    'hr.advanceAmount': 'Jumlah kasbon',
    'hr.advanceAmountHint': 'Contoh: ketik 300000 → otomatis Rp 300,000',
    'hr.advanceNote': 'Keterangan',
    'hr.advanceNotePh': 'Contoh: Kasbon operasional gudang / darurat',
    'hr.advanceCoaTitle': 'Akun jurnal (sesuai daftar COA)',
    'hr.debitAccount': 'Akun debit (no. & nama)',
    'hr.debitAccountHint': 'Kasbon: biasanya Piutang Karyawan / Pemegang',
    'hr.creditAccount': 'Akun kredit (no. & nama)',
    'hr.creditAccountHint': 'Kasbon: biasanya Kas / Bank',
    'hr.postJournalSwitch': 'Buat jurnal akuntansi otomatis (disarankan)',
    'hr.advanceNeedEmployee': 'Pilih karyawan dulu',
    'hr.advanceNeedAmount': 'Isi jumlah kasbon (> 0)',
    'hr.advanceNeedAccounts': 'Pilih akun debit & kredit dari COA',
    'hr.dialogPtNote': 'Disimpan ke {pt} — {name}',
    'hr.snack.deactivated': 'Karyawan dinonaktifkan',
    'hr.snack.activated': 'Karyawan diaktifkan',
    'hr.snack.advanceSaved': 'Kasbon / potongan disimpan',
    'hr.snack.copied': '{label} disalin',
    'hr.snack.exported': 'Export {n} baris CSV',
    'hr.kasbonBalance': 'Sisa kasbon',
    'hr.statCount': 'Karyawan',
    'hr.statActive': '{n} aktif',
    'hr.statGross': 'Total bruto/bulan',
    'hr.statAvg': 'Rata-rata bruto',
    'hr.perMonth': '/ bulan',
    'hr.coaKicker': 'Akun terkait (COA)',
    'hr.coaTitle': 'Nomor & nama akun payroll',
    'hr.coaSub': 'Diambil dari Daftar Akun — pastikan kode ini ada sebelum posting jurnal gaji.',
    'hr.openCoa': 'Buka Daftar Akun',
    'hr.coaMissing': 'Belum ada di COA',
    'hr.normal': 'Saldo normal',
    'hr.searchPlaceholder': 'Cari nama, jabatan, NIK…',
    'hr.rowHint': 'Klik baris untuk riwayat gaji, kasbon, dan jurnal terkait',
    'hr.emptyEmployees': 'Belum ada karyawan untuk PT ini.',
    'hr.emptyEmployeesHint': 'Tambah karyawan baru, atau ubah filter status / pencarian.',
    'hr.pickPtTap': 'Ketuk untuk buka',
    'hr.colNik': 'NIK',
    'hr.colGross': 'Bruto',
    'hr.colKasbon': 'Sisa kasbon',
    'hr.since': 'Sejak {date}',
    'hr.profileTitle': 'Profil',
    'hr.sinceLabel': 'Bergabung',
    'hr.payrollHistoryTitle': 'Riwayat gaji (posting)',
    'hr.noPayrollHistory': 'Belum ada payroll yang diposting untuk karyawan ini.',
    'hr.kasbonHistoryTitle': 'Kasbon & potongan',
    'hr.noKasbon': 'Belum ada catatan kasbon.',
    'hr.kindKasbon': 'Kasbon',
    'hr.kindRepayment': 'Potong gaji',
    'hr.kindBonus': 'Bonus',
    'hr.journalHistoryTitle': 'Jurnal terkait',
    'hr.noJournals': 'Belum ada jurnal yang cocok dengan nama karyawan.',
    'hr.linkedCoaTitle': 'Akun jurnal payroll',
    'hr.tabEmployees': 'Karyawan',
    'hr.tabPayroll': 'Payroll',
    'hr.addEmployee': 'Tambah Karyawan',
    'hr.restoreRoster': 'Pulihkan roster resign',
    'hr.restoreRosterShort': 'Pulihkan roster',
    'hr.resignHiddenBanner': '{n} karyawan resign disembunyikan oleh filter Aktif',
    'hr.showAllEmployees': 'Tampilkan semua',
    'hr.resignIncludedNote': 'Termasuk {n} karyawan resign (Jan–Agt) di daftar bawah',
    'hr.snack.rosterRestored': 'Roster karyawan (termasuk resign) dipasang ulang',
    'hr.colName': 'Nama',
    'hr.colPosition': 'Jabatan',
    'hr.colPtkp': 'PTKP',
    'hr.colSalary': 'Gaji',
    'hr.colAllowance': 'Tunjangan',
    'hr.edit': 'Edit',
    'hr.delete': 'Hapus',
    'hr.deleteHint': 'Tombol hapus (ikon tempat sampah) hanya untuk admin — buang data dummy/resign secara permanen.',
    'hr.deleteAdminOnly': 'Hanya admin yang boleh menghapus karyawan.',
    'hr.confirmDeleteNamed': 'Hapus permanen “{name}”? Tidak bisa dibatalkan.',
    'hr.snack.deleted': 'Karyawan {name} dihapus',
    'hr.monthLabel': 'Bulan',
    'hr.previewBtn': 'Preview',
    'hr.postJournal': 'Posting Jurnal',
    'hr.postJanAgt': 'Post Jan–Agt 2026',
    'hr.previewTitle': 'Preview · Gross {gross} · PPh21 {pph} · Net {net}',
    'hr.colPph21': 'PPh 21',
    'hr.colPphOverride': 'Override PPh 21 (Rp)',
    'hr.colNote': 'Catatan',
    'payslip.title': 'Slip Gaji',
    'payslip.kicker': 'HR · Payroll',
    'payslip.sub':
      'Pratinjau slip per karyawan dari gaji master (default bulan kemarin). Admin bisa edit gaji/status dan hapus data.',
    'payslip.search': 'Cari nama / NIK…',
    'payslip.refresh': 'Muat ulang',
    'payslip.empty': 'Tidak ada slip untuk PT/periode ini.',
    'payslip.adminHint': 'Mode admin: edit gaji, status resign, atau hapus karyawan dari daftar slip.',
    'payslip.editTitle': 'Edit karyawan & gaji',
    'payslip.editAdminOnly': 'Edit gaji hanya untuk admin / akuntan',
    'payslip.deleteAdminOnly': 'Hapus karyawan hanya untuk admin',
    'payslip.confirmDelete': 'Hapus permanen {name}? Absensi & kasbon terkait ikut terhapus.',
    'payslip.snackSaved': 'Data karyawan & gaji disimpan',
    'payslip.snackDeleted': '{name} dihapus',
    'payslip.empNotFound': 'Karyawan tidak ditemukan',
    'payslip.prevMonth': 'Bulan sebelumnya',
    'payslip.nextMonth': 'Bulan berikutnya',
    'hr.colNet': 'Net',
    'hr.calcNote':
      'Perhitungan progresif tahunan ÷ 12 (bukan TER). Sesuaikan dengan konsultan sebelum e-Bupot resmi.',
    'hr.historyTitle': 'Riwayat posting',
    'hr.colPeriod': 'Periode',
    'hr.colStatus': 'Status',
    'hr.dialogAdd': 'Tambah Karyawan',
    'hr.dialogEdit': 'Edit Karyawan',
    'hr.nameLabel': 'Nama',
    'hr.positionLabel': 'Jabatan',
    'hr.ptkpLabel': 'Status PTKP',
    'hr.baseSalaryLabel': 'Gaji pokok',
    'hr.allowanceLabel': 'Tunjangan',
    'hr.nikLabel': 'NIK',
    'hr.npwpLabel': 'NPWP',
    'hr.snack.saved': 'Karyawan disimpan',
    'hr.confirmDelete': 'Hapus karyawan?',
    'hr.snack.posted': 'Payroll diposting · jurnal {ref}',
    'hr.snack.batchPosted': 'Payroll Jan–Agt: {posted} bulan diposting, {skipped} dilewati (akrual)',

    'prac.kicker': 'Praktik konsultan',
    'prac.clientsTitle': 'Klien / Wajib Pajak',
    'prac.clientsSub': 'Master WP untuk engagement, surat, dan tracking fee',
    'prac.addClient': 'Tambah klien',
    'prac.editClient': 'Edit klien',
    'prac.searchClient': 'Cari kode / nama / NPWP…',
    'prac.emptyClients': 'Belum ada klien — tambah WP pertama',
    'prac.code': 'Kode',
    'prac.name': 'Nama',
    'prac.type': 'Jenis',
    'prac.phone': 'Telepon',
    'prac.address': 'Alamat',
    'prac.client': 'Klien',
    'prac.saved': 'Tersimpan',
    'prac.confirmDelete': 'Hapus “{name}”?',
    'prac.statTotal': 'Total klien',
    'prac.statNpwpOk': 'NPWP lengkap',
    'prac.statNpwpMissing': 'NPWP kosong',
    'prac.statIncomplete': 'Data kurang',
    'prac.statReady': 'Siap engagement',
    'prac.statNoContact': 'Tanpa kontak',
    'prac.showing': '{n} klien tampil',
    'prac.readyPct': 'Siap {pct}%',
    'prac.incompleteN': '{n} belum lengkap',
    'prac.readyHint': '{ok} siap · {need} perlu dilengkapi',
    'prac.needAttention': '{n} item perlu perhatian',
    'prac.vizReady': 'Kesiapan master WP',
    'prac.vizGaps': 'Field yang masih kosong',
    'prac.vizType': 'Komposisi jenis WP',
    'prac.vizInactive': '{n} klien nonaktif',
    'prac.filterBar': 'Filter jenis & pencarian',
    'prac.healthTitle': 'Status kesehatan master klien',
    'prac.healthSub': 'Klik lane untuk fokus klien yang perlu dilengkapi.',
    'prac.clearLane': 'Tampilkan semua',
    'prac.lane.all': 'Semua',
    'prac.lane.ready': 'Siap',
    'prac.lane.incomplete': 'Belum lengkap',
    'prac.lane.npwp_missing': 'NPWP kosong',
    'prac.lane.npwp_ok': 'NPWP lengkap',
    'prac.lane.badan': 'Badan',
    'prac.lane.pribadi': 'Pribadi',
    'prac.lane.umkm': 'UMKM',
    'prac.lane.no_contact': 'Tanpa kontak',
    'prac.lane.inactive': 'Nonaktif',
    'prac.type.badan': 'Badan',
    'prac.type.pribadi': 'Pribadi',
    'prac.type.umkm': 'UMKM',
    'prac.tipsTitle': 'Saran cepat · master WP rapi',
    'prac.tipsShow': 'Tampilkan',
    'prac.tipsHide': 'Sembunyikan',
    'prac.tip1': 'Isi NPWP, alamat, dan KPP dulu agar engagement & surat pajak akurat.',
    'prac.tip2': 'Lengkapi email/telepon untuk follow-up fee dan reminder kalender.',
    'prac.tip3': 'Jenis Badan / Pribadi / UMKM memengaruhi template dokumen & tarif.',
    'prac.tip4': 'Nonaktifkan klien lama tanpa menghapus — riwayat engagement tetap aman.',
    'prac.tipActEdit': 'Edit {n} belum lengkap',
    'prac.tipActNpwp': 'Filter NPWP kosong ({n})',
    'prac.tipActContact': 'Filter tanpa kontak ({n})',
    'prac.toCalendar': 'Kalender pajak',
    'prac.toDocs': 'Surat & berkas',
    'prac.exportCsv': 'Ekspor CSV',
    'prac.exportEmpty': 'Tidak ada data untuk diekspor',
    'prac.exportDone': 'CSV {n} klien diunduh',
    'prac.listKicker': 'Master list',
    'prac.listTitle': 'Daftar wajib pajak',
    'prac.listSub': 'Sel kosong ditandai merah · chip menunjukkan field yang kurang',
    'prac.colNpwp': 'NPWP',
    'prac.colEmail': 'Email',
    'prac.colKpp': 'KPP',
    'prac.colContact': 'Kontak',
    'prac.colStatus': 'Status',
    'prac.colAction': 'Aksi',
    'prac.statusIncomplete': 'Belum lengkap',
    'prac.statusReady': 'Siap',
    'prac.statusInactive': 'Nonaktif',
    'prac.emptyTitle': 'Tidak ada klien cocok',
    'prac.emptyFiltered': 'Filter terlalu ketat — reset atau ubah pencarian.',
    'prac.resetFilters': 'Reset filter',
    'prac.alertIncomplete':
      'Ada {n} klien dengan data kurang (NPWP / alamat / KPP). Lengkapi sebelum buat engagement.',
    'prac.dialogEdit': 'Edit manual',
    'prac.dialogNew': 'Tambah baru',
    'prac.tabIdentity': 'Identitas',
    'prac.tabTax': 'Alamat & KPP',
    'prac.tabContact': 'Kontak',
    'prac.codeHint': 'Kosongkan untuk kode otomatis WP-…',
    'prac.npwpHint': '15/16 digit — otomatis diformat',
    'prac.npwpIncomplete': 'NPWP belum lengkap (15/16 digit)',
    'prac.required': 'Wajib diisi',
    'prac.addressRequired': 'Wajib untuk surat & SPT',
    'prac.kppHint': 'Contoh: KPP Pratama Tangerang Barat',
    'prac.kppRequired': 'Wajib untuk birokrasi pajak',
    'prac.activeSwitch': 'Klien aktif',
    'prac.formReady': 'Kelengkapan form {pct}%',
    'prac.snack.nameRequired': 'Nama klien wajib',
    'prac.deleted': 'Klien dihapus',
    'prac.engTitle': 'Engagement & Fee',
    'prac.engSub': 'Kontrak jasa, status, dan pipeline fee per tahun',
    'prac.addEng': 'Tambah engagement',
    'prac.engName': 'Judul engagement',
    'prac.feePipeline': 'Total fee (pipeline)',
    'prac.emptyEng': 'Belum ada engagement',
    'prac.due': 'Jatuh tempo',
    'prac.engStatTotal': '{n} kontrak',
    'prac.engShowing': '{n} engagement tampil',
    'prac.engCollected': 'Tertagih {pct}%',
    'prac.engCollectedHint': 'Terbayar {paid} dari pipeline {total}',
    'prac.engOverdueN': '{n} lewat jatuh tempo',
    'prac.engFilteredFee': 'Fee filter {n}',
    'prac.engNeedAttention': '{n} item perlu perhatian',
    'prac.engVizCollect': 'Kolektibilitas fee',
    'prac.engVizFee': 'Pipeline per status',
    'prac.engVizKind': 'Komposisi jenis jasa',
    'prac.engVizNoFee': '{n} tanpa nilai fee',
    'prac.engFilterBar': 'Filter tahun, jenis & pencarian',
    'prac.engHealthTitle': 'Status pipeline engagement',
    'prac.engHealthSub': 'Klik lane untuk fokus kontrak yang perlu ditindaklanjuti.',
    'prac.engClearLane': 'Tampilkan semua',
    'prac.engLane.all': 'Semua',
    'prac.engLane.open': 'Open',
    'prac.engLane.in_progress': 'Berjalan',
    'prac.engLane.done': 'Selesai',
    'prac.engLane.billed': 'Ditagih',
    'prac.engLane.paid': 'Lunas',
    'prac.engLane.overdue': 'Lewat tempo',
    'prac.engLane.no_fee': 'Tanpa fee',
    'prac.engStatus.open': 'Open',
    'prac.engStatus.in_progress': 'Berjalan',
    'prac.engStatus.done': 'Selesai',
    'prac.engStatus.billed': 'Ditagih',
    'prac.engStatus.paid': 'Lunas',
    'prac.engKind.spt': 'SPT',
    'prac.engKind.pembukuan': 'Pembukuan',
    'prac.engKind.konsultan': 'Konsultan',
    'prac.engKind.lain': 'Lain',
    'prac.engYearAll': 'Semua tahun',
    'prac.engSearchPh': 'Cari klien / judul / status…',
    'prac.engTipsTitle': 'Saran cepat · pipeline fee rapi',
    'prac.engTip1': 'Buat engagement per klien + tahun agar fee dan deadline terlacak.',
    'prac.engTip2': 'Isi fee & jatuh tempo sebelum status Ditagih — hindari kontrak tanpa nilai.',
    'prac.engTip3': 'Gunakan DP jurnal dari baris engagement untuk mencatat penerimaan fee.',
    'prac.engTip4': 'Update status cepat (Open → Berjalan → Ditagih → Lunas) dari menu aksi.',
    'prac.engTipOverdue': 'Tinjau {n} lewat tempo',
    'prac.engTipNoFee': 'Isi {n} tanpa fee',
    'prac.engTipBilled': 'Filter ditagih ({n})',
    'prac.engNeedClient': 'Belum ada klien WP — tambah klien dulu sebelum buat engagement.',
    'prac.engListKicker': 'Pipeline',
    'prac.engListTitle': 'Daftar engagement',
    'prac.engListSub': 'Lewat tempo & tanpa fee ditandai · ubah status cepat dari aksi',
    'prac.engColKind': 'Jenis',
    'prac.engColFee': 'Fee',
    'prac.engColStatus': 'Status',
    'prac.engColAction': 'Aksi',
    'prac.engEmptyTitle': 'Tidak ada engagement cocok',
    'prac.engEmptyFiltered': 'Filter terlalu ketat — reset atau ubah pencarian.',
    'prac.engResetFilters': 'Reset filter',
    'prac.engAlertOverdue': 'Ada {n} engagement lewat jatuh tempo dan belum lunas/selesai.',
    'prac.engDialogEdit': 'Edit kontrak',
    'prac.engDialogNew': 'Kontrak baru',
    'prac.engEditTitle': 'Edit engagement',
    'prac.engTabContract': 'Kontrak',
    'prac.engTabFee': 'Fee & status',
    'prac.engTabSchedule': 'Jadwal',
    'prac.engStart': 'Tanggal mulai',
    'prac.engFeeHint': 'Nilai fee kontrak (Rp)',
    'prac.engFeeRequired': 'Isi fee agar pipeline akurat',
    'prac.engDueRequired': 'Jatuh tempo disarankan diisi',
    'prac.engFormReady': 'Kelengkapan form {pct}%',
    'prac.engSnack.clientRequired': 'Pilih klien wajib',
    'prac.engSnack.titleRequired': 'Judul engagement wajib',
    'prac.engDeleted': 'Engagement dihapus',
    'prac.engStatusUpdated': 'Status diperbarui',
    'prac.engQuickStatus': 'Ubah status cepat',
    'prac.engExportCsv': 'Ekspor CSV',
    'prac.engExportEmpty': 'Tidak ada data untuk diekspor',
    'prac.engExportDone': 'CSV {n} engagement diunduh',
    'prac.calTitle': 'Kalender Pajak',
    'prac.calSub': 'Deadline SPT masa, PPh Final, dan pengingat praktik',
    'prac.calAll': 'Semua',
    'prac.calSoon': 'Segera',
    'prac.calPast': 'Lewat',
    'prac.calUpcoming': 'Mendatang',
    'prac.calNext': 'Berikutnya: {title} · {date}',
    'prac.calEvent': 'Kegiatan',
    'prac.calKind': 'Jenis',
    'prac.calKicker': 'Deadline & pengingat',
    'prac.calToday': 'Hari ini {d}',
    'prac.calChipSoon': '{n} segera jatuh tempo',
    'prac.calChipClear': 'Tidak ada yang mendesak',
    'prac.calLoadedAt': 'Dimuat {t}',
    'prac.calOpen': 'Buka',
    'prac.calBannerOk': 'Tidak ada deadline dalam 14 hari ke depan',
    'prac.calKpiSoonMeta': '≤ 14 hari',
    'prac.calKpiUpcomingMeta': 'Lebih dari 14 hari',
    'prac.calKpiPastMeta': 'Sudah lewat tanggal',
    'prac.calKpiAllMeta': 'Total event tahun {year}',
    'prac.calVizUrgency': 'Komposisi urgensi',
    'prac.calVizKind': 'Jenis kewajiban',
    'prac.calVizMonth': 'Kepadatan per bulan jatuh tempo',
    'prac.calHealthTitle': 'Jalur kalender',
    'prac.calHealthSub': 'Klik untuk filter daftar deadline',
    'prac.calTipsTitle': 'Saran tindakan',
    'prac.calTipNext': 'Segera: {title} · {date}',
    'prac.calTipPast': '{n} deadline sudah lewat — review kepatuhan',
    'prac.calTipHub': 'Posting PPh final di Pusat Pajak',
    'prac.calTipSpt': 'Siapkan paket SPT masa',
    'prac.calTipSsp': 'Catat billing / NTPN di pelacak SSP',
    'prac.calTipOk': 'Kalender tenang — tidak ada deadline segera',
    'prac.calFocusSoon': 'Filter: segera',
    'prac.calFocusUpcoming': 'Filter: mendatang',
    'prac.calFocusPast': 'Filter: lewat',
    'prac.calFocusKind': 'Filter jenis: {kind}',
    'prac.calFocusSearch': 'Cari: “{q}”',
    'prac.calClearFocus': 'Hapus fokus',
    'prac.calEmpty': 'Kalender belum dimuat',
    'prac.calEmptyHint': 'Pilih tahun lalu muat ulang',
    'prac.calTableKicker': 'Daftar',
    'prac.calTableTitle': 'Deadline pajak {year}',
    'prac.calTableSub': 'Menampilkan {shown} dari {total} event',
    'prac.calSearchPh': 'Cari kegiatan / jenis / tanggal…',
    'prac.calSearchLabel': 'Cari',
    'prac.calRefreshShort': 'Ulang',
    'prac.calHubShort': 'Pusat',
    'prac.calSptShort': 'SPT Masa',
    'prac.calKindSptMasaShort': 'SPT Masa',
    'prac.calStatus': 'Status',
    'prac.calAction': 'Aksi',
    'prac.calMasa': 'Masa {m}',
    'prac.calNoRows': 'Tidak ada event cocok',
    'prac.calFooterNote': 'Segera = jatuh tempo dalam 14 hari. SPT masa umumnya tgl 20; PPh 21 tgl 10.',
    'prac.calKindSptMasa': 'SPT Masa / PPh Final',
    'prac.calKindPph21': 'PPh 21',
    'prac.calKindSptTahunan': 'SPT Tahunan',
    'prac.calKindOther': 'Lainnya',
    'prac.docTitle': 'Surat & Berkas Pajak',
    'prac.docSub': 'Arsip SPT, SSP, bukti potong, dan surat klien',
    'prac.upload': 'Unggah',
    'prac.pickFile': 'Pilih file',
    'prac.docName': 'Judul berkas',
    'prac.docType': 'Tipe',
    'prac.download': 'Unduh',
    'prac.emptyDocs': 'Belum ada berkas',
    'prac.needFile': 'Pilih file dulu',
    'prac.uploaded': 'Berkas terunggah',
    'prac.docPx.kicker': 'Arsip pajak',
    'prac.docPx.loadedAt': 'Dimuat {t}',
    'prac.docPx.chipCount': '{n} berkas',
    'prac.docPx.chipEmpty': 'Arsip kosong',
    'prac.docPx.bannerSpt': 'Belum ada berkas SPT untuk {year}',
    'prac.docPx.bannerOk': '{n} berkas · {size}',
    'prac.docPx.focusSptShort': 'Filter SPT',
    'prac.docPx.kpiCount': 'Total berkas',
    'prac.docPx.kpiCountMeta': 'Ukuran {size}',
    'prac.docPx.kpiYear': 'Tahun fokus',
    'prac.docPx.kpiYearMeta': 'Filter {year}',
    'prac.docPx.kpiRecent': '30 hari terakhir',
    'prac.docPx.kpiRecentMeta': 'Unggahan baru',
    'prac.docPx.kpiGaps': 'Metadata kurang',
    'prac.docPx.kpiGapsMeta': '{client} tanpa klien · {pt} tanpa PT',
    'prac.docPx.vizType': 'Tipe berkas',
    'prac.docPx.vizMonth': 'Unggahan per masa',
    'prac.docPx.vizSnapshot': 'Snapshot kelengkapan',
    'prac.docPx.vizEmpty': 'Belum ada tipe',
    'prac.docPx.vizEmptyMonth': 'Belum ada data bulanan',
    'prac.docPx.snapNoClient': 'Tanpa klien',
    'prac.docPx.snapNoPt': 'Tanpa PT',
    'prac.docPx.snapNoYear': 'Tanpa tahun',
    'prac.docPx.snapDp': 'Kontrak / Invoice DP',
    'prac.docPx.healthTitle': 'Jalur tipe',
    'prac.docPx.healthSub': 'Klik untuk filter arsip',
    'prac.docPx.tipsTitle': 'Saran tindakan',
    'prac.docPx.tipSpt': 'Belum ada SPT {year} — unggah paket SPT',
    'prac.docPx.tipClient': '{n} berkas tanpa klien',
    'prac.docPx.tipPt': '{n} berkas tanpa PT',
    'prac.docPx.tipDp': 'Lampirkan kontrak/Invoice DP lalu tautkan ke Uang Muka',
    'prac.docPx.tipWht': 'Bukti potong juga dicatat di register PPh 23',
    'prac.docPx.tipSsp': 'Billing/NTPN dicatat di pelacak SSP',
    'prac.docPx.tipUpload': 'Unggah berkas baru ke arsip',
    'prac.docPx.tipOk': 'Arsip sehat — metadata relatif lengkap',
    'prac.docPx.focusType': 'Filter tipe: {t}',
    'prac.docPx.focusSearch': 'Cari: “{q}”',
    'prac.docPx.clearFocus': 'Hapus fokus',
    'prac.docPx.emptyHint': 'Unggah SPT, SSP, bukti potong, atau surat klien',
    'prac.docPx.tableKicker': 'Arsip',
    'prac.docPx.tableTitle': 'Daftar berkas',
    'prac.docPx.tableSub': 'Menampilkan {shown} dari {total}',
    'prac.docPx.searchPh': 'Cari judul / tipe / klien / file…',
    'prac.docPx.noRows': 'Tidak ada baris cocok',
    'prac.docPx.action': 'Aksi',
    'prac.docPx.masa': 'Masa',
    'prac.docPx.size': 'Ukuran',
    'prac.docPx.noClient': 'Tanpa klien',
    'prac.docPx.noPt': 'Tanpa PT',
    'prac.docPx.typeBukti': 'Bukti Potong',
    'prac.docPx.typeSsp': 'SSP',
    'prac.docPx.typeEfaktur': 'e-Faktur',
    'prac.docPx.typeSpt': 'SPT',
    'prac.docPx.typeKontrak': 'Kontrak / PO',
    'prac.docPx.typeInvoiceDp': 'Invoice DP',
    'prac.docPx.typeLain': 'Lainnya',
    'prac.docPx.monthLabel': 'Bulan {m}',
    'prac.docPx.uploadKicker': 'Form unggah',
    'prac.docPx.deleted': 'Berkas dihapus',
    'prac.docPx.exportCsv': 'Ekspor CSV',
    'prac.docPx.exportCsvShort': 'CSV',
    'prac.docPx.refreshShort': 'Ulang',
    'prac.docPx.searchLabel': 'Cari',
    'prac.docPx.exportEmpty': 'Tidak ada baris untuk diekspor',
    'prac.docPx.footerNote':
      'Arsip untuk jejak audit. Tautkan memo jurnal ke nama pelanggan yang sama untuk DP/kontrak.',
    'prac.consTitle': 'Konsolidasi Grup',
    'prac.consSub': 'Gabungan L/R & neraca semua PT terpilih + eliminasi IC',
    'prac.consByPt': 'Per perusahaan',
    'prac.consKicker': 'Grup · Multi-PT · Eliminasi IC',
    'prac.consNote':
      'Angka komersial digabung untuk PT yang dipilih. Eliminasi IC ditampilkan terpisah — bukan full consolidation IFRS. PT baru di master otomatis ikut katalog grup.',
    'prac.consPtCount': '{n} PT',
    'prac.consPtPicker': 'PT dalam grup',
    'prac.consPtAll': 'Semua PT',
    'prac.consPtPickHint': 'Centang PT yang digabung. Default: semua perusahaan di master.',
    'prac.consAddPt': 'Kelola PT',
    'prac.consAddPtInline': 'Tambah PT',
    'prac.consAddPtFull': 'Master lengkap',
    'prac.consNoPtYet': 'Belum ada perusahaan. Tambah PT di sini — langsung masuk katalog grup.',
    'prac.consAddKicker': 'Master PT',
    'prac.consAddTitle': 'Tambah perusahaan',
    'prac.consAddSub': 'Kode singkat + nama resmi. Bisa dilengkapi NPWP nanti di master.',
    'prac.consAddCode': 'Kode PT',
    'prac.consAddCodePh': 'Mis. JGX',
    'prac.consAddName': 'Nama perusahaan',
    'prac.consAddNamePh': 'PT Contoh Indonesia',
    'prac.consAddNpwp': 'NPWP (opsional)',
    'prac.consAddNpwpPh': '15–16 digit',
    'prac.consAddSave': 'Simpan & gabungkan',
    'prac.consAddCodeNeed': 'Isi kode PT (min. 2 huruf/angka)',
    'prac.consAddNameNeed': 'Isi nama perusahaan',
    'prac.consAddOk': 'PT {code} ditambahkan ke grup',
    'prac.consBsOk': 'Aset ≈ Liabilitas+Ekuitas',
    'prac.consBsGap': 'Neraca gabungan timpang',
    'prac.consIcChip': 'IC: {n} pasangan · {amount}',
    'prac.consOpenIc': 'Antar perusahaan',
    'prac.consOpenLk': 'Buka LK',
    'prac.consKpiPlMeta': 'Fokus L/R',
    'prac.consKpiBsMeta': 'Fokus neraca',
    'prac.consVizPlMix': 'Komposisi L/R gabungan',
    'prac.consVizBsMix': 'Komposisi neraca gabungan',
    'prac.consVizShareRev': 'Porsi pendapatan per PT',
    'prac.consVizShareAssets': 'Porsi aset per PT',
    'prac.consVizSnapshot': 'Snapshot konsolidasi',
    'prac.consVizEmpty': 'Belum ada data PT',
    'prac.consSnapMargin': 'Margin laba bersih',
    'prac.consSnapBsGap': 'Selisih neraca gabungan',
    'prac.consSnapIc': 'Pasangan IC',
    'prac.consHealthTitle': 'Navigasi fokus',
    'prac.consHealthSub': 'Klik chip untuk fokus L/R, neraca, atau IC.',
    'prac.consLanePl': 'Laba rugi',
    'prac.consLaneBs': 'Neraca',
    'prac.consLaneIc': 'Eliminasi IC',
    'prac.consTipsTitle': 'Saran tindakan',
    'prac.consTipGap': 'Neraca gabungan timpang {amount} — cek LK per PT',
    'prac.consTipNoIc': 'Belum ada pasangan IC tahun ini — review antar perusahaan',
    'prac.consTipIc': '{n} pasangan IC · {amount} — review eliminasi',
    'prac.consTipLk': 'Buka Laporan Keuangan formal per PT untuk detail akun',
    'prac.consTipShare': 'Bandingkan porsi pendapatan antar PT di tabel bawah',
    'prac.consTipOk': 'Ringkasan konsolidasi sehat',
    'prac.consAutoHint': 'AI mengeksekusi saran otomatis lalu menulis note di lonceng untuk cross-check.',
    'prac.consAutoRunning': 'AI sedang mengeksekusi saran…',
    'prac.consAutoDone': 'AI sudah eksekusi · {n} note baru di lonceng (siap di-cross-check).',
    'prac.consAutoSnack': 'AI menulis {n} note di lonceng — silakan cross-check.',
    'prac.consTipExecuted': 'Sudah dieksekusi AI',
    'prac.consTipExecutedBell': 'Sudah dieksekusi · cek lonceng untuk cross-check',
    'prac.consFocusPl': 'Fokus: metrik laba rugi',
    'prac.consFocusBs': 'Fokus: metrik neraca',
    'prac.consFocusIc': 'Fokus: eliminasi IC',
    'prac.consClearFocus': 'Hapus fokus',
    'prac.consEmpty': 'Data konsolidasi belum termuat',
    'prac.consEmptyHint': 'Pilih tahun & PT lalu muat ulang.',
    'prac.consByPtKicker': 'Breakdown',
    'prac.consByPtSub': 'Klik baris untuk membuka Laporan Keuangan PT tersebut.',
    'prac.consColAction': 'Aksi',
    'prac.consNeedTwo': 'Pilih minimal 1 PT untuk digabung.',
    'dash.groupConsTitle': 'Konsolidasi Grup',
    'dash.groupConsSub': '{n} PT · Laba bersih {amount}',
    'dash.groupConsCta': 'Buka konsolidasi',
    'dash.groupConsEmpty': 'Belum ada PT — tambah di master perusahaan',
    'prac.metric.pendapatan': 'Pendapatan',
    'prac.metric.beban': 'Beban',
    'prac.metric.labaBersih': 'Laba bersih',
    'prac.metric.aset': 'Aset',
    'prac.metric.liabilitas': 'Liabilitas',
    'prac.metric.ekuitas': 'Ekuitas',

    'cal.title': 'Kalender',
    'cal.kicker': 'Kalender Indonesia',
    'cal.frameOpen': 'Buka frame',
    'cal.frameClose': 'Tutup',
    'cal.proOpen': 'Buka kalender pro',
    'cal.proClose': 'Tutup kalender',
    'cal.proPeekEmpty': 'Tidak ada kegiatan 7 hari ke depan.',
    'cal.filterMeeting': 'Meeting saja',
    'cal.densityCompact': 'Rapatkan',
    'cal.filterMonth': 'Bulan',
    'cal.filterToggle': 'Filter',
    'cal.allMonths': 'Semua bulan',
    'cal.periodToday': 'Hari ini',
    'cal.periodWeek': 'Minggu ini',
    'cal.periodMonth': 'Bulan ini',
    'cal.periodLastMonth': 'Bulan lalu',
    'cal.periodEmpty': 'Tidak ada kegiatan pada periode ini.',
    'cal.activities': 'kegiatan',
    'cal.viewDay': 'Hari',
    'cal.viewWeek': 'Minggu',
    'cal.viewMonth': 'Bulan',
    'cal.viewAgenda': 'Agenda',
    'cal.noEventsDay': 'Tidak ada acara untuk ditampilkan',
    'cal.noEventsAgenda': 'Tidak ada acara untuk ditampilkan',
    'cal.addMeeting': 'Meeting / Hall',
    'cal.hall': 'Hall',
    'cal.exploreStaff': 'Lihat kegiatan staff',
    'cal.exploreHall': 'Lihat meeting & hall',
    'cal.prevYear': 'Tahun sebelumnya',
    'cal.nextYear': 'Tahun berikutnya',
    'cal.addTodo': '+ Add To-Do',
    'cal.addSchedule': 'Tambah Jadwal',
    'cal.addLeave': 'Tambah Cuti',
    'cal.yearTitle': 'Kalender Tahun {year} — Libur Nasional, To-Do & Jadwal Staff',
    'cal.yearBlurb':
      'Tahun {days} hari dengan {libur} hari libur nasional dan {cuti} cuti bersama. Pantau {todos} to-do terbuka, aktivitas {staff} staff, plus deadline pajak & tutup masa.',
    'cal.badgeHijri': 'Kalender Hijriyah',
    'cal.days': 'hari',
    'cal.openTodos': 'to-do terbuka',
    'cal.staff': 'Staff',
    'cal.nationalHoliday': 'Hari Libur Nasional',
    'cal.collectiveLeave': 'Cuti Bersama',
    'cal.today': 'Hari ini',
    'cal.taskMarker': 'Ada tugas / jadwal',
    'cal.tabYear': 'Tahun',
    'cal.tabTodos': 'To-Do',
    'cal.tabSchedules': 'Jadwal',
    'cal.tabStaff': 'Monitor Staff',
    'cal.filterStaff': 'Filter staff',
    'cal.allStaff': 'Semua staff',
    'cal.longTitle': 'Daftar Hari Libur Panjang Tahun {year}',
    'cal.longSub': 'Rentang libur yang digabung weekend, libur nasional, dan cuti bersama.',
    'cal.libur': 'Libur',
    'cal.cuti': 'Cuti',
    'cal.todoTitle': 'Daftar To-Do',
    'cal.todoSub': 'Tugas kantor — centang selesai, assign ke staff, prioritas tinggi ditandai.',
    'cal.emptyTodos': 'Belum ada to-do. Klik + Add To-Do atau klik tanggal di kalender.',
    'cal.scheduleTitle': 'Jadwal & Cuti',
    'cal.scheduleSub': 'Meeting, jadwal kerja, dan cuti staff dalam satu timeline.',
    'cal.emptySchedules': 'Belum ada jadwal. Tambahkan meeting, jadwal, atau cuti staff.',
    'cal.staffTitle': 'Monitor Semua Staff',
    'cal.staffSub': 'Beban kerja, jadwal, dan cuti — filter PT: {company}',
    'cal.busyToday': 'Sibuk hari ini',
    'cal.onLeave': 'Sedang cuti',
    'cal.unassigned': 'Belum di-assign',
    'cal.emptyStaff': 'Belum ada data karyawan aktif.',
    'cal.busy': 'Sibuk',
    'cal.free': 'Tersedia',
    'cal.noStaffEvents': 'Belum ada event tahun ini',
    'cal.unassignedEvents': 'Event belum di-assign',
    'cal.kindTodo': 'To-Do',
    'cal.kindSchedule': 'Jadwal',
    'cal.kindMeeting': 'Meeting',
    'cal.kindLeave': 'Cuti',
    'cal.statusPending': 'Pending',
    'cal.statusProgress': 'Dikerjakan',
    'cal.statusDone': 'Selesai',
    'cal.statusCancelled': 'Batal',
    'cal.priorityLow': 'Rendah',
    'cal.priorityNormal': 'Normal',
    'cal.priorityHigh': 'Tinggi',
    'cal.priorityUrgent': 'Urgent',
    'cal.newEvent': 'Buat baru',
    'cal.editEvent': 'Edit event',
    'cal.fieldTitle': 'Judul',
    'cal.fieldDesc': 'Catatan',
    'cal.fieldDate': 'Tanggal',
    'cal.fieldEndDate': 'Sampai (opsional)',
    'cal.allDay': 'Sehari penuh',
    'cal.startTime': 'Mulai',
    'cal.endTime': 'Selesai',
    'cal.assignStaff': 'Assign ke staff',
    'cal.fieldStatus': 'Status',
    'cal.fieldPriority': 'Prioritas',
    'cal.save': 'Simpan',
    'cal.cancel': 'Batal',
    'cal.delete': 'Hapus',
    'cal.needTitle': 'Judul wajib diisi',
    'cal.created': 'Berhasil ditambahkan',
    'cal.updated': 'Berhasil diperbarui',
    'cal.deleted': 'Berhasil dihapus',
    'cal.confirmDelete': 'Hapus event ini?',
    'cal.tabOps': 'Operasional',
    'cal.layers': 'Layer',
    'cal.layerTax': 'Pajak',
    'cal.layerAccounting': 'Akuntansi',
    'cal.layerPayroll': 'Payroll',
    'cal.layerHr': 'HR / Kasbon',
    'cal.layerEngagement': 'Engagement',
    'cal.layerTasks': 'To-Do / Jadwal',
    'cal.opsTitle': 'Kalender Operasional',
    'cal.opsSub': 'Deadline SPT, SSP, bukti potong, tutup masa, payroll, kasbon, dan engagement — klik untuk buka menu terkait.',
    'cal.opsAll': 'Semua',
    'cal.opsSoon': 'segera',
    'cal.opsOverdue': 'terlewat',
    'cal.emptyOps': 'Tidak ada item operasional untuk filter ini.',
    'cal.dayDetail': 'Detail hari',
    'cal.holiday': 'Libur / Cuti',
    'cal.noDayEvents': 'Belum ada to-do / jadwal di tanggal ini.',
    'cal.noDayOps': 'Tidak ada deadline operasional di tanggal ini.',
    'cal.prevDay': 'Hari sebelumnya',
    'cal.nextDay': 'Hari berikutnya',
    'cal.tomorrow': 'Besok',
    'cal.yesterday': 'Kemarin',
    'cal.inDays': '{n} hari lagi',
    'cal.daysAgo': '{n} hari lalu',
    'cal.dayStatTasks': 'Tugas',
    'cal.dayStatOps': 'Ops',
    'cal.dayStatStaff': 'Staff',
    'cal.dayStatOpen': 'Open',
    'cal.dayEmptyCta': 'Buat to-do pertama',
    'cal.dayStaffTitle': 'Staff hari ini',
    'cal.noDayStaff': 'Tidak ada staff terjadwal di tanggal ini.',
    'cal.dayNearby': 'Deadline sekitar tanggal ini',
    'cal.dayShortcuts': 'Pintasan menu',
    'cal.tabAgenda': 'Agenda',
    'cal.agendaTitle': 'Agenda ke depan',
    'cal.agendaSub': 'Gabungan to-do, jadwal, libur, dan deadline operasional hari demi hari.',
    'cal.agendaEmpty': '+ Tambah to-do di hari ini',
    'cal.jumpToday': 'Hari ini',
    'cal.exportIcs': 'Unduh .ICS',
    'cal.icsExported': 'File kalender (.ics) diunduh',
    'cal.searchPh': 'Cari to-do / pajak / staff…',
    'cal.convertedTodo': 'Deadline dijadikan to-do',
    'cal.duplicated': 'Event diduplikasi',
    'cal.duplicate': 'Duplikat',
    'cal.conflictTitle': 'Bentrok jadwal staff terdeteksi',

    'att.title': 'Absensi Karyawan',
    'att.kicker': 'HR · Kehadiran',
    'att.sub': 'Papan absensi terpisah JGI & JGT — hadir, terlambat, alfa, cuti & lembur · filter: {company}',
    'att.statStaff': 'Staff aktif',
    'att.statResignMonth': 'Resign (bulan)',
    'att.statResignHist': 'Histori resign',
    'att.statResignTotal': 'Resign (tahun)',
    'att.statResignMonthMeta': '{n} di bulan ini',
    'att.statPresent': 'Hadir (bulan)',
    'att.statLate': 'Terlambat',
    'att.statAbsent': 'Alfa',
    'att.statLeave': 'Cuti/Sakit/Izin',
    'att.statUnmarked': 'Belum diisi',
    'att.statLateMin': 'Total telat',
    'att.statOt': 'Total lembur',
    'att.tabToday': 'Hari Ini',
    'att.tabMatrix': 'Matriks Bulan',
    'att.tabRecap': 'Rekap & Ranking',
    'att.tabSettings': 'Pengaturan',
    'att.todayTitle': 'Papan absensi hari ini',
    'att.todaySub': '{n} karyawan di roster hari ini',
    'att.matrixTitle': 'Matriks kehadiran bulanan',
    'att.matrixSub': 'Klik sel untuk isi/ubah absensi. Hover untuk jam masuk–pulang.',
    'att.rosterSummary': '{active} aktif · {resign} resign',
    'att.recapTitle': 'Rekap profesional',
    'att.recapSub': 'Ranking kehadiran, karyawan perlu perhatian, dan tabel ringkas — termasuk resign.',
    'att.active': 'Aktif',
    'att.resign': 'Resign',
    'att.rosterAll': 'Roster bulan',
    'att.rosterActive': 'Aktif',
    'att.rosterResign': 'Resign',
    'att.filterRoster': 'Roster',
    'att.filterStatus': 'Status',
    'att.ptFilter': 'Filter PT',
    'att.ptStripMeta': '{n} di papan · {unmarked} belum',
    'att.ptGroupTitle': '{pt} · {n} karyawan',
    'att.focusPt': 'Fokus {pt}',
    'att.quickPresent': 'Hadir',
    'att.quickAbsent': 'Alfa',
    'att.quickLeave': 'Cuti',
    'att.quickSick': 'Sakit',
    'att.filterResign': 'Lihat resign',
    'att.filterResignAll': 'Lihat semua resign',
    'att.seeResignHist': 'Lihat histori',
    'att.resignIncludedNote': 'Termasuk {n} karyawan resign di laporan bulan ini',
    'att.resignHistoryNote': '{n} karyawan resign tahun ini (sudah keluar sebelum bulan ini)',
    'att.resignTotalNote': '{n} resign tahun ini · {month} masih di roster bulan terpilih',
    'att.resignIncludedHint': 'Filter Resign menampilkan semua yang resign tahun ini. Klik “Buka bulan resign” untuk matriks absensi terakhir mereka. Hari setelah tanggal resign tidak dihitung “belum diisi”.',
    'att.resignTodayNote': 'Masih di roster sampai {date} — absensi histori tetap tercatat.',
    'att.resignHistoryTitle': 'Histori resign tahun ini',
    'att.resignHistorySub': 'Klik untuk membuka matriks bulan terakhir mereka bekerja.',
    'att.resignHistorySubFull': '{n} karyawan resign — klik kartu untuk buka matriks bulan terakhir mereka bekerja.',
    'att.resignRosterTitle': 'Roster resign lengkap',
    'att.resignRosterSub': '{total} resign · {inMonth} di bulan ini · {alumni} alumni (sudah keluar)',
    'att.resignMatrixTitle': 'Matriks resign',
    'att.resignMatrixSub': '{total} resign · {inMonth} di bulan ini · {alumni} alumni — klik “Buka bulan resign” untuk histori absen.',
    'att.resignAlumni': 'Alumni',
    'att.resignAlumniHint': 'sudah keluar sebelum bulan ini — buka bulan resign untuk isi absen',
    'att.resignAlumniNote': 'Sudah keluar sebelum bulan ini. Absensi ada di {month}.',
    'att.emptyResignHint': 'Belum ada karyawan resign di filter PT/tahun ini. Coba Semua PT atau ganti tahun.',
    'att.leftAt': 'Tanggal resign',
    'att.joinedAt': 'Tanggal gabung',
    'att.detail': 'Detail',
    'att.tenureLabel': 'Masa kerja',
    'att.tenureDays': '{n} hari',
    'att.tenureMonths': '{n} bln',
    'att.tenureYears': '{n} thn',
    'att.tenureYearsMonths': '{y} thn {m} bln',
    'att.timelineTitle': 'Timeline resign',
    'att.timelineSub': 'Siapa keluar tiap bulan · {year}',
    'att.timelineMonthTip': '{n} resign di {label} — klik untuk buka matriks',
    'att.timelineMonthsActive': 'Bulan ada resign',
    'att.timelineThisMonth': 'Resign bulan terpilih',
    'att.snapshotEmpty': 'Belum ada absensi di bulan keluar',
    'att.inThisMonth': 'Di bulan ini',
    'att.openLastMonth': 'Buka bulan resign',
    'att.emptyMatrixHint': 'Tidak ada karyawan untuk filter roster ini. Coba Semua / Aktif, atau ganti bulan.',
    'att.offRoster': 'Di luar masa kerja (belum gabung / sudah resign)',
    'att.tipResignMonth': '{n} resign ikut di laporan bulan ini — buka matriks',
    'att.tipResignHist': '{n} resign tahun ini — buka roster resign lengkap',
    'att.settingsTitle': 'Jam kerja & aturan terlambat',
    'att.settingsSub': 'Berlaku untuk perhitungan otomatis late / pulang cepat / lembur.',
    'att.add': 'Input Absen',
    'att.addShort': 'Input',
    'att.edit': 'Edit Absensi',
    'att.bulk': 'Absen Massal',
    'att.bulkShort': 'Massal',
    'att.exportCsvShort': 'Ekspor CSV',
    'att.employee': 'Karyawan',
    'att.employees': 'Pilih karyawan',
    'att.date': 'Tanggal',
    'att.status': 'Status',
    'att.note': 'Catatan',
    'att.save': 'Simpan',
    'att.cancel': 'Batal',
    'att.delete': 'Hapus',
    'att.saved': 'Absensi tersimpan',
    'att.deleted': 'Absensi dihapus',
    'att.checkedIn': 'Check-in berhasil',
    'att.checkedOut': 'Check-out berhasil',
    'att.bulkDone': '{n} absensi massal tersimpan',
    'att.settingsSaved': 'Pengaturan jam kerja disimpan',
    'att.csvExported': 'CSV absensi diunduh',
    'att.needFields': 'Karyawan, PT, dan tanggal wajib',
    'att.needCompany': 'Pilih minimal 1 karyawan — PT diambil otomatis dari data karyawan (JGI/JGT)',
    'att.needEmployees': 'Pilih minimal 1 karyawan',
    'att.confirmDelete': 'Hapus data absensi ini?',
    'att.deleteAdminOnly': 'Hapus absensi hanya untuk admin / akuntan',
    'att.editAdminOnly': 'Edit absensi manual hanya untuk admin / akuntan',
    'att.manualAdmin': 'Manual admin',
    'att.holidaysMonth': 'Libur nasional bulan ini',
    'att.ranking': 'Top kehadiran',
    'att.attention': 'Perlu perhatian',
    'att.employeeRecap': 'Rekap per karyawan',
    'att.noData': 'Belum ada data',
    'att.allGood': 'Tidak ada yang mencolok — bagus!',
    'att.workStart': 'Jam masuk',
    'att.workEnd': 'Jam pulang',
    'att.lateAfter': 'Toleransi terlambat',
    'att.earlyLeave': 'Batas pulang cepat',
    'att.breakMin': 'Istirahat (dipotong)',
    'att.workDays': 'Hari kerja (angka)',
    'att.saveSettings': 'Simpan pengaturan',
    'att.ytd': 'Ringkasan tahun berjalan',
    'att.monthDetail': 'Detail bulan ini',
    'att.recent': 'Riwayat terakhir',
    'att.allPt': 'Semua PT',
    'att.search': 'Cari nama / jabatan / PT…',
    'att.focusAll': 'Semua status',
    'att.focusPresent': 'Hadir',
    'att.focusLate': 'Terlambat',
    'att.focusAbsent': 'Alfa',
    'att.focusUnmarked': 'Belum diisi',
    'att.focusLeave': 'Cuti/Sakit/Izin',
    'att.focusHoliday': 'Libur',
    'att.focusBanner': 'Fokus: {focus} · {n} karyawan',
    'att.clearFocus': 'Hapus filter',
    'att.vizTodayFill': 'Kelengkapan hari ini',
    'att.vizTodayFillSub': 'terisi',
    'att.vizTodayHint': '{filled}/{total} karyawan sudah berstatus',
    'att.vizTodayMix': 'Komposisi hari ini',
    'att.vizMonth': 'Isi bulan ini',
    'att.vizMonthSub': 'hari kerja terisi',
    'att.healthTitle': 'Kesehatan absensi',
    'att.healthSub': 'Klik chip untuk filter papan hari ini',
    'att.laneUnmarked': 'Belum',
    'att.laneLate': 'Telat',
    'att.laneAbsent': 'Alfa',
    'att.laneLeave': 'Cuti/dll',
    'att.laneHoliday': 'Libur',
    'att.tipsTitle': 'Saran tindakan',
    'att.tipUnmarked': '{n} karyawan belum absen hari ini — isi atau check-in',
    'att.tipLate': '{n} terlambat hari ini — tinjau jam masuk',
    'att.tipAbsent': '{n} alfa hari ini — konfirmasi ke supervisor',
    'att.tipAllHoliday': 'Semua karyawan berstatus libur hari ini (akhir pekan / hari libur)',
    'att.tipBulk': 'Banyak slot bulan belum diisi — gunakan Absen Massal',
    'att.tipAttention': '{n} karyawan perlu perhatian di rekap',
    'att.tipOk': 'Absensi hari ini terlihat terkendali',
    'att.pillPresent': 'hadir',
    'att.pillLate': 'terlambat',
    'att.pillAbsent': 'alfa',
    'att.pillUnmarked': 'belum',
    'att.emptyToday': 'Belum ada karyawan di papan hari ini',
    'att.emptyFilter': 'Tidak ada hasil untuk filter ini',
    'att.emptyTodayHint': 'Ubah filter PT (JGI/JGT) atau periode, atau input absensi baru. Default menampilkan staff aktif saja.',
    'att.in': 'Masuk',
    'att.out': 'Pulang',
    'att.work': 'Kerja',
    'att.late': 'Telat',
    'att.checkIn': 'Check-in',
    'att.checkOut': 'Check-out',
    'att.editShort': 'Edit',
    'att.holidayNote': 'Hari libur — check-in dinonaktifkan. Edit jika perlu override.',

    'inv.title': 'Invoice & Proforma',
    'inv.kicker': 'Billing · Pelanggan',
    'inv.sub': 'Proforma dan invoice klien — filter PT: {company}',
    'inv.newProforma': 'Proforma Baru',
    'inv.newInvoice': 'Invoice Baru',
    'inv.edit': 'Edit dokumen',
    'inv.tabList': 'Daftar',
    'inv.tabPipeline': 'Pipeline',
    'inv.statSent': 'Belum lunas',
    'inv.statPaid': 'Lunas',
    'inv.statOverdue': 'Jatuh tempo',
    'inv.search': 'Cari nomor / klien…',
    'inv.empty': 'Belum ada proforma/invoice. Buat dari tombol di atas.',
    'inv.emptyCol': 'Kosong',
    'inv.colNumber': 'Nomor',
    'inv.colClient': 'Klien',
    'inv.colDate': 'Tanggal',
    'inv.colDue': 'Jatuh tempo',
    'inv.colTotal': 'Total',
    'inv.colStatus': 'Status',
    'inv.company': 'PT penerbit',
    'inv.client': 'Klien / pelanggan',
    'inv.engagement': 'Engagement (opsional)',
    'inv.lines': 'Item tagihan',
    'inv.addLine': 'Tambah baris',
    'inv.desc': 'Deskripsi',
    'inv.product': 'Produk katalog',
    'inv.price': 'Harga',
    'inv.discount': 'Diskon (Rp)',
    'inv.tax': 'Pajak',
    'inv.amountPaid': 'Jumlah dibayar',
    'inv.notes': 'Catatan',
    'inv.terms': 'Syarat & ketentuan',
    'inv.save': 'Simpan',
    'inv.cancel': 'Batal',
    'inv.delete': 'Hapus',
    'inv.void': 'Void',
    'inv.markPaid': 'Tandai lunas',
    'inv.convert': 'Jadikan Invoice',
    'inv.saved': 'Dokumen tersimpan',
    'inv.deleted': 'Dokumen dihapus',
    'inv.voided': 'Dokumen di-void',
    'inv.markedPaid': 'Invoice ditandai lunas',
    'inv.payTitle': 'Tandai lunas',
    'inv.payAmount': 'Jumlah dibayar',
    'inv.payBalance': 'Sisa tagihan',
    'inv.payConfirm': 'Konfirmasi bayar',
    'inv.glSale': 'Jurnal penjualan',
    'inv.glPay': 'Jurnal pelunasan',
    'inv.glNone': 'Belum ada jurnal — kirim invoice (bukan draft/proforma) agar otomatis terposting',

    'vb.kicker': 'Utang usaha',
    'vb.title': 'Tagihan vendor',
    'vb.sub': 'Catat belanja ke utang 2100, lalu bayar dari bank. Draft belum masuk jurnal.',
    'vb.statAll': 'Semua',
    'vb.statUnpaid': 'Belum lunas',
    'vb.statOverdue': 'Jatuh tempo',
    'vb.statPaid': 'Lunas',
    'vb.search': 'Cari nomor atau vendor…',
    'vb.add': 'Tagihan baru',
    'vb.edit': 'Ubah tagihan',
    'vb.empty': 'Belum ada tagihan vendor',
    'vb.company': 'PT',
    'vb.vendor': 'Vendor',
    'vb.newVendor': 'Vendor baru',
    'vb.vendorName': 'Nama vendor',
    'vb.phone': 'Telepon',
    'vb.billDate': 'Tanggal tagihan',
    'vb.dueDate': 'Jatuh tempo',
    'vb.status': 'Status',
    'vb.statusOpen': 'Terbuka (posting utang)',
    'vb.taxRate': 'PPN (mis. 0,11)',
    'vb.desc': 'Deskripsi',
    'vb.qty': 'Qty',
    'vb.price': 'Harga',
    'vb.account': 'Akun beban/aset',
    'vb.addLine': 'Tambah baris',
    'vb.total': 'Total',
    'vb.notes': 'Catatan',
    'vb.post': 'Posting utang',
    'vb.pay': 'Bayar lunas',
    'vb.void': 'Void',
    'vb.glBill': 'Jurnal utang',
    'vb.glPay': 'Jurnal pembayaran',
    'vb.needPtVendor': 'PT dan vendor wajib',
    'vb.saved': 'Tagihan {n} tersimpan',
    'vb.posted': 'Utang tercatat di jurnal',
    'vb.paid': 'Pembayaran tercatat',
    'vb.payTitle': 'Bayar tagihan',
    'vb.payAmount': 'Jumlah dibayar',
    'vb.payBalance': 'Sisa tagihan',
    'vb.payConfirm': 'Konfirmasi bayar',
    'vb.voided': 'Tagihan di-void',
    'vb.vendorSaved': 'Vendor disimpan',

    'fa.kicker': 'Aset tetap',
    'fa.title': 'Register aset tetap',
    'fa.sub': 'Hubungkan mutasi bank CAPEX ke register. Perolehan 1500 · penyusutan 5008 / 1600. Draft belum masuk jurnal.',
    'fa.statAll': 'Semua',
    'fa.statActive': 'Aktif',
    'fa.statPending': 'Belum disusutkan',
    'fa.statDone': 'Habis disusutkan',
    'fa.search': 'Cari nomor atau nama aset…',
    'fa.add': 'Aset baru',
    'fa.fromBank': 'Dari bank',
    'fa.fromBankTitle': 'Daftar aset dari mutasi bank',
    'fa.fromBankHint': 'Pilih pengeluaran bank yang sudah Dr 1500 atau terdeteksi CAPEX. Sistem mencatat ke register tanpa double jurnal kas.',
    'fa.fromBankEmpty': 'Tidak ada kandidat bank untuk periode ini',
    'fa.fromBankRegister': 'Catat aset',
    'fa.fromBankDone': 'Aset {n} tercatat dari bank',
    'fa.fromBankAlready': 'Jurnal ini sudah terhubung ke {n}',
    'fa.bankRef': 'Ref bank',
    'fa.edit': 'Ubah aset',
    'fa.empty': 'Belum ada aset tetap',
    'fa.company': 'PT',
    'fa.name': 'Nama aset',
    'fa.desc': 'Deskripsi',
    'fa.acquisitionDate': 'Tanggal perolehan',
    'fa.inServiceDate': 'Mulai disusutkan',
    'fa.cost': 'Harga perolehan',
    'fa.salvage': 'Nilai residu',
    'fa.lifeMonths': 'Masa manfaat (bulan)',
    'fa.monthlyDepr': 'Penyusutan / bulan',
    'fa.bookValue': 'Nilai buku',
    'fa.accumDepr': 'Akum. penyusutan',
    'fa.assetAccount': 'Akun aset (1500)',
    'fa.paidFrom': 'Bayar dari (opsional)',
    'fa.paidFromHint': 'Isi jika belum lewat tagihan vendor — posting Dr Aset / Cr Kas-Bank',
    'fa.status': 'Status',
    'fa.notes': 'Catatan',
    'fa.activate': 'Aktifkan',
    'fa.dispose': 'Dispose / jual',
    'fa.disposeConfirm': 'Tandai aset {n} sebagai dibuang/dijual? Penyusutan berhenti.',
    'fa.disposed': 'Aset ditandai disposed',
    'fa.void': 'Void',
    'fa.runDepr': 'Susutkan bulan ini',
    'fa.runDeprBatch': 'Jalankan penyusutan',
    'fa.period': 'Periode (YYYY-MM)',
    'fa.glAcq': 'Jurnal perolehan',
    'fa.glDepr': 'Jurnal penyusutan',
    'fa.deprHistory': 'Riwayat penyusutan',
    'fa.needPtName': 'PT dan nama aset wajib',
    'fa.saved': 'Aset {n} tersimpan',
    'fa.activated': 'Aset aktif — jurnal perolehan (jika ada) tercatat',
    'fa.voided': 'Aset di-void',
    'fa.deprDone': 'Penyusutan {period} tercatat · {amount}',
    'fa.deprBatchDone': '{n} aset disusutkan · total {amount}',
    'fa.noDepr': 'Tidak ada penyusutan untuk periode ini',

    'rj.kicker': 'Penyesuaian rutin',
    'rj.title': 'Jurnal berulang',
    'rj.sub': 'Sewa, amortisasi, akrual — jalankan otomatis tiap bulan. Idempotent per periode.',
    'rj.statAll': 'Semua aktif',
    'rj.statPending': 'Belum dijalankan',
    'rj.search': 'Cari nama jurnal…',
    'rj.add': 'Jadwal baru',
    'rj.edit': 'Ubah jadwal',
    'rj.empty': 'Belum ada jurnal berulang',
    'rj.company': 'PT',
    'rj.name': 'Nama',
    'rj.memo': 'Memo jurnal',
    'rj.kind': 'Jenis',
    'rj.amount': 'Nominal',
    'rj.day': 'Tanggal posting (1–28)',
    'rj.period': 'Periode (YYYY-MM)',
    'rj.account': 'Akun',
    'rj.side': 'Sisi',
    'rj.desc': 'Keterangan',
    'rj.addLine': 'Tambah baris',
    'rj.run': 'Jalankan',
    'rj.runBatch': 'Jalankan semua',
    'rj.deactivate': 'Nonaktifkan',
    'rj.lastRun': 'Terakhir',
    'rj.runs': 'Riwayat posting',
    'rj.needPtName': 'PT, nama, dan minimal 2 baris wajib',
    'rj.saved': 'Jadwal tersimpan',
    'rj.runDone': 'Jurnal {period} tercatat · {ref}',
    'rj.runBatchDone': '{n} jurnal tercatat · total {amount}',
    'rj.noRun': 'Tidak ada jadwal untuk periode ini',
    'rj.deactivated': 'Jadwal dinonaktifkan',

    'jra.kicker': 'Kontrol jurnal',
    'jra.title': 'Approval jurnal',
    'jra.sub': 'Jurnal manual yang minta approval tidak masuk laporan keuangan sampai disetujui.',
    'jra.pendingN': '{n} jurnal menunggu',
    'jra.empty': 'Tidak ada jurnal pending',
    'jra.approve': 'Setujui',
    'jra.reject': 'Tolak',
    'jra.view': 'Lihat jurnal',
    'jra.reason': 'Alasan penolakan',
    'jra.approved': 'Jurnal {ref} disetujui',
    'jra.rejected': 'Jurnal ditolak',

    'dim.kicker': 'Pelacakan',
    'dim.title': 'Dimensi jurnal',
    'dim.sub': 'Proyek dan gudang opsional — pilih saat buat jurnal manual.',
    'dim.projects': 'Proyek',
    'dim.warehouses': 'Gudang',
    'dim.add': 'Tambah',
    'dim.edit': 'Ubah',
    'dim.empty': 'Belum ada dimensi',
    'dim.code': 'Kode',
    'dim.name': 'Nama',
    'dim.company': 'PT (kosong = shared)',
    'dim.shared': 'Semua PT',
    'dim.saved': 'Dimensi tersimpan',
    'inv.converted': 'Proforma dikonversi → {number}',
    'inv.needCompanyClient': 'PT penerbit dan klien wajib',
    'inv.needLines': 'Isi minimal satu item',
    'inv.confirmDelete': 'Hapus dokumen ini?',
    'inv.statProforma': 'Proforma',
    'inv.statInvoice': 'Invoice',
    'inv.statDraft': 'Draft',
    'inv.showing': '{n} dokumen tampil',
    'inv.collected': 'Tertagih {pct}%',
    'inv.collectedHint': 'Lunas {paid} dari invoice {total}',
    'inv.overdueN': '{n} jatuh tempo',
    'inv.needAttention': '{n} item perlu perhatian',
    'inv.vizCollect': 'Kolektibilitas invoice',
    'inv.vizStatus': 'Status dokumen',
    'inv.vizType': 'Proforma vs Invoice',
    'inv.vizPartial': '{n} pembayaran sebagian',
    'inv.healthTitle': 'Status kesehatan billing',
    'inv.healthSub': 'Klik lane untuk fokus dokumen yang perlu ditindaklanjuti.',
    'inv.clearLane': 'Tampilkan semua',
    'inv.lane.all': 'Semua',
    'inv.lane.unpaid': 'Belum lunas',
    'inv.lane.overdue': 'Jatuh tempo',
    'inv.lane.draft': 'Draft',
    'inv.lane.sent': 'Terkirim',
    'inv.lane.partial': 'Sebagian',
    'inv.lane.paid': 'Lunas',
    'inv.lane.proforma': 'Proforma',
    'inv.lane.invoice': 'Invoice',
    'inv.tipsTitle': 'Saran cepat · billing rapi',
    'inv.tipsShow': 'Tampilkan',
    'inv.tipsHide': 'Sembunyikan',
    'inv.tip1': 'Draft invoice dengan sisa tagihan ikut dihitung “Belum lunas” — kirim atau lunasi agar pipeline akurat.',
    'inv.tip2': 'Konversi proforma → invoice setelah klien setuju, lalu tandai lunas saat bayar.',
    'inv.tip3': 'Pakai view Pipeline untuk alur Proforma → Belum lunas → Lunas.',
    'inv.tip4': 'Hubungkan engagement agar item tagihan terisi otomatis dari fee kontrak.',
    'inv.tipDraft': 'Edit {n} draft',
    'inv.tipPay': 'Tinjau {n} belum lunas',
    'inv.tipOverdue': 'Cek {n} jatuh tempo',
    'inv.tipConvert': 'Buka proforma siap konversi',
    'inv.filterAll': 'Semua',
    'inv.filterStatusAll': 'Semua status',
    'inv.emptyTitle': 'Tidak ada dokumen cocok',
    'inv.emptyFiltered': 'Filter terlalu ketat — reset atau ubah pencarian.',
    'inv.resetFilters': 'Reset filter',

    'mkt.title': 'Marketing & WhatsApp',
    'mkt.kicker': 'Broadcast · Database · Gateway',
    'mkt.sub': 'Database nomor marketing & follow-up — filter PT: {company}',
    'mkt.broadcastMarketing': 'Broadcast Marketing',
    'mkt.broadcastFollowup': 'Broadcast Follow-up',
    'mkt.statMarketing': 'DB Marketing',
    'mkt.statFollowup': 'DB Follow-up',
    'mkt.statActive': 'Kontak aktif',
    'mkt.statQueued': 'Antrian broadcast',
    'mkt.noGateway': 'Belum ada gateway',
    'mkt.tabOverview': 'Ringkasan',
    'mkt.tabContacts': 'Database',
    'mkt.tabBroadcast': 'Broadcast',
    'mkt.tabTemplates': 'Template',
    'mkt.tabGateway': 'Gateway WA',
    'mkt.laneMarketingTitle': 'Marketing broadcast',
    'mkt.laneMarketingDesc': 'Lead, prospect, nurture — untuk promosi & akuisisi.',
    'mkt.laneFollowupTitle': 'Follow-up broadcast',
    'mkt.laneFollowupDesc': 'Klien aktif, renewal, tunggakan — pengingat & perawatan.',
    'mkt.laneCta': 'Buat broadcast →',
    'mkt.mapBoard': 'Peta segmen nomor',
    'mkt.mapBoardSub': 'Setiap nomor dipetakan ke segmen. Marketing dan follow-up punya fokus berbeda.',
    'mkt.search': 'Cari nama / nomor / tag…',
    'mkt.addContact': 'Tambah nomor',
    'mkt.editContact': 'Edit kontak',
    'mkt.import': 'Import nomor',
    'mkt.importHint': 'Satu baris: Nama, Nomor [, mapKey] [, tags] — pisah koma/tab.',
    'mkt.importEmpty': 'Tidak ada baris untuk diimpor',
    'mkt.imported': 'Import selesai: {ok} ok, {skipped} dilewati',
    'mkt.remap': 'Petakan ulang',
    'mkt.selectAll': 'Pilih semua',
    'mkt.selectFirst': 'Pilih kontak dulu',
    'mkt.remapped': 'Pemetaan diperbarui',
    'mkt.emptyContacts': 'Belum ada nomor. Tambah manual atau import.',
    'mkt.colName': 'Nama',
    'mkt.colPhone': 'Nomor WA',
    'mkt.colChannel': 'Tipe DB',
    'mkt.colMap': 'Pemetaan',
    'mkt.colStatus': 'Status',
    'mkt.company': 'PT (opsional)',
    'mkt.notes': 'Catatan',
    'mkt.campaigns': 'Kampanye',
    'mkt.emptyCampaigns': 'Belum ada broadcast.',
    'mkt.pickCampaign': 'Pilih kampanye di kiri, atau buat broadcast baru.',
    'mkt.runBroadcast': 'Jalankan / siapkan WA',
    'mkt.openWa': 'Buka',
    'mkt.templates': 'Template pesan',
    'mkt.addTemplate': 'Template baru',
    'mkt.gatewayTitle': 'WhatsApp Gateway',
    'mkt.gatewaySub': 'Atur pengirim: manual wa.me, HTTP/WAHA, atau Meta Cloud API.',
    'mkt.addGateway': 'Tambah gateway',
    'mkt.ping': 'Tes koneksi',
    'mkt.campaignTitle': 'Judul kampanye',
    'mkt.template': 'Template',
    'mkt.message': 'Isi pesan',
    'mkt.createCampaign': 'Buat & antre target',
    'mkt.campaignCreated': 'Kampanye dibuat · {n} target',
    'mkt.campaignRan': 'Selesai batch · terkirim {sent}, gagal {failed}',
    'mkt.usingSelected': 'Menggunakan {n} kontak terpilih dari Database.',
    'mkt.savedContact': 'Kontak disimpan',
    'mkt.savedTemplate': 'Template disimpan',
    'mkt.savedGateway': 'Gateway disimpan',
    'mkt.deleted': 'Dihapus',
    'mkt.delete': 'Hapus',
    'mkt.cancel': 'Batal',
    'mkt.save': 'Simpan',
    'mkt.confirmDelete': 'Hapus item ini?',
    'mkt.confirmDeleteContact': 'Hapus kontak ini dari database?',
    'mkt.showing': '{n} nomor di DB',
    'mkt.readyPct': 'Aktif {pct}%',
    'mkt.readyHint': '{ok} aktif dari {total} kontak',
    'mkt.needAttention': '{n} item perlu perhatian',
    'mkt.vizReady': 'Kesehatan database',
    'mkt.vizChannel': 'Marketing vs Follow-up',
    'mkt.vizSegment': 'Segmen teratas',
    'mkt.vizSegmentEmpty': 'Belum ada segmen terisi',
    'mkt.camp.draft': 'Draft',
    'mkt.camp.queued': 'Antrian',
    'mkt.camp.done': 'Selesai',
    'mkt.healthTitle': 'Status kesehatan marketing',
    'mkt.healthSub': 'Klik lane untuk buka Database / Broadcast / Gateway.',
    'mkt.lane.all': 'Semua',
    'mkt.lane.active': 'Aktif',
    'mkt.lane.marketing': 'Marketing',
    'mkt.lane.followup': 'Follow-up',
    'mkt.lane.paused': 'Pause',
    'mkt.lane.optout': 'Opt-out',
    'mkt.lane.queued': 'Antrian BC',
    'mkt.lane.gateway': 'Gateway',
    'mkt.tipsTitle': 'Saran cepat · WA & broadcast rapi',
    'mkt.tipsShow': 'Tampilkan',
    'mkt.tipsHide': 'Sembunyikan',
    'mkt.tip1': 'Petakan setiap nomor ke segmen agar broadcast Marketing vs Follow-up akurat.',
    'mkt.tip2': 'Klik kartu segmen untuk membuka Database terfilter.',
    'mkt.tip3': 'Pastikan gateway WA aktif sebelum menjalankan antrian broadcast.',
    'mkt.tip4': 'Import CSV/TSV untuk isi cepat, lalu remap massal jika perlu.',
    'mkt.tipQueued': 'Buka {n} antrian broadcast',
    'mkt.tipGatewayOk': 'Gateway siap',
    'mkt.tipGatewayFix': 'Atur gateway WA',
    'mkt.emptyTitle': 'Database kosong',

    'wa.title': 'WhatsApp',
    'wa.loading': 'Memuat…',
    'wa.addNumber': 'Tambah nomor',
    'wa.addNumberSub': 'Multi-nomor: setiap session punya QR & chat tersendiri.',
    'wa.label': 'Label nomor',
    'wa.labelPh': 'mis. CS JGI / Marketing',
    'wa.gatewayUrl': 'URL Gateway API',
    'wa.apiToken': 'API Token',
    'wa.setDefault': 'Jadikan nomor default',
    'wa.continueQr': 'Lanjut scan QR',
    'wa.scanQr': 'Scan QR',
    'wa.newChat': 'Chat baru',
    'wa.settings': 'Pengaturan nomor',
    'wa.search': 'Cari atau mulai chat baru',
    'wa.needScan': 'Belum terhubung — scan QR',
    'wa.emptySessions': 'Belum ada nomor WhatsApp',
    'wa.emptySessionsSub': 'Tambah nomor lalu scan barcode dari HP untuk menghubungkan.',
    'wa.linkTitle': 'Hubungkan WhatsApp',
    'wa.linkSub': 'Scan QR dengan HP agar chat muncul di sini.',
    'wa.emptyChats': 'Belum ada percakapan',
    'wa.introTitle': 'WhatsApp untuk bisnis',
    'wa.introSub': 'Tampilan ala WhatsApp Web — multi nomor, scan QR, siap sambung gateway API.',
    'wa.featMulti': 'Multi nomor / multi session paralel',
    'wa.featQr': 'Scan barcode QR + kode pairing',
    'wa.featApi': 'Siap plug API gateway (WAHA/Meta/custom)',
    'wa.introHint': 'Nanti tinggal share endpoint API — UI sudah siap.',
    'wa.qrTitle': 'Gunakan WhatsApp di HP untuk scan',
    'wa.qrStep1': 'Buka WhatsApp di ponsel Anda',
    'wa.qrStep2': 'Ketuk Menu atau Setelan, lalu Perangkat tertaut',
    'wa.qrStep3': 'Ketuk Tautkan perangkat dan arahkan kamera ke QR ini',
    'wa.pairingCode': 'Kode pairing',
    'wa.phoneAfterScan': 'Nomor setelah terhubung (opsional)',
    'wa.qrHint': 'QR otomatis diperbarui',
    'wa.refreshQr': 'Refresh QR',
    'wa.iScanned': 'Saya sudah scan',
    'wa.colPhone': 'Nomor WA',
    'wa.colName': 'Nama tampilan',
    'wa.optional': 'Opsional',
    'wa.startChat': 'Mulai chat',
    'wa.newChatSub': 'Masukkan nomor untuk membuka percakapan.',
    'wa.typeMessage': 'Ketik pesan',
    'wa.today': 'Hari ini',
    'wa.group': 'Grup',
    'wa.sessionCreated': 'Nomor ditambahkan — scan QR',
    'wa.connected': 'WhatsApp terhubung',
    'wa.disconnected': 'Nomor diputuskan',
    'wa.confirmLogout': 'Logout & hapus chat lokal session ini?',
    'wa.confirmDelete': 'Hapus nomor/session ini permanen?',
    'wa.logout': 'Logout',
    'wa.disconnect': 'Putuskan',
    'wa.delete': 'Hapus',
    'wa.save': 'Simpan',
    'wa.saved': 'Pengaturan disimpan',
    'wa.cancel': 'Batal',
    'wa.tokenKeep': 'Kosongkan jika tidak diubah',
    'wa.yesterday': 'Kemarin',
    'wa.statusConnected': 'Terhubung',
    'wa.statusPendingQr': 'Menunggu QR',
    'wa.statusConnecting': 'Menghubungkan…',
    'wa.statusDisconnected': 'Terputus',
    'wa.statusLoggedOut': 'Logout',
    'wa.defaultBadge': 'Default',
    'wa.gatewayBadge': 'Gateway',
    'wa.chatMeta': '{n} chat · {u} belum dibaca',
    'wa.kpiConnected': 'Live',
    'wa.kpiPending': 'QR',
    'wa.kpiOffline': 'Offline',
    'wa.kpiReady': 'Siap',
    'wa.statSessions': 'Nomor',
    'wa.statGateway': 'Gateway',
    'wa.tipsTitle': 'Checklist operasional',
    'wa.tipAddSession': 'Tambah nomor WA untuk mulai',
    'wa.tipConnected': '{n} nomor live — siap kirim chat',
    'wa.tipNoConnected': 'Belum ada nomor terhubung — scan QR',
    'wa.tipPendingQr': '{n} nomor menunggu scan QR',
    'wa.tipOffline': '{n} nomor offline / logout',
    'wa.tipGatewayOk': 'Gateway API sudah terisi',
    'wa.tipGatewayFix': 'Isi URL gateway di pengaturan nomor',
    'wa.tipMarketing': 'Sinkron kontak & kampanye di Marketing',
    'wa.emptyChatsSub': 'Mulai chat baru atau tarik kontak dari Marketing.',
    'wa.emptyTip1': 'Satu nomor = satu session (CS, Marketing, dll).',
    'wa.emptyTip2': 'Setelah scan, chat lokal siap — gateway API bisa diisi nanti.',
    'wa.openMarketing': 'Buka Marketing',
    'wa.backChats': 'Kembali ke daftar',
    'wa.pin': 'Pin chat',
    'wa.unpin': 'Lepas pin',

    'kurs.title': 'Kalkulator Kurs Jasa',
    'kurs.kicker': 'FX · Fee · Pajak',
    'kurs.sub': 'Input USD/EUR/dll + kurs, otomatis hitung konversi, fee jasa, admin, spread bank, dan PPN.',
    'kurs.refresh': 'Muat kurs',
    'kurs.copy': 'Salin ringkasan',
    'kurs.inputTitle': 'Input jumlah & fee',
    'kurs.inputSub': 'Pilih preset atau atur manual. Kurs bisa diedit sebelum API live.',
    'kurs.amount': 'Jumlah mata uang',
    'kurs.qty': 'Qty',
    'kurs.rateUsed': 'Kurs dipakai',
    'kurs.editRates': 'Edit kurs',
    'kurs.hideRates': 'Sembunyikan',
    'kurs.rateHint': 'Nilai = Rupiah per 1 unit. Nanti diganti API live.',
    'kurs.servicePct': 'Fee jasa',
    'kurs.adminFee': 'Biaya admin',
    'kurs.bankSpread': 'Spread bank',
    'kurs.taxPct': 'Pajak',
    'kurs.discount': 'Diskon',
    'kurs.resultTitle': 'Hasil hitungan',
    'kurs.resultSub': 'Update langsung saat input berubah.',
    'kurs.grandTotal': 'Total dibayar (IDR)',
    'kurs.perUnit': 'Per unit',
    'kurs.fxAmount': 'Jumlah FX',
    'kurs.idrConvert': 'Konversi IDR',
    'kurs.spreadLine': 'Spread bank',
    'kurs.serviceLine': 'Fee jasa',
    'kurs.adminLine': 'Admin',
    'kurs.subtotal': 'Subtotal',
    'kurs.taxLine': 'Pajak',
    'kurs.rateBoard': 'Papan kurs',
    'kurs.footer': 'Sumber stub · as of {asOf} — ganti endpoint /api/kurs saat API siap.',
    'kurs.reset': 'Reset',
    'kurs.resetOk': 'Input dikembalikan ke default',
    'kurs.copied': 'Ringkasan disalin',
    'kurs.copyFail': 'Gagal salin ringkasan',
    'kurs.ratesLoaded': 'Kurs dimuat',
    'kurs.ratesFallback': 'Pakai kurs lokal (API gagal)',
    'kurs.tax0': '0%',
    'kurs.tax11': '11% PPN',
    'kurs.tax12': '12% PPN',
    'kurs.kpiTotal': 'Total dibayar',
    'kurs.kpiTotalHint': 'Termasuk fee, admin, spread & pajak',
    'kurs.kpiConvert': 'Konversi IDR',
    'kurs.kpiFees': 'Biaya tambahan',
    'kurs.kpiFeesHint': 'Markup efektif {pct}%',
    'kurs.kpiEff': 'Kurs efektif',
    'kurs.kpiEffHint': 'IDR per 1 {ccy} setelah semua biaya',
    'kurs.vizReady': 'Kesiapan hitung',
    'kurs.vizReadySub': 'siap',
    'kurs.readyHint': 'Aktif {ccy} @ Rp {rate}',
    'kurs.vizComp': 'Komposisi total',
    'kurs.vizFees': 'Rincian biaya',
    'kurs.compConvert': 'Konversi',
    'kurs.compSpread': 'Spread',
    'kurs.compFee': 'Fee + admin',
    'kurs.compTax': 'Pajak',
    'kurs.healthTitle': 'Status kalkulasi',
    'kurs.healthSub': 'Ringkas kesiapan input, kurs, dan beban biaya.',
    'kurs.lane.ready': 'Siap',
    'kurs.lane.rates': 'Mata uang',
    'kurs.lane.spread': 'Spread',
    'kurs.lane.tax': 'Pajak',
    'kurs.lane.disc': 'Diskon',
    'kurs.tipsTitle': 'Checklist & tips',
    'kurs.tipStub': 'Kurs masih stub — muat ulang / sambungkan API live',
    'kurs.tipLive': 'Sumber kurs aktif',
    'kurs.tipAmount': 'Isi jumlah FX agar hitungan bermakna',
    'kurs.tipAmountOk': 'Jumlah FX sudah terisi',
    'kurs.tipHighSpread': 'Spread bank tinggi — sesuaikan jika perlu',
    'kurs.tipSpreadOk': 'Spread bank dalam rentang wajar',
    'kurs.tipTaxConsult': 'Preset konsultasi tanpa PPN — cek ulang',
    'kurs.tipTaxOk': 'Pajak {n}% aktif',
    'kurs.tipEditRates': 'Edit kurs manual sebelum API live',
    'kurs.effRate': 'Efektif ≈ {rate} / 1 {ccy}',

    'prd.title': 'Produk',
    'prd.kicker': 'Katalog · Stok · Harga',
    'prd.sub': 'Kelola produk jasa & barang — filter PT: {company}',
    'prd.add': 'Tambah produk',
    'prd.edit': 'Edit produk',
    'prd.delete': 'Hapus',
    'prd.save': 'Simpan',
    'prd.adjustStock': 'Sesuaikan stok',
    'prd.adjustQty': 'Perubahan qty (+/-)',
    'prd.adjustMemo': 'Catatan penyesuaian',
    'prd.adjustDone': 'Stok disesuaikan',
    'prd.cancel': 'Batal',
    'prd.search': 'Cari produk, kode, deskripsi, catatan…',
    'prd.viewTable': 'Tabel',
    'prd.viewGrid': 'Kartu',
    'prd.statActive': 'Produk aktif',
    'prd.statLow': 'Stok menipis',
    'prd.statOut': 'Habis',
    'prd.statLocked': 'Terkunci (invoice)',
    'prd.statValue': 'Nilai stok',
    'prd.locked': 'Terkunci',
    'prd.lockedHint': 'Produk dipakai di {n} baris invoice/proforma — tidak bisa dihapus kecuali system',
    'prd.confirmDeleteLocked': 'SYSTEM ONLY: hapus paksa “{name}” yang terkunci ({n} invoice)?',
    'prd.systemCanDelete': 'Akun system dapat menghapus paksa produk terkunci.',
    'prd.colProduct': 'Produk',
    'prd.colQty': 'Qty',
    'prd.colPrice': 'Harga',
    'prd.colDesc': 'Deskripsi',
    'prd.colNotes': 'Catatan Internal',
    'prd.descHint': 'Deskripsi untuk klien / katalog umum',
    'prd.notesHint': 'Hanya untuk staff: syarat dokumen, checklist, SOP, dll.',
    'prd.notesStaffOnly': 'Terlihat untuk staff internal',
    'prd.hasNotes': 'Ada catatan',
    'prd.viewNotes': 'Lihat catatan',
    'prd.noNotes': 'Belum ada catatan internal',
    'prd.code': 'Kode',
    'prd.category': 'Kategori',
    'prd.unit': 'Satuan',
    'prd.status': 'Status',
    'prd.allCategories': 'Semua kategori',
    'prd.uncategorized': 'Tanpa kategori',
    'prd.noDesc': 'Belum ada deskripsi',
    'prd.empty': 'Belum ada produk. Tambah yang pertama.',
    'prd.needName': 'Nama produk wajib diisi',
    'prd.created': 'Produk ditambahkan',
    'prd.updated': 'Produk diperbarui',
    'prd.deleted': 'Produk dihapus',
    'prd.confirmDelete': 'Hapus produk “{name}”?',
    'prd.filterAll': 'Semua',
    'prd.filterActive': 'Aktif',
    'prd.filterArchived': 'Arsip',
    'prd.resetFilters': 'Reset filter',
    'prd.clearFocus': 'Hapus fokus',
    'prd.focusBanner': 'Fokus: {focus}',
    'prd.emptyFilter': 'Tidak ada produk di filter ini',
    'prd.emptyFilterSub': 'Ubah fokus/status atau reset filter untuk melihat katalog.',
    'prd.vizReady': 'Kesiapan katalog',
    'prd.vizReadySub': 'lengkap',
    'prd.readyHint': '{ok} siap · {need} tanpa deskripsi',
    'prd.vizStock': 'Kesehatan stok',
    'prd.vizCat': 'Kategori aktif',
    'prd.vizCatEmpty': 'Belum ada kategori',
    'prd.stock.ok': 'Stok aman',
    'prd.stock.low': 'Menipis',
    'prd.stock.out': 'Habis',
    'prd.healthTitle': 'Lane inventori',
    'prd.healthSub': 'Klik untuk filter cepat stok, kunci, dan kelengkapan.',
    'prd.lane.all': 'Semua',
    'prd.lane.active': 'Aktif',
    'prd.lane.low': 'Menipis',
    'prd.lane.out': 'Habis',
    'prd.lane.locked': 'Terkunci',
    'prd.lane.notes': 'Ada catatan',
    'prd.lane.nodesc': 'Tanpa deskripsi',
    'prd.tipsTitle': 'Checklist katalog',
    'prd.tipEmpty': 'Tambah produk pertama ke katalog',
    'prd.tipReadyOk': 'Katalog {n}% lengkap',
    'prd.tipReadyFix': 'Kelengkapan katalog {n}% — lengkapi deskripsi',
    'prd.tipLow': '{n} produk stok menipis',
    'prd.tipLowOk': 'Tidak ada stok menipis',
    'prd.tipOut': '{n} produk habis stok',
    'prd.tipCategory': '{n} produk tanpa kategori',
    'prd.tipLocked': '{n} produk terkunci di invoice',

    'taxReq.title': 'Request Pajak',
    'taxReq.kicker': 'Board staff',
    'taxReq.sub': 'Proses permintaan laporan dari customer — status, assign, dan hasil.',
    'taxReq.meTitle': 'Request Saya',
    'taxReq.meKicker': 'Self-service',
    'taxReq.meSub': 'Ajukan laporan pajak dan pantau progres pengerjaan.',
    'taxReq.refresh': 'Muat ulang',
    'taxReq.refreshShort': 'Ulang',
    'taxReq.new': 'Request baru',
    'taxReq.newShort': 'Baru',
    'taxReq.submit': 'Kirim request',
    'taxReq.empty': 'Belum ada request',
    'taxReq.emptySub': 'Buat request baru atau ubah filter.',
    'taxReq.unlinkedTitle': 'Portal belum aktif',
    'taxReq.unlinked': 'Akun belum ditautkan ke klien pajak. Hubungi admin untuk aktivasi portal.',
    'taxReq.statSubmitted': 'Baru',
    'taxReq.statProgress': 'Proses',
    'taxReq.statNeedInfo': 'Butuh info',
    'taxReq.statDone': 'Selesai',
    'taxReq.filterStatus': 'Status',
    'taxReq.filterKind': 'Jenis',
    'taxReq.filterClient': 'Klien',
    'taxReq.filterYear': 'Tahun',
    'taxReq.all': 'Semua',
    'taxReq.colTitle': 'Judul',
    'taxReq.colClient': 'Klien',
    'taxReq.colKind': 'Jenis',
    'taxReq.colPeriod': 'Periode',
    'taxReq.colStatus': 'Status',
    'taxReq.colUpdated': 'Diperbarui',
    'taxReq.colAssign': 'Assign',
    'taxReq.kind': 'Jenis laporan',
    'taxReq.periodYear': 'Tahun',
    'taxReq.periodMonth': 'Bulan',
    'taxReq.note': 'Catatan',
    'taxReq.staffNote': 'Catatan staff',
    'taxReq.resultDoc': 'Dokumen hasil (ID)',
    'taxReq.assignTo': 'Assign ke user ID',
    'taxReq.update': 'Simpan perubahan',
    'taxReq.detail': 'Detail request',
    'taxReq.snackCreated': 'Request terkirim',
    'taxReq.snackUpdated': 'Request diperbarui',
    'taxReq.kind.ppn': 'PPN',
    'taxReq.kind.pph21': 'PPh 21',
    'taxReq.kind.pph23': 'PPh 23',
    'taxReq.kind.pph_final': 'PPh Final',
    'taxReq.kind.spt': 'SPT',
    'taxReq.kind.efaktur': 'e-Faktur',
    'taxReq.kind.lain': 'Lainnya',
    'taxReq.status.draft': 'Draft',
    'taxReq.status.submitted': 'Diajukan',
    'taxReq.status.in_progress': 'Diproses',
    'taxReq.status.need_info': 'Butuh info',
    'taxReq.status.done': 'Selesai',
    'taxReq.status.rejected': 'Ditolak',
    'taxReq.resubmit': 'Kirim ulang info',
    'taxReq.monthOptional': 'Opsional',

    'cust.title': 'Kelola Customer',
    'cust.kicker': 'Akses portal',
    'cust.sub': 'Pantau akun customer, tautkan klien pajak, reset password, dan aktifkan akses.',
    'cust.refresh': 'Muat ulang',
    'cust.refreshShort': 'Ulang',
    'cust.create': 'Customer baru',
    'cust.createShort': 'Baru',
    'cust.search': 'Cari nama, username, klien…',
    'cust.searchLabel': 'Cari',
    'cust.statTotal': 'Total',
    'cust.statActive': 'Aktif',
    'cust.statUnlinked': 'Belum taut',
    'cust.statOpen': 'Request terbuka',
    'cust.chipTotal': '{n} customer',
    'cust.chipUnlinked': '{n} belum taut',
    'cust.chipLinkedOk': 'Semua tertaut',
    'cust.filterActive': 'Hanya aktif',
    'cust.filterUnlinked': 'Belum tertaut',
    'cust.focusSearch': 'Cari: “{q}”',
    'cust.clearFocus': 'Hapus fokus',
    'cust.showing': '{n} ditampilkan',
    'cust.empty': 'Belum ada customer',
    'cust.emptySub': 'Buat akun customer atau ubah filter.',
    'cust.linkClient': 'Tautkan klien pajak',
    'cust.colUser': 'User',
    'cust.colClient': 'Klien',
    'cust.colStatus': 'Status',
    'cust.colLogin': 'Login terakhir',
    'cust.colOpen': 'Request',
    'cust.contact': 'Kontak',
    'cust.active': 'Aktif',
    'cust.inactive': 'Nonaktif',
    'cust.resetPass': 'Reset password',
    'cust.resetPassShort': 'Password',
    'cust.save': 'Simpan',
    'cust.detail': 'Detail customer',
    'cust.detailShort': 'Detail',
    'cust.aclTitle': 'Hak akses',
    'cust.aclHint': 'Menu default level Customer — edit penuh di User & Akses.',
    'cust.openUsers': 'Buka User & Akses',
    'cust.openUsersShort': 'User & Akses',
    'cust.tipsTitle': 'Saran tindakan',
    'cust.tipUnlinked': '{n} customer belum taut klien — filter & lengkapi',
    'cust.tipOpen': '{n} request terbuka — buka board staff',
    'cust.tipCreate': 'Tambah customer baru untuk akses portal',
    'cust.tipUsers': 'Atur menu/ACL lengkap di User & Akses',
    'cust.tipOk': 'Semua customer sudah tertaut klien',
    'cust.snackCreated': 'Customer dibuat',
    'cust.snackUpdated': 'Customer diperbarui',
    'cust.snackPass': 'Password direset',
    'cust.password': 'Password awal',
    'cust.passwordConfirm': 'Konfirmasi password',
    'cust.passMismatch': 'Konfirmasi password tidak sama',
    'cust.mustChange': 'Wajib ganti password saat login',
    'cust.firstName': 'Nama depan',
    'cust.lastName': 'Nama belakang',
    'cust.username': 'Username',
    'cust.email': 'Email',
    'cust.phone': 'Telepon',
    'cust.neverLogin': 'Belum pernah',
    'cust.recentReq': 'Request terbaru',
    'cust.noClient': 'Belum tertaut',
    'custPortal.title': 'Portal Customer',
    'custPortal.kicker': 'Dashboard',
    'custPortal.sub': 'Ringkasan klien, request terbuka, dan dokumen terbaru.',
    'custPortal.refresh': 'Muat ulang',
    'custPortal.refreshShort': 'Ulang',
    'custPortal.unlinkedTitle': 'Portal belum aktif',
    'custPortal.unlinked': 'Akun belum ditautkan ke klien pajak. Hubungi admin.',
    'custPortal.ctaRequest': 'Ajukan request',
    'custPortal.ctaRequestShort': 'Ajukan',
    'custPortal.ctaAccount': 'Akun saya',
    'custPortal.ctaAccountShort': 'Akun',
    'custPortal.ctaMyReq': 'Lihat request saya',
    'custPortal.ctaMyReqShort': 'Request',
    'custPortal.statOpen': 'Request terbuka',
    'custPortal.statNeed': 'Butuh info',
    'custPortal.statDone': 'Selesai',
    'custPortal.clientCard': 'Klien tertaut',
    'custPortal.openList': 'Request terbuka',
    'custPortal.docs': 'Dokumen terakhir',
    'custPortal.emptyOpen': 'Tidak ada request terbuka',
    'custPortal.emptyDocs': 'Belum ada dokumen',
    'custPortal.npwp': 'NPWP',
  },
  en: {
    'common.company': 'Company',
    'common.pt': 'Co.',
    'common.year': 'Year',
    'common.date': 'Date',
    'common.from': 'From',
    'common.to': 'To',
    'common.source': 'Source',
    'common.memo': 'Memo',
    'common.debit': 'Debit',
    'common.credit': 'Credit',
    'common.account': 'Account',
    'common.amount': 'Amount',
    'common.refresh': 'Refresh',
    'common.export': 'Export Excel',
    'common.void': 'Void',
    'common.note': 'Note',
    'common.failed': 'Failed',
    'common.created': 'Created',
    'common.results': 'Results ({n})',
    'common.accountNo': 'Acct No',
    'common.accountName': 'Name',
    'common.total': 'Total',
    'common.addRow': '+ Row',
    'common.balance': 'Balanced',
    'common.diff': 'Diff {n}',

    'jr.generalTitle': 'Journal',
    'jr.hubTitle': 'Journal',
    'jr.generalSub': 'All double-entry posts — filter by source, void & audit',
    'jr.hub.sub':
      'Full journal books — General, Purchases, Sales, Cash receipts/disbursements, Adjusting, Correction, and Closing. Pick a type, read the guide, then post.',
    'jr.hub.kicker': 'JasaPembayaran · Ledger',
    'jr.kind.all': 'All',
    'jr.kind.general': 'General Journal',
    'jr.kind.purchase': 'Purchases Journal',
    'jr.kind.sales': 'Sales Journal',
    'jr.kind.cash_in': 'Cash Receipts',
    'jr.kind.cash_out': 'Cash Disbursements',
    'jr.kind.adjustment': 'Adjusting Journal',
    'jr.kind.correction': 'Correction Journal',
    'jr.kind.close': 'Closing Journal',
    'jr.kind.hint.all': 'All sources & types in the filtered period.',
    'jr.kind.hint.general': 'Mixed / non-special posts (manual & quick).',
    'jr.kind.hint.purchase': 'Buy goods/services — cash or on account.',
    'jr.kind.hint.sales': 'Sell goods/services — cash or receivables.',
    'jr.kind.hint.cash_in': 'Money into cash/bank (not a new sale).',
    'jr.kind.hint.cash_out': 'Money out of cash/bank (pay AP / expenses).',
    'jr.kind.hint.adjustment': 'Accruals, deferrals, depreciation — period end.',
    'jr.kind.hint.correction': 'Fix wrong posts (Ref tagged [CORR:…]).',
    'jr.kind.hint.close': 'Close nominal accounts to retained earnings.',
    'jr.guide.desk': 'Consultant desk',
    'jr.guide.howTo': 'How to use: {kind}',
    'jr.guide.coachTitle': 'Smart posting guide',
    'jr.guide.open': 'Open guide',
    'jr.guide.collapse': 'Close',
    'jr.ptChip': 'PT {pt}',
    'jr.ptHide': 'Hide PT picker',
    'jr.fillDiff': 'Fill difference',
    'jr.fillDiffDone': 'Difference {n} filled on empty line',
    'jr.kbdHint': 'Ctrl+Enter post · Ctrl+Shift+Enter add row · Tab Debit↔Credit',
    'jr.kbdPostHint': 'Ctrl+Enter',
    'jr.kbdNeedBalance': 'Balance Debit = Credit first',
    'jr.recentTag': 'Recent',
    'jr.guide.labelFungsi': 'Purpose',
    'jr.guide.labelKapan': 'When to use',
    'jr.guide.labelFormula': 'Debit / Credit pattern',
    'jr.guide.labelSteps': 'Steps (in order)',
    'jr.guide.labelContoh': 'Worked example',
    'jr.guide.labelTips': 'Consultant tips',
    'jr.guide.labelMistakes': 'Common mistakes',
    'jr.guide.startCreate': 'Start creating {kind}',

    'jr.dp.btn': 'DP / Unearned wizard',
    'jr.dp.title': 'DP → Revenue wizard',
    'jr.dp.sub': 'Down payment hits cash first — revenue rises only when earned',
    'jr.dp.explain':
      'Accrual-correct: DP = Dr Cash/Bank · Cr Unearned (not revenue). When performance is done: Dr Unearned · Cr Revenue — omset & final tax base rise, liability falls. Remaining = AR then Cash Receipts + recon.',
    'jr.dp.umBalance': 'Unearned balance (cleared only)',
    'jr.dp.customer': 'Customer name',
    'jr.dp.dpAmount': 'DP amount',
    'jr.dp.contract': 'Contract total (optional)',
    'jr.dp.remaining': 'Remainder becomes AR: {n}',
    'jr.dp.bank': 'Receiving cash / bank',
    'jr.dp.dpDate': 'DP received date',
    'jr.dp.recognizeDate': 'Revenue recognition date',
    'jr.dp.recognizeNow': 'Also recognize revenue now (work already done)',
    'jr.dp.needAmount': 'Enter DP amount > 0',
    'jr.dp.submitDp': 'Record DP only (pending recon)',
    'jr.dp.submitFull': 'Record DP + recognize revenue',
    'jr.dp.done': 'Posted successfully',
    'jr.dp.openHint': 'Open DP / customer deposit wizard',

    'dash.umKicker': 'Accrual · Cash',
    'dash.umTitle': 'Customer deposits & DP',
    'dash.umSub': 'Track deposits not yet recognized as revenue, plus items still waiting for bank match.',
    'dash.umSubShort': 'Track unrecognized deposits & pending bank matches.',
    'dash.umOpen': 'Open unearned details',
    'dash.umBalHint': 'Liability account 2600 (cleared)',
    'dash.umPendingHint': '{n} txns awaiting match',
    'dash.umOmsetHint': 'Cleared revenue this year',
    'dash.umRatioHint': 'Ideal below 15%',
    'dash.cfoKicker': 'CFO summary',
    'dash.cfoTitle': 'Financial position this period',
    'dash.cfoSub': 'Click a card for detail reports · follows PT & period filters above',
    'dash.cfoOpenHub': 'Reports hub',
    'dash.cfoTodayBtn': 'What to do today',
    'dash.cfoRunwayDays': 'Runway ~{n} days',
    'dash.cfoRunwayInfinite': 'Healthy runway',
    'dash.cfoRunwayZero': 'Runway depleted',
    'dash.cfoTaxDue': 'Tax due',
    'dash.cfoTaxOverdue': '{n} overdue',
    'dash.cfoTaxH3': '{n} due in 3 days',
    'dash.cfoTaxClear': 'No urgency',
    'dash.cfoAttGap': 'Attendance gaps',
    'dash.cfoAttMeta': '{absent} absent · {n} need attention',
    'dash.cfoLk': 'Financial statements',
    'dash.cfoLkHint': 'Open Report Studio',
    'dash.taxKicker': 'Tax modules',
    'dash.taxTitle': 'Tax compliance snapshot',
    'dash.taxSub': 'Final PPh, VAT, SSP, withholding certs · click a card for details',
    'dash.taxOpenHub': 'Tax center',

    'rpt.unearnedTitle': 'Customer Unearned Revenue',
    'rpt.unearnedKicker': 'Details · DP',
    'rpt.unearnedSub': 'Liability 2600 balance, DP awaiting reconciliation, and ratio vs revenue this year',
    'rpt.unearnedJgiJgtNote':
      'JGI and JGT: customers usually pay in small amounts and settle in full — no customer advances. Balances here appear only if credit account 2600 is still unrecognized.',
    'rpt.unearnedBal': 'Unearned balance',
    'rpt.unearnedPending': 'DP awaiting reconciliation',
    'rpt.unearnedOmset': 'Revenue this year',
    'rpt.unearnedRatio': 'Unearned ÷ revenue',
    'rpt.unearnedDays': 'days',
    'rpt.unearnedPendingList': 'DP waiting for statement match',
    'rpt.unearnedAging': 'Open unearned list (FIFO)',
    'rpt.unearnedEmpty': 'No open unearned balance',
    'rpt.ue.healthNoDp': 'Normal · no customer advances',
    'rpt.omsetUnearnedHint':
      'Omset is cleared revenue only. DP in unearned is excluded until recognized.',
    'rpt.consultantNotes': 'Consultant notes',
    'rpt.lkCostAttrTitle': 'Cost attribution by bank account',
    'rpt.lkCostAttrShare': 'This PT share of shared costs: {pct}% ({method})',
    'rpt.lkCostAttrHpp': 'COGS from shared CC/DBS: {n}',
    'rpt.lkCostAttrOpex': 'Opex from shared DBS: {n}',
    'rpt.ue.pageAll': 'All',
    'rpt.ue.perPage': 'Per page',
    'rpt.ue.pageMeta': 'Page {page} / {pages} · {total} rows',
    'rpt.ue.showing': 'Showing {from}–{to} of {total}',
    'rpt.ue.pagePrev': 'Previous',
    'rpt.ue.pageNext': 'Next',
    'rpt.ue.jumpPage': 'Go to page',
    'rpt.ue.go': 'Go',
    'rpt.ue.searchPh': 'Search ref / memo…',
    'rpt.ue.entries': 'entries',
    'rpt.ue.clickFilter': 'Click to filter',
    'rpt.ue.clearBucket': 'Clear age filter',
    'rpt.ue.totalNominal': 'Total',
    'rpt.ue.pendingKicker': 'Pending',
    'rpt.ue.emptyHint': 'No open 2600 balance yet, or try another PT / year.',
    'rpt.ue.account': 'Account',
    'rpt.ue.loadedAt': 'Loaded',
    'rpt.ue.factOpen': 'Open',
    'rpt.ue.factOpenVal': '{n} rows',
    'rpt.ue.factPending': 'Pending',
    'rpt.ue.factPendingVal': '{n} txn',
    'rpt.ue.factRatio': 'UM ratio',
    'rpt.ue.btnDpShort': 'DP wizard',
    'rpt.ue.btnCashShort': 'Cash in',
    'rpt.ue.healthOk': 'Healthy',
    'rpt.ue.healthWatch': 'Watch',
    'rpt.ue.healthCritical': 'Needs review',
    'rpt.ue.sort': 'Sort',
    'rpt.ue.sortDaysDesc': 'Oldest age',
    'rpt.ue.sortDaysAsc': 'Newest age',
    'rpt.ue.sortAmtDesc': 'Largest amount',
    'rpt.ue.sortAmtAsc': 'Smallest amount',
    'rpt.ue.sortDateDesc': 'Newest date',
    'rpt.ue.sortDateAsc': 'Oldest date',
    'rpt.ue.resetFilters': 'Reset filters',
    'rpt.ue.exportEmpty': 'No rows to export',
    'rpt.ue.pendingEmpty': 'No pending DP',
    'rpt.ue.pendingEmptyHint': 'All DP receipts are already matched in reconciliation.',
    'rpt.ue.guideTitle': 'How to read unearned desk',
    'rpt.ue.guideFlow': 'Workflow',
    'rpt.ue.guideWatch': 'Watchouts',
    'rpt.ue.guideStep1': 'Receive DP via Cash In / Wizard → credit 2600 (pending).',
    'rpt.ue.guideStep2': 'Match in Reconciliation so status becomes cleared.',
    'rpt.ue.guideStep3': 'When earned: Debit 2600 · Credit revenue.',
    'rpt.ue.guideStep4': 'Watch unearned ÷ revenue (ideal < 15%).',
    'rpt.ue.guideTip1': '90+ day bucket usually means unrecognized DP / delayed jobs.',
    'rpt.ue.guideTip2': 'High pending means unmatched statements, not revenue.',
    'rpt.ue.guideTip3': 'Export CSV before bulk fixes / month close.',
    'rpt.ue.vizAgingMix': 'DP age mix',
    'rpt.ue.vizComposition': 'Balance · pending · open',
    'rpt.ue.vizSnapshot': 'Desk snapshot',
    'rpt.ue.vizOpenAging': 'Open aging',
    'rpt.ue.snapHealth': 'Health status',
    'rpt.ue.snapOpen': 'Open entries',
    'rpt.ue.snapPending': 'Pending DP',
    'rpt.ue.tipsTitle': 'Action tips',
    'rpt.ue.tipPending': '{n} pending DP · {amount} — match in reconciliation',
    'rpt.ue.tipD90': '90+ bucket: {n} entries · {amount} — review recognition',
    'rpt.ue.tipRatio': 'Ratio {pct}% above 15% threshold — watch unearned',
    'rpt.ue.tipRatioWatch': 'Ratio {pct}% near threshold — monitor',
    'rpt.ue.tipWizard': 'Record new DP via DP / Unearned wizard',
    'rpt.ue.tipRecon': 'Open reconciliation to match bank statements',
    'rpt.ue.tipOk': 'Unearned desk looks healthy — no urgent findings',
    'rpt.ue.kpiTapOmset': 'Click to open omset report',
    'rpt.ue.focusBucket': 'Age filter: {b} days',
    'rpt.ue.focusBal': 'Focus: unearned balance',
    'rpt.ue.focusPending': 'Focus: pending DP',
    'rpt.ue.focusOmset': 'Focus: revenue',
    'rpt.ue.focusRatio': 'Focus: ratio',
    'rpt.ue.focusSearch': 'Search: “{q}”',

    'tax.umTitle': 'Customer unearned',
    'tax.umPending': '{n} DP still awaiting reconciliation',

    'recon.chipDp': 'DP pending {n}',
    'recon.chipDpHint': 'Filter book side to [DP:…] / unearned memos',

    'prac.docDpHint':
      'Attach DP contracts/invoices here, then match journal memos to the same customer name.',

    'jr.guide.all.fungsi':
      'Combined view of every journal book. Use for quick audit, Ref search, bulk unmatch/void, and CSV export without limiting type.',
    'jr.guide.all.kapan':
      'Daily/weekly review, reconciliation, or finding posts across types (general + purchases + cash + adjustments).',
    'jr.guide.all.formula':
      'No single Dr/Cr pattern — each row follows its own type.\nUse Source filter (on All) to narrow results.',
    'jr.guide.all.contoh':
      'Search Ref J7P-001234 → open detail → review CORR/VOID timeline → unmatch if a fix is needed.',
    'jr.guide.all.steps':
      'Pick period (year / month / 30 days) and company.\nLeave type on All, or click a type card to focus.\nSearch by Ref / memo; filter Cleared to unmatch.\nSelect rows for bulk unmatch or void.\nClick a type card then Create Journal to post new.',
    'jr.guide.all.tips':
      'Start from Cleared + active company before period close.\nExport CSV before mass corrections as a work trail.\nUse Month-Close Wizard when the period is nearly locked.',
    'jr.guide.all.mistakes':
      'Voiding while still reconciliation-locked.\nMixing Source filter with a type card (Source only works on All).\nEditing old journal amounts — use Correction instead.',

    'jr.guide.general.fungsi':
      'General Journal records transactions without a special book (or ones you choose to keep general). Still double-entry: total Debit = total Credit.',
    'jr.guide.general.kapan':
      'Payroll, opex, bank fees, transfers, simple accruals, or mixed posts that are not pure purchase/sale/cash movement.',
    'jr.guide.general.formula':
      'Dr Expense / Asset    ·    Cr Cash-Bank / Payable / Revenue\n(at least 2 lines; one line is either Dr or Cr)',
    'jr.guide.general.contoh':
      'Pay server fee 500,000: Dr Server Expense 500,000 · Cr Bank 500,000. Memo: “Server March”.',
    'jr.guide.general.steps':
      'Select company JGI or JGT (required).\nEnter the transaction date (not entry date).\nAdd ≥2 account lines; Debit must equal Credit.\nWrite a clear memo (who, what, evidence).\nTick “Post to statements” if final; leave pending if waiting on bank recon.\nPost → keep the Ref ID → verify in lookup if needed.',
    'jr.guide.general.tips':
      'Use Special Journals (Payroll, Opex, Bank fee) for consistent accounts on repeats.\nOne evidence set = one Ref; don’t mix different dates.\nIf it is a pure purchase/sale/cash move, use the special book.',
    'jr.guide.general.mistakes':
      'Debit and credit on the same line.\nForgetting company → wrong entity reports.\nUnbalanced amounts (system will reject — fix the difference).',

    'jr.guide.purchase.fungsi':
      'Purchases Journal records acquisition of goods/services/inventory — on account (AP) or cash (cash/bank out).',
    'jr.guide.purchase.kapan':
      'Supplier invoice, received PO, or buying supplies/inventory — paid now or later.',
    'jr.guide.purchase.formula':
      'On account:  Dr Inventory / Expense / Asset    ·    Cr Accounts Payable\nCash:        Dr Inventory / Expense / Asset    ·    Cr Cash / Bank',
    'jr.guide.purchase.contoh':
      'Buy inventory 2,000,000 due in 14 days: Dr Inventory 2,000,000 · Cr AP 2,000,000. When paying later → Cash Disbursements (Dr AP · Cr Bank).',
    'jr.guide.purchase.steps':
      'Select Purchases Journal (or open from the hub card).\nPick company & date matching the supplier invoice.\nDebit what you received (Inventory / Expense / Asset).\nCredit AP (on account) or Cash/Bank (cash).\nMemo: invoice no, supplier, due date.\nUse “Purchase credit/cash” templates, fill amount, post.\nFile the invoice under Letters & Files if needed.',
    'jr.guide.purchase.tips':
      'Separate fixed-asset buys from opex — different Dr accounts.\nDon’t record AP settlement here; that is Cash Disbursements.\nIf VAT applies later, split tax lines per fiscal policy.',
    'jr.guide.purchase.mistakes':
      'Recording a credit purchase as revenue.\nCrediting Bank while it is still payable (AP disappears).\nPaying AP with another purchases journal (double count).',

    'jr.guide.sales.fungsi':
      'Sales Journal recognizes revenue when goods/services are sold — cash or on account (AR).',
    'jr.guide.sales.kapan':
      'Customer invoice, warehouse/logistics service delivery, or sales that the company has earned (accrual).',
    'jr.guide.sales.formula':
      'On account:  Dr Accounts Receivable    ·    Cr Revenue\nCash:        Dr Cash / Bank            ·    Cr Revenue\n(Optional COGS: Dr COGS · Cr Inventory)',
    'jr.guide.sales.contoh':
      'Bill warehouse service 10,000,000: Dr AR 10,000,000 · Cr Service Revenue 10,000,000. When customer pays → Cash Receipts (Dr Bank · Cr AR).',
    'jr.guide.sales.steps':
      'Select Sales Journal.\nSet company, invoice date, memo with invoice # + customer.\nDebit AR (credit sale) or Cash/Bank (cash sale).\nCredit the correct revenue account.\nIf COGS applies, add Dr COGS · Cr Inventory.\nPost → monitor AR / revenue reports.',
    'jr.guide.sales.tips':
      'Don’t mix AR collections here — use Cash Receipts.\nJGI/JGT revenue must hit the correct company.\nFinal tax omset follows cleared revenue in statements.',
    'jr.guide.sales.mistakes':
      'Crediting revenue on deposit before delivery (check accrual policy).\nDr Bank + Cr AR inside Sales (that is a collection).\nSkipping COGS when inventory exists (gross profit overstated).',

    'jr.guide.cash_in.fungsi':
      'Cash Receipts records money actually entering cash/bank: AR collections, capital deposits, interest, and other inflows — without recognizing a new sale.',
    'jr.guide.cash_in.kapan':
      'Incoming customer transfer, capital deposit, bank interest, refunds, or other cash in already visible on the statement.',
    'jr.guide.cash_in.formula':
      'Dr Cash / Bank\nCr Accounts Receivable   (collection)\nCr Interest income / Equity / other source',
    'jr.guide.cash_in.contoh':
      'Customer pays invoice 10,000,000: Dr Bank 10,000,000 · Cr AR 10,000,000. Match to the bank statement in Reconciliation.',
    'jr.guide.cash_in.steps':
      'Ensure the credit sale was posted earlier (AR exists).\nSelect Cash Receipts · company · bank movement date.\nDebit Cash/Bank that received funds.\nCredit AR (or other source account).\nMemo: bank Ref / sender name.\nPost pending if awaiting statement match; cleared if certain.\nMatch in Reconciliation.',
    'jr.guide.cash_in.tips':
      'Align dates with bank movements for easier matching.\nUse the “AR collection” template.\nA pure cash sale can go through Sales (cash) — pick one consistent path.',
    'jr.guide.cash_in.mistakes':
      'Crediting revenue again on collection (double revenue).\nDr AR · Cr Bank (reversed).\nMixing many customers in one Ref without detail.',

    'jr.guide.cash_out.fungsi':
      'Cash Disbursements records money leaving cash/bank: paying AP, cash opex, payroll transfers, taxes, and operating outflows.',
    'jr.guide.cash_out.kapan':
      'Outgoing transfer, supplier payment against AP, expenses paid immediately, cash withdrawal, or tax/SSP payment.',
    'jr.guide.cash_out.formula':
      'Dr Accounts Payable / Expense / Tax\nCr Cash / Bank',
    'jr.guide.cash_out.contoh':
      'Pay supplier AP 2,000,000: Dr AP 2,000,000 · Cr Bank 2,000,000. Or pay opex: Dr Opex · Cr Bank.',
    'jr.guide.cash_out.steps':
      'Select Cash Disbursements.\nEnsure AP (if settling) was recorded in Purchases earlier.\nDebit AP or the expense being paid.\nCredit Cash/Bank funding source.\nMemo: transfer proof / invoice being settled.\nPost → reconcile to outflow statement.\nFor routine payroll, General template or this lane — keep policy consistent.',
    'jr.guide.cash_out.tips':
      'Separate AP settlement vs new expense so AP aging stays accurate.\nCheck bank balance before large posts.\nBank fees auto-debited → usually General / Bank-fee template.',
    'jr.guide.cash_out.mistakes':
      'Dr Bank · Cr Expense (reversed — cash rises).\nPaying AP by debiting Expense again (double expense, AP remains).\nBundling many suppliers without clear memos.',

    'jr.guide.adjustment.fungsi':
      'Adjusting entries align books with accrual principles at period end: unrecorded expense/revenue, deferrals, and depreciation.',
    'jr.guide.adjustment.kapan':
      'Month/year end before close — accrued expenses, prepaid consumption, accrued interest, depreciation, cut-off fixes.',
    'jr.guide.adjustment.formula':
      'Accrued expense:  Dr Expense · Cr Payable / accrued liability\nDeferral:         Dr Expense · Cr Prepaid (or reverse)\nDepreciation:     Dr Depreciation Expense · Cr Accum. Depreciation',
    'jr.guide.adjustment.contoh':
      'Monthly depreciation: Dr Depreciation Expense · Cr Accum. Depreciation. Accrue unpaid utilities: Dr Opex · Cr AP.',
    'jr.guide.adjustment.steps':
      'Run period-close checklist / Month-Close Wizard.\nIdentify accruals & deferrals still missing.\nSelect Adjusting Journal (source adjustment).\nPost with memo “Adjustment period MM/YYYY”.\nReview P&L and Balance Sheet after posting.\nOnly then run closing entries at year end.',
    'jr.guide.adjustment.tips':
      'Don’t mix with input-error fixes — use Correction.\nDepreciation & Accrued-expense templates are ready.\nDocument the basis (asset schedule, lease contract).',
    'jr.guide.adjustment.mistakes':
      'Adjusting by editing old journals (breaks audit trail).\nPosting mid-month without a clear cut-off.\nForgetting to reverse accruals next period if that is policy.',

    'jr.guide.correction.fungsi':
      'Correction journals fix posting errors without erasing history: reverse/adjust tagged [CORR:…] or controlled void.',
    'jr.guide.correction.kapan':
      'Wrong account, amount, company, or a cleared journal that later proves incorrect after reconciliation.',
    'jr.guide.correction.formula':
      'Flow: Unmatch (if locked) → Correction (reverse / adjust / void) → Post new Ref [CORR:…] / VOID-…\nNever delete historical lines.',
    'jr.guide.correction.contoh':
      'Wrong bank account: unmatch → open Correction → find Ref → full reverse → post correction → create the right journal.',
    'jr.guide.correction.steps':
      'Find the Ref in hub / lookup.\nIf Cleared & match-locked: Cancel reconciliation first.\nOpen /journals/pembetulan.\nChoose mode: full reverse, manual adjust, or void.\nPost → check Ref timeline (origin → CORR → VOID).\nCreate the correct replacement in the right type.\nAsk Tasya to explain the Ref chain if reviewing.',
    'jr.guide.correction.tips':
      'Always leave a trail: memo must cite the origin Ref.\nBulk void only what is allowed to void.\nAfter correction, rematch the statement.',
    'jr.guide.correction.mistakes':
      'Editing the database / deleting journal lines.\nVoiding without unmatch while still matched.\nPosting a “replacement” without reversing the wrong one (double balance).',

    'jr.guide.close.fungsi':
      'Closing journals close nominal accounts (revenue & expenses) into income summary / retained earnings so books are ready for the new year.',
    'jr.guide.close.kapan':
      'After all adjusting entries are final at fiscal year end (or the company’s official closing period).',
    'jr.guide.close.formula':
      'Dr Revenue (close) · Cr Income Summary\nDr Income Summary · Cr Expenses (close)\nDr/Cr Income Summary → Retained Earnings / Equity per profit/loss',
    'jr.guide.close.contoh':
      'Use Month/Year Close Wizard: checklist green → generate closing journals → review Refs with source close.',
    'jr.guide.close.steps':
      'Finish reconciliation & adjustments.\nOpen Close Wizard / checklist.\nReview omset, tax, and IC.\nPost closing journals (or entry kind=close).\nLock the period if company policy uses locks.\nBackup the database after close.',
    'jr.guide.close.tips':
      'Don’t close if material items are still pending.\nSave FS + tax packs before/after close.\nClosing is not for corrections — correct first.',
    'jr.guide.close.mistakes':
      'Closing mid-year without policy.\nDouble-closing the same period.\nLocking before fiscal adjustments finish.',

    'jr.hub.flowTitle': 'Workflow',
    'jr.hub.actionUnmatch': 'Cancel reconciliation',
    'jr.hub.actionUnmatchSub': 'Unmatch · journal returns to the queue',
    'jr.hub.actionFix': 'Fix input data',
    'jr.hub.actionFixSub': 'Correction lane · reverse / adjust / void',
    'jr.hub.actionCreate': 'Create Journal',
    'jr.hub.actionCreateSub': 'Post using the active type',
    'jr.hub.unmatchHint':
      'Cleared filter on. Expand a row → Cancel reconciliation.',
    'jr.hub.periodYear': 'This year',
    'jr.hub.periodMonth': 'This month',
    'jr.hub.period30': '30 days',
    'jr.hub.periodCustom': 'Custom',
    'jr.hub.filterToggle': 'List filters',
    'jr.hub.howtoShort': 'How to use',
    'jr.hub.widenYear': 'Widen to this year',
    'jr.hub.copyRef': 'Copy Ref',
    'jr.hub.copied': 'Ref {ref} copied',
    'jr.hub.exportCsv': 'Export CSV',
    'jr.hub.exportOk': 'CSV downloaded ({n} rows)',
    'jr.hub.gotoRecon': 'Reconciliation',
    'jr.hub.listTitle': 'Entry list',
    'jr.hub.activeKind': 'Active type',
    'jr.hub.perPage': 'Per page',
    'jr.hub.pageAll': 'All',
    'jr.hub.pageMeta': 'Page {page} / {pages} · {total} entries',
    'jr.hub.showing': 'Showing {from}–{to} of {total}',
    'jr.hub.pagePrev': 'Previous',
    'jr.hub.pageNext': 'Next',
    'jr.hub.pageFirst': 'First page',
    'jr.hub.pageLast': 'Last page',
    'jr.hub.pagination': 'Page navigation',
    'jr.hub.jumpPage': 'Go to page',
    'jr.hub.go': 'Go',
    'jr.hub.sort': 'Sort',
    'jr.hub.sortDateDesc': 'Newest date',
    'jr.hub.sortDateAsc': 'Oldest date',
    'jr.hub.sortAmtDesc': 'Largest amount',
    'jr.hub.sortAmtAsc': 'Smallest amount',
    'jr.hub.sortCreated': 'Recently created',
    'jr.hub.sortPending': 'Pending first',
    'jr.hub.sortRef': 'Ref A→Z',
    'jr.hub.quickPending': 'Pending only',
    'jr.hub.quickUnbalanced': 'Unbalanced',
    'jr.hub.resetFilters': 'Reset filters',
    'jr.hub.clickFilter': 'Click to filter',
    'jr.hub.ofBase': 'of {n} total',
    'jr.hub.compact': 'Compact view',
    'jr.hub.periodToday': 'Today',
    'jr.hub.amtMin': 'Min amount',
    'jr.hub.amtMax': 'Max amount',
    'jr.hub.hideVoid': 'Hide void',
    'jr.hub.shortcuts': 'Shortcuts',
    'jr.hub.keySearch': 'search',
    'jr.hub.keyPage': 'change page',
    'jr.hub.keyEsc': 'close / clear selection',
    'jr.hub.keyNav': 'move row',
    'jr.hub.keyExpand': 'expand',
    'jr.hub.keyDetail': 'open detail',
    'jr.hub.keyPreview': 'preview lines',
    'jr.hub.viewTable': 'Table view',
    'jr.hub.groupByDate': 'Group by date',
    'jr.hub.saveView': 'Save view',
    'jr.hub.viewName': 'View name',
    'jr.hub.viewSaved': 'View saved',
    'jr.hub.savedViews': 'Saved',
    'jr.hub.healthOk': 'Health OK',
    'jr.hub.healthWarn': 'Needs attention',
    'jr.hub.healthUnbal': 'Unbalanced {n}',
    'jr.hub.healthPending': 'Pending {n}',
    'jr.hub.healthVoid': 'Void {n}',
    'jr.hub.healthVolume': 'Dr {d} · Cr {c}',
    'jr.hub.dayMeta': '{n} entries · {amt}',
    'jr.hub.colRef': 'Ref',
    'jr.hub.colMemo': 'Memo',
    'jr.hub.openSelected': 'Open detail',
    'jr.hub.openFirstOf': 'Opening 1 of {n} selected',
    'jr.hub.auditHint': 'Full history in Detail → Timeline',
    'jr.hub.auditSection': 'Audit',
    'jr.hub.toTop': 'Back to list top',
    'jr.hub.exportEmpty': 'Nothing to export',
    'jr.bulk.selectPage': 'Select page',
    'jr.bulk.clearPage': 'Clear page',
    'jr.bulk.copyRefs': 'Copy Refs',
    'jr.bulk.copiedRefs': '{n} Refs copied',
    'jr.bulk.noneCopy': 'No refs to copy',
    'jr.bulk.exportSelected': 'Export selected',
    'jr.confirmUnmatch':
      'Cancel reconciliation for {ref}?\n\nThe journal returns to the match queue.',
    'jr.snackUnmatched': 'Reconciliation for {ref} cancelled',
    'jr.snackUnmatchFail': 'Failed to cancel reconciliation',
    'jr.statEntries': 'Entries',
    'jr.statVolume': 'Debit volume',
    'jr.statPending': 'Pending recon',
    'jr.statCleared': 'Cleared',
    'jr.statSources': 'Sources',
    'jr.expandAll': 'Expand all',
    'jr.collapseAll': 'Collapse all',
    'jr.expandView': 'Expand view',
    'jr.collapseView': 'Collapse view',
    'jr.lines': 'lines',
    'jr.emptyHint': 'Change date/type filters, or create a new journal.',
    'jr.emptyKind': 'No entries for {kind} in this period.',
    'jr.emptySearchHint': 'Try another Ref, clear search, or widen the date range.',
    'jr.emptyCorrectionHint':
      'No correction journals in this period. Open the Fix lane, or widen the date filter.',
    'jr.emptyCloseHint': 'No closing journals yet. Run the Month-Close Wizard after final adjustments.',
    'jr.emptyPeriodHint': 'Widen the period, switch type, or create a new journal.',
    'jr.corrPanel.kicker': 'Special lane',
    'jr.corrPanel.title': 'Fix incorrect posting',
    'jr.corrPanel.sub':
      'Unmatch if needed → fix via Correction → post a balanced Ref [CORR:…] entry.',
    'jr.corrPanel.s1': 'Cancel reconciliation',
    'jr.corrPanel.s1h': 'Unmatch so the journal can be corrected',
    'jr.corrPanel.s2': 'Fix input data',
    'jr.corrPanel.s2h': 'Reverse / adjust / void via Correction',
    'jr.corrPanel.s3': 'Create correction journal',
    'jr.corrPanel.s3h': 'Post CORR with Debit = Credit',
    'jr.recon.all': 'All statuses',
    'jr.entryTitle': 'Create Journal',
    'jr.entrySub': 'Professional journal entry — auto Ref ID J7P-###### · Debit must equal Credit',
    'jr.entrySub.manual':
      'General Journal — operational / mixed posts. Auto Ref · Debit must equal Credit.',
    'jr.entrySub.purchase':
      'Purchases — record goods/services acquired (cash or AP). Debit asset/expense · Credit AP or cash.',
    'jr.entrySub.sales':
      'Sales — recognize revenue (cash or AR). Debit cash/AR · Credit revenue.',
    'jr.entrySub.cash_receipt':
      'Cash Receipts — money into cash/bank (AR collection / deposits). Not a new sale.',
    'jr.entrySub.cash_disbursement':
      'Cash Disbursements — money out of cash/bank (pay AP / expenses). Debit AP/expense · Credit cash.',
    'jr.entrySub.adjustment':
      'Adjusting — accruals, deferrals, depreciation at period end before close.',
    'jr.entrySub.close':
      'Closing — close nominal accounts to retained earnings. Use after final adjustments.',
    'jr.entryKicker': 'Manual posting · Double-entry',
    'jr.entryKicker.manual': 'General Journal · Double-entry',
    'jr.entryKicker.purchase': 'Purchases · Supplier / PO',
    'jr.entryKicker.sales': 'Sales · Invoice / revenue',
    'jr.entryKicker.cash_receipt': 'Cash Receipts · Inflow',
    'jr.entryKicker.cash_disbursement': 'Cash Disbursements · Outflow',
    'jr.entryKicker.adjustment': 'Adjusting · Accrual / deferral',
    'jr.entryKicker.close': 'Closing · Year-end close',
    'jr.entryKickerAdj': 'Adjusting journal · Accrual / deferral',
    'jr.entryKickerClose': 'Closing journal · Year-end close',
    'jr.tpl.title': 'Journal templates',
    'jr.tpl.sub': 'Pick a ready-made pattern — fill the amount, then post.',
    'jr.tpl.open': 'From template',
    'jr.tpl.save': 'Save as template',
    'jr.tpl.apply': 'Apply',
    'jr.tpl.amount': 'Amount (optional)',
    'jr.tpl.amountHint': 'If set, the same amount is used on Debit & Credit.',
    'jr.tpl.empty': 'No templates for this journal type yet.',
    'jr.tpl.system': 'System',
    'jr.tpl.custom': 'Custom',
    'jr.tpl.used': 'used {n}×',
    'jr.tpl.name': 'Template name',
    'jr.tpl.saved': 'Template “{name}” saved',
    'jr.tpl.applied': 'Template “{name}” applied',
    'jr.tpl.deleted': 'Template deleted',
    'jr.tpl.deleteConfirm': 'Delete template “{name}”?',
    'jr.tpl.needLines': 'Fill at least 2 account lines before saving a template.',
    'jr.tpl.needName': 'Enter a template name.',
    'jr.tpl.strip': 'Quick-fill from a template',
    'jr.khusus.kicker': 'Inside General Journal',
    'jr.khusus.title': 'Special Journals',
    'jr.khusus.sub':
      'Repeatable patterns you use often (payroll, opex, bank fee, etc.). Click to quick-fill, then post.',
    'jr.khusus.add': 'New pattern',
    'jr.khusus.empty': 'No special journal patterns yet. Save a journal as a repeatable template.',
    'jr.khusus.loading': 'Loading patterns…',
    'jr.khusus.saveCheck': 'Save to Special Journals (repeatable / frequent)',
    'jr.draft.title': 'Draft saved',
    'jr.draft.sub': 'Local draft available · {at}',
    'jr.draft.restore': 'Continue draft',
    'jr.draft.discard': 'Discard',
    'jr.draft.restored': 'Draft restored',
    'jr.draft.discarded': 'Draft discarded',
    'jr.timeline.title': 'Ref chain',
    'jr.timeline.origin': 'Origin',
    'jr.timeline.correction': 'Correction',
    'jr.timeline.void': 'Void',
    'jr.timeline.related': 'Related',
    'jr.timeline.single': 'No related correction/void yet.',
    'jr.timeline.askTasya': 'Ask Tasya',
    'jr.bulk.selectAll': 'Select all',
    'jr.bulk.selected': '{n} selected',
    'jr.bulk.clear': 'Clear',
    'jr.bulk.confirmUnmatch': 'Cancel reconciliation for {n} journals?',
    'jr.bulk.confirmVoid': 'Void {n} journals?\nMatched ones will fail until unmatched.',
    'jr.bulk.doneUnmatch': 'Unmatch: {ok} ok · {fail} failed',
    'jr.bulk.doneVoid': 'Void: {ok} ok · {fail} failed',
    'jr.bulk.noneUnmatch': 'No cleared journals eligible to unmatch.',
    'jr.bulk.noneVoid': 'No journals eligible to void.',
    'jr.wizard.nav': 'Month close',
    'jr.wizard.kicker': 'Accounting · Tax · Advisory',
    'jr.wizard.title': 'Month Close',
    'jr.wizard.sub':
      'Work order: bank recon → adjustments → unearned → tax → report check → checklist → consultant pack → year close.',
    'jr.wizard.stepLabel': 'Step {n}',
    'jr.wizard.open': 'Open',
    'jr.wizard.next': 'Next',
    'jr.wizard.prev': 'Back',
    'jr.wizard.progress': 'Progress {pct}% · {done}/{total}',
    'jr.wizard.viewAdj': 'View adjustments',
    'jr.wizard.taxHub': 'Tax menu',
    'jr.wizard.lk': 'Financial statements',
    'jr.wizard.downloads': 'Report downloads',
    'jr.wizard.pickPt': 'Select a company first',
    'jr.wizard.readyBadge': 'Close-ready {pct}%',
    'jr.wizard.readyShort': 'Ready',
    'jr.wizard.step.recon': 'Bank reconciliation',
    'jr.wizard.step.reconHint': 'Import statements, clear unmatched items, align books with bank.',
    'jr.wizard.step.adjust': 'Adjusting journals',
    'jr.wizard.step.adjustHint': 'Post accruals, deferrals, depreciation, and corrections before close.',
    'jr.wizard.step.unearned': 'Unearned / DP',
    'jr.wizard.step.unearnedHint': 'Review customer unearned & pending DP before tax.',
    'jr.wizard.step.tax': 'This month’s tax',
    'jr.wizard.step.taxHint': 'Final MSME tax, Art. 21/23, SSP, calendar & periodic SPT.',
    'jr.wizard.step.checklist': 'Close checklist',
    'jr.wizard.step.checklistHint': 'Tick all month-close controls before advisory review.',
    'jr.wizard.step.checklistHintInline': 'Tick items in this wizard — no separate page required.',
    'jr.wizard.checklistInlineNote': 'Month-close checklist lives in this step. Tick items above, then continue to the consultant pack.',
    'jr.wizard.checklistFullPage': 'Full checklist page (optional)',
    'jr.wizard.checklistHere': 'Do it here',
    'jr.wizard.step.reports': 'Check reports',
    'jr.wizard.step.reportsHint': 'Confirm trial balance, then review BS / P&L / turnover.',
    'jr.wizard.step.pack': 'Consultant pack',
    'jr.wizard.step.packHint': 'Download Excel for KAP/advisor, backup, and close workpaper.',
    'jr.wizard.step.year': 'Year close',
    'jr.wizard.step.yearHint': 'Close revenue & expense to retained earnings (usually December).',
    'jr.wizard.metric.clear': 'Clear',
    'jr.wizard.metric.pending': '{n} pending',
    'jr.wizard.metric.journals': '{n} journals',
    'jr.wizard.metric.dpPending': '{n} DP',
    'jr.wizard.metric.pphPosted': 'Posted',
    'jr.wizard.metric.pphOpen': 'Not posted',
    'jr.wizard.metric.noOmset': 'No turnover',
    'jr.wizard.metric.tbOk': 'Balanced',
    'jr.wizard.metric.tbDiff': 'Diff {amt}',
    'jr.wizard.metric.quality': 'Score {n}',
    'jr.wizard.metric.yearClosed': 'Closed',
    'jr.wizard.metric.yearReady': 'Ready to review',
    'jr.wizard.metric.yearLater': 'Year-end',
    'jr.wizard.metric.payrollOk': 'Run exists',
    'jr.wizard.kpi.ready': 'Readiness',
    'jr.wizard.kpi.recon': 'Recon pending',
    'jr.wizard.kpi.tax': 'Final tax',
    'jr.wizard.kpi.tb': 'Trial balance',
    'jr.wizard.kpi.checklist': 'Checklist',
    'jr.wizard.kpi.quality': 'Completeness',
    'jr.wizard.stat.pending': 'Pending',
    'jr.wizard.stat.highRisk': 'High risk',
    'jr.wizard.stat.aging': 'Aging',
    'jr.wizard.stat.lowRisk': 'Low risk',
    'jr.wizard.stat.adjCount': 'Period adjusting journals',
    'jr.wizard.stat.umBalance': 'Unearned balance',
    'jr.wizard.stat.dpPending': 'Pending DP',
    'jr.wizard.stat.dpTotal': 'Pending DP amount',
    'jr.wizard.stat.aging90': 'Aging >90 days',
    'jr.wizard.stat.omset': 'Period turnover',
    'jr.wizard.stat.pphFinal': 'Final tax',
    'jr.wizard.stat.pphStatus': 'Posting status',
    'jr.wizard.stat.paid': 'paid',
    'jr.wizard.stat.tb': 'Trial balance',
    'jr.wizard.stat.debit': 'Total debit',
    'jr.wizard.stat.credit': 'Total credit',
    'jr.wizard.stat.accounts': 'Active accounts',
    'jr.wizard.stat.critical': 'Critical findings',
    'jr.wizard.stat.noCompany': 'No company',
    'jr.wizard.stat.badRef': 'Ref mismatch',
    'jr.wizard.guide.adjustTitle': 'Adjustment work order',
    'jr.wizard.guide.adjust1': 'Finish bank reconciliation first.',
    'jr.wizard.guide.adjust2': 'Post missing accruals and deferrals.',
    'jr.wizard.guide.adjust3': 'Run / review fixed-asset depreciation.',
    'jr.wizard.guide.adjust4': 'Re-check P&L after adjustments.',
    'jr.wizard.guide.rptTitle': 'Professional review before close',
    'jr.wizard.guide.rpt1': 'Confirm trial balance debits = credits.',
    'jr.wizard.guide.rpt2': 'Compare BS & P&L vs prior period/year.',
    'jr.wizard.guide.rpt3': 'Keep audit trail and download the client/KAP pack.',
    'jr.wizard.guide.yearTitle': 'Annual books close',
    'jr.wizard.guide.year1': 'All December adjustments and period tax are final.',
    'jr.wizard.guide.year2': 'Close checklist at 100% with adequate completeness score.',
    'jr.wizard.guide.year3': 'Generate closing journals to retained earnings.',
    'jr.wizard.guide.year4': 'Backup DB + export consultant pack before/after close.',
    'jr.wizard.action.postPph': 'Post this period’s final tax',
    'jr.wizard.action.exportPack': 'Export consultant pack (Excel)',
    'jr.wizard.action.yearClose': 'Close this fiscal year',
    'jr.wizard.action.yearClosed': 'Year already closed',
    'jr.wizard.confirmYear': 'Close fiscal year {year}? Closing journals will be created and cannot be deleted directly.',
    'jr.wizard.yearClosedBanner': 'Year {year} closed on {date} · Net income {amt}',
    'jr.wizard.yearMonthHint': 'Year close is usually run in December or at fiscal year-end. You can still review readiness anytime.',
    'jr.wizard.snack.pphOk': 'Final tax posted · {ref} · {amt}',
    'jr.wizard.snack.pphExists': 'Final tax already exists · {ref}',
    'jr.wizard.snack.yearOk': 'Year close succeeded',
    'jr.wizard.snack.packOk': 'Consultant pack downloaded',
    'jr.wizard.link.importStmt': 'Import statements',
    'jr.wizard.link.recon': 'Reconciliation',
    'jr.wizard.link.bankRpt': 'Bank report',
    'jr.wizard.link.cashBank': 'Cash & bank',
    'jr.wizard.link.accrual': 'Accruals',
    'jr.wizard.link.depreciation': 'Depreciation',
    'jr.wizard.link.revenue': 'Revenue',
    'jr.wizard.link.tb': 'Trial balance',
    'jr.wizard.link.audit': 'Audit trail',
    'jr.wizard.link.quality': 'Data quality',
    'jr.wizard.link.backup': 'Database backup',
    'jr.wizard.link.engagements': 'Engagements',
    'jr.wizard.link.clients': 'Tax clients',
    'jr.wizard.asideTitle': 'Advisory working standards',
    'jr.wizard.aside1': 'Keep companies strictly separate — always filter by entity.',
    'jr.wizard.aside2': 'Do not compute final tax before unearned revenue and turnover are reviewed.',
    'jr.wizard.aside3': 'Retain statements, withholding certificates, SSP, and Excel packs before close.',
    'jr.wizard.aside4': 'Close the year only after material adjustments are done and the trial balance is balanced.',
    'jr.wizard.jumpRec': 'Go to priority',
    'jr.wizard.print': 'Print approval',
    'jr.wizard.priorityNow': 'Do this first',
    'jr.wizard.focusStep': 'Open this step',
    'jr.wizard.allClear': 'No critical issues',
    'jr.wizard.allClearHint': 'Month looks clean — continue checklist / consultant pack.',
    'jr.wizard.stepsDone': '{done}/{total} steps done',
    'jr.wizard.workTitle': 'To-do list',
    'jr.wizard.gateTitle': 'Close requirements',
    'jr.wizard.signoffTitle': 'Month-close approval',
    'jr.wizard.signoffReady': 'Ready for consultant / reviewer approval.',
    'jr.wizard.signoffBlocked': '{n} important issues — clear them before approval.',
    'jr.wizard.markAll': 'Mark all',
    'jr.wizard.clearAll': 'Clear all',
    'jr.wizard.confirmMarkAll': 'Mark all checklist items for this month?',
    'jr.wizard.snack.markAll': 'Checklist completed',
    'jr.wizard.snack.clearAll': 'Checklist cleared',
    'jr.wizard.recentJournals': 'This month’s journals (latest)',
    'jr.wizard.kbdHint': 'Keyboard: ← → change step',
    'jr.wizard.col.step': 'Step',
    'jr.wizard.col.status': 'Status',
    'jr.wizard.col.metric': 'Summary',
    'jr.wizard.printSign': 'Reviewer / consultant initials',
    'jr.wizard.sev.critical': 'Critical',
    'jr.wizard.sev.high': 'High',
    'jr.wizard.sev.medium': 'Medium',
    'jr.wizard.sev.low': 'Low',
    'jr.wizard.kpi.omset': 'Month turnover',
    'jr.wizard.kpi.activity': 'Month journals',
    'jr.wizard.kpi.readyHint': 'Requirements {done}/{total}',
    'jr.wizard.kpi.reconHint': 'High risk {high}',
    'jr.wizard.kpi.omsetHint': 'Δ vs prior month {pct}%',
    'jr.wizard.kpi.taxHint': 'Final tax this month',
    'jr.wizard.kpi.tbHint': '{n} active accounts',
    'jr.wizard.kpi.activityHint': 'All journal types',
    'jr.wizard.gate.recon': 'Reconciliation clear',
    'jr.wizard.gate.pph': 'Final tax ready',
    'jr.wizard.gate.tb': 'Trial balance balanced',
    'jr.wizard.gate.checklist': 'Checklist 100%',
    'jr.wizard.gate.quality': 'Data completeness ≥70',
    'jr.wizard.gate.ssp': 'No open SSP',
    'jr.wizard.stat.umRatio': 'Unearned / YTD turnover',
    'jr.wizard.stat.omsetPrev': 'Prior month turnover',
    'jr.wizard.stat.omsetYtd': 'YTD turnover',
    'jr.wizard.autoCheck': 'Fill checklist automatically',
    'jr.wizard.autoSnack': 'AI posted {n} bell note(s) — please cross-check.',
    'jr.wizard.batch': 'All companies',
    'jr.wizard.filterToggle': 'Period & company',
    'jr.wizard.batchTitle': 'Close status — all companies',
    'jr.wizard.batchSum':
      '{total} companies · fully ready: {ready} · locked: {locked} · approved: {signed} · avg {avg}%',
    'jr.wizard.workpaper': 'Workpaper PDF',
    'jr.wizard.tasya': 'Ask Tasya',
    'jr.wizard.tasyaMemo': 'Draft memo (Tasya)',
    'jr.wizard.assistTitle': 'Tasya help · Month close',
    'jr.wizard.lock': 'Lock month',
    'jr.wizard.unlock': 'Unlock',
    'jr.wizard.sign': 'Approve close',
    'jr.wizard.revokeSign': 'Revoke approval',
    'jr.wizard.signHistory': 'Approval history',
    'jr.wizard.lockedBanner': 'This month is locked',
    'jr.wizard.deadlineNext': 'Tax due:',
    'jr.wizard.deadlineTitle': 'Tax due dates',
    'jr.wizard.deadlineIn': 'in {n} days',
    'jr.wizard.deadlineOverdue': '{n} days overdue',
    'jr.wizard.varianceTitle': 'Compare vs prior month',
    'jr.wizard.stat.revCur': 'This month revenue',
    'jr.wizard.stat.expCur': 'This month expense',
    'jr.wizard.stat.netCur': 'This month net',
    'jr.wizard.confirmLock':
      'Lock this month? New journals dated in this month will be rejected until unlocked (admin).',
    'jr.wizard.confirmUnlock': 'Unlock this month? Admin only.',
    'jr.wizard.confirmSign': 'Save month-close approval to the system?',
    'jr.wizard.confirmRevoke': 'Revoke the active approval?',
    'jr.wizard.snack.autoCheck': 'Auto checklist: {n} items filled',
    'jr.wizard.snack.locked': 'Month locked',
    'jr.wizard.snack.unlocked': 'Month unlocked',
    'jr.wizard.snack.signed': 'Approval saved',
    'jr.wizard.snack.revoked': 'Approval revoked',
    'jr.wizard.snack.workpaper': 'Workpaper PDF downloaded',
    'jr.wizard.signedBy': 'Approved by {who} · {when}',
    'jr.wizard.gate.signed': 'Approved',
    'jr.wizard.gate.locked': 'Month locked',
    'jr.wizard.loadingStatus': 'Loading month-close status…',
    'jr.wizard.emptyHint': 'Pick a company, then reload if % is still 0.',
    'jr.wizard.roleAll': 'All roles',
    'jr.wizard.roleAkuntan': 'Accountant',
    'jr.wizard.roleKonsultan': 'Consultant',
    'jr.wizard.rolePartner': 'Partner',
    'jr.wizard.compareTitle': 'Compare companies',
    'jr.wizard.compareMetric': 'Metric',
    'jr.wizard.lockHistoryTitle': 'Month-lock history',
    'jr.wizard.lockAction.lock': 'Lock',
    'jr.wizard.lockAction.unlock': 'Unlock',
    'jr.wizard.memoClient': 'Client memo (PDF)',
    'jr.wizard.snack.memo': 'Client memo downloaded',
    'jr.wizard.noLockHistory': 'No lock/unlock history for this month yet.',


    'corr.kicker': 'Journal · Correction lane',
    'corr.title': 'Correction Journal',
    'corr.sub':
      'Fix wrong journals/reconciliations. Pick the company first, find the original Ref ID, then choose a correction mode.',
    'corr.stepPt': 'Select company first',
    'corr.stepPtHint': 'JGI and JGT are separate — don’t mix them up.',
    'corr.lockUntilPt': 'Form locked until a company is selected.',
    'corr.stepFind': 'Find the wrong journal',
    'corr.stepFindHint': 'Enter Ref ID (J7P-…) or pick a suggestion below.',
    'corr.refLabel': 'Original Ref ID',
    'corr.btnFind': 'Find',
    'corr.needRef': 'Enter the Ref ID to correct.',
    'corr.notFound': 'Ref ID not found.',
    'corr.ptMismatch': 'Journal is {pt} ≠ active PT {pick}. Switch company to match.',
    'corr.ptMatch': 'Company matches',
    'corr.ptBad': 'Company mismatch',
    'corr.fixPtFirst': 'Match the company to the original journal first.',
    'corr.suggestions': 'Suggested recent journals (this company)',
    'corr.suggestionsHint': 'Click to load — prioritize pending / recent ones.',
    'corr.noSuggestions': 'No journals for this company yet.',
    'corr.stepFix': 'Choose correction mode',
    'corr.stepFixHint': 'Full reverse, manual adjust, or void the original.',
    'corr.modeReverse': 'Full reverse (correction)',
    'corr.modeReverseHint': 'Post opposite lines (Dr↔Cr) tagged [CORR:…]. Original stays.',
    'corr.modeCustom': 'Manual adjust',
    'corr.modeCustomHint': 'Edit accounts & amounts for the needed correction.',
    'corr.modeVoid': 'Void original',
    'corr.modeVoidHint': 'Full cancel with VOID-… (unmatch reconciliation first if locked).',
    'corr.reason': 'Correction reason',
    'corr.defaultReason': 'Reconciliation / posting correction · {ref}',
    'corr.postCleared': 'Post directly to reports (cleared)',
    'corr.linesTitle': 'Correction journal lines',
    'corr.reseed': 'Reseed from reverse',
    'corr.needBalance': 'Debit must equal Credit and be > 0.',
    'corr.confirmVoid': 'I confirm voiding the original (hard to undo).',
    'corr.confirmVoidHint': 'Check the void confirmation first.',
    'corr.btnPost': 'Post Correction',
    'corr.btnPostAuto': 'Auto-posting…',
    'corr.autoHint': 'Full reverse mode: correction posts automatically once the source journal is ready — no button click needed.',
    'corr.autoPosting': 'Auto-posting correction…',
    'corr.autoPosted': 'Correction auto-saved · {ref}',
    'corr.alreadyPosted': 'A correction for this Ref was already posted in this session.',
    'corr.btnVoid': 'Void Original',
    'corr.snackOk': 'Done · {ref}',
    'corr.done': 'Correction saved',
    'corr.progressLabel': 'Correction progress',
    'corr.progressWait': 'Waiting…',
    'corr.checkPt': 'Company selected',
    'corr.checkJournal': 'Source journal matched',
    'corr.checkBalance': 'Debit = Credit',
    'corr.checkVoid': 'Void confirmed',
    'corr.needJournalFirst': 'Find & select the source journal first.',
    'corr.statusPending': 'Pending',
    'corr.statusCleared': 'Cleared',
    'corr.statusReleased': 'Released',
    'corr.filterAll': 'All',
    'corr.sugSearchPh': 'Search ref / memo…',
    'corr.expandSug': 'Expand suggestions',
    'corr.expandOrig': 'Source journal detail',
    'corr.linesCount': 'lines',
    'corr.showAllLines': 'Show all {n} lines',
    'corr.showMore': 'Show more',
    'corr.showLess': 'Show less',
    'corr.switchToJournalPt': 'Switch to this journal’s company',
    'corr.voidLockedHint': 'Journal is cleared — unmatch reconciliation first if void fails.',
    'corr.previewTitle': 'Posting preview',
    'corr.previewFoot': '{n} lines will post as [CORR:{tag}]',
    'corr.nextOne': 'Correct another',
    'corr.sessionHistory': 'This session',
    'corr.hotkeyHint': 'Shortcuts: Enter to find · Ctrl+Enter to post',
    'corr.copyRef': 'Copy Ref',
    'corr.copied': 'Copied · {ref}',
    'corr.copyFail': 'Copy failed',
    'corr.timelineTitle': 'Ref chain (origin → CORR → VOID)',
    'corr.roleOrigin': 'Origin',
    'corr.roleCorr': 'Correction',
    'corr.roleVoid': 'Void',
    'corr.roleRelated': 'Related',
    'corr.warnAlreadyVoid': 'This journal is already void — cannot correct again.',
    'corr.warnAlreadyCorr': 'This is already a correction (CORR). Make sure you really want to correct a correction.',
    'corr.warnHasCorr': '{n} related correction(s) already exist — check the timeline before posting again.',
    'corr.cashImpact': 'Cash/bank impact',
    'corr.cashOrig': 'Original',
    'corr.cashCorr': 'Correction',
    'corr.cashNet': 'Combined',
    'corr.compareTitle': 'Compare accounts (original vs correction)',
    'corr.compareOrig': 'Orig net',
    'corr.compareCorr': 'Corr net',
    'corr.compareAfter': 'After',
    'corr.confirmPostTitle': 'Confirm correction posting?',
    'corr.confirmVoidTitle': 'Confirm voiding the original?',
    'corr.recentCorrections': 'Recent corrections (this company)',

    'jr.entryHeader': 'Journal header',
    'jr.entryLinesTitle': 'Account lines',
    'jr.entryLinesSub': 'At least 2 lines. Each line is debit or credit only. Must balance before posting.',
    'jr.entryFilledLines': 'Filled lines',
    'jr.entryDiff': 'Difference',
    'jr.entryPreview': 'Journal preview',
    'jr.entryReset': 'Clear form',
    'jr.entrySwap': 'Swap Dr/Cr',
    'jr.entryDuplicate': 'Duplicate row',
    'jr.entrySharedPt': 'Shared / no company',
    'jr.entryPostCleared': 'Post directly to financial reports',
    'jr.entryRequireApproval': 'Requires reviewer approval',
    'jr.entryProject': 'Project',
    'jr.entryWarehouse': 'Warehouse',
    'jr.entryPostedCleared': 'Cleared — included in balance sheet & P&L.',
    'jr.entryPostedPending': 'Pending reconciliation — excluded from reports until cleared.',
    'jr.lookupKicker': 'Track transactions',
    'jr.lookupTitle': 'Find Ref ID',
    'jr.lookupSub':
      'Every debit/credit has a unique Ref ID J7P-###### (3 mix + sequence). Search to track memo & account lines.',
    'jr.lookupClickHint': 'Click a row for the full detail popup (date, input time, accounts).',
    'jr.lookup.truncated': 'Results capped at {n} rows — narrow filters if needed',
    'jr.lookup.pageTotal': 'Page total',
    'jr.btnMulti': 'Multi-line',
    'jr.btnQuick': '+ Quick',
    'jr.btnPost': 'Post Journal',
    'jr.btnTrack': 'Track',
    'jr.btnVoid': 'Void',
    'jr.btnAddRow': 'Row',
    'jr.btnSaveNote': 'Save note',
    'jr.labelSource': 'Source',
    'jr.labelMemo': 'Memo / journal description',
    'jr.labelLineDesc': 'Line description',
    'jr.labelSearch': 'Ref ID / ID / memo keyword',
    'jr.searchPh': 'e.g. J7P-000001 or transfer',
    'jr.writeMemo': 'Write journal memo',
    'jr.noteTitle': 'Memo / Note',
    'jr.lineAccounts': 'Account lines',
    'jr.sourceCompany': 'Source · Company',
    'jr.savedRef': 'Saved · Ref ID',
    'jr.snackSaved': 'Saved Ref ID {ref}',
    'jr.snackVoided': 'Journal {ref} voided',
    'jr.snackVoidFail': 'Void failed',
    'jr.snackSearchFail': 'Search failed',
    'jr.confirmVoid': 'Void journal {ref}?\n\nA reversing journal VOID-{ref} will be created.',
    'jr.emptyPeriod': 'No journals in this period.',
    'jr.emptySearch': 'No journals found. Try another Ref ID or widen the dates.',
    'jr.detail': 'Detail',
    'jr.detailKicker': 'Ref ID detail',
    'jr.ref': 'Ref {ref}',
    'jr.journalDate': 'Journal date',
    'jr.reconStatus': 'Reconciliation status',
    'jr.balanced': 'Balanced',
    'jr.unbalanced': 'Unbalanced',
    'jr.dbId': 'Database ID',
    'jr.lineCount': 'Line count',
    'jr.recon.pending': 'Pending',
    'jr.recon.cleared': 'Cleared',
    'jr.recon.released': 'Released',
    'jr.source.all': 'All sources',
    'jr.source.quick': 'Quick',
    'jr.source.manual': 'Manual / General',
    'jr.source.purchase': 'Purchases',
    'jr.source.sales': 'Sales',
    'jr.source.cash_receipt': 'Cash receipts',
    'jr.source.cash_disbursement': 'Cash disbursements',
    'jr.source.import': 'Import',
    'jr.source.importStmt': 'Import / Statement',
    'jr.source.opening': 'Opening balance',
    'jr.source.tax': 'Tax',
    'jr.source.close': 'Year close',
    'jr.source.void': 'Void',
    'jr.source.correction': 'Correction',
    'jr.source.adjustment': 'Adjustment',

    'recon.kicker': 'Smart match · Anti-duplicate',
    'recon.title': 'Reconciliation',
    'recon.tasks': '{n} tasks',
    'recon.pickPt': 'Select company',
    'recon.pickPtPlaceholder': 'PT JGI / JGT…',
    'recon.needCompanyTitle': 'Select a company first',
    'recon.needCompanyBody': 'Choose PT JGI or JGT to load reconciliation data, suggestions, and balances below.',
    'recon.gateKicker': 'Reconciliation workspace',
    'recon.gateStep1': 'Pick a company (JGI / JGT)',
    'recon.gateStep2': 'Set the period (month / 30 days / year)',
    'recon.gateStep3': 'Match book left ↔ statement right',
    'recon.gateRecent': 'Last used',
    'recon.quickPeriods': 'Quick periods',
    'recon.periodToday': 'Today',
    'recon.periodMonth': 'This month',
    'recon.pickMonth': 'Month',
    'recon.pickMonthPlaceholder': 'January – December',
    'recon.pickMonthHint':
      'Pick a month: from the 1st through today’s day number in that month.',
    'recon.period30': '30 days',
    'recon.periodYear': 'Year {year}',
    'recon.periodCustom': 'Custom',
    'recon.coachKicker': 'Desk tips',
    'recon.coachTitle': 'Fast reconciliation workflow',
    'recon.coachBody':
      'Select a book row on the left, a statement on the right, then Match/Reject. Use the focus queue for high risk.',
    'recon.coachTip1': 'j / k — focus queue',
    'recon.coachTip2': 'Enter — match · x — reject',
    'recon.coachTip3': 'u — undo last action',
    'recon.coachTip1Mobile': 'Tap a book row in the panel below',
    'recon.coachTip2Mobile': 'Tap a statement row, then Match',
    'recon.coachTip3Mobile': 'Use Undo if you matched the wrong pair',
    'recon.expandBoards': 'Expand boards',
    'recon.collapseBoards': 'Collapse',
    'recon.boardsFsTitle': 'Reconciliation boards — fullscreen',
    'recon.taskFeedTitle': '{n} task alerts · {pt}',
    'recon.sub': 'Left = booked · Right = new statements · match without double posting',
    'recon.refresh': 'Refresh',
    'recon.matchLow': 'Match all low risk ({n})',
    'recon.export': 'Export Excel',
    'recon.undo': 'Undo',
    'recon.ruleBuilder': 'Rule builder',
    'recon.advanced': 'Settings',
    'recon.toolsMenu': 'Export & tools',
    'recon.matchGroup': 'Match group',
    'recon.reject': 'Reject',
    'recon.partial': 'Partial match',
    'recon.unmatch': 'Unmatch',
    'recon.newRule': '+ New rule',
    'recon.quickJournal': '+ Quick journal',
    'recon.eStatement': '+ E-Statement',
    'recon.leftTitle': 'Left · Already booked',
    'recon.rightTitle': 'Right · Newly arrived',
    'recon.kpiMatched': 'Reconciled',
    'recon.kpiBookOpen': 'Unmatched books',
    'recon.kpiStmtOpen': 'Unmatched statements',
    'recon.kpiDiff': 'Difference',
    'recon.kpiRisk': 'Risk',
    'recon.kpiAging': 'Aging statements',
    'recon.presetAging': 'Aging',
    'recon.presetHigh': 'High risk',
    'recon.presetPartial': 'Partial remainder',
    'recon.presetMonth': 'This month',
    'recon.saveFilter': 'Save this filter',
    'recon.emptyBook': 'No open booked items',
    'recon.emptyStmt': 'No open new statements',
    'recon.emptyPairs': 'No queue or pairs yet.',
    'recon.emptyHistory': 'No action history yet.',
    'recon.emptyRules': 'No rules yet.',
    'recon.sameBank': 'Require same bank account',
    'recon.bankMode': 'Bank balance mode',
    'recon.dateWindow': 'Date window',
    'recon.amountTol': 'Amount tolerance',
    'recon.compareTitle': 'Duplicate comparison',
    'recon.compareStudio': 'Anti-duplicate · Compare studio',
    'recon.confirmDiffDir': 'Transaction direction differs',
    'recon.confirmDirLead': 'Amounts match, but in/out direction differs between books and statement.',
    'recon.confirmDirPoint1': 'First check: is this the same transaction, only posted the wrong way?',
    'recon.confirmDirPoint2': 'If it is the wrong pair (not the same transaction) — cancel, do not match.',
    'recon.confirmDirPoint3': 'If you are sure it is the same pair — click “Yes, match anyway”.',
    'recon.sideUnknown': 'Direction unclear',
    'recon.confirmMatchLow': 'Match all low-risk items?',
    'recon.confirmSaveFilter': 'Save current filter',
    'recon.snackMatched': 'Matched successfully — not a double post',
    'recon.snackRejected': 'Rejected → added to history',
    'recon.snackPartial': 'Partial match saved',
    'recon.snackBatch': 'Batch done: {m} matched, {f} failed',
    'recon.snackExcel': 'Excel downloaded',
    'recon.pickPair': 'Select 1 left row + 1 right row',
    'recon.keyboard': 'Keyboard:',
    'recon.history': 'History',
    'recon.rules': 'Rules',
    'recon.suggestions': 'Suggestions',
    'recon.suggestionsHint': '{n} pairs ready to review',
    'recon.suggestionsBadge': 'ready',
    'recon.bulkSelectPage': 'Select this page',
    'recon.bulkPicked': '{n} selected',
    'recon.bulkMatch': 'Match selected',
    'recon.bulkReject': 'Reject selected',
    'recon.bulkPickFirst': 'Check suggestions first',
    'recon.perPage': '{n}/page',
    'recon.pageOf': 'Page {page}/{pages}',
    'recon.actions': 'Actions',
    'recon.emptySuggestionsFilter': 'No suggestions for this filter',
    'recon.snackBulkMatch': 'Bulk match: {m} ok, {f} failed',
    'recon.snackBulkReject': 'Bulk reject: {m} ok, {f} failed',
    'recon.bulkDirTitle': 'Direction differs in selection',
    'recon.bulkDirLead': '{n} pairs selected — some debit/credit directions do not match.',
    'recon.bulkDirPoint1': 'Make sure these are not wrong pairs before bulk matching.',
    'recon.bulkDirPoint2': 'If sure, continue. If unsure, cancel and review one by one.',
    'recon.bulkDirConfirm': 'Yes, match all selected',
    'recon.amountGroups': 'Amounts',
    'recon.amountGroupsHint': 'Click a chip → see all open transactions at that amount',
    'recon.amountGroupTip': '{amount}: {left} books · {right} statements open',
    'recon.amountFilterOn': 'Filter {amount}: {sug} suggestions · {left} books · {right} statements',
    'recon.amountFilterOff': 'Amount filter cleared',
    'recon.amountFilterBanner': 'Active filter: {amount}',
    'recon.amountFilterCounts': '{sug} suggestions · {left} in books · {right} in statement',
    'recon.amountFilterNoSugHint':
      'No automatic suggestion yet. Compare the lists below, or record missing book entries first.',
    'recon.amountFilterNoneLeft': 'Nothing in books yet — record it via the posting links',
    'recon.amountFilterNoneRight': 'Nothing in statement yet — upload / check e-statement',
    'recon.amountFilterGoBoards': 'View left/right queues',
    'recon.amountOpenTitle': 'Open {amount}',
    'recon.amountOpenHint': 'Click a row to fill the Match area',
    'recon.amountExplainNeedBook':
      'Statement: {right} · Books: {left}. Gap of {gap} is likely not recorded in books yet.',
    'recon.amountExplainNeedStmt':
      'Books: {left} · Statement: {right}. Gap of {gap} is likely missing from statement.',
    'recon.amountExplainEqual':
      'Same count ({left}↔{right}). Check dates & descriptions before Match.',
    'recon.amountExplainEmpty': 'No open transactions for {amount}.',
    'recon.amountOpenTip': 'Click a row → Match area. Missing records? use Quick journal / E-Statement links.',
    'recon.linkQuickJournal': 'Quick journal',
    'recon.linkQuickJournalHint': 'Record transactions not yet in the books',
    'recon.linkJournalEntry': 'Manual journal',
    'recon.linkJournalEntryHint': 'Full journal entry in a new tab',
    'recon.linkStatements': 'E-Statement',
    'recon.linkStatementsHint': 'Upload / check bank statement',
    'recon.match': 'Match',
    'recon.filter': 'Filter',
    'recon.inbox': 'Smart inbox',
    'recon.riskLow': 'safe',
    'recon.riskMed': 'review',
    'recon.riskHigh': 'risky',
    'recon.chipAging': '{n} long unmatched',
    'recon.chipDup': '{n} possible duplicates',
    'recon.srcStatement': 'Statement',
    'recon.srcQuick': 'Quick',
    'recon.srcManual': 'Manual',
    'recon.balBalanced': 'Balanced — books = statement',
    'recon.balBookHigher': 'Books higher than statement',
    'recon.balStmtHigher': 'Statement higher than books',
    'recon.balTitle': 'Bank balance — books vs statement',
    'recon.balBook': 'Books',
    'recon.balStmt': 'Statement',
    'recon.balMatched': 'Already matched',
    'recon.balDiffLabel': 'Difference (books − stmt)',
    'recon.dateWindowDays': 'Date window: ±{n} days',
    'recon.amountTolRp': 'Amount tolerance: Rp {n}',
    'recon.leftSub': 'Quick Journal / Manual — clear debit & credit',
    'recon.rightSub': 'E-Statement / Import — shows file origin & bank',
    'recon.kbNav': 'navigate',
    'recon.kbSwitch': 'switch side',
    'recon.kbMatch': 'match',
    'recon.kbReject': 'reject',
    'recon.kbPartial': 'partial',
    'recon.kbGroup': 'group',
    'recon.kbPick': 'pick suggestion/candidate',
    'recon.kbUndo': 'undo',
    'recon.kbClear': 'clear',
    'recon.savedFilters': 'Saved filters:',
    'recon.resetFilter': 'Reset filter',
    'recon.uploadStmt': 'Upload statement',
    'recon.queueRight': '{n} queued right',
    'recon.inboxHubMeta': 'match · anti-duplicate',
    'recon.quickDC': 'Quick Debit/Credit',
    'recon.queueLeft': '{n} queued left',
    'recon.cleanReport': 'Clean reports',
    'recon.pctMatched': '{n}% matched',
    'recon.matchPct': '{n}% match',
    'recon.inboxTipDefault': 'All new movements are verified here before they are final.',
    'recon.dupGroups': '{g} potential duplicate groups · {n} flagged rows',
    'recon.dupHint': 'Compare in the studio below before matching — avoid duplicate reports.',
    'recon.openCompare': 'Open Compare',
    'recon.book': 'Books',
    'recon.statement': 'Statement',
    'recon.colRef': 'Ref',
    'recon.colDesc': 'Description',
    'recon.colOrigin': 'Origin / source',
    'recon.colAction': 'Action',
    'recon.pick': 'Select',
    'recon.voidDouble': 'Void duplicate',
    'recon.compareHint':
      'Tip: pick 1 valid row to match against the other side, then Reject the duplicate so it is not reported twice.',
    'recon.agingAlert': '{n} statements unmatched > 30 days',
    'recon.agingHint': 'Prioritize aging rows so reconciliation does not pile up.',
    'recon.agingOldest': 'Oldest: {days} days · {desc}',
    'recon.gateClick': 'Click to load workspace',
    'recon.checkTitle': 'Work checklist',
    'recon.checkLow': 'Match low risk ({n})',
    'recon.checkAging': 'Clear 30+ aging ({n})',
    'recon.checkHigh': 'Review high risk ({n})',
    'recon.checkDup': 'Compare duplicates ({n})',
    'recon.chipAge07': '{n} aging 0–7d',
    'recon.chipAge830': '{n} aging 8–30d',
    'recon.seeAllTasks': 'See all {n} in Suggestions',
    'recon.pairDays': '{n}-day gap',
    'recon.ageDays': 'Aging {n} days',
    'recon.partialRemain': 'Left {remain} · used {used}',
    'recon.emptyActivityHint': 'After Match / Reject, actions show up here.',
    'recon.emptyPairsHint':
      'Upload & save an e-statement so rows appear under New (source). Matches/rejects are recorded in the same table.',
    'recon.startFromSaran': 'Start from suggestions',
    'recon.tlMatch': 'Match',
    'recon.tlStmtInbox': 'E-statement queued',
    'recon.statusQueuedStmt': 'Statement queue',
    'recon.statusQueuedBook': 'Book queue',
    'recon.waitingBook': 'Waiting for booked data (Quick Journal)',
    'recon.waitingStmt': 'Waiting for e-statement',
    'recon.gotoMatch': 'Match',
    'recon.tlReject': 'Reject',
    'recon.tlUndo': 'Undo',
    'recon.tlReopen': 'Reopen',
    'recon.tlRelease': 'Release',
    'recon.tlUnmatch': 'Unmatch',
    'recon.tlPartial': 'Partial',
    'recon.tlGroup': 'Group',
    'recon.tlBatch': 'Batch match',
    'recon.deskMode': 'Desk mode',
    'recon.modeWork': 'Work',
    'recon.modeReview': 'Review',
    'recon.focusTitle': 'Today focus queue',
    'recon.focusReviewTitle': 'Review queue (risk / aging)',
    'recon.focusMeta': '{high} high · {aging} aging · {n} total',
    'recon.focusPrev': 'Prev',
    'recon.focusNext': 'Next',
    'recon.focusOpen': 'Open',
    'recon.kbQueue': 'queue',
    'recon.batchPreviewHint': 'Preview {n} safe pairs (highest score first):',
    'recon.batchPreviewEmpty': 'No low-risk pairs to preview.',
    'recon.batchRun': 'Run {n} matches',
    'recon.historyHub': 'History',
    'recon.density': 'Density',
    'recon.exportAging': 'Aging CSV',
    'recon.copyDigest': 'Copy digest',
    'recon.exportAgingEmpty': 'No statements aging > 7 days',
    'recon.exportAgingOk': 'Aging CSV downloaded ({n} rows)',
    'recon.digestCopied': 'Digest summary copied',
    'recon.noteRequired': 'Add a note first for medium/high risk',
    'recon.noteRequiredMark': 'required',
    'recon.notePlaceholderRequired': 'Required: match / reject reason…',
    'recon.noteTplSameAmt': 'Same amount',
    'recon.noteTplDirDiff': 'Direction differs — checked',
    'recon.noteTplFee': 'Bank fee / small gap',
    'recon.noteTplPartial': 'Partial / remainder',
    'recon.noteTplChecked': 'Already verified',
    'recon.lockTaken': 'Being reviewed by {user}',
    'recon.lockMine': 'You hold this review · {user}',
    'recon.lockBlocked': 'Locked by {user} — wait or pick another pair',
    'recon.pinPreset': 'Pin PT filter',
    'recon.pinPresetNeed': 'Select a saved filter first',
    'recon.pinPresetOk': 'Filter pinned for {pt}',
    'recon.confTitle': 'Confidence',
    'recon.confAmount': 'Amount',
    'recon.confDate': 'Date',
    'recon.confDir': 'Direction',
    'recon.confBank': 'Bank',
    'recon.confWarn': 'Warnings',
    'recon.emptyBookHint':
      'Left panel = unmatched Quick/Manual journals. Uploading an e-statement fills the right panel — post books via Quick Journal to match.',
    'recon.emptyStmtHint':
      'Right panel = saved e-statement rows in the recon queue. Upload & save an e-statement, then return here — rows appear automatically.',
    'recon.bankFilterCleared': 'Bank filter cleared so all statements in this period can show.',
    'recon.ruleSub': 'Boost/prefer pair scoring by text pattern, side, and bank',
    'recon.pattern': 'Pattern',
    'recon.matchType': 'Match type',
    'recon.preferSide': 'Prefer side',
    'recon.boost': 'Boost',
    'recon.bankCode': 'Bank code',
    'recon.active': 'Active',
    'recon.saveChanges': 'Save changes',
    'recon.addRule': 'Add rule',
    'recon.emptyRulesHint': 'No rules yet. Add one to steer automatic scoring.',
    'recon.matchContains': 'Contains',
    'recon.matchStarts': 'Starts with',
    'recon.matchRegex': 'Regex',
    'recon.sideAny': 'Any',
    'recon.sideIn': 'In',
    'recon.sideOut': 'Out',
    'recon.groupCandidates': 'Group candidates 1↔N / N↔1',
    'recon.group1n': '1 book → N stmt',
    'recon.groupN1': 'N books → 1 stmt',
    'recon.bookCount': 'Books ({n})',
    'recon.stmtCount': 'Statement ({n})',
    'recon.totalLabel': 'Total: {n}',
    'recon.filterActive': 'Filter active',
    'recon.bookedLabel': 'Already booked',
    'recon.directionDiff': 'Direction differs',
    'recon.splitLike': 'Split-like',
    'recon.newOrigin': 'New · {origin}',
    'recon.pickedLeft': 'Selected left (books)',
    'recon.pickedRight': 'Selected right (statement)',
    'recon.clickLeft': '— click a left row —',
    'recon.clickRight': '— click a right row —',
    'recon.dockTitle': 'Match workspace',
    'recon.dockSubEmpty': 'Empty slots below are ready — click a left/right row to land it here.',
    'recon.dockSubEmptyMobile': 'Tap a book or statement row below to fill these slots.',
    'recon.dockSubActive': 'Compare the pair, then choose Match / Release / Reject.',
    'recon.dockClose': 'Close & clear selection',
    'recon.dockDropLeft': 'Clicked book rows will appear here',
    'recon.dockDropRight': 'Clicked statement rows will appear here',
    'recon.dockBridgeHint': 'Will connect',
    'recon.dockGuide1': 'Click 1 row in the left panel (already booked).',
    'recon.dockGuide2': 'Click 1 row in the right panel (bank statement).',
    'recon.dockGuide1Mobile': 'Tap 1 row in the Book panel (already booked).',
    'recon.dockGuide2Mobile': 'Tap 1 row in the Statement panel.',
    'recon.dockGuide3': 'Review the comparison, then Match / Reject.',
    'recon.dockCompareTitle': 'Detail comparison',
    'recon.diffOk': 'Match',
    'recon.diffWarn': 'Close',
    'recon.diffBad': 'Differs',
    'recon.nSelected': '{n} selected',
    'recon.pairReady': 'Ready to match',
    'recon.pairDirDiff': 'Amount OK · direction differs',
    'recon.pairAmtDiff': 'Amount differs',
    'recon.originLabel': 'Origin: {origin}',
    'recon.matchToReport': 'Match → Report',
    'recon.releaseToReport': 'Release to report',
    'recon.matchGroup1n': 'Match group 1↔N',
    'recon.decideTitle': 'Choose an action',
    'recon.actionMatchName': 'Match',
    'recon.actionMatchShort': 'Pair book ↔ statement',
    'recon.actionMatchDesc':
      'Match = same pair. Both sides are linked as one reconciliation, leave the queue, and enter reports as matched (not a double).',
    'recon.actionReleaseName': 'Release',
    'recon.actionReleaseShort': 'Send to report without a pair',
    'recon.actionReleaseDesc':
      'Release = no pair, but still go to reports. Use when the transaction is valid but has no matching statement/book partner.',
    'recon.actionRejectName': 'Reject',
    'recon.actionRejectShort': 'Not the same pair',
    'recon.actionRejectDesc':
      'Reject = not a pair. Saved in reject history so it is not suggested again. Items stay in the queue until matched/released correctly.',
    'recon.actionGroupShort': 'One-to-many / many-to-one',
    'recon.dockCompareHint': 'Green = same · Yellow = close · Red = differs — review before Match',
    'recon.diffStatus': 'Status',
    'recon.clear': 'Clear',
    'recon.notePlaceholder': 'Write match / reject note here…',
    'recon.noteHint': 'Drag the bottom-right corner to resize. Saved when you Match or Reject.',
    'recon.partialHint': 'Amount differs — partial match:',
    'recon.field': 'Field',
    'recon.diffLeft': 'Left (books)',
    'recon.diffRight': 'Right (statement)',
    'recon.direction': 'Direction',
    'recon.topRight': 'Top right candidates',
    'recon.topLeft': 'Top left candidates',
    'recon.onlyDupWarnings': 'Duplicate warnings only',
    'recon.multiSelected': 'Left: {l} · Right: {r} selected',
    'recon.leftEyebrow': 'Books · Quick/Manual inbox',
    'recon.leftPanelTitle': 'Booked data',
    'recon.leftPanelHint': 'Click a row → fill Match area as the book side',
    'recon.rightEyebrow': 'Statement · Upload inbox',
    'recon.rightPanelTitle': 'New funds + origin',
    'recon.rightPanelHint': 'Click a row → fill Match area as the statement side',
    'recon.rangeOf': '{from}–{to} of {total}',
    'recon.searchLeft': 'Search date / description / amount…',
    'recon.searchRight': 'Search origin / bank / amount…',
    'recon.colSource': 'Source origin',
    'recon.prev': '‹ Prev',
    'recon.next': 'Next ›',
    'recon.timeline': 'Action timeline',
    'recon.undoLast': 'Undo last action',
    'recon.emptyActivity': 'No activity yet.',
    'recon.fullHistory': 'Full history',
    'recon.eventPage': '{n} events · 100 / page',
    'recon.historySub': 'All actions recorded: date · month · year · time · from → to changes',
    'recon.colWhen': 'When',
    'recon.colActionLabel': 'Action',
    'recon.colFromTo': 'From → To',
    'recon.colDetail': 'Detail',
    'recon.colBy': 'By',
    'recon.pairsTitle': 'Queue & pairs',
    'recon.pairsSub':
      'Queued e-statement / book rows waiting to match, plus match & reject results. After sending an e-statement, rows appear here.',
    'recon.colStatus': 'Status',
    'recon.colBooked': 'Already booked',
    'recon.colNew': 'New (origin)',
    'recon.statusMatched': 'Match',
    'recon.statusRejected': 'Rejected',
    'recon.kindPartial': 'Partial',
    'recon.kindGroup': 'Group',
    'recon.editAgain': 'Edit again',
    'recon.confirmMatchBtn': 'Yes, match anyway',
    'recon.batchMatchBody':
      'Will match {n} low-risk pairs (no direction conflict) at once. High/medium stay manual.',
    'recon.bankFilterChip': 'Bank {code}',
    'recon.clearBankFilter': 'Clear bank filter',
    'recon.run': 'Run',
    'recon.filterName': 'Filter name',
    'recon.snackFilterSaved': 'Filter saved',
    'recon.snackPatternRequired': 'Rule pattern is required',
    'recon.snackRuleUpdated': 'Rule updated',
    'recon.snackRuleAdded': 'Rule added',
    'recon.snackRuleSaveFail': 'Failed to save rule',
    'recon.snackRuleDeleted': 'Rule deleted',
    'recon.snackRuleDeleteFail': 'Failed to delete rule',
    'recon.confirmDirMsg':
      'Debit/credit direction differs between books and statement. Are you sure this is the same pair (not a mis-post)?',
    'recon.snackMatchFail': 'Match failed',
    'recon.pickPairFirst': 'Select a pair first',
    'recon.rejectNote': 'Rejected — not a pair',
    'recon.confirmVoid': 'Void journal #{id}? This row leaves the queue and will not appear in reports.',
    'recon.voidReason': 'Duplicate in reconciliation — anti double report',
    'recon.snackVoided': 'Journal #{id} voided',
    'recon.snackVoidFail': 'Void failed',
    'recon.pickToRelease': 'Select rows first to release to reports',
    'recon.confirmRelease': 'Release {n} journals to reports without a pair?',
    'recon.releaseNote': 'Manual release to reports',
    'recon.snackReleased': '{n} journals released to reports',
    'recon.snackPartialAmount': 'Enter a valid partial amount',
    'recon.snackPartialFail': 'Partial match failed',
    'recon.pickGroupPattern': 'Select 1 single side + other side ≥2 (1↔N or N↔1 pattern)',
    'recon.snackGroupMatch': 'Group match: {n} pairs · total {total}',
    'recon.snackGroupFail': 'Group match failed',
    'recon.snackUnmatched': 'Unmatched — ready to rematch',
    'recon.snackReopened': 'Reopened from history',
    'recon.snackBatchFail': 'Batch failed',
    'recon.snackExportFail': 'Export failed',
    'recon.snackUndo': 'Undo: {action} ({n} rows)',
    'recon.snackUndoEmpty': 'Nothing to undo',
    'recon.debitCredit': 'Debit {d} · Credit {c}',

    'ptGate.kicker': 'Required step',
    'ptGate.stepLabel': 'Step 1 · Choose company',
    'ptGate.kickerReady': 'Target active',
    'ptGate.title': 'Pick target company',
    'ptGate.titleReady': 'Company {pt} selected',
    'ptGate.body':
      'Upload, parse, and add-row unlock after a company is selected. Each PT stays separate.',
    'ptGate.readyBody': 'Uploads & new rows go to {pt}. Switch anytime if needed.',
    'ptGate.readySub': 'Active target: {code}',
    'ptGate.pickSub': 'Click a company below, or add a new one.',
    'ptGate.chooseHint': 'Click one',
    'ptGate.chipAction': 'Select',
    'ptGate.chipSelected': 'Selected',
    'ptGate.change': 'Change',
    'ptGate.hide': 'Hide',
    'ptGate.placeholder': 'Company code…',
    'ptGate.empty': 'No companies yet. Add one first.',
    'ptGate.addPt': 'Add company',
    'ptGate.needPt': 'Select a company before upload, drag-drop, or adding rows.',
    'ptGate.needPtSave': 'Select a company before saving.',
    'ptGate.needPtRows': '{n} rows have no company — pick a target or fill the PT column.',
    'ptGate.dropLocked': 'Select a company above — then drop or pick files.',

    'bankDesk.label': 'Bank desk flow',
    'bankDesk.kicker': 'Bank desk',
    'bankDesk.title': 'Linear bank flow',
    'bankDesk.sub': 'Import → classify → reconcile → cash position',
    'bankDesk.stepImport': 'Import statements',
    'bankDesk.stepImportHint': 'Download & upload e-statements',
    'bankDesk.stepClassify': 'Classify',
    'bankDesk.stepClassifyHint': 'Review & post journals',
    'bankDesk.stepRecon': 'Reconcile',
    'bankDesk.stepReconHint': 'Match books vs bank',
    'bankDesk.stepCash': 'Cash position',
    'bankDesk.stepCashHint': 'Balances & account gaps',
    'stmt.kicker': 'E-statement download hub',
    'stmt.title': 'Smart E-Statement',
    'stmt.sub':
      'Download by bank · 1 week / 2 weeks / 1 month · year & month · Excel & CSV',
    'stmt.dlKicker': 'Download hub',
    'stmt.dlTitle': 'Download e-statements',
    'stmt.dlSub': 'Active period: {period}',
    'stmt.dlPickBank': 'Pick banks you already have',
    'stmt.dlBankMine': 'Yours',
    'stmt.dlBankMineEmpty': 'No account number yet — fill in Bank Accounts',
    'stmt.dlPickPeriod': 'Pick period',
    'stmt.dlWeek1': '1 week',
    'stmt.dlWeek2': '2 weeks',
    'stmt.dlMonth1': '1 month',
    'stmt.dlYearMonth': 'Year & month',
    'stmt.dlCustom': 'Date range',
    'stmt.dlAllBanks': 'All banks',
    'stmt.dlExcel': 'Download Excel',
    'stmt.dlCsv': 'Download CSV',
    'stmt.dlPdf': 'Download PDF',
    'stmt.dlZip': 'ZIP multi-bank',
    'stmt.dlThisMonth': 'This month',
    'stmt.dlLastMonth': 'Last month',
    'stmt.dlYtd': 'YTD',
    'stmt.dlQ1': 'Q1',
    'stmt.dlQ2': 'Q2',
    'stmt.dlQ3': 'Q3',
    'stmt.dlQ4': 'Q4',
    'stmt.dlStatRows': 'Rows',
    'stmt.dlStatDebit': 'Debit',
    'stmt.dlStatCredit': 'Credit',
    'stmt.dlStatNet': 'Net',
    'stmt.dlPreviewTitle': 'Mutation preview',
    'stmt.dlBankBreak': 'Per-bank breakdown',
    'stmt.dlEmptyTitle': 'No mutations',
    'stmt.dlEmptyHint':
      'No mutations for this filter — widen the period, switch bank, or pick All banks.',
    'stmt.dlPreviewFail': 'Failed to load download preview',
    'stmt.dlTruncWarn':
      'Data truncated at {n} rows. Narrow the period or download per bank / ZIP multi-bank.',
    'stmt.dlDoneTrunc':
      '{format} downloaded · file may be truncated near ~{n} rows — narrow the period for a full set',
    'stmt.dlHistoryTitle': 'Download history',
    'stmt.dlHistoryEmpty': 'No downloads on this device yet.',
    'stmt.dlHistoryClear': 'Clear history',
    'stmt.dlAgain': 'Download again',
    'stmt.dlHint':
      'Excel includes Cover + Mutations + Summary (running balance, direction, recon, entity). ZIP = one file per bank. Upload new e-statements from the panel above.',
    'stmt.dlDone': 'E-statement {format} ready · {period}',
    'stmt.dlHeroCta': 'Download now',
    'stmt.uploadMoreTitle': 'Upload e-statement (bank / credit card)',
    'stmt.uploadMoreSub':
      'Drop PDF, Excel, ZIP, or images — Rekening for bank, Kartu kredit for CC. History rows below are read-only.',
    'stmt.uploadHeroCta': 'Open upload',
    'stmt.histUploadCta': 'Upload new e-statement',
    'stmt.needCcSlot': 'Switch to the Credit card channel first (CC payable slot).',
    'stmt.periodLast14': 'Last 14 days',
    'stmt.legacyExcel': 'Legacy Excel',
    'stmt.opening': 'Opening balance',
    'stmt.lk': 'Financial statements',
    'stmt.dropTitle': 'Drop multiple files here',
    'stmt.toolbarUpload': 'File queue',
    'stmt.toolbarReview': 'After review',
    'stmt.dropActive': 'Release to add to the queue…',
    'stmt.pickFiles': 'Choose files',
    'stmt.pickFilesMulti': 'Choose files (multi-select)',
    'stmt.process': 'Process upload ({n})',
    'stmt.processFabHint': 'Next step ↓',
    'stmt.uploadProgressTitle': 'Processing e-statement',
    'stmt.uploadPhaseUpload': 'Uploading files',
    'stmt.uploadPhaseParse': 'Reading PDF & extracting rows',
    'stmt.uploadPhaseAi': 'Mapping accounts',
    'stmt.uploadPhaseDone': 'Done',
    'stmt.uploadSecondsLeft': '~{n}s remaining',
    'stmt.uploadFileCount': '{n} file(s)',
    'stmt.uploadAlmost': 'Almost done…',
    'stmt.uploadElapsed': '{done} / {total}',
    'stmt.uploadStepUpload': 'Upload',
    'stmt.uploadStepParse': 'Parse',
    'stmt.uploadStepAi': 'AI',
    'stmt.uploadStepDone': 'Done',
    'stmt.uploadBytes': '{loaded} / {total}',
    'stmt.uploadFilesDone': '{done}/{total} files',
    'stmt.uploadRowsFound': '{n} rows',
    'stmt.aiSkipOn': 'Fast · AI later',
    'stmt.aiSkipOff': 'AI on upload',
    'stmt.aiSkipHint': 'Skip AI during upload — show review first, enrich in background',
    'stmt.aiBgStart': 'AI running in background…',
    'stmt.aiBgDone': 'AI done · {n} rows enriched',
    'stmt.aiBgRunning': 'AI running…',
    'stmt.aiBgQueued': 'AI queued',
    'stmt.clearQueue': 'Clear',
    'stmt.tabMutasi': 'Lines & mapping',
    'stmt.tabBalance': 'Balance match',
    'stmt.tabRules': 'Rules editor',
    'stmt.tabMemory': 'Memory',
    'stmt.tabLk': 'FS → Opening balance',
    'stmt.rows': 'Rows',
    'stmt.selected': 'Selected',
    'stmt.allBanks': 'All banks',
    'stmt.mapSource': 'Map source',
    'stmt.pickFilter': 'Pick filter',
    'stmt.filterBar': 'Filter & selection',
    'stmt.bulkChecked': 'Bulk checked',
    'stmt.cashBank': 'Cash/Bank',
    'stmt.pickBankTitle': 'Select bank account',
    'channel.rekening': 'Bank Account',
    'channel.cc': 'Credit Card',
    'channel.smartUploadRekening': 'Smart Bank Upload',
    'channel.smartUploadCc': 'Smart Credit Card Upload',
    'channel.smartUploadRekeningSub': 'E-statements & bank movements — BCA, Mandiri, BNI, shared DBS.',
    'channel.smartUploadCcSub': 'Credit card charges — auto HPP allocation.',
    'channel.rekeningHint': 'Upload bank e-statements — pick company then BCA, Mandiri, BNI, or shared DBS.',
    'channel.ccHint': 'Upload credit card charges — counter accounts filtered to COGS/expense; HPP allocation on.',
    'channel.dbsShared': '50:50',
    'channel.ccLock': 'CC payable · {code}',
    'cls.label': 'Classify as',
    'cls.defaultLabel': 'Default on upload',
    'cls.defaultPick': 'Pick default classification',
    'cls.defaultHint': 'Change per row after upload — choose Custom for manual account pick.',
    'cls.inflow': 'Money in',
    'cls.outflow': 'Money out',
    'cls.autoFlow': 'Auto (from movement)',
    'cls.groupIn': 'Money in',
    'cls.groupOut': 'Money out',
    'cls.groupCc': 'Credit card',
    'cls.groupManual': 'Manual',
    'cls.dp': 'Customer deposit / DP',
    'cls.ar': 'AR collection',
    'cls.revenue': 'Service revenue',
    'cls.bunga': 'Bank interest',
    'cls.ownerIn': 'Owner payable (deposit in)',
    'cls.ownerOut': 'Owner / related party receivable',
    'cls.internal': 'Internal transfer',
    'cls.prepaid': 'Prepaid expense',
    'cls.ap': 'Pay AP / supplier',
    'cls.admin': 'Bank admin fee',
    'cls.gaji': 'Salaries & allowances',
    'cls.bpjs': 'BPJS contributions',
    'cls.server': 'Server / IT expense',
    'cls.perlengkapan': 'Office supplies',
    'cls.perjamuan': 'Business entertainment',
    'cls.opex': 'Other operating expense',
    'cls.hpp': 'COGS (HPP)',
    'cls.custom': 'Custom — manual account',
    'stmt.bankQuickPick': 'Quick bank pick',
    'stmt.sharedMode': 'Shared (DBS / Credit Card)',
    'stmt.sharedHint': 'No company — balance split 50:50 JGI & JGT on consolidated reports.',
    'stmt.sharedBankOnly': 'Shared mode is only for DBS (1004) or Credit Card (2700).',
    'stmt.queueNeedBank': '{n} files queued — pick a bank account first, then Process.',
    'stmt.queueReadyHint': '{n} files queued — pick account then Process upload',
    'stmt.filterCount': 'Showing {shown} of {total} rows · {period}',
    'stmt.savedLinks': 'Saved to journal — continue:',
    'stmt.savedLinksPending': 'Saved · ready on the recon desk:',
    'stmt.openJournal': 'General journal',
    'stmt.toReconBatch': 'Open reconciliation',
    'stmt.stepPt': 'Company / Shared',
    'stmt.stepBank': 'Account',
    'stmt.stepQueue': 'File queue',
    'stmt.stepReview': 'Review rows',
    'stmt.stepSave': 'Save',
    'stmt.uploadPhaseRead': 'Reading local files…',
    'stmt.uploadFileProgress': 'File {current}/{total} · {name}',
    'stmt.snackBalanceMismatch': 'Balance mismatch: {ok} OK · {bad} off — fix in Balance tab',
    'stmt.balanceGateBanner': 'Account balance: {ok} matched · {bad} mismatch — save blocked until reviewed',
    'stmt.viewBalance': 'View balance',
    'stmt.ccPoolTitle': 'Credit card charge pool',
    'stmt.ccPoolSub': 'Proportional COGS split JGI/JGT — not per-line CC journals',
    'wizard.checkBank': 'Bank ready',
    'wizard.checkFiles': 'Files ready',
    'wizard.checkReviewOk': 'Review clean',
    'wizard.checkReviewWarn': '{n} rows need review',
    'wizard.checkBalanceOk': '{n} balances matched',
    'wizard.checkBalanceWarn': '{n} balance mismatch',
    'wizard.checkBalanceNa': 'Balance not checked yet',
    'wizard.shortcutsHint': 'Ctrl+Enter save · Ctrl+Shift+Enter process · 1–7 lanes · A needs review',
    'stmt.draftBannerTitle': 'Saved review — continue from last session',
    'stmt.draftDiscard': 'Discard draft',
    'stmt.draftDiscarded': 'Review draft cleared',
    'stmt.draftPendingTitle': 'Saved review found — load to continue',
    'stmt.draftLoaded': 'Loaded {n} review rows',
    'stmt.draftRestored': 'Restored {n} rows · {time}',
    'stmt.draftDurableHint':
      'Draft is per company · kept ≤7 days — switching bank/CC keeps rows; use chips to focus a bank.',
    'stmt.draftBankAny': 'all banks',
    'stmt.draftOtherLabel': 'Other company drafts:',
    'stmt.draftFilterBank': 'Filter → {bank} (draft kept intact)',
    'stmt.queueBankFocus': 'Highlight {n} file(s) · {bank}',
    'stmt.autoPickBank': 'Auto-selected bank: {bank} (from filename)',
    'stmt.bankBreakdown': 'Per-bank summary',
    'stmt.histSourcesKicker': 'E-statement sources',
    'stmt.histSourcesTitle': 'All sources ever uploaded',
    'stmt.histSourcesSub':
      'Green buttons = data exists for {year}. Click to load history mutations into the review table (no re-upload).',
    'stmt.histEmpty': 'empty',
    'stmt.histLoaded': '{n} mutations from e-statement history {year} loaded into the table',
    'stmt.histLoadedCapped':
      '{n} of {total} history rows for {year} loaded (capped to keep the page responsive)',
    'stmt.histLoadFail': 'Failed to load e-statement history',
    'stmt.histDashTitle': 'E-statement history',
    'stmt.histInsight':
      '{n} previously uploaded & saved mutations for {year} — shown immediately without re-uploading.',
    'stmt.histMixedInsight':
      '{live} new session rows · {posted} from history · {files} uploaded file(s).',
    'stmt.histBrowseHint':
      '{n} history mutations for {year} are already saved (Posted). This is not the upload queue — click “Upload new e-statement” for bank or credit card.',
    'stmt.histMixedHint':
      '{live} new rows ready to review · {posted} history rows (Posted) are browse-only and will not be saved again.',
    'stmt.mapPosted': 'Posted',
    'stmt.mapConfTitle': 'Confidence mapping {pct}%',
    'stmt.autoScanKicker': 'Auto scan',
    'stmt.autoScanTitle': 'Bank / credit-card detection result',
    'stmt.autoScanSub': 'The system scans files right after upload — no extra command needed.',
    'stmt.mixedBankHint': 'Multiple banks detected — click a chip to filter.',
    'stmt.bankModeDetect': 'Follow file detection',
    'stmt.bankModeSlot': 'Force selected account',
    'stmt.bankModeDetectHint':
      'Each file keeps its bank from PDF/filename. Selected slot is only a fallback for unclear files.',
    'stmt.queueBankSplit': 'Queue: {parts}',
    'stmt.queueBanksLabel': 'Queue banks',
    'stmt.queueBankSplitLine': '{n} → {bank}',
    'stmt.queueBankUnknown': '{n} unclear',
    'stmt.mixedBankSplitDone': 'Multi-bank batch: {summary}',
    'stmt.mixedBankAutoDetect': 'Multiple banks in queue — follow-file-detection mode on.',
    'stmt.queueNeedBankOrDetect':
      '{n} files queued — pick a fallback account, or enable follow file detection.',
    'stmt.pickBankSub': 'You must pick one account number per company before upload/submit.',
    'stmt.pickBankLabel': 'Destination account',
    'stmt.needBankAccount': 'Select a bank account first (code + account number)',
    'stmt.needAccountNo': 'Pick a specific account number. If empty, fill it in Update Accounts first.',
    'stmt.needBankRows': '{n} rows are missing a cash/bank account',
    'stmt.bankEmpty': 'Cash/bank account list is empty — check Chart of Accounts (1000–1005).',
    'bsp.title': 'Pick cash/bank & account number',
    'bsp.subNeedPt': 'Choose a company first, then pick cash/bank and account number.',
    'bsp.subPt': '{pt} · {n} slots · {filled} have account numbers',
    'bsp.selectLabel': 'Cash/Bank + account number',
    'bsp.placeholder': 'Pick an account…',
    'bsp.searchPh': 'Search bank, code, account no…',
    'bsp.manage': 'Update / create accounts',
    'bsp.manageShort': 'Update',
    'bsp.emptyNo': 'No account no.',
    'bsp.fillNow': 'Fill now',
    'bsp.needPick': 'Pick an account from the list before continuing.',
    'bsp.emptyHint': '{n} slots missing account numbers — fill via Update (not here).',
    'bsp.noRekLabel': 'Account number',
    'bsp.noRekPlaceholder': 'e.g. 2532999996',
    'bsp.noRekSave': 'Save account number',
    'bsp.noRekHint': 'Fill / pick an account number so reconciliation direction is clear.',
    'bsp.noRekSaved': 'Account number saved.',
    'bsp.noRekNeedSlot': 'Pick a cash/bank slot first, then enter the account number.',
    'bsp.kasCash': 'Cash on hand · no account number',
    'bsp.noRekEmpty': 'Account number not filled yet',
    'bsp.stepBadge': 'Step 1 · required',
    'bsp.prominentHint': 'A default account is pre-selected — verify it, change if needed, then upload.',
    'bsp.defaultSelected': 'Default selected',
    'bsp.confirmed': 'Account ready — you may upload',
    'bsp.needConfirm': 'Pick an account from the list (default is pre-filled) before uploading.',
    'bam.kicker': 'Master · Bank accounts',
    'bam.title': 'Update Accounts',
    'bam.sub': 'Manage account numbers per company: name, alias, target bank (COA), and create new slots (#1 / #2).',
    'bam.toCash': 'Cash position',
    'bam.toStmt': 'E-Statement',
    'bam.save': 'Save all',
    'bam.saved': 'Bank accounts saved',
    'bam.statTotal': 'Total slots',
    'bam.statFilled': 'With number',
    'bam.statEmpty': 'Empty',
    'bam.allPt': 'All',
    'bam.searchPh': 'Search bank, alias, number…',
    'bam.add': 'Add account',
    'bam.addSecond': 'Add slot #2',
    'bam.colPt': 'Co.',
    'bam.colBank': 'Target bank',
    'bam.colName': 'Account name',
    'bam.colAlias': 'Alias',
    'bam.colNo': 'Account no.',
    'bam.colOrder': 'Order',
    'bam.colActive': 'Active',
    'bam.shared': 'Shared',
    'bam.aliasPh': 'BCA JGI #1',
    'bam.noPh': 'Account number',
    'bam.empty': 'No rows yet — press Add account.',
    'bam.note': 'One bank (COA) can have multiple numbers per company. Used by E-Statement, Excel import, and Quick debit/credit.',
    'bam.lockHint': 'Accounts with journals / e-statements are system-locked — cannot be deleted.',
    'bam.statLocked': 'Locked',
    'bam.colStatus': 'Status',
    'bam.colActions': 'Actions',
    'bam.locked': 'System',
    'bam.lockedTip': 'Has data — only the system may delete',
    'bam.lockedDelete': 'Cannot delete: {n} records ({reason}). System only.',
    'bam.lockedEditHint': 'Company, bank, and number are locked. Name/alias/active can still be edited.',
    'bam.editable': 'Deletable',
    'bam.inactive': 'Inactive',
    'bam.edit': 'Edit',
    'bam.delete': 'Delete',
    'bam.deleteTitle': 'Delete account?',
    'bam.deleteConfirm': 'Remove {name} ({no}) from the list? Save to apply.',
    'bam.deletedLocal': 'Removed from list — press Save to apply',
    'bam.editTitle': 'Edit account',
    'bam.createTitle': 'New account',
    'bam.editLockedTitle': 'Edit (locked)',
    'bam.apply': 'Apply',
    'bam.errBank': 'Pick a target bank first',
    'bam.showing': '{n} rows shown',
    'bam.unsaved': 'Unsaved changes',
    'bam.discarded': 'Changes discarded',
    'bam.discard': 'Discard changes',
    'bam.leaveDirty': 'You have unsaved changes. Leave this page?',
    'bam.exportCsv': 'Export CSV',
    'bam.exported': 'Downloaded CSV ({n} rows)',
    'bam.sort': 'Sort',
    'bam.sortOrder': 'Order #',
    'bam.sortPt': 'Entity',
    'bam.sortBank': 'Bank / COA',
    'bam.sortName': 'Name A → Z',
    'bam.sortNo': 'Account no.',
    'bam.sortStatus': 'Status',
    'bam.resetFilters': 'Reset filters',
    'bam.filterAll': 'All',
    'bam.filterHint': 'Filtered · {n} accounts',
    'bam.statDup': 'Duplicates',
    'bam.dupWarn': '{n} duplicate numbers',
    'bam.dupHint': 'Same number on another slot',
    'bam.fillNo': 'Fill account number',
    'bam.copyNo': 'Copy account number',
    'bam.copiedNo': 'Copied {n}',
    'bam.tipsTitle': 'Quick tips · tidy account master',
    'bam.tipsShow': 'Show',
    'bam.tipsHide': 'Hide',
    'bam.tip1': 'Fill empty numbers first (Empty chip) so statements & imports stay accurate.',
    'bam.tip2': 'Locked slots can still update name/alias — number & entity stay fixed.',
    'bam.tip3': 'Use #2 for a second account on the same bank/entity.',
    'bam.tip4': 'Ctrl+S saves all. You’ll be warned if you leave with a draft.',
    'bam.tableKicker': 'Master data',
    'bam.tableTitle': 'Account number list',
    'bam.emptyTitle': 'No matching accounts',
    'bam.pageAll': 'All',
    'bam.perPage': 'Per page',
    'bam.pageRange': 'Rows {from}–{to} of {total}',
    'bam.pageMeta': 'Page {page} / {pages}',
    'bam.saveHint': 'Local draft — press Save all (Ctrl+S) to write to the database.',
    'bam.savedHint': 'All changes are saved.',
    'bam.fillPct': '{pct}% filled',
    'bam.fillPctHint': '{filled} of {total} slots have account numbers',
    'bam.filterBank': 'Bank / COA',
    'bam.bankAll': 'All banks',
    'bam.groupByBank': 'Group by bank',
    'bam.compact': 'Compact density',
    'bam.seedSlots': 'Seed standard slots',
    'bam.seeded': '{n} standard slots added (draft)',
    'bam.seedNone': 'Standard slots already complete',
    'bam.selected': '{n} selected',
    'bam.selectPage': 'Select all on this page',
    'bam.clearSelection': 'Clear selection',
    'bam.bulkActivate': 'Activate',
    'bam.bulkDeactivate': 'Deactivate',
    'bam.bulkDelete': 'Delete ({n})',
    'bam.bulkDeleteTitle': 'Delete selected accounts?',
    'bam.bulkDeleteConfirm': 'Remove {n} deletable accounts from the list? Save to apply.',
    'bam.bulkActivated': '{n} accounts activated (draft)',
    'bam.bulkDeactivated': '{n} accounts deactivated (draft)',
    'bam.bulkDeleted': '{n} accounts removed from list (draft)',
    'bam.exportSelected': 'Export selected',
    'bam.exportEmpty': 'Nothing to export',
    'bam.inlineEdit': 'Click to quick-edit',
    'bam.inlineHint': 'Click alias / number to quick-edit · Enter save · Esc cancel',
    'bam.suggestAlias': 'Auto-fill alias',
    'bam.groupMeta': '{n} slots · {empty} empty',
    'bam.stickyTitle': 'Unsaved changes',
    'bam.stickySub': '{n} drafts on this page — save so statements & imports stay accurate.',
    'bam.tip5': 'Select rows for bulk activate/deactivate/delete, or group by bank.',
    'bam.vizReady': 'Number readiness',
    'bam.vizPt': 'Fill by entity',
    'bam.vizBank': 'Bank mix',
    'bam.vizShared': '{n} shared slots (SHARED)',
    'bam.vizBankEmpty': 'No bank slots yet',
    'bam.readyHint': '{ok} filled · {need} need attention',
    'bam.filterBar': 'Account filters & search',
    'bam.healthTitle': 'Master health status',
    'bam.healthSub': 'Click a lane to focus rows that need cleanup.',
    'bam.clearLane': 'Show all',
    'bam.lane.all': 'All',
    'bam.lane.empty': 'Empty',
    'bam.lane.filled': 'Has number',
    'bam.lane.locked': 'Locked',
    'bam.lane.inactive': 'Inactive',
    'bam.lane.dup': 'Duplicates',
    'bam.tipActEmpty': 'Fill {n} empty numbers',
    'bam.tipActDup': 'Review {n} duplicates',
    'bam.tipActInactive': 'Review {n} inactive',
    'bam.tipActSeed': 'Seed standard slots',
    'stmt.contra': 'Contra account',
    'stmt.preview': 'Preview',
    'stmt.saveLearn': 'Save + learn',
    'stmt.toRecon': 'Go to reconciliation',
    'stmt.toJournal': 'View journal',
    'stmt.split': 'Split',
    'stmt.saveRule': 'Save rule',
    'stmt.delete': 'Delete',
    'stmt.matchBalance': 'Match statement balance vs ledger',
    'stmt.addRule': 'Add mapping rule',
    'stmt.rulesSub': 'Rules auto-map transaction descriptions to contra accounts — lower priority numbers are evaluated first.',
    'stmt.rulesTotal': 'Total rules',
    'stmt.rulesActive': 'Active',
    'stmt.rulesInactive': 'Inactive',
    'stmt.rulesFiltered': 'Filtered',
    'stmt.rulesSearch': 'Search pattern / account / note',
    'stmt.rulesPageSize': 'Show',
    'stmt.rulesSeeAll': 'See all',
    'stmt.rulesEmpty': 'No rules yet — add a pattern using the form above.',
    'stmt.rulesEmptySearch': 'No rules match your search.',
    'stmt.rulesFoot': 'Showing {from}–{to} of {total} rules',
    'stmt.memory': 'Mapping memory',
    'stmt.memorySub': 'Description patterns you saved — applied automatically on the next upload.',
    'stmt.memTotal': 'Memory entries',
    'stmt.memTotalHits': 'Total hits',
    'stmt.memAccounts': 'Unique accounts',
    'stmt.memSearch': 'Search description / account',
    'stmt.memEmptySearch': 'No memory entries match your search.',
    'stmt.lkImport': 'Import FS PDF → opening balance',
    'stmt.lkSub': 'Read balance sheet from FS PDF draft and prepare opening journal entries.',
    'stmt.lkFiles': 'FS files',
    'stmt.lkLines': 'Balance lines',
    'stmt.lkBalanced': 'Balanced',
    'stmt.lkUnbalanced': 'Out of balance',
    'stmt.lkEmptySub': 'Upload an FS PDF with the e-statement or drop it in the zone above.',
    'stmt.noLk': 'No financial-statement file detected yet.',
    'stmt.snackEmpty': 'Queue empty — drop files first',
    'stmt.snackParsed': 'Parsed {n} rows · {f} files',
    'stmt.snackNoMutasi': 'File was read but debit/credit lines were not detected — check Mutations tab or re-upload the PDF.',
    'stmt.snackNeedRows': 'Check at least 1 row',
    'stmt.snackSaved': 'Saved & learned',
    'stmt.snackExcel': 'Review Excel downloaded',
    'stmt.snackRule': 'Rule added',
    'stmt.ocr': 'Image OCR',
    'stmt.excel': 'Excel',
    'stmt.pdf': 'PDF',
    'stmt.dropHint':
      'PDF e-statements, ZIP, Excel/CSV, HTML/receipts, or OCR photos. Click Choose files then Shift/Ctrl to pick many at once — queue first, process together.',
    'stmt.zip': 'ZIP',
    'stmt.csv': 'CSV',
    'stmt.ofx': 'OFX/QFX',
    'stmt.json': 'JSON',
    'stmt.queueTitle': 'Queue · {n} files · {size}',
    'stmt.queueLoading': '{n} loading',
    'stmt.queueIngesting': 'Loading file…',
    'stmt.queueStillLoading': 'Wait until all files finish loading into the queue.',
    'stmt.queueNotReady': 'Some files are not ready yet — wait until 100%.',
    'stmt.queueReadFail': 'Failed to read file',
    'stmt.queueReadFailCount': '{n} file(s) failed to load',
    'stmt.uploadTimeout': 'Upload timed out — please try again.',
    'stmt.queueSwipeHint': 'Swipe cards or use ‹ › to browse files',
    'upload.rule.kicker': 'Important rule',
    'upload.rule.badge': 'Must read',
    'upload.rule.badgeDetect': 'Smart',
    'upload.rule.title': 'Multiple PDFs OK — same bank account only',
    'upload.rule.titleDetect': 'Multiple PDFs OK — mixed banks allowed (follow file detection)',
    'upload.rule.titleImport': 'Excel multi-sheet — one bank account per upload session',
    'upload.rule.summaryShort': 'Many files OK · one account · do not mix banks',
    'upload.rule.summaryShortDetect': 'Multi-bank OK · each file keeps its bank · slot = fallback',
    'upload.rule.summaryShortImport': 'Excel .xlsx / .xls / .xlsm · one account · Gemini ↔ Groq AI',
    'upload.rule.line1':
      'You may upload several PDFs for the same account (e.g. January + February, or split pages).',
    'upload.rule.line2':
      'Do not mix different banks or account numbers in one upload (e.g. BCA + BNI, or two different account numbers).',
    'upload.rule.line3':
      'Check the default account below before uploading. All files will post to the selected account.',
    'upload.rule.detectLine1':
      'Mixing BCA + Mandiri + BNI in one batch is OK — each file follows PDF/filename detection.',
    'upload.rule.detectLine2':
      'The account slot is only used for files whose bank is still unclear.',
    'upload.rule.detectLine3':
      'After parsing, use per-bank chips to focus review.',
    'upload.rule.target': 'Active account: {bank}',
    'upload.rule.importNote':
      'This page is for multi-sheet Excel. PDF e-statements → E-Statement menu; still one account per upload session.',
    'upload.rule.intense':
      'Pick the bank account in step 1 first — do not upload until the account number matches.',
    'upload.rule.intenseDetect':
      'Detect mode on — Process can run even without a slot if filenames are recognized.',
    'setup.kicker': 'Setup',
    'setup.title': 'Target & bank account',
    'setup.sub': 'Choose company, confirm the default account, then upload files for that same account.',
    'setup.ready': 'Ready to upload',
    'setup.needBank': 'Confirm account',
    'setup.needPt': 'Choose company',
    'setup.step2': 'Upload files',
    'stmt.needsOcr': 'Needs OCR',
    'stmt.periodUnknown': 'period ?',
    'stmt.txnCount': '{n} lines',
    'stmt.noRowsYet':
      'No mutation rows are ready yet. If the file is financial statements/opening data, see other tabs. For reconciliation, upload bank statement transaction files.',
    'stmt.parseInsight':
      'Upload result: {files} file(s) · {rows} mutation row(s) · {lk} FS preview(s) · {balances} balance check(s) · {errors} file error(s).',
    'stmt.dashTitle': 'Upload summary',
    'stmt.dashFiles': 'Uploaded files',
    'stmt.dashHintTitle': 'Guide',
    'stmt.fileLibKicker': 'Saved e-statements',
    'stmt.fileLibTitle': 'Files already in the system',
    'stmt.fileLibSub':
      'Click a file to load mutations into the review table · year {year}. New uploads still go through the dropzone above.',
    'stmt.fileLibEmpty':
      'No saved e-statements yet. Upload files in the dropzone above, then save to the journal.',
    'stmt.bank': 'Bank',
    'stmt.allMapping': 'All mapping',
    'stmt.mapRule': 'Rule',
    'stmt.mapMemory': 'Memory',
    'stmt.mapAuto': 'Auto',
    'stmt.mapManual': 'Manual',
    'stmt.notSelected': 'No',
    'stmt.desc': 'Description',
    'stmt.mapCol': 'Map',
    'stmt.contraShort': 'Contra acct no',
    'stmt.actions': 'Actions',
    'stmt.acctNo': 'Bank acct no',
    'stmt.refNo': 'Ref no',
    'stmt.bankName': 'Cash/bank name',
    'stmt.contraName': 'Contra name',
    'stmt.mapDir': 'Direction',
    'stmt.swapDir': 'Swap debit/credit',
    'stmt.applyRec': 'Use',
    'stmt.applyAllRec': 'Apply all recommendations',
    'stmt.clearSelection': 'Clear checks',
    'stmt.deleteSelected': 'Delete selected',
    'stmt.clearTable': 'Clear table',
    'stmt.resetTable': 'Reset table to start',
    'stmt.selectInvalid': 'Select invalid',
    'stmt.deleteSelectedCount': 'Delete selected ({n})',
    'stmt.snackInvalidSelected': '{n} invalid rows checked',
    'stmt.snackNoInvalid': 'No invalid rows',
    'stmt.swapSide': 'Swap debit ↔ credit',
    'stmt.snackRowDeleted': '1 row removed from table',
    'stmt.snackRowsDeleted': '{n} rows removed from table',
    'stmt.snackTableCleared': 'Table cleared',
    'stmt.snackRowAdded': 'Manual row added — fill description, debit/credit, then save.',
    'stmt.periodFilter': 'Date filter',
    'stmt.periodAll': 'All dates',
    'stmt.periodLast7': 'Last 7 days',
    'stmt.periodLast30': 'Last 30 days',
    'stmt.periodLast90': 'Last 90 days',
    'stmt.periodLastYear': 'Last year',
    'stmt.periodMatch':
      'Showing {n} / {total} rows · Filter debit {debit} · Filter credit {credit}',
    'stmt.toolbarBulkSelected': '{n} selected',
    'stmt.toolbarFiltersActive': '{n} active filters',
    'stmt.pageInfo': 'Page {page}/{pages} · {n} rows · 100/page',
    'stmt.tableFoot': '{n} filtered rows · pagination inside table (default 50)',
    'stmt.howtoTitle': 'How to use E-Statement',
    'stmt.howtoHint': 'Click to expand',
    'stmt.howtoS1t': '1. Pick entity',
    'stmt.howtoS1': 'Click the JGI or JGT card — all mutations follow that entity.',
    'stmt.howtoS2t': '2. Pick account',
    'stmt.howtoS2': 'Pick cash/bank + account number. Changing PT remaps account numbers automatically.',
    'stmt.howtoS3t': '3. Upload & process / Add Row',
    'stmt.howtoS3':
      'Drop PDF/ZIP/Excel/CSV/images — AI parse fills debit/credit & accounts. Or press Add Row (teal) for manual entry like Quick Debit/Credit.',
    'stmt.howtoS4t': '4. Review table',
    'stmt.howtoS4':
      'Column # · checklist 1×/2× · required description · AUTO NoRef · bank chips · DP/AR tags · pagination 50+',
    'stmt.howtoS5t': '5. Save / send recon',
    'stmt.howtoS5': 'Save + learn or send to reconciliation — confirm “already checked?” first.',
    'stmt.howtoTip':
      'Tip: pick an account first so Add Row appears. Empty description = red box.',
    'stmt.confirmAccKicker': 'Save e-statement',
    'stmt.confirmReconKicker': 'Send to reconciliation',
    'stmt.confirmAccTitle': 'Are you sure you already checked?',
    'stmt.confirmAccLead':
      '{n} selected rows will be saved. Confirm description, debit/credit, and accounts first.',
    'stmt.confirmAccB1': 'Description required · auto NoRef · cash/bank & contra filled.',
    'stmt.confirmAccB2': 'Uncheck unsure/wrong rows before continuing.',
    'stmt.confirmAccB3': 'On Yes, rows become import journals (pending or cleared per switch).',
    'stmt.confirmProcessKicker': 'Process upload',
    'stmt.confirmProcessTitle': 'Review files before processing',
    'stmt.confirmProcessLead': 'You will process {n} file(s). Ensure all belong to the same account.',
    'stmt.confirmProcessLeadDetect':
      'You will process {n} file(s). Detect mode: each file posts to its own bank.',
    'stmt.confirmStep': 'Step {n}/2',
    'stmt.confirmStep2Title': 'Final confirmation',
    'stmt.confirmStep2Lead': 'Check the statement below if you are sure — cannot be undone after processing.',
    'stmt.confirmFiles': 'Total files',
    'stmt.confirmSize': 'Size',
    'stmt.confirmTotalDebit': 'Total debit',
    'stmt.confirmTotalCredit': 'Total credit',
    'stmt.confirmTargetBank': 'Posts to account',
    'stmt.confirmChangeBank': 'Wrong account? Change here before continuing.',
    'stmt.confirmPanelSize': 'Panel size',
    'stmt.confirmSizeS': 'Small (S)',
    'stmt.confirmSizeM': 'Medium (M)',
    'stmt.confirmSizeL': 'Large (L)',
    'stmt.confirmDragHint': 'Drag header to move panel',
    'stmt.confirmResizeHint': 'Drag to resize',
    'stmt.confirmSelected': 'Selected',
    'stmt.confirmMoreFiles': '+{n} more files',
    'stmt.confirmWarnSameBank': 'All files must be for the same account. Do not mix banks/account numbers.',
    'stmt.confirmWarnDetect':
      'Follow-detection is on — mixed banks are OK. Slot is only a fallback for unclear files.',
    'stmt.confirmRecapProcess': '{n} file(s) will be processed → account: {bank}',
    'stmt.confirmRecapProcessDetect': '{n} file(s) will be processed · {summary}',
    'stmt.confirmRecapSave': '{n} rows ({deb} debit · {cred} credit) → account: {bank}',
    'stmt.confirmSureCheck': 'I confirm account {bank} is correct and data is ready to process.',
    'stmt.confirmSureCheckDetect':
      'I confirm per-file bank detection looks correct and data is ready to process.',
    'stmt.confirmNext': 'Continue review',
    'stmt.confirmNextHint': 'Go to final confirmation',
    'stmt.confirmBack': 'Back',
    'stmt.confirmBackHint': 'Review details again',
    'stmt.confirmFinalHint': 'Process now',
    'stmt.confirmSaveLead': 'You will save {n} selected rows to the ledger.',
    'stmt.confirmNoHint': 'Back to the table',
    'stmt.confirmYesAccHint': 'Yes, checked — save',
    'stmt.confirmYesReconHint': 'Yes — save & open Recon',
    'stmt.balanceEmpty':
      'Upload an e-statement first — the system extracts the PDF ending balance and compares it to the account balance.',
    'stmt.balanceSub': 'Compare e-statement closing balance with ledger position per account.',
    'stmt.balanceNotesTitle': 'Comparison notes',
    'stmt.balanceTipTitle': 'Tips & explanation',
    'stmt.balanceNoStmt': 'Not detected from PDF',
    'stmt.balUnknown': 'Not compared',
    'stmt.balMatchRate': 'Match rate',
    'stmt.balanceUnknownHint':
      '{n} account(s) could not be compared — statement balance was not detected from the PDF or ledger balance is empty.',
    'stmt.stmtBal': 'Statement balance',
    'stmt.bookBal': 'Book balance',
    'stmt.diffCol': 'Difference',
    'stmt.status': 'Status',
    'stmt.matchOk': 'Match',
    'stmt.matchDiff': 'Diff',
    'stmt.na': 'N/A',
    'stmt.balanceTip':
      'Differences usually mean opening balance is missing, or not all lines are posted. Post the lines, then re-upload to refresh.',
    'stmt.pattern': 'Pattern (text / regex)',
    'stmt.matchType': 'Type',
    'stmt.side': 'Side',
    'stmt.priority': 'Priority',
    'stmt.prio': 'Prio',
    'stmt.active': 'Active',
    'stmt.memoryHint':
      'Each time you save lines, the system remembers description → contra account. The next upload uses memory automatically (memory chip).',
    'stmt.sampleDesc': 'Sample description',
    'stmt.hits': 'Hits',
    'stmt.noMemory': 'No memory yet — post some lines first.',
    'stmt.lkHint':
      'Upload a draft FS (e.g. 2024 warehouse FS) with e-statements, or drop the FS file on the dropzone. The system reads the balance sheet and prepares an opening journal.',
    'stmt.postOpening': 'Post opening balance',
    'stmt.asOf': 'as of {date}',
    'stmt.importDone': 'Import complete',
    'stmt.saveSummary': '{imported} new · {skipped} skipped',
    'stmt.skippedDupHint': 'Skipped = already in books ([FP] fingerprint) — not recreated.',
    'stmt.memoryPlus': ' · memory +{n}',
    'stmt.newRefs': 'New Ref IDs:',
    'stmt.noteTitle': 'Row memo / note',
    'stmt.noteLabel': 'Write a memo for this credit/debit',
    'stmt.noteHint': 'Saved to the journal on post · auto Ref ID J7P-######',
    'stmt.saveNote': 'Save note',
    'stmt.splitTitle': 'Split transaction',
    'stmt.splitSubtitle': '{desc} · total {amount}',
    'stmt.addSplit': '+ Split line',
    'stmt.splitSum': 'Split total {n}',
    'stmt.splitOk': '= OK',
    'stmt.splitNeq': '≠ {n}',
    'stmt.applySplit': 'Apply split',
    'stmt.part1': 'Part 1',
    'stmt.part2': 'Part 2',
    'stmt.snackQueued': '{n} files queued · click Process upload',
    'stmt.snackDupFile': '{n} files already in the queue (same name) — skipped',
    'stmt.snackDebitXor':
      '{n} invalid rows: fill Debit OR Credit only (not both / empty)',
    'stmt.snackNeedAcctNo': '{n} bank rows missing account number — fill account no first',
    'stmt.snackChannelMix':
      '{n} rows do not match {channel} channel — split CC vs bank uploads',
    'stmt.snackUnsupported': '{n} unsupported files were skipped from queue',
    'stmt.snackUploadFail': 'Upload failed',
    'stmt.snackSplit': 'Split saved on the row — ready to post',
    'stmt.snackMemo': 'Row memo saved (included on post)',
    'stmt.snackPreviewOk': 'Preview OK · {n} journals',
    'stmt.snackImported': 'Saved {imported} · skipped {skipped} → reconciliation queue',
    'stmt.snackImportedDup':
      'Saved {imported} new · {skipped} already exist (fingerprint) — no duplicates',
    'stmt.snackAllDup': 'All {skipped} rows already in books (fingerprint) — nothing new',
    'stmt.saveToRecon': 'Save selected → Reconciliation',
    'stmt.snackSaveFail': 'Save failed',
    'stmt.snackExportFail': 'Export failed',
    'stmt.snackLkPreview': 'Opening-balance preview {n} lines',
    'stmt.snackLkSaved': 'Opening balance saved {ref}',
    'stmt.label': 'Label',
    'stmt.code': 'Code',
    'stmt.splitChip': 'split {n}',
    'stmt.ocrShort': 'OCR',
    'stmt.ocrRescueTitle': 'Files need OCR / clearer scan',
    'stmt.ocrRescueBody':
      '{n} file(s) could not be read as text. Re-upload a sharper scan (PNG/JPG) or a non-blurry photo PDF.',
    'stmt.readyScore': 'Ready to post',
    'stmt.readyHint': '{ok} OK · {need} still need review',
    'stmt.healthTitle': 'Quick review lanes',
    'stmt.healthSub': 'Click a chip to filter rows — stays in sync with the table below.',
    'stmt.clearLane': 'Clear filter',
    'stmt.tableFootRich':
      '{n} rows shown · needs check {unsure} · DP {dp} · prepaid {prepaid} · OK {ok}',
    'stmt.openRecon': 'Open Reconciliation',
    'stmt.balTotal': 'Accounts checked',
    'stmt.balAbsDiff': 'Total |diff|',
    'stmt.balanceMismatchHint':
      '{n} account(s) still mismatched. Post reviewed lines or set opening balance — then open Reconciliation.',

    'rpt.hubTitle': 'Reports Hub',
    'rpt.hubSub': 'All financial & classification reports — ready for consultant / KAP review',
    'rpt.cfoKicker': 'CFO summary',
    'rpt.cfoTitle': 'Financial snapshot',
    'rpt.cfoSub': 'Follows work context PT & period — click a card to drill down',
    'rpt.cfoCash': 'Cash & bank',
    'rpt.cfoCashHint': 'Closing position {closing}',
    'rpt.cfoNetProfit': 'Net profit',
    'rpt.cfoRevenue': 'Revenue {amount}',
    'rpt.cfoAr': 'Open receivables',
    'rpt.cfoAp': 'Open payables',
    'rpt.cfoOpenDocs': '{n} docs · {overdue} overdue',
    'rpt.cfoCfOps': 'Operating cash flow',
    'rpt.cfoCfMix': 'Inv {inv} · Fin {fin}',
    'rpt.cfoEquity': 'Closing equity',
    'rpt.cfoEquityHint': 'Period income {income}',
    'rpt.cfoBs': 'Balance sheet',
    'rpt.cfoBsHint': 'Position as of {to}',
    'rpt.cfoStmtCoverage': 'E-statement coverage',
    'rpt.cfoStmtCoverageEmpty': 'No import lines in this period',
    'rpt.hubKicker': 'Report studio',
    'rpt.hubSearch': 'Search reports…',
    'rpt.hub.count': '{n} active reports',
    'rpt.hub.groupExport': 'Export',
    'rpt.hub.groupCore': 'Core statements',
    'rpt.hub.groupOps': 'Operations',
    'rpt.hub.groupClassify': 'Classification & analysis',
    'rpt.hub.downloads': 'Download Reports',
    'rpt.hub.downloadsDesc': 'Professional Excel/PDF/CSV/Word packs — preview & download',
    'rpt.hub.lk': 'Financial Statements (FS)',
    'rpt.hub.lkDesc': 'Balance sheet, P&L commercial–fiscal, tax pack',
    'rpt.hub.yoy': 'YoY comparison',
    'rpt.hub.yoyDesc': 'Compare P&L & balance sheet across years',
    'rpt.hub.bank': 'By bank / account',
    'rpt.hub.bankDesc': 'Movements & balances for cash/bank accounts',
    'rpt.hub.forecast': 'Cash forecast',
    'rpt.hub.forecastDesc': '30/60-day cash projection',
    'rpt.hub.ic': 'Intercompany JGI↔JGT',
    'rpt.hub.icDesc': 'Candidates & eliminations',
    'rpt.hub.budget': 'Budget vs actual',
    'rpt.hub.budgetDesc': 'Budget versus realization',
    'rpt.hub.ledger': 'General ledger',
    'rpt.hub.ledgerDesc': 'Ledger by account',
    'rpt.ld.kicker': 'Account activity',
    'rpt.ld.loadedAt': 'Loaded {t}',
    'rpt.ld.healthOk': 'Balance OK',
    'rpt.ld.healthNeg': 'Negative balance',
    'rpt.ld.openJournals': 'Journals',
    'rpt.ld.openJournalsShort': 'Journals',
    'rpt.ld.exportCsv': 'Export CSV',
    'rpt.ld.exportCsvShort': 'Export CSV',
    'rpt.ld.exportEmpty': 'No rows to export',
    'rpt.ld.bannerNegCash': 'Negative cash/bank balance · {amount} — review outflows',
    'rpt.ld.bannerOk': '{n} movements · net change {net}',
    'rpt.ld.focusCreditShort': 'Focus credits',
    'rpt.ld.kpiOpeningMeta': 'Balance before period',
    'rpt.ld.kpiClosingMeta': 'Change {net}',
    'rpt.ld.kpiDebit': 'Total debit',
    'rpt.ld.kpiDebitMeta': 'Inflows / debits in period',
    'rpt.ld.kpiCredit': 'Total credit',
    'rpt.ld.kpiCreditMeta': '{n} lines in period',
    'rpt.ld.vizDc': 'Debit vs credit',
    'rpt.ld.vizMonth': 'Monthly activity',
    'rpt.ld.vizSnapshot': 'Ledger snapshot',
    'rpt.ld.vizNet': 'Net change {amount}',
    'rpt.ld.vizEmpty': 'No movements in period',
    'rpt.ld.snapLines': 'Line count',
    'rpt.ld.snapOpening': 'Opening',
    'rpt.ld.snapClosing': 'Closing',
    'rpt.ld.snapNormal': 'Normal balance',
    'rpt.ld.healthTitle': 'Source & side lanes',
    'rpt.ld.healthSub': 'Click to filter the movement list',
    'rpt.ld.tipsTitle': 'Action tips',
    'rpt.ld.tipNegCash': 'Negative cash/bank {amount} — review credits / advances',
    'rpt.ld.tipEmpty': 'No movements — check HPP 5000 / bank, or re-import e-statements',
    'rpt.ld.tipOutOnly': 'Credits only this period — no debit inflows',
    'rpt.ld.tipTb': 'Compare closing balance with trial balance',
    'rpt.ld.tipJournals': 'Open journals to edit / trace refs',
    'rpt.ld.tipStatements': 'Sync bank & credit-card e-statements (COGS)',
    'rpt.ld.tipOk': 'Ledger healthy — movements & balances look consistent',
    'rpt.ld.focusSource': 'Source filter: {s}',
    'rpt.ld.focusOpening': 'Focus: opening balance',
    'rpt.ld.focusClosing': 'Focus: closing balance',
    'rpt.ld.focusDebit': 'Focus: debit lines',
    'rpt.ld.focusCredit': 'Focus: credit lines',
    'rpt.ld.focusLines': 'Focus: all lines',
    'rpt.ld.focusSearch': 'Search: “{q}”',
    'rpt.ld.clearFocus': 'Clear focus',
    'rpt.ld.empty': 'Ledger not loaded',
    'rpt.ld.emptyHint': 'Pick account / period then refresh',
    'rpt.ld.tableKicker': 'Detail',
    'rpt.ld.tableTitle': 'General ledger movements',
    'rpt.ld.tableSub': 'Showing {shown} of {total} lines',
    'rpt.ld.searchPh': 'Search ref / memo / source…',
    'rpt.ld.noRows': 'No matching rows',
    'rpt.ld.noRowsHint': 'Change filters or clear focus',
    'rpt.ld.footerNote': 'Running balance uses the account normal balance. Cleared/released journals only.',
    'rpt.hub.omset': 'Annual revenue',
    'rpt.hub.omsetDesc': 'Monthly revenue by company',
    'rpt.hub.tb': 'Trial balance',
    'rpt.hub.tbDesc': 'Account balances & balance check',
    'rpt.tb.kicker': 'Balance check',
    'rpt.tb.ok': 'Balanced',
    'rpt.tb.bad': 'Out of balance',
    'rpt.tb.balancedHint': 'Total debits = total credits',
    'rpt.tb.unbalancedHint': 'Debit vs credit gap — review journals',
    'rpt.tb.accountsChip': '{n} active accounts',
    'rpt.tb.loadedAt': 'Loaded {t}',
    'rpt.tb.openLk': 'Financial statements',
    'rpt.tb.openLkShort': 'FS report',
    'rpt.tb.exportCsv': 'Export CSV',
    'rpt.tb.exportCsvShort': 'Export CSV',
    'rpt.tb.exportEmpty': 'No rows to export',
    'rpt.tb.bannerGap': 'Trial balance out of balance · gap {amount}',
    'rpt.tb.bannerOk': 'Trial balance is balanced — debits equal credits',
    'rpt.tb.focusGapShort': 'Focus gap',
    'rpt.tb.kpiDebit': 'Total debit',
    'rpt.tb.kpiDebitMeta': 'Sum of debit side for period',
    'rpt.tb.kpiCredit': 'Total credit',
    'rpt.tb.kpiCreditMeta': 'Sum of credit side for period',
    'rpt.tb.kpiGap': 'Gap (D−C)',
    'rpt.tb.kpiAccounts': 'Active accounts',
    'rpt.tb.kpiAccountsMeta': 'Showing {n} rows after filters',
    'rpt.tb.vizDc': 'Debit vs credit',
    'rpt.tb.vizTypeMix': 'Activity by type',
    'rpt.tb.vizTop': 'Largest balances',
    'rpt.tb.vizEmpty': 'No account activity yet',
    'rpt.tb.meterLabel': 'Balance gap',
    'rpt.tb.meterHint': 'Relative deviation ~{pct}%',
    'rpt.tb.healthTitle': 'Account type lanes',
    'rpt.tb.healthSub': 'Click to filter the trial balance list',
    'rpt.tb.tipsTitle': 'Action tips',
    'rpt.tb.tipGap': 'Gap {amount} — inspect largest absolute balances',
    'rpt.tb.tipJournals': 'Open journals to find unbalanced entries',
    'rpt.tb.tipOpening': 'Check opening balances if the period starts mid-year',
    'rpt.tb.tipLk': 'Continue to BS / P&L once TB is balanced',
    'rpt.tb.tipEmptyTypes': '{n} account types have no activity this period',
    'rpt.tb.tipOk': 'Trial balance healthy — ready for financial statements',
    'rpt.tb.tipEmpty': 'No rows — show zero accounts or change period',
    'rpt.tb.focusType': 'Type filter: {type}',
    'rpt.tb.focusDebit': 'Focus: accounts with debit',
    'rpt.tb.focusCredit': 'Focus: accounts with credit',
    'rpt.tb.focusGap': 'Focus: largest absolute balances',
    'rpt.tb.focusAccounts': 'Focus: account list (code)',
    'rpt.tb.focusSearch': 'Search: “{q}”',
    'rpt.tb.clearFocus': 'Clear focus',
    'rpt.tb.empty': 'Trial balance not loaded',
    'rpt.tb.emptyHint': 'Pick company / period then refresh',
    'rpt.tb.tableKicker': 'Detail',
    'rpt.tb.tableTitle': 'Account balances',
    'rpt.tb.tableSub': 'Showing {shown} of {total} accounts',
    'rpt.tb.searchPh': 'Search code / name / type…',
    'rpt.tb.showZeros': 'Show zero accounts',
    'rpt.tb.noRows': 'No matching rows',
    'rpt.tb.noRowsHint': 'Change filters, clear focus, or show zero accounts',
    'rpt.tb.footerNote': 'Balance check: total debits must equal total credits (cleared/released).',
    'rpt.hub.bs': 'Balance sheet',
    'rpt.hub.bsDesc': 'Assets = liabilities + equity',
    'rpt.bss.kicker': 'Financial position',
    'rpt.bss.loadedAt': 'Loaded {t}',
    'rpt.bss.openLk': 'Financial statements',
    'rpt.bss.openLkShort': 'FS report',
    'rpt.bss.exportCsv': 'Export CSV',
    'rpt.bss.exportCsvShort': 'Export CSV',
    'rpt.bss.exportEmpty': 'No data to export',
    'rpt.bss.focusGapShort': 'Focus gap',
    'rpt.bss.kpiAssets': 'Total assets',
    'rpt.bss.kpiAssetsMeta': 'Left side of the balance sheet',
    'rpt.bss.kpiLiab': 'Total liabilities',
    'rpt.bss.kpiLiabMeta': 'Payables & other obligations',
    'rpt.bss.kpiEquity': 'Total equity',
    'rpt.bss.kpiEquityMeta': '{pct}% share of L+E',
    'rpt.bss.kpiGap': 'Gap (A − L−E)',
    'rpt.bss.vizBalance': 'Assets vs L+E',
    'rpt.bss.vizMix': 'Balance sheet mix',
    'rpt.bss.vizTop': 'Largest balances',
    'rpt.bss.vizEmpty': 'No balance sheet lines yet',
    'rpt.bss.meterLabel': 'Balance gap',
    'rpt.bss.meterHint': 'Relative deviation ~{pct}%',
    'rpt.bss.healthTitle': 'Balance sheet lanes',
    'rpt.bss.healthSub': 'Click to focus a section',
    'rpt.bss.laneGap': 'Gap',
    'rpt.bss.tipsTitle': 'Action tips',
    'rpt.bss.tipGap': 'Gap {amount} — Assets ≠ Liabilities+Equity',
    'rpt.bss.tipTb': 'Open trial balance to trace unbalanced accounts',
    'rpt.bss.tipJournals': 'Review journals / uncleared reconciliations',
    'rpt.bss.tipOpening': 'Check opening balances if the period starts mid-year',
    'rpt.bss.tipNegAssets': '{n} asset accounts with negative balances — review cash/bank',
    'rpt.bss.tipLk': 'Open formal financial statements (BS tab)',
    'rpt.bss.tipOk': 'Balance sheet balanced — ready for formal review / close',
    'rpt.bss.focusAssets': 'Focus: assets',
    'rpt.bss.focusLiab': 'Focus: liabilities',
    'rpt.bss.focusEquity': 'Focus: equity',
    'rpt.bss.focusGap': 'Focus: A vs L+E gap',
    'rpt.bss.focusSearch': 'Search: “{q}”',
    'rpt.bss.clearFocus': 'Clear focus',
    'rpt.bss.empty': 'Balance sheet not loaded',
    'rpt.bss.emptyHint': 'Pick company / period then refresh',
    'rpt.bss.sheetKicker': 'Detail',
    'rpt.bss.sheetTitle': 'Financial position',
    'rpt.bss.sheetSub': 'Assets {assets} · L+E {le}',
    'rpt.bss.searchPh': 'Search account code / name…',
    'rpt.bss.noLines': 'No matching lines',
    'rpt.bss.footerNote': 'Equity includes current-period net income/(loss) (3999). Cleared/released journals only.',
    'rpt.bss.mandiriNegTitle': 'JGI Mandiri bank balance is negative',
    'rpt.bss.mandiriNegDetail':
      'Mandiri (1003) JGI is {amount}. Debit−credit math is correct; it went negative because outflows posted without an opening balance. Reset voids JGI Mandiri journals so the account returns to 0 — then re-upload the Mandiri 2 e-statement.',
    'rpt.bss.mandiriPreview': 'Review Mandiri journals',
    'rpt.bss.mandiriReset': 'Delete & re-enter',
    'rpt.bss.mandiriPreviewOk': 'Preview: {n} JGI Mandiri journals will be voided',
    'rpt.bss.mandiriResetOk': '{n} JGI Mandiri journals voided. Balance is 0 — please re-upload.',
    'rpt.bss.mandiriResetNone': 'No JGI Mandiri journals to void',
    'rpt.bss.mandiriConfirm':
      'Void {n} JGI Bank Mandiri journals (account 1003)? JGT Mandiri is not changed. This is hard to undo — you will need to re-upload the e-statement.',
    'rpt.bss.tipMandiriNeg': 'JGI Bank Mandiri {amount} — check source or reset to re-enter',
    'rpt.hub.is': 'Income statement',
    'rpt.hub.isDesc': 'Revenue, COGS, opex, net profit',
    'rpt.is.kicker': 'Performance report',
    'rpt.is.profitChip': 'Profit',
    'rpt.is.lossChip': 'Loss',
    'rpt.is.marginChip': 'Margin {pct}%',
    'rpt.is.loadedAt': 'Loaded {t}',
    'rpt.is.openLk': 'Financial statements',
    'rpt.is.openLkShort': 'FS report',
    'rpt.is.exportCsv': 'Export CSV',
    'rpt.is.exportCsvShort': 'Export CSV',
    'rpt.is.exportEmpty': 'No data to export',
    'rpt.is.bannerLoss': 'Period is at a loss · {amount}',
    'rpt.is.bannerOpex': 'Opex ratio {pct}% is high — review expenses',
    'rpt.is.bannerOk': 'Positive net profit · margin {pct}%',
    'rpt.is.focusOpexShort': 'Focus opex',
    'rpt.is.kpiRev': 'Revenue',
    'rpt.is.kpiRevMeta': 'Total revenue for period',
    'rpt.is.kpiGross': 'Gross profit',
    'rpt.is.kpiGrossMeta': 'Gross margin {pct}%',
    'rpt.is.kpiOpex': 'Operating expenses',
    'rpt.is.kpiOpexMeta': 'Opex ratio {pct}% of revenue',
    'rpt.is.kpiNet': 'Net profit',
    'rpt.is.kpiNetMeta': 'Net margin {pct}%',
    'rpt.is.vizMix': 'P&L composition',
    'rpt.is.vizShare': 'Share by company',
    'rpt.is.vizSnapshot': 'Margin snapshot',
    'rpt.is.vizEmpty': 'No company data yet',
    'rpt.is.snapGrossMargin': 'Gross margin',
    'rpt.is.snapNetMargin': 'Net margin',
    'rpt.is.snapOpexRatio': 'Opex ratio',
    'rpt.is.snapPt': 'Companies',
    'rpt.is.healthTitle': 'Statement lanes',
    'rpt.is.healthSub': 'Click to focus a summary section',
    'rpt.is.tipsTitle': 'Action tips',
    'rpt.is.tipLoss': 'Loss {amount} — review operating expenses',
    'rpt.is.tipOpexHigh': 'Opex {pct}% of revenue — above 25% threshold',
    'rpt.is.tipOpexWatch': 'Opex {pct}% nearing threshold — watch',
    'rpt.is.tipHppZero': 'COGS is still zero — check e-statement / shared credit-card classification',
    'rpt.is.tipGajiZero': 'Salary expense (5001) is still zero — post HR payroll to match the salary roster',
    'rpt.is.tipStmtAligned': 'E-statement: revenue {omset} · COGS {hpp} (after shared allocation)',
    'rpt.is.stmtStripTitle': 'Aligned with e-statement (cleared import journals)',
    'rpt.is.stmtOmset': 'Import revenue',
    'rpt.is.stmtHpp': 'Import COGS',
    'rpt.is.stmtNamedOpex': 'Named opex',
    'rpt.is.stmtAdmin': 'Bank fees',
    'rpt.is.stmtOpexOther': 'Other opex',
    'rpt.is.stmtStripHint':
      'Figures above are source=import. Salary expense 5001 comes from payroll; bank transfers labeled salary/employee names settle 2201. Lim/Lix draws are owner receivables, not opex.',
    'rpt.is.tipLk': 'Open formal financial statements (P&L tab)',
    'rpt.is.tipTb': 'Check trial balance if figures look off',
    'rpt.is.tipOk': 'Healthy performance — positive margin & controlled opex',
    'rpt.is.focusRev': 'Focus: revenue',
    'rpt.is.focusHpp': 'Focus: COGS / gross profit',
    'rpt.is.focusOpex': 'Focus: operating expenses',
    'rpt.is.focusNet': 'Focus: net profit',
    'rpt.is.focusPt': 'Focus company: {code}',
    'rpt.is.focusSearch': 'Search: “{q}”',
    'rpt.is.clearFocus': 'Clear focus',
    'rpt.is.empty': 'Income statement not loaded',
    'rpt.is.emptyHint': 'Pick company / period then refresh',
    'rpt.is.ptKicker': 'By company',
    'rpt.is.ptTitle': 'Company summaries',
    'rpt.is.ptSub': 'Click a card to filter consolidation · open FS for formal detail',
    'rpt.is.ptTap': 'Click to filter',
    'rpt.is.ptEmpty': 'No company data',
    'rpt.is.sheetKicker': 'Consolidation',
    'rpt.is.sheetSub': 'Simple P&L aligned with the balance sheet — description and amount',
    'rpt.is.searchPh': 'Search account code / name…',
    'rpt.is.noLines': 'No matching lines',
    'rpt.is.hppEmpty': 'No COGS 51xx in this period',
    'rpt.is.footerNote':
      'Layout: Revenue → COGS → Gross profit → Operating expenses (salaries from payroll) → Operating profit → Other → Final income tax. Cleared/released journals only.',
    'rpt.hub.cf': 'Cash flow',
    'rpt.hub.cfDesc': 'Three-activity cash flow statement',
    'rpt.hub.assets': 'Assets report',
    'rpt.hub.assetsDesc': 'Cash, receivables, inventory, fixed assets',
    'rpt.hub.liabilities': 'Liabilities report',
    'rpt.hub.liabilitiesDesc': 'Payables & other obligations',
    'rpt.hub.equity': 'Equity report',
    'rpt.hub.equityDesc': 'Capital & owners equity',
    'rpt.eqSub': 'Changes in capital, retained earnings, and current-period profit',
    'rpt.eqOpening': 'Opening balance',
    'rpt.eqIncrease': 'Increase',
    'rpt.eqDecrease': 'Decrease',
    'rpt.eqClosing': 'Closing balance',
    'rpt.eqNetIncome': 'Net income (loss)',
    'rpt.eqComponent': 'Equity component',
    'rpt.eqTableTitle': 'Statement of changes in equity',
    'rpt.eqExport': 'Export report',
    'rpt.hub.revenue': 'Revenue report',
    'rpt.hub.revenueDesc': 'Income from goods/services',
    'rpt.hub.expense': 'Expense report',
    'rpt.hub.expenseDesc': 'Account summary + journal detail (one ID Ref per row)',
    'rpt.hub.ar': 'Accounts receivable',
    'rpt.hub.arDesc': 'Outstanding customer invoices',
    'rpt.hub.ap': 'Accounts payable',
    'rpt.hub.apDesc': 'Amounts owed to suppliers',
    'rpt.hub.depreciation': 'Depreciation',
    'rpt.hub.depreciationDesc': 'Depreciation expense & accumulations',
    'rpt.hub.inventory': 'Inventory',
    'rpt.hub.inventoryDesc': 'Stock on the balance sheet',
    'rpt.hub.cogs': 'COGS report',
    'rpt.hub.cogsDesc': 'Cost of goods sold (51xx)',
    'rpt.hub.accrual': 'Accrual vs cash',
    'rpt.hub.accrualDesc': 'Accrual profit versus net cash flow',
    'rpt.hub.ctxAllPt': 'All companies',
    'rpt.hub.ctxHint': 'Follows the Work Context bar above',
    'rpt.hub.pinCount': '{n} pinned',
    'rpt.hub.statAll': 'All reports',
    'rpt.hub.statAllMeta': 'Full catalog',
    'rpt.hub.statCore': 'Core statements',
    'rpt.hub.statCoreMeta': '{n} KAP priorities',
    'rpt.hub.statOps': 'Operations',
    'rpt.hub.statOpsMeta': 'Bank · IC · revenue',
    'rpt.hub.statClassify': 'Classification',
    'rpt.hub.statClassifyMeta': 'A · L · E · P/L',
    'rpt.hub.statPinned': 'Favorites',
    'rpt.hub.statPinnedMeta': 'Local pins',
    'rpt.hub.vizReady': 'Studio readiness',
    'rpt.hub.vizReadySub': 'review-ready',
    'rpt.hub.vizReadyHint': 'Raise the score by pinning reports & setting a company filter',
    'rpt.hub.vizMix': 'Catalog mix',
    'rpt.hub.vizPriority': 'Consultant priorities',
    'rpt.hub.healthTitle': 'Quick navigation',
    'rpt.hub.healthSub': 'Filter catalog groups in one click',
    'rpt.hub.laneAll': 'All',
    'rpt.hub.laneCore': 'Core',
    'rpt.hub.laneOps': 'Ops',
    'rpt.hub.laneClassify': 'Classify',
    'rpt.hub.lanePinned': 'Pins',
    'rpt.hub.tipsTitle': 'Review flow tips',
    'rpt.hub.tipCtx': 'Set a company in Work Context so reports stay entity-focused',
    'rpt.hub.tipCtxOk': 'Active context: {pt} · {period} — continue to FS',
    'rpt.hub.tipPin': 'Pin frequently used reports so they stay on top',
    'rpt.hub.tipLk': 'Start review from the full Financial Statements pack',
    'rpt.hub.tipTb': 'Check Trial Balance for account balance integrity',
    'rpt.hub.tipCons': 'No company filter — open Group Consolidation for all entities',
    'rpt.hub.tipIc': 'Review intercompany before consolidation',
    'rpt.hub.tipDownload': 'Prepare Excel/PDF packs for the auditor',
    'rpt.hub.recent': 'Recently opened',
    'rpt.hub.focusAll': 'All',
    'rpt.hub.focusGroup': 'Group: {group} · {n} reports',
    'rpt.hub.focusPinned': 'Favorites · {n} reports',
    'rpt.hub.focusSearch': 'Search “{q}” · {n} hits',
    'rpt.hub.clearFocus': 'Clear filters',
    'rpt.hub.empty': 'No matching reports',
    'rpt.hub.emptyHint': 'Change keywords or clear group/pin filters.',
    'rpt.hub.badgePriority': 'Priority',
    'rpt.hub.togglePin': 'Pin / unpin report',
    'studio.kicker': 'Report studio',
    'studio.healthTitle': 'Report health',
    'studio.healthSub': 'Quick data health before export / review.',
    'studio.healthRows': 'Rows',
    'studio.healthKpi': 'KPI',
    'studio.healthNotes': 'Notes',
    'studio.healthExport': 'Export',
    'studio.healthOk': 'Good',
    'studio.healthNeedReview': 'Needs review',
    'studio.healthReady': 'Ready',
    'studio.ptAll': 'All companies',
    'studio.ptAllShort': 'All PT',
    'studio.filterPt': 'Company filter',
    'studio.search': 'Search',
    'studio.searchPh': 'Search account, code, memo…',
    'studio.notes': 'Notes & scope',
    'studio.dataTitle': 'Detail data',
    'studio.rowCount': '{n} rows',
    'studio.openDownload': 'Open Download',
    'studio.exportPack': 'Export pack',
    'studio.refresh': 'Refresh',
    'studio.loading': 'Loading report…',
    'studio.empty': 'No data for this filter',
    'studio.emptySection': 'No attachment data',
    'studio.loadFail': 'Failed to load report',
    'rpt.lkTitle': 'Financial Statements',
    'rpt.lkSub': 'Formal document format — balance sheet, P&L, tax pack (print-ready PDF)',
    'rpt.lkModes': 'Mode',
    'rpt.lkModeRead': 'Read / print',
    'rpt.lkModeWork': 'Work BS',
    'rpt.lkModeDownload': 'Download pack',
    'rpt.lkDocKicker': 'Formal document',
    'rpt.lkDocTitle': 'Financial Statements',
    'rpt.lkConfidential': 'Client confidential',
    'rpt.lkColAccount': 'Description',
    'rpt.lkSptHint': 'Monthly tax overview · for consultant working papers',
    'rpt.lkSignerRole': 'Director / Responsible Officer',
    'rpt.lkFooterLeft': 'Consultant working paper · not official DJP e-Filing',
    'rpt.printPdf': 'Print / PDF',
    'rpt.printChoose': 'Choose print mode',
    'rpt.printCurrent': 'Current tab only',
    'rpt.printCurrentHint': 'Print the section currently open',
    'rpt.printAll': 'Full pack',
    'rpt.printAllHint': 'Balance sheet + P&L + tax pack (1 PDF)',
    'rpt.printOneByOne': 'Custom one-by-one',
    'rpt.printScopeLabel': 'Print content',
    'rpt.closeYear': 'Close year books',
    'rpt.closedYear': 'Year already closed',
    'rpt.tabBs': 'Balance sheet',
    'rpt.tabIs': 'Income statement',
    'rpt.tabSpt': 'Tax pack / Final income tax',
    'rpt.sectionBs': 'BALANCE SHEET',
    'rpt.assets': 'ASSETS',
    'rpt.liabEquity': 'LIABILITIES & EQUITY',
    'rpt.sectionIs': 'Income statement',
    'rpt.colCommercial': 'Commercial',
    'rpt.colFiscalAdj': 'Fiscal adjustment',
    'rpt.colFiscal': 'Fiscal',
    'rpt.bsOk': 'Balance sheet balanced',
    'rpt.bsBad': 'Balance sheet not balanced',
    'rpt.lkKpiAssets': 'Total assets',
    'rpt.lkKpiAssetsMeta': 'Balance sheet asset side',
    'rpt.lkKpiLE': 'Liabilities + equity',
    'rpt.lkKpiLEMeta': 'Balance sheet liability side',
    'rpt.lkKpiGap': 'Balance gap',
    'rpt.lkKpiGapMeta': '~{pct}% of larger side',
    'rpt.lkKpiAssetsYoYMeta': 'YoY Δ {amount}',
    'rpt.lkKpiNetYoYMeta': 'Commercial {year} · Δ {amount}',
    'rpt.lkYoYPct': '{pct}%',
    'rpt.lkFactPeriod': 'Period',
    'rpt.lkFactPeriodVal': 'FY {year} vs {prior}',
    'rpt.lkFactBalance': 'Balance sheet',
    'rpt.lkFactClose': 'Year close',
    'rpt.lkFactClosed': 'Closed',
    'rpt.lkFactOpen': 'Open',
    'rpt.lkFactPrint': 'PDF print',
    'rpt.lkFactPrintReady': 'Ready to print',
    'rpt.lkFactPrintHold': 'Hold — not balanced',
    'rpt.lkSnapPriorAssets': 'Prior-year assets',
    'rpt.lkSnapPph': 'Final tax YTD',
    'rpt.lkSheetNote':
      'Vertical statement: Assets, then Liabilities, then Equity. One account per row — name and amount on the same line. Columns {year} vs {prior}.',
    'rpt.lkKpiNet': 'Profit after tax',
    'rpt.lkKpiNetMeta': 'Commercial {year}',
    'rpt.lkKpiPph': 'Final income tax YTD',
    'rpt.lkKpiPphMeta': 'Monthly SPT accumulation',
    'rpt.lkVizBalance': 'Balance sheet equilibrium',
    'rpt.lkVizYoY': 'YoY comparative',
    'rpt.lkVizSnapshot': 'Document snapshot',
    'rpt.lkVizAssetsYoY': 'Assets',
    'rpt.lkVizNetYoY': 'Profit after tax',
    'rpt.lkVizEmpty': 'Comparative data not available',
    'rpt.lkMeterLabel': 'Assets vs Liabilities+Equity delta',
    'rpt.lkMeterHint': 'Relative gap ~{pct}% of the larger side',
    'rpt.lkSnapTab': 'Active tab',
    'rpt.lkSnapClosed': 'Year closed',
    'rpt.lkSnapGap': 'Abs. gap',
    'rpt.lkOpenTrial': 'Trial balance',
    'rpt.lkOpenCf': 'Cash flow',
    'rpt.lkStudioKicker': 'Report Studio',
    'rpt.lkStudioTitle': 'YoY compare · drill to ledger',
    'rpt.lkStudioHint': 'Click coded amounts to open this year’s ledger. Presentation mode hides chrome.',
    'rpt.lkStudioPrior': 'Compare vs {year}',
    'rpt.lkPresent': 'Present',
    'rpt.lkPresentExit': 'Exit present',
    'rpt.lkShare': 'Copy link',
    'rpt.lkShareOk': 'Link copied',
    'rpt.lkShareFail': 'Could not copy link',
    'rpt.lkDrillLedger': 'Open ledger for this account',
    'rpt.lkHealthTitle': 'Report navigation',
    'rpt.lkHealthSub': 'Tap a chip to switch document tabs.',
    'rpt.lkTipsTitle': 'Action tips',
    'rpt.lkTipGap': 'Balance sheet off by {amount} — check capital, owner drawings, or opening balances',
    'rpt.lkAutoSnack': 'AI posted {n} bell note(s) — please cross-check BS/TB.',
    'rpt.lkTipTrial': 'Open trial balance to trace unbalanced accounts',
    'rpt.lkTipOpening': 'Review opening balances for this entity',
    'rpt.lkTipUnearned': 'Review customer advances (acct 2600) vs revenue',
    'rpt.lkTipCloseReady': 'Balanced — {year} is ready to close if adjustments are done',
    'rpt.lkTipCloseBlocked': 'Do not close the year until the balance sheet balances',
    'rpt.lkTipClosed': 'Year {year} is already closed',
    'rpt.lkTipOk': 'LK document looks healthy — balance sheet balances',
    'rpt.lkEmpty': 'Report not loaded',
    'rpt.lkEmptyHint': 'Pick a company & year, then refresh.',
    'rpt.closeOk': 'Year close OK · P&L posted',
    'rpt.closeFail': 'Year close failed',
    'rpt.omsetTitle': '1-year revenue',
    'rpt.omsetKicker': 'Report · Revenue',
    'rpt.omsetSub':
      'Months 1–12 breakdown from revenue accounts (linked to cleared journals). Company, period, and date range filters match the dashboard.',
    'rpt.omsetTotal': 'Total revenue {year}',
    'rpt.omsetChart': 'Monthly revenue chart',
    'rpt.omsetChartHint': 'Total vs per company — expand for fullscreen',
    'rpt.omsetTable': 'Months 1–12 table',
    'rpt.omsetFilters': 'Revenue report filters',
    'rpt.omsetFiltersHint': 'Company · Year · Period · From / To — collapse to save space',
    'rpt.omsetFullYear': 'Full year',
    'rpt.omsetPartial': 'Partial range',
    'rpt.omsetAvg': 'Avg / active month',
    'rpt.omsetAvgHint': 'Total ÷ months with revenue',
    'rpt.omsetPeak': 'Peak month',
    'rpt.omsetNoPeak': 'No revenue yet',
    'rpt.omsetActiveMonths': '{n} active months',
    'rpt.omsetOfTotal': 'of total',
    'rpt.omsetMom': 'MoM',
    'rpt.omsetShare': 'Share',
    'rpt.omsetHideZero': 'Hide Rp 0 months',
    'rpt.omsetExpand': 'Expand chart',
    'rpt.omsetViz': 'Visualization',
    'rpt.omsetDetail': 'Detail',
    'rpt.omsetNoData': 'No data for this filter',
    'rpt.omsetEmptyExport': 'No rows to export',
    'rpt.omsetExported': 'Revenue CSV downloaded',
    'rpt.omsetGuideTitle': 'How to read this revenue report',
    'rpt.omsetGuide1': 'Revenue comes from cleared/released income journals — not drafts or voids.',
    'rpt.omsetGuide2': 'Period filters limit journal dates; the year sets which months 1–12 appear.',
    'rpt.omsetGuide3': 'Down payments stay off revenue until recognized — see the Unearned report.',
    'rpt.omsetModeBar': 'Bar',
    'rpt.omsetModeLine': 'Line',
    'rpt.omsetModeArea': 'Area',
    'rpt.omsetModeStacked': 'Stacked',
    'rpt.omsetChartMode': 'Chart mode',
    'rpt.omsetShowPt': 'Show by company',
    'rpt.omsetCumulative': 'YTD cumulative',
    'rpt.omsetShowYoy': 'Compare prior year',
    'rpt.omsetYoy': 'YoY vs {year}',
    'rpt.omsetYoyPrev': 'Prior year',
    'rpt.omsetYoySeries': 'Revenue {year}',
    'rpt.omsetPkp': 'PKP MSME progress',
    'rpt.omsetPkpRemain': 'Remaining to limit',
    'rpt.omsetPkpLimit': 'Limit',
    'rpt.omsetDonutTitle': 'Share by company',
    'rpt.omsetDonutHint': 'Contribution of each company',
    'rpt.omsetPrint': 'Print',
    'rpt.colMonth': 'Month',
    'rpt.colPeriod': 'Period',
    'rpt.colOmset': 'Total revenue',
    'rpt.filterPt': 'Company filter',
    'rpt.load': 'Load',
    'rpt.assetsLabel': 'Assets',
    'rpt.liabilities': 'Liabilities',
    'rpt.equity': 'Equity',
    'rpt.totalAssets': 'Total Assets',
    'rpt.totalLiabilities': 'Total Liabilities',
    'rpt.totalEquity': 'Total Equity',
    'rpt.liabPlusEquity': 'Liabilities + Equity',
    'rpt.bsBalancedHint': 'Balance sheet balanced',
    'rpt.bsUnbalancedHint': 'Balance sheet not balanced — review journals',
    'rpt.asOf': 'As of {date}',
    'rpt.opex': 'Operating Expenses',
    'rpt.consolidatedSummary': 'Consolidated Summary',
    'rpt.totalRevenue': 'Total Revenue',
    'rpt.grossProfitLoss': 'Gross Profit / (Loss)',
    'rpt.netProfitLoss': 'Net Income / (Loss)',
    'rpt.colLine': 'Line',
    'rpt.colDelta': 'Δ',
    'rpt.cfInflows': 'Cash Inflows',
    'rpt.cfOutflows': 'Cash Outflows',
    'rpt.cfNet': 'Net',
    'rpt.cfRecentTitle': 'Recent Cash/Bank Movements',
    'rpt.cfOperating': 'Operating',
    'rpt.cfInvesting': 'Investing',
    'rpt.cfFinancing': 'Financing',
    'rpt.cfOpening': 'Opening cash',
    'rpt.cfClosing': 'Closing cash',
    'rpt.cfStatementTitle': 'Three-activity summary',
    'rpt.cfStatementSub': 'Operating · Investing · Financing — classified from cash journal counterparts',
    'rpt.cfActivity': 'Activity',
    'rpt.cfAmount': 'Cash flow',
    'rpt.cfNetChange': 'Net change in cash',
    'rpt.cfNetIncome': 'Net income (reference)',
    'rpt.cfNetIncomeHint': 'From accrual P&L, not an SCF line',
    'rpt.cfStmtTab': 'Journal detail',
    'rpt.colIn': 'In',
    'rpt.colOut': 'Out',
    'rpt.colAccountCode': 'Account',
    'rpt.forecastDays': 'Days',
    'rpt.currentCash': 'Current cash balance',
    'rpt.avgInflowDay': 'Avg inflow / day',
    'rpt.avgOutflowDay': 'Avg outflow / day',
    'rpt.horizon': 'Horizon',
    'rpt.inflow': 'Inflow',
    'rpt.outflow': 'Outflow',
    'rpt.projectedCash': 'Projected cash',
    'rpt.daysUnit': '{n} days',
    'rpt.openingBalance': 'Opening Balance',
    'rpt.closingBalance': 'Closing Balance',
    'rpt.budgetNew': 'New budget',
    'rpt.budgetSelect': 'Select budget',
    'rpt.budgetSaved': 'Budget saved',
    'rpt.budgetLineAdded': 'Line added',
    'rpt.budgetAddLine': '+ Line (form below)',
    'rpt.budgetLineForm': 'Budget line form',
    'rpt.budgetYearNew': 'Year (new budget)',
    'rpt.budgetMonth': 'Month 1–12',
    'rpt.budgetAmount': 'Budget amount',
    'rpt.budgetActual': 'Actual',
    'rpt.budgetVariance': 'Variance',
    'rpt.budgetFormHint': 'Fill account, month, and amount in the line form, then save.',
    'rpt.icElimDetected': 'Eliminations detected: {pairs} pairs · Total {total}',
    'rpt.icAutoRunning': 'AI is executing intercompany tips…',
    'rpt.icAutoDone': 'AI finished · {n} new bell note(s).',
    'rpt.icAutoSynced': 'AI scan synced — bell notes ready to cross-check.',
    'rpt.icKicker': 'Group · IC eliminations · Cross-check',
    'rpt.icHealthOk': 'IC looks clean',
    'rpt.icHealthWarn': 'Pairs need review',
    'rpt.icHealthHot': 'Candidates without pairs',
    'rpt.icHealthOkShort': 'Healthy',
    'rpt.icHealthWarnShort': 'Review',
    'rpt.icHealthHotShort': 'Attention',
    'rpt.icHealthTitle': 'IC status',
    'rpt.icHealthHint': 'Pairs vs intercompany memo candidates',
    'rpt.icPairsChip': '{n} pairs',
    'rpt.icUnmatchedMeta': '~{n} unpaired',
    'rpt.icOpenCons': 'Consolidation',
    'rpt.icPairsTitle': 'Elimination pairs',
    'rpt.icPairsSub': 'Candidates matched by amount and date across entities.',
    'rpt.icCandTitle': 'All IC candidates',
    'rpt.icCandSub': 'Journals with intercompany / loan / transfer memos.',
    'rpt.icNoCandidates': 'No candidates in this period',
    'rpt.icElimPairs': 'Elimination pairs',
    'rpt.icNoPairs': 'No automatic pairs yet',
    'rpt.icAllCandidates': 'All candidates (interco keyword)',
    'rpt.icColPtA': 'Co. A',
    'rpt.icColPtB': 'Co. B',
    'rpt.closeConfirm':
      'Close books for {year}?\n\nP&L balance will transfer to Retained Earnings. Closing journal dated Dec 31 {year}.',
    'rpt.yearClosedBanner': 'Year {year} closed on {date} · net {amount}',
    'rpt.docMeta': '{code} · Fiscal year {year} · Comparative {prior}',
    'rpt.asOfDec31': 'As of December 31 {year}',
    'rpt.inRupiah': '(In Rupiah)',
    'rpt.bsBannerDetail': 'Assets {assets} vs Liabilities+Equity {total}',
    'rpt.compareAssets': 'Comparative Assets {year}',
    'rpt.compareNetAfterTax': 'Comparative Net Income After Tax {year}',
    'rpt.thisYearAmount': 'This year {amount}',
    'rpt.deltaAmount': 'Δ {amount}',
    'rpt.compareIncomeBanner':
      'Comparative {year}: Revenue {revenue} · Gross profit {gross} · After tax {afterTax}',
    'rpt.revenue': 'Revenue',
    'rpt.grossProfit': 'Gross profit',
    'rpt.afterTax': 'After tax',
    'rpt.pph25Title': 'Art. 25 income tax calculation {year}',
    'rpt.pph25Base': 'Taxable income base (fiscal, rounded)',
    'rpt.pph25Self': 'Self-assessed tax payable (estimate)',
    'rpt.pph25Installment': 'Art. 25 installment (1/12)',
    'rpt.sptDisclaimer':
      'This page helps prepare tax pack figures. Final validation remains with your tax advisor / official e-Filing.',
    'rpt.periodOf': 'Period {label}',
    'rpt.signPlace': 'Jakarta, {date}',

    'common.edit': 'Edit',
    'common.delete': 'Delete',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.confirmDelete': 'Delete?',
    'common.action': 'Action',
    'common.code': 'Code',
    'common.type': 'Type',
    'common.status': 'Status',
    'common.description': 'Description',
    'common.select': 'Select',
    'common.apply': 'Apply',
    'common.file': 'File',
    'common.rows': 'Rows',
    'common.invalid': 'Invalid',
    'common.selectAll': 'Select All',
    'common.unselectAll': 'Unselect All',
    'common.descShort': 'Description',
    'common.autoFix': 'Auto Fix',

    'qj.uploadTitle': 'Smart Transaction Proof Upload',
    'qj.uploadSub':
      'All files · auto-parse · Gemini→Groq · smart debit/credit · new rows append below.',
    'qj.uploadLabel': 'Upload transaction / statement files',
    'qj.aiOn': 'AI ON (Gemini→Groq)',
    'qj.aiOff': 'AI OFF · local rules',
    'qj.aiGemini': 'Gemini ON',
    'qj.aiGroq': 'Groq fallback',
    'qj.recFillManual': 'Fill debit/credit + bank & contra accounts',
    'qj.uploadHint': 'Multi-file · all formats tried · jpg/png/pdf/xlsx/csv/zip/etc',
    'qj.uploadHintReady': 'Draft ready: {n} rows. Review, revise, then ACC save.',
    'qj.uploadHintAppend': '+{n} new rows · total {total}. Upload more = append below.',
    'qj.uploadHintDone': 'Import done: {imported} journals, skipped {skipped}, errors {errors}.',
    'qj.parseAuto': 'Auto Parse',
    'qj.accSaveSelected': 'ACC Save Selected ({n})',
    'qj.howtoTitle': 'How to upload & ACC',
    'qj.howtoHint': 'Click to expand',
    'qj.howtoS1t': '1. Pick entity',
    'qj.howtoS1': 'Click the JGI or JGT card — every row follows that entity (no mixing).',
    'qj.howtoS2t': '2. Pick bank account',
    'qj.howtoS2': 'Choose the destination account slot. Account numbers come from master — fill via Update if empty.',
    'qj.howtoS3t': '3. Upload & Parse',
    'qj.howtoS3': 'Drop files (any format) then Parse Auto. New files append below — they do not replace existing rows.',
    'qj.howtoS4t': '4. Review table (# & checklist)',
    'qj.howtoS4':
      'Column # = row number. Header checklist: 1× = select all, 2× (double-click) = clear all. Review ✓/?/✕ before ACC.',
    'qj.howtoS5t': '5. ACC then Send Recon',
    'qj.howtoS5':
      'ACC Save Selected = save draft import journals. Send Report = ACC + open the smart reconciliation queue.',
    'qj.howtoTip':
      'Tip: confirm debit/credit, account no, cash/bank, and contra accounts before Yes on the confirm dialog.',
    'qj.autoFillAccount': 'Auto Fill Accounts',
    'qj.setContraSelected': 'Set contra account (selected)',
    'qj.setContraManual': 'Set contra account (manual selected)',
    'qj.fileErrors': 'File errors',
    'qj.avgConfidence': 'Avg confidence',
    'qj.needsOcrScan': 'Needs OCR retry (scan)',
    'qj.fillForm': 'Fill Form',
    'qj.toManual': '+ Manual',
    'qj.manualTitle': 'Manual Multi-Line Entry (Not Single)',
    'qj.manualTitleShort': 'Manual Multi-Line Entry',
    'qj.manualSub':
      'Numeric debit/credit table · Add rows · save selected. Assist tools optional (Auto Fix / contra).',
    'qj.manualTipsTitle': 'Quick tips',
    'qj.manualTip1': 'Scroll the table right for Debit, Credit, Account no, Ref, Cash/Bank, Contra, Map, Review.',
    'qj.manualTip2': 'Fill description + either Debit/Credit + contra account before saving.',
    'qj.manualTip3': 'PT is locked to the left-panel target — change PT there if needed.',
    'qj.manualScrollHint': '↔ Scroll horizontally for all columns',
    'qj.manualCheckSelected': 'Selected: {n} rows',
    'qj.manualCheckInvalid': 'Needs fix: {n} rows',
    'qj.manualCheckValid': 'All selected rows are valid',
    'qj.manualCheckBankOk': 'Cash/bank account ready',
    'qj.manualCheckBankNeed': 'Pick an account on the left panel first',
    'qj.showAssist': 'Assist tools',
    'qj.hideAssist': 'Hide tools',
    'qj.aiParsing': 'AI parsing…',
    'qj.aiParsingHint': 'Gemini reading files… on failure Groq kicks in. Debit/credit normalized.',
    'qj.autoTable': 'AI auto table',
    'qj.autoTableHint': '{n} rows ready · fields auto-filled',
    'qj.dropLockTitle': 'Upload locked',
    'qj.dropLockNeedBoth': 'Complete first: pick company and account — then drop / pick files.',
    'qj.dropLockNeedBank': 'Complete first: pick destination account — then drop / pick files.',
    'qj.dropReadyTitle': 'Drag & drop files here',
    'qj.dropReadyBody': 'All formats · multi-file · auto-parse · AI debit/credit detection',
    'qj.dropPickFiles': 'Choose files',
    'qj.dropAddMore': 'Add files',
    'qj.dropClearFiles': 'Clear all',
    'qj.dropPrev': 'Previous file',
    'qj.dropNext': 'Next file',
    'qj.dropFilesUnit': 'files',
    'qj.dropRemoveFile': 'Remove this file',
    'qj.demoBadge': 'Sample',
    'qj.demoTitle': 'Preview after parse',
    'qj.demoSub': 'Interactive dummy — see how the table looks after AI reads multi-file uploads.',
    'qj.demoShow': 'View sample',
    'qj.demoHide': 'Close',
    'qj.demoFoot':
      'Sample: Bank acct no = rekening · Cash/Bank = 1001 · Contra acct no = 4101/5201… · Direction = bank side in recon. Not saved.',
    'qj.demoRow1Desc': 'INCOMING TRF · Maju Jaya · warehouse invoice',
    'qj.demoRow2Desc': 'BCA ADMIN FEE · transfer fee',
    'qj.demoRow3Desc': 'DP PAYMENT · customer Sinar Abadi',
    'qj.demoContra1': 'Service revenue',
    'qj.demoContra2': 'Operating expense',
    'qj.demoContra3': 'Accounts receivable',
    'qj.demoDirIn': 'Bank Debit',
    'qj.demoDirOut': 'Bank Credit',
    'qj.demoRekHint': 'Bank account number is selectable per row',
    'qj.emptyUploadTitle': 'No table yet',
    'qj.emptyUploadSub': 'Pick company + account, then upload — AI parse fills the table automatically.',
    'qj.skelPreview': 'Column preview',
    'qj.skelSeeHere': 'See here',
    'qj.skelDetailTitle': 'Row detail slots',
    'qj.skelDetailSub': 'After parse, file summary + per-row details appear here.',
    'qj.skelHint1': 'Date · Entity · Description · Bank acct no · Ref',
    'qj.skelHint2': 'Debit/Credit · Cash/Bank · Contra acct no · Type',
    'qj.skelHint3': 'Map direction · AI Gemini/Groq · Send → Recon',
    'qj.sendReport': 'Send Report ({n})',
    'qj.cancelUpload': 'Cancel',
    'qj.sendHint': 'Send = ACC + smart recon queue · Cancel = clear & re-upload',
    'qj.uploadHintCleared': 'Cancelled. All files & table cleared — upload again.',
    'qj.confirmSendKicker': 'Send to reconciliation',
    'qj.confirmSendTitle': 'Send selected report now?',
    'qj.confirmSendLead':
      '{n} rows will be saved as import journals (pending queue) then open Reconciliation.',
    'qj.confirmSendB1': 'Complete fields: date, entity, description, account no, ref, debit/credit, cash/bank, contra, type, map direction.',
    'qj.confirmSendB2': 'Gemini (primary) + Groq (fallback) auto-filled fields — you can edit before sending.',
    'qj.confirmSendB3': 'On Yes, rows enter the smart reconciliation queue to match statements.',
    'qj.confirmCancelKicker': 'Cancel upload',
    'qj.confirmCancelTitle': 'Cancel and clear everything?',
    'qj.confirmCancelLead':
      'All files, draft table, and AI parse results will be removed. Workspace ready to upload again.',
    'qj.confirmCancelB1': 'Upload files + draft rows cleared completely.',
    'qj.confirmCancelB2': 'No journals are written to the database.',
    'qj.confirmCancelB3': 'You can pick entity/account then upload the statement again.',
    'qj.confirmAccKicker': 'ACC save selected',
    'qj.confirmAccTitle': 'Are you sure you already checked?',
    'qj.confirmAccLead':
      '{n} checked rows will be saved as import journals. Make sure you reviewed them before Yes.',
    'qj.confirmAccB1': 'Check column #: date, description, debit/credit, account no, cash/bank, contra.',
    'qj.confirmAccB2': 'Keep only correct rows checked — uncheck unsure/wrong ones.',
    'qj.confirmAccB3': 'On Yes, rows are saved (pending). You can still Send Report to reconciliation.',
    'qj.confirmYes': 'Yes',
    'qj.confirmNo': 'No',
    'qj.confirmYesSendHint': 'Save & open Reconciliation',
    'qj.confirmNoSendHint': 'Stay on this page',
    'qj.confirmYesCancelHint': 'Clear all & start over',
    'qj.confirmNoCancelHint': 'Keep editing the table',
    'qj.confirmYesAccHint': 'Yes, checked — save ACC',
    'qj.confirmNoAccHint': 'Not yet — back to the table',
    'stmt.contraType': 'Contra type',
    'qj.manualTable': 'Manual table',
    'qj.manualTableHint': 'Edit cells inline · use Auto Fix / Auto Fill to speed up',
    'qj.singleTitle': 'Quick single entry',
    'qj.singleSub': 'Pick entity, bank, contra, enter debit/credit → Add to table → Submit',
    'qj.addToTable': 'Add to table',
    'qj.resetForm': 'Reset form',
    'qj.resetFormHint': 'Clear amounts & description — keep PT/bank/account',
    'qj.singleQueueTitle': 'Single-entry queue',
    'qj.singleQueueSub': '{n} rows ready to save',
    'qj.singleQueueEmpty': 'No rows yet — fill the form, then click Add to table.',
    'qj.singleQueueDummySub': 'Sample table (dummy) — fill the form & Add to replace with real data',
    'qj.singleDummyBadge': 'SAMPLE',
    'qj.singleDummy1': 'INCOMING TRF · sample warehouse invoice',
    'qj.singleDummy2': 'ADMIN FEE · sample transfer fee',
    'qj.singleDummy3': 'DP PAYMENT · sample customer',
    'qj.singleActive': 'Active',
    'qj.singleActiveOn': 'Include in table (checked)',
    'qj.singleActiveOff': 'Inactive in table',
    'qj.singleSubmit': 'Submit ({n})',
    'qj.confirmContinueTitle': 'Are you sure you want to continue?',
    'qj.confirmSingleSubmitKicker': 'Submit queue',
    'qj.confirmSingleSubmitLead': 'Submit {n} selected rows to the reconciliation queue?',
    'qj.confirmSingleSubmitB1': 'Check entity, description, debit/credit, account no, cash/bank, contra, map, review.',
    'qj.confirmSingleSubmitB2': 'Only checked (active) rows are sent.',
    'qj.confirmSingleSubmitB3': 'On Yes, rows are saved as pending for statement matching.',
    'qj.confirmSingleCancelKicker': 'Cancel entry',
    'qj.confirmSingleCancelLead': 'Clear the queue and reset the single-entry form?',
    'qj.confirmSingleCancelB1': 'Table queue is cleared (dummy returns).',
    'qj.confirmSingleCancelB2': 'Nothing is written to the database.',
    'qj.confirmYesSingleSubmitHint': 'Yes — submit now',
    'qj.confirmNoSingleSubmitHint': 'Not yet — keep checking',
    'qj.confirmYesSingleCancelHint': 'Yes — clear',
    'qj.confirmNoSingleCancelHint': 'No — keep editing',
    'qj.errDebitOrCredit': 'Fill only one side: Debit or Credit (not both).',
    'qj.confManualSingle': 'Filled manually (single entry)',
    'qj.clearQueue': 'Clear',
    'qj.saveQueue': 'Save queue ({n})',
    'qj.errNoSingleQueue': 'No real selected rows in the queue (dummy rows are not submitted).',
    'qj.addRow': 'Add Row',
    'qj.addRowNeedPt': 'Select PT JGI / JGT first — then you can add rows.',
    'qj.addRowNeedBank': 'Select an account first — then Add Row appears.',
    'qj.saveMulti': 'Save Multi Rows ({n})',
    'qj.manualSelected': 'Manual selected',
    'qj.resetRow': 'Reset row',
    'qj.removeRow': 'Remove row',
    'qj.resetAllRows': 'Reset all to start',
    'qj.removeSelected': 'Delete selected ({n})',
    'qj.selectInvalid': 'Select invalid',
    'qj.expandTitle': 'Expand Quick Debit / Credit',
    'qj.confUnevaluated': 'Not evaluated yet',
    'qj.confEmptyContra': 'Contra account empty.',
    'qj.confStrongKeyword': 'Strong keyword detected.',
    'qj.confNeedVerify': 'Some context found — still verify.',
    'qj.confDescThin': 'Description too short.',
    'qj.confParserFilled': 'Parser filled contra account — double-check.',
    'qj.confContraMissing': 'Contra account not detected.',
    'qj.errNoTxn': 'Files uploaded, but no readable transactions were found.',
    'qj.errParseUpload': 'Failed to process upload',
    'qj.errNoUploadSelected': 'No upload rows selected.',
    'qj.errUploadInvalid': '{n} upload rows are still invalid (debit/credit/accounts/date).',
    'qj.errSaveUpload': 'Failed to save upload results',
    'qj.errManualNeedRow':
      'Fill at least 1 valid manual row (debit/credit + bank account + contra).',
    'qj.errManualInvalid': '{n} manual rows are still invalid (debit/credit/accounts/date).',
    'qj.errSaveManual': 'Failed to save manual rows',
    'qj.errManualDate': '{n} rows are missing a full date (year-month-day). Fill them before saving.',
    'qj.errNeedDate': 'A full date (year-month-day) is required.',
    'qj.errNeedDesc': '{n} rows are missing a description — fill them (red boxes) before continuing.',

    'stx.scrollHint': 'Scroll right · review ✓/?/✕ · tag DP/Prepaid · pick accounts before recon',
    'stx.massCheckHint': '1× select all · 2× clear checklist',
    'stx.descRequired': 'Description is required',
    'stx.toolbar': 'Table tools',
    'stx.showTools': 'Tools',
    'stx.hideTools': 'Hide tools',
    'stx.lanes': 'Row filters',
    'stx.segSelect': 'Select rows',
    'stx.selected': 'Selected',
    'stx.fillDates': 'Fill empty dates',
    'stx.fillDatesShort': 'Dates',
    'stx.deleteAll': 'Delete all',
    'stx.enlarge': 'Enlarge table',
    'stx.confirmDeleteAll': 'Delete all rows in this table?',
    'stx.review': 'Review',
    'stx.tag': 'Quick tag',
    'stx.wrong': 'Wrong',
    'stx.unsure': 'Unsure',
    'stx.markOk': 'OK',
    'stx.markWrong': 'Wrong',
    'stx.markUnsure': 'Unsure',
    'stx.selectUnsure': 'Select unsure',
    'stx.applyGate': 'Auto ✓/? confidence',
    'stx.applyGateShort': 'Auto ✓/?',
    'stx.openDpWizard': 'DP wizard',
    'stx.laneEmpty': 'No rows in this lane',
    'stx.lane.all': 'All',
    'stx.lane.unsure': 'Needs check',
    'stx.lane.dp': 'DP',
    'stx.lane.prepaid': 'Prepaid',
    'stx.lane.no_acct': 'Missing account',
    'stx.lane.wrong': 'Wrong',
    'stx.lane.ok': 'OK',
    'stx.ptLocked': 'PT locked to the gate selection — cannot mix companies',
    'stx.refLocked': 'NoRef auto from available J7P numbers — not selectable',
    'stx.refAutoBadge': 'Auto',
    'stx.refAutoPending': 'Pending…',
    'stx.perPage': 'Per page',
    'stx.pageAll': 'All',
    'stx.pageAllCapped': 'All capped (>{max}) → 50/page',
    'stx.pageAllCappedHint': 'Large datasets are paginated so the page stays responsive.',
    'stx.pagination': 'Page navigation',
    'stx.pagePrev': 'Previous page',
    'stx.pageNext': 'Next page',
    'stx.pageShowing': 'Showing {from}–{to} of {total}',
    'qj.errNeedHuman': '{n} low-confidence rows — mark ✓ or fix accounts first.',
    'stmt.snackNeedHuman': '{n} rows still need a human check (low confidence / missing account).',
    'recon.rowDpHint': 'DP / unearned — match to pending cash in, not revenue',
    'recon.matchDpHint': 'This pair looks like a DP. Match cash receipt ↔ customer advances (2600).',
    'stmt.postPending': 'Recon queue (pending)',
    'stmt.postCleared': 'Post to reports now (cleared)',
    'stx.needReview': 'Fix or uncheck wrong/unsure rows before reconciliation.',
    'stmt.reviewHint': 'Check contra accounts · mark ✓/✕ · tag DP/Prepaid before save.',
    'stmt.tagDp': 'DP',
    'stmt.tagPrepaid': 'Prepaid',
    'stmt.tagAr': 'AR',
    'stmt.tagAp': 'AP',
    'stmt.markOk': 'OK',
    'stmt.markWrong': 'Wrong',
    'stmt.markUnsure': 'Unsure',
    'stmt.bulkOk': 'Mark ✓ selected',
    'stmt.bulkWrong': 'Mark ✕ selected',
    'stmt.snackNeedReview': '{n} rows marked wrong — fix accounts, uncheck, or mark ✓ first.',
    'qj.errNeedReview': '{n} rows marked wrong — fix accounts or uncheck before save.',

    'dash.expandByCompany': 'Expand by Company',
    'dash.expandActivity': 'Expand Activity',
    'dash.expandOmset': 'Expand Omset',
    'dash.expandBank': 'Expand Bank Balances',
    'dash.expandInsight': 'Expand Analytics',

    'tax.hubTitle': 'Tax Center',
    'tax.hubSub': 'Final MSME income tax (PP 55/2022) per period — calculate & auto-post journals',
    'tax.vatTitle': 'VAT Summary',
    'tax.vatSub': 'Monitor output VAT from invoices versus input VAT from vendor bills by period.',
    'tax.vatOutput': 'Output VAT',
    'tax.vatInput': 'Input VAT',
    'tax.vatNet': 'Net VAT',
    'tax.vatMonthly': 'Monthly movement',
    'tax.vatHint': 'Positive net means potential VAT payable, negative net means input-credit / operational overpayment.',
    'tax.vatGapFilter': '{n} periods without paid SSP',
    'tax.vatSspAmount': 'SSP paid',
    'tax.vatSspStatus': 'SSP status',
    'tax.vatNtpn': 'NTPN',
    'tax.vatAction': 'Action',
    'tax.vatDraftAll': 'Create VAT SSP drafts',
    'tax.vatDraftOne': 'Draft',
    'tax.vatOpenSsp': 'Open SSP',
    'tax.vatNeedCompany': 'Pick a company before creating VAT SSP drafts',
    'tax.vatDrafted': '{n} VAT SSP drafts created',
    'tax.vatDraftSkipped': 'No new SSP drafts needed',
    'tax.vatExport': 'Export Excel',
    'tax.vatExportPdf': 'Export PDF',
    'tax.vatSalesDocs': 'Invoices',
    'tax.vatPurchaseDocs': 'Vendor bills',
    'tax.pph21Title': 'Art.21 — calculator & upload',
    'tax.pph21ExportPdf': 'Export PDF',
    'tax.pph21Sub': 'Estimate Art.21 tax, then upload withholding slips / monthly returns into the system.',
    'tax.pph21Employee': 'Employee (optional)',
    'tax.pph21EmployeeHint': 'Pick from the HR roster — resigned status and tenure are shown.',
    'tax.pph21Status': 'PTKP status',
    'tax.pph21Base': 'Base salary',
    'tax.pph21Allowance': 'Allowance',
    'tax.pph21Gross': 'Monthly gross',
    'tax.pph21Annual': 'Annual gross',
    'tax.pph21Ptkp': 'PTKP',
    'tax.pph21TakeHome': 'Net after Art.21',
    'tax.pph21MethodTitle': 'Method summary',
    'tax.pph21MethodNote': 'This calculator uses the current simplified annual formula already used by the payroll preview.',
    'tax.pph21MethodGross': 'Annualized gross from monthly gross: {amount}',
    'tax.pph21MethodPtkp': 'PTKP for status {status}: {amount}',
    'tax.pph21MethodPkp': 'Estimated taxable base after PTKP: {amount}',
    'tax.pph21UploadKicker': 'Into the system',
    'tax.pph21UploadTitle': 'Upload Art.21 documents',
    'tax.pph21UploadSub': 'PDF/CSV withholding slips, monthly SPT, or e-billing — stored in the tax archive.',
    'tax.pph21UploadKind': 'Document kind',
    'tax.pph21UploadFile': 'PDF / CSV file',
    'tax.pph21UploadTitleField': 'Title (optional)',
    'tax.pph21UploadBtn': 'Upload to system',
    'tax.pph21UploadOk': 'Art.21 file saved',
    'tax.pph21UploadArchive': 'Open archive',
    'tax.pph21NeedFile': 'Choose a file first',
    'tax.pph21NeedCompany': 'Select a company before upload',
    'tax.postAll': 'Post all periods',
    'tax.postAllShort': 'Post all',
    'tax.rate': 'Final tax rate',
    'tax.gross': 'Gross circulation',
    'tax.post': 'Post',
    'tax.posted': 'Posted',
    'tax.snackPosted': 'Tax journal {ref} · {amount}',
    'tax.snackExists': 'Already exists {ref}',
    'tax.snackFail': 'Posting failed',
    'tax.month': 'Period',
    'tax.sptTitle': 'Periodic tax pack',
    'tax.sptOpen': 'Open & print PDF',
    'tax.sptOpenShort': 'Print PDF',
    'tax.sptPx.kicker': 'Period readiness',
    'tax.sptPx.sub':
      'Print-ready HTML/PDF — attachment checklist, PPh 23, payroll, SSP. Company tax ID required.',
    'tax.sptPx.loadedAt': 'Loaded {t}',
    'tax.sptPx.chipReady': 'Ready to open',
    'tax.sptPx.chipBlocked': 'Missing required tax ID / data',
    'tax.sptPx.bannerBlocked': 'Pack cannot open yet — complete company tax ID & required fields',
    'tax.sptPx.bannerGaps': '{n} items incomplete · readiness {pct}%',
    'tax.sptPx.bannerOk': 'Checklist complete — pack ready to print',
    'tax.sptPx.focusGapsShort': 'View gaps',
    'tax.sptPx.kpiReady': 'Readiness',
    'tax.sptPx.kpiReadyMeta': '{ok}/{total} items OK',
    'tax.sptPx.kpiGaps': 'Incomplete',
    'tax.sptPx.kpiGapsMeta': '{n} required items missing',
    'tax.sptPx.kpiAttach': 'Attachments',
    'tax.sptPx.kpiAttachMeta': 'PPh 23 + payroll + SSP',
    'tax.sptPx.kpiPph': 'Period final PPh',
    'tax.sptPx.notPosted': 'Not posted',
    'tax.sptPx.vizReady': 'Checklist readiness',
    'tax.sptPx.vizAttach': 'Period attachments',
    'tax.sptPx.vizSnapshot': 'Pack snapshot',
    'tax.sptPx.vizAttachHint': 'PPh 23 {wht} · SSP {ssp}',
    'tax.sptPx.meterLabel': 'Readiness progress',
    'tax.sptPx.readyOk': 'Done',
    'tax.sptPx.readyGap': 'Missing',
    'tax.sptPx.attWht': 'Withholdings',
    'tax.sptPx.attPayroll': 'Payroll',
    'tax.sptPx.attSsp': 'SSP',
    'tax.sptPx.attNtpn': 'NTPN',
    'tax.sptPx.npwpMissing': 'Not filled',
    'tax.sptPx.snapPph': 'Final PPh journal',
    'tax.sptPx.snapKpp': 'Tax office',
    'tax.sptPx.healthTitle': 'Readiness lanes',
    'tax.sptPx.healthSub': 'Click to filter the checklist',
    'tax.sptPx.tipsTitle': 'Action tips',
    'tax.sptPx.tipNpwp': 'Fill company tax ID before opening the pack',
    'tax.sptPx.tipAddress': 'Complete company address in master data',
    'tax.sptPx.tipPph': 'Post the final PPh journal for this period',
    'tax.sptPx.tipSsp': 'Add billing / SSP codes for this period',
    'tax.sptPx.tipCal': 'Check deadlines on the Tax Calendar',
    'tax.sptPx.tipOk': 'Pack is ready — open & print PDF',
    'tax.sptPx.focusReady': 'Focus: completed items',
    'tax.sptPx.focusGaps': 'Focus: incomplete items',
    'tax.sptPx.focusAttach': 'Focus: period attachments',
    'tax.sptPx.clearFocus': 'Clear focus',
    'tax.sptPx.empty': 'Tax pack not loaded',
    'tax.sptPx.emptyHint': 'Pick company / period then refresh',
    'tax.sptPx.checkKicker': 'Checklist',
    'tax.sptPx.checkTitle': 'Attachment completeness',
    'tax.sptPx.checkSub': 'Required items must be green before opening',
    'tax.sptPx.statusOk': 'OK',
    'tax.sptPx.statusRequired': 'Required — missing',
    'tax.sptPx.statusOptional': 'Optional — missing',
    'tax.sptPx.noChecks': 'No items for this focus',
    'tax.sptPx.actionKicker': 'Actions',
    'tax.sptPx.actionTitle': 'Open pack & fixes',
    'tax.sptPx.actionSub': 'Print HTML to PDF (Ctrl+P). Not official e-Filing.',
    'tax.sptPx.openTaxHub': 'Tax Center (final PPh)',
    'tax.sptPx.openTaxHubShort': 'Tax hub',
    'tax.sptPx.refreshShort': 'Reload',
    'tax.sptPx.calShort': 'Calendar',
    'tax.sptPx.whtShort': 'WHT',
    'tax.sptPx.sspShort': 'SSP',
    'tax.sptPx.statusRequiredShort': 'Required',
    'tax.sptPx.statusOptionalShort': 'Optional',
    'tax.sptPx.blockedNpwp': 'Tax ID incomplete — finish it under Companies',
    'tax.sptPx.footerNote':
      'Pack is for consultant completeness. Add SSP/NTPN after payment.',
    'tax.sptPx.check.npwp': 'Company identity & tax ID',
    'tax.sptPx.check.address': 'Company address',
    'tax.sptPx.check.kpp': 'Registered tax office',
    'tax.sptPx.check.pph': 'Final PPh journal for period',
    'tax.sptPx.check.wht': 'PPh 23 withholding slips (if any)',
    'tax.sptPx.check.payroll': 'PPh 21 / payroll',
    'tax.sptPx.check.ssp': 'Billing code / SSP',
    'tax.sptPx.check.ntpn': 'NTPN filled (after payment)',
    'tax.fillNpwp': 'Complete company tax ID',
    'tax.fillNpwpShort': 'Fill tax ID',
    'tax.fiscalTitle': 'Fiscal adjustments',
    'tax.fiscalAdd': 'Add rule',
    'tax.fiscalAddShort': 'Add',
    'tax.fiscalSaved': 'Rule saved — used in financial statements',
    'tax.fiscPx.kicker': 'Fiscal P&L rules',
    'tax.fiscPx.loadedAt': 'Loaded {t}',
    'tax.fiscPx.ctxGlobal': 'Global (all companies)',
    'tax.fiscPx.chipYear': 'FS {year}',
    'tax.fiscPx.chipInactive': '{n} inactive',
    'tax.fiscPx.chipOk': '{n} active',
    'tax.fiscPx.bannerInactive': '{n} inactive rules — not applied in FS',
    'tax.fiscPx.bannerOk': '{n} active · {zero} zero-out on fiscal P&L',
    'tax.fiscPx.focusInactiveShort': 'View inactive',
    'tax.fiscPx.kpiCount': 'Rule count',
    'tax.fiscPx.kpiCountMeta': 'All treatments',
    'tax.fiscPx.kpiActive': 'Active',
    'tax.fiscPx.kpiActiveMeta': '{n} inactive',
    'tax.fiscPx.kpiZeroOut': 'Zero-out',
    'tax.fiscPx.kpiZeroOutMeta': 'Fiscal = 0 on FS',
    'tax.fiscPx.kpiGaps': 'Needs review',
    'tax.fiscPx.kpiGapsMeta': '{reason} without basis · {partial} partial',
    'tax.fiscPx.vizTreatment': 'Treatment mix',
    'tax.fiscPx.vizActive': 'Active status',
    'tax.fiscPx.vizSnapshot': 'Impact snapshot',
    'tax.fiscPx.snapZeroOut': 'Zero-out accounts',
    'tax.fiscPx.snapMissingReason': 'Missing basis/reason',
    'tax.fiscPx.snapPartial': 'Partial % adjustments',
    'tax.fiscPx.snapNone': 'No adjustment (none)',
    'tax.fiscPx.healthTitle': 'Rule lanes',
    'tax.fiscPx.healthSub': 'Click to filter the rule list',
    'tax.fiscPx.laneActive': 'Active',
    'tax.fiscPx.laneInactive': 'Inactive',
    'tax.fiscPx.tipsTitle': 'Action tips',
    'tax.fiscPx.tipInactive': '{n} inactive rules — enable or delete',
    'tax.fiscPx.tipReason': '{n} missing legal basis / reason',
    'tax.fiscPx.tipPartial': '{n} percent adjustments under 100%',
    'tax.fiscPx.tipLk': 'Check impact on Financial Statements (fiscal column)',
    'tax.fiscPx.tipHub': 'Back to Tax Center',
    'tax.fiscPx.tipAdd': 'Add a rule for a new account',
    'tax.fiscPx.tipOk': 'Rules look healthy — ready for FS',
    'tax.fiscPx.focusTreatment': 'Treatment filter: {s}',
    'tax.fiscPx.focusActive': 'Filter: active',
    'tax.fiscPx.focusInactive': 'Filter: inactive',
    'tax.fiscPx.focusSearch': 'Search: “{q}”',
    'tax.fiscPx.clearFocus': 'Clear focus',
    'tax.fiscPx.empty': 'No fiscal rules yet',
    'tax.fiscPx.emptyHint': 'Add zero / percent / none rules for accounts to adjust',
    'tax.fiscPx.tableKicker': 'Register',
    'tax.fiscPx.tableTitle': 'Adjustment rules',
    'tax.fiscPx.tableSub': 'Showing {shown} of {total}',
    'tax.fiscPx.searchPh': 'Search code / account / treatment / basis…',
    'tax.fiscPx.noRows': 'No matching rows',
    'tax.fiscPx.action': 'Action',
    'tax.fiscPx.treatZero': 'Zero (full)',
    'tax.fiscPx.treatNone': 'None (no adjustment)',
    'tax.fiscPx.treatPercent': 'Percent',
    'tax.fiscPx.noReason': 'No basis',
    'tax.fiscPx.impactZero': 'On FS: fiscal value for this account = 0',
    'tax.fiscPx.impactNone': 'On FS: follows commercial (no adjustment)',
    'tax.fiscPx.impactPercent': 'On FS: adjust {p}% of the balance',
    'tax.fiscPx.impactInactive': 'Not applied until activated',
    'tax.fiscPx.previewLabel': 'Impact on FS',
    'tax.fiscPx.needCode': 'Account code is required',
    'tax.fiscPx.deleted': 'Rule deleted',
    'tax.fiscPx.exportCsv': 'Export CSV',
    'tax.fiscPx.exportCsvShort': 'CSV',
    'tax.fiscPx.refreshShort': 'Reload',
    'tax.fiscPx.searchLabel': 'Search',
    'tax.fiscPx.exportEmpty': 'No rows to export',
    'tax.fiscPx.footerNote':
      'Rules are global across companies. Zero / percent ≥100% zero-out the account on fiscal P&L.',
    'tax.whtTitle': 'Withholding tax / certificates',
    'tax.whtSub': 'Third-party withholding register',
    'tax.whtAdd': 'Add',
    'tax.whtVendor': 'Vendor name',
    'tax.whtDpp': 'Tax base',
    'tax.whtNo': 'Certificate no.',
    'tax.whtSaved': 'Withholding certificate saved',
    'tax.whtPx.kicker': 'Withholding register',
    'tax.whtPx.loadedAt': 'Loaded {t}',
    'tax.whtPx.chipDraft': '{n} draft',
    'tax.whtPx.chipOk': 'No drafts',
    'tax.whtPx.bannerDraft': '{n} certificates still draft · {amount}',
    'tax.whtPx.bannerOk': '{n} certificates · total PPh 23 {amount}',
    'tax.whtPx.focusDraftShort': 'View drafts',
    'tax.whtPx.kpiCount': 'Certificate count',
    'tax.whtPx.kpiCountMeta': 'Year {year}',
    'tax.whtPx.kpiDpp': 'Total tax base',
    'tax.whtPx.kpiDppMeta': 'Withholding tax base',
    'tax.whtPx.kpiPphMeta': 'Total PPh 23 withheld',
    'tax.whtPx.kpiDraft': 'Draft',
    'tax.whtPx.kpiDraftMeta': '{amount} not yet issued',
    'tax.whtPx.vizStatus': 'Certificate status',
    'tax.whtPx.vizMonth': 'PPh by month',
    'tax.whtPx.vizSnapshot': 'Register snapshot',
    'tax.whtPx.vizEmpty': 'No monthly data yet',
    'tax.whtPx.monthCount': '{n} certificates',
    'tax.whtPx.snapMissingBukti': 'Missing certificate no.',
    'tax.whtPx.snapMissingNpwp': 'Missing vendor tax ID',
    'tax.whtPx.snapAvgRate': 'Effective rate',
    'tax.whtPx.snapReported': 'Reported',
    'tax.whtPx.healthTitle': 'Status lanes',
    'tax.whtPx.healthSub': 'Click to filter the register',
    'tax.whtPx.tipsTitle': 'Action tips',
    'tax.whtPx.tipDraft': '{n} certificates still draft — complete & issue',
    'tax.whtPx.tipBukti': '{n} rows without certificate numbers',
    'tax.whtPx.tipNpwp': '{n} vendors without tax ID',
    'tax.whtPx.tipSpt': 'Include in the monthly tax pack when ready to e-File',
    'tax.whtPx.tipAdd': 'Record a new withholding certificate',
    'tax.whtPx.tipOk': 'Register healthy — no urgent drafts',
    'tax.whtPx.focusStatus': 'Status filter: {s}',
    'tax.whtPx.focusSearch': 'Search: “{q}”',
    'tax.whtPx.clearFocus': 'Clear focus',
    'tax.whtPx.empty': 'No withholding certificates yet',
    'tax.whtPx.emptyHint': 'Add PPh 23 for vendors this year',
    'tax.whtPx.tableKicker': 'Register',
    'tax.whtPx.tableTitle': 'Withholding certificates {year}',
    'tax.whtPx.tableSub': 'Showing {shown} of {total}',
    'tax.whtPx.searchPh': 'Search vendor / certificate / tax ID…',
    'tax.whtPx.searchLabel': 'Search',
    'tax.whtPx.noRows': 'No matching rows',
    'tax.whtPx.action': 'Action',
    'tax.whtPx.rateLabel': 'PPh 23 rate',
    'tax.whtPx.statusDraft': 'Draft',
    'tax.whtPx.statusIssued': 'Issued',
    'tax.whtPx.statusReported': 'Reported',
    'tax.whtPx.noNpwp': 'No tax ID',
    'tax.whtPx.addTitle': 'Add withholding certificate',
    'tax.whtPx.editTitle': 'Edit withholding certificate',
    'tax.whtPx.needCompany': 'Select a company before saving',
    'tax.whtPx.deleted': 'Withholding certificate deleted',
    'tax.whtPx.exportCsv': 'Export CSV',
    'tax.whtPx.exportCsvShort': 'CSV',
    'tax.whtPx.refreshShort': 'Reload',
    'tax.whtPx.exportEmpty': 'No rows to export',
    'tax.whtPx.footerNote': 'Default rate 2%. Status flow: draft → issued → reported in monthly SPT.',
    'tax.sspTitle': 'e-Bupot / SSP billing tracker',
    'tax.sspSub': 'One-by-one dossier · PPN & Art.23 billing · e-bupot / SPT archive',
    'tax.sspAdd': 'Add',
    'tax.sspSaved': 'SSP saved',
    'tax.sspPx.kicker': 'e-Bupot · dossier',
    'tax.sspPx.loadedAt': 'Loaded {t}',
    'tax.sspPx.chipOverdue': '{n} overdue',
    'tax.sspPx.chipUnpaid': '{n} unpaid',
    'tax.sspPx.chipOk': 'All paid',
    'tax.sspPx.bannerOverdue': '{n} SSP overdue · {amount}',
    'tax.sspPx.bannerUnpaid': '{n} unpaid · {amount}',
    'tax.sspPx.bannerOk': '{n} billings · paid {amount}',
    'tax.sspPx.focusOverdueShort': 'View overdue',
    'tax.sspPx.focusUnpaidShort': 'View unpaid',
    'tax.sspPx.kpiCount': 'SSP count',
    'tax.sspPx.kpiCountMeta': 'Year {year}',
    'tax.sspPx.kpiAmount': 'Total amount',
    'tax.sspPx.kpiAmountMeta': 'All statuses',
    'tax.sspPx.kpiUnpaid': 'Unpaid',
    'tax.sspPx.kpiUnpaidMeta': '{amount} outstanding',
    'tax.sspPx.kpiOverdue': 'Overdue',
    'tax.sspPx.kpiOverdueMeta': '{amount} past due',
    'tax.sspPx.vizStatus': 'Payment status',
    'tax.sspPx.vizType': 'Tax types',
    'tax.sspPx.vizSnapshot': 'Compliance snapshot',
    'tax.sspPx.vizMonth': 'Amount by period',
    'tax.sspPx.vizEmpty': 'No type data yet',
    'tax.sspPx.typeCount': '{n} billings',
    'tax.sspPx.snapMissingBilling': 'Missing billing code',
    'tax.sspPx.snapMissingNtpn': 'Billed without NTPN',
    'tax.sspPx.snapPaidPct': 'Paid share',
    'tax.sspPx.snapDueSoon': 'Due within 14 days',
    'tax.sspPx.healthTitle': 'Status lanes',
    'tax.sspPx.healthSub': 'Click to filter the SSP list',
    'tax.sspPx.tipsTitle': 'Action tips',
    'tax.sspPx.tipOverdue': '{n} overdue · {amount} — pay now',
    'tax.sspPx.tipDueSoon': '{n} due within 14 days',
    'tax.sspPx.tipBilling': '{n} missing a billing code',
    'tax.sspPx.tipNtpn': '{n} billings still missing NTPN',
    'tax.sspPx.tipCal': 'Check deadlines in Tax Calendar',
    'tax.sspPx.tipSpt': 'Attach NTPN to the monthly SPT pack',
    'tax.sspPx.tipAdd': 'Record a new billing / SSP',
    'tax.sspPx.tipOk': 'Billing is healthy — nothing overdue',
    'tax.sspPx.focusStatus': 'Status filter: {s}',
    'tax.sspPx.focusType': 'Type filter: {t}',
    'tax.sspPx.focusSearch': 'Search: “{q}”',
    'tax.sspPx.clearFocus': 'Clear focus',
    'tax.sspPx.empty': 'No SSP billings yet',
    'tax.sspPx.emptyHint': 'Add billing codes, due dates, and NTPN for this year',
    'tax.sspPx.tableKicker': 'Register',
    'tax.sspPx.tableTitle': 'SSP billings {year}',
    'tax.sspPx.tableSub': 'Showing {shown} of {total}',
    'tax.sspPx.searchPh': 'Search period / billing / NTPN / type…',
    'tax.sspPx.noRows': 'No matching rows',
    'tax.sspPx.action': 'Action',
    'tax.sspPx.statusOpen': 'Not billed',
    'tax.sspPx.statusBilled': 'Billed',
    'tax.sspPx.statusPaid': 'Paid',
    'tax.sspPx.statusOverdue': 'Overdue',
    'tax.sspPx.noBilling': 'None',
    'tax.sspPx.noNtpn': 'None',
    'tax.sspPx.paidAt': 'Paid {d}',
    'tax.sspPx.paidDate': 'Payment date',
    'tax.sspPx.addTitle': 'Add SSP billing',
    'tax.sspPx.editTitle': 'Edit SSP billing',
    'tax.sspPx.needCompany': 'Select a company before saving',
    'tax.sspPx.needFile': 'Choose a PDF/CSV file first',
    'tax.sspPx.gapsKicker': '7 priority sources',
    'tax.sspPx.gapsTitle': 'Statement sources still missing',
    'tax.sspPx.gapsSub': 'Jan–Jul {year} coverage. Re-upload via E-Statement if empty.',
    'tax.sspPx.gapsMissing': 'Missing: {months}',
    'tax.sspPx.gapsOk': 'Present in GL',
    'tax.sspPx.gapsHint': '{n} sources still incomplete — prioritize e-statement upload.',
    'tax.sspPx.uploadKicker': 'Tax archive',
    'tax.sspPx.uploadTitle': 'Upload e-billing / e-bupot / SPT',
    'tax.sspPx.uploadSub': 'For VAT & Art.23 — files go into the tax documents archive.',
    'tax.sspPx.vaultKicker': 'e-Bupot vault',
    'tax.sspPx.vaultTitle': 'Upload withholding slips / e-billing / SPT',
    'tax.sspPx.vaultSub': '{n} files this year in the archive — upload PDF/CSV then link to a period.',
    'tax.sspPx.uploadKind': 'Document kind',
    'tax.sspPx.uploadFile': 'PDF / CSV file',
    'tax.sspPx.uploadBtn': 'Upload',
    'tax.sspPx.uploadOk': 'Tax file saved',
    'tax.sspPx.uploadArchive': 'Open archive',
    'tax.sspPx.uploadDialogHint': 'Optional: attach when saving VAT / Art.23 billing',
    'tax.sspPx.viewDossier': 'Detail',
    'tax.sspPx.viewTable': 'Table',
    'tax.sspPx.timelineKicker': 'Period coverage',
    'tax.sspPx.timelineTitle': 'e-Bupot & SSP timeline',
    'tax.sspPx.timelineSub': 'Click a month to filter · avg completeness {pct}% · {year}',
    'tax.sspPx.timelineTip': 'Period {m}: {n} billings · {docs} files · {amount}',
    'tax.sspPx.completenessShort': 'Complete',
    'tax.sspPx.completenessAvg': 'Average completeness {pct}%',
    'tax.sspPx.completenessOf': '{done}/{total} steps',
    'tax.sspPx.stepAmount': 'Amount',
    'tax.sspPx.stepBilling': 'Billing',
    'tax.sspPx.stepDue': 'Due date',
    'tax.sspPx.stepNtpn': 'NTPN/Paid',
    'tax.sspPx.stepDoc': 'File',
    'tax.sspPx.markPaid': 'Mark paid',
    'tax.sspPx.markedPaid': 'Marked as paid',
    'tax.sspPx.attachDoc': 'Attach file',
    'tax.sspPx.attachedDocs': '{n} attached files',
    'tax.sspPx.noAttachedDoc': 'No e-bupot / e-billing attached for this period yet.',
    'tax.sspPx.copiedBilling': 'Billing code copied',
    'tax.sspPx.copiedNtpn': 'NTPN copied',
    'tax.sspPx.draftWht': 'From withholdings',
    'tax.sspPx.draftWhtShort': 'From WHT',
    'tax.sspPx.draftWhtOk': '{n} SSP drafts created from {wht} certificates ({skip} skipped)',
    'tax.sspPx.draftWhtSkip': 'All periods already have SSP ({skip} skipped · {wht} certificates)',
    'tax.sspPx.draftWhtEmpty': 'No withholding certificates this year to generate from',
    'tax.sspPx.chipDueOverdue': '{n} overdue',
    'tax.sspPx.chipDueH1': '{n} D−1',
    'tax.sspPx.chipDueH3': '{n} D−3',
    'tax.sspPx.focusDueH1': 'Filter: due D−1',
    'tax.sspPx.focusDueH3': 'Filter: due within 3 days',
    'tax.sspPx.tipDueH1': '{n} due today/tomorrow · {amount}',
    'tax.sspPx.tipDueH3': '{n} due within 3 days · {amount}',
    'tax.sspPx.urgOverdue': 'Overdue',
    'tax.sspPx.urgH1': 'D−1',
    'tax.sspPx.urgH3': 'D−3',
    'tax.sspPx.urgSoon': '≤14d',
    'tax.sspPx.coreTitle': 'Coretax checklist',
    'tax.sspPx.corePct': '{done}/{total} · {pct}%',
    'tax.sspPx.core.bupot': 'e-Bupot / certificate',
    'tax.sspPx.core.billing': 'e-Billing code',
    'tax.sspPx.core.pay': 'Pay / remit',
    'tax.sspPx.core.ntpn': 'Enter NTPN',
    'tax.sspPx.core.spt': 'Attach to monthly SPT',
    'tax.sspPx.coreTodo': 'Todo',
    'tax.sspPx.coreDone': 'Done',
    'tax.sspPx.coreBupotMeta': '{n} certificates linked',
    'tax.sspPx.openWht': 'Open withholdings',
    'tax.sspPx.openCalendar': 'Tax calendar',
    'tax.sspPx.openSpt': 'Monthly SPT pack',
    'tax.sspPx.whtLinked': '{n} certificates this period',
    'tax.sspPx.deleted': 'SSP deleted',
    'tax.sspPx.exportCsv': 'Export CSV',
    'tax.sspPx.exportCsvShort': 'CSV',
    'tax.sspPx.refreshShort': 'Reload',
    'tax.sspPx.searchLabel': 'Search',
    'tax.sspPx.exportEmpty': 'No rows to export',
    'tax.sspPx.previewLabel': 'SSP amount',
    'tax.sspPx.monthLabel': 'Month {m}',
    'tax.sspPx.footerNote':
      'Effective status: past due without payment = overdue. Fill NTPN after paying on DJP Online.',
    'tax.type.final': 'Final MSME income tax',
    'tax.type.pph21': 'Art. 21 withholding',
    'tax.type.pph23': 'Art. 23 withholding',
    'tax.type.pph25': 'Art. 25 installment',
    'tax.type.ppn': 'VAT',
    'tax.type.other': 'Other',
    'tax.postingHint':
      'Posting creates journals: Dr Final Income Tax (5009) / Cr Final Income Tax Payable (2303). Duplicate periods are skipped (unique ref). Tax pack details are also on Financial Statements.',
    'tax.journalRef': 'Journal Ref',
    'tax.action': 'Action',
    'tax.openLkSpt': 'Open Financial Statements (tax pack tab)',
    'tax.px.kicker': 'Tax compliance',
    'tax.px.loadedAt': 'Loaded {t}',
    'tax.px.chipPending': '{n} periods awaiting post',
    'tax.px.chipDone': 'All periods posted',
    'tax.px.chipNeedPost': 'Needs posting',
    'tax.px.bannerPending': '{n} periods not posted · {amount}',
    'tax.px.bannerOk': 'All periods with turnover have final PPh journals',
    'tax.px.focusPendingShort': 'View pending',
    'tax.px.kpiBruto': 'Gross turnover {year}',
    'tax.px.kpiBrutoMeta': '{n} periods with turnover',
    'tax.px.kpiPph': 'Final MSME PPh {year}',
    'tax.px.kpiPphMeta': 'Rate × gross turnover',
    'tax.px.kpiRateMeta': 'PP 55/2022 (MSME)',
    'tax.px.kpiProgress': 'Posting progress',
    'tax.px.kpiProgressMeta': '{pct}% of taxable periods posted',
    'tax.px.vizMonthly': 'PPh by period',
    'tax.px.vizStatus': 'Posting status',
    'tax.px.vizSnapshot': 'Year snapshot',
    'tax.px.meterLabel': 'Posting progress',
    'tax.px.snapPending': 'Pending periods',
    'tax.px.statusPosted': 'Posted',
    'tax.px.statusPending': 'Awaiting post',
    'tax.px.statusZero': 'No turnover',
    'tax.px.healthTitle': 'Tax period lanes',
    'tax.px.healthSub': 'Click to filter the monthly table',
    'tax.px.tipsTitle': 'Action tips',
    'tax.px.tipPending': '{n} pending periods · {amount} — post final PPh journals',
    'tax.px.tipUnearned': 'Unearned {amount} — watch so it does not inflate turnover',
    'tax.px.tipSpt': 'Prepare the monthly tax pack for e-Filing',
    'tax.px.tipLk': 'Open the SPT tab on formal financial statements',
    'tax.px.tipSsp': 'Record billing codes / NTPN in the SSP tracker',
    'tax.px.tipOk': 'Final PPh for this year is under control — all periods posted',
    'tax.px.focusPending': 'Filter: periods awaiting post',
    'tax.px.focusPosted': 'Filter: posted periods',
    'tax.px.focusZero': 'Filter: periods with no turnover',
    'tax.px.focusRate': 'Focus: final PPh rate',
    'tax.px.focusBruto': 'Focus: gross turnover',
    'tax.px.focusPph': 'Focus: final PPh',
    'tax.px.focusProgress': 'Focus: posting progress',
    'tax.px.clearFocus': 'Clear focus',
    'tax.px.empty': 'Tax data not loaded',
    'tax.px.emptyHint': 'Pick company / year then refresh',
    'tax.px.tableKicker': 'Monthly',
    'tax.px.tableTitle': 'Final MSME PPh {year}',
    'tax.px.tableSub': 'Showing {shown} of {total} periods',
    'tax.px.noRows': 'No matching periods',
    'tax.px.footPosted': '{n}/{total} taxable periods posted',
    'tax.px.footerNote': 'Posting creates Dr 5009 / Cr 2303. Duplicate periods are skipped (unique ref).',
    'tax.snap.kicker': 'Tax modules',
    'tax.snap.title': 'Compliance Snapshot',
    'tax.snap.sub': 'Cross-module summary of final PPh, VAT, SSP, and withholding certificates · click a card for details',
    'tax.snap.pphFinal': 'Final MSME PPh',
    'tax.snap.pphPending': '{n} periods pending · {amount}',
    'tax.snap.pphDone': '{pct}% periods posted',
    'tax.snap.vatNet': 'Net VAT',
    'tax.snap.vatSspGap': '{n} positive-net periods without paid SSP',
    'tax.snap.vatOk': 'VAT SSP tracked',
    'tax.snap.sspOpen': 'Unpaid SSP',
    'tax.snap.sspOverdue': '{n} overdue · {amount}',
    'tax.snap.sspOk': 'All SSP paid',
    'tax.snap.withholdings': 'Withholding certs',
    'tax.snap.withholdingsHint': '{n} certs · DPP {dpp}',
    'tax.fiscalSub': 'Editable rules — directly affect fiscal P&L on Financial Statements',
    'tax.fiscalTreatmentHint':
      'Treatment zero = full adjustment (fiscal = 0 for that account). Consult your advisor before e-Filing.',
    'tax.colTreatment': 'Treatment',
    'tax.colPercent': '%',
    'tax.colBasis': 'Basis',
    'tax.colActive': 'Active',
    'tax.confirmDeleteRule': 'Delete rule?',
    'tax.addRule': 'Add rule',
    'tax.editRule': 'Edit rule',
    'tax.accountCode': 'Account code',
    'tax.accountName': 'Account name',
    'tax.treatment': 'Treatment',
    'tax.percentIf': 'Percent (if percent)',
    'tax.reason': 'Reason',
    'tax.openLk': 'Open FS',
    'tax.colType': 'Type',
    'tax.billing': 'Billing',
    'tax.dueDate': 'Due date',
    'tax.taxType': 'Tax type',
    'tax.billingCode': 'Billing code',
    'tax.vendorNpwp': 'Vendor tax ID',

    'dl.title': 'Download Reports',
    'dl.sub': 'Download professional reports (Excel & PDF) — pick a report, set the period, preview, then download',
    'dl.kicker': 'Professional export',
    'dl.guide.heroSub':
      'Simple flow: pick company & period (default last month) → catalog unlocks → download.',
    'dl.guide.bannerTitle': 'Set download filters',
    'dl.guide.bannerSub': 'Default period = last month. Pick a company, then download.',
    'dl.guide.bannerSeal': 'Ready',
    'dl.guide.bannerCta': 'Go to filters',
    'dl.guide.catalogOpen': 'Catalog open',
    'dl.guide.stepShort1': 'Company & period',
    'dl.guide.stepShort2': 'Unlock',
    'dl.guide.stepShort3': 'Report',
    'dl.guide.intentTag': 'Pack',
    'dl.guide.intentSelected': 'Active',
    'dl.guide.intentPick': 'Open pack',
    'dl.guide.ctxHint': 'Default period = last month. Change company/dates anytime — catalog stays open.',
    'dl.guide.check1': 'Pick company & period (default last month)',
    'dl.guide.check2': 'Unlock catalog',
    'dl.guide.check3': 'Pick a report, then download',
    'dl.guide.aria': 'Download report guide',
    'dl.guide.kicker': 'Download catalog',
    'dl.guide.step1': '1 · Company & period',
    'dl.guide.step2': '2 · Unlock',
    'dl.guide.step3': '3 · Pick report',
    'dl.guide.titleLocked': 'All reports are locked',
    'dl.guide.titleOpen': 'Pick a pack, then download',
    'dl.guide.subLocked':
      'Pick company and period in the top filters. Default is last month — catalog unlocks once filters are valid.',
    'dl.guide.subOpen':
      'One pack filters the catalog. Choose the closest match for your need.',
    'dl.guide.pickIntent': 'Filter catalog (optional)',
    'dl.guide.searchIntent': 'Search packs (name, tag, description)…',
    'dl.guide.intentCount': '{shown} / {total} packs',
    'dl.guide.intentReports': 'reports',
    'dl.guide.searchEmptyTitle': 'No packs found',
    'dl.guide.searchEmptySub': 'Try another keyword or clear the search.',
    'dl.guide.searchClear': 'Clear search',
    'dl.guide.pagerAria': 'Goal pack pages',
    'dl.guide.pagerPrev': 'Previous page',
    'dl.guide.pagerNext': 'Next page',
    'dl.guide.intent.lk': 'FS & ledger pack',
    'dl.guide.intent.lkDesc': 'Financials, P&L, balance sheet, TB, GL',
    'dl.guide.intent.lkHint': 'Best for month-end close & management review',
    'dl.guide.intent.bank': 'Bank & e-statement',
    'dl.guide.intent.bankDesc': 'Bank/cash, statements, cash flow',
    'dl.guide.intent.bankHint': 'Bank reconciliation and daily cash position',
    'dl.guide.intent.tax': 'Tax & operations',
    'dl.guide.intent.taxDesc': 'Final income tax, advances, IC',
    'dl.guide.intent.taxHint': 'Tax ops and intercompany transactions',
    'dl.guide.intent.classify': 'Account classification',
    'dl.guide.intent.classifyDesc': 'Assets, liabilities, AR/AP, COGS, stock',
    'dl.guide.intent.classifyHint': 'Account breakdown for balance sheet structure',
    'dl.guide.intent.audit': 'Audit & analysis',
    'dl.guide.intent.auditDesc': 'Accrual vs cash, data quality',
    'dl.guide.intent.auditHint': 'Check consistency and booking quality',
    'dl.guide.intent.all': 'Browse all',
    'dl.guide.intent.allDesc': 'Unlock all 27 reports at once',
    'dl.guide.intent.allHint': 'Full catalog access without pack filter',
    'dl.guide.ctxTitle': 'Confirm active filters',
    'dl.guide.unlockBtn': 'Unlock catalog',
    'dl.guide.editCtx': 'Adjust filters first',
    'dl.guide.reset': 'Reset goal',
    'dl.guide.lockChip': 'Locked',
    'dl.guide.cardLockedDesc': 'Waiting for catalog unlock',
    'dl.guide.relock': 'Lock again',
    'dl.guide.needIntent': 'Pick company & period in the top filters first',
    'dl.guide.needDates': 'Set From & To dates in the top filters first',
    'dl.guide.badDates': 'From date cannot be after To date',
    'dl.guide.lockedHint': 'Report locked — pick company & period, then unlock the catalog',
    'dl.guide.contextOk': 'Catalog unlocked — pick a report on the left',
    'dl.guide.catalogLocked': 'Locked',
    'dl.guide.gateBadge': 'Restricted access',
    'dl.guide.gateTitle1': '27 reports locked',
    'dl.guide.gateTitle2': 'Company & period ready — unlock',
    'dl.guide.gateSub1':
      'Set company and period in the top filters (default last month). Once valid, the catalog unlocks automatically — or click Unlock.',
    'dl.guide.gateSub2':
      'Company & period filters are ready. The catalog unlocks automatically — or click Unlock below.',
    'dl.guide.gateHint': 'Default period = last month · pick a company in the top filters',
    'dl.pickReport': 'Choose report',
    'dl.group.core': '01 · Core reports',
    'dl.group.classify': '02 · Account classification',
    'dl.group.ops': '03 · Operations & tax',
    'dl.group.extra': '04 · Analysis & audit',
    'dl.searchReportPlaceholder': 'Search reports (name, description, category)',
    'dl.searchReportCount': '{shown} of {total} reports',
    'dl.searchNoReport': 'No reports match this keyword',
    'dl.searchTablePlaceholder': 'Search preview table (account, memo, code, Ref ID)',
    'dl.searchNoRows': 'No rows match this keyword',
    'dl.filterAll': 'All',
    'dl.filterReady': 'Ready',
    'dl.filterAction': 'Needs Action',
    'dl.filterFavorite': 'Favorites ({n})',
    'dl.pinFavorite': 'Pin favorite',
    'dl.unpinFavorite': 'Unpin favorite',
    'dl.favEmptyEdit': 'Tap the pin icon on a report below to add it',
    'dl.resetSort': 'Reset sort',
    'dl.preview': 'Preview',
    'dl.downloadExcel': 'Download Excel',
    'dl.downloadPdf': 'Download PDF',
    'dl.exportBtn': 'Export',
    'dl.exportTitle': 'Download report',
    'dl.exportFormat': 'File format',
    'dl.exportHint': 'Confirm company, pick a format, then Load filter & Download.',
    'dl.downloadNow': 'Download Now',
    'dl.loadAndDownload': 'Load filter & Download',
    'dl.ptAll': 'All companies',
    'dl.ptAllShort': 'All PT',
    'dl.ptActiveHint': 'Active filter: {pt}',
    'dl.ptConfirm': 'Confirm download company',
    'dl.ptConfirmHint': 'Confirm the PT first. The app reloads the filter, then downloads — so you never pull the wrong company data.',
    'dl.exportTarget': 'Will download · {pt}',
    'dl.snackDownloadReady': 'Report ready · {format}',
    'dl.downloading': 'Preparing Excel…',
    'dl.downloadingPdf': 'Preparing PDF…',
    'dl.expand': 'Expand preview',
    'dl.expandShort': 'Expand',
    'dl.collapse': 'Collapse',
    'dl.expandHint': 'Scroll horizontally/vertically to see all columns & rows',
    'dl.ready': 'Ready',
    'dl.emptyShort': 'X Empty',
    'dl.needPt': 'Pick PT',
    'dl.statusCheck': 'Checking…',
    'dl.statusUnknown': '—',
    'dl.needCompanyTitle': 'Select a company',
    'dl.needCompany':
      'The FS pack needs a specific PT (JGI or JGT) so the balance sheet and P&L stay clean.',
    'dl.soon': 'Next up',
    'dl.step': '27 reports ready',
    'dl.allReady': 'All ready',
    'dl.reportsReady': 'Reports ready',
    'dl.statReady': 'Ready',
    'dl.statTotal': 'Total reports',
    'dl.statNeedPt': 'Needs PT',
    'dl.statLiveFilter': 'Follow active filter',
    'dl.empty': 'No data for this period',
    'dl.emptyHint': 'Adjust company/period, or follow the Work Context above.',
    'dl.emptySearchHint': 'Clear the table search, or change filters.',
    'dl.clearTableSearch': 'Clear table search',
    'dl.followedCtx': 'Download filters now match Work Context',
    'dl.vizReady': 'Download readiness',
    'dl.vizReadySub': 'ready',
    'dl.vizReadyHint': '{ready}/{known} reports ready for this filter',
    'dl.vizGroups': 'Ready by group',
    'dl.vizActions': 'Quick actions',
    'dl.vizFollowCtx': 'Match Work Context',
    'dl.vizShowAction': 'Show needs action ({n})',
    'dl.vizOpenLk': 'Open FS pack',
    'dl.vizManageFav': 'Manage favorites',
    'dl.healthTitle': 'Catalog filters',
    'dl.healthSub': 'Click a chip to filter the report list',
    'dl.tipsTitle': 'Download tips',
    'dl.tipAllReady': 'All reports have data for this filter — ready to export',
    'dl.tipNeedPt': '{n} reports need a specific PT — pick JGI/JGT',
    'dl.tipEmpty': '{n} reports empty in this period — check filters or journals',
    'dl.tipFollow': 'Work Context differs from download filters — click to sync',
    'dl.tipFav': 'Pin favorite reports for faster access',
    'dl.tipLk': 'The FS pack is ideal for consultant / KAP review',
    'dl.tipLedger': 'Post-reconciliation GL is the main practice pack',
    'dl.loaded': '{n} accounts · downloaded {date}',
    'dl.loadedRows': '{n} rows · downloaded {date}',
    'dl.snackOk': 'Excel downloaded successfully',
    'dl.snackOkPdf': 'PDF downloaded successfully',
    'dl.snackFail': 'Failed to download Excel',
    'dl.snackFailPdf': 'Failed to download PDF',
    'dl.snackSoon': 'This report is coming next',
    'dl.showIdRef': 'Show ID Ref',
    'dl.hideIdRef': 'Hide ID Ref',
    'dl.pickCompany': 'Select company',
    'dl.detailKicker': 'Row detail',
    'dl.detailDay': 'Day',
    'dl.detailMonth': 'Month',
    'dl.detailYear': 'Year',
    'dl.detailInputTime': 'Input time',
    'dl.detailPeriod': 'Filter period',
    'dl.detailFullStamp': 'Timestamp',
    'dl.detailJournal': 'Related journal',
    'dl.detailSource': 'Source',
    'dl.detailMemo': 'Memo',
    'dl.detailFields': 'Row data',
    'dl.colOpening': 'Opening',
    'dl.colClosing': 'Closing',
    'dl.colType': 'Type',
    'dl.colNormal': 'Normal',
    'dl.ledger.title': 'General Ledger After Reconciliation',
    'dl.ledger.desc':
      'Post-reconciliation GL: rollforward · ID Ref movements · adjusting entries · classification — consultant/KAP practice pack',
    'dl.ledger.tip':
      'Excel: Cover · Methodology · Summary · Rollforward (Ops+AJ) · Movements · Adjusting Entries · Classification · Sign-off. Download after adjusted TB.',
    'dl.ledgerUna.title': 'General Ledger Before Reconciliation',
    'dl.ledgerUna.desc':
      'GL excluding adjusting journals — rollforward & ID Ref movements before AJ',
    'dl.ledgerUna.tip':
      'Use with unadjusted TB. After AJ, download General Ledger After Reconciliation.',
    'dl.sheetTabs': 'Report sheets',
    'dl.sheetMain': 'Rollforward',
    'dl.notesTitle': 'Scope & policy notes',
    'dl.lk.title': 'Financial Statements Pack',
    'dl.lk.desc':
      'Simple financial statements: Income Statement, Balance Sheet (comparative), Equity Changes, Cash Flow, Notes, and monthly tax',
    'dl.lk.tip':
      'Standard SME/management FS layout — multi-sheet for tax & KAP review. Not a formal audit opinion.',
    'dl.tb.title': 'Trial Balance After Reconciliation',
    'dl.tb.desc':
      'Account balances including adjusting entries — debit = credit gate before final FS',
    'dl.tb.tip':
      'Cycle order: unadjusted TB → adjusting journals → this TB → FS. Unbalanced? fix journals first.',
    'dl.tbUna.title': 'Trial Balance Before Reconciliation',
    'dl.tbUna.desc':
      'Balances excluding adjusting journals (accruals, depreciation, prepaid) — first close step',
    'dl.tbUna.tip':
      'Use before posting adjustments. After AJ, download Trial Balance After Reconciliation.',
    'dl.is.title': 'Income Statement',
    'dl.is.desc':
      'Financial-statement layout: Revenue − COGS → Gross − OpEx → Operating − Tax/VAT → Net Income',
    'dl.is.tip':
      'Stepped layout for KAP review. Tax/VAT deducted after operating profit. Margin detail is on Net Profit.',
    'dl.bs.title': 'Balance Sheet',
    'dl.bs.desc':
      'Simple statement of financial position: current/non-current assets, liabilities, and equity (incl. current earnings)',
    'dl.bs.tip':
      'Layout matches a simple FS PDF balance sheet. Ensure Assets = Liabilities + Equity before KAP.',
    'dl.cf.title': 'Cash Flow',
    'dl.cf.desc': 'Cash in/out on cash-bank accounts + ending cash position — ops reconciliation',
    'dl.cf.tip': 'Direct method on 11xx. Compare with Accrual vs Cash for gap analysis.',
    'dl.np.title': 'Net Profit & Margin',
    'dl.np.desc':
      'Net profit = Revenue − COGS − Operating expenses · margin by company (tax layer excluded here)',
    'dl.np.tip':
      'Focus on operating efficiency & margin by PT. After-tax result is on the Income Statement.',
    'dl.accrual.title': 'Accrual vs Cash',
    'dl.accrual.desc':
      'Accrual profit vs net cash gap — consultant analysis (not merely accrual account list)',
    'dl.accrual.tip':
      'Material gaps often come from AR/AP/DP. Investigate before financial review.',
    'dl.double.title': 'Double-Entry',
    'dl.double.desc': 'Merged into Journal + Double-entry control',
    'dl.journal.title': 'Journal + Double-entry Control',
    'dl.journal.desc':
      'Double-entry journal lines plus debit=credit control per ID Ref (merges former Double-entry card)',
    'dl.journal.tip':
      'Focus the Double-entry annex on unbalanced entries before audit. Click ID Ref to trace.',
    'dl.assets.title': 'Assets Report',
    'dl.assets.desc':
      'All inventory & office assets already on account numbers (cash, bank, AR, inventory, fixed assets)',
    'dl.assets.tip':
      'All CoA asset accounts — cash/bank 11xx, AR 12xx, inventory 13xx, fixed assets 15xx.',
    'dl.liabilities.title': 'Liabilities Report',
    'dl.liabilities.desc': 'Debts or financial obligations of the company to other parties',
    'dl.liabilities.tip':
      'All liability accounts — AP, reimbursements, and tax payables.',
    'dl.equity.title': 'Equity Report',
    'dl.equity.desc': "Owners' residual interest in assets after deducting liabilities",
    'dl.equity.tip':
      'Owner capital, owner draws, and retained earnings — net worth.',
    'dl.revenue.title': 'Revenue Report',
    'dl.revenue.desc': 'Total income from selling goods or services',
    'dl.revenue.tip':
      'Revenue accounts (41xx/42xx). Basis for turnover & final income tax.',
    'dl.expense.title': 'Expense Report',
    'dl.expense.desc': 'Costs incurred to run business operations (excluding COGS)',
    'dl.expense.tip':
      'Operating expenses 52xx/53xx — COGS 51xx is in the COGS report.',
    'dl.ar.title': 'Accounts Receivable',
    'dl.ar.desc': 'Money owed to the business by customers for credit sales',
    'dl.ar.tip':
      '12xx / “receivable” accounts. Empty = no AR movement in this period.',
    'dl.ap.title': 'Accounts Payable',
    'dl.ap.desc': 'Money the business owes suppliers for credit purchases',
    'dl.ap.tip':
      '21xx accounts (AP & reimbursements). Track supplier obligations.',
    'dl.depreciation.title': 'Depreciation',
    'dl.depreciation.desc': 'Systematic allocation of tangible asset cost over time',
    'dl.depreciation.tip':
      'Accounts labeled depreciation (1520 / 5280). Post depreciation journals to populate.',
    'dl.inventory.title': 'Inventory Report',
    'dl.inventory.desc': 'Goods or materials held by the business for sale',
    'dl.inventory.tip':
      '13xx inventory accounts. Empty until inventory has a balance/movement.',
    'dl.cogs.title': 'COGS Report',
    'dl.cogs.desc': 'Direct costs to produce or buy goods sold',
    'dl.cogs.tip':
      '51xx Cost of Goods Sold — reduces revenue to gross profit.',
    'dl.whyLabel': 'What this report is for',
    'dl.omset.title': 'Monthly Revenue',
    'dl.omset.desc': 'Merged into Tax Pack / Final Income Tax + Revenue',
    'dl.ledgerDetail.title': 'General Ledger · Detail',
    'dl.ledgerDetail.desc': 'Merged into General Ledger (Balance + Movements)',
    'dl.bank.title': 'Bank / Cash Report',
    'dl.bank.desc': 'Movements & balances for cash/bank 11xx accounts',
    'dl.bank.tip':
      'Match movements in Reconciliation (/reconciliation) before consultant review. For per-bank statements, open the E-Statement Bank Statement menu.',
    'dl.estatement.title': 'E-Statement Bank Statement',
    'dl.estatement.desc': 'Download bank statements per account — Excel · PDF · Word · CSV · ZIP',
    'dl.estatement.tip':
      'Download only banks with valid reconciliation (cleared/released). Unmatched banks stay locked — finish Reconciliation first.',
    'dl.estatement.heroSub':
      'Quality gate: download-ready banks only. Tick cleared accounts, export Excel/PDF/ZIP audit-ready.',
    'dl.bankEstmtKicker': 'Post-reconciliation',
    'dl.bankEstmtTitle': 'Bank Statement E-Statement',
    'dl.bankEstmtSub':
      'Pick a cash/bank account, then download a bank-statement layout — clean, professional, audit-ready.',
    'dl.bankEstmtPick': 'Pick download-ready banks (post-reconciliation)',
    'dl.bankEstmtAll': 'All ready banks (ZIP)',
    'dl.bankEstmtEmpty':
      'No cash/bank accounts in your master list or cleared movements for this period',
    'dl.bankEstmtEmptyReady':
      'No banks with cleared/released movements in this period — download stays locked until reconciliation is done.',
    'dl.bankEstmtEmptyReadyTitle': 'Download still locked',
    'dl.bankEstmtGoMaps': 'Manage account numbers →',
    'dl.bankEstmtGoRecon': 'Open Reconciliation',
    'dl.bankEstmtLoading': 'Loading accounts…',
    'dl.bankEstmtPickNeed': 'Select at least one reconciled (cleared) bank',
    'dl.bankEstmtPickReady': 'Select all ready',
    'dl.bankEstmtSelectedMeta': '{n} ready banks · {lines} cleared rows',
    'dl.bankEstmtSelectAll': 'All ready',
    'dl.bankEstmtSelectData': 'All download-ready',
    'dl.bankEstmtSelectVisible': 'Visible (ready)',
    'dl.bankEstmtClear': 'Clear',
    'dl.bankEstmtOnlyData': 'Ready only',
    'dl.bankEstmtShowLocked': 'Show locked',
    'dl.bankEstmtFilterAll': 'All types',
    'dl.bankEstmtFilterReady': 'Ready',
    'dl.bankEstmtFilterLocked': 'Not reconciled',
    'dl.bankEstmtNoMutasi': 'no movements yet',
    'dl.bankEstmtMine': 'Yours',
    'dl.bankEstmtMineTip': 'Account number filled in your bank master',
    'dl.bankEstmtPicked': 'Selected',
    'dl.bankEstmtBadgeReady': 'Ready',
    'dl.bankEstmtBadgeLocked': 'Locked',
    'dl.bankEstmtLockedSub': 'Not cleared — download blocked',
    'dl.bankEstmtLockedTip':
      'This bank has no cleared/released movements for the selected period',
    'dl.bankEstmtLockedToast':
      'Bank not reconciled yet — finish matching in Reconciliation before download',
    'dl.bankEstmtGateKicker': 'Data quality gate',
    'dl.bankEstmtGateReadyTitle': 'All listed banks are audit-ready',
    'dl.bankEstmtGateReadyText':
      '{n} accounts have cleared/released movements. E-statements only include post-reconciliation data — safe for auditors & consultants.',
    'dl.bankEstmtGatePartialTitle': 'Some banks still await reconciliation',
    'dl.bankEstmtGatePartialText':
      '{ready} ready to download · {locked} still locked. Locked banks cannot be selected until movements are cleared/released.',
    'dl.bankEstmtGateBlockedTitle': 'No valid data to download yet',
    'dl.bankEstmtGateBlockedText':
      'E-statements only export post-reconciliation movements. Match books ↔ bank in Reconciliation, then come back here.',
    'dl.bankEstmtReadyLabel': 'readiness',
    'dl.bankEstmtReadyPct': 'Download readiness {pct}%',
    'dl.bankEstmtOpening': 'Opening',
    'dl.bankEstmtDebit': 'Debit',
    'dl.bankEstmtCredit': 'Credit',
    'dl.bankEstmtClosing': 'Closing',
    'dl.bankEstmtExcel': 'Download Excel',
    'dl.bankEstmtPdf': 'Download PDF',
    'dl.bankEstmtWord': 'Download Word',
    'dl.bankEstmtCsv': 'Download CSV',
    'dl.bankEstmtZip': 'ZIP selected banks',
    'dl.bankEstmtZipXlsx': 'ZIP Excel all banks',
    'dl.bankEstmtZipPdf': 'ZIP PDF all banks',
    'dl.bankEstmtPickFormat': 'Choose download format',
    'dl.bankEstmtFmtXlsxDesc': 'Cover + statement + summary',
    'dl.bankEstmtFmtPdfDesc': 'Formal bank-statement layout',
    'dl.bankEstmtFmtDocDesc': 'Word document — print / edit ready',
    'dl.bankEstmtFmtCsvDesc': 'Raw data for Excel / BI',
    'dl.bankEstmtFmtZipDesc': 'Selected banks in one ZIP archive',
    'dl.bankEstmtDownloadNow': 'Download now',
    'dl.bankEstmtDownloadZip': 'Download ZIP now',
    'dl.bankEstmtDone': 'E-statement {format} ready',
    'dl.bankEstmtHint':
      'Pick Ready banks → format → Download. Several banks = ZIP. Use the top toolbar for company/period.',
    'dl.bankEstmtFilterBar': 'E-statement filters',
    'dl.bankEstmtWeek1': '1 week',
    'dl.bankEstmtWeek2': '2 weeks',
    'dl.bankEstmtMonth1': '1 month',
    'dl.bankEstmtDirty': 'Not applied yet',
    'dl.bankEstmtApplyFirst': 'Click Apply first so the date & company filters take effect before download.',
    'dl.bankEstmtMeta': '{banks} accounts · {n} cleared rows',
    'dl.bankEstmtBanks': 'Accounts',
    'dl.bankEstmtLines': 'Rows',
    'dl.bankEstmtSample': 'Cleared mutation preview',
    'dl.exportBankMode': 'Download type',
    'dl.exportBankModeEstmt': 'Bank e-statement',
    'dl.exportBankModeEstmtSub': 'Debit/credit detail per account · cleared',
    'dl.exportBankModeSummary': 'Rollforward summary',
    'dl.exportBankModeSummarySub': 'Opening → movements → closing (table)',
    'dl.exportBankPick': 'Pick bank account',
    'dl.exportBankAllSub': '{n} accounts in ZIP',
    'dl.exportBankRowSub': '{n} rows · balance {bal}',
    'dl.exportBankGo': 'Download e-statement',
    'dl.exportFail': 'Failed to download report',
    'dl.recon.title': 'Financial Statement Reconciliation',
    'dl.recon.desc':
      'Bridge TB & GL before ↔ after reconciliation — per-account AJ variance before FS',
    'dl.recon.tip':
      'Links unadjusted/adjusted TB + GL. Bank statement matching stays in the Reconciliation menu.',
    'dl.ic.title': 'Intercompany',
    'dl.ic.desc': 'Elimination candidates for JGI↔JGT transactions',
    'dl.ic.tip': 'Required for Group Consolidation — attach for group KAP review.',
    'dl.tax.title': 'Tax Pack / Final Income Tax + Revenue',
    'dl.tax.desc':
      'Gross revenue, rate, final tax by period + monthly revenue annex (merges former Omset report)',
    'dl.tax.tip':
      'Verify rate & PPHFIN postings before filing. Tax-consultant ready (PP 55/2022).',
    'dl.kasbon.title': 'Employee Cash Advance Report',
    'dl.kasbon.desc':
      'Receivables · Approve/Reject · movements · payslip (gross − advance = take-home) · live BS & P&L sync',
    'dl.kasbon.tip':
      'Pick a company. Approve = Dr Receivable 1201 · Cr Cash (BS live). Reject = payslip only. Payroll clears receivable · P&L via salary expense.',
    'dl.audit.title': 'Data Quality Audit',
    'dl.audit.desc':
      'Quality score, findings, recommendations, statement gaps — pre-KAP review (not a formal opinion)',
    'dl.audit.tip':
      'Clear high/critical findings before handing the FS pack to the public accountant.',

    'bk.kicker': 'Vault · Safe transfer',
    'bk.title': 'Backup & Restore',
    'bk.sub':
      'Pull the local database, save on your PC, fix things, then ship via Git/VPS — same data. Git does not carry the live .db; use download, server snapshots, or Git bootstrap.',
    'bk.subShort':
      'Backup to PC first, restore here or on VPS. Full ZIP = DB + uploads; JSON = per table.',
    'bk.twowayHint':
      'Windows → save ZIP → restore on Linux VPS (or reverse). Git pull does NOT carry live DB, uploads, or .env.',
    'bk.twowayHintShort':
      'Windows → ZIP → restore on VPS (or reverse). Git pull does not carry DB/uploads/.env.',
    'bk.backupAll': 'Backup all (ZIP)',
    'bk.backupAllNow': 'Backup All Now',
    'bk.backupAllNowShort': 'Backup Now',
    'bk.downloadZipOnly': 'ZIP only',
    'bk.downloadZipOnlyShort': 'ZIP only',
    'bk.downloadDbShort': 'Get .db',
    'bk.downloadJsonShort': 'All JSON',
    'bk.restoreBtnShort': 'Restore',
    'bk.refreshShort': 'Reload',
    'bk.liveZipAllShort': 'ZIP all',
    'bk.selectAllShort': 'All',
    'bk.deselectAllShort': 'Clear',
    'bk.backupSelectedShort': 'Selected ({n})',
    'bk.snackBackupAllNowOk': 'Full ZIP backup downloaded — see history below',
    'bk.refreshStatus': 'Refresh status',
    'bk.backupAllTitle': 'Backup database',
    'bk.backupAllSub':
      'Backup All Now = one ZIP (DB + uploads). Per-table JSON only when you click a table Backup.',
    'bk.zipContentsTitle': 'Full ZIP contents',
    'bk.zipItemDb': 'Full SQLite database',
    'bk.zipItemUploads': 'Disk attachments (if any)',
    'bk.zipItemManifest': 'Manifest & table counts',
    'bk.zipItemEnv': '.env key list (no secrets)',
    'bk.fileNameHint':
      'Filenames: laporanJP-full-*.zip · laporanJP-accounting-*.db · laporanJP-json-all-*.json · laporanJP-table-{name}-*.json',
    'bk.uploadsPill': 'Uploads: {n} files',
    'bk.lastBackupAt': 'Last backup',
    'bk.lastBackupHint': 'Last backup time (day/month/year + hour:minute:second)',
    'bk.lastRestoreAt': 'Last restore',
    'bk.lastRestoreHint': 'Last restore time (day/month/year + hour:minute:second)',
    'bk.dbFileAt': 'DB file',
    'bk.gitGapLead':
      'Windows → Git → Linux VPS: more than just the database is missing from pull — see the right list. Use full ZIP for DB + uploads.',
    'bk.partsTitle': 'Per-table / selected backup',
    'bk.partsSub': 'Tick tables → download JSON. Restoring JSON only replaces selected tables (if ticked).',
    'bk.partsNote':
      'Tip: backup/restore journal_entries + journal_lines together so journals stay consistent.',
    'bk.selectAll': 'Select all',
    'bk.deselectAll': 'Clear selection',
    'bk.backupSelected': 'Backup selected ({n})',
    'bk.backupOne': 'Backup',
    'bk.colTable': 'Table',
    'bk.colRows': 'Rows',
    'bk.colAction': 'Action',
    'bk.seeCoverage': 'What Git does / does not carry',
    'bk.gitTitleShort': 'Via Git (bootstrap)',
    'bk.dropSubJson': 'or click · .db / .zip / .json (max 200MB)',
    'bk.partialRestoreHint':
      '{n} tables ticked — JSON restore overwrites only those tables (not the whole DB).',
    'bk.snackNeedTables': 'Tick at least one table first',
    'bk.path': 'Path',
    'bk.size': 'Size',
    'bk.updated': 'Last updated',
    'bk.journals': 'Journals',
    'bk.lines': 'Lines',
    'bk.companies': 'Companies',
    'bk.accounts': 'Accounts',
    'bk.recon': 'Reconciliations',
    'bk.refresh': 'Refresh',
    'bk.quickZip': 'Download ZIP now',
    'bk.workflowLabel': 'Workflow',
    'bk.flowTitle': 'Three flexible ways to move the database',
    'bk.flowManualTitle': 'Manual to PC',
    'bk.flowManualDesc': 'Download ZIP/.db → save locally → fix → upload restore to local or VPS.',
    'bk.flowSnapTitle': 'Server snapshot',
    'bk.flowSnapDesc': 'Copy into data/backups/ on the same machine (safe rollback without download).',
    'bk.flowGitTitle': 'Via Git',
    'bk.flowGitDesc': 'Pack to data/bootstrap/ → commit+push → VPS pull (empty DB auto-fills).',
    'bk.sectionBackup': 'Backup',
    'bk.sectionBackupSub': 'Save locally before changing anything — recommended: ZIP (includes manifest)',
    'bk.zipTitle': 'ZIP package',
    'bk.zipDesc':
      'accounting.db + uploads/ + manifest + ENV_CHECKLIST — safest Windows ↔ VPS',
    'bk.dbTitle': 'Raw SQLite (.db)',
    'bk.dbDesc': 'Single file — place in data/accounting.db or restore via upload',
    'bk.jsonTitle': 'JSON export',
    'bk.jsonDesc': 'Table dump — full or per-table; JSON restore overwrites tables in the file',
    'bk.downloadZip': 'Download full ZIP',
    'bk.downloadDb': 'Download .db',
    'bk.downloadJson': 'Download all JSON',
    'bk.sectionSnap': 'Server snapshot',
    'bk.sectionSnapSub': 'Copy on the VPS/server without downloading (data/backups/)',
    'bk.snapNow': 'Create snapshot now',
    'bk.snapEmpty': 'No snapshots yet — create one before risky experiments',
    'bk.snapRestore': 'Restore',
    'bk.snapDownload': 'Download',
    'bk.snapDelete': 'Delete',
    'bk.sectionRestore': 'Restore',
    'bk.sectionRestoreSub':
      'ZIP = DB + uploads. .db = database only. JSON = tables. Pre-restore snapshot is automatic.',
    'bk.dropTitle': 'Drop .db / .zip / .json here',
    'bk.dropSub': 'or click to choose a file (max 200MB)',
    'bk.confirmLabel': 'I understand this overwrites current data',
    'bk.restoreBtn': 'Restore now',
    'bk.restoring': 'Restoring…',
    'bk.confirmRestoreTitle': 'Restore the database now?',
    'bk.confirmRestoreLead':
      'The selected file will change the live database (ZIP also restores uploads/). A pre-restore copy is kept under data/backups/.',
    'bk.confirmYes': 'Yes, restore',
    'bk.confirmNo': 'No',
    'bk.confirmYesHint': 'Overwrite live DB with this file',
    'bk.confirmNoHint': 'Cancel, stay on this page',
    'bk.sectionGuide': 'Full guide',
    'bk.seeGuide': 'See here',
    'bk.hideGuide': 'Close',
    'bk.tipsTitle': 'Tips so VPS matches local',
    'bk.tip1': 'Before push: Pack DB for Git (or npm run db:pack) → commit data/bootstrap.',
    'bk.tip2': 'On VPS: git pull. If data/accounting.db is missing, the app auto-restores from bootstrap.',
    'bk.tip3': 'Live DB (data/accounting.db) stays gitignored — only the bootstrap snapshot is pushed.',
    'bk.tip4': 'Overwrite VPS DB with latest local: DB_BOOTSTRAP_FORCE=1 npm run db:restore:force then restart.',
    'bk.tip5': 'After restore, hard-refresh the browser (Ctrl+F5) so reports reload.',
    'bk.gitTitle': 'Ship database via Git (no manual copy)',
    'bk.gitSub':
      'Pack a snapshot into data/bootstrap/, then commit+push. VPS auto-uses it when the live DB is missing. Uploads & .env still never ride with Git.',
    'bk.gitPack': 'Pack DB for Git',
    'bk.gitStep1': 'Click “Pack DB for Git” on the machine with full data (or npm run db:pack).',
    'bk.gitStep2': 'git add data/bootstrap && git commit -m "db: sync bootstrap" && git push',
    'bk.gitStep3': 'On VPS: git pull && restart — empty DB is filled from bootstrap automatically.',
    'bk.gitStep4': 'If VPS already has an old DB you want replaced: npm run db:restore:force (once).',
    'bk.gitPacked': 'Snapshot ready',
    'bk.copyCmd': 'Copy',
    'bk.copied': 'Copied',
    'bk.snackPackOk': 'Bootstrap DB ready to commit ({size})',
    'bk.snackPackFail': 'Failed to pack bootstrap DB',
    'bk.countsTitle': 'Table inventory',
    'bk.snackDlOk': 'Backup downloaded',
    'bk.snackDlFail': 'Download failed',
    'bk.snackSnapOk': 'Snapshot saved: {name}',
    'bk.snackSnapFail': 'Failed to create snapshot',
    'bk.snackRestoreOk': 'Database restored successfully',
    'bk.snackRestoreFail': 'Restore failed',
    'bk.snackNeedConfirm': 'Tick the confirmation first',
    'bk.snackNeedFile': 'Choose a .db, .zip, or .json file first',
    'bk.snackDelOk': 'Snapshot deleted',
    'bk.confirmRestore':
      'Restore this snapshot?\n\nCurrent data will be replaced (a pre-restore copy is kept).',
    'bk.confirmDelete': 'Delete snapshot {name}?',
    'bk.recommend': 'Recommended',
    'bk.danger': 'Destructive',
    'bk.live': 'Live database',
    'bk.snapshots': 'Snapshots',
    'bk.coverInTitle': 'Included in ZIP / bootstrap',
    'bk.coverIn1': 'All journals, lines, COA, entities, reconciliation, statement rules, AI account memory',
    'bk.coverIn2': 'Employees, payroll, advances, tax, year-close, budgets (if used)',
    'bk.coverIn3': 'Full ZIP: accounting.db (WAL checkpointed) + data/uploads/',
    'bk.coverIn4': 'Via Git: only data/bootstrap/accounting.db (+ manifest) — Pack before push',
    'bk.coverIn5': 'ENV_CHECKLIST.txt in ZIP = keys you must fill manually on VPS',
    'bk.coverOutTitle': 'NOT in git pull (Windows → VPS)',
    'bk.coverOut1': 'Live data/accounting.db (+ .db-wal / .db-shm) — intentionally gitignored',
    'bk.coverOut2': 'data/uploads/ disk attachments — in full ZIP, not Git',
    'bk.coverOut3': '.env / API & login keys (Gemini, Groq, session) — reconfigure on VPS',
    'bk.coverOut4': 'node_modules, .nuxt, .output — npm ci + build on Linux',
    'bk.coverOut5': 'data/backups/ server snapshots — per machine',

    'bk.histKicker': 'Activity · Audit trail',
    'bk.histTitle': 'Backup & Restore history',
    'bk.histSub':
      'Every download, restore, snapshot, and Git pack is logged with user, full date/time to the second, and what was included.',
    'bk.histEmpty': 'No activity yet — try Backup all or Restore, then history appears here.',
    'bk.histLoading': 'Loading history…',
    'bk.histClear': 'Clear history',
    'bk.histClearConfirm': 'Clear all backup/restore history on this machine?',
    'bk.histCleared': 'History cleared',
    'bk.histShowItems': 'Show {n} included items',
    'bk.histHideItems': 'Hide details',
    'bk.histActBackupZip': 'Backup ZIP',
    'bk.histActBackupDb': 'Backup .db',
    'bk.histActBackupJson': 'Backup JSON',
    'bk.histActBackupTables': 'Per-table backup',
    'bk.histActBackupAllNow': 'Backup All Now',
    'bk.histActBackupFile': 'Single-file backup',
    'bk.histActBackupLiveZip': 'Non-Git ZIP',
    'bk.histActRestoreZip': 'Restore ZIP',
    'bk.histActRestoreDb': 'Restore .db',
    'bk.histActRestoreJson': 'Restore JSON',
    'bk.histActSnapCreate': 'Snapshot',
    'bk.histActSnapRestore': 'Restore snapshot',
    'bk.histActSnapDelete': 'Delete snapshot',
    'bk.histActPackGit': 'Pack Git',

    'bk.liveKicker': 'Non-Git · Live inventory',
    'bk.liveTitle': 'Files not covered by Git',
    'bk.liveSub':
      'Every live artifact intentionally gitignored on this machine: live DB, uploads, server snapshots, env checklist. Download as one ZIP or one-by-one by filename.',
    'bk.liveZipAll': 'Download all (ZIP)',
    'bk.liveZipHint':
      'Non-Git ZIP = accounting.db + uploads + snapshots + ENV_CHECKLIST (no secret .env values). Full “Backup All Now” ZIP is still best for DB+uploads VPS migration.',
    'bk.liveColKind': 'Kind',
    'bk.liveColName': 'Filename',
    'bk.liveColPath': 'Path',
    'bk.liveColSize': 'Size',
    'bk.liveColMtime': 'Modified',
    'bk.liveColAction': 'Action',
    'bk.liveDownload': 'Download',
    'bk.liveBlocked': 'Secret',
    'bk.liveEmpty': 'No live files in this filter',
    'bk.livePillFiles': '{n} non-Git files',
    'bk.livePillSize': 'Σ {size}',
    'bk.liveKpiTotal': 'Inventory',
    'bk.liveKpiReady': 'Downloadable',
    'bk.liveKpiBlocked': 'Blocked',
    'bk.liveKpiSize': 'Download size',
    'bk.liveFilterAll': 'All',
    'bk.kindDb': 'Database',
    'bk.kindSidecar': 'WAL/SHM',
    'bk.kindUpload': 'Upload',
    'bk.kindSnapshot': 'Snapshot',
    'bk.kindEnv': '.env',
    'bk.kindChecklist': 'Checklist',
    'bk.snackLiveZipOk': 'Non-Git live ZIP downloaded',
    'bk.noteMissing': 'File not found on disk',
    'bk.noteSidecar': 'Usually already included in .db download (serialize). Optional raw copy.',
    'bk.noteSnapshot': 'Local machine snapshot (also not in Git)',
    'bk.noteChecklist': 'Env key list without secret values',
    'bk.noteSecret': 'Contains secrets — not downloadable. Copy manually / use ENV_CHECKLIST.txt',

    'imp.title': 'Import Workbook',
    'imp.kicker': 'Bulk import',
    'imp.sub':
      'Upload Excel bank & credit-card movements — auto-post journals with COGS allocated proportionally to JGI & JGT. For multi-format e-statements, also use Smart E-Statement.',    'imp.eStatement': 'Smart E-Statement',
    'imp.journals': 'Journals',
    'imp.fsUploadReview': 'Upload & review workbook',
    'imp.setupTitle': 'Import preparation',
    'imp.setupStepPt': 'Choose target company',
    'imp.setupStepBank': 'Bank account',
    'imp.setupStepUpload': 'Upload workbook',
    'imp.setupHintPt': 'All rows & journals go to the selected company.',
    'imp.setupHintBank': 'Confirm cash/bank account and account number.',
    'imp.setupReady': 'Ready to upload',
    'imp.step1': 'Step 1',
    'imp.step2Title': 'Step 2 — Import into the system',
    'imp.step2Body': '{n} rows selected. Click the blue “Import to system” button (uploading Excel alone is not enough). Enable “Post to reports” to hit the balance sheet.',
    'imp.aiLocalFallback': 'Local rule mapping for {n} rows (AI offline). Check the MAP column, then click Import to system.',
    'imp.uploadTitle': 'Upload Excel / e-statement',
    'imp.uploadSub':
      'Multi-sheet Excel bank & CC, or PDF/CSV/OFX e-statements — Gemini ↔ Groq AI fills debit/credit automatically.',
    'imp.parsed': 'Parsed',
    'imp.readingWorkbook': 'Reading workbook…',
    'imp.processingSheets': 'Processing bank & card sheets',
    'imp.aiSmartFill': 'AI smart fill',
    'imp.aiMapping': 'AI mapping accounts…',
    'imp.aiMappingHint': 'Gemini first, Groq fallback — filling kind & counterpart into all tables',
    'imp.aiOfflineChip': 'Local rules',
    'imp.mutations': 'lines',
    'imp.bankSheets': 'bank sheets',
    'imp.changeFile': 'Change file',
    'imp.step3Title': 'Upload file',
    'imp.toolbarUpload': 'Upload',
    'imp.toolbarReview': 'Review & actions',
    'imp.processFiles': 'Process {n} file(s)',
    'imp.parsedStmtSummary': '{rows} transaction rows · {files} file(s)',
    'imp.multiFileLabel': '{n} import files',
    'imp.parsedWorkbookSummary': '{bank} txns · {sheets} bank sheets · CC {cc}',
    'imp.snack.parseTimeout': 'Process took too long — try again or use a smaller file.',
    'imp.metricRows': 'rows',
    'imp.selectedShort': 'selected',
    'imp.debitShort': 'debit',
    'imp.creditShort': 'credit',
    'imp.dropActive': 'Drop file here',
    'imp.dropTitle': 'Drag & drop Excel / PDF e-statement',
    'imp.dropHint': 'Upload → parse → AI fills debit/credit · multi-sheet workbook or bank PDF',
    'imp.chipMultiSheet': 'Multi bank sheets',
    'imp.chipCcHpp': 'CC → COGS',
    'imp.pickExcel': 'Choose Excel file',
    'imp.pickFile': 'Choose file',
    'imp.fsReviewMulti': 'Review lines · multi sheet',
    'imp.multiKicker': 'Multi-sheet frame',
    'imp.reviewTitle': 'Review lines · pick flow & accounts',
    'imp.reviewTitleDemo': 'Movement table per sheet (sample)',
    'imp.reviewSub':
      'Auto from workbook · {n} lines ready to route · change flow / debit-credit accounts before import',
    'imp.reviewSubDemo':
      'After Excel upload, all bank sheets load automatically — pick flow & debit/credit account numbers.',
    'imp.realData': 'Live data',
    'imp.illustration': 'Sample',
    'imp.file': 'File',
    'imp.visibleSelected': 'Shown / selected',
    'imp.debitFilter': 'Filter debit',
    'imp.creditFilter': 'Filter credit',
    'imp.totalDebit': 'Total debit',
    'imp.totalCredit': 'Total credit',
    'imp.readyScore': 'Ready to import',
    'imp.readyHint': '{ok} OK · {need} still need review',
    'imp.healthTitle': 'Quick review lanes',
    'imp.healthSub': 'Click a chip to filter rows — stays in sync with the table below.',
    'imp.clearLane': 'Clear filter',
    'imp.statUnmatched': 'Unmatched sheets',
    'imp.statInvalid': 'Invalid rows',
    'imp.statReady': 'Ready %',
    'imp.rulesLegendChip': 'Legend',
    'imp.rulesLegendHint': 'Click a rule to filter the table. Workbook default mapping (not CRUD rules).',
    'imp.hppPreviewTip':
      'Enter CC spend total (or click “Fill from workbook”) — JGI/JGT split preview updates automatically.',
    'imp.sheetStatusTitle': 'All workbook sheet status',
    'imp.statusCc': 'CC',
    'imp.statusEmpty': 'empty',
    'imp.statusSkip': 'skip',
    'imp.allSheets': 'All ({n})',
    'imp.selectVisible': 'Select visible',
    'imp.resetTable': 'Reset to start',
    'imp.selectInvalid': 'Select invalid',
    'imp.removeSelected': 'Delete selected ({n})',
    'imp.removeRow': 'Remove row',
    'imp.snack.rowDeleted': '1 row deleted',
    'imp.snack.rowsDeleted': '{n} rows deleted',
    'imp.snack.needSelected': 'Check rows first',
    'imp.snack.invalidSelected': '{n} invalid rows checked',
    'imp.snack.noInvalid': 'No invalid rows',
    'imp.snack.rowAdded': 'Manual row added — fill description, debit/credit, then import.',
    'imp.filterBar': 'Filter & selection',
    'imp.manualMode': 'Manual entry',
    'imp.errNeedAmount': '{n} rows have invalid debit/credit — fill exactly one side (not both / empty).',
    'imp.errNeedAccounts': '{n} rows are missing cash/bank & contra accounts.',
    'imp.confirmKicker': 'Import workbook',
    'imp.confirmLead': '{n} selected rows will be imported as journals. Confirm description, amounts, and accounts first.',
    'imp.confirmB1': 'Description required · debit XOR credit · cash/bank & contra filled · PT set.',
    'imp.confirmB2': 'Uncheck unsure/wrong rows before Yes.',
    'imp.confirmB3': 'On Yes, rows become journals (pending or cleared per option).',
    'imp.confirmYesHint': 'Yes, checked — import now',
    'imp.confirmImportTitle': 'Review before importing to the system',
    'imp.confirmSaveLead': 'You will import {n} selected rows to the ledger.',
    'imp.confirmRecapImport': '{n} rows ({deb} debit · {cred} credit) → account: {bank}',
    'imp.processWorkbook': 'Read workbook',
    'imp.processWorkbookHint': 'Parse Excel after confirmation',
    'imp.searchRows': 'Search description / account / sheet…',
    'imp.allFlows': 'All flows',
    'imp.bulkApply': 'Apply to selected ({n})',
    'imp.flow': 'Flow',
    'imp.setFlow': 'Set flow',
    'imp.bankAccount': 'Bank account',
    'imp.contraAccount': 'Contra account',
    'imp.setAccountPt': 'Set acct/co.',
    'imp.bankSheetSummary': 'Bank sheet summary',
    'imp.ccSheetSummary': 'Card sheet summary',
    'imp.colTxn': 'Txn',
    'imp.colCharges': 'Charges',
    'imp.totalHppPool': 'Total COGS pool',
    'imp.colDate': 'Date',
    'imp.colSheet': 'Sheet',
    'imp.colDesc': 'Description',
    'imp.colFlow': 'Flow',
    'imp.colDebitAcct': 'Debit account',
    'imp.colCreditAcct': 'Credit account',
    'imp.colKind': 'Kind',
    'imp.noRowsFilter': 'No rows match this filter',
    'imp.demoUploadTitle': 'Upload Excel above',
    'imp.demoUploadSub': 'All bank & card sheets auto-load into a multi-sheet frame like this',
    'imp.ccBanner':
      '{count} card lines in review · {selected} selected · pool {pool}. Check proportional COGS allocation = pooled to JGI/JGT; uncheck = line-by-line journals (company required).',
    'imp.sharedPtBanner':
      '{n} rows still Shared company — excluded from per-company reports (avoid double-count). Set JGI/JGT in the Company column.',
    'imp.optHppAllocate': 'Proportional COGS allocation from selected card charges (not line-by-line card journals)',
    'imp.optPostCleared': 'Post directly to financial statements (cleared) — not pending reconciliation',
    'imp.hppJournalDate': 'COGS journal date',
    'imp.dryRun': 'Dry-run (preview)',
    'imp.importSelected': 'Import {n} selected',
    'imp.saveToRecon': 'Import selected → Reconciliation',
    'imp.savedLinks': 'Saved to journal — continue:',
    'imp.savedLinksPending': 'Saved · ready on the recon desk:',
    'imp.openJournal': 'General journal',
    'imp.toRecon': 'Go to reconciliation',
    'imp.toReconBatch': 'Ready to auto-match',
    'imp.postSaveTitle': 'Import successful',
    'imp.postSaveSub': '{imported} journals created · skip {skipped} · error {errors}',
    'imp.postSaveRemaining': '{n} rows still in review — continue import or upload a new file.',
    'imp.uploadAgain': 'Upload again',
    'imp.continueReview': 'Continue review',
    'imp.createdRefs': 'Journal refs',
    'imp.reconCleared': 'Cleared (in financial statements)',
    'imp.reconPending': 'Pending reconciliation',
    'imp.statImported': 'Imported',
    'imp.statSkipped': 'Skipped',
    'imp.statErrors': 'Errors',
    'imp.statRemaining': 'Remaining',
    'imp.queueOutcomeRows': '{n} rows',
    'imp.queueOutcomeEmpty': '0 rows',
    'imp.queueOutcomeFail': 'Parse failed',
    'imp.queueProcessDone': '{ok} files OK · {rows} rows · {fail} failed',
    'imp.draftReuploadHint': 'Review saved — re-upload the same file if you need the raw sheet view.',
    'imp.applyDefaultPanel': 'Panel default',
    'imp.selectNeedCheck': 'Select needs review',
    'imp.snack.defaultApplied': 'Panel default applied to {n} rows',
    'imp.snack.needCheckSelected': '{n} rows needing review selected',
    'imp.snack.noNeedCheck': 'No rows need review',
    'stmt.queueDoneOk': 'Done',
    'stmt.queueDoneFail': 'Failed',
    'imp.viewJournals': 'View journals',
    'imp.financialReports': 'Financial statements',
    'imp.dryRunBanner': 'Dry-run: {n} journals ready to post',
    'imp.importedBanner': 'Imported {imported} · skipped {skipped} · error {errors}',
    'imp.classification': 'classification',
    'imp.searchPreview': 'Search description / sheet…',
    'imp.allKinds': 'All kinds',
    'imp.rowsCount': '{n} rows',
    'imp.hppAllocation': 'COGS allocation',
    'imp.colRevenue': 'Revenue',
    'imp.controlPanel': 'Control panel',
    'imp.sessionSummary': 'Session summary',
    'imp.workbookActive': 'Workbook active',
    'imp.awaitingUpload': 'Awaiting upload',
    'imp.statBankRows': 'Bank rows',
    'imp.statCcRows': 'Card rows',
    'imp.statSelected': 'Selected',
    'imp.statSheets': 'Sheets',
    'imp.statCcPool': 'Card pool',
    'imp.statEmptyPt': 'No company',
    'imp.sessionEmpty': 'Upload Excel on the left to see sheet count, movements, and card pool here.',
    'imp.sessionEmptyMobile': 'Upload Excel above to see sheet count, movements, and card pool here.',
    'imp.coa': 'COA',
    'imp.mappingDefault': 'Default mapping',
    'imp.autoClassification': 'Auto classification',
    'imp.autoClassSub':
      'Used on parse. Override per row in review (flow, company, Dr/Cr accounts). Click a rule to filter the table.',
    'imp.legendIn': 'Inflow',
    'imp.legendOut': 'Outflow',
    'imp.legendBoth': 'Both directions',
    'imp.legendCc': 'Credit card',
    'imp.clearedNote':
      'Journals hit reports only when status is cleared (check “Post directly to FS” on import).',
    'imp.hppManualKicker': 'Without workbook',
    'imp.hppManualTitle': 'Manual COGS allocation',
    'imp.hppManualSub':
      'Split proportionally by JGI/JGT YTD revenue (or equal if revenue is zero). Journal: Dr 5000 · Cr 2700 per company.',
    'imp.allTab': 'All',
    'imp.hppDebitAcct': '5000 COGS',
    'imp.hppCreditAcct': '2700 CC reimbursement payable',
    'imp.lkShort': 'FS',
    'imp.hppTotalLabel': 'Total card spend (Rp)',
    'imp.fillFromWorkbook': 'Fill from workbook',
    'imp.journalDate': 'Journal date',
    'imp.memoLabel': 'Description / memo',
    'imp.hppPostCleared': 'Post directly to financial statements (cleared)',
    'imp.previewSplit': 'Preview split',
    'imp.allocateHpp': 'Allocate COGS → Journal',
    'imp.preview': 'Preview',
    'imp.result': 'Result',
    'imp.equalSplit': 'Equal split',
    'imp.revenueSplit': 'Revenue proportion',
    'imp.viewJournalLink': 'View journals',
    'imp.openLk': 'Open FS',
    'imp.shared': 'Shared',
    'imp.kind.revenue': 'Service revenue',
    'imp.kind.bunga': 'Bank interest',
    'imp.kind.owner': 'Owner movement',
    'imp.kind.internal': 'Internal transfer',
    'imp.kind.admin': 'Bank admin fee',
    'imp.kind.opex': 'Operating expense',
    'imp.kind.hpp': 'COGS',
    'imp.kind.custom': 'Custom (pick accounts)',
    'imp.rule.revenue.title': 'Credit inflow',
    'imp.rule.revenue.accountName': 'Service revenue',
    'imp.rule.revenue.journal': 'Dr Bank · Cr 4000',
    'imp.rule.revenue.hint': 'Incoming transfer / settlement / QRIS (default)',
    'imp.rule.bunga.title': 'Bank interest',
    'imp.rule.bunga.accountName': 'Interest income',
    'imp.rule.bunga.journal': 'Dr Bank · Cr 4001',
    'imp.rule.bunga.hint': 'Description contains “BUNGA” / interest',
    'imp.rule.admin.title': 'Admin fee / BIFAST',
    'imp.rule.admin.accountName': 'Bank admin fee',
    'imp.rule.admin.journal': 'Dr 5003 · Cr Bank',
    'imp.rule.admin.hint': 'Admin, fee, card charge, minimum balance',
    'imp.rule.owner.title': 'Owner movement',
    'imp.rule.owner.accountName': 'Related-party receivable / owner payable',
    'imp.rule.owner.journal': 'Out Dr 1202 · In Cr 2400 ↔ Bank',
    'imp.rule.owner.hint': 'Lim Sulaiman / Sulaiman Jaya',
    'imp.rule.internal.title': 'Internal transfer',
    'imp.rule.internal.accountName': 'Intercompany receivable',
    'imp.rule.internal.journal': 'Dr/Cr 1203 ↔ Bank',
    'imp.rule.internal.hint': 'Transfers between group accounts',
    'imp.rule.opex.title': 'Other debit',
    'imp.rule.opex.accountName': 'Operating expense',
    'imp.rule.opex.journal': 'Dr 5004 · Cr Bank',
    'imp.rule.opex.hint': 'Outflow fallback when no other rule matches',
    'imp.rule.hpp.title': 'Card charges',
    'imp.rule.hpp.accountName': 'COGS',
    'imp.rule.hpp.journal': 'Dr 5000 · Cr 2700',
    'imp.rule.hpp.hint': 'Revenue-proportional pool for JGI/JGT, or line journals + company',
    'imp.rule.keywords.ccSheet': 'Card sheets Panin/Danamon/…',
    'imp.hppDefaultMemo': 'COGS allocation from owner credit-card spend',
    'imp.snack.noCcTotal': 'No card total from workbook yet',
    'imp.snack.hppFilled': 'COGS filled {amount} from selected card/workbook',
    'imp.snack.unsupportedFile': 'Unsupported format — Excel, PDF, CSV, OFX, or e-statement image',
    'imp.snack.unsupportedFileNamed': '“{name}” rejected — use Excel / PDF / CSV / OFX / image',
    'imp.snack.unsupportedMany': '{n} files rejected — use Excel / PDF / CSV / OFX / image',
    'imp.snack.parsedStmt': 'E-statement: {n} lines from {files} file(s)',
    'imp.snack.parseEmpty': 'No transactions found — try another file or Excel workbook format',
    'imp.snack.duplicateFile': '“{name}” is already in the queue',
    'imp.snack.queuedMany': '{n} files queued — click Read workbook to continue',
    'imp.snack.queueReadFail': '{n} file(s) failed to read — try uploading again',
    'imp.aiStatusGemini': 'Gemini AI active',
    'imp.aiStatusGroq': 'Groq AI active (fallback)',
    'imp.aiStatusFailover': 'Gemini ↔ Groq auto-switch on limit',
    'imp.aiStatusOffline': 'AI offline — using local rules',
    'imp.snack.queued': '{name} queued — click Read workbook to continue',
    'imp.snack.needFile': 'Pick an Excel file first',
    'imp.snack.parsed':
      'Parsed {bank} bank + {cc} card · {sheets} bank sheets · card {ccTotal}{unmatched}',
    'imp.snack.unmatchedSheets': ' · {n} unrecognized sheets',
    'imp.snack.parseFail': 'Failed to parse Excel',
    'imp.snack.aiGemini': ' · Gemini smart-filled {n} rows',
    'imp.snack.aiGroq': ' · Groq (fallback) smart-filled {n} rows',
    'imp.snack.aiOffline': ' · AI offline — using local rules',
    'imp.snack.aiFail': 'AI failed — using local rule classification',
    'imp.snack.noSelection': 'No rows selected',
    'imp.snack.sharedPtWarn':
      '{n} rows still Shared — pick JGI/JGT so they are not missing from per-company reports',
    'imp.snack.ccNoPt':
      'Card line mode: {n} rows have no company. Set JGI/JGT first, or enable proportional COGS allocation.',
    'imp.snack.dryRun': 'Dry-run: {n} journals ready{pool}',
    'imp.snack.dryRunPool': ' + COGS pool {amount}',
    'imp.snack.imported': 'Import: {n} journals · skip {skipped}{report}',
    'imp.snack.inReport': ' · in reports',
    'imp.snack.pendingRecon': ' · pending reconciliation',
    'imp.snack.importFail': 'Import failed',
    'imp.snack.hppPreview': 'COGS preview: {method} · {amount}',
    'imp.snack.hppAllocated': 'COGS allocated to {n} companies{report}',
    'imp.snack.hppFail': 'Allocation failed',
    'imp.warn.unmatchedSheet':
      'Sheet "{sheet}" not recognized — skipped. Rename to Bank BCA/BNI/Mandiri/DBS or CC Panin/Danamon/Mega/CIMB/DBS.',
    'imp.warn.ccEmpty': 'Card sheet "{sheet}" recognized but charges = 0',
    'imp.warn.bankEmpty': 'Sheet "{sheet}" recognized but 0 transactions parsed',
    'imp.warn.oddYear': '{count} transactions outside 2025–2027 included (verify dates in review).',
    'imp.accountTitle': 'Account {code}',

    'usr.kicker': 'Access control',
    'usr.title': 'Users & Access Levels',
    'usr.sub':
      'Create accounts, set levels, and choose which menus each level can see. Users cannot be deleted — deactivate instead. Permanent removal is system-only.',
    'usr.addUser': 'Add user',
    'usr.addUserShort': 'User',
    'usr.addLevel': 'Add level',
    'usr.addLevelShort': 'Level',
    'usr.editUser': 'Edit user',
    'usr.editLevel': 'Edit level',
    'usr.editShort': 'Edit',
    'usr.levelFormKicker': 'Access & menus',
    'usr.sectionLevelIdentity': 'Level identity',
    'usr.sectionLevelSettings': 'Settings',
    'usr.levelCodeHint': 'Unique lowercase code',
    'usr.levelCodeAuto': 'Automatic: next available sequence number',
    'usr.levelNamePreview': 'Level #{code}',
    'usr.levelCodeLocked': 'Code cannot be changed',
    'usr.rankHint': 'Higher rank = more authority',
    'usr.rankAutoHint': 'Automatic from selected menus & permissions',
    'usr.rankLocked': 'System level rank is locked',
    'usr.levelDescResize': 'Drag the corner to resize',
    'usr.levelDescPlaceholder': 'Describe this level’s duties and limits…',
    'usr.canManageHint': 'Can open the user management page',
    'usr.canManageOn': 'On',
    'usr.canManageOff': 'Off',
    'usr.colorHint': 'Chip color on the level list',
    'usr.menuAccessSub': 'Choose pages this level may open',
    'usr.allMenusNote': 'This level gets full access to every menu.',
    'usr.saveLevel': 'Save level',
    'usr.createLevel': 'Create level',
    'usr.tabUsers': 'User accounts',
    'usr.tabUsersShort': 'Accounts',
    'usr.tabLevels': 'Levels & menus',
    'usr.tabLevelsShort': 'Levels',
    'usr.search': 'Search users / levels…',
    'usr.searchLabel': 'Search',
    'usr.statUsers': 'Total users',
    'usr.statActive': 'Active',
    'usr.statInactive': 'Inactive',
    'usr.statLevels': 'Levels',
    'usr.statToday': 'Changes today',
    'usr.statPass': 'Password changes',
    'usr.statTap': 'All accounts',
    'usr.statFilter': 'Filter list',
    'usr.statReview': '{n} need review',
    'usr.statOpenLevels': 'Open levels tab',
    'usr.statJumpHist': 'Jump to audit trail',
    'usr.statJumpPass': 'Password filter',
    'usr.vizLevelMix': 'Level mix',
    'usr.vizActivity': '7-day activity',
    'usr.vizActivityHint': 'Access-control changes per day',
    'usr.vizSnapshot': 'Control snapshot',
    'usr.vizEmpty': 'Nothing to visualize yet',
    'usr.snapActivePct': 'Active users',
    'usr.snapNever': 'Never logged in',
    'usr.snapReview': 'Levels needing review',
    'usr.openLevels': 'Manage levels',
    'usr.openLevelsShort': 'Levels',
    'usr.openMenuSyncHist': 'Menu sync history',
    'usr.openMenuSyncHistShort': 'Menu sync',
    'usr.healthTitle': 'Account status',
    'usr.healthSub': 'Tap a chip to filter the user list.',
    'usr.laneNever': 'Never logged in',
    'usr.laneMustPass': 'Must change password',
    'usr.tipsTitle': 'Action tips',
    'usr.tipInactive': '{n} inactive accounts — review if still needed',
    'usr.tipNever': '{n} users never logged in — check invite / initial password',
    'usr.tipMustPass': '{n} active users must change password',
    'usr.tipReviewLevels': '{n} levels need menu review after sync',
    'usr.tipToday': '{n} changes today — open audit trail',
    'usr.tipOk': 'Access control looks healthy — no urgent findings',
    'usr.focusActive': 'Focus: active users',
    'usr.focusInactive': 'Focus: inactive users',
    'usr.focusNever': 'Focus: never logged in',
    'usr.focusMustPass': 'Focus: must change password',
    'usr.focusSearch': 'Search: “{q}”',
    'usr.focusHist': 'History: {f}',
    'usr.clearFocus': 'Clear filters',
    'usr.emptyUsersFiltered': 'No users match this filter',
    'usr.emptyUsersFilteredHint': 'Change the search or clear the status focus.',
    'usr.emptyUsersHint': 'Add the first user to start managing access.',
    'usr.hist.emptyHint': 'User & level activity will show here after changes.',
    'usr.noDeleteNote':
      'There is no delete-user action. Deactivate unused accounts. System-marked users are locked. Use the eye icon to reveal a password; click the history row under it for the timeline.',
    'usr.emptyUsers': 'No users yet',
    'usr.colUser': 'User',
    'usr.colName': 'Name',
    'usr.colAccount': 'Account',
    'usr.colContact': 'Contact',
    'usr.colPassword': 'Password',
    'usr.colLevel': 'Level',
    'usr.colStatus': 'Status',
    'usr.colLogin': 'Last login',
    'usr.colActions': 'Actions',
    'usr.active': 'Active',
    'usr.inactive': 'Inactive',
    'usr.mustChange': 'Reset pass',
    'usr.passSet': 'Stored',
    'usr.passNever': 'Never changed',
    'usr.revealPass': 'Show password',
    'usr.hidePass': 'Hide password',
    'usr.passNoVault': 'Older passwords cannot be revealed. Change the password once to store it in the vault.',
    'usr.passRevealFail': 'Failed to reveal password',
    'usr.lastLogin': 'Last login',
    'usr.neverLogin': 'Never logged in',
    'usr.copyUser': 'Copy username',
    'usr.viewPassHistory': 'Password history',
    'usr.noName': 'Name not set',
    'usr.edit': 'Edit',
    'usr.changePass': 'Change password',
    'usr.activate': 'Activate',
    'usr.deactivate': 'Deactivate',
    'usr.editMenus': 'Edit menus',
    'usr.canManage': 'Manage users',
    'usr.allMenus': 'All menus',
    'usr.menuCount': '{n} menus',
    'usr.formKicker': 'Account form',
    'usr.createUser': 'Create user',
    'usr.sectionIdentity': 'Identity',
    'usr.sectionContact': 'Contact',
    'usr.sectionAccount': 'Account & security',
    'usr.sectionStatus': 'Status & policy',
    'usr.sectionIdentityHint': 'Official name shown in the user list and audit trail.',
    'usr.sectionContactHint': 'Used for notifications and account verification.',
    'usr.sectionAccountHint': 'Login credentials and access level in the app.',
    'usr.sectionStatusHint': 'Password policy and whether the account can sign in.',
    'usr.firstName': 'First name',
    'usr.lastName': 'Last name',
    'usr.username': 'Username',
    'usr.usernameHint': 'Suggested from the name; editable before saving.',
    'usr.usernameLocked': 'Username cannot be changed after the account is created.',
    'usr.levelHint': 'Controls which menus and permissions are available.',
    'usr.displayName': 'Display name',
    'usr.email': 'Email',
    'usr.phone': 'Phone',
    'usr.phoneHint': 'Example: 08xxxxxxxxxx',
    'usr.phFirstName': 'e.g. John',
    'usr.phLastName': 'e.g. Doe',
    'usr.phEmail': 'name@company.com',
    'usr.phPhone': '08xxxxxxxxxx',
    'usr.phUsername': 'user.name',
    'usr.phLevel': 'Select access level',
    'usr.phPassword': 'At least 8 characters',
    'usr.phPasswordConfirm': 'Repeat the same password',
    'usr.level': 'Access level',
    'usr.employeeLink': 'Employee link (portal)',
    'usr.employeeNone': '— Not linked —',
    'usr.employeeNoneHint': 'User cannot use payslip/advance portal',
    'usr.employeeHint': 'Required for Staff level so they can view pay & request advances.',
    'usr.employeeResign': 'Resigned',
    'usr.phEmployee': 'Search employee / company…',
    'usr.taxClientLink': 'Tax client link (customer)',
    'usr.taxClientNone': '— Not linked —',
    'usr.taxClientHint': 'Required for Customer level so they can submit tax report requests.',
    'usr.phTaxClient': 'Search client code / name…',
    'usr.password': 'Password',
    'usr.mustChangePass': 'Must change password on next login',
    'usr.mustChangeShort': 'Change password',
    'usr.mustChangePassHint': 'User must set a new password on the next login.',
    'usr.mustChangeOn': 'Required',
    'usr.mustChangeOff': 'Not required',
    'usr.accountStatus': 'Account status',
    'usr.activeHint': 'Inactive accounts cannot sign in to the app.',
    'usr.newPassword': 'New password',
    'usr.confirmPassword': 'Confirm password',
    'usr.savePass': 'Save password',
    'usr.passFormKicker': 'Account security',
    'usr.passSection': 'New password',
    'usr.passSectionHint': 'Enter the new password twice. Use the eye icon to verify before saving.',
    'usr.passTipLength': 'Use at least 8 characters (longer is safer).',
    'usr.passTipMix': 'Mix letters, numbers, and symbols when possible.',
    'usr.passTipUnique': 'Do not reuse passwords from other accounts.',
    'usr.levelCode': 'Level code',
    'usr.levelName': 'Level name',
    'usr.levelDesc': 'Description',
    'usr.rank': 'Rank',
    'usr.color': 'Color',
    'usr.menuAccess': 'Menus this level can see',
    'usr.forbidden': 'Your level cannot open this page',
    'usr.loadFail': 'Failed to load users',
    'usr.hist.kicker': 'Audit trail',
    'usr.hist.title': 'Change history',
    'usr.hist.sub': 'All activity: add user, password change, profile update, levels, menu sync, activate/deactivate.',
    'usr.hist.refresh': 'Refresh',
    'usr.hist.refreshShort': 'Reload',
    'usr.hist.search': 'Search history…',
    'usr.hist.searchLabel': 'Search',
    'usr.hist.empty': 'No change history yet',
    'usr.hist.filterAll': 'All',
    'usr.hist.filterPass': 'Password',
    'usr.hist.filterPassShort': 'Password',
    'usr.hist.filterCreate': 'Add user',
    'usr.hist.filterCreateShort': 'Add',
    'usr.hist.filterUpdate': 'Updates',
    'usr.hist.filterLevel': 'Levels',
    'usr.hist.filterMenuSync': 'Menu update',
    'usr.hist.filterMenuSyncShort': 'Menu',
    'usr.hist.password': 'Password',
    'usr.hist.create': 'Created',
    'usr.hist.update': 'Updated',
    'usr.hist.activate': 'Activated',
    'usr.hist.deactivate': 'Deactivated',
    'usr.hist.levelCreate': 'Level created',
    'usr.hist.levelUpdate': 'Level updated',
    'usr.hist.menuSync': 'Menu sync',
    'usr.sync.title': 'Menu & access catalog',
    'usr.sync.kicker': 'Authority sync',
    'usr.sync.desc':
      'Pull every latest page & menu. Admin / Super System are auto-checked for full access. Other levels can be reviewed.',
    'usr.sync.update': 'Update',
    'usr.sync.updateNow': 'Update Now',
    'usr.sync.lastUpdate': 'Last update',
    'usr.sync.never': 'Never updated. Click Update Now to pull all pages.',
    'usr.sync.neverShort': 'No sync yet. Press Update Now.',
    'usr.sync.updating': 'Updating…',
    'usr.sync.paths': '{n} paths',
    'usr.sync.autoFull': 'Admin full · {n}',
    'usr.sync.autoFullHint': 'Admin & Super System already have full access automatically.',
    'usr.sync.fullAccess': 'Full access',
    'usr.sync.bootstrap': 'Catalog synced · {n} paths · admin full auto ({a})',
    'usr.sync.foundNew': '{n} new access items · admin full auto ({a}) — review other levels',
    'usr.sync.upToDate': 'Up to date · {n} paths · admin full ({a})',
    'usr.sync.fail': 'Failed to update menu catalog',
    'usr.sync.newFound': '{n} new menu/access items',
    'usr.sync.reviewHint': '{n} levels need checklist review',
    'usr.sync.reviewChip': '{n} new',
    'usr.sync.newChip': '{n} new',
    'usr.sync.onlyNew': 'New only',
    'usr.sync.checkNew': 'Check all new',
    'usr.sync.checkedNew': 'New menus checked — save the level to apply',
    'usr.sync.badgeNew': 'New',
    'usr.sync.noNewInFilter': 'No new menus in this filter',
    'usr.hist.passKicker': 'Password history',
    'usr.hist.passEmpty': 'No password changes for this user yet',
    'usr.hist.passEmptyHint': 'When the password is changed, each update will appear here with date and actor.',
    'usr.hist.passTimeline': 'Change timeline',
    'usr.hist.passTimelineHint': 'Newest first. All entries come from the application audit trail.',
    'usr.hist.passCount': 'Total changes',
    'usr.hist.passLast': 'Last changed',
    'usr.hist.passLatest': 'Latest',
    'usr.hist.day': 'Day',
    'usr.hist.month': 'Month',
    'usr.hist.year': 'Year',
    'usr.hist.clock': 'Time',
    'usr.snack.userCreated': 'User created',
    'usr.snack.userUpdated': 'User updated',
    'usr.snack.levelCreated': 'Level created',
    'usr.snack.levelUpdated': 'Level updated',
    'usr.snack.passChanged': 'Password changed',
    'usr.snack.passMismatch': 'Passwords do not match',
    'usr.snack.saveFail': 'Save failed',
    'usr.snack.systemLocked': 'System user cannot be deactivated',
    'usr.snack.activated': 'User activated',
    'usr.snack.deactivated': 'User deactivated',
    'usr.snack.copied': 'Username @{user} copied',
    'usr.snack.copyFail': 'Copy failed',

    'ob.title': 'Opening Balance',
    'ob.kicker': 'Books setup',
    'ob.sub':
      'Enter opening balance sheet so financial statements balance. Journals post one day before the “As of” date. Example: As of 1 Jan 2026 → posting 31 Dec 2025.',
    'ob.postingDateLabel': 'Journal posting date',
    'ob.postingHint': 'As of {asOf} → journal one day earlier',
    'ob.formKicker': 'Opening balance form',
    'ob.statusReady': 'Balanced — ready to save',
    'ob.statusDiff': 'Difference {n}',
    'ob.statusEmpty': 'Not filled yet',
    'ob.asOfLabel': 'As of (period start)',
    'ob.description': 'Description',
    'ob.memoPlaceholder': 'Example: Opening balance 1 Jan 2026',
    'ob.memoAuto': 'Opening balance {code} as of {date}',
    'ob.tip':
      'Tip: enter Cash, Bank, Shareholder receivable, Accounts payable, Capital, Retained earnings.',
    'ob.tipBold': 'Total debit must equal total credit.',
    'ob.filledLines': 'Filled lines',
    'ob.totalDebit': 'Total debit',
    'ob.totalCredit': 'Total credit',
    'ob.diff': 'Difference',
    'ob.pickAccount': 'Select account',
    'ob.addLine': 'Add row',
    'ob.addFive': '+5 rows',
    'ob.clearLines': 'Clear form',
    'ob.save': 'Save opening balance',
    'ob.snack.minLines': 'At least 2 lines required',
    'ob.snack.saved': 'Opening balance saved {ref} (posted {date})',
    'ob.snack.template': 'Template applied · {n} accounts detected',
    'ob.snack.tplMissing': 'Template account not found in COA',
    'ob.snack.alreadyBalanced': 'Already balanced',
    'ob.snack.noRe': 'Retained earnings / equity account not found',
    'ob.snack.autoBal': 'Difference {amt} moved to {acct}',
    'ob.snack.csv': 'Draft CSV downloaded',
    'ob.snack.dupWarn': 'Duplicate accounts — review before saving',
    'ob.snack.dupBlock': 'Duplicate accounts found. Fix them, or check the override in the warning.',
    'ob.snack.ptCleared': 'Company changed — lines cleared so accounts are not mixed',
    'ob.snack.loadedExisting': 'Loaded opening balance {ref} into the form',
    'ob.existingTitle': 'Opening balance exists · Ref {ref}',
    'ob.existingSub': 'Journal posted {date}. Load into the form or open the Ref.',
    'ob.existingLoad': 'Load into form',
    'ob.flowAria': 'Opening balance workflow',
    'ob.dupOverride': 'I understand — allow save with duplicate accounts',
    'ob.progress': 'Progress {n}/{total}',
    'ob.flow1': 'Pick company',
    'ob.flow2': 'Set as-of date',
    'ob.flow3': 'Fill account lines',
    'ob.flow4': 'Balance & save',
    'ob.linkLk': 'Import from FS PDF',
    'ob.linkHistory': 'Opening history',
    'ob.linkBs': 'View balance sheet',
    'ob.coachKicker': 'Desk guide',
    'ob.coachTitle': 'Checklist before posting',
    'ob.check.pt': 'Company selected',
    'ob.check.date': 'As-of date set',
    'ob.check.lines': 'At least 2 valued lines',
    'ob.check.dup': 'No duplicate accounts',
    'ob.check.bal': 'Debit = Credit',
    'ob.keySave': 'save',
    'ob.keyAdd': 'add row',
    'ob.tpl.kicker': 'Quick skeleton',
    'ob.tpl.title': 'Typical opening accounts',
    'ob.tpl.apply': 'Apply skeleton',
    'ob.tpl.dummy': 'Fill dummy balance',
    'ob.tpl.missing': 'Not found in COA',
    'ob.tpl.cash': 'Cash',
    'ob.tpl.bank': 'Bank',
    'ob.tpl.ar': 'Accounts receivable',
    'ob.tpl.arStaff': 'Staff receivable',
    'ob.tpl.arRelated': 'Related-party receivable',
    'ob.tpl.inv': 'Inventory',
    'ob.tpl.prepaid': 'Prepaid expenses',
    'ob.tpl.prepaidTax': 'Prepaid tax',
    'ob.tpl.fa': 'Fixed assets',
    'ob.tpl.accum': 'Accumulated depreciation',
    'ob.tpl.ap': 'Accounts payable',
    'ob.tpl.tax': 'Tax payable',
    'ob.tpl.unearned': 'Customer advances',
    'ob.tpl.cc': 'Credit card payable',
    'ob.tpl.owner': 'Owner payable',
    'ob.tpl.intangible': 'Intangible assets',
    'ob.tpl.equity': 'Capital',
    'ob.tpl.re': 'Retained earnings',
    'ob.lk.kicker': 'Statement / FS',
    'ob.lk.title': 'Upload balance-sheet PDF',
    'ob.lk.sub': 'Parse the FS (dry-run) then load rows into the table — no auto-posting.',
    'ob.lk.parse': 'Parse preview',
    'ob.lk.apply': 'Load into table',
    'ob.lk.clear': 'Clear file',
    'ob.lk.pickFile': 'Choose PDF / TXT file',
    'ob.lk.needFile': 'Choose a PDF/TXT file first',
    'ob.lk.parsed': 'Preview ready · {n} lines detected',
    'ob.lk.applied': '{n} FS lines loaded into the table',
    'ob.lk.empty': 'No balance-sheet lines in the preview',
    'ob.lk.previewMeta': '{pt} · {n} lines · As of {asOf}',
    'ob.linkLkFull': 'Open Statement Import',
    'ob.col.lineRef': 'Line Ref',
    'ob.col.code': 'Code',
    'ob.col.type': 'Type',
    'ob.col.accountNo': 'Account no.',
    'ob.col.accountNoEmpty': 'Not set',
    'ob.col.kasBank': 'Cash/Bank',
    'ob.col.cashName': 'Cash name',
    'ob.col.contra': 'Contra account',
    'ob.col.contraPh': 'Pick contra',
    'ob.col.contraType': 'Contra type',
    'ob.col.desc': 'Description',
    'ob.col.descPh': 'Line note',
    'ob.col.journalRef': 'Journal fingerprint',
    'ob.col.officialRef': 'Official Ref (J7P)',
    'ob.col.fingerprint': 'OB fingerprint',
    'ob.refPreviewHint': 'Next available number — locked on save (late requests get the following number)',
    'ob.refSavedHint': 'Official journal ref (unique, no doubles)',
    'ob.fingerprintHint': 'Idempotent PT+date key — re-save does not create a new journal',
    'ob.snack.dummy': 'Dummy balance filled · {n} accounts',
    'ob.snack.skippedDup': 'Opening balance already exists · using Ref {ref} (not duplicated)',
    'ob.typeAll': 'All types',
    'ob.typeAsset': 'Assets',
    'ob.typeLiability': 'Liabilities',
    'ob.typeEquity': 'Equity',
    'ob.typeRevenue': 'Revenue',
    'ob.typeExpense': 'Expense',
    'ob.dateThisFy': '1 Jan {year}',
    'ob.datePrevFy': '1 Jan {year}',
    'ob.dupAlert': 'An account is selected more than once. Merge or change one.',
    'ob.savedTitle': 'Saved · Ref {ref}',
    'ob.savedSub': 'Journal posted {date}',
    'ob.openRef': 'Open Ref',
    'ob.hideEmpty': 'Hide empty',
    'ob.showEmpty': 'Show empty',
    'ob.autoBalance': 'Auto-balance difference',
    'ob.exportCsv': 'Export draft CSV',
    'ob.expand': 'Expand table',
    'ob.collapse': 'Collapse',
    'ob.expandTitle': 'Opening balance table — fullscreen',
    'ob.confirmTitle': 'Confirm save opening balance',
    'ob.confirmBody': 'Posting for {pt} · As of {asOf} · journal {post}.',
    'ob.confirmDebit': 'Total Debit {n}',
    'ob.confirmCredit': 'Total Credit {n}',
    'ob.confirmLines': '{n} filled lines',

    'co.title': 'Tax ID & Companies',
    'co.kicker': 'Identity & tax administration',
    'co.sub':
      'Enter tax ID, tax office, NITKU, VAT registration, and SPT-related data manually. Empty cells are highlighted — complete before export.',
    'co.addCompany': 'Add company',
    'co.statTotal': 'Total companies',
    'co.statNpwpOk': 'Tax ID complete',
    'co.statNpwpMissing': 'Tax ID missing',
    'co.statIncomplete': 'Admin data incomplete',
    'co.listKicker': 'Master list',
    'co.listTitle': 'Company & tax data list',
    'co.searchPh': 'Search code / name / tax ID / office…',
    'co.colNo': 'No',
    'co.colCode': 'Code',
    'co.colName': 'Company name',
    'co.colNpwp': 'Tax ID',
    'co.colAddress': 'Address',
    'co.colCity': 'City',
    'co.colKpp': 'Tax office',
    'co.colNitku': 'NITKU',
    'co.colPkp': 'VAT',
    'co.colTaxPic': 'Tax PIC',
    'co.colStatus': 'Status',
    'co.colAction': 'Action',
    'co.pphFinal': 'Final tax {rate}%',
    'co.pkp': 'VAT registered',
    'co.nonPkp': 'Non-VAT',
    'co.statusIncomplete': 'Incomplete',
    'co.statusReady': 'Ready for SPT',
    'co.editSave': 'Edit & save',
    'co.empty': 'No company data yet — click Add company to enter tax ID & admin details',
    'co.alertIncomplete':
      '{n} companies have incomplete admin data (tax ID / address / tax office). Edit and save before SPT export.',
    'co.goSpt': 'Go to periodic SPT',
    'co.dialogEdit': 'Manual edit',
    'co.dialogNew': 'Add new',
    'co.dialogEditTitle': 'Edit {code}',
    'co.dialogAddTitle': 'Add company + tax ID',
    'co.tabIdentity': 'Identity',
    'co.tabTax': 'Tax administration',
    'co.tabContact': 'Contact & PIC',
    'co.codeLabel': 'Company code *',
    'co.codeHint': 'Example: JGI, JGT',
    'co.nameLabel': 'Full company name *',
    'co.npwpLabel': 'Tax ID *',
    'co.npwpHint': '15/16 digits — auto-formatted',
    'co.required': 'Required',
    'co.npwpIncomplete': 'Tax ID incomplete (15/16 digits)',
    'co.addressLabel': 'Full address *',
    'co.addressRequired': 'Required for SPT',
    'co.cityLabel': 'City / regency',
    'co.pphRateLabel': 'Final tax rate (0.005 = 0.5%)',
    'co.kppLabel': 'Tax office name *',
    'co.kppHint': 'Example: KPP Pratama Tangerang Barat',
    'co.kppRequired': 'Required for tax administration',
    'co.kppCodeLabel': 'Tax office code',
    'co.nitkuLabel': 'NITKU',
    'co.nitkuHint': 'Business activity location ID number',
    'co.kluLabel': 'Business field / KLU',
    'co.pkpSwitch': 'VAT registered (PKP)',
    'co.pkpDateLabel': 'VAT registration date',
    'co.taxPicLabel': 'Tax PIC / responsible person',
    'co.taxPicNpwpLabel': 'PIC tax ID',
    'co.phoneLabel': 'Phone',
    'co.emailLabel': 'Email',
    'co.saveCompany': 'Save company data',
    'co.snack.nameRequired': 'Company name is required',
    'co.snack.codeRequired': 'Company code is required',
    'co.snack.saved': 'Tax ID & company admin data saved',
    'co.snack.added': 'New company added',
    'co.snack.saveFail': 'Save failed',
    'co.statReady': 'SPT ready',
    'co.statNoPic': 'No tax PIC',
    'co.showing': '{n} companies shown',
    'co.readyPct': '{pct}% ready',
    'co.incompleteN': '{n} incomplete',
    'co.readyHint': '{ok} SPT-ready · {need} need attention',
    'co.needAttention': '{n} items need attention',
    'co.vizReady': 'SPT readiness',
    'co.vizGaps': 'Still-empty fields',
    'co.vizPt': 'Completeness by company',
    'co.vizPkp': 'VAT {pkp} · Non-VAT {non}',
    'co.filterBar': 'Company filter & search',
    'co.healthTitle': 'Tax data health',
    'co.healthSub': 'Click a lane to focus companies that need cleanup.',
    'co.clearLane': 'Show all',
    'co.lane.all': 'All',
    'co.lane.ready': 'SPT ready',
    'co.lane.incomplete': 'Incomplete',
    'co.lane.npwp_missing': 'Tax ID missing',
    'co.lane.npwp_ok': 'Tax ID complete',
    'co.lane.pkp': 'VAT registered',
    'co.lane.non_pkp': 'Non-VAT',
    'co.lane.no_pic': 'No PIC',
    'co.tipsTitle': 'Quick tips · tidy tax master',
    'co.tipsShow': 'Show',
    'co.tipsHide': 'Hide',
    'co.tip1': 'Prioritize tax ID, address, and tax office — without them status stays Incomplete.',
    'co.tip2': 'Fill NITKU & tax PIC so SPT docs and correspondence are ready.',
    'co.tip3': 'Red chips on a row show which fields are still empty.',
    'co.tip4': 'Export CSV after data is complete — active filters are included.',
    'co.tipActEdit': 'Edit {n} incomplete companies',
    'co.tipActIncomplete': 'Filter incomplete ({n})',
    'co.tipActNpwp': 'Filter missing tax ID ({n})',
    'co.tipActPic': 'Filter no PIC ({n})',
    'co.toBank': 'Bank accounts',
    'co.exportCsv': 'Export CSV',
    'co.exportEmpty': 'Nothing to export',
    'co.exportDone': 'CSV downloaded ({n} companies)',
    'co.listSub': 'Empty cells are red · chips show missing fields',
    'co.emptyTitle': 'No matching companies',
    'co.emptyFiltered': 'Filters are too tight — reset or change search.',
    'co.resetFilters': 'Reset filters',
    'co.formReady': 'Form completeness {pct}%',

    'acc.title': 'Account List',
    'acc.eyebrow': 'Master · Chart of Accounts',
    'acc.sub': 'Manage account numbers & names, report mapping, and normal balance — linked to journals, reconciliation, and reports',
    'acc.add': 'Add account',
    'acc.addMulti': 'Add multiple',
    'acc.expandView': 'Expand',
    'acc.collapseView': 'Collapse',
    'acc.edit': 'Edit',
    'acc.activate': 'Activate',
    'acc.deactivate': 'Deactivate',
    'acc.search': 'Search by account number or name…',
    'acc.empty': 'No matching accounts',
    'acc.colCode': 'No.',
    'acc.colName': 'Account name',
    'acc.colBand': 'Group',
    'acc.colType': 'Type',
    'acc.colMap': 'Mapping',
    'acc.colNormal': 'Normal',
    'acc.colCompany': 'Co.',
    'acc.colStatus': 'Status',
    'acc.colLastEdit': 'Last edit',
    'acc.colActions': 'Actions',
    'acc.log.title': 'Edit history',
    'acc.log.sub': 'Who changed it, with date & time saved automatically',
    'acc.log.last': 'Last edit',
    'acc.log.empty': 'No history yet',
    'acc.log.showMore': 'Show all ({n})',
    'acc.log.showLess': 'Show less',
    'acc.log.action.create': 'Create',
    'acc.log.action.update': 'Update',
    'acc.log.action.activate': 'Activate',
    'acc.log.action.deactivate': 'Deactivate',
    'acc.log.action.bulk': 'Bulk',
    'acc.allCompanies': 'All',
    'acc.dialogTitle': 'Add account',
    'acc.dialogEdit': 'Edit account',
    'acc.dialogAddEyebrow': 'New account',
    'acc.dialogEditEyebrow': 'Update account',
    'acc.dialogHint':
      'Pick a type → the system sets report mapping & normal balance. Read the red Debit/Credit guide, then enter a clear account name.',
    'acc.codeEditHint': 'Account number is locked after save',
    'acc.codeLockedHint': 'Number locked — only the system may change it. Name & type remain editable.',
    'acc.codeCapacity': 'Used: {used} · Remaining: {remaining} · Reserve: {reserve} (e.g. {example})',
    'acc.codeLabel': 'Account number',
    'acc.nameLabel': 'Account name',
    'acc.namePlaceholder': 'e.g. Cash, BCA Bank, Accounts Receivable…',
    'acc.codeShort': 'No.',
    'acc.nameShort': 'Account name',
    'acc.typeLabel': 'Type / report mapping',
    'acc.normalLabel': 'Normal balance',
    'acc.normalHint': 'Default journal side (Debit or Credit)',
    'acc.normalGuide.incLabel': 'Increases',
    'acc.normalGuide.decLabel': 'Decreases',
    'acc.normalGuide.asset.title': 'Normal balance for Assets = Debit',
    'acc.normalGuide.asset.side': 'Debit',
    'acc.normalGuide.asset.meaning':
      'Debit = left journal side (increases assets/expenses). Credit = right side (increases liabilities/equity/revenue).',
    'acc.normalGuide.asset.why':
      'Normal balance = the side that increases the account. Assets rise on Debit — so asset normal balance = Debit.',
    'acc.normalGuide.asset.inc': 'Equipment (asset) increases = Debit',
    'acc.normalGuide.asset.dec': 'Equipment (asset) decreases = Credit',
    'acc.normalGuide.asset.tip':
      'Example: buy equipment → Debit Equipment, Credit Bank/Cash. Dispose of an asset → Credit the asset.',
    'acc.normalGuide.liability.title': 'Normal balance for Liabilities = Credit',
    'acc.normalGuide.liability.side': 'Credit',
    'acc.normalGuide.liability.meaning':
      'Debit = left. Credit = right. Payables increase on Credit; paying them decreases with Debit.',
    'acc.normalGuide.liability.why':
      'Liabilities increase on the Credit side. Liability normal balance = Credit.',
    'acc.normalGuide.liability.inc': 'Accounts payable (liability) increases = Credit',
    'acc.normalGuide.liability.dec': 'Accounts payable (liability) decreases / paid = Debit',
    'acc.normalGuide.liability.tip':
      'Example: buy on credit → Debit Expense/Inventory, Credit Payable. Pay the debt → Debit Payable, Credit Bank.',
    'acc.normalGuide.equity.title': 'Normal balance for Equity = Credit',
    'acc.normalGuide.equity.side': 'Credit',
    'acc.normalGuide.equity.meaning':
      'Owner capital increases on Credit. Owner draws decrease equity with Debit.',
    'acc.normalGuide.equity.why':
      'Equity increases on the Credit side. Equity normal balance = Credit.',
    'acc.normalGuide.equity.inc': 'Capital (equity) increases = Credit',
    'acc.normalGuide.equity.dec': 'Capital (equity) decreases / owner draw = Debit',
    'acc.normalGuide.equity.tip':
      'Example: owner invests cash → Debit Cash/Bank, Credit Capital. Owner outflow → Debit related-party receivable (1202), Credit Bank. Owner inflow → Debit Bank, Credit owner payable (2400).',
    'acc.normalGuide.revenue.title': 'Normal balance for Revenue = Credit',
    'acc.normalGuide.revenue.side': 'Credit',
    'acc.normalGuide.revenue.meaning':
      'Revenue increases profit → recorded as Credit. Reversals debit revenue.',
    'acc.normalGuide.revenue.why':
      'Revenue increases equity on the Credit side. Revenue normal balance = Credit.',
    'acc.normalGuide.revenue.inc': 'Service revenue increases = Credit',
    'acc.normalGuide.revenue.dec': 'Revenue reversed / corrected = Debit',
    'acc.normalGuide.revenue.tip':
      'Example: receive payment for services → Debit Cash/Bank/AR, Credit Revenue. Refund → Debit Revenue.',
    'acc.normalGuide.expense.title': 'Normal balance for Expenses = Debit',
    'acc.normalGuide.expense.side': 'Debit',
    'acc.normalGuide.expense.meaning':
      'Expenses reduce profit → recorded as Debit. Corrections credit the expense.',
    'acc.normalGuide.expense.why':
      'Expenses increase on the Debit side. Expense normal balance = Debit.',
    'acc.normalGuide.expense.inc': 'Salary expense increases = Debit',
    'acc.normalGuide.expense.dec': 'Salary expense reversed / corrected = Credit',
    'acc.normalGuide.expense.tip':
      'Example: pay salaries → Debit Salary Expense, Credit Bank. Correct overstated expense → Credit Expense.',
    'acc.nameGuide.asset.title': 'How to name asset accounts',
    'acc.nameGuide.asset.hint':
      'Use clear, specific names. Do not put “JGI/JGT” in the name — company is chosen on the journal. One bank = one shared name.',
    'acc.nameGuide.asset.examples':
      'Good examples: Cash · BCA Bank · BNI Bank · Accounts Receivable · Warehouse Equipment · Inventory',
    'acc.nameGuide.liability.title': 'How to name liability accounts',
    'acc.nameGuide.liability.hint':
      'Name the kind of payable clearly so journals are easy to read.',
    'acc.nameGuide.liability.examples':
      'Good examples: Accounts Payable · Credit Card Reimbursement · PPh 21 Tax Payable · Final Tax Payable',
    'acc.nameGuide.equity.title': 'How to name equity accounts',
    'acc.nameGuide.equity.hint':
      'Split capital by owner if needed. Owner movement and internal transfers are receivables (1202 / 1203), not equity.',
    'acc.nameGuide.equity.examples':
      'Good examples: Capital · Capital Lim Sulaiman Jaya · Capital Andi Chandra · Retained Earnings',
    'acc.nameGuide.revenue.title': 'How to name revenue accounts',
    'acc.nameGuide.revenue.hint':
      'One revenue type = one account. Do not mix bank interest with service revenue.',
    'acc.nameGuide.revenue.examples':
      'Good examples: Warehouse Service Revenue · Bank Interest Income · Rental Income',
    'acc.nameGuide.expense.title': 'How to name expense accounts',
    'acc.nameGuide.expense.hint':
      'Group costs clearly. One main expense type = one account.',
    'acc.nameGuide.expense.examples':
      'Good examples: Salaries & Benefits · Bank Admin Fees · Other Operating Costs · COGS',
    'acc.companyOptional': 'Company',
    'acc.mapLabel': 'Mapping',
    'acc.map.asset': 'Balance sheet · Assets',
    'acc.map.liability': 'Balance sheet · Liabilities',
    'acc.map.equity': 'Balance sheet · Equity',
    'acc.map.revenue': 'Income statement · Revenue',
    'acc.map.expense': 'Income statement · Expenses',
    'acc.status.active': 'Active',
    'acc.status.inactive': 'Inactive',
    'acc.stat.total': 'Total accounts',
    'acc.stat.active': 'Active',
    'acc.stat.inactive': 'Inactive',
    'acc.stat.totalHint': 'Click to reset all filters',
    'acc.stat.activeHint': 'Click to filter active accounts',
    'acc.stat.inactiveHint': 'Click to filter inactive accounts',
    'acc.type.asset': 'Asset',
    'acc.type.liability': 'Liability',
    'acc.type.equity': 'Equity',
    'acc.type.revenue': 'Revenue',
    'acc.type.expense': 'Expense',
    'acc.bandsTitle': 'Account class ranges',
    'acc.bandsHint': 'Grouped by financial-statement line (PSAK 1). Codes follow class: cash 1000, AR 1200, tax payables 2300, …',
    'acc.view.ledger': 'Ledger',
    'acc.view.table': 'Table',
    'acc.print': 'Print chart',
    'acc.printTitle': 'Chart of Accounts',
    'acc.printMeta': 'Printed {date} · {n} accounts',
    'acc.exportCsv': 'Export CSV',
    'acc.exportEmpty': 'No accounts to export',
    'acc.exportDone': 'CSV downloaded ({n} accounts)',
    'acc.ledgerCount': '{n} accounts shown',
    'acc.ledgerAccounts': '{n} accounts',
    'acc.colFs': 'Statement line',
    'acc.vizStmt': 'Statement lines',
    'acc.liq.current': 'Current',
    'acc.liq.noncurrent': 'Non-current',
    'acc.liq.equity': 'Equity',
    'acc.liq.pl': 'P&L',
    'acc.stmt.bs_ca': 'Current assets',
    'acc.stmt.bs_nca': 'Non-current assets',
    'acc.stmt.bs_cl': 'Current liabilities',
    'acc.stmt.bs_ncl': 'Non-current liabilities',
    'acc.stmt.bs_eq': 'Equity',
    'acc.stmt.pl_rev': 'Revenue',
    'acc.stmt.pl_exp': 'Expenses',
    'acc.class.kas': 'Cash & equivalents',
    'acc.class.persediaan': 'Inventory',
    'acc.class.piutang': 'Receivables',
    'acc.class.prepaid': 'Prepaid',
    'acc.class.prepaid_tax': 'Prepaid tax',
    'acc.class.fixed_asset': 'Fixed assets',
    'acc.class.accum_depr': 'Accumulated depreciation',
    'acc.class.accum_amort': 'Accumulated amortization',
    'acc.class.intangible': 'Intangibles',
    'acc.class.other_nca': 'Other non-current assets',
    'acc.class.hutang_usaha': 'Trade payables',
    'acc.class.hutang_ops': 'Operating payables',
    'acc.class.hutang_pajak': 'Tax payables',
    'acc.class.hutang_owner': 'Owner payables',
    'acc.class.hutang_ic': 'Intercompany payables',
    'acc.class.unearned': 'Unearned revenue',
    'acc.class.hutang_cc': 'Credit card / bank debt',
    'acc.class.hutang_lt': 'Long-term liabilities',
    'acc.class.equity': 'Equity',
    'acc.class.revenue': 'Revenue',
    'acc.class.expense': 'Expense',
    'acc.clearBand': 'Clear class filter',
    'acc.codeAutoHint': 'Auto from name/class · range {range} · Regenerate = next free number',
    'acc.codeManualHint': 'Number edited manually — click Regenerate to auto-fill again',
    'acc.codeRegen': 'Regenerate',
    'acc.multiTitle': 'Add multiple accounts',
    'acc.multiHint': 'Pick a type — numbers follow the class from the name (inventory 1100, AR 1200, …). Enter names only.',
    'acc.multiApplyDefaults': 'Apply type to all rows',
    'acc.multiAddRow': 'Add row',
    'acc.cap.used': 'Used',
    'acc.cap.remaining': 'Remaining',
    'acc.cap.reserve': 'Reserve',
    'acc.cap.overflow': 'Reserve example',
    'acc.multiRemoveRow': 'Remove row',
    'acc.multiNoRows': 'No rows yet. Click Add row to start.',
    'acc.multiReady': '{n} rows ready to save',
    'acc.multiSave': 'Save {n} accounts',
    'acc.bulk.selected': '{n} accounts selected',
    'acc.bulk.edit': 'Bulk edit',
    'acc.bulk.title': 'Bulk edit accounts',
    'acc.bulk.hint': 'Change fields below for {n} selected accounts. “Keep” leaves a field unchanged.',
    'acc.bulk.keep': '— Keep —',
    'acc.bulk.keepNote': 'Only the fields you pick will change. Account numbers & names are not edited here.',
    'acc.bulk.apply': 'Apply changes',
    'acc.snack.required': 'Account number and name are required',
    'acc.snack.saved': 'Account updated',
    'acc.snack.added': 'Account added',
    'acc.snack.saveFail': 'Failed to save account',
    'acc.snack.activated': 'Account activated',
    'acc.snack.deactivated': 'Account deactivated',
    'acc.snack.multiEmpty': 'Fill at least 1 row (number + name)',
    'acc.snack.multiOk': '{n} accounts added',
    'acc.snack.multiPartial': '{ok} saved, {err} failed',
    'acc.snack.bulkEmpty': 'Pick at least 1 field to change',
    'acc.snack.bulkOk': '{n} accounts updated',
    'acc.dup.eyebrow': 'Fix required',
    'acc.dup.title': '{n} duplicate / PT-conflicted account numbers',
    'acc.dup.lead':
      'The same account number or name is used across more than one company. This must be cleaned up so journals and reports stay accurate.',
    'acc.dup.admin':
      'Contact admin to merge into one shared number (company is chosen on the journal, not on the chart of accounts). Click a row for quick edit.',
    'acc.dup.shared': 'Shared',
    'acc.dup.itemCode': 'No. {code} — used {n}×',
    'acc.dup.itemCodeDetail': 'Co.: {pts} · Names: {names}',
    'acc.dup.itemName': '“{name}” — {n} rows (different PT/code)',
    'acc.dup.itemNameDetail': 'Codes: {codes} · Co.: {pts}',
    'acc.dup.expand': 'Expand',
    'acc.dup.collapse': 'Collapse',
    'acc.dup.dismiss': 'Dismiss for now',
    'acc.dup.purgeHint':
      '{n} issue(s) come from junk/test accounts (e.g. “zzz”). Auto-delete them to clear the alert — any journal lines are remapped to the canonical account.',
    'acc.dup.purgeBtn': 'Delete junk accounts',
    'acc.dup.purgeOk': '{n} junk accounts deleted · {remapped} journal lines remapped',
    'acc.dup.purgeEmpty': 'No junk accounts left',
    'acc.vizReady': 'COA health',
    'acc.vizReadySub': 'ready',
    'acc.readyHint': '{active}/{total} active accounts',
    'acc.vizTypes': 'Type mix',
    'acc.vizBands': 'Range capacity',
    'acc.healthTitle': 'Account lanes',
    'acc.healthSub': 'Click to quickly filter status, duplicates, and anomalies.',
    'acc.lane.all': 'All',
    'acc.lane.active': 'Active',
    'acc.lane.inactive': 'Inactive',
    'acc.lane.dups': 'Duplicates',
    'acc.lane.mismatch': 'Wrong normal',
    'acc.lane.class': 'Wrong class',
    'acc.lane.overflow': 'Overflow',
    'acc.lane.asset': 'Asset',
    'acc.lane.expense': 'Expense',
    'acc.tipsTitle': 'COA checklist',
    'acc.tipEmpty': 'Add the first account to the chart of accounts',
    'acc.tipReadyOk': 'COA healthy at {n}%',
    'acc.tipReadyFix': 'COA health {n}% — check duplicates & types',
    'acc.tipDups': '{n} duplicate code/name issues',
    'acc.tipDupsOk': 'No duplicate codes/names',
    'acc.tipMismatch': '{n} accounts with normal balance mismatch',
    'acc.tipMismatchOk': 'Normal balances match types',
    'acc.tipClass': '{n} accounts sitting in the wrong class band (name ≠ code class)',
    'acc.tipClassOk': 'Account numbers match name class',
    'acc.tipMissingTypes': '{n} types missing: {list}',
    'acc.tipInactive': '{n} inactive accounts',
    'acc.focusBanner': 'Focus: {focus}',
    'acc.clearFocus': 'Clear focus',
    'acc.emptyFiltered': 'No accounts in this filter',
    'acc.emptyFilteredSub': 'Change type/status/focus or reset filters.',
    'acc.resetFilters': 'Reset filters',

    'cb.title': 'Cash & Bank Position',
    'cb.sub': 'Cash/bank balances by company — account number, book balance, and last e-statement status',
    'cb.totalLabel': 'Total cash & bank · {date}',
    'cb.colCode': 'Code',
    'cb.colName': 'Account name',
    'cb.colBalance': 'Balance',
    'cb.colAccountNo': 'Account No.',
    'cb.colBook': 'Book balance',
    'cb.colStmtBal': 'Statement balance',
    'cb.colStmtDate': 'Statement date',
    'cb.colStmtStatus': 'Update status',
    'cb.ledger': 'General ledger',
    'cb.updateStmt': 'E-Statement',
    'cb.editMap': 'Update accounts',
    'cb.manageAccounts': 'Update accounts',
    'cb.accountNoEmpty': 'Add account number',
    'cb.emptyNoAlert': '{n} accounts missing numbers',
    'cb.emptyNoHint': 'Fill account numbers so smart import & balance updates stay accurate.',
    'cb.emptyNoStat': 'No account no.',
    'cb.emptyNoStatSub': 'Needs master update',
    'cb.sort': 'Sort',
    'cb.sortName': 'Name A → Z',
    'cb.sortBalDesc': 'Balance high → low',
    'cb.sortBalAsc': 'Balance low → high',
    'cb.sortStatus': 'Update status',
    'cb.sortStmtDate': 'Latest statement date',
    'cb.filterAll': 'All',
    'cb.filterEmptyNo': 'Missing account no.',
    'cb.showing': '{n} rows',
    'cb.tableKicker': 'Accounts',
    'cb.tableTitle': 'Cash & bank detail',
    'cb.colDiff': 'Diff',
    'cb.colActions': 'Actions',
    'cb.continueFrom': 'Continue {date}',
    'cb.perPage': 'Per page',
    'cb.pageAll': 'All',
    'cb.pageMeta': 'Page {page} / {pages} · {total} accounts',
    'cb.mapKicker': 'Account master',
    'cb.mapTitle': 'Bank account number mapping',
    'cb.mapSub':
      'One bank can have 2 account numbers per company (e.g. BCA JGI #1 & #2). Used by e-statement, Excel, and quick debit/credit.',
    'cb.mapAdd': 'Add row',
    'cb.mapAddSecond': 'Add slot #2 for this bank',
    'cb.mapSave': 'Save mapping',
    'cb.mapSaved': 'Account mapping saved',
    'cb.colBank': 'Bank (COA)',
    'cb.colAlias': 'Alias / sheet',
    'cb.aliasPh': 'BCA 1 / BCA JGI #2',
    'cb.accountNoPh': 'Account number',
    'cb.shared': 'Shared',
    'cb.asOf': 'As of',
    'cb.searchPh': 'Search bank, code, account no., alias, status…',
    'cb.filterHint': 'Active filter: {pt} · as of {date}',
    'cb.ptAll': 'All companies (group)',
    'cb.ptAllShort': 'Combined',
    'cb.accountCount': '{n} accounts',
    'cb.ptMini': '{n} accounts · {stale} need update',
    'cb.stmtAttention': 'Needs attention',
    'cb.stmtAttentionSub': '{stale} stale · {miss} missing',
    'cb.statusCurrent': 'Current',
    'cb.statusStale': 'Stale',
    'cb.statusMissing': 'Missing',
    'cb.emptyTitle': 'No cash/bank position yet',
    'cb.emptySub': 'Try another company filter or post journals to cash/bank accounts.',
    'cb.uploadStmt': 'E-Statement',
    'cb.quickImport': 'Excel import',
    'cb.quickJournal': 'Quick debit/credit',
    'cb.footnote':
      'Book balance comes from cleared/released journals. Statement balance fills after e-statements are uploaded and saved. Select ALL / JGI / JGT before uploading in related menus.',
    'cb.loading': 'Loading',
    'cb.searchFull': 'Fullscreen search',
    'cb.searchHint': '{n} matching accounts · Enter to close ·',
    'cb.today': 'Today',
    'cb.thisMonth': 'Month end',
    'cb.coverage': '{pct}% current',
    'cb.coverageHint': '{pct}% of accounts have a current e-statement (≤35 days)',
    'cb.filterBar': 'Cash & bank filters',
    'cb.syncedDash': 'Synced from Work Context (company + period + dates)',
    'cb.asOfShort': 'Position as of {date}',
    'cb.readyScore': 'Treasury ready',
    'cb.readyHint': '{ok} complete · {need} need attention',
    'cb.healthTitle': 'Quick treasury lanes',
    'cb.healthSub': 'Click a chip to filter accounts — stays in sync with the table below.',
    'cb.clearLane': 'Clear filter',
    'cb.openRecon': 'Open Reconciliation',
    'cb.filterDateOnly': 'Date only, no balance',
    'cb.dateOnlyBal': 'Date only',
    'cb.dateOnlyHint': 'Import date exists but statement balance is missing — upload e-statement',
    'cb.openMaster': 'Open account master',
    'cb.masterShort': 'Master',
    'cb.lane.all': 'All',
    'cb.lane.stale': 'Stale',
    'cb.lane.missing': 'Missing',
    'cb.lane.current': 'Current',
    'cb.lane.empty_no': 'No account no.',
    'cb.lane.date_only': 'Date only',
    'cb.lane.neg': 'Negative',
    'cb.lane.diff': 'Has difference',
    'cb.tipActEmptyNo': 'Fill {n} account nos',
    'cb.tipActDiff': 'Check {n} diffs',
    'cb.tipActStale': 'Update {n} stale',
    'cb.tipActDateOnly': 'Complete {n} stmt bals',
    'cb.tipActImport': 'Import Excel',
    'cb.tipActStmt': 'E-Statement',
    'cb.daysAgo': '{n} days ago',
    'cb.sortDiff': 'Difference high → low',
    'cb.bankAll': 'All banks / COA',
    'cb.filterBank': 'Bank / COA',
    'cb.filterBalSign': 'Balance sign',
    'cb.balAll': 'All balances',
    'cb.balPos': 'Positive balance',
    'cb.balNeg': 'Negative balance',
    'cb.balZero': 'Zero balance',
    'cb.balMin': 'Min balance',
    'cb.balMax': 'Max balance',
    'cb.balMinPh': 'e.g. 0',
    'cb.balMaxPh': 'e.g. 10000000',
    'cb.onlyDiff': 'Only book↔statement differences',
    'cb.onlyDiffShort': 'Has difference',
    'cb.hideZero': 'Hide zero balances',
    'cb.advFilters': 'Advanced filters',
    'cb.resetFilters': 'Reset filters',
    'cb.activeFilters': '{n} active filters',
    'cb.filteredTotal': 'Filtered · {amt}',
    'cb.filteredDiff': 'Σ diff {amt}',
    'cb.full': 'Maximize (fullscreen)',
    'cb.exitFull': 'Restore',
    'cb.minimize': 'Minimize',
    'cb.windowControls': 'Window controls',
    'cb.tipsTitle': 'Quick tips · keep treasury tidy',
    'cb.tipsShow': 'Show',
    'cb.tipsHide': 'Hide',
    'cb.tip1': 'Fill account numbers first (“No account no.” chip) so PDF/Excel imports stay accurate.',
    'cb.tip2': 'Use “Has difference” to check book vs statement before closing.',
    'cb.tip3': 'Combine bank + balance range to focus problem accounts (negative / extreme).',
    'cb.tip4': 'Fullscreen (top-right) helps review long lists; minimize/close to exit.',
    'cb.editMapShort': 'Account',
    'cb.updateStmtShort': 'E-Stmt',
    'cb.ledgerShort': 'GL',
    'cb.copyNo': 'Copy account number',
    'cb.copiedNo': 'Copied {n}',
    'cb.noStmtYet': 'No e-statement yet',
    'cb.pageRange': 'Rows {from}–{to} of {total}',
    'cb.firstPage': 'First page',
    'cb.lastPage': 'Last page',
    'cb.statClickPt': 'Filter entity {pt}',
    'cb.statClickAttention': 'Filter accounts needing attention',
    'cb.statClickEmptyNo': 'Filter missing account numbers',
    'aud.title': 'Audit Trail',
    'aud.sub': 'Trail of all journal postings — source, time & amount',
    'aud.kicker': 'Control · Posting trail',
    'aud.searchPh': 'Search ref/memo',
    'aud.colTime': 'Time',
    'aud.colRef': 'Ref',
    'aud.colDesc': 'Description',
    'aud.colAmount': 'Amount',
    'aud.allCompanies': 'ALL',
    'aud.ptAll': 'All companies',
    'aud.ptAllShort': 'All',
    'aud.followCtx': 'Follow work context',
    'aud.countLoaded': '{n} loaded',
    'aud.countShown': '{n} shown',
    'aud.statTotal': 'Total trail',
    'aud.statShare': '{n}% of period',
    'aud.vizMix': 'Source mix',
    'aud.vizDays': 'Daily activity',
    'aud.vizDaysHint': 'Last 14 days in filter',
    'aud.vizSnapshot': 'Period snapshot',
    'aud.vizEmpty': 'No data for this filter yet',
    'aud.snapImport': 'Import share',
    'aud.snapFiltered': 'Filtered amount',
    'aud.snapVoid': 'Void journals',
    'aud.openQuality': 'Data completeness',
    'aud.openJournals': 'Open journals',
    'aud.healthTitle': 'Quick source filters',
    'aud.healthSub': 'Click a chip to filter the table',
    'aud.laneAll': 'All',
    'aud.tipsTitle': 'Audit tips',
    'aud.tipEmpty': 'No trail yet — adjust period or follow work context',
    'aud.tipImportHeavy': 'Imports dominate ({n}%) — expected after workbook migration',
    'aud.tipVoid': '{n} voided journals — review before close',
    'aud.tipSystem': '{n} system postings (payroll/advance/etc.)',
    'aud.tipFollow': 'Work Context differs from audit filters — click to sync',
    'aud.tipQuality': 'Check Data Completeness for critical findings',
    'aud.tipJournals': 'Open Journals to edit / inspect ID Ref',
    'aud.tipOk': 'Audit trail looks normal for this filter',
    'aud.focusSource': 'Source: {source} · {n} rows',
    'aud.focusSearch': 'Search “{q}” · {n} hits',
    'aud.clearFocus': 'Clear filters',
    'aud.empty': 'No posting trail yet',
    'aud.emptyFilter': 'No results for this filter',
    'aud.emptyHint': 'Change company/period/source, or follow Work Context.',
    'aud.sourceSystem': 'System',
    'aud.refreshShort': 'Reload',
    'aud.openQualityShort': 'Completeness',
    'aud.openJournalsShort': 'Journals',
    'aud.followCtxShort': 'Follow context',
    'aud.searchLabel': 'Search',
    'aud.fromLabel': 'From',
    'aud.toLabel': 'To',
    'aud.sourceLabel': 'Source',

    'ql.title': 'Data Completeness',
    'ql.kicker': 'Control · Workbook audit',
    'ql.sub':
      'Check data readiness before tax consultant review / Accurate-style close. Statement gaps come from GL coverage Jan–Jul.',
    'ql.refreshShort': 'Reload',
    'ql.previewVoid2025': 'Preview void 2025',
    'ql.previewVoidShort': 'Preview void',
    'ql.void2025': 'Void 2025 data',
    'ql.voidShort': 'Void 2025',
    'ql.exportPack': 'Export consultant pack',
    'ql.exportPackShort': 'Export',
    'ql.searchLabel': 'Search',
    'ql.selectAllShort': 'All',
    'ql.unselectShort': 'Clear',
    'ql.selectOpenShort': 'Unchecked',
    'ql.removeSelectedShort': 'Hide ({n})',
    'ql.cleanPreviewTitle': 'Preview void 2025',
    'ql.cleanPreview': 'Preview clean 2025: {n} journals. Sample IDs: {ids}',
    'ql.scoreCaption': 'Completeness score {year}',
    'ql.statJournals': 'Journals',
    'ql.statNoPt': 'No company',
    'ql.statRefMismatch': 'Ref mismatch',
    'ql.statCoa': 'COA accounts',
    'ql.findingsTitle': 'Audit findings',
    'ql.gapTitle': 'Action checklist (workbook)',
    'ql.gapKicker': 'Checklist',
    'ql.gapSub':
      'Mark reviewed / misclassified. Each bank shows account code, account number, month grid, and short steps.',
    'ql.gapEmpty': 'All gaps are hidden or none available.',
    'ql.gapSumMissing': 'Missing months',
    'ql.gapSumOpen': 'Unchecked',
    'ql.gapSumComplete': 'Complete',
    'ql.gapSumP1': 'P1 priority',
    'ql.gapMissingCount': '{n} months missing',
    'ql.gapMonthGrid': 'Month coverage (journal count)',
    'ql.gapFocusMiss': 'Jan–Jul missing {n}',
    'ql.gapActionLabel': 'Action',
    'ql.gapAccountInfo': 'Account & numbers',
    'ql.glKicker': 'P1 priority',
    'ql.glTitle': 'Books (GL) coverage Jan–Jul',
    'ql.glSub':
      'Per-bank report: COA account code, account number, company, and journal count by month. Focus Jan–Jul; Aug–Dec + CC Akin still shown.',
    'ql.glEmpty': 'No coverage data yet.',
    'ql.glMissingBadge': '{n} sources still incomplete',
    'ql.glGoImport': 'Import Excel',
    'ql.glGoStmt': 'E-Statement',
    'ql.glColSource': 'Source',
    'ql.glColPresent': 'In GL',
    'ql.glColMissing': 'Missing in GL',
    'ql.glColAccountCode': 'Account code',
    'ql.glColAccountNo': 'Account no.',
    'ql.glColPt': 'Company',
    'ql.glColTag': 'Memo tag',
    'ql.glPtShared': 'Shared',
    'ql.glStatBanks': 'Bank sources',
    'ql.glStatFocusOk': 'Complete Jan–Jul',
    'ql.glStatFocusMiss': 'Empty month slots',
    'ql.glStatJournals': 'Journals found',
    'ql.glBankAccounts': '{n} accounts',
    'ql.glBankFocusMiss': '{n} Jan–Jul slots empty',
    'ql.glBankFocusOk': '{n} focus-complete',
    'ql.glStatusGap': 'Needs import',
    'ql.glStatusOk': 'Complete',
    'ql.glStatusFocusOk': 'Jan–Jul OK',
    'ql.glStatusFocusGap': 'Missing {n} mo',
    'ql.glFocusProgress': 'Jan–Jul progress',
    'ql.glFocusMonths': 'Focus Jan–Jul (journal count)',
    'ql.glRestMonths': 'Aug–Dec + CC Akin',
    'ql.glAkinShort': 'Akin',
    'ql.glFocusMissingList': 'Jan–Jul missing: {list}',
    'ql.glDoubleList': 'Suspect double: {list}',
    'ql.glActImport': 'Import',
    'ql.glActStmt': 'Statement',
    'ql.glHint':
      'Coverage Jan–Dec plus Akin Dec (prior year) for credit cards. Enable “Post to reports” on import. [FP] fingerprints prevent duplicates. Shared DBS is split 50/50 on JGI/JGT balance sheets. Account codes: 1001 BCA · 1002 BNI · 1003 Mandiri · 1004 DBS · 2700 CC payable.',
    'ql.colPrio': 'Prio',
    'ql.colBank': 'Bank / source',
    'ql.colMissingMonths': 'Missing months',
    'ql.colNote': 'Note',
    'ql.colStatus': 'Status',
    'ql.complete': 'Complete',
    'ql.fixBtn': 'Fix',
    'ql.fixKicker': 'Fix panel',
    'ql.originalNote': 'Original note',
    'ql.verdict': 'Verdict',
    'ql.statusOk': 'Correct',
    'ql.statusWrong': 'Wrong',
    'ql.statusOpen': 'Unchecked',
    'ql.correctionLabel': 'Correction note',
    'ql.correctionPh': 'Write what was / will be fixed…',
    'ql.saveFix': 'Save fix',
    'ql.resetFix': 'Reset this row fix',
    'ql.openStatements': 'Open E-Statement',
    'ql.openImport': 'Open Import Workbook',
    'ql.resetAllGaps': 'Show all gaps again',
    'ql.selectOpen': 'Select unchecked',
    'ql.removeSelected': 'Hide selected ({n})',
    'ql.removeGap': 'Hide row',
    'ql.snack.fixSaved': 'Fix saved',
    'ql.snack.fixReset': 'Row fix reset',
    'ql.snack.gapHidden': 'Row hidden',
    'ql.snack.gapsHidden': '{n} rows hidden',
    'ql.snack.gapsReset': 'All gaps shown again',
    'ql.snack.needSelected': 'Check rows first',
    'ql.companiesTitle': 'Companies',
    'ql.npwpMissing': 'NOT FILLED',
    'ql.pphFinal': 'Final tax {rate}%',
    'ql.editCompanies': 'Edit companies',
    'ql.omsetTitle': 'Revenue {year}',
    'ql.recommendationsTitle': 'Recommendations',
    'ql.journalsByMonth': 'Journals by month ({year})',
    'ql.colMonth': 'Month',
    'ql.colJournalCount': 'Journal count',
    'ql.colTotalDebit': 'Total debit',
    'ql.priorYearAlert':
      'Prior-year months (other than December CC akin) remain in the books — review whether they need a year-close split.',
    'ql.snack.loadFail': 'Failed to load',
    'ql.autoSnack': 'AI posted {n} bell note(s) — please cross-check.',
    'ql.snack.packOk': 'Consultant pack downloaded',
    'ql.snack.exportFail': 'Export failed (check company tax IDs)',
    'ql.snack.previewVoid': 'Preview: {n} year-2025 journals ready to void',
    'ql.snack.previewFail': 'Preview failed',
    'ql.confirmVoid2025':
      'Void ALL year-2025 journals? This separates 2025 data from 2026 revenue. Not easily undone.',
    'ql.snack.voided': '{n} year-2025 journals voided',
    'ql.snack.cleanFail': 'Clean failed',
    'ql.rec.0':
      'Clear priority e-statement sources via Quality, then re-upload files one by one in E-Statement.',
    'ql.rec.1':
      'Ensure priority sources are filled: DBS Credit Card, DBS Account, Danamon CC, Panin CC, Mandiri, Mega CC, BCA, and BNI.',
    'ql.rec.2':
      'Tick “Post to reports” on import so credit-card payables and DBS balances hit the balance sheet (cleared).',
    'ql.rec.3':
      'Mark the Coretax checklist (VAT, Art.23, Art.21, SPT) after finishing in Coretax; optional PDFs can be archived under SSP / Tax Documents.',
    'ql.rec.4':
      'Compute Art.21 via the calculator and/or upload withholding PDFs on the Art.21 page.',
    'ql.rec.5':
      'Review GL coverage for January–December — especially the Double? column for Mandiri 1 — to avoid duplicate postings.',
    'ql.rec.6':
      'Reconcile bank versus books every month until statement aging reaches zero.',
    'ql.rec.7':
      'Treat prior-year December credit-card bills as cycle akin for the review year; keep them in the review instead of voiding for date alone.',
    'ql.statJournalsMeta': 'Click → monthly trend',
    'ql.statNoPtMeta': 'Click → warning findings',
    'ql.statRefMeta': 'Click → filter findings',
    'ql.statCoaMeta': 'Click → chart of accounts',
    'ql.vizFindings': 'Findings by level',
    'ql.vizGaps': 'Statement gaps',
    'ql.vizMonths': 'Journals by month',
    'ql.vizMonthsHint': 'Thin/orange bars = low volume',
    'ql.healthTitle': 'Data health navigation',
    'ql.healthSub': 'Filter findings or gaps in one click',
    'ql.tipsTitle': 'Action tips',
    'ql.tipScoreLow': 'Completeness score {n} — prioritize critical findings',
    'ql.tipScoreOk': 'Score {n} is strong enough for consultant review',
    'ql.tipCritical': '{n} critical findings still need closure',
    'ql.tipP1': '{n} priority-1 statement sources still incomplete',
    'ql.tipNoPt': '{n} journals without company — remap bank → company',
    'ql.actVoidPreview': 'Preview void',
    'ql.actVoidCcDec': 'Preview void Dec CC',
    'ql.actOpenCcJournals': 'Open CC journals',
    'ql.actViewAkin': 'View CC akin',
    'ql.findingItemsTitle': '{n} related journals',
    'ql.findingColDate': 'Date',
    'ql.findingColRef': 'Ref',
    'ql.findingColMemo': 'Memo',
    'ql.findingColAmount': 'Amount',
    'ql.snack.previewVoidCc': 'Preview: {n} December {year} CC journals ready to void',
    'ql.confirmVoidCcDec':
      'Void {n} December {year} credit-card journals? This is CC-December only, not the whole year. Hard to undo.',
    'ql.snack.voidedCc': '{n} December CC journals voided',
    'ql.ccDecBanner':
      '{n} December {prior} CC bills count as cycle akin for {year}. Keep them in the {year} review — do not void only because the date is still {prior}.',
    'ql.ccDecBannerTitle': 'CC December {prior} akin',
    'ql.tipPriorYear':
      '{n} prior-year December CC bills are cycle akin — review in findings (not a void error).',
    'ql.coretaxTitle': 'Coretax checklist',
    'ql.coretaxSub': 'Tick after finishing in Coretax. Detail figures stay in Coretax.',
    'ql.coretax.ppn': 'VAT period',
    'ql.coretax.pph23': 'Art. 23',
    'ql.coretax.pph21': 'Art. 21',
    'ql.coretax.spt': 'SPT / e-bupot',
    'ql.coretax.done': 'Done in Coretax',
    'ql.coretax.pending': 'Pending',
    'ql.tipPack': 'Export the consultant pack after P1 gaps are closed',
    'ql.levelCritical': 'Critical',
    'ql.levelWarning': 'Warning',
    'ql.levelInfo': 'Info',
    'ql.levelOk': 'OK',
    'ql.filterAll': 'All',
    'ql.focusP1': 'P1',
    'ql.focusMissing': 'Missing months',
    'ql.focusOpen': 'Unchecked',
    'ql.focusComplete': 'Complete',
    'ql.focusFindingBanner': 'Findings: {level} · {n} items',
    'ql.focusGapBanner': 'Gap filter · {n} rows',
    'ql.clearFocus': 'Clear filters',
    'ql.findingsSub': 'Summary + gap detail, metrics, and fix steps — click the title to expand/collapse',
    'ql.findingsEmpty': 'No findings for this filter',
    'ql.findingExpandAll': 'Expand all',
    'ql.findingCollapseAll': 'Collapse all',
    'ql.findingImpact': 'Impact',
    'ql.findingStepsTitle': 'Fix steps',
    'ql.findingGapsTitle': 'Detail for {n} sources / periods',
    'ql.findingGapMissing': '{n} months missing',
    'ql.findingGapOk': 'Complete',
    'ql.findingGapSuspect': '{n} suspect months',
    'ql.findingGapAkin': 'Akin Dec: {n}',
    'ql.findingLegendOk': 'Present',
    'ql.findingLegendMiss': 'Missing',
    'ql.findingLegendSuspect': 'Suspect double',
    'ql.gapSearch': 'Search bank / account code / number / notes…',
    'ql.gapFilterEmpty': 'No gaps match this filter',
    'ql.actCompanies': 'Companies',
    'ql.actJournals': 'Journals',
    'ql.actGaps': 'View gaps',
    'ql.actHr': 'HR',
    'ql.actOpen': 'Open',
    'ql.npwpMissingShort': 'NPWP?',
    'ql.npwpOk': 'OK',
    'ql.journalsByMonthSub': 'Posting volume by month — watch sudden spikes/drops',

    'cl.title': 'Monthly Close Checklist',
    'cl.kicker': 'Month-end · Quality control',
    'cl.sub': 'Month-end checklist before consultant review / periodic SPT',
    'cl.companyOptional': 'Company (optional)',
    'cl.allCompanies': 'All companies / consolidated',
    'cl.monthLabel': 'Month',
    'cl.yearLabel': 'Year',
    'cl.prevMonth': 'Previous month',
    'cl.cancel': 'Cancel',
    'cl.save': 'Save',
    'cl.failed': 'Failed to load / save',
    'cl.nextMonth': 'Next month',
    'cl.thisMonth': 'This month',
    'cl.thisMonthShort': 'This month',
    'cl.jumpOpen': 'Jump to {n} open',
    'cl.jumpOpenShort': '{n} open',
    'cl.search': 'Search checklist items…',
    'cl.markDone': 'Done',
    'cl.markDoneShort': 'OK',
    'cl.markUndone': 'Undo',
    'cl.markUndoneShort': 'Undo',
    'cl.openRelated': 'Open related page',
    'cl.progress': 'Progress {done}/{total}',
    'cl.progressHint': 'Required items must be done before the period is ready to close.',
    'cl.statDone': 'Done',
    'cl.statOpen': 'Open',
    'cl.statRequired': 'Required done',
    'cl.statPct': 'Progress',
    'cl.readyYes': 'Ready to close',
    'cl.readyNo': 'Not ready',
    'cl.copy': 'Copy summary',
    'cl.copyShort': 'Copy',
    'cl.copied': 'Summary copied',
    'cl.markRequired': 'Mark required',
    'cl.markRequiredShort': 'Required',
    'cl.reset': 'Reset',
    'cl.confirmMarkAll': 'Mark all required items done for this period?',
    'cl.confirmReset': 'Reset all checklist items for this period?',
    'cl.markedAll': 'Required items marked done',
    'cl.resetDone': 'Checklist reset',
    'cl.openWizard': 'Close Wizard',
    'cl.openWizardShort': 'Wizard',
    'cl.filterAll': 'All',
    'cl.filterOpen': 'Open',
    'cl.filterDone': 'Done',
    'cl.role.all': 'All roles',
    'cl.role.allShort': 'All',
    'cl.role.akuntan': 'Accountant',
    'cl.role.konsultan': 'Consultant',
    'cl.role.konsultanShort': 'Consultant',
    'cl.role.partner': 'Partner',
    'cl.optional': 'Optional',
    'cl.hasNote': 'Has note',
    'cl.addNote': 'Notes',
    'cl.noteTitle': 'Item notes',
    'cl.noteLabel': 'Internal note',
    'cl.noteHint': 'Findings, blockers, or follow-ups for this item',
    'cl.noteSaved': 'Note saved',
    'cl.emptyFilter': 'No items for this filter.',
    'cl.item.stmt_import': 'All bank/card statements for this month imported',
    'cl.item.recon_done': 'Book ↔ statement reconciliation done / aging reviewed',
    'cl.item.unearned_review': 'Customer unearned (DP) reviewed — recognize / defer per performance',
    'cl.item.journals_ok': 'Anomaly / no-company journals fixed',
    'cl.item.pph_final': 'Final MSME tax calculated & posted (if revenue exists)',
    'cl.item.payroll': 'Payroll & Art. 21 posted (if employees exist)',
    'cl.item.pph23': 'Art. 23 certificates / SSP recorded',
    'cl.item.lk_review': 'FS (balance sheet / P&L) reviewed for current month',
    'cl.item.quality': 'Data completeness score checked in Control',
    'cl.item.backup': 'DB backup / consultant pack export (optional)',

    'account.title': 'My Account',
    'account.kicker': 'Employee profile & pay',
    'account.unlinked':
      'This login is not linked to an employee. Showing sample data — ask HR admin to link your user.',
    'account.demoBadge': 'Sample data',
    'account.position': 'Position',
    'account.positionDemo': 'Staff (sample)',
    'account.joinedAt': 'Joined',
    'account.leftAt': 'Left',
    'account.lastAttendance': 'Last attendance',
    'account.salary': 'Salary',
    'account.allowance': 'Allowance',
    'account.commission': 'Commission',
    'account.bonus': 'Bonus',
    'account.gross': 'Gross',
    'account.period': 'Period',
    'account.takeHome': 'Take-home',
    'account.pph21': 'Income tax',
    'account.kasbonCut': 'Advance deduction',
    'account.deductionsTotal': 'Total deductions',
    'account.kpiGrossHint': 'Salary + commission',
    'account.kpiGrossHintFull': 'Salary + allowance + commission + bonus',
    'account.kpiDeductHint': 'Tax + BPJS + advance',
    'account.tenure': 'Tenure',
    'account.payday': 'Est. payday',
    'account.earningsTitle': 'Earnings breakdown',
    'account.earningsTotal': 'Gross total',
    'account.bonusYtd': 'Bonus YTD',
    'account.allowanceYtd': 'Allowance YTD (est.)',
    'account.earningsHint':
      'Salary & allowance come from the employee master. Bonus is from this month’s transactions. Commission appears when a separate data source exists.',
    'account.compTitle': 'Compensation',
    'account.slipTitle': 'Estimated payslip',
    'account.compositionTitle': 'Pay composition',
    'account.takeHomeShare': '{pct}% of gross becomes take-home',
    'account.trendTitle': 'Pay trend',
    'account.trendTitleN': 'Pay trend ({n} months)',
    'account.trendRange': 'Range',
    'account.trendMonthShort': ' mo',
    'account.trendAnchor': 'End point',
    'account.trendAnchorLast': 'Last month',
    'account.trendAnchorThis': 'This month',
    'account.salaryDetail': 'Salary, deductions & take-home',
    'account.kasbonTitle': 'My cash advance',
    'account.kasbonOpen': 'Open balance',
    'account.kasbonMax': 'Limit',
    'account.kasbonPending': 'Pending',
    'account.kasbonLimit': '{pct}% of gross limit',
    'account.kasbonRoom': 'Remaining limit {room}',
    'account.kasbonHistory': 'History / requests',
    'account.kasbonEmpty': 'No cash-advance history yet',
    'account.askKasbon': 'Request cash advance',
    'account.attTitle': 'Attendance this month',
    'account.attPresent': 'Present',
    'account.attLate': 'Late',
    'account.attAbsent': 'Absent',
    'account.attHadir': 'Present',
    'account.attBolos': 'No-show',
    'account.attLeave': 'Leave',
    'account.attSick': 'Sick',
    'account.attPermit': 'Permit',
    'account.attHoliday': 'Holiday',
    'account.attHalfday': 'Half day',
    'account.attRate': 'Attendance rate',
    'account.attOfWorkdays': 'of {n} workdays',
    'account.attHadirHint': 'Includes present & late',
    'account.attDailyRate': 'Daily rate',
    'account.attDailyRateHint': 'Gross ÷ workdays',
    'account.attAbsentCut': 'Deduction ≈ {amount}',
    'account.attLateCut': 'Late cut ≈ {amount}',
    'account.attAbsentCutLabel': 'Absence deduction',
    'account.attLateCutLabel': 'Late deduction',
    'account.attCutsTitle': 'Attendance-related cuts',
    'account.attCutsHint':
      'Estimated absence/late cuts for overview. Official payslip follows HR policy.',
    'account.attBreakdown': 'Status breakdown',
    'account.attRecent': 'Recent attendance',
    'account.attRecentEmpty': 'No attendance records this month yet',
    'account.attCheckIn': 'Check in',
    'account.attCheckOut': 'Check out',
    'account.attCheckInOk': 'Checked in',
    'account.attCheckOutOk': 'Checked out',
    'account.attNeedLink': 'Link your user to an employee first for self check-in',
    'account.attDetail': 'Details',
    'account.holTitle': 'Holiday schedule',
    'account.holThisMonth': 'This month',
    'account.holThisMonthEmpty': 'No national holidays this month',
    'account.holUpcoming': 'Upcoming holidays',
    'account.holUpcomingEmpty': 'No upcoming holidays this year',
    'account.holLibur': 'Holiday',
    'account.holCuti': 'Joint leave',
    'account.holYearSummary': '{year}: {libur} holidays · {cuti} joint leave',
    'account.holOpenCalendar': 'Open calendar',
    'account.bpjsTitle': 'BPJS (employee estimate)',
    'account.bpjsNote':
      'Estimated employee contributions from gross: health 1%, JHT 2%, JP 1%. Not official BPJS figures.',
    'account.bpjsHealth': 'Health',
    'account.bpjsJht': 'JHT',
    'account.bpjsJp': 'JP',
    'account.bpjsTotal': 'Total contribution',
    'account.bpjsCutHint': 'Deducted on this month’s slip: {amount}',
    'account.tabOverview': 'Overview',
    'account.tabSalary': 'Salary',
    'account.tabKasbon': 'Advance',
    'account.tabInvoice': 'Invoice',
    'account.tabAttendance': 'Attendance',
    'account.tabBpjs': 'BPJS',
    'account.tabPassword': 'Password',
    'account.invTitle': 'My invoices',
    'account.invPaidCair': 'Paid & disbursed',
    'account.invPaidCairShort': 'Paid',
    'account.invPending': 'Pending',
    'account.invPartialPaid': 'Partially received',
    'account.invPipeline': 'Total pipeline',
    'account.invRecent': 'Recent invoices',
    'account.invEmpty': 'No related invoices yet',
    'account.invYear': 'Year {year}',
    'account.invPaidCount': '{n} paid docs',
    'account.invPendingCount': '{n} awaiting payment',
    'account.invCairShare': '{pct}% disbursed',
    'account.invHint':
      'Paid & disbursed = fully paid invoices. Pending = remaining unpaid balance.',
    'account.invStatusPaid': 'Paid',
    'account.invStatusPartial': 'Partial',
    'account.invStatusSent': 'Sent',
    'account.openInvoices': 'Open invoice list',
    'account.openPortal': 'Open employee portal',
    'account.openAttendance': 'Open attendance',
    'account.pwdTitle': 'Change password',
    'account.pwdSub': 'Enter your current password, then a new one (min. 6 characters).',
    'account.pwdOld': 'Current password',
    'account.pwdNew': 'New password',
    'account.pwdConfirm': 'Confirm new password',
    'account.pwdSave': 'Save password',
    'account.pwdMin': 'New password must be at least 6 characters',
    'account.pwdMismatch': 'Password confirmation does not match',
    'account.pwdOk': 'Password updated',

    'portal.title': 'Employee Portal',
    'portal.kicker': 'Self-service',
    'portal.refresh': 'Refresh',
    'portal.refreshShort': 'Reload',
    'portal.unlinked':
      'Your account is not linked to an employee record. Ask an admin to link you under Users & Access.',
    'portal.askKasbon': 'Request advance',
    'portal.askKasbonShort': 'Request',
    'portal.resignBanner': 'Employment status: Resigned. New cash advances are closed.',
    'portal.noKasbonResign': 'This account is resigned — advance requests are closed.',
    'portal.statGross': 'Gross pay',
    'portal.statGrossHint': 'This month',
    'portal.statKasbon': 'Open advance',
    'portal.statKasbonHint': 'Outstanding receivable',
    'portal.statDeduct': 'Advance deduction',
    'portal.statDeductHint': 'Payslip estimate',
    'portal.statTakeHome': 'Take-home',
    'portal.statTakeHomeHint': 'Estimate {period}',
    'portal.tabOverview': 'Overview',
    'portal.tabSlip': 'Payslip',
    'portal.tabKasbon': 'Advances',
    'portal.tabRequest': 'Request',
    'portal.profileTitle': 'Pay profile',
    'portal.baseSalary': 'Base salary',
    'portal.allowance': 'Allowance',
    'portal.howItWorks': 'Advance & payroll flow',
    'portal.how1': 'Request an advance → pending.',
    'portal.how2': 'Admin approves → receivable rises + live journal.',
    'portal.how3': 'Reject → off reports; still noted on payslip.',
    'portal.how4': 'Payroll deducts advance → take-home drops; receivable clears.',
    'portal.slipTitle': 'Estimated payslip',
    'portal.afterTax': 'After Art. 21',
    'portal.openPiutang': 'Open advance balance',
    'portal.openPiutangHint': 'Approved advances only.',
    'portal.requestKicker': 'Request',
    'portal.requestTitle': 'New cash advance',
    'portal.requestSub': 'After submit, admin will Approve or Reject.',
    'portal.requestHint':
      'Pending does not reduce pay yet. Once approved, it becomes a receivable and may be deducted on the payslip.',
    'portal.submitRequest': 'Submit request',
    'portal.needAmount': 'Enter amount (> 0)',
    'portal.snackRequested': 'Request sent {no} — awaiting admin approval',
    'portal.installments': 'Installments',
    'portal.installmentsHint': 'Monthly deduction = amount ÷ installments (1–12×)',
    'portal.limitLabel': 'Advance ceiling',
    'portal.limitHint': '{pct}% of pay · room left {room}',
    'portal.downloadPdf': 'Download PDF slip',
    'portal.qrTitle': 'Approve advance via QR',
    'portal.qrKicker': 'Advance · QR',
    'portal.qrSub': 'Scan or open the link to Approve / Reject.',
    'portal.qrHint': 'Show QR to HR admin, or copy the approve link.',
    'portal.qrStaffHint': 'Waiting for admin. You do not need to tap buttons.',
    'portal.openQr': 'Open QR',
    'portal.proofUpload': 'Upload proof',
    'portal.proofView': 'View proof',
    'portal.decidedBy': 'Decided by',
    'portal.waShare': 'Share WA',
    'portal.snackPdf': 'Payslip PDF downloaded',
    'portal.snackProof': 'Transfer proof saved',
    'portal.unlinkedTitle': 'Account not linked to an employee',
    'portal.unlinkedStep1': 'Admin opens User & Access.',
    'portal.unlinkedStep2': 'Pick your user, then link it to an employee record.',
    'portal.unlinkedStep3': 'Refresh this portal — payslip & advances appear.',
    'portal.openUsers': 'Open User & Access',
    'portal.openUsersShort': 'Users & Access',
    'portal.openHr': 'Open HR master',
    'portal.openHrShort': 'HR Master',
    'portal.vizReady': 'Portal readiness',
    'portal.vizReadySub': 'ready',
    'portal.readyHint': 'Profile {name}',
    'portal.vizComp': 'Payslip mix',
    'portal.vizKasbon': 'Ceiling & advances',
    'portal.compNet': 'Take-home',
    'portal.compTax': 'Art. 21',
    'portal.compKasbon': 'Advance deduct',
    'portal.barOpen': 'Open balance',
    'portal.barRoom': 'Room left',
    'portal.barPending': 'Pending',
    'portal.barRejected': 'Rejected',
    'portal.healthTitle': 'Self-service lanes',
    'portal.healthSub': 'Click to jump to payslip, advances, or request.',
    'portal.lane.ringkas': 'Ready',
    'portal.lane.slip': 'Payslip',
    'portal.lane.kasbon': 'Advances',
    'portal.lane.pending': 'Pending',
    'portal.lane.rejected': 'Rejected',
    'portal.lane.ajukan': 'Can request',
    'portal.tipsTitle': 'Portal checklist',
    'portal.tipUnlinked': 'Link your user to an employee to show payslip',
    'portal.tipAdminLink': 'You are admin — link in User & Access',
    'portal.tipContactHr': 'Open HR master to review employee data',
    'portal.tipReadyOk': 'Portal ready at {n}%',
    'portal.tipReadyFix': 'Portal completeness {n}% — finish profile',
    'portal.tipPending': '{n} advance request(s) awaiting approval',
    'portal.tipPendingOk': 'No pending advances',
    'portal.tipNoRoom': 'Advance ceiling full — repay first',
    'portal.tipRoomOk': 'Room left {room} — ready to request',
    'portal.tipNik': 'NIK is missing on the employee master',
    'portal.tipPdf': 'Download this month’s estimated payslip PDF',

    'dash.hrCardTitle': 'My pay & advances',
    'dash.hrCardSub': 'Estimated take-home this month',
    'dash.hrPendingTitle': 'Advances pending',
    'dash.hrPendingSub': '{n} requests need Approve / Reject',
    'dash.hrOpenPortal': 'My portal',
    'dash.hrOpenEmployees': 'Open HR',
    'dash.staffKasbonKicker': 'My advances',
    'dash.staffKasbonPending': 'Pending · {n}',
    'dash.staffKasbonNone': 'No pending',
    'dash.staffKasbonLast': 'Last',
    'dash.staffKasbonLastEmpty': 'No history yet',
    'dash.staffKasbonShow': 'History',
    'dash.staffKasbonHide': 'Close',
    'dash.staffKasbonShowHint': 'Filters & pages',
    'dash.staffKasbonPerPage': 'Per page',
    'dash.staffKasbonPageAll': 'All',
    'dash.staffKasbonShowing': 'Showing {from}–{to} of {total}',
    'dash.staffKasbonFilter': 'Filter',
    'dash.staffKasbonStatus': 'Status',
    'dash.staffKasbonStatusAll': 'All statuses',
    'dash.staffKasbonStatusPending': 'Pending',
    'dash.staffKasbonStatusApproved': 'Approved',
    'dash.staffKasbonStatusRejected': 'Rejected',
    'dash.staffKasbonEmpty': 'No advances match these filters',
    'dash.staffKasbonDemoBadge': 'Sample',
    'dash.staffKasbonDemoName': 'Demo employee',
    'dash.staffKasbonApprovedBy': 'Approved by',
    'dash.staffKasbonRejectedBy': 'Rejected by',
    'dash.staffKasbonAwaiting': 'Awaiting HR approval',
    'dash.staffKasbonNoDecision': 'No decision yet',
    'dash.staffKasbonOpenShort': 'Open',
    'dash.staffKasbonExpandAria': 'Expand or collapse advance history',

    'hr.title': 'Employee Master & Art. 21 Payroll',
    'hr.kicker': 'HR & tax',
    'hr.sub': 'Calculate progressive Art. 21 (simplified) and post payroll journals',
    'hr.needPt': 'Select PT JGI or JGT before adding / editing employees.',
    'hr.needPtTitle': 'Select a company first',
    'hr.needPtBody':
      'JGI and JGT employee data are kept separate. Pick a company above so the table, payroll, and advances stay clean.',
    'hr.useContextPt': 'Use context filter ({pt})',
    'hr.contextPtHint': 'Work context is already {pt} — click above to open the list.',
    'hr.tipPickPt': 'Pick JGI or JGT to open the employee master',
    'hr.tipUseContext': 'Work context = {pt} — use that filter',
    'hr.tipReadyOk': 'Employee data {n}% complete',
    'hr.tipReadyFix': 'Active staff completeness {n}% — fill NIK/NPWP',
    'hr.tipNik': '{n} active employees missing NIK',
    'hr.tipNpwp': '{n} active employees missing NPWP',
    'hr.tipResignOk': '{n} resigned — NIK/tax ID not requested',
    'hr.tipResignOkDetail': 'Use Resign filter for history; advances & slips still available',
    'hr.tipPending': '{n} advances awaiting approval',
    'hr.tipPendingDetail': 'Approve or reject on the Advances tab',
    'hr.tipPendingOk': 'No pending advances',
    'hr.tipNoPending': 'No pending advances',
    'hr.tipKasbon': '{n} employees have open advances',
    'hr.vizReady': 'Data readiness',
    'hr.vizReadySub': 'complete',
    'hr.readyHint': '{nik} active missing NIK · {npwp} active missing NPWP',
    'hr.vizPtkp': 'PTKP mix',
    'hr.vizPtkpEmpty': 'No employees yet',
    'hr.vizGaps': 'Data gaps',
    'hr.healthTitle': 'HR lanes',
    'hr.healthSub': 'Click to quickly filter status, advances, and completeness.',
    'hr.lane.all': 'All',
    'hr.lane.active': 'Active',
    'hr.lane.resign': 'Resigned',
    'hr.lane.inactive': 'Resigned',
    'hr.lane.kasbon': 'Has advance',
    'hr.lane.pending': 'Pending',
    'hr.lane.nik': 'No NIK',
    'hr.lane.npwp': 'No NPWP',
    'hr.tipsTitle': 'HR checklist',
    'hr.focusBanner': 'Focus: {focus}',
    'hr.clearFocus': 'Clear focus',
    'hr.pickPtLabel': 'Choose company',
    'hr.searchLabel': 'Search employees',
    'hr.ptActiveHint': 'Showing {pt} only — switch the chip to change company.',
    'hr.ptPickHint': 'Select JGI or JGT before viewing the employee list.',
    'hr.filterAllStatus': 'All statuses',
    'hr.filterActive': 'Active',
    'hr.filterResign': 'Resigned',
    'hr.filterInactive': 'Resigned',
    'hr.filterAllPtkp': 'All PTKP',
    'hr.filterKasbon': 'Has advance',
    'hr.statPphEst': 'Est. Art. 21',
    'hr.statActiveMeta': '{total} total · {off} resigned',
    'hr.kasbonOpen': 'outstanding',
    'hr.kasbonCount': '{n} people',
    'hr.kasbonAging': 'Advance aging',
    'hr.kasbonAgingHint': 'Based on the oldest open advance date.',
    'hr.aging0_30': '0–30 days',
    'hr.aging31_60': '31–60 days',
    'hr.aging61_90': '61–90 days',
    'hr.aging90p': '>90 days',
    'hr.agingDays': '{n} days',
    'hr.colAging': 'Aging',
    'hr.tabKasbon': 'Advances',
    'hr.exportCsv': 'Export CSV',
    'hr.exportBtn': 'Export',
    'hr.exportTitle': 'Download HR data',
    'hr.exportFormat': 'File format',
    'hr.exportScope': 'Data set',
    'hr.exportHint': 'Pick format & content, then press Download Now. Full pack includes employees, advances, payroll, and COA.',
    'hr.downloadNow': 'Download Now',
    'hr.exportScopePack': 'Full pack (all)',
    'hr.exportScopeEmployees': 'Employee master',
    'hr.exportScopeKasbon': 'Advances & ledger',
    'hr.exportScopePayroll': 'Payroll this month',
    'hr.exportScopeCoa': 'Payroll COA accounts',
    'hr.snack.downloadReady': 'Ready: {format} · {scope}',
    'hr.active': 'Active',
    'hr.resign': 'Resigned',
    'hr.badgeGaji': 'Salary P&L',
    'hr.badgeOpex': 'Opex/office',
    'hr.badgeGajiHint': 'Counts as Salary expense (5001) on financial reports',
    'hr.badgeOpexHint': 'Not warehouse roster — posts to other opex (5004)',
    'hr.inactive': 'Resigned',
    'hr.activate': 'Reactivate',
    'hr.deactivate': 'Mark resigned',
    'hr.markResign': 'Mark resigned',
    'hr.employmentStatus': 'Employment status',
    'hr.leftAtLabel': 'Resignation date',
    'hr.workPeriod': 'Tenure',
    'hr.periodRange': '{from} → {to}',
    'hr.periodOpenEnd': 'Since {from}',
    'hr.snack.resigned': 'Employee marked as resigned',
    'hr.kasbonChannel': 'Advance source',
    'hr.kasbonChannelSystem': 'HR system (employee receivable vs cash)',
    'hr.kasbonChannelExternal': 'Separate system (kasbon payable vs cash)',
    'hr.kasbonChannelSystemHint': 'On approve: Dr Employee receivable · Cr Cash',
    'hr.kasbonChannelExternalHint': 'On approve: Dr Kasbon payable · Cr Cash — for advances already on the e-statement',
    'hr.kasbonResignBlocked': 'Resigned staff cannot request a new advance. Repayment can still be recorded.',
    'hr.viewDetail': 'View detail',
    'hr.addKasbon': 'Record advance',
    'hr.addKasbonBtn': 'Add Advance',
    'hr.saveKasbon': 'Save Advance',
    'hr.kasbonNo': 'Advance No.',
    'hr.refId': 'Ref ID',
    'hr.refIdAuto': 'Journal Ref ID',
    'hr.pickEmployee': 'Select employee',
    'hr.pickEmployeeHint': 'Pick an active employee in this company',
    'hr.copyNik': 'Copy ID',
    'hr.kasbonBoardTitle': 'Open advances',
    'hr.kasbonBoardSub': 'Employees with outstanding balances — click a row for full history.',
    'hr.noOpenKasbon': 'No open advances for this company.',
    'hr.kasbonLedger': 'Advance ledger',
    'hr.kasbonLedgerHint': 'Movements in the selected period (default: this month). Click a row for employee history.',
    'hr.kasbonFilterActive': 'Active movement filter: {period}',
    'hr.kasbonSearchPh': 'Search name, advance no, ref…',
    'hr.filterKindAll': 'All types',
    'hr.filterEmployee': 'Employee',
    'hr.filterEmployeeAll': 'All employees',
    'hr.pengajuanTitle': 'Advance requests',
    'hr.pengajuanSub':
      'Request → Approve (live receivable journal) or Reject (stays on payslip, not in financial reports).',
    'hr.pengajuanBtn': 'Request advance',
    'hr.pengajuanEmptyTitle': 'No requests yet',
    'hr.pengajuanEmptySub':
      'When requests come in, they appear here with Approve and Reject buttons.',
    'hr.pengajuanDialogTitle': 'Request cash advance',
    'hr.pengajuanDialogSub': 'Saved as pending — no journal until approved.',
    'hr.pengajuanStatusPending': 'Pending',
    'hr.pengajuanStatusApproved': 'Approved',
    'hr.pengajuanStatusRejected': 'Rejected',
    'hr.pengajuanColStatus': 'Status',
    'hr.pengajuanColAction': 'Action',
    'hr.pengajuanApprove': 'Approve',
    'hr.pengajuanReject': 'Reject',
    'hr.pengajuanConfirmApprove':
      'Approve advance for {name} {n}? Journal Dr Employee Receivable · Cr Cash posts now — balance sheet updates live.',
    'hr.pengajuanConfirmReject':
      'Reject advance for {name} {n}? It will not enter financial reports, but remains on the payslip/history.',
    'hr.snack.pengajuanSaved': 'Advance request saved (awaiting approval)',
    'hr.snack.pengajuanApproved': 'Advance approved · journal {ref} · balance sheet updated',
    'hr.snack.pengajuanRejected': 'Advance rejected — not in financial reports',
    'hr.kasbonNeedsApproveHint':
      'New advances are saved as requests. After save, use Approve / Reject. Approve posts the receivable journal immediately.',
    'hr.colGajiAwal': 'Gross pay',
    'hr.colGajiPulang': 'Take-home',
    'hr.colKasbonDeduct': 'Kasbon deduction',
    'hr.kasbonDeductHint': 'Receivable clearance on payslip',
    'hr.openBalances': 'Open balances',
    'hr.openPortal': 'Employee portal',
    'hr.pendingApproveBtn': '{n} pending',
    'hr.pendingBannerTitle': '{n} cash-advance requests awaiting approval',
    'hr.pendingBannerSub': 'Approve to post receivable & update BS, or reject (stays on payslip, no GL).',
    'hr.ledgerTotal': 'ledger total',
    'hr.movements': '{n} movements',
    'hr.payrollPanelTitle': 'Payroll & salary journal',
    'hr.payrollPanelSub': 'Period {period} — preview, post, and history per company.',
    'hr.previewBreakdown': 'Preview breakdown',
    'hr.clickRowHistory': 'Click row → full history',
    'hr.journalPreview': 'Journal preview',
    'hr.journalPreviewSub': 'Will post to these COA accounts:',
    'hr.takeHome': 'take-home',
    'hr.postedRuns': 'posted runs',
    'hr.noCompanyPayroll': 'No payroll posted for this company yet.',
    'hr.historyPopupTitle': 'Full employee history',
    'hr.tabOverview': 'Overview',
    'hr.tabPayHist': 'Pay',
    'hr.tabJournals': 'Journals',
    'hr.tabCoa': 'COA',
    'hr.kasbonIn': 'Total advances',
    'hr.advanceDialogTitle': 'Record advance / deduction',
    'hr.advanceDialogSub': 'Includes COA accounts, advance number, and auto journal Ref ID.',
    'hr.advanceKind': 'Type',
    'hr.advanceAmount': 'Advance amount',
    'hr.advanceAmountHint': 'Example: type 300000 → formats as Rp 300,000',
    'hr.advanceNote': 'Note',
    'hr.advanceNotePh': 'e.g. Warehouse ops advance / emergency',
    'hr.advanceCoaTitle': 'Journal accounts (from COA)',
    'hr.debitAccount': 'Debit account (code & name)',
    'hr.debitAccountHint': 'Advance: usually Employee / Shareholder Receivable',
    'hr.creditAccount': 'Credit account (code & name)',
    'hr.creditAccountHint': 'Advance: usually Cash / Bank',
    'hr.postJournalSwitch': 'Create accounting journal automatically (recommended)',
    'hr.advanceNeedEmployee': 'Select an employee first',
    'hr.advanceNeedAmount': 'Enter advance amount (> 0)',
    'hr.advanceNeedAccounts': 'Select debit & credit accounts from COA',
    'hr.dialogPtNote': 'Saved to {pt} — {name}',
    'hr.snack.deactivated': 'Employee deactivated',
    'hr.snack.activated': 'Employee activated',
    'hr.snack.advanceSaved': 'Advance / deduction saved',
    'hr.snack.copied': '{label} copied',
    'hr.snack.exported': 'Exported {n} CSV rows',
    'hr.kasbonBalance': 'Advance balance',
    'hr.statCount': 'Employees',
    'hr.statActive': '{n} active',
    'hr.statGross': 'Total gross/month',
    'hr.statAvg': 'Average gross',
    'hr.perMonth': '/ month',
    'hr.coaKicker': 'Linked accounts (COA)',
    'hr.coaTitle': 'Payroll account codes & names',
    'hr.coaSub': 'Loaded from Chart of Accounts — ensure these codes exist before posting payroll.',
    'hr.openCoa': 'Open Chart of Accounts',
    'hr.coaMissing': 'Missing from COA',
    'hr.normal': 'Normal balance',
    'hr.searchPlaceholder': 'Search name, position, ID…',
    'hr.rowHint': 'Click a row for salary, cash advance, and journal history',
    'hr.emptyEmployees': 'No employees for this company yet.',
    'hr.emptyEmployeesHint': 'Add a new employee, or adjust status / search filters.',
    'hr.pickPtTap': 'Tap to open',
    'hr.colNik': 'National ID',
    'hr.colGross': 'Gross',
    'hr.colKasbon': 'Advance balance',
    'hr.since': 'Since {date}',
    'hr.profileTitle': 'Profile',
    'hr.sinceLabel': 'Joined',
    'hr.payrollHistoryTitle': 'Payroll history (posted)',
    'hr.noPayrollHistory': 'No posted payroll for this employee yet.',
    'hr.kasbonHistoryTitle': 'Cash advances & deductions',
    'hr.noKasbon': 'No advance records yet.',
    'hr.kindKasbon': 'Advance',
    'hr.kindRepayment': 'Payroll deduction',
    'hr.kindBonus': 'Bonus',
    'hr.journalHistoryTitle': 'Related journals',
    'hr.noJournals': 'No journals matching this employee name.',
    'hr.linkedCoaTitle': 'Payroll journal accounts',
    'hr.tabEmployees': 'Employees',
    'hr.tabPayroll': 'Payroll',
    'hr.addEmployee': 'Add employee',
    'hr.restoreRoster': 'Restore resign roster',
    'hr.restoreRosterShort': 'Restore roster',
    'hr.resignHiddenBanner': '{n} resigned employees hidden by Active filter',
    'hr.showAllEmployees': 'Show all',
    'hr.resignIncludedNote': 'Includes {n} resigned employees (Jan–Aug) below',
    'hr.snack.rosterRestored': 'Employee roster (including resigns) restored',
    'hr.colName': 'Name',
    'hr.colPosition': 'Position',
    'hr.colPtkp': 'PTKP',
    'hr.colSalary': 'Salary',
    'hr.colAllowance': 'Allowance',
    'hr.edit': 'Edit',
    'hr.delete': 'Delete',
    'hr.deleteHint': 'The trash button is admin-only — permanently remove dummy / resigned records.',
    'hr.deleteAdminOnly': 'Only admins can delete employees.',
    'hr.confirmDeleteNamed': 'Permanently delete “{name}”? This cannot be undone.',
    'hr.snack.deleted': 'Deleted {name}',
    'hr.monthLabel': 'Month',
    'hr.previewBtn': 'Preview',
    'hr.postJournal': 'Post journal',
    'hr.postJanAgt': 'Post Jan–Aug 2026',
    'hr.previewTitle': 'Preview · Gross {gross} · Art.21 {pph} · Net {net}',
    'hr.colPph21': 'Art. 21',
    'hr.colPphOverride': 'Art. 21 override (Rp)',
    'hr.colNote': 'Note',
    'payslip.title': 'Payslips',
    'payslip.kicker': 'HR · Payroll',
    'payslip.sub':
      'Per-employee payslip preview from master salary (default last month). Admins can edit pay/status and delete.',
    'payslip.search': 'Search name / ID…',
    'payslip.refresh': 'Refresh',
    'payslip.empty': 'No payslips for this company/period.',
    'payslip.adminHint': 'Admin mode: edit salary, resign status, or delete an employee from the slip list.',
    'payslip.editTitle': 'Edit employee & salary',
    'payslip.editAdminOnly': 'Salary edit is for admin / accountant only',
    'payslip.deleteAdminOnly': 'Delete employee is admin-only',
    'payslip.confirmDelete': 'Permanently delete {name}? Related attendance & advances are removed too.',
    'payslip.snackSaved': 'Employee & salary saved',
    'payslip.snackDeleted': '{name} deleted',
    'payslip.empNotFound': 'Employee not found',
    'payslip.prevMonth': 'Previous month',
    'payslip.nextMonth': 'Next month',
    'hr.colNet': 'Net',
    'hr.calcNote':
      'Progressive annual calculation ÷ 12 (not TER). Align with consultant before official e-Bupot.',
    'hr.historyTitle': 'Posting history',
    'hr.colPeriod': 'Period',
    'hr.colStatus': 'Status',
    'hr.dialogAdd': 'Add employee',
    'hr.dialogEdit': 'Edit employee',
    'hr.nameLabel': 'Name',
    'hr.positionLabel': 'Position',
    'hr.ptkpLabel': 'PTKP status',
    'hr.baseSalaryLabel': 'Base salary',
    'hr.allowanceLabel': 'Allowance',
    'hr.nikLabel': 'National ID',
    'hr.npwpLabel': 'Tax ID',
    'hr.snack.saved': 'Employee saved',
    'hr.confirmDelete': 'Delete employee?',
    'hr.snack.posted': 'Payroll posted · journal {ref}',
    'hr.snack.batchPosted': 'Payroll Jan–Aug: {posted} months posted, {skipped} skipped (accrual)',

    'prac.kicker': 'Practice desk',
    'prac.clientsTitle': 'Clients / Taxpayers',
    'prac.clientsSub': 'Taxpayer master for engagements, letters, and fee tracking',
    'prac.addClient': 'Add client',
    'prac.editClient': 'Edit client',
    'prac.searchClient': 'Search code / name / tax ID…',
    'prac.emptyClients': 'No clients yet — add the first taxpayer',
    'prac.code': 'Code',
    'prac.name': 'Name',
    'prac.type': 'Type',
    'prac.phone': 'Phone',
    'prac.address': 'Address',
    'prac.client': 'Client',
    'prac.saved': 'Saved',
    'prac.confirmDelete': 'Delete “{name}”?',
    'prac.statTotal': 'Total clients',
    'prac.statNpwpOk': 'Tax ID complete',
    'prac.statNpwpMissing': 'Tax ID missing',
    'prac.statIncomplete': 'Incomplete data',
    'prac.statReady': 'Engagement-ready',
    'prac.statNoContact': 'No contact',
    'prac.showing': '{n} clients shown',
    'prac.readyPct': '{pct}% ready',
    'prac.incompleteN': '{n} incomplete',
    'prac.readyHint': '{ok} ready · {need} need attention',
    'prac.needAttention': '{n} items need attention',
    'prac.vizReady': 'Taxpayer master readiness',
    'prac.vizGaps': 'Still-empty fields',
    'prac.vizType': 'Taxpayer type mix',
    'prac.vizInactive': '{n} inactive clients',
    'prac.filterBar': 'Type filter & search',
    'prac.healthTitle': 'Client master health',
    'prac.healthSub': 'Click a lane to focus clients that need cleanup.',
    'prac.clearLane': 'Show all',
    'prac.lane.all': 'All',
    'prac.lane.ready': 'Ready',
    'prac.lane.incomplete': 'Incomplete',
    'prac.lane.npwp_missing': 'Tax ID missing',
    'prac.lane.npwp_ok': 'Tax ID complete',
    'prac.lane.badan': 'Entity',
    'prac.lane.pribadi': 'Individual',
    'prac.lane.umkm': 'SME',
    'prac.lane.no_contact': 'No contact',
    'prac.lane.inactive': 'Inactive',
    'prac.type.badan': 'Entity',
    'prac.type.pribadi': 'Individual',
    'prac.type.umkm': 'SME',
    'prac.tipsTitle': 'Quick tips · tidy taxpayer master',
    'prac.tipsShow': 'Show',
    'prac.tipsHide': 'Hide',
    'prac.tip1': 'Fill tax ID, address, and tax office first so engagements & letters stay accurate.',
    'prac.tip2': 'Add email/phone for fee follow-up and calendar reminders.',
    'prac.tip3': 'Entity / Individual / SME types drive document templates & rates.',
    'prac.tip4': 'Deactivate old clients instead of deleting — engagement history stays intact.',
    'prac.tipActEdit': 'Edit {n} incomplete',
    'prac.tipActNpwp': 'Filter missing tax ID ({n})',
    'prac.tipActContact': 'Filter no contact ({n})',
    'prac.toCalendar': 'Tax calendar',
    'prac.toDocs': 'Letters & files',
    'prac.exportCsv': 'Export CSV',
    'prac.exportEmpty': 'Nothing to export',
    'prac.exportDone': 'CSV downloaded ({n} clients)',
    'prac.listKicker': 'Master list',
    'prac.listTitle': 'Taxpayer list',
    'prac.listSub': 'Empty cells are red · chips show missing fields',
    'prac.colNpwp': 'Tax ID',
    'prac.colEmail': 'Email',
    'prac.colKpp': 'Tax office',
    'prac.colContact': 'Contact',
    'prac.colStatus': 'Status',
    'prac.colAction': 'Action',
    'prac.statusIncomplete': 'Incomplete',
    'prac.statusReady': 'Ready',
    'prac.statusInactive': 'Inactive',
    'prac.emptyTitle': 'No matching clients',
    'prac.emptyFiltered': 'Filters are too tight — reset or change search.',
    'prac.resetFilters': 'Reset filters',
    'prac.alertIncomplete':
      '{n} clients have incomplete data (tax ID / address / tax office). Complete before creating engagements.',
    'prac.dialogEdit': 'Manual edit',
    'prac.dialogNew': 'Add new',
    'prac.tabIdentity': 'Identity',
    'prac.tabTax': 'Address & tax office',
    'prac.tabContact': 'Contact',
    'prac.codeHint': 'Leave blank for auto code WP-…',
    'prac.npwpHint': '15/16 digits — auto-formatted',
    'prac.npwpIncomplete': 'Tax ID incomplete (15/16 digits)',
    'prac.required': 'Required',
    'prac.addressRequired': 'Required for letters & SPT',
    'prac.kppHint': 'Example: KPP Pratama Tangerang Barat',
    'prac.kppRequired': 'Required for tax administration',
    'prac.activeSwitch': 'Client active',
    'prac.formReady': 'Form completeness {pct}%',
    'prac.snack.nameRequired': 'Client name is required',
    'prac.deleted': 'Client deleted',
    'prac.engTitle': 'Engagements & Fees',
    'prac.engSub': 'Service contracts, status, and fee pipeline by year',
    'prac.addEng': 'Add engagement',
    'prac.engName': 'Engagement title',
    'prac.feePipeline': 'Total fees (pipeline)',
    'prac.emptyEng': 'No engagements yet',
    'prac.due': 'Due date',
    'prac.engStatTotal': '{n} contracts',
    'prac.engShowing': '{n} engagements shown',
    'prac.engCollected': '{pct}% collected',
    'prac.engCollectedHint': 'Paid {paid} of pipeline {total}',
    'prac.engOverdueN': '{n} overdue',
    'prac.engFilteredFee': 'Filtered fee {n}',
    'prac.engNeedAttention': '{n} items need attention',
    'prac.engVizCollect': 'Fee collectibility',
    'prac.engVizFee': 'Pipeline by status',
    'prac.engVizKind': 'Service type mix',
    'prac.engVizNoFee': '{n} with zero fee',
    'prac.engFilterBar': 'Year, type & search filters',
    'prac.engHealthTitle': 'Engagement pipeline health',
    'prac.engHealthSub': 'Click a lane to focus contracts that need follow-up.',
    'prac.engClearLane': 'Show all',
    'prac.engLane.all': 'All',
    'prac.engLane.open': 'Open',
    'prac.engLane.in_progress': 'In progress',
    'prac.engLane.done': 'Done',
    'prac.engLane.billed': 'Billed',
    'prac.engLane.paid': 'Paid',
    'prac.engLane.overdue': 'Overdue',
    'prac.engLane.no_fee': 'No fee',
    'prac.engStatus.open': 'Open',
    'prac.engStatus.in_progress': 'In progress',
    'prac.engStatus.done': 'Done',
    'prac.engStatus.billed': 'Billed',
    'prac.engStatus.paid': 'Paid',
    'prac.engKind.spt': 'Tax return',
    'prac.engKind.pembukuan': 'Bookkeeping',
    'prac.engKind.konsultan': 'Advisory',
    'prac.engKind.lain': 'Other',
    'prac.engYearAll': 'All years',
    'prac.engSearchPh': 'Search client / title / status…',
    'prac.engTipsTitle': 'Quick tips · tidy fee pipeline',
    'prac.engTip1': 'Create one engagement per client + year so fees and deadlines stay trackable.',
    'prac.engTip2': 'Fill fee & due date before Billed — avoid zero-value contracts.',
    'prac.engTip3': 'Use the DP journal action on a row to record fee receipts.',
    'prac.engTip4': 'Quick-update status (Open → In progress → Billed → Paid) from the action menu.',
    'prac.engTipOverdue': 'Review {n} overdue',
    'prac.engTipNoFee': 'Fill {n} with no fee',
    'prac.engTipBilled': 'Filter billed ({n})',
    'prac.engNeedClient': 'No taxpayers yet — add a client before creating engagements.',
    'prac.engListKicker': 'Pipeline',
    'prac.engListTitle': 'Engagement list',
    'prac.engListSub': 'Overdue & zero-fee rows are flagged · quick status from actions',
    'prac.engColKind': 'Type',
    'prac.engColFee': 'Fee',
    'prac.engColStatus': 'Status',
    'prac.engColAction': 'Action',
    'prac.engEmptyTitle': 'No matching engagements',
    'prac.engEmptyFiltered': 'Filters are too tight — reset or change search.',
    'prac.engResetFilters': 'Reset filters',
    'prac.engAlertOverdue': '{n} engagements are past due and not paid/done yet.',
    'prac.engDialogEdit': 'Edit contract',
    'prac.engDialogNew': 'New contract',
    'prac.engEditTitle': 'Edit engagement',
    'prac.engTabContract': 'Contract',
    'prac.engTabFee': 'Fee & status',
    'prac.engTabSchedule': 'Schedule',
    'prac.engStart': 'Start date',
    'prac.engFeeHint': 'Contract fee amount',
    'prac.engFeeRequired': 'Enter a fee so the pipeline stays accurate',
    'prac.engDueRequired': 'Due date is recommended',
    'prac.engFormReady': 'Form completeness {pct}%',
    'prac.engSnack.clientRequired': 'Client is required',
    'prac.engSnack.titleRequired': 'Engagement title is required',
    'prac.engDeleted': 'Engagement deleted',
    'prac.engStatusUpdated': 'Status updated',
    'prac.engQuickStatus': 'Quick status change',
    'prac.engExportCsv': 'Export CSV',
    'prac.engExportEmpty': 'Nothing to export',
    'prac.engExportDone': 'CSV downloaded ({n} engagements)',
    'prac.calTitle': 'Tax Calendar',
    'prac.calSub': 'Periodic SPT deadlines, final tax, and practice reminders',
    'prac.calAll': 'All',
    'prac.calSoon': 'Soon',
    'prac.calPast': 'Past',
    'prac.calUpcoming': 'Upcoming',
    'prac.calNext': 'Next: {title} · {date}',
    'prac.calEvent': 'Event',
    'prac.calKind': 'Kind',
    'prac.calKicker': 'Deadlines & reminders',
    'prac.calToday': 'Today {d}',
    'prac.calChipSoon': '{n} due soon',
    'prac.calChipClear': 'Nothing urgent',
    'prac.calLoadedAt': 'Loaded {t}',
    'prac.calOpen': 'Open',
    'prac.calBannerOk': 'No deadlines in the next 14 days',
    'prac.calKpiSoonMeta': 'Within 14 days',
    'prac.calKpiUpcomingMeta': 'More than 14 days away',
    'prac.calKpiPastMeta': 'Already past due date',
    'prac.calKpiAllMeta': 'Total events in {year}',
    'prac.calVizUrgency': 'Urgency mix',
    'prac.calVizKind': 'Obligation types',
    'prac.calVizMonth': 'Due-date density by month',
    'prac.calHealthTitle': 'Calendar lanes',
    'prac.calHealthSub': 'Click to filter the deadline list',
    'prac.calTipsTitle': 'Action tips',
    'prac.calTipNext': 'Soon: {title} · {date}',
    'prac.calTipPast': '{n} deadlines already past — review compliance',
    'prac.calTipHub': 'Post final PPh in Tax Center',
    'prac.calTipSpt': 'Prepare the monthly tax pack',
    'prac.calTipSsp': 'Record billing / NTPN in the SSP tracker',
    'prac.calTipOk': 'Calendar is calm — no soon deadlines',
    'prac.calFocusSoon': 'Filter: soon',
    'prac.calFocusUpcoming': 'Filter: upcoming',
    'prac.calFocusPast': 'Filter: past',
    'prac.calFocusKind': 'Type filter: {kind}',
    'prac.calFocusSearch': 'Search: “{q}”',
    'prac.calClearFocus': 'Clear focus',
    'prac.calEmpty': 'Calendar not loaded',
    'prac.calEmptyHint': 'Pick a year then refresh',
    'prac.calTableKicker': 'List',
    'prac.calTableTitle': 'Tax deadlines {year}',
    'prac.calTableSub': 'Showing {shown} of {total} events',
    'prac.calSearchPh': 'Search event / type / date…',
    'prac.calSearchLabel': 'Search',
    'prac.calRefreshShort': 'Reload',
    'prac.calHubShort': 'Tax hub',
    'prac.calSptShort': 'SPT pack',
    'prac.calKindSptMasaShort': 'Monthly SPT',
    'prac.calStatus': 'Status',
    'prac.calAction': 'Action',
    'prac.calMasa': 'Period {m}',
    'prac.calNoRows': 'No matching events',
    'prac.calFooterNote': 'Soon = due within 14 days. SPT masa usually day 20; PPh 21 day 10.',
    'prac.calKindSptMasa': 'Monthly SPT / Final PPh',
    'prac.calKindPph21': 'PPh 21',
    'prac.calKindSptTahunan': 'Annual SPT',
    'prac.calKindOther': 'Other',
    'prac.docTitle': 'Tax Letters & Files',
    'prac.docSub': 'Archive SPT, SSP, withholding certificates, and client letters',
    'prac.upload': 'Upload',
    'prac.pickFile': 'Choose file',
    'prac.docName': 'File title',
    'prac.docType': 'Type',
    'prac.download': 'Download',
    'prac.emptyDocs': 'No files yet',
    'prac.needFile': 'Choose a file first',
    'prac.uploaded': 'File uploaded',
    'prac.docPx.kicker': 'Tax archive',
    'prac.docPx.loadedAt': 'Loaded {t}',
    'prac.docPx.chipCount': '{n} files',
    'prac.docPx.chipEmpty': 'Archive empty',
    'prac.docPx.bannerSpt': 'No SPT files for {year} yet',
    'prac.docPx.bannerOk': '{n} files · {size}',
    'prac.docPx.focusSptShort': 'Filter SPT',
    'prac.docPx.kpiCount': 'Total files',
    'prac.docPx.kpiCountMeta': 'Size {size}',
    'prac.docPx.kpiYear': 'Focus year',
    'prac.docPx.kpiYearMeta': 'Filter {year}',
    'prac.docPx.kpiRecent': 'Last 30 days',
    'prac.docPx.kpiRecentMeta': 'Recent uploads',
    'prac.docPx.kpiGaps': 'Missing metadata',
    'prac.docPx.kpiGapsMeta': '{client} without client · {pt} without company',
    'prac.docPx.vizType': 'File types',
    'prac.docPx.vizMonth': 'Uploads by period',
    'prac.docPx.vizSnapshot': 'Completeness snapshot',
    'prac.docPx.vizEmpty': 'No types yet',
    'prac.docPx.vizEmptyMonth': 'No monthly data yet',
    'prac.docPx.snapNoClient': 'Missing client',
    'prac.docPx.snapNoPt': 'Missing company',
    'prac.docPx.snapNoYear': 'Missing year',
    'prac.docPx.snapDp': 'Contract / DP invoice',
    'prac.docPx.healthTitle': 'Type lanes',
    'prac.docPx.healthSub': 'Click to filter the archive',
    'prac.docPx.tipsTitle': 'Action tips',
    'prac.docPx.tipSpt': 'No SPT for {year} yet — upload the SPT pack',
    'prac.docPx.tipClient': '{n} files without a client',
    'prac.docPx.tipPt': '{n} files without a company',
    'prac.docPx.tipDp': 'Attach contract/DP invoice then link to Unearned',
    'prac.docPx.tipWht': 'Withholding certificates are also tracked in PPh 23',
    'prac.docPx.tipSsp': 'Billing/NTPN is tracked in the SSP register',
    'prac.docPx.tipUpload': 'Upload a new file to the archive',
    'prac.docPx.tipOk': 'Archive looks healthy — metadata mostly complete',
    'prac.docPx.focusType': 'Type filter: {t}',
    'prac.docPx.focusSearch': 'Search: “{q}”',
    'prac.docPx.clearFocus': 'Clear focus',
    'prac.docPx.emptyHint': 'Upload SPT, SSP, withholding certificates, or client letters',
    'prac.docPx.tableKicker': 'Archive',
    'prac.docPx.tableTitle': 'File list',
    'prac.docPx.tableSub': 'Showing {shown} of {total}',
    'prac.docPx.searchPh': 'Search title / type / client / file…',
    'prac.docPx.noRows': 'No matching rows',
    'prac.docPx.action': 'Action',
    'prac.docPx.masa': 'Period',
    'prac.docPx.size': 'Size',
    'prac.docPx.noClient': 'No client',
    'prac.docPx.noPt': 'No company',
    'prac.docPx.typeBukti': 'Withholding certificate',
    'prac.docPx.typeSsp': 'SSP',
    'prac.docPx.typeEfaktur': 'e-Faktur',
    'prac.docPx.typeSpt': 'SPT',
    'prac.docPx.typeKontrak': 'Contract / PO',
    'prac.docPx.typeInvoiceDp': 'DP invoice',
    'prac.docPx.typeLain': 'Other',
    'prac.docPx.monthLabel': 'Month {m}',
    'prac.docPx.uploadKicker': 'Upload form',
    'prac.docPx.deleted': 'File deleted',
    'prac.docPx.exportCsv': 'Export CSV',
    'prac.docPx.exportCsvShort': 'CSV',
    'prac.docPx.refreshShort': 'Reload',
    'prac.docPx.searchLabel': 'Search',
    'prac.docPx.exportEmpty': 'No rows to export',
    'prac.docPx.footerNote':
      'Archive for audit trail. Link journal memos to the same customer name for DP/contracts.',
    'prac.consTitle': 'Group Consolidation',
    'prac.consSub': 'Combined P&L & balance sheet for selected entities + IC eliminations',
    'prac.consByPt': 'By company',
    'prac.consKicker': 'Group · Multi-entity · IC elimination',
    'prac.consNote':
      'Commercial figures combined for selected entities. IC eliminations are shown separately — not full IFRS consolidation. New companies in master join the group catalog automatically.',
    'prac.consPtCount': '{n} entities',
    'prac.consPtPicker': 'Entities in group',
    'prac.consPtAll': 'All entities',
    'prac.consPtPickHint': 'Select entities to combine. Default: every company in master.',
    'prac.consAddPt': 'Manage companies',
    'prac.consAddPtInline': 'Add company',
    'prac.consAddPtFull': 'Full master',
    'prac.consNoPtYet': 'No companies yet. Add one here — it joins the group catalog immediately.',
    'prac.consAddKicker': 'Company master',
    'prac.consAddTitle': 'Add company',
    'prac.consAddSub': 'Short code + legal name. NPWP can be completed later in master.',
    'prac.consAddCode': 'Entity code',
    'prac.consAddCodePh': 'e.g. JGX',
    'prac.consAddName': 'Company name',
    'prac.consAddNamePh': 'Example Indonesia Ltd',
    'prac.consAddNpwp': 'Tax ID (optional)',
    'prac.consAddNpwpPh': '15–16 digits',
    'prac.consAddSave': 'Save & include',
    'prac.consAddCodeNeed': 'Enter entity code (min. 2 chars)',
    'prac.consAddNameNeed': 'Enter company name',
    'prac.consAddOk': 'Company {code} added to the group',
    'prac.consBsOk': 'Assets ≈ Liabilities+Equity',
    'prac.consBsGap': 'Combined BS out of balance',
    'prac.consIcChip': 'IC: {n} pairs · {amount}',
    'prac.consOpenIc': 'Intercompany',
    'prac.consOpenLk': 'Open FS',
    'prac.consKpiPlMeta': 'P&L focus',
    'prac.consKpiBsMeta': 'Balance sheet focus',
    'prac.consVizPlMix': 'Combined P&L mix',
    'prac.consVizBsMix': 'Combined BS mix',
    'prac.consVizShareRev': 'Revenue share by entity',
    'prac.consVizShareAssets': 'Asset share by entity',
    'prac.consVizSnapshot': 'Consolidation snapshot',
    'prac.consVizEmpty': 'No entity data yet',
    'prac.consSnapMargin': 'Net margin',
    'prac.consSnapBsGap': 'Combined BS gap',
    'prac.consSnapIc': 'IC pairs',
    'prac.consHealthTitle': 'Focus navigation',
    'prac.consHealthSub': 'Tap a chip to focus P&L, balance sheet, or IC.',
    'prac.consLanePl': 'P&L',
    'prac.consLaneBs': 'Balance sheet',
    'prac.consLaneIc': 'IC elimination',
    'prac.consTipsTitle': 'Action tips',
    'prac.consTipGap': 'Combined BS off by {amount} — check each entity FS',
    'prac.consTipNoIc': 'No IC pairs this year — review intercompany',
    'prac.consTipIc': '{n} IC pairs · {amount} — review eliminations',
    'prac.consTipLk': 'Open formal financial statements per entity for account detail',
    'prac.consTipShare': 'Compare revenue share across entities in the table below',
    'prac.consTipOk': 'Consolidation summary looks healthy',
    'prac.consAutoHint': 'AI runs tips automatically and posts bell notes for cross-check.',
    'prac.consAutoRunning': 'AI is executing tips…',
    'prac.consAutoDone': 'AI finished · {n} new bell note(s) ready to cross-check.',
    'prac.consAutoSnack': 'AI posted {n} bell note(s) — please cross-check.',
    'prac.consTipExecuted': 'Already executed by AI',
    'prac.consTipExecutedBell': 'Executed · check the bell to cross-check',
    'prac.consFocusPl': 'Focus: P&L metrics',
    'prac.consFocusBs': 'Focus: balance sheet metrics',
    'prac.consFocusIc': 'Focus: IC eliminations',
    'prac.consClearFocus': 'Clear focus',
    'prac.consEmpty': 'Consolidation data not loaded',
    'prac.consEmptyHint': 'Pick a year & entities, then refresh.',
    'prac.consByPtKicker': 'Breakdown',
    'prac.consByPtSub': 'Click a row to open that entity’s financial statements.',
    'prac.consColAction': 'Action',
    'prac.consNeedTwo': 'Select at least 1 entity to combine.',
    'dash.groupConsTitle': 'Group Consolidation',
    'dash.groupConsSub': '{n} entities · Net profit {amount}',
    'dash.groupConsCta': 'Open consolidation',
    'dash.groupConsEmpty': 'No companies yet — add them in company master',
    'prac.metric.pendapatan': 'Revenue',
    'prac.metric.beban': 'Expenses',
    'prac.metric.labaBersih': 'Net income',
    'prac.metric.aset': 'Assets',
    'prac.metric.liabilitas': 'Liabilities',
    'prac.metric.ekuitas': 'Equity',

    'cal.title': 'Calendar',
    'cal.kicker': 'Indonesia Calendar',
    'cal.frameOpen': 'Open frame',
    'cal.frameClose': 'Close',
    'cal.proOpen': 'Open pro calendar',
    'cal.proClose': 'Close calendar',
    'cal.proPeekEmpty': 'No activities in the next 7 days.',
    'cal.filterMeeting': 'Meetings only',
    'cal.densityCompact': 'Compact',
    'cal.filterMonth': 'Month',
    'cal.filterToggle': 'Filters',
    'cal.allMonths': 'All months',
    'cal.periodToday': 'Today',
    'cal.periodWeek': 'This week',
    'cal.periodMonth': 'This month',
    'cal.periodLastMonth': 'Last month',
    'cal.periodEmpty': 'No activities in this period.',
    'cal.activities': 'activities',
    'cal.viewDay': 'Day',
    'cal.viewWeek': 'Week',
    'cal.viewMonth': 'Month',
    'cal.viewAgenda': 'Agenda',
    'cal.noEventsDay': 'No events to display',
    'cal.noEventsAgenda': 'No events to display',
    'cal.addMeeting': 'Meeting / Hall',
    'cal.hall': 'Hall',
    'cal.exploreStaff': 'View staff activities',
    'cal.exploreHall': 'View meetings & halls',
    'cal.prevYear': 'Previous year',
    'cal.nextYear': 'Next year',
    'cal.addTodo': '+ Add To-Do',
    'cal.addSchedule': 'Add Schedule',
    'cal.addLeave': 'Add Leave',
    'cal.yearTitle': 'Year {year} Calendar — Holidays, To-Dos & Staff Schedules',
    'cal.yearBlurb':
      '{days}-day year with {libur} national holidays and {cuti} collective leave days. Track {todos} open to-dos, {staff} staff, plus tax & period-close deadlines.',
    'cal.badgeHijri': 'Hijri calendar',
    'cal.days': 'days',
    'cal.openTodos': 'open to-dos',
    'cal.staff': 'Staff',
    'cal.nationalHoliday': 'National holidays',
    'cal.collectiveLeave': 'Collective leave',
    'cal.today': 'Today',
    'cal.taskMarker': 'Has task / schedule',
    'cal.tabYear': 'Year',
    'cal.tabTodos': 'To-Do',
    'cal.tabSchedules': 'Schedule',
    'cal.tabStaff': 'Staff Monitor',
    'cal.filterStaff': 'Filter staff',
    'cal.allStaff': 'All staff',
    'cal.longTitle': 'Long Holiday List {year}',
    'cal.longSub': 'Holiday spans combining weekends, national holidays, and collective leave.',
    'cal.libur': 'Holiday',
    'cal.cuti': 'Leave',
    'cal.todoTitle': 'To-Do List',
    'cal.todoSub': 'Office tasks — mark done, assign staff, flag high priority.',
    'cal.emptyTodos': 'No to-dos yet. Click + Add To-Do or pick a date on the calendar.',
    'cal.scheduleTitle': 'Schedules & Leave',
    'cal.scheduleSub': 'Meetings, work schedules, and staff leave in one timeline.',
    'cal.emptySchedules': 'No schedules yet. Add a meeting, schedule, or staff leave.',
    'cal.staffTitle': 'Monitor All Staff',
    'cal.staffSub': 'Workload, schedules, and leave — company filter: {company}',
    'cal.busyToday': 'Busy today',
    'cal.onLeave': 'On leave',
    'cal.unassigned': 'Unassigned',
    'cal.emptyStaff': 'No active employees yet.',
    'cal.busy': 'Busy',
    'cal.free': 'Available',
    'cal.noStaffEvents': 'No events this year',
    'cal.unassignedEvents': 'Unassigned events',
    'cal.kindTodo': 'To-Do',
    'cal.kindSchedule': 'Schedule',
    'cal.kindMeeting': 'Meeting',
    'cal.kindLeave': 'Leave',
    'cal.statusPending': 'Pending',
    'cal.statusProgress': 'In progress',
    'cal.statusDone': 'Done',
    'cal.statusCancelled': 'Cancelled',
    'cal.priorityLow': 'Low',
    'cal.priorityNormal': 'Normal',
    'cal.priorityHigh': 'High',
    'cal.priorityUrgent': 'Urgent',
    'cal.newEvent': 'Create new',
    'cal.editEvent': 'Edit event',
    'cal.fieldTitle': 'Title',
    'cal.fieldDesc': 'Notes',
    'cal.fieldDate': 'Date',
    'cal.fieldEndDate': 'Until (optional)',
    'cal.allDay': 'All day',
    'cal.startTime': 'Start',
    'cal.endTime': 'End',
    'cal.assignStaff': 'Assign to staff',
    'cal.fieldStatus': 'Status',
    'cal.fieldPriority': 'Priority',
    'cal.save': 'Save',
    'cal.cancel': 'Cancel',
    'cal.delete': 'Delete',
    'cal.needTitle': 'Title is required',
    'cal.created': 'Created successfully',
    'cal.updated': 'Updated successfully',
    'cal.deleted': 'Deleted successfully',
    'cal.confirmDelete': 'Delete this event?',
    'cal.tabOps': 'Operations',
    'cal.layers': 'Layers',
    'cal.layerTax': 'Tax',
    'cal.layerAccounting': 'Accounting',
    'cal.layerPayroll': 'Payroll',
    'cal.layerHr': 'HR / Advances',
    'cal.layerEngagement': 'Engagement',
    'cal.layerTasks': 'To-Do / Schedule',
    'cal.opsTitle': 'Operations Calendar',
    'cal.opsSub': 'SPT deadlines, SSP, withholdings, period close, payroll, advances, and engagements — click to open the related menu.',
    'cal.opsAll': 'All',
    'cal.opsSoon': 'soon',
    'cal.opsOverdue': 'overdue',
    'cal.emptyOps': 'No operational items for this filter.',
    'cal.dayDetail': 'Day detail',
    'cal.holiday': 'Holiday / Leave',
    'cal.noDayEvents': 'No to-dos / schedules on this date.',
    'cal.noDayOps': 'No operational deadlines on this date.',
    'cal.prevDay': 'Previous day',
    'cal.nextDay': 'Next day',
    'cal.tomorrow': 'Tomorrow',
    'cal.yesterday': 'Yesterday',
    'cal.inDays': 'in {n} days',
    'cal.daysAgo': '{n} days ago',
    'cal.dayStatTasks': 'Tasks',
    'cal.dayStatOps': 'Ops',
    'cal.dayStatStaff': 'Staff',
    'cal.dayStatOpen': 'Open',
    'cal.dayEmptyCta': 'Create first to-do',
    'cal.dayStaffTitle': 'Staff today',
    'cal.noDayStaff': 'No staff scheduled on this date.',
    'cal.dayNearby': 'Nearby deadlines',
    'cal.dayShortcuts': 'Menu shortcuts',
    'cal.tabAgenda': 'Agenda',
    'cal.agendaTitle': 'Upcoming agenda',
    'cal.agendaSub': 'Combined to-dos, schedules, holidays, and operational deadlines day by day.',
    'cal.agendaEmpty': '+ Add a to-do on this day',
    'cal.jumpToday': 'Today',
    'cal.exportIcs': 'Download .ICS',
    'cal.icsExported': 'Calendar file (.ics) downloaded',
    'cal.searchPh': 'Search to-do / tax / staff…',
    'cal.convertedTodo': 'Deadline converted to to-do',
    'cal.duplicated': 'Event duplicated',
    'cal.duplicate': 'Duplicate',
    'cal.conflictTitle': 'Staff schedule conflicts detected',

    'att.title': 'Employee Attendance',
    'att.kicker': 'HR · Attendance',
    'att.sub': 'Separate JGI & JGT attendance boards — present, late, absent, leave & overtime · filter: {company}',
    'att.statStaff': 'Active staff',
    'att.statResignMonth': 'Resigned (month)',
    'att.statResignHist': 'Resign history',
    'att.statResignTotal': 'Resigned (year)',
    'att.statResignMonthMeta': '{n} this month',
    'att.statPresent': 'Present (month)',
    'att.statLate': 'Late',
    'att.statAbsent': 'Absent',
    'att.statLeave': 'Leave/Sick/Permit',
    'att.statUnmarked': 'Unmarked',
    'att.statLateMin': 'Total late',
    'att.statOt': 'Total overtime',
    'att.tabToday': 'Today',
    'att.tabMatrix': 'Month Matrix',
    'att.tabRecap': 'Recap & Ranking',
    'att.tabSettings': 'Settings',
    'att.todayTitle': 'Today attendance board',
    'att.todaySub': '{n} employees on today’s roster',
    'att.matrixTitle': 'Monthly attendance matrix',
    'att.matrixSub': 'Click a cell to add/edit. Hover for check-in/out times.',
    'att.rosterSummary': '{active} active · {resign} resigned',
    'att.recapTitle': 'Professional recap',
    'att.recapSub': 'Attendance ranking, people needing attention, and summary table — including resigned staff.',
    'att.active': 'Active',
    'att.resign': 'Resigned',
    'att.rosterAll': 'Month roster',
    'att.rosterActive': 'Active',
    'att.rosterResign': 'Resigned',
    'att.filterRoster': 'Roster',
    'att.filterStatus': 'Status',
    'att.ptFilter': 'Company filter',
    'att.ptStripMeta': '{n} on board · {unmarked} unmarked',
    'att.ptGroupTitle': '{pt} · {n} employees',
    'att.focusPt': 'Focus {pt}',
    'att.quickPresent': 'Present',
    'att.quickAbsent': 'Absent',
    'att.quickLeave': 'Leave',
    'att.quickSick': 'Sick',
    'att.filterResign': 'View resigned',
    'att.filterResignAll': 'View all resigned',
    'att.seeResignHist': 'View history',
    'att.resignIncludedNote': 'Includes {n} resigned employees in this month’s report',
    'att.resignHistoryNote': '{n} employees resigned this year (left before this month)',
    'att.resignTotalNote': '{n} resignations this year · {month} still on this month’s roster',
    'att.resignIncludedHint': 'The Resign filter lists everyone who resigned this year. Use “Open resign month” for their last attendance matrix. Days after the leave date are not counted as unmarked.',
    'att.resignTodayNote': 'Still on roster until {date} — historical attendance stays recorded.',
    'att.resignHistoryTitle': 'Resign history this year',
    'att.resignHistorySub': 'Click to open the matrix for their last working month.',
    'att.resignHistorySubFull': '{n} resigned employees — click a card to open their last working month matrix.',
    'att.resignRosterTitle': 'Full resign roster',
    'att.resignRosterSub': '{total} resigned · {inMonth} this month · {alumni} alumni (already left)',
    'att.resignMatrixTitle': 'Resign matrix',
    'att.resignMatrixSub': '{total} resigned · {inMonth} this month · {alumni} alumni — use “Open resign month” for attendance history.',
    'att.resignAlumni': 'Alumni',
    'att.resignAlumniHint': 'left before this month — open resign month to edit attendance',
    'att.resignAlumniNote': 'Left before this month. Attendance lives in {month}.',
    'att.emptyResignHint': 'No resigned employees for this company/year filter. Try All companies or change the year.',
    'att.leftAt': 'Leave date',
    'att.joinedAt': 'Join date',
    'att.detail': 'Detail',
    'att.tenureLabel': 'Tenure',
    'att.tenureDays': '{n} days',
    'att.tenureMonths': '{n} mo',
    'att.tenureYears': '{n} yr',
    'att.tenureYearsMonths': '{y} yr {m} mo',
    'att.timelineTitle': 'Resign timeline',
    'att.timelineSub': 'Who left each month · {year}',
    'att.timelineMonthTip': '{n} resigned in {label} — click to open matrix',
    'att.timelineMonthsActive': 'Months with exits',
    'att.timelineThisMonth': 'Resignations this month',
    'att.snapshotEmpty': 'No attendance in leave month yet',
    'att.inThisMonth': 'In this month',
    'att.openLastMonth': 'Open resign month',
    'att.emptyMatrixHint': 'No employees for this roster filter. Try All / Active, or change the month.',
    'att.offRoster': 'Outside employment period (not joined yet / already resigned)',
    'att.tipResignMonth': '{n} resigned staff are included in this month — open matrix',
    'att.tipResignHist': '{n} resignations this year — open full resign roster',
    'att.settingsTitle': 'Work hours & late rules',
    'att.settingsSub': 'Used for automatic late / early leave / overtime calculation.',
    'att.add': 'Add Attendance',
    'att.addShort': 'Add',
    'att.edit': 'Edit Attendance',
    'att.bulk': 'Bulk Mark',
    'att.bulkShort': 'Bulk',
    'att.exportCsvShort': 'Export CSV',
    'att.employee': 'Employee',
    'att.employees': 'Select employees',
    'att.date': 'Date',
    'att.status': 'Status',
    'att.note': 'Note',
    'att.save': 'Save',
    'att.cancel': 'Cancel',
    'att.delete': 'Delete',
    'att.saved': 'Attendance saved',
    'att.deleted': 'Attendance deleted',
    'att.checkedIn': 'Checked in',
    'att.checkedOut': 'Checked out',
    'att.bulkDone': '{n} bulk attendance rows saved',
    'att.settingsSaved': 'Work-hour settings saved',
    'att.csvExported': 'Attendance CSV downloaded',
    'att.needFields': 'Employee, company, and date are required',
    'att.needCompany': 'Select at least one employee — company is taken from each employee (JGI/JGT)',
    'att.needEmployees': 'Select at least one employee',
    'att.confirmDelete': 'Delete this attendance record?',
    'att.deleteAdminOnly': 'Deleting attendance is admin / accountant only',
    'att.editAdminOnly': 'Manual attendance edits are admin / accountant only',
    'att.manualAdmin': 'Admin manual',
    'att.holidaysMonth': 'National holidays this month',
    'att.ranking': 'Top attendance',
    'att.attention': 'Needs attention',
    'att.employeeRecap': 'Per-employee recap',
    'att.noData': 'No data yet',
    'att.allGood': 'Nothing critical — looking good!',
    'att.workStart': 'Start time',
    'att.workEnd': 'End time',
    'att.lateAfter': 'Late grace',
    'att.earlyLeave': 'Early-leave threshold',
    'att.breakMin': 'Break (deducted)',
    'att.workDays': 'Workdays (numbers)',
    'att.saveSettings': 'Save settings',
    'att.ytd': 'Year-to-date summary',
    'att.monthDetail': 'This month detail',
    'att.recent': 'Recent history',
    'att.allPt': 'All companies',
    'att.search': 'Search name / role / company…',
    'att.focusAll': 'All statuses',
    'att.focusPresent': 'Present',
    'att.focusLate': 'Late',
    'att.focusAbsent': 'Absent',
    'att.focusUnmarked': 'Unmarked',
    'att.focusLeave': 'Leave/Sick/Permit',
    'att.focusHoliday': 'Holiday',
    'att.focusBanner': 'Focus: {focus} · {n} employees',
    'att.clearFocus': 'Clear filter',
    'att.vizTodayFill': 'Today completeness',
    'att.vizTodayFillSub': 'filled',
    'att.vizTodayHint': '{filled}/{total} employees already have a status',
    'att.vizTodayMix': 'Today mix',
    'att.vizMonth': 'Month fill',
    'att.vizMonthSub': 'workdays filled',
    'att.healthTitle': 'Attendance health',
    'att.healthSub': 'Click a chip to filter today’s board',
    'att.laneUnmarked': 'Open',
    'att.laneLate': 'Late',
    'att.laneAbsent': 'Absent',
    'att.laneLeave': 'Leave+',
    'att.laneHoliday': 'Holiday',
    'att.tipsTitle': 'Action tips',
    'att.tipUnmarked': '{n} employees unmarked today — fill or check in',
    'att.tipLate': '{n} late today — review check-in times',
    'att.tipAbsent': '{n} absent today — confirm with supervisors',
    'att.tipAllHoliday': 'Everyone is on holiday status today (weekend / public holiday)',
    'att.tipBulk': 'Many month slots still empty — try Bulk Mark',
    'att.tipAttention': '{n} employees need attention in the recap',
    'att.tipOk': 'Today’s attendance looks under control',
    'att.pillPresent': 'present',
    'att.pillLate': 'late',
    'att.pillAbsent': 'absent',
    'att.pillUnmarked': 'open',
    'att.emptyToday': 'No employees on today’s board yet',
    'att.emptyFilter': 'No matches for this filter',
    'att.emptyTodayHint': 'Change company filter (JGI/JGT) or period, or add attendance. Default shows active staff only.',
    'att.in': 'In',
    'att.out': 'Out',
    'att.work': 'Work',
    'att.late': 'Late',
    'att.checkIn': 'Check-in',
    'att.checkOut': 'Check-out',
    'att.editShort': 'Edit',
    'att.holidayNote': 'Holiday — check-in disabled. Edit to override if needed.',

    'inv.title': 'Invoice & Proforma',
    'inv.kicker': 'Billing · Customers',
    'inv.sub': 'Client proformas and invoices — company filter: {company}',
    'inv.newProforma': 'New Proforma',
    'inv.newInvoice': 'New Invoice',
    'inv.edit': 'Edit document',
    'inv.tabList': 'List',
    'inv.tabPipeline': 'Pipeline',
    'inv.statSent': 'Outstanding',
    'inv.statPaid': 'Paid',
    'inv.statOverdue': 'Overdue',
    'inv.search': 'Search number / client…',
    'inv.empty': 'No proforma/invoice yet. Create one from the buttons above.',
    'inv.emptyCol': 'Empty',
    'inv.colNumber': 'Number',
    'inv.colClient': 'Client',
    'inv.colDate': 'Date',
    'inv.colDue': 'Due date',
    'inv.colTotal': 'Total',
    'inv.colStatus': 'Status',
    'inv.company': 'Issuing company',
    'inv.client': 'Client / customer',
    'inv.engagement': 'Engagement (optional)',
    'inv.lines': 'Line items',
    'inv.addLine': 'Add line',
    'inv.desc': 'Description',
    'inv.product': 'Catalog product',
    'inv.price': 'Price',
    'inv.discount': 'Discount (Rp)',
    'inv.tax': 'Tax',
    'inv.amountPaid': 'Amount paid',
    'inv.notes': 'Notes',
    'inv.terms': 'Terms & conditions',
    'inv.save': 'Save',
    'inv.cancel': 'Cancel',
    'inv.delete': 'Delete',
    'inv.void': 'Void',
    'inv.markPaid': 'Mark paid',
    'inv.convert': 'Convert to Invoice',
    'inv.saved': 'Document saved',
    'inv.deleted': 'Document deleted',
    'inv.voided': 'Document voided',
    'inv.markedPaid': 'Invoice marked as paid',
    'inv.payTitle': 'Mark as paid',
    'inv.payAmount': 'Amount paid',
    'inv.payBalance': 'Balance due',
    'inv.payConfirm': 'Confirm payment',
    'inv.glSale': 'Sales journal',
    'inv.glPay': 'Receipt journal',
    'inv.glNone': 'No journal yet — send the invoice (not draft/proforma) to post automatically',

    'vb.kicker': 'Accounts payable',
    'vb.title': 'Vendor bills',
    'vb.sub': 'Book purchases to AP 2100, then pay from bank. Drafts stay off the ledger.',
    'vb.statAll': 'All',
    'vb.statUnpaid': 'Unpaid',
    'vb.statOverdue': 'Overdue',
    'vb.statPaid': 'Paid',
    'vb.search': 'Search number or vendor…',
    'vb.add': 'New bill',
    'vb.edit': 'Edit bill',
    'vb.empty': 'No vendor bills yet',
    'vb.company': 'Company',
    'vb.vendor': 'Vendor',
    'vb.newVendor': 'New vendor',
    'vb.vendorName': 'Vendor name',
    'vb.phone': 'Phone',
    'vb.billDate': 'Bill date',
    'vb.dueDate': 'Due date',
    'vb.status': 'Status',
    'vb.statusOpen': 'Open (post AP)',
    'vb.taxRate': 'VAT (e.g. 0.11)',
    'vb.desc': 'Description',
    'vb.qty': 'Qty',
    'vb.price': 'Price',
    'vb.account': 'Expense/asset account',
    'vb.addLine': 'Add line',
    'vb.total': 'Total',
    'vb.notes': 'Notes',
    'vb.post': 'Post AP',
    'vb.pay': 'Pay in full',
    'vb.void': 'Void',
    'vb.glBill': 'AP journal',
    'vb.glPay': 'Payment journal',
    'vb.needPtVendor': 'Company and vendor are required',
    'vb.saved': 'Bill {n} saved',
    'vb.posted': 'AP posted to the ledger',
    'vb.paid': 'Payment posted',
    'vb.payTitle': 'Pay bill',
    'vb.payAmount': 'Amount paid',
    'vb.payBalance': 'Balance due',
    'vb.payConfirm': 'Confirm payment',
    'vb.voided': 'Bill voided',
    'vb.vendorSaved': 'Vendor saved',

    'fa.kicker': 'Fixed assets',
    'fa.title': 'Fixed asset register',
    'fa.sub': 'Link bank CAPEX outflows to the register. Acquisition 1500 · depreciation 5008 / 1600. Drafts are not posted.',
    'fa.statAll': 'All',
    'fa.statActive': 'Active',
    'fa.statPending': 'Depreciation due',
    'fa.statDone': 'Fully depreciated',
    'fa.search': 'Search number or asset name…',
    'fa.add': 'New asset',
    'fa.fromBank': 'From bank',
    'fa.fromBankTitle': 'Register asset from bank',
    'fa.fromBankHint': 'Pick bank outflows already Dr 1500 or flagged as CAPEX. Linked without double-posting cash.',
    'fa.fromBankEmpty': 'No bank candidates for this period',
    'fa.fromBankRegister': 'Register asset',
    'fa.fromBankDone': 'Asset {n} registered from bank',
    'fa.fromBankAlready': 'This journal is already linked to {n}',
    'fa.bankRef': 'Bank ref',
    'fa.edit': 'Edit asset',
    'fa.empty': 'No fixed assets yet',
    'fa.company': 'Company',
    'fa.name': 'Asset name',
    'fa.desc': 'Description',
    'fa.acquisitionDate': 'Acquisition date',
    'fa.inServiceDate': 'In-service date',
    'fa.cost': 'Cost',
    'fa.salvage': 'Salvage value',
    'fa.lifeMonths': 'Useful life (months)',
    'fa.monthlyDepr': 'Monthly depreciation',
    'fa.bookValue': 'Book value',
    'fa.accumDepr': 'Accum. depreciation',
    'fa.assetAccount': 'Asset account (1500)',
    'fa.paidFrom': 'Paid from (optional)',
    'fa.paidFromHint': 'Fill if not via vendor bill — posts Dr Asset / Cr Cash-Bank',
    'fa.status': 'Status',
    'fa.notes': 'Notes',
    'fa.activate': 'Activate',
    'fa.dispose': 'Dispose / sell',
    'fa.disposeConfirm': 'Mark asset {n} as disposed/sold? Depreciation stops.',
    'fa.disposed': 'Asset marked disposed',
    'fa.void': 'Void',
    'fa.runDepr': 'Depreciate this month',
    'fa.runDeprBatch': 'Run depreciation',
    'fa.period': 'Period (YYYY-MM)',
    'fa.glAcq': 'Acquisition journal',
    'fa.glDepr': 'Depreciation journal',
    'fa.deprHistory': 'Depreciation history',
    'fa.needPtName': 'Company and asset name required',
    'fa.saved': 'Asset {n} saved',
    'fa.activated': 'Asset active — acquisition journal posted (if applicable)',
    'fa.voided': 'Asset voided',
    'fa.deprDone': 'Depreciation {period} posted · {amount}',
    'fa.deprBatchDone': '{n} assets depreciated · total {amount}',
    'fa.noDepr': 'No depreciation for this period',

    'rj.kicker': 'Routine adjustments',
    'rj.title': 'Recurring journals',
    'rj.sub': 'Rent, amortization, accruals — run monthly. Idempotent per period.',
    'rj.statAll': 'All active',
    'rj.statPending': 'Due to run',
    'rj.search': 'Search schedule name…',
    'rj.add': 'New schedule',
    'rj.edit': 'Edit schedule',
    'rj.empty': 'No recurring journals yet',
    'rj.company': 'Company',
    'rj.name': 'Name',
    'rj.memo': 'Journal memo',
    'rj.kind': 'Kind',
    'rj.amount': 'Amount',
    'rj.day': 'Posting day (1–28)',
    'rj.period': 'Period (YYYY-MM)',
    'rj.account': 'Account',
    'rj.side': 'Side',
    'rj.desc': 'Description',
    'rj.addLine': 'Add line',
    'rj.run': 'Run',
    'rj.runBatch': 'Run all due',
    'rj.deactivate': 'Deactivate',
    'rj.lastRun': 'Last run',
    'rj.runs': 'Posting history',
    'rj.needPtName': 'Company, name, and at least 2 lines required',
    'rj.saved': 'Schedule saved',
    'rj.runDone': 'Journal {period} posted · {ref}',
    'rj.runBatchDone': '{n} journals posted · total {amount}',
    'rj.noRun': 'No schedules due for this period',
    'rj.deactivated': 'Schedule deactivated',

    'jra.kicker': 'Journal control',
    'jra.title': 'Journal approvals',
    'jra.sub': 'Manual journals requiring approval are excluded from financial reports until approved.',
    'jra.pendingN': '{n} journals pending',
    'jra.empty': 'No pending journals',
    'jra.approve': 'Approve',
    'jra.reject': 'Reject',
    'jra.view': 'View journal',
    'jra.reason': 'Rejection reason',
    'jra.approved': 'Journal {ref} approved',
    'jra.rejected': 'Journal rejected',

    'dim.kicker': 'Tracking',
    'dim.title': 'Journal dimensions',
    'dim.sub': 'Optional project and warehouse — select when creating manual journals.',
    'dim.projects': 'Projects',
    'dim.warehouses': 'Warehouses',
    'dim.add': 'Add',
    'dim.edit': 'Edit',
    'dim.empty': 'No dimensions yet',
    'dim.code': 'Code',
    'dim.name': 'Name',
    'dim.company': 'Company (blank = shared)',
    'dim.shared': 'All companies',
    'dim.saved': 'Dimension saved',
    'inv.converted': 'Proforma converted → {number}',
    'inv.needCompanyClient': 'Issuing company and client are required',
    'inv.needLines': 'Add at least one line item',
    'inv.confirmDelete': 'Delete this document?',
    'inv.statProforma': 'Proforma',
    'inv.statInvoice': 'Invoice',
    'inv.statDraft': 'Draft',
    'inv.showing': '{n} documents shown',
    'inv.collected': '{pct}% collected',
    'inv.collectedHint': 'Paid {paid} of invoices {total}',
    'inv.overdueN': '{n} overdue',
    'inv.needAttention': '{n} items need attention',
    'inv.vizCollect': 'Invoice collectibility',
    'inv.vizStatus': 'Document status',
    'inv.vizType': 'Proforma vs Invoice',
    'inv.vizPartial': '{n} partial payments',
    'inv.healthTitle': 'Billing health status',
    'inv.healthSub': 'Click a lane to focus documents that need follow-up.',
    'inv.clearLane': 'Show all',
    'inv.lane.all': 'All',
    'inv.lane.unpaid': 'Outstanding',
    'inv.lane.overdue': 'Overdue',
    'inv.lane.draft': 'Draft',
    'inv.lane.sent': 'Sent',
    'inv.lane.partial': 'Partial',
    'inv.lane.paid': 'Paid',
    'inv.lane.proforma': 'Proforma',
    'inv.lane.invoice': 'Invoice',
    'inv.tipsTitle': 'Quick tips · tidy billing',
    'inv.tipsShow': 'Show',
    'inv.tipsHide': 'Hide',
    'inv.tip1': 'Draft invoices with a remaining balance count as Outstanding — send or mark paid so the pipeline stays accurate.',
    'inv.tip2': 'Convert proforma → invoice after client approval, then mark paid when funds clear.',
    'inv.tip3': 'Use Pipeline view for Proforma → Outstanding → Paid flow.',
    'inv.tip4': 'Link an engagement so line items can auto-fill from contract fees.',
    'inv.tipDraft': 'Edit {n} drafts',
    'inv.tipPay': 'Review {n} outstanding',
    'inv.tipOverdue': 'Check {n} overdue',
    'inv.tipConvert': 'Open convertible proforma',
    'inv.filterAll': 'All',
    'inv.filterStatusAll': 'All statuses',
    'inv.emptyTitle': 'No matching documents',
    'inv.emptyFiltered': 'Filters are too tight — reset or change search.',
    'inv.resetFilters': 'Reset filters',

    'mkt.title': 'Marketing & WhatsApp',
    'mkt.kicker': 'Broadcast · Database · Gateway',
    'mkt.sub': 'Marketing & follow-up number database — company filter: {company}',
    'mkt.broadcastMarketing': 'Marketing broadcast',
    'mkt.broadcastFollowup': 'Follow-up broadcast',
    'mkt.statMarketing': 'Marketing DB',
    'mkt.statFollowup': 'Follow-up DB',
    'mkt.statActive': 'Active contacts',
    'mkt.statQueued': 'Broadcast queue',
    'mkt.noGateway': 'No gateway yet',
    'mkt.tabOverview': 'Overview',
    'mkt.tabContacts': 'Database',
    'mkt.tabBroadcast': 'Broadcast',
    'mkt.tabTemplates': 'Templates',
    'mkt.tabGateway': 'WA Gateway',
    'mkt.laneMarketingTitle': 'Marketing broadcast',
    'mkt.laneMarketingDesc': 'Leads, prospects, nurture — for promos & acquisition.',
    'mkt.laneFollowupTitle': 'Follow-up broadcast',
    'mkt.laneFollowupDesc': 'Active clients, renewals, overdue — reminders & care.',
    'mkt.laneCta': 'Create broadcast →',
    'mkt.mapBoard': 'Number segment map',
    'mkt.mapBoardSub': 'Each number is mapped to a segment. Marketing and follow-up have different focus.',
    'mkt.search': 'Search name / phone / tag…',
    'mkt.addContact': 'Add number',
    'mkt.editContact': 'Edit contact',
    'mkt.import': 'Import numbers',
    'mkt.importHint': 'One line: Name, Phone [, mapKey] [, tags] — comma/tab separated.',
    'mkt.importEmpty': 'No rows to import',
    'mkt.imported': 'Import done: {ok} ok, {skipped} skipped',
    'mkt.remap': 'Remap',
    'mkt.selectAll': 'Select all',
    'mkt.selectFirst': 'Select contacts first',
    'mkt.remapped': 'Mapping updated',
    'mkt.emptyContacts': 'No numbers yet. Add manually or import.',
    'mkt.colName': 'Name',
    'mkt.colPhone': 'WA number',
    'mkt.colChannel': 'DB type',
    'mkt.colMap': 'Mapping',
    'mkt.colStatus': 'Status',
    'mkt.company': 'Company (optional)',
    'mkt.notes': 'Notes',
    'mkt.campaigns': 'Campaigns',
    'mkt.emptyCampaigns': 'No broadcasts yet.',
    'mkt.pickCampaign': 'Pick a campaign on the left, or create a new broadcast.',
    'mkt.runBroadcast': 'Run / prepare WA',
    'mkt.openWa': 'Open',
    'mkt.templates': 'Message templates',
    'mkt.addTemplate': 'New template',
    'mkt.gatewayTitle': 'WhatsApp Gateway',
    'mkt.gatewaySub': 'Configure sender: manual wa.me, HTTP/WAHA, or Meta Cloud API.',
    'mkt.addGateway': 'Add gateway',
    'mkt.ping': 'Test connection',
    'mkt.campaignTitle': 'Campaign title',
    'mkt.template': 'Template',
    'mkt.message': 'Message body',
    'mkt.createCampaign': 'Create & queue targets',
    'mkt.campaignCreated': 'Campaign created · {n} targets',
    'mkt.campaignRan': 'Batch done · sent {sent}, failed {failed}',
    'mkt.usingSelected': 'Using {n} selected contacts from Database.',
    'mkt.savedContact': 'Contact saved',
    'mkt.savedTemplate': 'Template saved',
    'mkt.savedGateway': 'Gateway saved',
    'mkt.deleted': 'Deleted',
    'mkt.delete': 'Delete',
    'mkt.cancel': 'Cancel',
    'mkt.save': 'Save',
    'mkt.confirmDelete': 'Delete this item?',
    'mkt.confirmDeleteContact': 'Remove this contact from the database?',
    'mkt.showing': '{n} numbers in DB',
    'mkt.readyPct': '{pct}% active',
    'mkt.readyHint': '{ok} active of {total} contacts',
    'mkt.needAttention': '{n} items need attention',
    'mkt.vizReady': 'Database health',
    'mkt.vizChannel': 'Marketing vs Follow-up',
    'mkt.vizSegment': 'Top segments',
    'mkt.vizSegmentEmpty': 'No filled segments yet',
    'mkt.camp.draft': 'Draft',
    'mkt.camp.queued': 'Queued',
    'mkt.camp.done': 'Done',
    'mkt.healthTitle': 'Marketing health status',
    'mkt.healthSub': 'Click a lane to open Database / Broadcast / Gateway.',
    'mkt.lane.all': 'All',
    'mkt.lane.active': 'Active',
    'mkt.lane.marketing': 'Marketing',
    'mkt.lane.followup': 'Follow-up',
    'mkt.lane.paused': 'Paused',
    'mkt.lane.optout': 'Opt-out',
    'mkt.lane.queued': 'BC queue',
    'mkt.lane.gateway': 'Gateway',
    'mkt.tipsTitle': 'Quick tips · tidy WA & broadcasts',
    'mkt.tipsShow': 'Show',
    'mkt.tipsHide': 'Hide',
    'mkt.tip1': 'Map every number to a segment so Marketing vs Follow-up broadcasts stay accurate.',
    'mkt.tip2': 'Click a segment card to open the filtered Database.',
    'mkt.tip3': 'Keep the WA gateway active before running the broadcast queue.',
    'mkt.tip4': 'Import CSV/TSV for a quick fill, then bulk-remap if needed.',
    'mkt.tipQueued': 'Open {n} queued broadcasts',
    'mkt.tipGatewayOk': 'Gateway ready',
    'mkt.tipGatewayFix': 'Configure WA gateway',
    'mkt.emptyTitle': 'Database empty',

    'wa.title': 'WhatsApp',
    'wa.loading': 'Loading…',
    'wa.addNumber': 'Add number',
    'wa.addNumberSub': 'Multi-number: each session has its own QR & chats.',
    'wa.label': 'Number label',
    'wa.labelPh': 'e.g. CS JGI / Marketing',
    'wa.gatewayUrl': 'Gateway API URL',
    'wa.apiToken': 'API Token',
    'wa.setDefault': 'Set as default number',
    'wa.continueQr': 'Continue to QR',
    'wa.scanQr': 'Scan QR',
    'wa.newChat': 'New chat',
    'wa.settings': 'Number settings',
    'wa.search': 'Search or start new chat',
    'wa.needScan': 'Not linked — scan QR',
    'wa.emptySessions': 'No WhatsApp numbers yet',
    'wa.emptySessionsSub': 'Add a number, then scan the barcode from your phone.',
    'wa.linkTitle': 'Link WhatsApp',
    'wa.linkSub': 'Scan the QR with your phone to show chats here.',
    'wa.emptyChats': 'No conversations yet',
    'wa.introTitle': 'WhatsApp for business',
    'wa.introSub': 'WhatsApp Web–style UI — multi number, QR scan, gateway API ready.',
    'wa.featMulti': 'Multi number / parallel sessions',
    'wa.featQr': 'QR barcode scan + pairing code',
    'wa.featApi': 'Ready for gateway API (WAHA/Meta/custom)',
    'wa.introHint': 'Share your API endpoint later — the UI is ready.',
    'wa.qrTitle': 'Use WhatsApp on your phone to scan',
    'wa.qrStep1': 'Open WhatsApp on your phone',
    'wa.qrStep2': 'Tap Menu or Settings, then Linked devices',
    'wa.qrStep3': 'Tap Link a device and point at this QR',
    'wa.pairingCode': 'Pairing code',
    'wa.phoneAfterScan': 'Phone after linking (optional)',
    'wa.qrHint': 'QR refreshes automatically',
    'wa.refreshQr': 'Refresh QR',
    'wa.iScanned': 'I scanned it',
    'wa.colPhone': 'WA number',
    'wa.colName': 'Display name',
    'wa.optional': 'Optional',
    'wa.startChat': 'Start chat',
    'wa.newChatSub': 'Enter a number to open a conversation.',
    'wa.typeMessage': 'Type a message',
    'wa.today': 'Today',
    'wa.group': 'Group',
    'wa.sessionCreated': 'Number added — scan QR',
    'wa.connected': 'WhatsApp connected',
    'wa.disconnected': 'Number disconnected',
    'wa.confirmLogout': 'Log out and clear local chats for this session?',
    'wa.confirmDelete': 'Permanently delete this number/session?',
    'wa.logout': 'Log out',
    'wa.disconnect': 'Disconnect',
    'wa.delete': 'Delete',
    'wa.save': 'Save',
    'wa.saved': 'Settings saved',
    'wa.cancel': 'Cancel',
    'wa.tokenKeep': 'Leave blank to keep current',
    'wa.yesterday': 'Yesterday',
    'wa.statusConnected': 'Connected',
    'wa.statusPendingQr': 'Awaiting QR',
    'wa.statusConnecting': 'Connecting…',
    'wa.statusDisconnected': 'Disconnected',
    'wa.statusLoggedOut': 'Logged out',
    'wa.defaultBadge': 'Default',
    'wa.gatewayBadge': 'Gateway',
    'wa.chatMeta': '{n} chats · {u} unread',
    'wa.kpiConnected': 'Live',
    'wa.kpiPending': 'QR',
    'wa.kpiOffline': 'Offline',
    'wa.kpiReady': 'Ready',
    'wa.statSessions': 'Numbers',
    'wa.statGateway': 'Gateway',
    'wa.tipsTitle': 'Ops checklist',
    'wa.tipAddSession': 'Add a WA number to get started',
    'wa.tipConnected': '{n} number(s) live — ready to chat',
    'wa.tipNoConnected': 'No linked numbers — scan QR',
    'wa.tipPendingQr': '{n} number(s) awaiting QR scan',
    'wa.tipOffline': '{n} number(s) offline / logged out',
    'wa.tipGatewayOk': 'Gateway API configured',
    'wa.tipGatewayFix': 'Add gateway URL in number settings',
    'wa.tipMarketing': 'Sync contacts & campaigns in Marketing',
    'wa.emptyChatsSub': 'Start a new chat or pull contacts from Marketing.',
    'wa.emptyTip1': 'One number = one session (CS, Marketing, etc.).',
    'wa.emptyTip2': 'After scanning, local chats are ready — gateway API can come later.',
    'wa.openMarketing': 'Open Marketing',
    'wa.backChats': 'Back to chats',
    'wa.pin': 'Pin chat',
    'wa.unpin': 'Unpin',

    'kurs.title': 'Service FX Calculator',
    'kurs.kicker': 'FX · Fee · Tax',
    'kurs.sub': 'Enter USD/EUR/etc + rates to auto-calc conversion, service fee, admin, bank spread, and VAT.',
    'kurs.refresh': 'Reload rates',
    'kurs.copy': 'Copy summary',
    'kurs.inputTitle': 'Amount & fees',
    'kurs.inputSub': 'Pick a preset or set manually. Rates are editable until the live API is wired.',
    'kurs.amount': 'Foreign amount',
    'kurs.qty': 'Qty',
    'kurs.rateUsed': 'Rate in use',
    'kurs.editRates': 'Edit rates',
    'kurs.hideRates': 'Hide',
    'kurs.rateHint': 'Value = IDR per 1 unit. Replace with live API later.',
    'kurs.servicePct': 'Service fee',
    'kurs.adminFee': 'Admin fee',
    'kurs.bankSpread': 'Bank spread',
    'kurs.taxPct': 'Tax',
    'kurs.discount': 'Discount',
    'kurs.resultTitle': 'Calculation',
    'kurs.resultSub': 'Updates live as inputs change.',
    'kurs.grandTotal': 'Total payable (IDR)',
    'kurs.perUnit': 'Per unit',
    'kurs.fxAmount': 'FX amount',
    'kurs.idrConvert': 'IDR conversion',
    'kurs.spreadLine': 'Bank spread',
    'kurs.serviceLine': 'Service fee',
    'kurs.adminLine': 'Admin',
    'kurs.subtotal': 'Subtotal',
    'kurs.taxLine': 'Tax',
    'kurs.rateBoard': 'Rate board',
    'kurs.footer': 'Stub source · as of {asOf} — swap /api/kurs when the live API is ready.',
    'kurs.reset': 'Reset',
    'kurs.resetOk': 'Inputs restored to defaults',
    'kurs.copied': 'Summary copied',
    'kurs.copyFail': 'Could not copy summary',
    'kurs.ratesLoaded': 'Rates loaded',
    'kurs.ratesFallback': 'Using local rates (API failed)',
    'kurs.tax0': '0%',
    'kurs.tax11': '11% VAT',
    'kurs.tax12': '12% VAT',
    'kurs.kpiTotal': 'Total payable',
    'kurs.kpiTotalHint': 'Includes fee, admin, spread & tax',
    'kurs.kpiConvert': 'IDR conversion',
    'kurs.kpiFees': 'Add-on costs',
    'kurs.kpiFeesHint': 'Effective markup {pct}%',
    'kurs.kpiEff': 'Effective rate',
    'kurs.kpiEffHint': 'IDR per 1 {ccy} after all costs',
    'kurs.vizReady': 'Calc readiness',
    'kurs.vizReadySub': 'ready',
    'kurs.readyHint': 'Active {ccy} @ Rp {rate}',
    'kurs.vizComp': 'Total composition',
    'kurs.vizFees': 'Fee breakdown',
    'kurs.compConvert': 'Conversion',
    'kurs.compSpread': 'Spread',
    'kurs.compFee': 'Fee + admin',
    'kurs.compTax': 'Tax',
    'kurs.healthTitle': 'Calculation status',
    'kurs.healthSub': 'Quick view of input readiness, rates, and cost load.',
    'kurs.lane.ready': 'Ready',
    'kurs.lane.rates': 'Currencies',
    'kurs.lane.spread': 'Spread',
    'kurs.lane.tax': 'Tax',
    'kurs.lane.disc': 'Discount',
    'kurs.tipsTitle': 'Checklist & tips',
    'kurs.tipStub': 'Rates still stub — reload / wire live API',
    'kurs.tipLive': 'Live rate source active',
    'kurs.tipAmount': 'Enter an FX amount for a meaningful calc',
    'kurs.tipAmountOk': 'FX amount is set',
    'kurs.tipHighSpread': 'Bank spread is high — adjust if needed',
    'kurs.tipSpreadOk': 'Bank spread looks reasonable',
    'kurs.tipTaxConsult': 'Consult preset without VAT — double-check',
    'kurs.tipTaxOk': 'Tax {n}% active',
    'kurs.tipEditRates': 'Edit rates manually until live API is ready',
    'kurs.effRate': 'Effective ≈ {rate} / 1 {ccy}',

    'prd.title': 'Products',
    'prd.kicker': 'Catalog · Stock · Price',
    'prd.sub': 'Manage service & goods products — company filter: {company}',
    'prd.add': 'Add product',
    'prd.edit': 'Edit product',
    'prd.delete': 'Delete',
    'prd.save': 'Save',
    'prd.adjustStock': 'Adjust stock',
    'prd.adjustQty': 'Qty change (+/-)',
    'prd.adjustMemo': 'Adjustment note',
    'prd.adjustDone': 'Stock adjusted',
    'prd.cancel': 'Cancel',
    'prd.search': 'Search product, code, description, notes…',
    'prd.viewTable': 'Table',
    'prd.viewGrid': 'Cards',
    'prd.statActive': 'Active products',
    'prd.statLow': 'Low stock',
    'prd.statOut': 'Out of stock',
    'prd.statLocked': 'Locked (invoiced)',
    'prd.statValue': 'Stock value',
    'prd.locked': 'Locked',
    'prd.lockedHint': 'Product used on {n} invoice/proforma lines — only system can delete',
    'prd.confirmDeleteLocked': 'SYSTEM ONLY: force-delete locked “{name}” ({n} invoices)?',
    'prd.systemCanDelete': 'System accounts may force-delete locked products.',
    'prd.colProduct': 'Product',
    'prd.colQty': 'Qty',
    'prd.colPrice': 'Price',
    'prd.colDesc': 'Description',
    'prd.colNotes': 'Internal notes',
    'prd.descHint': 'Public / catalog description for clients',
    'prd.notesHint': 'Staff only: required documents, checklist, SOP, etc.',
    'prd.notesStaffOnly': 'Visible to internal staff',
    'prd.hasNotes': 'Has notes',
    'prd.viewNotes': 'View notes',
    'prd.noNotes': 'No internal notes yet',
    'prd.code': 'Code',
    'prd.category': 'Category',
    'prd.unit': 'Unit',
    'prd.status': 'Status',
    'prd.allCategories': 'All categories',
    'prd.uncategorized': 'Uncategorized',
    'prd.noDesc': 'No description yet',
    'prd.empty': 'No products yet. Add the first one.',
    'prd.needName': 'Product name is required',
    'prd.created': 'Product created',
    'prd.updated': 'Product updated',
    'prd.deleted': 'Product deleted',
    'prd.confirmDelete': 'Delete product “{name}”?',
    'prd.filterAll': 'All',
    'prd.filterActive': 'Active',
    'prd.filterArchived': 'Archived',
    'prd.resetFilters': 'Reset filters',
    'prd.clearFocus': 'Clear focus',
    'prd.focusBanner': 'Focus: {focus}',
    'prd.emptyFilter': 'No products in this filter',
    'prd.emptyFilterSub': 'Change focus/status or reset filters to see the catalog.',
    'prd.vizReady': 'Catalog readiness',
    'prd.vizReadySub': 'complete',
    'prd.readyHint': '{ok} ready · {need} missing description',
    'prd.vizStock': 'Stock health',
    'prd.vizCat': 'Active categories',
    'prd.vizCatEmpty': 'No categories yet',
    'prd.stock.ok': 'Healthy stock',
    'prd.stock.low': 'Low',
    'prd.stock.out': 'Out',
    'prd.healthTitle': 'Inventory lanes',
    'prd.healthSub': 'Click to quickly filter stock, locks, and completeness.',
    'prd.lane.all': 'All',
    'prd.lane.active': 'Active',
    'prd.lane.low': 'Low',
    'prd.lane.out': 'Out',
    'prd.lane.locked': 'Locked',
    'prd.lane.notes': 'Has notes',
    'prd.lane.nodesc': 'No description',
    'prd.tipsTitle': 'Catalog checklist',
    'prd.tipEmpty': 'Add the first product to the catalog',
    'prd.tipReadyOk': 'Catalog {n}% complete',
    'prd.tipReadyFix': 'Catalog completeness {n}% — fill descriptions',
    'prd.tipLow': '{n} products low on stock',
    'prd.tipLowOk': 'No low-stock products',
    'prd.tipOut': '{n} products out of stock',
    'prd.tipCategory': '{n} products without category',
    'prd.tipLocked': '{n} products locked on invoices',

    'taxReq.title': 'Tax Requests',
    'taxReq.kicker': 'Staff board',
    'taxReq.sub': 'Process customer tax report requests — status, assignment, and results.',
    'taxReq.meTitle': 'My Requests',
    'taxReq.meKicker': 'Self-service',
    'taxReq.meSub': 'Submit tax report requests and track progress.',
    'taxReq.refresh': 'Refresh',
    'taxReq.refreshShort': 'Reload',
    'taxReq.new': 'New request',
    'taxReq.newShort': 'New',
    'taxReq.submit': 'Submit request',
    'taxReq.empty': 'No requests yet',
    'taxReq.emptySub': 'Create a request or change filters.',
    'taxReq.unlinkedTitle': 'Portal not activated',
    'taxReq.unlinked': 'Account is not linked to a tax client. Contact admin to activate the portal.',
    'taxReq.statSubmitted': 'New',
    'taxReq.statProgress': 'In progress',
    'taxReq.statNeedInfo': 'Need info',
    'taxReq.statDone': 'Done',
    'taxReq.filterStatus': 'Status',
    'taxReq.filterKind': 'Type',
    'taxReq.filterClient': 'Client',
    'taxReq.filterYear': 'Year',
    'taxReq.all': 'All',
    'taxReq.colTitle': 'Title',
    'taxReq.colClient': 'Client',
    'taxReq.colKind': 'Type',
    'taxReq.colPeriod': 'Period',
    'taxReq.colStatus': 'Status',
    'taxReq.colUpdated': 'Updated',
    'taxReq.colAssign': 'Assign',
    'taxReq.kind': 'Report type',
    'taxReq.periodYear': 'Year',
    'taxReq.periodMonth': 'Month',
    'taxReq.note': 'Note',
    'taxReq.staffNote': 'Staff note',
    'taxReq.resultDoc': 'Result document (ID)',
    'taxReq.assignTo': 'Assign to user ID',
    'taxReq.update': 'Save changes',
    'taxReq.detail': 'Request detail',
    'taxReq.snackCreated': 'Request submitted',
    'taxReq.snackUpdated': 'Request updated',
    'taxReq.kind.ppn': 'VAT',
    'taxReq.kind.pph21': 'PPh 21',
    'taxReq.kind.pph23': 'PPh 23',
    'taxReq.kind.pph_final': 'Final PPh',
    'taxReq.kind.spt': 'Tax return',
    'taxReq.kind.efaktur': 'e-Invoice',
    'taxReq.kind.lain': 'Other',
    'taxReq.status.draft': 'Draft',
    'taxReq.status.submitted': 'Submitted',
    'taxReq.status.in_progress': 'In progress',
    'taxReq.status.need_info': 'Need info',
    'taxReq.status.done': 'Done',
    'taxReq.status.rejected': 'Rejected',
    'taxReq.resubmit': 'Resubmit info',
    'taxReq.monthOptional': 'Optional',

    'cust.title': 'Manage Customers',
    'cust.kicker': 'Portal access',
    'cust.sub': 'Monitor customer accounts, link tax clients, reset passwords, and toggle access.',
    'cust.refresh': 'Refresh',
    'cust.refreshShort': 'Reload',
    'cust.create': 'New customer',
    'cust.createShort': 'New',
    'cust.search': 'Search name, username, client…',
    'cust.searchLabel': 'Search',
    'cust.statTotal': 'Total',
    'cust.statActive': 'Active',
    'cust.statUnlinked': 'Unlinked',
    'cust.statOpen': 'Open requests',
    'cust.chipTotal': '{n} customers',
    'cust.chipUnlinked': '{n} unlinked',
    'cust.chipLinkedOk': 'All linked',
    'cust.filterActive': 'Active only',
    'cust.filterUnlinked': 'Unlinked only',
    'cust.focusSearch': 'Search: “{q}”',
    'cust.clearFocus': 'Clear focus',
    'cust.showing': '{n} shown',
    'cust.empty': 'No customers yet',
    'cust.emptySub': 'Create a customer account or change filters.',
    'cust.linkClient': 'Link tax client',
    'cust.colUser': 'User',
    'cust.colClient': 'Client',
    'cust.colStatus': 'Status',
    'cust.colLogin': 'Last login',
    'cust.colOpen': 'Requests',
    'cust.contact': 'Contact',
    'cust.active': 'Active',
    'cust.inactive': 'Inactive',
    'cust.resetPass': 'Reset password',
    'cust.resetPassShort': 'Password',
    'cust.save': 'Save',
    'cust.detail': 'Customer detail',
    'cust.detailShort': 'Detail',
    'cust.aclTitle': 'Access rights',
    'cust.aclHint': 'Default Customer level menus — full edit in Users & Access.',
    'cust.openUsers': 'Open Users & Access',
    'cust.openUsersShort': 'Users & Access',
    'cust.tipsTitle': 'Suggested actions',
    'cust.tipUnlinked': '{n} customers not linked — filter and complete',
    'cust.tipOpen': '{n} open requests — open staff board',
    'cust.tipCreate': 'Add a new customer for portal access',
    'cust.tipUsers': 'Manage full menus/ACL in Users & Access',
    'cust.tipOk': 'All customers are linked to clients',
    'cust.snackCreated': 'Customer created',
    'cust.snackUpdated': 'Customer updated',
    'cust.snackPass': 'Password reset',
    'cust.password': 'Initial password',
    'cust.passwordConfirm': 'Confirm password',
    'cust.passMismatch': 'Password confirmation does not match',
    'cust.mustChange': 'Must change password on login',
    'cust.firstName': 'First name',
    'cust.lastName': 'Last name',
    'cust.username': 'Username',
    'cust.email': 'Email',
    'cust.phone': 'Phone',
    'cust.neverLogin': 'Never',
    'cust.recentReq': 'Recent requests',
    'cust.noClient': 'Not linked',

    'custPortal.title': 'Customer Portal',
    'custPortal.kicker': 'Dashboard',
    'custPortal.sub': 'Linked client summary, open requests, and recent documents.',
    'custPortal.refresh': 'Refresh',
    'custPortal.refreshShort': 'Reload',
    'custPortal.unlinkedTitle': 'Portal not activated',
    'custPortal.unlinked': 'Account is not linked to a tax client. Contact admin.',
    'custPortal.ctaRequest': 'Submit request',
    'custPortal.ctaRequestShort': 'Request',
    'custPortal.ctaAccount': 'My account',
    'custPortal.ctaAccountShort': 'Account',
    'custPortal.ctaMyReq': 'View my requests',
    'custPortal.ctaMyReqShort': 'Requests',
    'custPortal.statOpen': 'Open requests',
    'custPortal.statNeed': 'Need info',
    'custPortal.statDone': 'Done',
    'custPortal.clientCard': 'Linked client',
    'custPortal.openList': 'Open requests',
    'custPortal.docs': 'Recent documents',
    'custPortal.emptyOpen': 'No open requests',
    'custPortal.emptyDocs': 'No documents yet',
    'custPortal.npwp': 'Tax ID',
  },
} as const;
